import type { SVGProps } from "react";

export const AlignBottom01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2c.5523 0 1 .4477 1 1v11.5858l5.2929-5.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143l-7 7c-.3905.3905-1.0237.3905-1.4142 0l-7-7c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L11 14.5858V3c0-.5523.4477-1 1-1M2 21c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const AlignBottom02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.968 6h.064c.4386 0 .8171 0 1.1304.0213.3298.0225.6597.072.9857.207a3 3 0 0 1 1.6235 1.6237c.135.3259.1845.6558.2071.9856C21 9.151 21 9.5294 21 9.968v8.064c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9857a3 3 0 0 1-1.6235 1.6235c-.326.135-.6559.1845-.9857.2071C17.8491 22 17.4706 22 17.032 22h-.064c-.4386 0-.8171 0-1.1304-.0213-.3298-.0226-.6597-.0721-.9856-.2071a3 3 0 0 1-1.6236-1.6235c-.135-.326-.1845-.6559-.207-.9857C13 18.8491 13 18.4706 13 18.032V9.968c0-.4386 0-.8171.0214-1.1304.0225-.3298.072-.6597.207-.9856a3 3 0 0 1 1.6236-1.6236c.3259-.135.6558-.1845.9856-.207C16.1509 6 16.5294 6 16.968 6M6.968 2h.064c.4386 0 .8171 0 1.1304.0213.3298.0226.6597.072.9856.207a3 3 0 0 1 1.6236 1.6237c.135.3259.1845.6558.2071.9856C11 5.151 11 5.5294 11 5.968v12.064c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9857a3 3 0 0 1-1.6235 1.6235c-.326.135-.6559.1845-.9857.2071C7.849 22 7.4706 22 7.032 22h-.064c-.4386 0-.8171 0-1.1304-.0213-.3298-.0226-.6597-.0721-.9856-.2071a3 3 0 0 1-1.6236-1.6235c-.135-.326-.1845-.6559-.207-.9857C3 18.8491 3 18.4706 3 18.032V5.968c0-.4386 0-.8171.0213-1.1304.0226-.3298.072-.6597.207-.9857A3 3 0 0 1 4.852 2.2285c.3259-.135.6558-.1845.9856-.207C6.151 2 6.5294 2 6.968 2"
      clipRule="evenodd"
    />
  </svg>
);

export const AlignHorizontalCentre01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M17.9142 11l2.2929-2.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L17.9142 13H22c.5523 0 1-.4477 1-1s-.4477-1-1-1zM1 12c0-.5523.4477-1 1-1h4.0858l-2.293-2.2929c-.3904-.3905-.3904-1.0237 0-1.4142.3906-.3905 1.0238-.3905 1.4143 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L6.0858 13H2c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const AlignHorizontalCentre02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.968 3h8.064c.4386 0 .8171 0 1.1304.0213.3298.0226.6597.072.9857.207a3 3 0 0 1 1.6235 1.6237c.135.3259.1845.6558.2071.9856C20 6.151 20 6.5294 20 6.968v.064c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9856a3 3 0 0 1-1.6235 1.6236c-.326.135-.6559.1845-.9857.2071C16.8491 11 16.4706 11 16.032 11H7.968c-.4386 0-.8171 0-1.1304-.0213-.3298-.0226-.6597-.0721-.9856-.2071a3 3 0 0 1-1.6236-1.6235c-.135-.326-.1845-.6559-.207-.9857C4 7.849 4 7.4706 4 7.032v-.064c0-.4386 0-.8171.0213-1.1304.0226-.3298.072-.6597.207-.9856A3 3 0 0 1 5.852 3.2284c.3259-.135.6558-.1846.9856-.207C7.151 3 7.5294 3 7.968 3M5.968 13h12.064c.4386 0 .8171 0 1.1304.0214.3298.0225.6597.072.9857.207a3 3 0 0 1 1.6235 1.6236c.135.3259.1845.6558.2071.9856.0213.3133.0213.6918.0213 1.1304v.064c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9857a3 3 0 0 1-1.6235 1.6235c-.326.135-.6559.1845-.9857.2071C18.8491 21 18.4706 21 18.032 21H5.968c-.4386 0-.8171 0-1.1304-.0214-.3298-.0225-.6597-.072-.9857-.207a3 3 0 0 1-1.6235-1.6235c-.135-.326-.1846-.6559-.207-.9857C2 17.8491 2 17.4706 2 17.032v-.064c0-.4386 0-.8171.0213-1.1304.0226-.3298.072-.6597.207-.9856a3 3 0 0 1 1.6237-1.6236c.3259-.135.6558-.1845.9856-.2071C5.151 13 5.5294 13 5.968 13"
      clipRule="evenodd"
    />
  </svg>
);

export const AlignLeft01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M9.4142 11l5.2929-5.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-7 7c-.3905.3905-.3905 1.0237 0 1.4142l7 7c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L9.4142 13H21c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const AlignLeft02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 7.032v-.064c0-.4386 0-.8171-.0213-1.1304-.0226-.3298-.0721-.6597-.2071-.9856a3 3 0 0 0-1.6235-1.6236c-.326-.135-.6559-.1846-.9857-.207C14.8491 3 14.4706 3 14.032 3H5.968c-.4386 0-.8171 0-1.1304.0213-.3298.0225-.6597.072-.9857.207A3 3 0 0 0 2.2285 4.852c-.135.3259-.1845.6558-.207.9856C2 6.151 2 6.5294 2 6.968v.064c0 .4386 0 .8171.0213 1.1304.0226.3298.072.6597.207.9856a3 3 0 0 0 1.6237 1.6236c.3259.135.6558.1845.9856.2071C5.151 11 5.5294 11 5.968 11h8.064c.4386 0 .8171 0 1.1304-.0213.3298-.0226.6597-.0721.9857-.2071a3 3 0 0 0 1.6235-1.6235c.135-.326.1845-.6559.2071-.9857C18 7.849 18 7.4706 18 7.032M22 17.032v-.064c0-.4386 0-.8171-.0213-1.1304-.0226-.3298-.0721-.6597-.2071-.9856a3 3 0 0 0-1.6235-1.6236c-.326-.135-.6559-.1845-.9857-.2071C18.8491 13 18.4706 13 18.032 13H5.968c-.4386 0-.8171 0-1.1304.0214-.3298.0225-.6597.072-.9857.207a3 3 0 0 0-1.6235 1.6236c-.135.3259-.1846.6558-.207.9856C2 16.1509 2 16.5294 2 16.968v.064c0 .4386 0 .8171.0213 1.1304.0225.3298.072.6597.207.9857a3 3 0 0 0 1.6237 1.6235c.3259.135.6558.1845.9856.2071C5.151 21 5.5294 21 5.968 21h12.064c.4386 0 .8171 0 1.1304-.0213.3298-.0226.6597-.0721.9857-.2071a3 3 0 0 0 1.6235-1.6235c.135-.326.1845-.6559.2071-.9857C22 17.8491 22 17.4706 22 17.032"
      clipRule="evenodd"
    />
  </svg>
);

export const AlignRight01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M2 12c0-.5523.4477-1 1-1h11.5858l-5.293-5.2929c-.3904-.3905-.3904-1.0237 0-1.4142.3906-.3905 1.0238-.3905 1.4143 0l7 7a1 1 0 0 1 0 1.4142l-7 7c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L14.5858 13H3c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const AlignRight02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 7.032v-.064c0-.4386 0-.8171.0213-1.1304.0225-.3298.072-.6597.207-.9856A3 3 0 0 1 7.852 3.2284c.3259-.135.6558-.1846.9856-.207C9.151 3 9.5294 3 9.968 3h8.064c.4386 0 .8171 0 1.1304.0213.3298.0225.6597.072.9857.207a3 3 0 0 1 1.6235 1.6237c.135.3259.1845.6558.2071.9856C22 6.151 22 6.5294 22 6.968v.064c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9856a3 3 0 0 1-1.6235 1.6236c-.326.135-.6559.1845-.9857.2071C18.8491 11 18.4706 11 18.032 11H9.968c-.4386 0-.8171 0-1.1304-.0213-.3298-.0226-.6597-.0721-.9856-.2071a3 3 0 0 1-1.6236-1.6235c-.135-.326-.1845-.6559-.207-.9857C6 7.849 6 7.4706 6 7.032M2 17.032v-.064c0-.4386 0-.8171.0213-1.1304.0225-.3298.072-.6597.207-.9856a3 3 0 0 1 1.6237-1.6236c.3259-.135.6558-.1845.9856-.207C5.151 13 5.5294 13 5.968 13h12.064c.4386 0 .8171 0 1.1304.0214.3298.0225.6597.072.9857.207a3 3 0 0 1 1.6235 1.6236c.135.3259.1845.6558.2071.9856.0213.3133.0213.6918.0213 1.1304v.064c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9857a3 3 0 0 1-1.6235 1.6235c-.326.135-.6559.1845-.9857.2071C18.8491 21 18.4706 21 18.032 21H5.968c-.4386 0-.8171 0-1.1304-.0213-.3298-.0226-.6597-.0721-.9857-.2071a3 3 0 0 1-1.6235-1.6235c-.135-.326-.1845-.6559-.207-.9857C2 17.8491 2 17.4706 2 17.032"
      clipRule="evenodd"
    />
  </svg>
);

export const AlignTop01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 3c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M13 9.4142l5.2929 5.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-7-7c-.3905-.3905-1.0237-.3905-1.4142 0l-7 7c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L11 9.4142V21c0 .5523.4477 1 1 1s1-.4477 1-1z"
    />
  </svg>
);

export const AlignTop02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.968 18h.064c.4386 0 .8171 0 1.1304-.0213.3298-.0226.6597-.0721.9857-.2071a3 3 0 0 0 1.6235-1.6235c.135-.326.1845-.6559.2071-.9857C21 14.8491 21 14.4706 21 14.032V5.968c0-.4386 0-.8171-.0213-1.1304-.0226-.3298-.0721-.6597-.2071-.9857a3 3 0 0 0-1.6235-1.6235c-.326-.135-.6559-.1845-.9857-.207C17.8491 2 17.4706 2 17.032 2h-.064c-.4386 0-.8171 0-1.1304.0213-.3298.0226-.6597.072-.9856.207a3 3 0 0 0-1.6236 1.6237c-.135.3259-.1845.6558-.207.9856C13 5.151 13 5.5294 13 5.968v8.064c0 .4386 0 .8171.0214 1.1304.0225.3298.072.6597.207.9857a3 3 0 0 0 1.6236 1.6235c.3259.135.6558.1845.9856.2071.3133.0213.6918.0213 1.1304.0213M6.968 22h.064c.4386 0 .8171 0 1.1304-.0213.3298-.0226.6597-.0721.9856-.2071a3 3 0 0 0 1.6236-1.6235c.135-.326.1845-.6559.2071-.9857C11 18.8491 11 18.4706 11 18.032V5.968c0-.4386 0-.8171-.0213-1.1304-.0226-.3298-.0721-.6597-.2071-.9857a3 3 0 0 0-1.6235-1.6235c-.326-.135-.6559-.1845-.9857-.207C7.849 2 7.4706 2 7.032 2h-.064c-.4386 0-.8171 0-1.1304.0213-.3298.0226-.6597.072-.9856.207A3 3 0 0 0 3.2284 3.852c-.135.3259-.1846.6558-.207.9856C3 5.151 3 5.5294 3 5.968v12.064c0 .4386 0 .8171.0213 1.1304.0226.3298.072.6597.207.9857a3 3 0 0 0 1.6237 1.6235c.3259.135.6558.1845.9856.2071C6.151 22 6.5294 22 6.968 22"
      clipRule="evenodd"
    />
  </svg>
);

export const AlignVerticalCenter01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1c.5523 0 1 .4477 1 1v4.0858l2.2929-2.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L11 6.0858V2c0-.5523.4477-1 1-1M2 12c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M12 23c-.5523 0-1-.4477-1-1v-4.0858l-2.2929 2.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l4-4c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 17.9142V22c0 .5523-.4477 1-1 1"
    />
  </svg>
);

export const AlignVerticalCenter02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.968 4h.064c.4386 0 .8171 0 1.1304.0213.3298.0226.6597.072.9857.207a3 3 0 0 1 1.6235 1.6237c.135.3259.1845.6558.2071.9856C21 7.151 21 7.5294 21 7.968v8.064c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9857a3 3 0 0 1-1.6235 1.6235c-.326.135-.6559.1845-.9857.2071C17.8491 20 17.4706 20 17.032 20h-.064c-.4386 0-.8171 0-1.1304-.0213-.3298-.0226-.6597-.0721-.9856-.2071a3 3 0 0 1-1.6236-1.6235c-.135-.326-.1845-.6559-.207-.9857C13 16.8491 13 16.4706 13 16.032V7.968c0-.4386 0-.8171.0214-1.1304.0225-.3298.072-.6597.207-.9856a3 3 0 0 1 1.6236-1.6236c.3259-.135.6558-.1845.9856-.207C16.1509 4 16.5294 4 16.968 4M6.968 2h.064c.4386 0 .8171 0 1.1304.0213.3298.0226.6597.072.9856.207a3 3 0 0 1 1.6236 1.6237c.135.3259.1845.6558.2071.9856C11 5.151 11 5.5294 11 5.968v12.064c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9857a3 3 0 0 1-1.6235 1.6235c-.326.135-.6559.1845-.9857.2071C7.849 22 7.4706 22 7.032 22h-.064c-.4386 0-.8171 0-1.1304-.0213-.3298-.0226-.6597-.0721-.9856-.2071a3 3 0 0 1-1.6236-1.6235c-.135-.326-.1845-.6559-.207-.9857C3 18.8491 3 18.4706 3 18.032V5.968c0-.4386 0-.8171.0213-1.1304.0226-.3298.072-.6597.207-.9857A3 3 0 0 1 4.852 2.2285c.3259-.135.6558-.1845.9856-.207C6.151 2 6.5294 2 6.968 2"
      clipRule="evenodd"
    />
  </svg>
);

export const Columns01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.1615 2h.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1796 22 5.6343 22 6.1615v11.677c0 .5272 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C18.8205 22 18.3657 22 17.8386 22h-.6772c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C13 18.8205 13 18.3657 13 17.8385V6.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C16.1795 2 16.6343 2 17.1615 2M6.1615 2h.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C11 5.1796 11 5.6343 11 6.1615v11.677c0 .5272 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C7.8205 22 7.3657 22 6.8386 22h-.6772c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8385V6.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1796 2 5.6343 2 6.1615 2"
      clipRule="evenodd"
    />
  </svg>
);

export const Columns02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.2401 2 9.96 2 9.4 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22H9.4c.56 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C11 21.2401 11 20.9601 11 20.4zM13 20.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109h3.2386c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8386 2H14.6c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C13 2.76 13 3.04 13 3.6z"
    />
  </svg>
);

export const Columns03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 3.6c0-.5742 0-.8612-.1128-1.0781a1.017 1.017 0 0 0-.4504-.4383c-.22-.1067-.4922-.0993-1.0367-.0843a11 11 0 0 0-.5951.0313c-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964.1978.0162.3963.0258.595.0313.5446.0149.8169.0224 1.0368-.0843.19-.0923.353-.2509.4504-.4383C7 21.2612 7 20.9742 7 20.4zM9 20.4c0 .56 0 .8401.109 1.054.0959.1881.2488.3411.437.437C9.76 22 10.04 22 10.6 22h2.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C15 21.2401 15 20.96 15 20.4V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.2401 2 13.9601 2 13.4 2h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 2.76 9 3.04 9 3.6zM18.5999 1.9993c-.5445-.015-.8168-.0224-1.0367.0843a1.017 1.017 0 0 0-.4504.4383C17 2.7388 17 3.0259 17 3.5999V20.4c0 .5741 0 .8612.1128 1.0781.0974.1874.2605.346.4504.4383.2199.1067.4922.0992 1.0367.0843.1988-.0055.3973-.0151.5951-.0313.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964a11 11 0 0 0-.5951-.0313"
    />
  </svg>
);

export const DistributeSpacingHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M3 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M11.968 4h.064c.4386 0 .8171 0 1.1304.0213.3298.0225.6597.072.9857.207a3 3 0 0 1 1.6235 1.6237c.135.3259.1845.6558.2071.9856C16 7.151 16 7.5294 16 7.968v8.064c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9857a3 3 0 0 1-1.6235 1.6235c-.326.135-.6559.1845-.9857.207C12.8491 20 12.4706 20 12.032 20h-.064c-.4386 0-.8171 0-1.1304-.0214-.3298-.0225-.6597-.072-.9856-.207a3 3 0 0 1-1.6236-1.6236c-.135-.3259-.1845-.6558-.207-.9856C8 16.8491 8 16.4706 8 16.032V7.968c0-.4386 0-.8171.0213-1.1304.0226-.3298.072-.6597.207-.9856A3 3 0 0 1 9.852 4.2284c.326-.135.6559-.1845.9857-.207C11.1509 4 11.5294 4 11.968 4"
      clipRule="evenodd"
    />
  </svg>
);

export const DistributeSpacingVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 3c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 21c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M7.968 8h8.064c.4386 0 .8171 0 1.1304.0213.3298.0226.6597.072.9857.207a3 3 0 0 1 1.6235 1.6236c.135.326.1845.6559.2071.9857.0213.3133.0213.6918.0213 1.1304v.064c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9857a3 3 0 0 1-1.6235 1.6235c-.326.135-.6559.1845-.9857.2071C16.8491 16 16.4706 16 16.032 16H7.968c-.4386 0-.8171 0-1.1304-.0214-.3298-.0225-.6597-.072-.9856-.207a3 3 0 0 1-1.6236-1.6236c-.135-.3259-.1845-.6558-.207-.9856C4 12.8491 4 12.4706 4 12.032v-.064c0-.4386 0-.8171.0213-1.1304.0225-.3298.072-.6597.207-.9856A3 3 0 0 1 5.852 8.2284c.3259-.135.6558-.1845.9856-.207C7.151 8 7.5294 8 7.968 8"
      clipRule="evenodd"
    />
  </svg>
);

export const Divider = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0-.5522.4477-1 1-1h.01c.5523 0 1 .4478 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M6.5 12c0-.5522.4477-1 1-1h.01c.5523 0 1 .4478 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M15.5 12c0-.5522.4477-1 1-1h.01c.5523 0 1 .4478 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M11 12c0-.5522.4477-1 1-1h.01c.5523 0 1 .4478 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M20 12c0-.5522.4477-1 1-1h.01c.5523 0 1 .4478 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M19.7342 1.9999c.2348-.0007.5226-.0016.7834.0683a2 2 0 0 1 1.4143 1.4142c.0698.2608.069.5486.0682.7834-.0015.5024.0289 1.021-.1023 1.5107a3 3 0 0 1-2.1213 2.1213c-.3856.1033-.8236.1029-1.3313.1023a6087 6087 0 0 0-12.8904 0c-.5077.0006-.9457.001-1.3313-.1023a3 3 0 0 1-2.1213-2.1213C1.971 5.2868 2.0014 4.7682 2 4.2658c-.0008-.2348-.0016-.5226.0683-.7834a2 2 0 0 1 1.4142-1.4142c.2607-.0699.5486-.069.7834-.0683Q12 2.0234 19.7342 2M19.7342 22.0001c.2348.0008.5226.0016.7834-.0682a2 2 0 0 0 1.4142-1.4143c.0699-.2608.069-.5486.0683-.7834-.0015-.5024.0289-1.0209-.1023-1.5107a3 3 0 0 0-2.1214-2.1213c-.3855-.1033-.8235-.1028-1.3312-.1023q-6.4452.0069-12.8904 0c-.5077-.0005-.9457-.001-1.3313.1023a3 3 0 0 0-2.1213 2.1213c-.1312.4898-.1008 1.0083-.1023 1.5107-.0008.2348-.0016.5226.0682.7834a2 2 0 0 0 1.4143 1.4143c.2607.0698.5485.069.7834.0682q7.7342-.0235 15.4684 0"
      clipRule="evenodd"
    />
  </svg>
);

export const FlexAlignBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M6.5 16.6001c-.5523 0-1 .4477-1 1s.4477 1 1 1h11c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const FlexAlignLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M7.5 6.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v11c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const FlexAlignRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M18.5 6.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v11c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const FlexAlignTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M6.5 5.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h11c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Grid01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5681 2c1.288.0002 2.5784.0002 3.8638 0 .2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.454.0169.7063V8.432c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.454.0169-.7063.0169H4.568c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C2 8.9301 2 8.6842 2 8.432V4.5681c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201C4.0699 2 4.3158 2 4.568 2M4.5681 13c1.288.0002 2.5784.0002 3.8638 0 .2524 0 .4982-.0001.7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v3.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.454.0169-.7063.0169H4.568c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C2 19.9301 2 19.6843 2 19.4319v-3.8637999999999995c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201.2081-.0171.454-.017.7063-.017M15.5681 2c1.2879.0002 2.5784.0002 3.8638 0 .2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.454.0169.7063V8.432c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-3.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063V4.5681c0-.2524-.0001-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201.2081-.017.4539-.017.7063-.017M15.5681 13c1.2879.0002 2.5784.0002 3.8638 0 .2524 0 .4982-.0001.7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v3.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-3.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.4539-.017-.7063v-3.8637999999999995c0-.2524-.0001-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201.2081-.0171.4539-.017.7063-.017"
      clipRule="evenodd"
    />
  </svg>
);

export const Grid02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.0322 4.024C18.7488 4.0007 18.3766 4 17.8 4H16c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.8385c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1796 22 5.6343 22 6.1615V8c0 .5523-.4477 1-1 1s-1-.4477-1-1V6.2c0-.5766-.0008-.9488-.0239-1.2322-.0222-.2716-.0599-.3723-.0851-.4218a1 1 0 0 0-.437-.437c-.0495-.0252-.1502-.0629-.4218-.085M8 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614V8c0 .5523.4477 1 1 1s1-.4477 1-1V6.2c0-.5766.0008-.9488.024-1.2322.0221-.2716.0598-.3723.085-.4218a1 1 0 0 1 .437-.437c.0495-.0252.1502-.0629.4218-.085C5.2512 4.0007 5.6234 4 6.2 4H8c.5523 0 1-.4477 1-1s-.4477-1-1-1M4 16c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.8385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1796 22 5.6343 22 6.1615 22H8c.5523 0 1-.4477 1-1s-.4477-1-1-1H6.2c-.5766 0-.9488-.0008-1.2322-.0239-.2716-.0222-.3723-.0599-.4218-.0851a1 1 0 0 1-.437-.437c-.0252-.0495-.0629-.1502-.085-.4218C4.0007 18.7488 4 18.3766 4 17.8zM22 16c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.8c0 .5766-.0008.9488-.0239 1.2322-.0222.2716-.0599.3723-.0851.4218a1 1 0 0 1-.437.437c-.0495.0252-.1502.0629-.4218.0851-.2834.0231-.6556.0239-1.2322.0239H16c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.8385c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8385zM12 6c.5523 0 1 .4477 1 1v4h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4H7c-.5523 0-1-.4477-1-1s.4477-1 1-1h4V7c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const Grid03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.8 4c.5766 0 .9488.0008 1.2322.024.2716.0221.3723.0598.4218.085a1 1 0 0 1 .437.437c.0252.0495.0629.1502.0851.4218.0231.2834.0239.6556.0239 1.2322V8c0 .5523.4477 1 1 1s1-.4477 1-1V6.1615c0-.5272 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8386 2H16c-.5523 0-1 .4477-1 1s.4477 1 1 1zM6.1615 2H8c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4218C4.0007 5.2512 4 5.6234 4 6.2V8c0 .5523-.4477 1-1 1s-1-.4477-1-1V6.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1795 2 5.6343 2 6.1615 2M3 15c.5523 0 1 .4477 1 1v1.8c0 .5766.0008.9488.024 1.2322.0221.2716.0598.3723.085.4218a1 1 0 0 0 .437.437c.0495.0252.1502.0629.4218.0851.2834.0231.6556.0239 1.2322.0239H8c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.1615c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8386V16c0-.5523.4477-1 1-1M21 15c.5523 0 1 .4477 1 1v1.8385c0 .5272 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C18.8205 22 18.3657 22 17.8385 22H16c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.8c.5766 0 .9488-.0008 1.2322-.0239.2716-.0222.3723-.0599.4218-.0851a1 1 0 0 0 .437-.437c.0252-.0495.0629-.1502.0851-.4218.0231-.2834.0239-.6556.0239-1.2322V16c0-.5523.4477-1 1-1M16 12c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    />
  </svg>
);

export const GridDotsBlank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M6.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M6.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M6.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M15.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M15.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M15.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M11 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M20 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const GridDotsBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M6.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M6.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M15.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M15.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M11 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M20 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M2 21c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const GridDotsHorizontalCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M6.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M6.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M6.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M15.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M15.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M15.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M20 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M12 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const GridDotsLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M6.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M6.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M15.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M15.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M15.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M11 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M20 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M3 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const GridDotsOuter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M15.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M11 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0462 22 16.2412 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2M5.911 4.0376c-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 6.3611 4 6.9434 4 7.8v8.4c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C6.3611 19.9992 6.9434 20 7.8 20h8.4c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V7.8c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804C17.6389 4.0008 17.0566 4 16.2 4H7.8c-.8566 0-1.4389.0008-1.889.0376"
      clipRule="evenodd"
    />
  </svg>
);

export const GridDotsRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M6.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M6.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M15.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M15.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M15.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M11 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M2 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M21 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const GridDotsTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M6.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M6.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M15.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M15.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M11 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M20 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M2 3c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const GridDotsVerticalCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M6.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M6.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M15.5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M15.5 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M11 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M20 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 16.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M20 7.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M2 12c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const IntersectCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1 9c0-4.4183 3.5817-8 8-8 3.8003 0 6.9817 2.6499 7.7973 6.2027A8.03 8.03 0 0 0 15 7c-4.4183 0-8 3.5817-8 8 0 .618.07 1.2196.2027 1.7973C3.6499 15.9817 1 12.8003 1 9"
    />
    <path
      fill="currentColor"
      d="M7.2027 16.7973A8.03 8.03 0 0 0 9 17c4.4183 0 8-3.5817 8-8 0-.618-.0701-1.2196-.2027-1.7973C20.3501 8.0183 23 11.1997 23 15c0 4.4183-3.5817 8-8 8-3.8003 0-6.9817-2.6499-7.7973-6.2027"
    />
  </svg>
);

export const IntersectSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.1615 1h7.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C17 4.1795 17 4.6343 17 5.1615V7h-5.8385c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C7 10.1795 7 10.6343 7 11.1614V17H5.1615c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 13.8205 1 13.3657 1 12.8386V5.1614c0-.5271 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 1 4.6343 1 5.1615 1"
    />
    <path
      fill="currentColor"
      d="M7 17h5.8385c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C17 13.8205 17 13.3657 17 12.8386V7h1.8385c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3745.0306.8294.0306 1.3565v7.6771c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 23 19.3656 23 18.8385 23h-7.6771c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C7 19.8205 7 19.3657 7 18.8385z"
    />
  </svg>
);

export const LayerSingle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.7234 6.0848a1.5 1.5 0 0 1 .5532 0c.2164.0406.4095.1391.5028.1867q.0145.0075.0256.013l9.6422 4.8211a1 1 0 0 1 0 1.7889l-9.6422 4.8211-.0256.013c-.0933.0476-.2864.1461-.5028.1867a1.5 1.5 0 0 1-.5532 0c-.2164-.0406-.4095-.1391-.5028-.1867l-.0256-.013-9.6422-4.8211a1 1 0 0 1 0-1.7889l9.6422-4.821.0256-.013c.0933-.0477.2864-.1462.5028-.1868"
      clipRule="evenodd"
    />
  </svg>
);

export const LayersThree01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.1056 11.5529c.247-.494.8476-.6943 1.3416-.4473L12 15.882l9.5528-4.7764c.4939-.247 1.0946-.0467 1.3416.4473s.0468 1.0946-.4472 1.3416l-9.6422 4.8211-.0256.013c-.0933.0476-.2864.1461-.5028.1867a1.5 1.5 0 0 1-.5532 0c-.2165-.0406-.4095-.1391-.5028-.1867l-.0256-.013-9.6422-4.8211c-.494-.247-.6942-.8477-.4472-1.3416"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.1056 16.5529c.247-.494.8476-.6943 1.3416-.4473L12 20.882l9.5528-4.7764c.4939-.247 1.0946-.0467 1.3416.4473s.0468 1.0946-.4472 1.3416l-9.6422 4.8211-.0256.013c-.0933.0476-.2864.1461-.5028.1867a1.5 1.5 0 0 1-.5532 0c-.2165-.0406-.4095-.1391-.5028-.1867l-.0256-.013-9.6422-4.8211c-.494-.247-.6942-.8477-.4472-1.3416M11.7234 1.0848a1.5 1.5 0 0 1 .5532 0c.2164.0406.4095.1391.5028.1867q.0145.0075.0256.013l9.6422 4.8211a1 1 0 0 1 0 1.7889l-9.6422 4.8211-.0256.013c-.0933.0476-.2864.1461-.5028.1867a1.5 1.5 0 0 1-.5532 0c-.2165-.0406-.4095-.1391-.5028-.1867l-.0256-.013-9.6422-4.8211a1 1 0 0 1 0-1.7889l9.6422-4.821.0256-.013c.0933-.0477.2863-.1462.5028-.1868"
      clipRule="evenodd"
    />
  </svg>
);

export const LayersThree02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.7234 1.0848a1.5 1.5 0 0 1 .5532 0c.2164.0406.4095.1391.5028.1867q.0145.0075.0256.013l9.6422 4.8211a1 1 0 0 1 0 1.7889l-9.6422 4.8211-.0256.013c-.0933.0476-.2864.1461-.5028.1867a1.5 1.5 0 0 1-.5532 0c-.2164-.0406-.4095-.1391-.5028-.1867l-.0256-.013-9.6422-4.8211a1 1 0 0 1 0-1.7889l9.6422-4.821.0256-.013c.0933-.0477.2864-.1462.5028-.1868"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m2.5277 10.6181-.975.4874a1 1 0 0 0 0 1.7889l9.6423 4.8211.0256.013c.0933.0476.2864.1461.5028.1867.1828.0343.3704.0343.5532 0 .2164-.0406.4095-.1391.5028-.1867l.0256-.013 9.6422-4.8211a1 1 0 0 0 0-1.7889l-.9749-.4874-7.7729 3.8864-.0118.0059a6 6 0 0 1-.2891.1371 3.5 3.5 0 0 1-.7531.2336c-.4265.08-.8643.08-1.2908 0a3.5 3.5 0 0 1-.7531-.2336 6 6 0 0 1-.2891-.1371l-.0118-.0059z"
    />
    <path
      fill="currentColor"
      d="m2.5278 15.618-.975.4875a1 1 0 0 0 0 1.7889l9.6422 4.8211.0256.013c.0933.0476.2864.1461.5028.1867.1828.0343.3704.0343.5532 0 .2164-.0406.4095-.1391.5028-.1867l.0256-.013 9.6422-4.8211a1 1 0 0 0 0-1.7889l-.975-.4875-7.7728 3.8864-.0118.0059c-.0488.0245-.1689.0848-.2891.1371a3.5 3.5 0 0 1-.7531.2336c-.4265.08-.8643.08-1.2908 0a3.5 3.5 0 0 1-.7531-.2336c-.1202-.0523-.2403-.1126-.2891-.1371l-.0118-.0059z"
    />
  </svg>
);

export const LayersTwo01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.7234 3.5758a1.5 1.5 0 0 1 .5532 0c.2164.0406.4095.1391.5028.1867q.0145.0075.0256.013l9.6422 4.8211a1 1 0 0 1 0 1.7889l-9.6422 4.8211-.0256.0129c-.0933.0477-.2864.1462-.5028.1868a1.5 1.5 0 0 1-.5532 0c-.2164-.0406-.4095-.1391-.5028-.1868l-.0256-.0129-9.6422-4.8211a1 1 0 0 1 0-1.7889l9.6422-4.8211q.0112-.0055.0256-.013c.0933-.0476.2864-.1461.5028-.1867"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m2.5277 13.109-.975.4875a1 1 0 0 0 0 1.7889l9.6423 4.8211.0256.0129c.0933.0476.2864.1462.5028.1868.1828.0343.3704.0343.5532 0 .2164-.0406.4095-.1391.5028-.1868l.0256-.0129 9.6422-4.8211a1 1 0 0 0 0-1.7889l-.9749-.4875-7.7729 3.8865-.0118.0059c-.0488.0245-.1689.0848-.2891.1371a3.5 3.5 0 0 1-.7531.2336c-.4265.08-.8643.08-1.2908 0a3.5 3.5 0 0 1-.7531-.2336c-.1202-.0523-.2403-.1126-.2891-.1371l-.0118-.0059z"
    />
  </svg>
);

export const LayersTwo02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.7234 3.5758a1.5 1.5 0 0 1 .5532 0c.2164.0406.4095.1391.5028.1867q.0145.0075.0256.013l9.6422 4.8211a1 1 0 0 1 0 1.7889l-9.6422 4.8211-.0256.0129c-.0933.0477-.2864.1462-.5028.1868a1.5 1.5 0 0 1-.5532 0c-.2164-.0406-.4095-.1391-.5028-.1868l-.0256-.0129-9.6422-4.8211a1 1 0 0 1 0-1.7889l9.6422-4.8211q.0112-.0055.0256-.013c.0933-.0476.2864-.1461.5028-.1867"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m2.5277 13.109-.975.4875a1 1 0 0 0 0 1.7889l9.6423 4.8211.0256.0129c.0933.0476.2864.1462.5028.1868.1828.0343.3704.0343.5532 0 .2164-.0406.4095-.1391.5028-.1868l.0256-.0129 9.6422-4.8211a1 1 0 0 0 0-1.7889l-.9749-.4875-7.7729 3.8865-.0118.0059c-.0488.0245-.1689.0848-.2891.1371a3.5 3.5 0 0 1-.7531.2336c-.4265.08-.8643.08-1.2908 0a3.5 3.5 0 0 1-.7531-.2336c-.1202-.0523-.2403-.1126-.2891-.1371l-.0118-.0059z"
    />
  </svg>
);

export const LayoutAlt01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614V6.4c0 .56 0 .84.109 1.054.0959.1882.2489.3411.437.437C2.76 8 3.04 8 3.6 8h16.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 7.24 22 6.96 22 6.4v-.2386c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M22 11.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 10 20.9601 10 20.4 10h-8.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C10 10.7599 10 11.0399 10 11.6v8.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109h6.2386c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386zM6.4 22c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 21.2401 8 20.9601 8 20.4v-8.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C7.24 10 6.96 10 6.4 10H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 10.7599 2 11.0399 2 11.6v6.2385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22z"
    />
  </svg>
);

export const LayoutAlt02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 2 6.96 2 6.4 2h-.2385c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22H6.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 21.2401 8 20.9601 8 20.4z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 20.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109h6.2386c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8386 2H11.6c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C10 2.76 10 3.04 10 3.6zM12 7c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1m1 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1zm0 4c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const LayoutAlt03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614 2 6.6246 2.3754 7 2.8386 7h18.3228A.8385.8385 0 0 0 22 6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 10.6c0-.5601 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.2401 9 20.9601 9 20.4 9H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 9.76 2 10.04 2 10.6v7.2385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386zM5.5 13c0-.5523.4477-1 1-1h11c.5523 0 1 .4477 1 1s-.4477 1-1 1h-11c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h11c.5523 0 1 .4477 1 1s-.4477 1-1 1h-11c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const LayoutAlt04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.2401 2 9.96 2 9.4 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22H9.4c.56 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C11 21.2401 11 20.9601 11 20.4zM13 20.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109h3.2386c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V14.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 13 20.9601 13 20.4 13h-5.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C13 13.7599 13 14.0399 13 14.6zM20.4 11c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 10.2401 22 9.96 22 9.4V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8386 2H14.6c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C13 2.76 13 3.04 13 3.6v5.8c0 .56 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109z"
    />
  </svg>
);

export const LayoutBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614V12.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 14 3.04 14 3.6 14h16.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 13.2401 22 12.9601 22 12.4V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M22 17.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 16 20.9601 16 20.4 16H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 16.7599 2 17.0399 2 17.6v.2385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386z"
    />
  </svg>
);

export const LayoutGrid01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.2401 2 9.96 2 9.4 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614V9.4c0 .56 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 11 3.04 11 3.6 11h5.8c.56 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C11 10.2401 11 9.96 11 9.4zM3.6 13c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 13.7599 2 14.0399 2 14.6v3.2385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22H9.4c.56 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C11 21.2401 11 20.9601 11 20.4v-5.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C10.2401 13 9.96 13 9.4 13zM13 20.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109h3.2386c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V14.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 13 20.9601 13 20.4 13h-5.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C13 13.7599 13 14.0399 13 14.6zM22 9.4c0 .56 0 .8401-.109 1.054a1 1 0 0 1-.437.437C21.2401 11 20.9601 11 20.4 11h-5.8c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.437C13 10.2401 13 9.96 13 9.4V3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C13.7599 2 14.0399 2 14.6 2h3.2385c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1795 22 5.6343 22 6.1614z"
    />
  </svg>
);

export const LayoutGrid02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.2401 2 9.96 2 9.4 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614c0 .315 0 .4723.0351.6014a1 1 0 0 0 .7021.702c.129.0352.2865.0352.6014.0352H9.4c.56 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C11 6.74 11 6.46 11 5.9zM3.6 9.5c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 10.2599 2 10.5399 2 11.1v1.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h5.8c.56 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C11 13.7401 11 13.4601 11 12.9v-1.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C10.2401 9.5 9.96 9.5 9.4 9.5zM3.3386 16.5c-.315 0-.4723 0-.6014.0351a1 1 0 0 0-.702.7021C2 17.3663 2 17.5237 2 17.8385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22H9.4c.56 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C11 21.2401 11 20.9601 11 20.4v-2.3c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C10.2401 16.5 9.96 16.5 9.4 16.5zM13 20.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109h3.2386c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386c0-.3149 0-.4723-.0351-.6014a1 1 0 0 0-.7021-.7021c-.1291-.0351-.2865-.0351-.6014-.0351H14.6c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C13 17.2599 13 17.5399 13 18.1zM20.4 14.5c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 13.7401 22 13.4601 22 12.9v-1.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 9.5 20.9601 9.5 20.4 9.5h-5.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C13 10.2599 13 10.5399 13 11.1v1.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109zM22 6.1614c0 .315 0 .4723-.0351.6014a1 1 0 0 1-.7021.702c-.1291.0352-.2865.0352-.6014.0352H14.6c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.437C13 6.74 13 6.46 13 5.9V3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C13.7599 2 14.0399 2 14.6 2h3.2385c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1795 22 5.6343 22 6.1614"
    />
  </svg>
);

export const LayoutLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 2 6.96 2 6.4 2h-.2385c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22H6.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 21.2401 8 20.9601 8 20.4zM10 20.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109h6.2386c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8386 2H11.6c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C10 2.76 10 3.04 10 3.6z"
    />
  </svg>
);

export const LayoutRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.2401 2 12.9601 2 12.4 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22H12.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C14 21.2401 14 20.9601 14 20.4zM16 20.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109h.2386c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8386 2H17.6c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C16 2.76 16 3.04 16 3.6z"
    />
  </svg>
);

export const LayoutTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614V6.4c0 .56 0 .84.109 1.054.0959.1882.2489.3411.437.437C2.76 8 3.04 8 3.6 8h16.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 7.24 22 6.96 22 6.4v-.2386c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M22 11.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 10 20.9601 10 20.4 10H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 10.7599 2 11.0399 2 11.6v6.2385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386z"
    />
  </svg>
);

export const List = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 12c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1M8 6c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1M8 18c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1M2 12c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M2 6c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M2 18c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Maximize01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-5.2929 5.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 4H15c-.5523 0-1-.4477-1-1M5.4142 20l5.2929-5.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L4 18.5858V15c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Maximize02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2H8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.2c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 6.3611 4 6.9434 4 7.8V8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.2413c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2M3 15c.5523 0 1 .4477 1 1v.2c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1805C6.3611 19.9992 6.9434 20 7.8 20H8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.2413c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V16c0-.5523.4477-1 1-1M18.089 4.0376C17.6389 4.0008 17.0566 4 16.2 4H16c-.5523 0-1-.4477-1-1s.4477-1 1-1h.24130000000000001c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587V8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.2c0-.8566-.0008-1.4389-.0375-1.889-.0359-.4384-.1008-.6626-.1805-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804M21 15c.5523 0 1 .4477 1 1v.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H16c-.5523 0-1-.4477-1-1s.4477-1 1-1h.2c.8566 0 1.4389-.0008 1.889-.0375.4384-.0359.6626-.1008.819-.1805a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1805-.819.0367-.4501.0375-1.0324.0375-1.889V16c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Minimize01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m16.4142 9 5.2929-5.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L15 7.5858V4c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1zM9 20v-3.5858l-5.2929 5.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L7.5858 15H4c-.5523 0-1-.4477-1-1s.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1"
    />
  </svg>
);

export const Minimize02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.9999 2c.5523 0 1 .4477 1 1v.2413c0 .805 0 1.4693-.0442 2.0105-.046.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C4.7105 9 4.0462 9 3.2412 9h-.2413c-.5523 0-1-.4477-1-1s.4477-1 1-1h.2c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819C6.9991 4.6389 7 4.0566 7 3.2V3c0-.5523.4477-1 1-1M5.0888 17.0376C4.6388 17.0008 4.0565 17 3.1998 17h-.2c-.5522 0-1-.4477-1-1s.4478-1 1-1h.2414c.805 0 1.4693 0 2.0105.0442.5621.0459 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4854.3459 1.0021.3918 1.5642.0442.5412.0442 1.2055.0442 2.0105V21c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.2c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804M15.9999 2c.5523 0 1 .4477 1 1v.2c0 .8566.0008 1.4389.0375 1.889.0358.4384.1008.6626.1805.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804.4501.0368 1.0324.0376 1.889.0376h.2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.2413c-.805 0-1.4694 0-2.0105-.0442-.5621-.046-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.002-.3918-1.5642-.0442-.5412-.0442-1.2055-.0442-2.0105V3c0-.5523.4477-1 1-1M20.7586 15h.2413c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.2c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1447.3806-.1805.819-.0367.4501-.0375 1.0324-.0375 1.889v.2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.2413c0-.805 0-1.4693.0442-2.0105.0459-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.0021-.3459 1.5642-.3918C19.2892 15 19.9536 15 20.7586 15"
      clipRule="evenodd"
    />
  </svg>
);

export const Rows01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 17.1615v.677c0 .5272 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C18.8205 22 18.3657 22 17.8385 22H6.1615c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8386v-.6772c0-.5271 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1796 13 5.6343 13 6.1615 13h11.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3745.0306.8293.0306 1.3565M22 6.1615v.677c0 .5272 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C18.8205 11 18.3657 11 17.8385 11H6.1615c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 7.8205 2 7.3657 2 6.8386v-.6772c0-.5271 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1796 2 5.6343 2 6.1615 2h11.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1796 22 5.6343 22 6.1615"
      clipRule="evenodd"
    />
  </svg>
);

export const Rows02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.4 11c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 10.2401 22 9.96 22 9.4V6.1615c0-.5272 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8386 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614V9.4c0 .56 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 11 3.04 11 3.6 11zM3.6 13c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 13.7599 2 14.0399 2 14.6v3.2386c0 .5271 0 .9819.0306 1.3564.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V14.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 13 20.9601 13 20.4 13z"
    />
  </svg>
);

export const Rows03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.4 7c.5742 0 .8612 0 1.0781-.1128a1.017 1.017 0 0 0 .4383-.4504c.1067-.22.0992-.4922.0843-1.0367a11 11 0 0 0-.0313-.5951c-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8386 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167a11 11 0 0 0-.0313.595c-.015.5446-.0224.8169.0843 1.0368.0923.19.251.353.4383.4504C2.7388 7 3.0259 7 3.5999 7zM3.6 9c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 9.76 2 10.04 2 10.6v2.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 15 3.04 15 3.6 15h16.8c.56 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 14.2401 22 13.9601 22 13.4v-2.8c0-.5601 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.2401 9 20.96 9 20.4 9zM22.0007 18.5999c.0149-.5445.0224-.8168-.0843-1.0367a1.017 1.017 0 0 0-.4383-.4504C21.2612 17 20.9742 17 20.4 17H3.6c-.5742 0-.8612 0-1.0781.1128a1.017 1.017 0 0 0-.4383.4504c-.1067.2199-.0993.4922-.0843 1.0367.0055.1988.0151.3973.0313.5951.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167.0162-.1978.0258-.3963.0313-.5951"
    />
  </svg>
);

export const SpacingHeight01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 3c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 21c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M14.4453 8.832 13 7.8686v8.2631l1.4453-.9635c.4595-.3064 1.0804-.1822 1.3867.2773s.1822 1.0804-.2773 1.3868l-3 2a1 1 0 0 1-1.1094 0l-3-2c-.4595-.3064-.5837-.9273-.2774-1.3868s.9273-.5837 1.3868-.2773L11 16.1316v-8.263l-1.4453.9635c-.4595.3063-1.0804.1821-1.3868-.2774s-.1821-1.0804.2774-1.3868l3-2a1 1 0 0 1 1.1094 0l3 2c.4595.3064.5837.9273.2773 1.3868s-.9272.5837-1.3867.2774"
    />
  </svg>
);

export const SpacingHeight02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 3c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 21c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M15.0001 7.5H13v9h2.0001c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-9H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h6.0001c.5523 0 1 .4477 1 1s-.4477 1-1 1"
    />
  </svg>
);

export const SpacingWidth01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M21 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M7.8685 13l.9636 1.4454c.3063.4595.1821 1.0804-.2774 1.3868s-1.0804.1821-1.3868-.2774l-2-3a1 1 0 0 1 0-1.1094l2-3c.3064-.4595.9273-.5837 1.3868-.2773s.5837.9272.2774 1.3867L7.8686 11h8.2628l-.9635-1.4452c-.3063-.4595-.1821-1.0804.2774-1.3867s1.0804-.1822 1.3867.2773l2 3a1 1 0 0 1 0 1.1094l-2 3c-.3063.4595-.9272.5837-1.3867.2774s-.5837-.9273-.2774-1.3868L16.1315 13z"
    />
  </svg>
);

export const SpacingWidth02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M21 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M7.5 13v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V9c0-.5523.4477-1 1-1s1 .4477 1 1v2h9V9c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2z"
    />
  </svg>
);

export const Table = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.24 2 6.96 2 6.4 2h-.2385c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614V6.4c0 .56 0 .84.109 1.054.0959.1882.2489.3411.437.437C2.76 8 3.04 8 3.6 8h2.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 7.24 8 6.96 8 6.4zM3.6 10c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 10.7599 2 11.0399 2 11.6v6.2385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22H6.4c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C8 21.2401 8 20.9601 8 20.4v-8.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C7.24 10 6.96 10 6.4 10zM10 20.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109h6.2386c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V11.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 10 20.9601 10 20.4 10h-8.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C10 10.7599 10 11.0399 10 11.6zM22 6.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C21.2401 8 20.9601 8 20.4 8h-8.8c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.437C10 7.24 10 6.96 10 6.4V3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C10.7599 2 11.0399 2 11.6 2h6.2385c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1795 22 5.6343 22 6.1614z"
    />
  </svg>
);

export const BarChart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 9c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V10c0-.5523.4477-1 1-1M6 13c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1M12 3c.5523 0 1 .4477 1 1v16c0 .5523-.4477 1-1 1s-1-.4477-1-1V4c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 3c.5523 0 1 .4477 1 1v16c0 .5523-.4477 1-1 1s-1-.4477-1-1V4c0-.5523.4477-1 1-1M6 15c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1M12 9c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V10c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 3c.5523 0 1 .4477 1 1v16c0 .5523-.4477 1-1 1s-1-.4477-1-1V4c0-.5523.4477-1 1-1M18 15c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1M12 9c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V10c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChart04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 10c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V11c0-.5523.4477-1 1-1M15 10c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V11c0-.5523.4477-1 1-1M9 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M21 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChart05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 16c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1M15 7c.5523 0 1 .4477 1 1v13c0 .5523-.4477 1-1 1s-1-.4477-1-1V8c0-.5523.4477-1 1-1M9 12c.5523 0 1 .4477 1 1v8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-8c0-.5523.4477-1 1-1M21 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChart06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 7c.5523 0 1 .4477 1 1v13c0 .5523-.4477 1-1 1s-1-.4477-1-1V8c0-.5523.4477-1 1-1M21 16c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1M3 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M15 12c.5523 0 1 .4477 1 1v8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-8c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChart07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 2c.5523 0 1 .4477 1 1v14.8c0 .5766.0008.9488.024 1.2322.0221.2716.0598.3723.085.4218a1 1 0 0 0 .437.437c.0495.0252.1502.0629.4218.0851.2834.0231.6556.0239 1.2322.0239H21c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.1615c-.5271 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8385V3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 9.5c.5523 0 1 .4477 1 1v7c0 .5523-.4477 1-1 1s-1-.4477-1-1v-7c0-.5523.4477-1 1-1M11.5 4.5c.5523 0 1 .4477 1 1v12c0 .5523-.4477 1-1 1s-1-.4477-1-1v-12c0-.5523.4477-1 1-1M16 9.5c.5523 0 1 .4477 1 1v7c0 .5523-.4477 1-1 1s-1-.4477-1-1v-7c0-.5523.4477-1 1-1M20.5 4.5c.5523 0 1 .4477 1 1v12c0 .5523-.4477 1-1 1s-1-.4477-1-1v-12c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChart08 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 2c.5523 0 1 .4477 1 1v14.8c0 .5766.0008.9488.024 1.2322.0221.2716.0598.3723.085.4218a1 1 0 0 0 .437.437c.0495.0252.1502.0629.4218.0851.2834.0231.6556.0239 1.2322.0239H21c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.1615c-.5271 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8385V3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 13.5c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3c0-.5523.4477-1 1-1M11.5 10.5c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1M16 7.5c.5523 0 1 .4477 1 1v9c0 .5523-.4477 1-1 1s-1-.4477-1-1v-9c0-.5523.4477-1 1-1M20.5 4.5c.5523 0 1 .4477 1 1v12c0 .5523-.4477 1-1 1s-1-.4477-1-1v-12c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChart09 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 2c.5523 0 1 .4477 1 1v14.8c0 .5766.0008.9488.024 1.2322.0221.2716.0598.3723.085.4218a1 1 0 0 0 .437.437c.0495.0252.1502.0629.4218.0851.2834.0231.6556.0239 1.2322.0239H21c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.1615c-.5271 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8385V3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 4.5c.5523 0 1 .4477 1 1v12c0 .5523-.4477 1-1 1s-1-.4477-1-1v-12c0-.5523.4477-1 1-1M11.5 7.5c.5523 0 1 .4477 1 1v9c0 .5523-.4477 1-1 1s-1-.4477-1-1v-9c0-.5523.4477-1 1-1M16 10.5c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1M20.5 13.5c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChart10 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.5681 6h.8638000000000001c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201a2 2 0 0 1 .874.874c.1383.2715.1824.5412.201.7698.017.2081.017.454.017.7063V19.432c0 .2524 0 .4982-.017.7063-.0186.2286-.0627.4984-.201.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.454.0169-.7063.0169H3.568c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C1 19.9301 1 19.6843 1 19.4319V8.5681c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4983.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201C3.0699 6 3.3158 6 3.568 6M11.5681 2h.8638000000000001c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.454.0169.7063V19.432c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C9 19.9301 9 19.6843 9 19.4319V4.5681c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201.2081-.017.4539-.017.7063-.017M19.5681 10h.8638000000000001c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v6.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.4539-.017-.7063v-6.8638c0-.2524-.0001-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201.2081-.017.4539-.017.7063-.017"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChart11 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.5681 2h.8638000000000001c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201a2 2 0 0 1 .874.874c.1383.2714.1824.5412.201.7698.017.2081.017.454.017.7063V19.432c0 .2524 0 .4982-.017.7063-.0186.2286-.0627.4984-.201.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C1 19.9301 1 19.6843 1 19.4319V4.5681c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201C3.0699 2 3.3158 2 3.568 2M11.5681 6h.8638000000000001c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2715.1824.5412.2011.7698.017.2081.0169.454.0169.7063V19.432c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4983-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C9 19.9301 9 19.6843 9 19.4319V8.5681c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4983.201-.7698a2 2 0 0 1 .874-.874c.2715-.1383.5412-.1824.7698-.201.2081-.017.4539-.017.7063-.017M19.5681 10h.8638000000000001c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v6.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.4539-.017-.7063v-6.8638c0-.2524-.0001-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201.2081-.017.4539-.017.7063-.017"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChart12 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.5681 10h.8638000000000001c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.201.7698.017.2081.017.4539.017.7063v6.8638c0 .2524 0 .4982-.017.7063-.0186.2286-.0627.4984-.201.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.454.0169-.7063.0169H3.568c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C1 19.9301 1 19.6843 1 19.4319v-6.8638c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201.2081-.017.454-.017.7063-.017M11.5681 6h.8638000000000001c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2715.1824.5412.2011.7698.017.2081.0169.454.0169.7063V19.432c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4983-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C9 19.9301 9 19.6843 9 19.4319V8.5681c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4983.201-.7698a2 2 0 0 1 .874-.874c.2715-.1383.5412-.1824.7698-.201.2081-.017.4539-.017.7063-.017M19.5681 2h.8638000000000001c.2524 0 .4982 0 .7064.017.2285.0186.4983.0627.7697.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.017.454.0169.7063V19.432c.0001.2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7697.2011-.2082.017-.454.0169-.7064.0169h-.8638c-.2524 0-.4981.0001-.7063-.0169-.2286-.0187-.4983-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.017-.2081-.017-.4539-.017-.7063V4.5681c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2715-.1383.5412-.1824.7698-.201C19.07 2 19.3157 2 19.5681 2"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChartCircle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m1 6c0-.5523-.4477-1-1-1s-1 .4477-1 1v10c0 .5523.4477 1 1 1s1-.4477 1-1zm3 3c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1m-8 2c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChartCircle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m5 6c0-.5523-.4477-1-1-1s-1 .4477-1 1v10c0 .5523.4477 1 1 1s1-.4477 1-1zm-5 3c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1m-4 4c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChartCircle03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M8 6c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V7c0-.5523.4477-1 1-1m4 4c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1m5 5c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChartSquare01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M13 7c0-.5523-.4477-1-1-1s-1 .4477-1 1v10c0 .5523.4477 1 1 1s1-.4477 1-1zm3 3c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1m-8 2c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChartSquare02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M17 7c0-.5523-.4477-1-1-1s-1 .4477-1 1v10c0 .5523.4477 1 1 1s1-.4477 1-1zm-5 3c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1m-4 4c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChartSquare03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M8 6c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V7c0-.5523.4477-1 1-1m4 4c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1m5 5c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChartSquareDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5858l-1.2929-1.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143l3 3a1 1 0 0 0 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L6 5.5858z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m10.1213 7.1213-2.9995 2.9995a3.002 3.002 0 0 1-2.2706.8755 3 3 0 0 1-1.9725-.875c-.0209-.0208-.0313-.0312-.0376-.0371-.3136-.2926-.826-.0805-.8408.3482C2 10.4411 2 10.4558 2 10.4853v7.3533c0 .5271 0 .9819.0306 1.3564.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h7.6772c.5271 0 4.9819 0 5.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8386 2H9.7543a.2543.2543 0 0 0-.2543.2543c0 .0908.0489.174.1252.2233.1757.1135.3422.2472.4961.401 1.1716 1.1717 1.1716 3.0712 0 4.2427M17 6c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V7c0-.5523.4477-1 1-1m-3 5c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1s1-.4477 1-1zm-4 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChartSquareMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.5 2.2545C9.5 2.114 9.614 2 9.7545 2h8.084c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1795 22 5.6343 22 6.1614v11.6772c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C18.8205 22 18.3657 22 17.8386 22H6.1614c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8386V9.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 8 3.04 8 3.6 8H8c1.6569 0 3-1.3431 3-3 0-1.0579-.5476-1.9879-1.3748-2.522C9.549 2.4286 9.5 2.3454 9.5 2.2545M17 6c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V7c0-.5523.4477-1 1-1m-3 5c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1s1-.4477 1-1zm-4 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 5c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BarChartSquarePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 17.8385v-8.084c0-.1405.114-.2545.2545-.2545.0909 0 .1742.049.2234.1252C3.0122 10.4524 3.9422 11 5 11c1.6569 0 3-1.3431 3-3 1.6569 0 3-1.3431 3-3 0-1.0579-.5476-1.9879-1.3748-2.522C9.549 2.4286 9.5 2.3454 9.5 2.2545 9.5 2.114 9.614 2 9.7545 2h8.084c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1795 22 5.6343 22 6.1614v11.6772c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C18.8205 22 18.3657 22 17.8386 22H6.1614c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8385M18 7c0-.5523-.4477-1-1-1s-1 .4477-1 1v10c0 .5523.4477 1 1 1s1-.4477 1-1zm-5 3c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1m-4 2c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M6 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1V6h2c.5523 0 1-.4477 1-1s-.4477-1-1-1H6z"
    />
  </svg>
);

export const BarChartSquareUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.2545 9.5A.2545.2545 0 0 0 2 9.7545v8.084c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8386 2h-7.3533c-.4586 0-.6882.5544-.364.8787 1.1716 1.1716 1.1716 3.071 0 4.2426C9.5355 7.7071 8.7678 8 8 8c0 1.6569-1.3431 3-3 3-1.0579 0-1.9879-.5476-2.522-1.3748C2.4286 9.549 2.3454 9.5 2.2545 9.5M18 7c0-.5523-.4477-1-1-1s-1 .4477-1 1v10c0 .5523.4477 1 1 1s1-.4477 1-1zm-5 3c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1m-4 2c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.7071 1.2929a1 1 0 0 0-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L4 4.4142V8c0 .5523.4477 1 1 1s1-.4477 1-1V4.4142l1.2929 1.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143z"
    />
  </svg>
);

export const BarLineChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.2322 2.7322c.9763-.9763 2.5593-.9763 3.5356 0a2.49 2.49 0 0 1 .7287 1.636l3.7092 1.391.0265-.027c.9763-.9763 2.5593-.9763 3.5356 0s.9763 2.5593 0 3.5356-2.5593.9763-3.5356 0a2.49 2.49 0 0 1-.7287-1.636l-3.7092-1.391-.0265.027c-.8133.8132-2.0475.949-3.0014.4074L6.4334 9.925c.1917.8149-.0302 1.7073-.6656 2.3428-.9763.9763-2.5593.9763-3.5356 0s-.9763-2.5593 0-3.5356c.8133-.8133 2.0475-.949 3.0014-.4074l4.333-3.2498c-.1917-.8149.0302-1.7073.6656-2.3428"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20 12c.5523 0 1 .4477 1 1v7c0 .5523-.4477 1-1 1s-1-.4477-1-1v-7c0-.5523.4477-1 1-1M13 10c0-.5523-.4477-1-1-1s-1 .4477-1 1v10c0 .5523.4477 1 1 1s1-.4477 1-1zM4 15c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const ChartBreakoutCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1C5.9249 1 1 5.9249 1 12c0 .0992 0 .1488.0101.2195.0455.3167.2963.6461.5895.7743.0654.0285.1233.0445.239.0765.1816.0501.3452.094.4818.1296A12.04 12.04 0 0 0 5 13.5c3.3056 0 6.2993-1.336 8.4706-3.5H12c-.5523 0-1-.4477-1-1s.4477-1 1-1h4c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1.7022C12.4598 13.8899 8.918 15.5 5 15.5q-.3902 0-.777-.0209c-1.0122-.0547-1.5183-.082-1.7969.1065-.2372.1605-.4018.4331-.4334.7177-.0372.3343.1605.6653.5557 1.3274C4.4682 20.8464 7.9826 23 12 23c6.0751 0 11-4.9249 11-11S18.0751 1 12 1"
    />
  </svg>
);

export const ChartBreakoutSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v5.7298c0 .4332 0 .6498.0893.8467.0723.1594.2184.3294.3651.4249.1812.118.3682.1465.742.2034C3.793 13.4571 4.397 13.5 5 13.5c3.3056 0 6.2993-1.336 8.4706-3.5H12c-.5523 0-1-.4477-1-1s.4477-1 1-1h4c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1.7022C12.4598 13.8899 8.918 15.5 5 15.5q-.5221-.0002-1.035-.0378c-.762-.0557-1.143-.0836-1.3729.0191-.2197.0981-.359.2276-.473.4396C2 16.1426 2 16.4833 2 17.1647v.6738c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2"
    />
  </svg>
);

export const HorizontalBarChart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.1382 1.517c.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.454.0169.7063v.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.201-.2081.017-.4539.017-.7063.017H4V9h15.4319c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201a2 2 0 0 1 .874.874c.1383.2715.1824.5412.2011.7698.017.2081.0169.4538.0169.7061v.864c0 .2523.0001.4983-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169H4v1.5h5.4319c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1918.6823.4977.874.874.1383.2715.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v.8638c0 .2524.0001.4982-.0169.7064-.0187.2285-.0628.4983-.2011.7697a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.454.017-.7063.0169H3c-.5523 0-1-.4477-1-1v-19c0-.5523.4477-1 1-1h10.4319c.2524 0 .4982 0 .7063.017"
    />
  </svg>
);

export const HorizontalBarChart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.1382 1.517c.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.208.0169.4538.0169.706v.8641c0 .2523.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.201-.2081.017-.4539.017-.7063.017H4V9h9.4319c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201a2 2 0 0 1 .874.874c.1383.2715.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169H4v1.5h5.4319c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1918.6823.4977.874.874.1383.2715.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v.8638c0 .2524.0001.4982-.0169.7064-.0187.2285-.0628.4983-.2011.7697a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4538.017-.7062.0169H3c-.5523 0-1-.4477-1-1v-19c0-.5523.4477-1 1-1h16.4319c.2524 0 .4982 0 .7063.017"
    />
  </svg>
);

export const HorizontalBarChart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.1382 1.517c.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.454.0169.7063v.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.201-.2081.017-.454.017-.7063.017H4V9h9.4319c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201a2 2 0 0 1 .874.874c.1383.2715.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169H4v1.5h15.4319c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1918.6823.4977.874.874.1383.2715.1824.5412.2011.7698.017.2081.0169.4538.0169.7061v.864c0 .2523.0001.4983-.0169.7064-.0187.2285-.0628.4983-.2011.7697a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.017-.7062.0169H3a.9997.9997 0 0 1-1-1v-19a1 1 0 0 1 1-1h6.4319c.2524 0 .4982 0 .7063.017"
    />
  </svg>
);

export const LineChartDown01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 2c.5523 0 1 .4477 1 1v16.4c0 .2965.0008.4588.0103.5754l.0011.0131.0132.0012c.1166.0095.2789.0103.5754.0103H21c.5523 0 1 .4477 1 1s-.4477 1-1 1H4.5682c-.2524 0-.4982.0001-.7064-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C2 19.9301 2 19.6843 2 19.4319V3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.6837 15.7297c.4031-.3776.4237-1.0104.046-1.4134l-3.9188-4.1827q-.0125-.0133-.0286-.031c-.1024-.1119-.315-.3442-.5977-.4734a1.5 1.5 0 0 0-.7584-.1298c-.3095.0279-.5873.1762-.721.2477q-.0212.0114-.0373.0197l-3.1229 1.6215-3.8152-4.072c-.3777-.403-1.0105-.4237-1.4135-.046-.403.3776-.4237 1.0104-.046 1.4134l3.9188 4.1827q.0125.0133.0286.031c.1024.1119.315.3442.5977.4734.2372.1085.4986.1532.7584.1298.3095-.0279.5873-.1762.721-.2477l.0373-.0197 3.1229-1.6215 3.8153 4.072c.3776.403 1.0104.4237 1.4134.046"
      clipRule="evenodd"
    />
  </svg>
);

export const LineChartDown02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 2c.5523 0 1 .4477 1 1v16.4c0 .2965.0008.4588.0103.5754l.0011.0131.0132.0012c.1166.0095.2789.0103.5754.0103H21c.5523 0 1 .4477 1 1s-.4477 1-1 1H4.5682c-.2524 0-.4983.0001-.7064-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C2 19.9301 2 19.6843 2 19.4319V3c0-.5523.4477-1 1-1"
    />
    <path
      fill="currentColor"
      d="M20 12.5858V11c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1h-4c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.5858L15 10.4142l-1.7436 1.7436c-.0842.0843-.1847.1849-.2806.2663-.111.0942-.2796.2198-.5123.2954a1.5 1.5 0 0 1-.927 0c-.2327-.0756-.4013-.2012-.5123-.2954-.0959-.0814-.1964-.1821-.2806-.2663L6.2929 7.7071c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L12 10.5858l1.7436-1.7436c.0842-.0843.1847-.1849.2806-.2662.111-.0943.2796-.2199.5123-.2955a1.5 1.5 0 0 1 .927 0c.2327.0756.4013.2012.5123.2955.0959.0813.1964.1819.2806.2661z"
    />
  </svg>
);

export const LineChartDown03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1025.2012-.1706.4065-.2169.614-.025.1128-.0376.1692-.0314.2448.005.06.0278.1384.0558.1916.0353.0672.0856.1174.186.218L8 10.5857l1.7436-1.7436c.0842-.0842.1847-.1849.2806-.2662.111-.0943.2796-.2199.5123-.2955a1.5 1.5 0 0 1 .927 0c.2327.0756.4013.2012.5123.2955.0959.0813.1964.182.2806.2662L16 12.5858V11c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1h-4c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.5858L11 10.4142l-1.7436 1.7436c-.0842.0842-.1847.1849-.2806.2663-.111.0942-.2796.2198-.5123.2954a1.5 1.5 0 0 1-.927 0c-.2327-.0756-.4013-.2012-.5123-.2954-.0959-.0814-.1964-.182-.2806-.2662l-3.378-3.378c-.4283-.4284-.6425-.6426-.8264-.657a.5.5 0 0 0-.4194.1737C2 8.4369 2 8.7398 2 9.3456v8.4929c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2"
    />
  </svg>
);

export const LineChartDown04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v.5063c0 .1511 0 .2267.0203.2957a.5.5 0 0 0 .0867.1682c.0445.0566.106.1004.2292.188l7.5547 5.3754 2.9381-2.9381c.0719-.072.1601-.1602.2446-.2329.0998-.0857.2463-.1967.4467-.273a1.5 1.5 0 0 1 .8284-.0694c.2103.042.3732.127.4858.195.0955.0577.1971.13.28.189l5.6217 4.0001c.4085.2907.6127.436.783.4295a.5.5 0 0 0 .3768-.1944c.104-.1349.104-.3856.104-.8869V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2"
    />
    <path
      fill="currentColor"
      d="M22 17.3322c0-.1511 0-.2267-.0203-.2957a.5.5 0 0 0-.0868-.1682c-.0444-.0565-.106-.1003-.2291-.1879l-7.5545-5.3754-2.9381 2.9381c-.072.072-.1601.1603-.2447.2329-.0997.0858-.2463.1967-.4466.2731a1.5 1.5 0 0 1-.8284.0693c-.2103-.042-.3733-.127-.4859-.195-.0954-.0576-.197-.1299-.2799-.189l-5.6219-4.0002c-.4085-.2906-.6127-.436-.783-.4294a.5.5 0 0 0-.3768.1943C2 10.334 2 10.5847 2 11.086v6.7525c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386z"
    />
  </svg>
);

export const LineChartDown05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M6.7071 9.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3.4507 3.4507c.0842.0843.1847.1849.2806.2663.111.0942.2796.2198.5123.2954.3012.0979.6258.0979.927 0 .2327-.0756.4013-.2012.5123-.2954.0959-.0814.1964-.1821.2806-.2663L14 11.4142l3.2929 3.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-3.4506-3.4507c-.0842-.0842-.1848-.1849-.2807-.2662-.111-.0943-.2796-.2199-.5123-.2955a1.5 1.5 0 0 0-.927 0c-.2327.0756-.4013.2012-.5123.2955-.0959.0813-.1964.182-.2806.2662L10 12.5858z"
      clipRule="evenodd"
    />
  </svg>
);

export const LineChartUp01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v16.4319c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.454.0169.7063.0169H21c.5523 0 1-.4477 1-1s-.4477-1-1-1H4.6c-.2965 0-.4588-.0008-.5754-.0103l-.0132-.0012-.001-.0131C4.0007 19.8588 4 19.6965 4 19.4z"
    />
    <path
      fill="currentColor"
      d="M20.7297 8.6837c.3777-.403.3571-1.0358-.046-1.4134-.403-.3777-1.0358-.357-1.4134.046l-3.8153 4.072-3.1229-1.6215-.0212-.0112-.0161-.0085c-.1337-.0715-.4115-.2198-.721-.2477a1.5 1.5 0 0 0-.7584.1298c-.2827.1292-.4953.3615-.5977.4734l-.0086.0094-.02.0216-3.9188 4.1827c-.3777.403-.357 1.0358.046 1.4134.403.3777 1.0358.3571 1.4135-.046l3.8152-4.072 3.1229 1.6215.0373.0197c.1337.0715.4115.2198.721.2477a1.5 1.5 0 0 0 .7584-.1298c.2827-.1292.4953-.3615.5977-.4734q.0161-.0177.0286-.031z"
    />
  </svg>
);

export const LineChartUp02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 2c.5523 0 1 .4477 1 1v16.4c0 .2965.0008.4588.0103.5754l.0011.0131.0132.0012c.1166.0095.2789.0103.5754.0103H21c.5523 0 1 .4477 1 1s-.4477 1-1 1H4.5682c-.2524 0-.4983.0001-.7064-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C2 19.9301 2 19.6843 2 19.4319V3c0-.5523.4477-1 1-1"
    />
    <path
      fill="currentColor"
      d="M20 9.4142V11c0 .5523.4477 1 1 1s1-.4477 1-1V7c0-.5523-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5858L15 11.5858l-1.7436-1.7436c-.0842-.0843-.1847-.1849-.2806-.2662-.111-.0943-.2796-.2199-.5123-.2955a1.5 1.5 0 0 0-.927 0c-.2327.0756-.4013.2012-.5123.2955-.0959.0813-.1964.182-.2806.2662L6.2929 14.293c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L12 11.4142l1.7436 1.7436c.0842.0842.1847.1849.2806.2663.111.0942.2796.2198.5123.2954.3012.0979.6258.0979.927 0 .2327-.0756.4013-.2012.5123-.2954.0959-.0814.1964-.182.2806-.2663z"
    />
  </svg>
);

export const LineChartUp03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.8385 22H6.1615c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1025-.2012-.1706-.4065-.2169-.6141-.025-.1127-.0376-.1691-.0314-.2447a.56.56 0 0 1 .0558-.1916c.0353-.0672.0856-.1174.186-.2179L8 13.4142l1.7436 1.7436c.0842.0842.1847.1849.2806.2663.111.0942.2796.2198.5123.2954.3012.0979.6258.0979.927 0 .2327-.0756.4013-.2012.5123-.2954.0959-.0814.1964-.182.2806-.2663L16 11.4142V13c0 .5523.4477 1 1 1s1-.4477 1-1V9c0-.5523-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5858L11 13.5858l-1.7436-1.7436c-.0842-.0842-.1847-.1849-.2806-.2662-.111-.0943-.2796-.2199-.5123-.2955a1.5 1.5 0 0 0-.927 0c-.2327.0756-.4013.2012-.5123.2955-.0959.0813-.1964.1819-.2806.2661l-3.378 3.378c-.4283.4284-.6425.6426-.8264.657a.5.5 0 0 1-.4194-.1737C2 15.5631 2 15.2602 2 14.6544v-8.493c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1795 2 5.6343 2 6.1614 2h11.6772c.5271 0 .9819 0 1.3564.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1795 22 5.6343 22 6.1614v11.6772c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C18.8205 22 18.3657 22 17.8385 22"
    />
  </svg>
);

export const LineChartUp04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.1615 2h11.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1795 22 5.6343 22 6.1614v.5063c0 .1511 0 .2267-.0203.2957a.5.5 0 0 1-.0868.1682c-.0444.0566-.106.1004-.2291.188l-7.5547 5.3754-2.9381-2.9381c-.0719-.072-.1601-.1602-.2446-.2329-.0998-.0857-.2463-.1967-.4467-.273a1.5 1.5 0 0 0-.8284-.0694c-.2103.042-.3732.127-.4858.195-.0955.0577-.197.13-.28.189l-5.6217 4.0001c-.4085.2907-.6127.436-.783.4295a.5.5 0 0 1-.3768-.1944C2 13.6659 2 13.4152 2 12.9139V6.1614c0-.5271 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1795 2 5.6343 2 6.1615 2"
    />
    <path
      fill="currentColor"
      d="M2 17.3322c0-.1511 0-.2267.0203-.2957a.5.5 0 0 1 .0867-.1682c.0445-.0565.106-.1003.2292-.1879l7.5545-5.3754 2.9381 2.9381c.072.072.1601.1603.2447.2329.0997.0858.2463.1967.4467.2731.264.1007.5512.1247.8283.0693.2103-.042.3732-.127.4859-.195.0954-.0576.197-.1299.2799-.189l5.6219-4.0002c.4085-.2906.6127-.436.783-.4294a.5.5 0 0 1 .3768.1943c.104.1349.104.3856.104.8869v6.7525c0 .5272 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C18.8205 22 18.3657 22 17.8386 22H6.1614c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8386z"
    />
  </svg>
);

export const LineChartUp05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 23C5.9249 23 1 18.0751 1 12S5.9249 1 12 1s11 4.9249 11 11-4.9249 11-11 11m-5.2929-8.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l3.4507-3.4507c.0842-.0843.1847-.1849.2806-.2662.111-.0943.2796-.2199.5123-.2955a1.5 1.5 0 0 1 .927 0c.2327.0756.4013.2012.5123.2955.0959.0813.1964.182.2806.2662L14 12.5858l3.2929-3.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143l-3.4506 3.4507c-.0842.0842-.1848.1849-.2807.2663-.111.0942-.2796.2198-.5123.2954a1.5 1.5 0 0 1-.927 0c-.2327-.0756-.4013-.2012-.5123-.2954-.0959-.0814-.1964-.1821-.2806-.2663L10 11.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const PieChart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.595 1.1148c4.7985.697 8.5932 4.4918 9.2902 9.2903.0689.4744.1034.7116.0082.9568-.0765.1969-.2563.4048-.4402.5087-.229.1295-.5037.1295-1.0532.1295h-7.8c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.4371C12 11.2401 12 10.9601 12 10.4001v-7.8c0-.5495 0-.8243.1295-1.0533.1039-.1838.3118-.3637.5086-.4401.2453-.0952.4825-.0608.9569.0081"
    />
    <path
      fill="currentColor"
      d="M10 3.102c0-.638 0-.957-.1627-1.2062-.129-.1976-.3878-.3772-.6181-.429-.2904-.0651-.5497.0317-1.0683.2255C3.9741 3.2526 1 7.279 1 12c0 6.0751 4.9249 11 11 11 4.721 0 8.7474-2.9741 10.3078-7.1509.1937-.5187.2906-.778.2254-1.0683-.0518-.2304-.2313-.489-.429-.6181-.2491-.1627-.5682-.1627-1.2062-.1627h-7.3443c-.2382.0001-.5227.0002-.7733-.0203-.2905-.0237-.7065-.0846-1.1423-.3067a3 3 0 0 1-1.3111-1.3111c-.2221-.4359-.283-.8518-.3067-1.1423-.0205-.2506-.0204-.5351-.0203-.7734z"
    />
  </svg>
);

export const PieChart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.149 5.0397c.1803-.0207.5669-.065.9368.092.3043.129.5709.3702.7297.66.1207.2204.158.4323.1726.5907.012.1307.012.277.0119.3937V11.4c0 .56 0 .8401.109 1.054.0959.1881.2489.3411.437.437.2139.109.494.109 1.054.109h4.6239c.1167-.0001.263-.0002.3937.0119.1584.0146.3704.0519.5907.1726.2898.1588.531.4254.6601.7297.1569.37.1126.7566.0919.9369l-.0053.0474a8.9996 8.9996 0 0 1-10.7108 7.9286A9.0003 9.0003 0 0 1 4.9999 6.5168 9 9 0 0 1 9.1015 5.045q.0205-.0021.0474-.0053"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.851 1.0397q.027.0031.0475.0052a9.0004 9.0004 0 0 1 8.0566 8.0566q.002.0205.0052.0475c.0207.1803.065.5669-.0919.9369-.1291.3042-.3703.5708-.6601.7296-.2203.1207-.4323.1579-.5907.1726-.1307.012-.277.012-.3937.0119h-6.447c-.1191 0-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.1111-.218-.1415-.426-.1534-.5712C12.9999 9.4845 13 9.3423 13 9.2231v-6.447c-.0001-.1167-.0001-.263.0119-.3937.0147-.1584.0519-.3704.1726-.5907.1588-.2898.4254-.531.7296-.66.37-.157.7566-.1127.9369-.092"
      clipRule="evenodd"
    />
  </svg>
);

export const PieChart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 2.7955c0-.5921 0-.8882-.1454-1.1275-.1161-.191-.3486-.3717-.5623-.437-.2678-.0818-.5174-.0182-1.0166.109C4.5183 2.552 1 6.8652 1 12c0 6.0751 4.9249 11 11 11 1.4348 0 2.8055-.2747 4.0623-.7744.4783-.1902.7174-.2853.8861-.5089.1346-.1785.2165-.4614.1982-.6842-.023-.2791-.197-.5186-.545-.9976l-5.4039-7.4378A.996.996 0 0 1 11 12z"
    />
    <path
      fill="currentColor"
      d="M21.2045 13c.5921 0 .8881 0 1.1274.1454.191.1161.3717.3486.437.5623.0819.2678.0183.5173-.1088 1.0162-.4079 1.6011-1.167 3.0619-2.1905 4.2955-.3296.3973-.4944.5959-.7592.6872-.2115.0729-.5056.0635-.7119-.0229-.2584-.1081-.4327-.3479-.7812-.8276l-3.3318-4.5859c-.2978-.4099-.4467-.6148-.4413-.7859a.5.5 0 0 1 .1933-.3794C14.7727 13 15.0261 13 15.5327 13zM13 2.7955c0-.5921 0-.8882.1454-1.1275.1161-.191.3486-.3717.5623-.437.2678-.0818.5174-.0182 1.0165.109 3.8863.9901 6.9457 4.0495 7.9359 7.9358.1271.4991.1907.7487.1089 1.0165-.0654.2137-.246.4462-.437.5623C22.0927 11 21.7966 11 21.2045 11H13.8c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C13 10.62 13 10.48 13 10.2z"
    />
  </svg>
);

export const PieChart04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.6255 20.158c-.2221.5496-.3332.8245-.558.9919-.1794.1337-.463.2139-.6858.1941-.2793-.0248-.4869-.1779-.9021-.484C2.7626 18.8572 1 15.6344 1 12l.0003-.0855c.004-.5165.006-.7747.1534-1.013.1177-.1904.3516-.3691.5662-.4327.2687-.0796.5553-.0039 1.1285.1476l6.9222 1.8289c.3032.0801.4547.1201.5484.2104a.5.5 0 0 1 .149.2976c.0162.1291-.0425.2744-.16.5651zM13.0962 2.8063c.0062-.592.0093-.888.1573-1.1258.118-.1898.3525-.368.5669-.4311.2686-.079.5175-.0128 1.0151.1196C19.5365 2.6196 23 6.9053 23 12c0 6.0752-4.9249 11-11 11-.4968 0-.986-.0329-1.4654-.0967-.5106-.068-.7659-.102-.984-.2781-.1741-.1405-.3225-.3954-.3588-.6161-.0454-.2767.0656-.5513.2875-1.1006l3.4479-8.5339A1 1 0 0 0 13 11.9959zM9.3875 1.3121c.5005-.1219.7507-.1828 1.0176-.0982.213.0676.4436.2507.5576.4429.1429.2408.1398.5369.1336 1.129l-.072 6.8833c-.0037.3513-.0056.5269-.0797.6459a.5.5 0 0 1-.2839.2155c-.1345.0394-.3041-.0061-.6434-.097L3.3678 8.6518c-.5721-.1533-.8582-.23-1.0518-.4327-.1545-.1617-.2688-.4336-.2763-.657-.0094-.2803.117-.5047.37-.9535C3.8831 3.993 6.3956 2.041 9.3874 1.3121"
    />
  </svg>
);

export const PresentationChart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 3c0-.5523.4477-1 1-1h20c.5523 0 1 .4477 1 1s-.4477 1-1 1v7.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 17 17.0463 17 16.2413 17h-1.4792l3.8781 3.2318c.4243.3535.4816.9841.128 1.4084s-.9841.4816-1.4084.128L13 18.135V21c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2.8649l-4.3598 3.6331c-.4243.3536-1.0548.2963-1.4084-.128s-.2962-1.0549.128-1.4084L9.238 17H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 12.7106 2 12.0463 2 11.2413V4c-.5523 0-1-.4477-1-1m11 3c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1V7c0-.5523.4477-1 1-1M8 8c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1V9c0-.5523.4477-1 1-1m9 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v1c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const PresentationChart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 3c0-.5523.4477-1 1-1h20c.5523 0 1 .4477 1 1s-.4477 1-1 1v7.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 17 17.0463 17 16.2413 17h-1.4792l3.8781 3.2318c.4243.3535.4816.9841.128 1.4084s-.9841.4816-1.4084.128L13 18.135V21c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2.8649l-4.3598 3.6331c-.4243.3536-1.0548.2963-1.4084-.128s-.2962-1.0549.128-1.4084L9.238 17H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 12.7106 2 12.0463 2 11.2413V4c-.5523 0-1-.4477-1-1m16 4c0-.5523-.4477-1-1-1s-1 .4477-1 1v5c0 .5523.4477 1 1 1s1-.4477 1-1zm-5 1c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1V9c0-.5523.4477-1 1-1m-4 2c.5523 0 1 .4477 1 1v1c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const PresentationChart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 3c0-.5523.4477-1 1-1h20c.5523 0 1 .4477 1 1s-.4477 1-1 1v7.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 17 17.0463 17 16.2413 17h-1.4792l3.8781 3.2318c.4243.3535.4816.9841.128 1.4084s-.9841.4816-1.4084.128L13 18.135V21c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2.8649l-4.3598 3.6331c-.4243.3536-1.0548.2963-1.4084-.128s-.2962-1.0549.128-1.4084L9.238 17H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 12.7106 2 12.0463 2 11.2413V4c-.5523 0-1-.4477-1-1m7 3c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1V7c0-.5523.4477-1 1-1m4 2c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1V9c0-.5523.4477-1 1-1m5 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v1c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const TrendDown01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.7071 6.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l4.8912 4.8912c.1784.1785.3522.3523.5114.4875.1749.1484.3967.308.6865.4021a2 2 0 0 0 1.236 0c.2897-.0941.5116-.2537.6865-.4021.1592-.1352.333-.309.5114-.4875l2.7598-2.7598c.2097-.2097.325-.3239.4142-.3996L13 9.4304l.0101.0085c.0892.0757.2045.1899.4142.3996L19.5858 16H15c-.5523 0-1 .4477-1 1s.4477 1 1 1h7c.5523 0 1-.4477 1-1v-7c0-.5523-.4477-1-1-1s-1 .4477-1 1v4.5858l-6.1841-6.184c-.1784-.1786-.3522-.3524-.5114-.4876-.1749-.1484-.3967-.308-.6865-.4021a2 2 0 0 0-1.236 0c-.2898.0941-.5116.2537-.6865.4021-.1592.1352-.333.309-.5114.4875l-2.7598 2.7598c-.2097.2097-.325.3239-.4142.3996L8 11.5696l-.0101-.0085c-.0892-.0757-.2045-.1899-.4142-.3996z"
    />
  </svg>
);

export const TrendDown02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7071 6.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L14.5858 16H7c-.5523 0-1 .4477-1 1s.4477 1 1 1h10c.5523 0 1-.4477 1-1V7c0-.5523-.4477-1-1-1s-1 .4477-1 1v7.5858z"
    />
  </svg>
);

export const TrendUp01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h4.5858l-6.1615 6.1615c-.2097.2097-.325.3239-.4142.3996L13 14.5696l-.0101-.0085c-.0892-.0757-.2045-.1899-.4142-.3996l-2.7598-2.7598c-.1784-.1785-.3522-.3523-.5114-.4875-.1749-.1484-.3968-.308-.6865-.4021a2 2 0 0 0-1.236 0c-.2897.0941-.5116.2537-.6865.4021-.1592.1352-.333.309-.5114.4875l-4.8912 4.8912c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l4.8686-4.8686c.2097-.2097.325-.3239.4142-.3996L8 12.4304l.0101.0085c.0892.0757.2045.1899.4142.3996l2.7598 2.7598c.1784.1785.3522.3523.5114.4875.1749.1484.3967.308.6865.4021a2 2 0 0 0 1.236 0c.2898-.0941.5116-.2537.6865-.4021.1592-.1352.333-.309.5114-.4875L21 9.4143V14c0 .5523.4477 1 1 1s1-.4477 1-1V7c0-.5523-.4477-1-1-1z"
    />
  </svg>
);

export const TrendUp02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h7.5858l-8.293 8.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0L16 9.4142V17c0 .5523.4477 1 1 1s1-.4477 1-1V7c0-.5523-.4477-1-1-1z"
    />
  </svg>
);

export const FaceId = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2H8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.2c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 6.3611 4 6.9434 4 7.8V8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.2413c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2M3 15c.5523 0 1 .4477 1 1v.2c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1805C6.3611 19.9992 6.9434 20 7.8 20H8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.2413c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V16c0-.5523.4477-1 1-1M18.089 4.0376C17.6389 4.0008 17.0566 4 16.2 4H16c-.5523 0-1-.4477-1-1s.4477-1 1-1h.24130000000000001c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587V8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.2c0-.8566-.0008-1.4389-.0375-1.889-.0359-.4384-.1008-.6626-.1805-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804M21 15c.5523 0 1 .4477 1 1v.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H16c-.5523 0-1-.4477-1-1s.4477-1 1-1h.2c.8566 0 1.4389-.0008 1.889-.0375.4384-.0359.6626-.1008.819-.1805a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1805-.819.0367-.4501.0375-1.0324.0375-1.889V16c0-.5523.4477-1 1-1M7.5 7c.5523 0 1 .4477 1 1v1.5c0 .5523-.4477 1-1 1s-1-.4477-1-1V8c0-.5523.4477-1 1-1M16.5 7c.5523 0 1 .4477 1 1v1.5c0 .5523-.4477 1-1 1s-1-.4477-1-1V8c0-.5523.4477-1 1-1M12.5 7c.5523 0 1 .4477 1 1v3.1001c0 1.3523-1.1477 2.5-2.5 2.5-.5523 0-1-.4477-1-1s.4477-1 1-1c.2477 0 .5-.2523.5-.5V8c0-.5523.4477-1 1-1M7.993 14.4928c.3906-.3905 1.0238-.3905 1.4143 0a3.587 3.587 0 0 0 5.0858 0c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4143c-2.1905 2.1905-5.7237 2.1905-7.9142 0-.3905-.3906-.3905-1.0237 0-1.4143"
      clipRule="evenodd"
    />
  </svg>
);

export const FaceIdSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M8.5 8c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.5c0 .5523.4477 1 1 1s1-.4477 1-1zm9 0c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.5c0 .5523.4477 1 1 1s1-.4477 1-1zm-5-1c.5523 0 1 .4477 1 1v3.1001c0 1.3523-1.1477 2.5-2.5 2.5-.5523 0-1-.4477-1-1s.4477-1 1-1c.2477 0 .5-.2523.5-.5V8c0-.5523.4477-1 1-1m-3.0927 7.4928c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4143c2.1905 2.1905 5.7237 2.1905 7.9142 0 .3905-.3906.3905-1.0237 0-1.4143s-1.0237-.3905-1.4142 0a3.587 3.587 0 0 1-5.0858 0"
      clipRule="evenodd"
    />
  </svg>
);

export const FileLock01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.5 13.5c-1.5188 0-2.75 1.2312-2.75 2.75v.778c-.2025.024-.4296.0736-.658.19a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.0171.2081-.017.4539-.017.7063v.8638c0 .2524-.0001.4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h3.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2284-.1164-.4555-.166-.658-.19v-.778c0-1.5188-1.2312-2.75-2.75-2.75m.75 3.5v-.75a.75.75 0 0 0-1.5 0V17z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.5 13.5c-1.5188 0-2.75 1.2312-2.75 2.75v.778c-.2025.024-.4296.0736-.658.19a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.0171.2081-.017.4539-.017.7063v.8638c0 .2524-.0001.4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h3.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2284-.1164-.4555-.166-.658-.19v-.778c0-1.5188-1.2312-2.75-2.75-2.75m.75 3.5v-.75a.75.75 0 0 0-1.5 0V17z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h2.3916c.4588 0 .6881 0 .804-.0667.1228-.0707.1711-.1281.2199-.2611.046-.1255-.0027-.4074-.1-.971a4.5 4.5 0 0 1-.0506-.4001c-.024-.2938-.0237-.6187-.0236-.8482v-.9057c-.0001-.2295-.0004-.5544.0236-.8482.0288-.3523.1065-.9145.4124-1.5149a4 4 0 0 1 1.3491-1.5148C14.0715 13.3198 16.0732 11.5 18.5 11.5c.4084 0 .8047.0515 1.1829.1485.5525.1416.8287.2124.9628.1715.1376-.0419.2067-.0955.2815-.2184.0728-.1197.0728-.3561.0728-.8287V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1"
    />
  </svg>
);

export const FileLock02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v4.0142c0 .4726 0 .709-.0728.8287-.0748.1229-.1439.1765-.2815.2184-.1341.0409-.4103-.0299-.9628-.1715A4.76 4.76 0 0 0 18.5 11.5c-2.4268 0-4.4285 1.8198-4.7149 4.1693a4 4 0 0 0-1.3491 1.5148c-.3059.6004-.3836 1.1626-.4124 1.5149-.024.2938-.0237.6187-.0236.8482v.9057c-.0001.2295-.0004.5544.0236.8482a4.5 4.5 0 0 0 .0506.4001c.0973.5636.146.8455.1.971-.0488.133-.0971.1904-.2199.2611-.1159.0667-.3452.0667-.804.0667H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9538 1 8.7587 1M7 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h5c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h3c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.75 16.25c0-1.5188 1.2312-2.75 2.75-2.75s2.75 1.2312 2.75 2.75v.778c.2025.024.4296.0736.658.19.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4538.0169-.7062.0169h-3.8639c-.2523 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.4539-.017-.7063v-.8638c0-.2524-.0001-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2284-.1164.4555-.166.658-.19zm3.5 0V17h-1.5v-.75a.75.75 0 0 1 1.5 0"
      clipRule="evenodd"
    />
  </svg>
);

export const FileLock03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.75 13.25V14h-1.5v-.75a.75.75 0 0 1 1.5 0M13.7 18c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-.4c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C14.12 16 13.98 16 13.7 16h-3.4c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C9.5 16.38 9.5 16.52 9.5 16.8v.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C9.88 18 10.02 18 10.3 18z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zM9.25 13.25c0-1.5188 1.2312-2.75 2.75-2.75s2.75 1.2312 2.75 2.75v.778c.2025.024.4296.0736.658.19.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-3.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.017-.2081-.017-.4539-.017-.7063v-.8638c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2284-.1164.4555-.166.658-.19z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7z"
    />
  </svg>
);

export const FileShield01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m19.1496 14.1995 2.1869.7815a1 1 0 0 1 .6635.9417v2.5023c0 1.539-1.0564 2.6898-1.8595 3.3596-.4264.3557-.8476.6313-1.1599.8173a8 8 0 0 1-.4994.2755c-.1684.0828-.7536.1004-.912.0248a7.8 7.8 0 0 1-.5498-.3003c-.3123-.186-.7335-.4616-1.1599-.8173C15.0565 21.1148 14 19.964 14 18.425v-2.5023c0-.4225.2655-.7994.6633-.9417l2.1859-.7815a3.415 3.415 0 0 1 2.3004 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23H12.17c.6478 0 .9718 0 1.1046-.0989.1307-.0971.1873-.1997.2-.3621.013-.1651-.1825-.4758-.5735-1.0973-.5083-.808-.9011-1.8173-.9011-3.0166v-2.5023a3 3 0 0 1 1.99-2.8249l2.1859-.7815a5.413 5.413 0 0 1 3.646-.0004l.001.0004.0012.0004.1067.0382c.36.1286.54.1929.6837.1591a.5.5 0 0 0 .3053-.2151C21 12.175 21 11.9839 21 11.6016v-4.843c0-.8049 0-1.4692-.0442-2.0104-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1"
    />
  </svg>
);

export const FileShield02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v4.8429c0 .3823 0 .5734-.0802.6974a.5.5 0 0 1-.3053.2151c-.1437.0338-.3237-.0305-.6837-.1591l-.1067-.0382-.0012-.0004-.001-.0004a5.413 5.413 0 0 0-3.646.0004l-2.1859.7815A3 3 0 0 0 12 15.9228v2.5023c0 1.1993.3928 2.2086.9011 3.0166.391.6215.5865.9322.5735 1.0973-.0127.1624-.0693.265-.2.3621C13.1418 23 12.8178 23 12.17 23H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9538 1 8.7587 1M7 9c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1m1-9c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m21.3365 14.981-2.1869-.7815a3.415 3.415 0 0 0-2.3004 0l-2.1859.7815a1 1 0 0 0-.6633.9417v2.5023c0 1.539 1.0565 2.6898 1.8595 3.3596.4264.3557.8476.6313 1.1599.8173.1795.1069.3623.2082.5498.3003.1584.0756.7436.058.912-.0248.084-.042.2634-.1349.4994-.2755.3123-.186.7335-.4616 1.1599-.8173C20.9436 21.1148 22 19.964 22 18.425v-2.5023a1 1 0 0 0-.6635-.9417"
    />
  </svg>
);

export const FileShield03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.8595 17.2488c-.3054.2547-.6153.4613-.8595.6091-.2442-.1478-.5541-.3544-.8595-.6091C10.4435 16.6674 10 16.0308 10 15.425v-1.7979l1.5236-.5447a1.413 1.413 0 0 1 .9523.0003L14 13.6273v1.7977c0 .6058-.4435 1.2424-1.1405 1.8238"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.9989 1.9523C13 1.976 13 1.9893 13 2.0156v4.4163c0 .2524-.0001.4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.201.2081.017.4539.017.7063.017h4.4164c.0262 0 .0393 0 .0632.0012.4938.0235.9279.4578.9512.9516A1 1 0 0 1 21 10v7.2414c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C16.7106 23 16.0463 23 15.2413 23H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9537 1 8.7586 1H12c.0156 0 .0234 0 .0473.0011.4937.0234.928.4574.9516.9512m2.3376 10.0287-2.1869-.7815a3.415 3.415 0 0 0-2.3004 0l-2.1859.7815A1 1 0 0 0 8 12.9227v2.5023c0 1.539 1.0564 2.6898 1.8595 3.3596.4264.3557.8476.6313 1.1599.8173.1795.1069.3623.2082.5498.3003.2722.1297.5889.13.8611.0003a9.2 9.2 0 0 0 .5503-.3006c.3123-.186.7335-.4616 1.1599-.8173C14.9435 18.1148 16 16.964 16 15.425v-2.5023a1 1 0 0 0-.6635-.9417"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.4686 6.9263C19.3484 7 19.2016 7 18.908 7H15.8c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2186C15 6.62 15 6.48 15 6.2V3.092c0-.2936 0-.4404.0737-.5607.1042-.1698.3495-.2713.5432-.2248.1371.033.2328.1287.4241.3202l3.3323 3.3323c.1915.1913.2872.287.3202.4241.0465.1937-.055.439-.2249.5432"
    />
  </svg>
);

export const Fingerprint01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 7c-2.7614 0-5 2.2386-5 5 0 .6174.1114 1.2066.3145 1.7499.1933.5173-.0694 1.0934-.5868 1.2867s-1.0934-.0693-1.2867-.5867A6.99 6.99 0 0 1 5 12c0-3.866 3.134-7 7-7 .8554 0 1.6771.1539 2.4375.4364.5177.1923.7815.7679.5892 1.2856s-.7679.7815-1.2856.5892A4.99 4.99 0 0 0 12 7m5.2763 1.9704c.5177-.1926 1.0934.071 1.286.5885A6.99 6.99 0 0 1 19 12c0 3.866-3.134 7-7 7a6.99 6.99 0 0 1-2.4223-.4307c-.5182-.1912-.7833-.7661-.5922-1.2843s.7661-.7833 1.2843-.5922A4.99 4.99 0 0 0 12 17c2.7614 0 5-2.2386 5-5a4.99 4.99 0 0 0-.3121-1.7436c-.1926-.5176.0708-1.0933.5884-1.286"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3c-1.6714 0-3.2335.4547-4.5729 1.2465-.4754.281-1.0886.1235-1.3697-.352s-.1235-1.0886.352-1.3697C8.0483 1.5558 9.9607 1 12 1c6.0751 0 11 4.9249 11 11q0 .0546-.0005.109c-.0054.5523-.4575.9956-1.0097.9902-.5523-.0053-.9956-.4574-.9902-1.0096A9 9 0 0 0 21 12c0-4.9706-4.0294-9-9-9M3.8893 6.0646c.4757.2806.6337.8937.3531 1.3694C3.4531 8.7718 3 10.3315 3 12c0 4.1923 2.8673 7.7174 6.7493 8.7165.5348.1377.8568.6829.7191 1.2177-.1376.5349-.6828.8569-1.2177.7192C4.5066 21.4323 1 17.1269 1 12c0-2.0357.554-3.945 1.5199-5.5823.2806-.4757.8937-.6338 1.3694-.3531m17.3111 9.9858c.4806.2722.6496.8824.3774 1.3629-1.4516 2.5633-3.9031 4.4871-6.8285 5.2401-.5349.1377-1.0801-.1843-1.2177-.7192-.1377-.5348.1843-1.08.7191-1.2177 2.3893-.6149 4.3975-2.1887 5.5868-4.2887.2721-.4806.8823-.6495 1.3629-.3774M12 9c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Fingerprint02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 10c0-3.0376 2.4624-5.5 5.5-5.5a5.48 5.48 0 0 1 2.8423.7906c.4727.2857.6241.9005.3384 1.3731s-.9005.6241-1.3731.3384A3.48 3.48 0 0 0 12 6.5c-1.933 0-3.5 1.567-3.5 3.5v2.95c0 .5523-.4477 1-1 1s-1-.4477-1-1zm10 .04c.5523 0 1 .4477 1 1V14c0 3.0376-2.4624 5.5-5.5 5.5a5.48 5.48 0 0 1-2.8361-.7868c-.473-.2852-.6253-.8997-.3402-1.3727s.8997-.6253 1.3727-.3402A3.48 3.48 0 0 0 12 17.5c1.933 0 3.5-1.567 3.5-3.5v-2.96c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 9c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1M6.8773 2.5992C8.3316 1.591 10.0983 1 12 1c4.9706 0 9 4.0294 9 9v1.2367c0 .5522-.4477 1-1 1s-1-.4478-1-1V10c0-3.866-3.134-7-7-7-1.4815 0-2.8528.4591-3.983 1.2428-.454.3147-1.077.2019-1.3917-.252s-.2018-1.0769.252-1.3916m-2.142 3.8991c.5235.1762.805.7434.6288 1.2668A6.99 6.99 0 0 0 5 10v4c0 3.179 2.12 5.8655 5.0255 6.7179.5299.1555.8335.7111.678 1.2411-.1555.5299-.7111.8335-1.241.678C5.7283 21.5415 3 18.0907 3 14v-4a8.99 8.99 0 0 1 .4686-2.873c.1762-.5234.7433-.8049 1.2668-.6287m15.2129 8.8632c.5287.1599.8277.718.6678 1.2466-.821 2.7156-2.8882 4.8869-5.5372 5.8512-.5189.1889-1.0928-.0786-1.2817-.5976s.0786-1.0928.5976-1.2817c2.0597-.7498 3.669-2.441 4.3069-4.5507.1598-.5286.718-.8276 1.2466-.6678"
      clipRule="evenodd"
    />
  </svg>
);

export const Fingerprint03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.8418 14.2187c0-5.6135 4.5488-10.164 10.1599-10.164s10.1599 4.5505 10.1599 10.164c0 2.2392-1.8149 4.0546-4.0536 4.0546s-4.0537-1.8154-4.0537-4.0546c0-1.1352-.9199-2.0547-2.0536-2.0547s-2.0536.9195-2.0536 2.0547c0 2.9241 1.5374 5.4896 3.8515 6.9327.4686.2922.6116.909.3193 1.3777-.2922.4686-.909.6116-1.3777.3193-2.8747-1.7927-4.7931-4.9863-4.7931-8.6297 0-2.2393 1.815-4.0547 4.0536-4.0547s4.0536 1.8154 4.0536 4.0547c0 1.1351.92 2.0546 2.0537 2.0546s2.0536-.9195 2.0536-2.0546c0-4.5097-3.654-8.164-8.1599-8.164s-8.1599 3.6543-8.1599 8.164c0 1.0532.1178 2.0801.3352 3.0716.1183.5395-.2232 1.0727-.7626 1.191-.5395.1182-1.0727-.2232-1.191-.7627-.247-1.1264-.3816-2.2968-.3816-3.4999"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.9988 9.1093c-2.8197 0-5.1063 2.2868-5.1063 5.1094 0 2.3929.7501 4.607 2.0264 6.4284.317.4523.2072 1.0759-.245 1.3928-.4523.317-1.076.2072-1.3929-.2451-1.5034-2.1455-2.3885-4.7579-2.3885-7.5761 0-3.9263 3.1812-7.1094 7.1063-7.1094 3.925 0 7.1062 3.1831 7.1062 7.1094 0 .5522-.4477 1-1 1s-1-.4478-1-1c0-2.8226-2.2866-5.1094-5.1062-5.1094"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.0008 13.2187c.5523 0 1 .4477 1 1 0 2.8225 2.2867 5.1093 5.1063 5.1093.0457 0 .0776-.0022.1324-.0059.0347-.0024.0786-.0054.141-.0089.5514-.0306 1.0233.3916 1.0539.943.0307.5515-.3915 1.0233-.943 1.054-.0122.0006-.0297.0018-.0509.0032-.0808.0055-.2167.0146-.3334.0146-3.9251 0-7.1063-3.1831-7.1063-7.1093 0-.5523.4477-1 1-1M2.7236 5.2024C4.9866 2.6318 8.3 1 11.9998 1s7.0132 1.6318 9.2761 4.2024c.365.4145.3248 1.0464-.0898 1.4113s-1.0464.3247-1.4113-.0898C17.8731 4.3638 15.0977 3 11.9998 3s-5.8734 1.3638-7.775 3.5239c-.365.4145-.9968.4548-1.4114.0898s-.4547-.9968-.0898-1.4113"
      clipRule="evenodd"
    />
  </svg>
);

export const Fingerprint04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.9999 11c0-2.7614 2.2386-5 5-5s5 2.2386 5 5c0 1.0625-.0723 2.1092-.2125 3.1353-.0747.5472-.5789.9302-1.1261.8555s-.9302-.5789-.8555-1.1261A21.2 21.2 0 0 0 14.9999 11c0-1.6569-1.3432-3-3-3s-3 1.3431-3 3c0 2.9356-.8403 5.6658-2.2922 7.9738a3 3 0 0 0-.041.0672c-.282.4749-.8956.6312-1.3705.3492-.4748-.2821-.6311-.8956-.3491-1.3705a5 5 0 0 1 .0677-.1108c1.2571-1.9984 1.985-4.361 1.985-6.9089m8.4431 5.0378c.5314.1504.8403.7031.6899 1.2345a22.88 22.88 0 0 1-1.5596 4.0192c-.2474.4938-.8482.6936-1.342.4462s-.6936-.8482-.4462-1.342a20.9 20.9 0 0 0 1.4234-3.668c.1504-.5314.7031-.8403 1.2345-.6899"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.4993 3.2047C8.824 2.4383 10.3624 2 12 2c4.9705 0 9 4.0294 9 9 0 2.5667-.3584 5.0513-1.0286 7.4057-.1512.5312-.7043.8392-1.2355.6881-.5312-.1512-.8393-.7044-.6881-1.2356C18.6678 15.6801 19 13.3797 19 11c0-3.866-3.134-7-7-7-1.2767 0-2.4707.3409-3.4993.9359-.478.2765-1.0898.1131-1.3663-.365-.2766-.478-.1132-1.0897.3649-1.3662M5.571 6.1343c.478.2765.6414.8883.3649 1.3663-.595 1.0286-.936 2.2226-.936 3.4993 0 1.7193-.395 3.3491-1.1004 4.8011-.2414.4968-.8397.7038-1.3365.4625-.4967-.2413-.7038-.8397-.4625-1.3364C2.6765 13.7416 3 12.41 3 11c0-1.6376.4383-3.176 1.2046-4.5007.2766-.478.8883-.6414 1.3664-.365"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.9999 10c.5522 0 1 .4477 1 1 0 3.7111-1.065 7.1765-2.9064 10.1037-.294.4675-.9114.608-1.379.314-.4674-.2941-.608-.9115-.3139-1.379 1.6466-2.6176 2.5993-5.7154 2.5993-9.0387 0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderShield = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.8595 15.7488c-.3054.2547-.6153.4613-.8595.6091-.2442-.1478-.5541-.3544-.8595-.6091C10.4436 15.1674 10 14.5308 10 13.925v-1.7979l1.5236-.5447a1.413 1.413 0 0 1 .9523.0003L14 12.1273v1.7977c0 .6058-.4435 1.2424-1.1405 1.8238"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617v10.0796c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-3.6234l-.8945-1.7894c-.2648-.5312-.4976-.9984-.8603-1.3536a3 3 0 0 0-1.121-.6928c-.4799-.1656-1.0019-.1649-1.5954-.164H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1797 1 5.6346 1 6.1617m9.09-2.1068c-.1206-.0416-.2773-.0547-1.0677-.0547H5.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4219C3.0035 5.217 3.0004 5.535 3 6h8.3819l-.3919-.7836c-.3534-.707-.4352-.8413-.5263-.9306a1 1 0 0 0-.3737-.231m5.2465 6.4261-2.1869-.7815a3.415 3.415 0 0 0-2.3004 0l-2.1859.7815A1 1 0 0 0 8 11.4227v2.5023c0 1.539 1.0564 2.6898 1.8595 3.3596.4264.3557.8476.6313 1.1599.8173.1794.1069.3614.2101.5498.3003.2722.1297.5889.13.8611.0003 0 0 .1527-.0637.5503-.3006.3123-.186.7335-.4616 1.1599-.8173C14.9436 16.6148 16 15.464 16 13.925v-2.5023a1 1 0 0 0-.6635-.9417"
      clipRule="evenodd"
    />
  </svg>
);

export const Key01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.9999 2c-3.8659 0-7 3.134-7 7 0 .3184.0214.6323.0628.9403.0302.225.049.3658.0589.4684q.0026.0274.0039.0454l-.0089.0099c-.0487.0535-.1187.1238-.2446.2498l-5.1105 5.1105-.0362.036c-.1346.1339-.3042.3026-.4306.5089a2 2 0 0 0-.2395.5781c-.0565.2354-.0559.4745-.0554.6644l.0001.051v1.7692c0 .2524 0 .4982.017.7063.0187.2286.0627.4984.201.7698.1918.3763.4977.6823.874.874.2715.1383.5412.1824.7698.2011.2081.017.4539.0169.7062.0169H7c.5523 0 1-.4477 1-1v-1h1c.5523 0 1-.4477 1-1v-1h1c.2653 0 .5196-.1054.7072-.2929l1.5791-1.5791c.1259-.1259.1963-.1959.2497-.2447l.0099-.0088q.018.0012.0454.0039c.1027.0099.2435.0286.4685.0589.308.0414.6219.0627.9402.0627 3.866 0 7-3.134 7-7s-3.134-7-7-7m.0002 5.9998a.994.994 0 0 1 .7071.293.994.994 0 0 1 .2929.707c0 .5523.4477 1 1 1s1-.4478 1-1a2.994 2.994 0 0 0-.8787-2.1213 2.994 2.994 0 0 0-2.1213-.8787c-.5523 0-1 .4477-1 1s.4477 1 1 1"
      clipRule="evenodd"
    />
  </svg>
);

export const Key02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 9c0-3.866 3.134-7 6.9999-7s7 3.134 7 7-3.134 7-7 7a7.1 7.1 0 0 1-.9402-.0627c-.225-.0303-.3658-.049-.4685-.0589a2 2 0 0 0-.0454-.0039l-.0099.0088c-.0534.0488-.1238.1188-.2497.2447l-5.1105 5.1105-.036.0361c-.134.1347-.3026.3042-.509.4307a2 2 0 0 1-.578.2394c-.2354.0565-.4745.0559-.6645.0554L6.3372 22H4.568c-.2523 0-.498.0001-.7062-.0169-.2286-.0187-.4983-.0628-.7697-.2011a2 2 0 0 1-.874-.874c-.1384-.2714-.1824-.5412-.2011-.7698-.017-.2081-.017-.4539-.017-.7063v-1.8202c-.0006-.1899-.0012-.429.0553-.6644.049-.204.1298-.3991.2395-.5781.1264-.2063.296-.375.4306-.5089l.0362-.036 5.1105-5.1105c.1259-.126.1959-.1963.2446-.2498l.0089-.0099a2 2 0 0 0-.004-.0454c-.0098-.1026-.0286-.2434-.0588-.4684A7.1 7.1 0 0 1 8 9m7 1.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Lock01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 8c0-3.3137 2.6863-6 6-6s6 2.6863 6 6v1.1503c.2826.062.5539.1521.816.2857a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.0021.3918 1.5642C21 13.2894 21 13.9537 21 14.7587v1.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C16.7106 22 16.0463 22 15.2413 22H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 17.7106 3 17.0463 3 16.2413v-1.4826c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.2621-.1336.5334-.2237.816-.2857zm10 0v1.0016H8V8c0-2.2091 1.7909-4 4-4s4 1.7909 4 4m-3 6.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Lock02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2C8.6863 2 6 4.6863 6 8v2.0271a10 10 0 0 0-.2518.0171c-.5621.0459-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.0021-.3918 1.5642C2 14.2894 2 14.9537 2 15.7587v.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 22 6.9537 22 7.7587 22h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 17.7106 22 17.0463 22 16.2413v-.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918A10 10 0 0 0 18 10.0271V8c0-3.3137-2.6863-6-6-6m4 8V8c0-2.2091-1.7909-4-4-4S8 5.7909 8 8v2z"
      clipRule="evenodd"
    />
  </svg>
);

export const Lock03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2C8.6863 2 6 4.6863 6 8v2.1503c-.2826.062-.5539.1521-.816.2857a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.0021-.3918 1.5642C3 14.2894 3 14.9537 3 15.7587v.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 22 7.9537 22 8.7587 22h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 17.7106 21 17.0463 21 16.2413v-.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.2621-.1336-.5334-.2237-.816-.2857V8c0-3.3137-2.6863-6-6-6m4 8.0016V8c0-2.2091-1.7909-4-4-4S8 5.7909 8 8v2.0016C8.2377 10 8.4904 10 8.7587 10h6.4826c.2683 0 .521 0 .7587.0016"
      clipRule="evenodd"
    />
  </svg>
);

export const Lock04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 8v1.7083C4.7553 11.1186 4 12.9712 4 15c0 4.4183 3.5817 8 8 8s8-3.5817 8-8c0-2.0289-.7553-3.8814-2-5.2917V8c0-3.3137-2.6863-6-6-6S6 4.6863 6 8m6-4C9.7909 4 8 5.7909 8 8v.0703C9.1767 7.3896 10.5429 7 12 7s2.8233.3896 4 1.0703V8c0-2.2091-1.7909-4-4-4m1 10c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const LockKeyholeCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m1.6276 11.7907c-.0019.0865.0334.1924.104.404l.9174 2.7523c.1185.3555.1778.5333.1422.6748a.5.5 0 0 1-.216.2998c-.123.0784-.3104.0784-.6851.0784h-3.7802c-.3747 0-.562 0-.685-.0784a.5.5 0 0 1-.2161-.2998c-.0356-.1415.0237-.3193.1422-.6748l.9174-2.7523c.0706-.2116.1059-.3175.104-.404-.0019-.0911-.0141-.1388-.056-.2196-.0399-.0769-.1464-.1761-.3596-.3744C9.3682 11.649 9 10.8675 9 10c0-1.6569 1.3431-3 3-3s3 1.3431 3 3c0 .8675-.3682 1.649-.9568 2.1967-.2132.1983-.3197.2975-.3596.3744-.0419.0808-.0541.1285-.056.2196"
      clipRule="evenodd"
    />
  </svg>
);

export const LockKeyholeSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2m-4.1069 11.1947.9174 2.7523c.1185.3555.1778.5333.1422.6748a.5.5 0 0 1-.216.2998c-.123.0784-.3104.0784-.6851.0784h-3.7802c-.3747 0-.562 0-.685-.0784a.5.5 0 0 1-.2161-.2998c-.0356-.1415.0237-.3193.1422-.6748l.9174-2.7523c.0706-.2116.1059-.3175.104-.404-.0019-.0911-.0141-.1388-.056-.2196-.0399-.0769-.1464-.1761-.3596-.3744C9.3682 11.649 9 10.8675 9 10c0-1.6569 1.3431-3 3-3s3 1.3431 3 3c0 .8675-.3682 1.649-.9568 2.1967-.2132.1983-.3197.2975-.3596.3744-.0419.0808-.0541.1285-.056.2196-.0019.0865.0334.1924.104.404"
      clipRule="evenodd"
    />
  </svg>
);

export const LockUnlocked01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 8c0-3.3137 2.6863-6 6-6 2.4619 0 4.5754 1.4826 5.5003 3.5996.2211.5061-.0099 1.0956-.516 1.3168-.5061.221-1.0956-.01-1.3167-.516C15.0494 4.9856 13.6387 4 12 4 9.7909 4 8 5.7909 8 8v1.0016C8.2377 9 8.4903 9 8.7586 9h6.4827c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.0021.3918 1.5642C21 13.2894 21 13.9537 21 14.7587v1.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C16.7106 22 16.0463 22 15.2413 22H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 17.7106 3 17.0463 3 16.2413v-1.4826c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.2621-.1336.5334-.2237.816-.2857zm7 6.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const LockUnlocked02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2C8.6863 2 6 4.6863 6 8v2.0271a10 10 0 0 0-.2518.0171c-.5621.0459-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.0021-.3918 1.5642C2 14.2894 2 14.9537 2 15.7587v.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 22 6.9537 22 7.7587 22h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 17.7106 22 17.0463 22 16.2413v-.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 10 17.0463 10 16.2413 10H8V8c0-2.2091 1.7909-4 4-4 1.934 0 3.5494 1.3736 3.92 3.199.1098.5412.6377.8909 1.1789.781s.891-.6377.7811-1.179C17.324 4.062 14.9039 2 12 2"
      clipRule="evenodd"
    />
  </svg>
);

export const LockUnlocked03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 8c0-3.3137 2.6863-6 6-6 2.9039 0 5.324 2.062 5.88 4.801.1099.5413-.2398 1.0691-.7811 1.179s-1.0691-.2398-1.1789-.781C15.5494 5.3735 13.934 4 12 4 9.7909 4 8 5.7909 8 8v2.0016C8.2377 10 8.4904 10 8.7587 10h6.4826c.805 0 1.4693 0 2.0105.0442.5621.0459 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.0021.3918 1.5642C21 14.2894 21 14.9537 21 15.7587v.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C16.7106 22 16.0463 22 15.2413 22H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 17.7106 3 17.0463 3 16.2413v-.4826c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.2621-.1336.5334-.2237.816-.2857z"
    />
  </svg>
);

export const LockUnlocked04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 8c0-2.2091 1.7909-4 4-4 1.308 0 2.4693.6268 3.2008 1.6006.3317.4416.9586.5307 1.4001.199.4416-.3317.5307-.9586.199-1.4002C15.707 2.9444 13.9636 2 12 2 8.6863 2 6 4.6863 6 8v1.7083C4.7553 11.1186 4 12.9712 4 15c0 4.4183 3.5817 8 8 8s8-3.5817 8-8-3.5817-8-8-8c-1.4571 0-2.8233.3896-4 1.0703zm5 6c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Passcode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.1615 6h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 9.1795 23 9.6343 23 10.1614v3.6772c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 18 19.3657 18 18.8385 18H5.1615c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 14.8205 1 14.3657 1 13.8386v-3.6772c0-.5271 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 6 4.6343 6 5.1615 6M7 10.75c-.6903 0-1.25.5596-1.25 1.25s.5597 1.25 1.25 1.25 1.25-.5596 1.25-1.25-.5596-1.25-1.25-1.25M10.75 12c0-.6904.5596-1.25 1.25-1.25s1.25.5596 1.25 1.25-.5596 1.25-1.25 1.25-1.25-.5596-1.25-1.25m5 0c0-.6904.5596-1.25 1.25-1.25s1.25.5596 1.25 1.25-.5596 1.25-1.25 1.25-1.25-.5596-1.25-1.25"
      clipRule="evenodd"
    />
  </svg>
);

export const PasscodeLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.1615 4h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 7.1795 23 7.6343 23 8.1614V11c0 .5523-.4477 1-1 1s-1-.4477-1-1V8.2c0-.5765-.0008-.9488-.0239-1.2322-.0222-.2716-.0599-.3723-.0851-.4218a1 1 0 0 0-.437-.437c-.0495-.0252-.1502-.0629-.4218-.085C19.7488 6.0007 19.3766 6 18.8 6H5.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4218C3.0007 7.2512 3 7.6234 3 8.2v3.6c0 .5766.0008.9488.024 1.2322.0221.2716.0598.3723.085.4218a1 1 0 0 0 .437.437c.0495.0252.1502.0629.4218.0851.2834.0231.6557.0239 1.2322.0239H11c.5523 0 1 .4477 1 1s-.4477 1-1 1H5.1615c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 12.8205 1 12.3657 1 11.8386V8.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 4 4.6343 4 5.1615 4"
    />
    <path
      fill="currentColor"
      d="M5.75 10c0-.6904.5597-1.25 1.25-1.25s1.25.5596 1.25 1.25-.5596 1.25-1.25 1.25-1.25-.5596-1.25-1.25M12 8.75c-.6904 0-1.25.5596-1.25 1.25s.5596 1.25 1.25 1.25 1.25-.5596 1.25-1.25-.5596-1.25-1.25-1.25M17 8.75c-.6904 0-1.25.5596-1.25 1.25s.5596 1.25 1.25 1.25 1.25-.5596 1.25-1.25-.5596-1.25-1.25-1.25"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.75 15.25c0-1.5188 1.2312-2.75 2.75-2.75s2.75 1.2312 2.75 2.75v.778c.2025.024.4296.0736.658.19.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-3.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.4539-.017-.7063v-.8638c0-.2524-.0001-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2284-.1164.4555-.166.658-.19zm3.5 0V16h-1.5v-.75a.75.75 0 0 1 1.5 0"
      clipRule="evenodd"
    />
  </svg>
);

export const Scan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2H8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.2c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 6.3611 4 6.9434 4 7.8V8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.2413c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2M3 15c.5523 0 1 .4477 1 1v.2c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1805C6.3611 19.9992 6.9434 20 7.8 20H8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.2413c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V16c0-.5523.4477-1 1-1M18.089 4.0376C17.6389 4.0008 17.0566 4 16.2 4H16c-.5523 0-1-.4477-1-1s.4477-1 1-1h.24130000000000001c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587V8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.2c0-.8566-.0008-1.4389-.0375-1.889-.0359-.4384-.1008-.6626-.1805-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804M21 15c.5523 0 1 .4477 1 1v.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H16c-.5523 0-1-.4477-1-1s.4477-1 1-1h.2c.8566 0 1.4389-.0008 1.889-.0375.4384-.0359.6626-.1008.819-.1805a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1805-.819.0367-.4501.0375-1.0324.0375-1.889V16c0-.5523.4477-1 1-1M2 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M6.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.5c-.5523 0-1-.4477-1-1M15.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M11 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M20 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Shield03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 2.4616c0-.3879 0-.5818-.0815-.7064a.5.5 0 0 0-.3093-.2145c-.1453-.0325-.3269.0356-.69.1718L5.5946 3.3341c-.6178.2306-1.1604.4332-1.5782.8014a3 3 0 0 0-.8203 1.1838c-.1981.5205-.1973 1.0996-.1963 1.759L3 12.0002c0 2.8266 1.5373 5.1832 3.199 6.9144 1.079 1.1241 2.3165 2.1408 3.6404 2.9907.3536.227.5305.3406.6964.3286.1398-.01.2805-.0869.3645-.1991.0997-.1332.0997-.3522.0997-.7902zM13 21.2447c0 .4379 0 .6569.0997.7901.084.1122.2247.1891.3645.1992.1659.0119.3428-.1016.6964-.3287 1.3239-.8499 2.5613-1.8666 3.6404-2.9907C19.4627 17.1834 21 14.8268 21 12.0002l.0002-4.9219c.0009-.6594.0017-1.2385-.1963-1.759a3 3 0 0 0-.8204-1.1838c-.4178-.3682-.9603-.5708-1.5781-.8014l-4.3245-1.6216c-.3632-.1362-.5448-.2043-.6901-.1718a.5.5 0 0 0-.3093.2144C13 1.8798 13 2.0737 13 2.4616z"
    />
  </svg>
);

export const ShieldDollar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.714 1.0887a2 2 0 0 1 .5721 0c.2186.0316.422.1084.5836.1695l.0432.0163 5.4925 2.0595c.6178.2306 1.1603.4332 1.5781.8014.3655.3221.6471.7284.8204 1.1838.198.5205.1972 1.0996.1963 1.759L21 12.0001c0 2.8266-1.5373 5.1832-3.199 6.9144-1.6729 1.7428-3.587 2.9738-4.5991 3.5642l-.041.0241c-.1847.1084-.4244.2492-.7415.3172-.2595.0556-.5793.0556-.8387 0-.3172-.068-.5569-.2088-.7416-.3172l-.041-.0241c-1.012-.5904-2.9261-1.8214-4.599-3.5642C4.5373 17.1833 3 14.8267 3 12.0001l-.0002-4.9218c-.001-.6595-.0018-1.2386.1963-1.7591a3 3 0 0 1 .8203-1.1838c.4178-.3682.9604-.5708 1.5782-.8014l5.4924-2.0595.0433-.0163c.1615-.061.365-.138.5836-.1695M13 6c0-.5523-.4477-1-1-1s-1 .4477-1 1v.5c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2.1333a.867.867 0 0 1-.7684-.4649c-.2568-.489-.8613-.6772-1.3503-.4204-.489.2567-.6772.8613-.4204 1.3502.4781.9105 1.4349 1.5351 2.5391 1.5351H11v.5c0 .5523.4477 1 1 1s1-.4477 1-1v-.5c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3h-2c-.5523 0-1-.4477-1-1s.4477-1 1-1h2.1333c.332 0 .6221.1864.7684.465.2568.4889.8613.6771 1.3503.4203.4889-.2567.6772-.8613.4204-1.3502C15.1942 7.1246 14.2375 6.5 13.1333 6.5H13z"
      clipRule="evenodd"
    />
  </svg>
);

export const ShieldOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l.9977.9977A2.117 2.117 0 0 0 3 5.7762V12c0 2.8267 1.5373 5.1832 3.199 6.9144 1.673 1.7428 3.587 2.9738 4.5991 3.5643l.041.024c.1847.1084.4244.2492.7416.3172.2595.0557.5794.0557.8388 0 .3172-.0681.5576-.2093.7428-.318l.0413-.0242c.9782-.5708 2.8104-1.7465 4.449-3.4108l2.6403 2.6403c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20.0529 15.8102c.5754-1.1441.9471-2.4204.9471-3.8103l.0002-4.922c.0009-.6593.0017-1.2385-.1963-1.759a3 3 0 0 0-.8204-1.1837c-.4178-.3683-.9603-.5708-1.5781-.8015l-5.4925-2.0595-.0432-.0163c-.1616-.061-.365-.1379-.5836-.1695a2 2 0 0 0-.5721 0c-.2186.0316-.4221.1085-.5836.1695l-.0433.0163-4.0512 1.5191z"
    />
  </svg>
);

export const ShieldPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.714 1.0884a2 2 0 0 1 .5721 0c.2186.0316.422.1085.5836.1695l.0432.0163 5.4925 2.0595c.6178.2307 1.1603.4332 1.5781.8015.3655.322.6471.7284.8204 1.1837.198.5205.1972 1.0996.1963 1.759L21 12c0 2.8266-1.5373 5.1832-3.199 6.9144-1.6729 1.7428-3.587 2.9737-4.5991 3.5642l-.041.024c-.1847.1085-.4244.2492-.7415.3173-.2595.0556-.5793.0556-.8387 0-.3172-.068-.5569-.2088-.7416-.3173l-.041-.024c-1.012-.5905-2.9261-1.8214-4.599-3.5642C4.5373 17.1831 3 14.8265 3 11.9999L2.9998 7.078c-.001-.6594-.0018-1.2386.1963-1.759a3 3 0 0 1 .8203-1.1838c.4178-.3683.9604-.5708 1.5782-.8015l5.4924-2.0595.0433-.0163c.1615-.061.365-.1379.5836-.1695M12 7.5c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ShieldTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.714 1.0884a2 2 0 0 1 .5721 0c.2186.0316.422.1085.5836.1695l.0432.0163 5.4925 2.0595c.6178.2307 1.1603.4332 1.5781.8015.3655.322.6471.7284.8204 1.1837.198.5205.1972 1.0996.1963 1.759L21 12c0 2.8266-1.5373 5.1832-3.199 6.9144-1.6729 1.7428-3.587 2.9737-4.5991 3.5642l-.041.024c-.1847.1085-.4244.2492-.7415.3173-.2595.0556-.5793.0556-.8387 0-.3172-.068-.5569-.2088-.7416-.3173l-.041-.024c-1.012-.5905-2.9261-1.8214-4.599-3.5642C4.5373 17.1831 3 14.8265 3 11.9999L2.9998 7.078c-.001-.6594-.0018-1.2386.1963-1.759a3 3 0 0 1 .8203-1.1838c.4178-.3683.9604-.5708 1.5782-.8015l5.4924-2.0595.0433-.0163c.1615-.061.365-.1379.5836-.1695m4.4931 8.6187c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 12.0858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const ShieldZap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.714 1.0884a2 2 0 0 1 .5721 0c.2186.0316.422.1085.5836.1695l.0432.0163 5.4925 2.0595c.6178.2307 1.1603.4332 1.5781.8015.3655.322.6471.7284.8204 1.1837.198.5205.1972 1.0996.1963 1.759L21 12c0 2.8266-1.5373 5.1832-3.199 6.9144-1.6729 1.7428-3.587 2.9737-4.5991 3.5642l-.041.024c-.1847.1085-.4244.2492-.7415.3173-.2595.0556-.5793.0556-.8387 0-.3172-.068-.5569-.2088-.7416-.3173l-.041-.024c-1.012-.5905-2.9261-1.8214-4.599-3.5642C4.5373 17.1831 3 14.8265 3 11.9999L2.9998 7.078c-.001-.6594-.0018-1.2386.1963-1.759a3 3 0 0 1 .8203-1.1838c.4178-.3683.9604-.5708 1.5782-.8015l5.4924-2.0595.0433-.0163c.1615-.061.365-.1379.5836-.1695m1.9931 7.1187c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3a1 1 0 0 0 .2599 1.6015l2.759 1.3796-2.0189 2.0189c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3a1 1 0 0 0-.2599-1.6015l-2.759-1.3796z"
      clipRule="evenodd"
    />
  </svg>
);

export const Shield01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.2861 1.0884a2 2 0 0 0-.5721 0c-.2186.0316-.4221.1085-.5836.1695l-.0433.0163-5.4924 2.0595c-.6178.2307-1.1604.4333-1.5782.8015a3 3 0 0 0-.8203 1.1837c-.1981.5205-.1973 1.0997-.1963 1.7591L3 11.9999c0 2.8266 1.5373 5.1832 3.199 6.9144 1.673 1.7428 3.587 2.9737 4.5991 3.5642l.041.024c.1847.1085.4244.2492.7416.3173.2594.0556.5792.0556.8387 0 .3171-.0681.5568-.2088.7415-.3173l.041-.024c1.0121-.5905 2.9262-1.8214 4.5991-3.5642C19.4627 17.1831 21 14.8265 21 11.9999l.0002-4.922c.0009-.6593.0017-1.2385-.1963-1.759a3 3 0 0 0-.8204-1.1837c-.4178-.3683-.9603-.5708-1.5781-.8015l-5.4925-2.0595-.0432-.0163c-.1616-.061-.365-.1379-.5836-.1695"
    />
  </svg>
);

export const Shield02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.5207 1.4727c-.1453-.0392-.319-.0757-.5207-.0757s-.3754.0365-.5207.0757c-.2708.073-.4982.2182-.6625.3317-.17.1175-.3732.2747-.6027.4523l-.0204.0157c-.9127.7061-1.9002 1.1912-3.215 1.4646l-.0291.006c-.6408.1334-1.1614.2416-1.5626.3477-.3897.103-.7913.2332-1.1173.4634-.2195.155-.4242.3273-.6058.5505s-.3085.4586-.4156.7051c-.1505.3466-.202.7104-.2255 1.0693C3 7.228 3 7.6583 3 8.1675v3.8326c0 2.8266 1.5373 5.1832 3.199 6.9144 1.673 1.7428 3.587 2.9737 4.5991 3.5642l.041.024c.1847.1085.4244.2492.7415.3173.2595.0556.5793.0556.8388 0 .3171-.0681.5568-.2088.7415-.3173l.041-.024c1.0121-.5905 2.9261-1.8214 4.599-3.5642C19.4627 17.1833 21 14.8267 21 12.0001V8.1676c0-.5092 0-.9396-.0228-1.2886-.0235-.3589-.075-.7227-.2255-1.0693-.1071-.2465-.2341-.482-.4156-.7051-.1816-.2232-.3863-.3955-.6058-.5505-.326-.2302-.7276-.3604-1.1173-.4634-.4012-.106-.9218-.2144-1.5626-.3476l-.0291-.006c-1.3148-.2735-2.3023-.7586-3.215-1.4647l-.0204-.0158c-.2295-.1775-.4327-.3347-.6027-.4522-.1642-.1135-.3917-.2587-.6625-.3317"
    />
  </svg>
);

export const Atom01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 10.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.1192 2.5753c-.998.411-2.0512.9794-3.1193 1.6853-1.068-.7059-2.1212-1.2743-3.1192-1.6853-1.1601-.4777-2.2933-.7622-3.3155-.7699-1.0272-.0077-2.0231.2678-2.7576 1.0022-.7345.7345-1.01 1.7305-1.0023 2.7577.0077 1.0222.2923 2.1554.77 3.3155.411.998.9794 2.0512 1.6853 3.1192-.706 1.068-1.2744 2.1212-1.6853 3.1192-.4777 1.1601-.7623 2.2933-.77 3.3155-.0077 1.0272.2678 2.0232 1.0023 2.7576.7345.7345 1.7304 1.01 2.7576 1.0023 1.0222-.0077 2.1554-.2923 3.3155-.77.998-.4109 2.0512-.9793 3.1192-1.6852 1.0681.7059 2.1213 1.2744 3.1193 1.6853 1.1601.4777 2.2933.7623 3.3155.77 1.0272.0077 2.0232-.2678 2.7577-1.0023s1.0099-1.7304 1.0022-2.7576c-.0077-1.0222-.2923-2.1554-.77-3.3155-.4109-.998-.9794-2.0513-1.6853-3.1193.7059-1.068 1.2744-2.1213 1.6853-3.1193.4777-1.1601.7623-2.2933.77-3.3155.0077-1.0272-.2678-2.0231-1.0023-2.7576s-1.7304-1.01-2.7576-1.0023c-1.0222.0077-2.1554.2923-3.3155.77m.7615 1.8493c-.677.2788-1.3969.6475-2.1402 1.0997.845.669 1.6856 1.4166 2.5021 2.233.8165.8166 1.5641 1.6572 2.233 2.5021.4522-.7433.8209-1.4632 1.0997-2.1402.418-1.0152.6142-1.8865.6193-2.569.0051-.6776-.1746-1.0866-.4165-1.3284s-.6508-.4216-1.3284-.4165c-.6825.0051-1.5538.2013-2.569.6193M4.4247 8.1193c.2787.677.6474 1.3968 1.0996 2.1401.669-.845 1.4165-1.6856 2.233-2.502.8165-.8165 1.657-1.5641 2.5021-2.233-.7433-.4523-1.4632-.821-2.1402-1.0997-1.0152-.418-1.8865-.6142-2.569-.6193-.6776-.0051-1.0866.1746-1.3284.4165s-.4216.6508-.4165 1.3284c.0051.6824.2013 1.5538.6193 2.569m4.7468 1.0522c-.9317.9318-1.757 1.8866-2.464 2.8285.707.9419 1.5323 1.8967 2.464 2.8285s1.8865 1.757 2.8284 2.464c.9419-.707 1.8967-1.5323 2.8285-2.4641s1.757-1.8865 2.4641-2.8284c-.7071-.9419-1.5323-1.8966-2.4641-2.8284s-1.8866-1.7571-2.8285-2.4641c-.9419.707-1.8966 1.5323-2.8284 2.464m-4.7469 6.7092c.2788-.677.6475-1.3969 1.0997-2.1402.669.8451 1.4166 1.6857 2.233 2.5022.8165.8164 1.657 1.564 2.5021 2.233-.7433.4521-1.4632.8208-2.1402 1.0996-1.0152.418-1.8865.6142-2.569.6193-.6776.0051-1.0866-.1746-1.3284-.4165s-.4216-.6508-.4165-1.3284c.0051-.6825.2013-1.5538.6193-2.569m11.4561 3.6947c-.677-.2788-1.3969-.6475-2.1402-1.0997.845-.669 1.6856-1.4166 2.5021-2.2331s1.5641-1.6571 2.233-2.5021c.4522.7434.8209 1.4633 1.0997 2.1403.418 1.0152.6142 1.8865.6194 2.569.005.6775-.1747 1.0866-.4166 1.3284-.2418.2418-.6508.4216-1.3284.4165-.6824-.0051-1.5538-.2013-2.569-.6193"
      clipRule="evenodd"
    />
  </svg>
);

export const Atom02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 10c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.5614 9.803c.2135.7258.5095 1.47.882 2.2178-.7497 1.5049-1.2012 3.0192-1.274 4.4113-.0804 1.5408.3048 3.0126 1.3661 4.0739 1.5517 1.5517 3.944 1.6575 6.2675.9741.7258-.2135 1.47-.5094 2.2178-.882.7477.3726 1.492.6685 2.2178.882 2.3234.6834 4.7158.5776 6.2674-.9741s1.6575-3.944.9741-6.2674c-.2135-.7258-.5094-1.4701-.882-2.2178.7785-1.5626 1.2374-3.1397 1.281-4.5806.0446-1.4782-.351-2.8827-1.373-3.9047-1.5517-1.5517-3.944-1.6575-6.2675-.9741-.7258.2135-1.47.5094-2.2178.882-.7478-.3726-1.4921-.6685-2.2179-.882-2.3234-.6834-4.7158-.5776-6.2674.974S1.878 7.4795 2.5614 9.803M9.2386 4.48c-2.0273-.5962-3.4974-.322-4.289.4696-.7914.7915-1.0657 2.2616-.4695 4.2889.5841 1.9859 1.9522 4.2648 4.0051 6.3177 1.1385 1.1385 2.3466 2.0664 3.5356 2.7667 1.189-.7003 2.397-1.6282 3.5355-2.7667.2827-.2827.5527-.57.8099-.8608.3659-.4136.9978-.4524 1.4115-.0865s.4525.9979.0866 1.4116a21.3 21.3 0 0 1-.8938.9499c-.9035.9036-1.8585 1.6981-2.8315 2.3703q.3367.1244.6639.2206c2.0272.5962 3.4974.3219 4.2889-.4696s1.0658-2.2617.4696-4.2889c-.5841-1.9859-1.9522-4.2648-4.0051-6.3177-1.1385-1.1385-2.3465-2.0664-3.5355-2.7667-1.189.7003-2.397 1.6282-3.5355 2.7667-.2955.2955-.5772.5961-.8448.9003-.3647.4147-.9966.4553-1.4113.0905s-.4553-.9966-.0905-1.4113c.2958-.3364.6068-.6681.9323-.9937.9036-.9035 1.8586-1.698 2.8316-2.3703a10.3 10.3 0 0 0-.664-.2206M7.071 16.9705c.9036.9036 1.8586 1.6981 2.8316 2.3703-.2244.0829-.446.1565-.664.2206-2.0272.5962-3.4974.3219-4.2889-.4696-.545-.5451-.8436-1.3937-.783-2.5554.0378-.722.2149-1.5334.534-2.3974.6722.9729 1.4667 1.9279 2.3703 2.8315M19.88 7.3798c-.0227.7516-.2008 1.6069-.5392 2.5228-.6722-.973-1.4667-1.928-2.3703-2.8316s-1.8586-1.698-2.8315-2.3703q.3367-.1244.664-.2206c2.0272-.5962 3.4974-.322 4.2889.4696.5256.5256.8213 1.3319.7881 2.4301"
      clipRule="evenodd"
    />
  </svg>
);

export const Award01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C7.5817 1 4 4.5817 4 9c0 2.4797 1.1282 4.6959 2.8993 6.1633l-.8906 6.705a1.0002 1.0002 0 0 0 1.5058.9892L12 20.1661l4.4855 2.6914a1.0001 1.0001 0 0 0 1.5058-.9891l-.8897-6.7059C18.8722 13.6951 20 11.4793 20 9c0-4.4183-3.5817-8-8-8M8.7635 16.3183C9.753 16.7565 10.848 17 12 17c1.1523 0 2.2476-.2436 3.2374-.6821l.4985 3.7574-2.8098-1.6859-.029-.0177c-.1054-.0646-.3238-.1985-.5753-.2537a1.5 1.5 0 0 0-.6435 0c-.2516.0552-.47.1891-.5753.2537l-.0291.0177-2.8094 1.6857z"
      clipRule="evenodd"
    />
  </svg>
);

export const Award02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C7.3056 1 3.5 4.8056 3.5 9.5c0 2.3525.9557 4.4818 2.5 6.0208v6.4793a1 1 0 0 0 1.3714.9284L12 21.0771l4.6286 1.8514A.9998.9998 0 0 0 18 22.0001v-6.4793c1.5443-1.539 2.5-3.6683 2.5-6.0208C20.5 4.8056 16.6944 1 12 1M8 17.0019c1.1921.637 2.5539.9981 4 .9981s2.8079-.3611 4-.9981v3.5211l-3.3315-1.3326-.0215-.0087c-.0788-.0321-.2415-.0985-.4196-.1258a1.5 1.5 0 0 0-.4548 0c-.1781.0273-.3408.0937-.4196.1258l-.0215.0087L8 20.523z"
      clipRule="evenodd"
    />
  </svg>
);

export const Award03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.3345 3.8313a1 1 0 0 1 .0155.0355.524.524 0 0 0 .2832.2838l1.3084.542a2.5243 2.5243 0 0 1 1.3662 3.2984l-.5417 1.308a.522.522 0 0 0-.0002.4004l.0009.0021.5405 1.3069a2.5238 2.5238 0 0 1-1.3664 3.2993l-1.3079.5418a.526.526 0 0 0-.2846.2838l-.1898.4584.8327 6.2768a1 1 0 0 1-1.5058.989L12 20.1662l-4.4855 2.6913a1 1 0 0 1-1.5058-.9891l.8333-6.2739-.1911-.4614a.526.526 0 0 0-.2833-.2843l-1.3086-.5421a2.5245 2.5245 0 0 1-1.3668-3.2968l.5417-1.3079a.525.525 0 0 0-.0003-.4013l-.5411-1.3101a2.5246 2.5246 0 0 1 1.3664-3.2994l1.3079-.5418a.526.526 0 0 0 .2842-.283l.5418-1.308a2.5245 2.5245 0 0 1 3.2983-1.3662l1.3072.5414a.525.525 0 0 0 .4012-.0003l1.3102-.5404.0009-.0003a2.5245 2.5245 0 0 1 3.297 1.3664zM8.5653 17.8104l-.3008 2.2648 2.8094-1.6857.0291-.0177c.1053-.0646.3237-.1985.5753-.2538a1.5 1.5 0 0 1 .6435 0c.2515.0553.4699.1892.5753.2538l.029.0177 2.8098 1.6859-.3006-2.2656a2.525 2.525 0 0 1-1.9271-.0021l-1.3071-.5415a.525.525 0 0 0-.4013.0003l-1.3099.5419a2.525 2.525 0 0 1-1.9246.002"
      clipRule="evenodd"
    />
  </svg>
);

export const Award04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.1615 1h9.6771c.5271 0 .9819 0 1.3565.0306.3953.0323.7886.1036 1.1669.2964a3 3 0 0 1 1.3111 1.311c.1928.3784.2641.7716.2964 1.167.0306.3745.0306.8293.0306 1.3564v.7866c.0003.3466.0005.6524-.0613.9536a3 3 0 0 1-.2672.7617c-.1399.2738-.3311.5124-.5478.7829l-3.647 4.5587c2.1062 2.356 2.0282 5.9754-.2342 8.2377-2.3431 2.3432-6.1421 2.3432-8.4852 0-2.2624-2.2623-2.3404-5.8818-.234-8.2378l-3.647-4.5586c-.2168-.2705-.408-.5091-.5479-.7829a3 3 0 0 1-.2672-.7617c-.0618-.3012-.0615-.607-.0613-.9536v-.7865c0-.5272 0-.982.0306-1.3565.0323-.3954.1037-.7886.2964-1.167a3 3 0 0 1 1.3111-1.311c.3784-.1928.7716-.2641 1.167-.2964C6.1796 1 6.6344 1 7.1615 1M12 10.3712l4.7229-6.0722c.3223-.4144.4834-.6215.4819-.7954a.5.5 0 0 0-.1897-.3878c-.1363-.108-.3988-.108-.9237-.108H7.9087c-.525 0-.7874 0-.9237.108a.5.5 0 0 0-.1897.3878c-.0015.1739.1596.381.4819.7954z"
      clipRule="evenodd"
    />
  </svg>
);

export const Award05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m2.437 4.8316 3.4964 6.2567c-2.1386 2.9333-1.8841 7.0676.7633 9.715 2.929 2.9289 7.6777 2.9289 10.6066 0 2.6475-2.6475 2.9019-6.7817.7633-9.715l3.4964-6.2567c.2012-.3599.3844-.6877.508-.966.1261-.2837.261-.6633.2114-1.0943a2 2 0 0 0-.8181-1.3944c-.3521-.2535-.7492-.321-1.0584-.3493-.3032-.0278-.6788-.0278-1.091-.0277L16.968.9997c-.2569-.001-.58-.002-.8858.0964a2 2 0 0 0-.7161.4093c-.2401.2135-.4031.4925-.5327.7143L12 7.0296l-2.8334-4.81c-.1296-.2217-.2926-.5007-.5327-.7142a2 2 0 0 0-.716-.4093c-.306-.0985-.629-.0973-.886-.0964L4.6852.9999c-.4123 0-.7878-.0001-1.091.0277-.3092.0284-.7063.0958-1.0584.3493a2 2 0 0 0-.8181 1.3944c-.0496.431.0853.8106.2113 1.0943.1237.2783.307.6061.508.966m2.6647-1.8299c-.447-.0006-.6705-.0008-.8013.093a.5.5 0 0 0-.2053.3475c-.019.1599.0892.3555.3055.7466l2.9848 5.398a7.454 7.454 0 0 1 2.9717-1.4056L7.534 3.3973c-.0845-.1432-.1268-.2148-.1853-.2668a.5.5 0 0 0-.1787-.1022c-.0746-.024-.1577-.0242-.324-.0244zm11.5129 6.585a7.454 7.454 0 0 0-2.9718-1.4055l2.8232-4.7839c.0845-.1432.1268-.2148.1853-.2668a.5.5 0 0 1 .1787-.1022c.0745-.024.1577-.0242.324-.0244l1.7443-.0022c.447-.0006.6704-.0008.8013.093a.5.5 0 0 1 .2053.3475c.0189.1599-.0892.3555-.3055.7466zm-4.1426 2.5316a1 1 0 0 1 .5281.8817v4h.2499c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2.5c-.5523 0-1-.4477-1-1s.4477-1 1-1h.2501v-2.1339c-.453.2621-1.0377.1301-1.332-.3114-.3064-.4595-.1822-1.0804.2773-1.3867l1.5-1a1 1 0 0 1 1.0266-.0497"
      clipRule="evenodd"
    />
  </svg>
);

export const Backpack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.675 2h8.65c.7663 0 1.3987 0 1.9147.0402.5356.0417 1.029.1311 1.4958.356a4 4 0 0 1 1.8684 1.8683c.2248.4668.3142.9601.3559 1.4958C22 6.2763 22 6.9087 22 7.675v.08c0 1.0317 0 1.8638-.0525 2.5387-.0541.6947-.1683 1.306-.4427 1.8757A5 5 0 0 1 21 13v4.8386c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C17.8205 22 17.3657 22 16.8386 22H7.1614c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C3 18.8205 3 18.3657 3 17.8385V13a5 5 0 0 1-.5048-.8306c-.2744-.5697-.3886-1.181-.4427-1.8756C2 9.6188 2 8.7867 2 7.755v-.08c0-.7663 0-1.3987.0402-1.9147.0417-.5357.1311-1.029.356-1.4958A4 4 0 0 1 4.2644 2.396c.4668-.2248.9601-.3142 1.4958-.356C6.2763 2 6.9087 2 7.675 2m9.6188 12.9475c.6262-.0488 1.1848-.1464 1.7062-.3662V17.8c0 .5766-.0008.9488-.0239 1.2322-.0222.2716-.0599.3723-.0851.4218a1 1 0 0 1-.437.437c-.0495.0252-.1502.0629-.4218.0851-.2834.0231-.6556.0239-1.2322.0239H7.2c-.5766 0-.9488-.0008-1.2322-.0239-.2716-.0222-.3723-.0599-.4218-.0851a1 1 0 0 1-.437-.437c-.0252-.0495-.0629-.1502-.085-.4218C5.0007 18.7488 5 18.3766 5 17.8v-3.2187c.5214.2198 1.08.3174 1.7063.3662C7.3812 15 8.2133 15 9.245 15h5.51c1.0317 0 1.8638 0 2.5388-.0525M9 9c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Beaker01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 2c0-.5523.4477-1 1-1h7c.5523 0 1 .4477 1 1s-.4477 1-1 1H15v3.5448c3.2126 1.2121 5.5 4.3153 5.5 7.9552 0 4.6944-3.8056 8.5-8.5 8.5s-8.5-3.8056-8.5-8.5c0-3.6399 2.2874-6.743 5.5-7.9552V3h-.5c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Beaker02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.2769 1h7.4463c.1191 0 .2613 0 .3866.0102.1453.0118.3533.0423.5712.1533a1.5 1.5 0 0 1 .6555.6555c.1111.218.1415.426.1534.5712.0102.1253.0102.2676.0101.3867V5.223c.0001.1192.0001.2614-.0101.3867-.0119.1453-.0423.3533-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.2179.111-.4259.1415-.5712.1534a3 3 0 0 1-.1099.0065v3.5048c0 .605.008.7241.0343.8219.0304.113.0805.2199.1479.3157.0583.0828.1446.1651.6094.5525l3.7696 3.1412c.3518.2926.6618.5504.8921.8777.2022.2873.3524.6079.4437.9471.1039.3865.1035.7897.103 1.2473l.0002 1.1794c.0003.3806.0006.7085-.0577 1.0014a3 3 0 0 1-2.357 2.357c-.2929.0583-.6207.058-1.0014.0577H5.4162c-.3807.0003-.7085.0006-1.0014-.0577a3.0004 3.0004 0 0 1-2.357-2.357c-.0583-.2929-.058-.6207-.0578-1.0014l-.0002-1.1794c-.0005-.4576-.0009-.8608.1031-1.2473a3 3 0 0 1 .4436-.9471c.2304-.3273.5404-.5851.8922-.8777l3.7696-3.1412c.4648-.3874.5511-.4697.6094-.5525a1 1 0 0 0 .1479-.3157c.0263-.0978.0343-.2169.0343-.8219V6.9963a3 3 0 0 1-.1097-.0064c-.1452-.0119-.3532-.0423-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.111-.218-.1415-.426-.1533-.5712-.0103-.1253-.0102-.2675-.0102-.3866V2.7769c0-.1191 0-.2614.0102-.3867.0118-.1452.0423-.3532.1533-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1533C8.0155.9999 8.1578 1 8.2769 1m9.961 15.0001H5.7619l2.7992-2.3326c.3518-.2926.6618-.5504.8922-.8777a3 3 0 0 0 .4436-.9471c.1039-.3865.1035-.7897.103-1.2473V7h4l-.0001 3.5954c-.0005.4576-.0009.8608.1031 1.2473.0913.3392.2414.6598.4436.9471.2303.3273.5404.5851.8922.8777z"
      clipRule="evenodd"
    />
  </svg>
);

export const BookClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.0443 19.2518c.0459.5621.1445 1.0788.3917 1.5642a4 4 0 0 0 1.7481 1.748c.4853.2473 1.002.3459 1.5641.3918C7.2894 23 7.9538 23 8.7587 23h8.0799c.5272 0 .9819 0 1.3565-.0306.3953-.0323.7886-.1036 1.1669-.2964a3 3 0 0 0 1.3111-1.311c.1928-.3784.2641-.7716.2964-1.167.0274-.3357.0306-.7357.0306-1.195V5.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.3111-1.311c-.3783-.1928-.7716-.2641-1.1669-.2964C17.8205 1 17.3658 1 16.8387 1h-8.08c-.8049 0-1.4693 0-2.0105.0442-.562.046-1.0788.1445-1.5641.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.346 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .671-.0105 1.3422.0442 2.0105m15.9318.7804c-.0222.2716-.0598.3723-.085.4218a1 1 0 0 1-.437.437c-.0495.0252-.1502.0629-.4219.0851-.2833.0231-.6556.0239-1.2321.0239h-8c-.8566 0-1.439-.0008-1.889-.0375-.4384-.0359-.6626-.1008-.819-.1805a2 2 0 0 1-.874-.874c-.1792-.3517-.2678-.6562-.2012-1.1683C5.1445 17.7581 5.9837 17 7 17h12c0 1.005.058 2.0295-.024 3.0322"
      clipRule="evenodd"
    />
  </svg>
);

export const BookOpen01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.2211 1.9977c.206.0011.4118.0022.6174.0022.5272 0 .982 0 1.3565.0305.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3785.2641.7717.2964 1.167C23 5.1794 23 5.6341 23 6.1613v8.6771c0 .5271 0 .9819-.0306 1.3565-.0323.3953-.1036.7886-.2964 1.1669a3 3 0 0 1-1.311 1.3111c-.3784.1928-.7716.2641-1.167.2964-.669.0547-1.3464.0458-2.0208.0371a57 57 0 0 0-.749-.0065c-1.3146 0-1.7635.0101-2.1562.1294a3 3 0 0 0-1.0331.5529c-.4599.378-.7972.9151-1.1212 1.4311-.0937.1492-.1863.2967-.2805.438a1 1 0 0 1-1.6662.0033c-.0949-.1424-.1882-.291-.2827-.4413-.324-.516-.6613-1.0531-1.1212-1.4311a3 3 0 0 0-1.033-.5529c-.3928-.1193-.8417-.1294-2.1563-.1294-.2489 0-.4987.0032-.749.0065-.6744.0087-1.3518.0176-2.0208-.0371-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.3111c-.1928-.3783-.2641-.7716-.2964-1.1669C1 15.8203 1 15.3656 1 14.8384v-8.677c0-.5272 0-.982.0306-1.3566.0323-.3953.1036-.7885.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.264 1.167-.2964.3745-.0306.8293-.0306 1.3565-.0305.2056 0 .4114-.0011.6174-.0022.8438-.0043 1.6894-.0087 2.5297.06.7289.0595 1.369.1853 1.9614.4871A5 5 0 0 1 12 3.9998a5 5 0 0 1 1.73-1.455c.5923-.3018 1.2325-.4276 1.9614-.4871.8403-.0687 1.6859-.0643 2.5297-.06"
    />
  </svg>
);

export const BookOpen02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.6428 3h-.4813c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 6.1795 1 6.6343 1 7.1614v9.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 21 4.6343 21 5.1614 21h13.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 17.8205 23 17.3657 23 16.8386V7.1615c0-.5272 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 3 19.3657 3 18.8386 3h-.4814c-1.0838 0-1.958 0-2.6658.0578-.7289.0596-1.3691.1854-1.9614.4872A5 5 0 0 0 12 5a5 5 0 0 0-1.73-1.455c-.5923-.3018-1.2325-.4276-1.9614-.4872C7.6008 3 6.7266 3 5.6428 3"
    />
  </svg>
);

export const Briefcase01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.8625 2h.2752c.7954-.0004 1.386-.0007 1.8977.1364a4 4 0 0 1 2.8284 2.8284c.0824.3075.1151.6434.1281 1.0352h1.8466c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 9.1795 23 9.6343 23 10.1614v7.6772c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 22 19.3658 22 18.8386 22H5.1615c-.5271 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 18.8205 1 18.3657 1 17.8386v-7.6771c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 6 4.6343 6 5.1615 6h1.8468c.013-.3918.0457-.7277.128-1.0352a4 4 0 0 1 2.8285-2.8284c.5117-.1371 1.1023-.1368 1.8977-.1364m3.1277 4H9.01c.0091-.2575.0264-.3988.0583-.5175a2 2 0 0 1 1.4142-1.4143c.2222-.0595.5232-.0681 1.5176-.0681s1.2954.0086 1.5176.0681a2 2 0 0 1 1.4142 1.4143c.0319.1187.0491.26.0583.5175"
      clipRule="evenodd"
    />
  </svg>
);

export const Briefcase02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.8625 2h.2752c.7954-.0004 1.386-.0007 1.8977.1364a4 4 0 0 1 2.8284 2.8284c.0824.3075.1151.6434.1281 1.0352h1.8466c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 9.1795 23 9.6343 23 10.1614v7.6772c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 22 19.3658 22 18.8387 22H5.1615c-.5271 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 18.8205 1 18.3657 1 17.8386v-7.6771c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 6 4.6343 6 5.1615 6h1.8468c.013-.3918.0457-.7277.128-1.0352a4 4 0 0 1 2.8285-2.8284c.5117-.1371 1.1023-.1368 1.8977-.1364M9.01 6c.0091-.2575.0264-.3988.0583-.5175a2 2 0 0 1 1.4142-1.4143c.2222-.0595.5232-.0681 1.5176-.0681s1.2954.0086 1.5176.0681a2 2 0 0 1 1.4142 1.4143c.0319.1187.0491.26.0583.5175zM8 9c.5523 0 1 .4477 1 1v8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-8c0-.5523.4477-1 1-1m9 1c0-.5523-.4477-1-1-1s-1 .4477-1 1v8c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Calculator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9538 2 7.7587 2m-.5516 16.2071 11-11c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-11 11c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0M9.5 6.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v1h-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v1c0 .5523.4477 1 1 1s1-.4477 1-1v-1h1c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1zm3 9c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Certificate01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 1C3.3432 1 2 2.3432 2 4v13c0 1.6569 1.3432 3 3 3h.098l3.0385 2.9143a1 1 0 0 0 1.3993-.0145l2.4749-2.475 2.475 2.475a1 1 0 0 0 1.4017.0123L18.9039 20H19c1.6569 0 3-1.3431 3-3V4c0-1.6568-1.3431-3-3-3zm10.875 16.7892a4.52 4.52 0 0 1-1.9108 1.7606l1.241 1.241 1.868-1.8034zm-3.868.2107h.0176C13.394 17.9867 14.5 16.8725 14.5 15.5c0-1.3807-1.1193-2.5-2.5-2.5s-2.5 1.1193-2.5 2.5c0 1.3769 1.1132 2.4939 2.4887 2.5l.0173-.0001zM8.814 20.793l1.2363-1.2362a4.52 4.52 0 0 1-1.9253-1.7676L6.929 18.9851zM8 6c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1M7 8.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h10c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Certificate02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 1C3.2466 1 2 2.5444 2 4.2222v15.5556C2 21.4557 3.2466 23 5 23h14c1.7534 0 3-1.5443 3-3.2222V4.2222C22 2.5444 20.7534 1 19 1zm2 13c-.5523 0-1 .4477-1 1s.4477 1 1 1h10c.5523 0 1-.4477 1-1s-.4477-1-1-1zm2 3.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1zm.2541-11.5633c.8768-.7135 2.0437-.5039 2.7435.2752.6998-.7791 1.8516-.9812 2.7435-.2752.8918.706 1.0002 1.9063.3116 2.7501-.3887.4764-1.3123 1.3115-2.0429 1.9485-.3465.3021-.5197.4532-.7293.515a1.03 1.03 0 0 1-.5658 0c-.2096-.0618-.3828-.2129-.7293-.515-.7306-.637-1.6542-1.4721-2.043-1.9485-.6885-.8438-.565-2.0367.3117-2.7501"
      clipRule="evenodd"
    />
  </svg>
);

export const Compass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.145C9.5543 3.5751 8.5 4.9144 8.5 6.5c0 .9282.3613 1.772.951 2.3985l-4.021 6.925a11.07 11.07 0 0 1-1.6802-1.5477c-.3655-.4141-.9975-.4535-1.4115-.088-.414.3654-.4535.9974-.088 1.4114a13.07 13.07 0 0 0 2.1699 1.9634l-2.285 3.9354c-.2774.4776-.115 1.0896.3626 1.3669s1.0896.1149 1.367-.3627l2.2646-3.9003C7.8928 19.4959 9.8877 20 12 20s4.1071-.5041 5.8705-1.398l2.2646 3.9002c.2774.4776.8893.64 1.367.3627s.6399-.8893.3626-1.3669l-2.285-3.9353a13.07 13.07 0 0 0 2.1701-1.9635c.3654-.414.326-1.046-.0881-1.4114-.414-.3655-1.046-.3261-1.4114.088a11.07 11.07 0 0 1-1.6804 1.5477l-4.021-6.925c.5897-.6264.9511-1.4702.9511-2.3985 0-1.5855-1.0543-2.9248-2.5-3.355zm-1 8c.2823 0 .5568-.0334.8197-.0965l4.0446 6.9656C15.3976 17.5934 13.7465 18 12 18s-3.3977-.4066-4.8644-1.131l4.0445-6.9655A3.5 3.5 0 0 0 12 10"
      clipRule="evenodd"
    />
  </svg>
);

export const Glasses01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.4645 8.4645c1.9526-1.9527 5.1184-1.9526 7.071 0 .5054.5053.88 1.092 1.1238 1.7178a5.02 5.02 0 0 1 2.6814.0001 4.98 4.98 0 0 1 1.1238-1.718c1.9526-1.9526 5.1184-1.9525 7.071 0 1.9527 1.9527 1.9526 5.1185 0 7.0711s-5.1184 1.9527-7.071 0c-.9327-.9326-1.4198-2.142-1.4616-3.3638a3.016 3.016 0 0 0-2.0058-.0001c-.0417 1.2218-.5289 2.4313-1.4616 3.3639-1.9526 1.9527-5.1184 1.9527-7.071 0-1.9527-1.9526-1.9527-5.1184 0-7.071"
    />
  </svg>
);

export const Glasses02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.961 4H6c.5524 0 1 .4477 1 1s-.4476 1-1 1c-.2853 0-.3718.0008-.4393.006a2 2 0 0 0-1.8144 1.642c-.012.0667-.0213.1527-.0497.4366l-.2623 2.6225c1.9206-1.1498 4.4466-.8973 6.1013.7574.5054.5053.88 1.092 1.1237 1.7179a5.02 5.02 0 0 1 2.6815 0 4.98 4.98 0 0 1 1.1237-1.7179c1.6548-1.6547 4.1807-1.9072 6.1013-.7574l-.2623-2.6225c-.0283-.284-.0377-.37-.0496-.4365a2 2 0 0 0-1.8145-1.6421C18.372 6.0007 18.2855 6 18.0001 6c-.5523 0-1-.4477-1-1s.4477-1 1-1h.0391c.2292 0 .3996 0 .5545.012 1.8164.1405 3.3084 1.4907 3.629 3.2841.0273.153.0443.3225.067.5506l.621 6.2094a5.03 5.03 0 0 1 .0894.9591c-.0039 1.2745-.492 2.5479-1.4645 3.5203-1.9526 1.9527-5.1184 1.9527-7.0711 0-.9326-.9326-1.4198-2.142-1.4615-3.3638a3.016 3.016 0 0 0-2.0059-.0001c-.0417 1.2218-.5288 2.4313-1.4615 3.3639-1.9526 1.9527-5.1184 1.9527-7.071 0C1.492 17.5631 1.004 16.2898 1 15.0152v-.0274a5.03 5.03 0 0 1 .0894-.9317l.617-6.1705.004-.039c.0227-.228.0396-.3975.067-.5505C2.098 5.5027 3.59 4.1525 5.4065 4.012 5.5613 4 5.7316 4 5.9608 4"
      clipRule="evenodd"
    />
  </svg>
);

export const GlobeSlated01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.3387 1.661c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0238 0 1.4143c4.0987 4.0987 4.1005 10.7429.0053 14.8439l-.0053.0052c-3.8619 3.862-9.9847 4.0867-14.109.6739l1.4225-1.4224C6.6853 18.3182 8.513 19 10.5 19c4.6944 0 8.5-3.8056 8.5-8.5S15.1944 2 10.5 2 2 5.8056 2 10.5c0 1.9868.6816 3.8144 1.8239 5.2617L2.21 17.3755c-.0832.0831-.1858.1857-.269.285-.0993.1187-.2237.2926-.2959.5313a1.52 1.52 0 0 0 .0331.9656c.0857.226.2147.3877.3236.5022.0882.0926.1946.1852.2773.2572l.0173.0151c4.9091 4.2777 12.361 4.082 17.0365-.5875q.003-.0028.0058-.0057c4.8816-4.8815 4.8816-12.796 0-17.6776"
    />
  </svg>
);

export const GlobeSlated02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5104 2.0756c.3905-.3905 1.0237-.3905 1.4142 0 4.1005 4.1005 4.1005 10.7487 0 14.8492-1.6677 1.6678-3.7568 2.6572-5.9246 2.9684V21h4c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1s.4477-1 1-1h4v-1.0116c-2.2059-.1045-4.3851-.9011-6.1843-2.3897l-1.4475 1.4474c-.3905.3905-1.0236.3905-1.4142 0s-.3905-1.0237 0-1.4142l3.9397-3.9397C5.0184 12.5236 4.5 11.0724 4.5 9.5c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7c-1.5723 0-3.0235-.5184-4.1921-1.3936l-1.0701 1.0701c3.3362 2.6364 8.1923 2.4144 11.2726-.6659 3.3194-3.3194 3.3194-8.7013 0-12.0208-.3905-.3905-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const GraduationHat01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.4472 9.3945a1 1 0 0 0 0-1.7889l-9.6678-4.834c-.0933-.0477-.2864-.1462-.5028-.1868a1.5 1.5 0 0 0-.5532 0c-.2164.0406-.4095.1391-.5028.1867L1.5528 7.6057a1 1 0 0 0 0 1.7889l9.7301 4.878c.2629.1318.3944.1977.5323.2236a1 1 0 0 0 .3696 0c.1379-.0259.2694-.0918.5323-.2236z"
    />
    <path
      fill="currentColor"
      d="M19.9966 14.1653c0-.4294-.0001-.6441-.0904-.7731a.5.5 0 0 0-.3366-.208c-.1558-.0231-.3477.0729-.7314.2648l-6.0588 3.0295c-.0933.0476-.2864.1462-.5028.1868a1.5 1.5 0 0 1-.5532 0c-.2164-.0406-.4095-.1392-.5028-.1868l-6.059-3.0296c-.3837-.1919-.5756-.2878-.7314-.2648a.5.5 0 0 0-.3366.208c-.0903.129-.0903.3437-.0904.7731q0 .9609-.0035 1.9216c-.001.2761-.0023.623.1095.9473.0967.2803.2544.5355.4619.7473.24.2451.551.3991.7983.5216 1.8432.9157 3.6848 1.835 5.5227 2.7613.2026.1021.4576.2306.739.2834.2438.0457.4939.0457.7376 0 .2815-.0528.5364-.1813.739-.2834a883 883 0 0 1 5.5228-2.7613c.2473-.1225.5582-.2765.7983-.5216a2 2 0 0 0 .4618-.7473c.1119-.3243.1106-.6712.1095-.9473a559 559 0 0 1-.0035-1.9215"
    />
  </svg>
);

export const GraduationHat02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m18.5716 10.7597.1349.1377c.1974.1967.3206.2173.5712.0957.5774-.28 1.1483-.5741 1.7222-.861v-.014l1.4473-.7236a1 1 0 0 0 0-1.7889l-9.6678-4.834c-.0933-.0477-.2864-.1462-.5028-.1868a1.5 1.5 0 0 0-.5532 0c-.2164.0406-.4095.1391-.5028.1867L1.5528 7.6057a1 1 0 0 0 0 1.7889l9.7317 4.8798c.2623.1311.3935.1967.5311.2225a1 1 0 0 0 .3688 0c.1376-.0258.2688-.0914.5311-.2225l2.8578-1.4289c.4594-.2297.6891-.3446.763-.5001a.5.5 0 0 0 .0005-.4281c-.0735-.1558-.3029-.2712-.7617-.502l-3.0223-1.5205c-.494-.247-.6942-.8477-.4473-1.3417s.8477-.6942 1.3417-.4472L18.0364 10.4c.114.0556.3505.171.5352.3596"
    />
    <path
      fill="currentColor"
      d="M16.4346 14.6508c.2598-.1299.5654.059.5654.3494 0 .5523.4477 1 1 1s1-.4477 1-1v-1.1377c0-.1794 0-.2692.0273-.3484a.5.5 0 0 1 .1155-.1868c.0586-.0599.1389-.1.2994-.1803l.4001-.2c.3833-.1917.575-.2876.7308-.2645a.5.5 0 0 1 .3367.208c.0902.1291.0902.3434.0903.772l.0001 2.7227c.0011.2856.0025.6445-.1163.9778a2 2 0 0 1-.4887.7616c-.2535.2468-.5803.3951-.8405.5131l-6.5227 2.9894c-.1898.0877-.4287.198-.6899.2434a2 2 0 0 1-.6843 0c-.2612-.0454-.5001-.1557-.6899-.2434l-6.5227-2.9894c-.2602-.118-.587-.2663-.8405-.5131a2 2 0 0 1-.4887-.7616c-.1188-.3333-.1174-.6922-.1163-.9779l.0001-2.7227c0-.4286 0-.6429.0903-.7719a.5.5 0 0 1 .3367-.2081c.1558-.023.3474.0728.7308.2645l7.0374 3.5187.0256.013c.0933.0476.2864.1461.5028.1867.1828.0343.3704.0343.5532 0 .2164-.0406.4095-.1391.5028-.1867l.0256-.013z"
    />
  </svg>
);

export const Microscope = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 5.5C3 3.0147 5.0147 1 7.5 1c2.3359 0 4.2561 1.7799 4.4785 4.0574A9.1 9.1 0 0 1 13 5c4.9705 0 9 4.0294 9 9 0 3.7786-2.3284 7.011-5.6248 8.3454-.512.2072-1.095-.0398-1.3022-.5517s.0398-1.0949.5517-1.3022C18.1919 19.4524 20 16.9361 20 14c0-3.866-3.1341-7-7-7-.34 0-.6738.0242-1 .0708v5.6931c.4748.4248.8127.9988.9424 1.6509.1311.6589.1315 1.5094 0 2.1706a3 3 0 0 1-2.3571 2.357c-.2928.0583-.6207.058-1.0014.0577H5.4162c-.3807.0003-.7086.0006-1.0014-.0577a3 3 0 0 1-2.3571-2.357c-.131-.6589-.1315-1.5094 0-2.1706A2.998 2.998 0 0 1 3 12.7641z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M3 21c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5522 0 1-.4477 1-1s-.4478-1-1-1z"
    />
  </svg>
);

export const Ruler = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.4634 1.2805a1.5 1.5 0 0 0-.927 0c-.2326.0755-.4012.201-.5123.2954-.0958.0813-.1963.1819-.2805.2661L1.8422 15.7435c-.0843.0842-.185.1847-.2663.2806-.0943.1111-.2199.2797-.2954.5123a1.5 1.5 0 0 0 0 .927c.0755.2327.201.4013.2954.5124.0813.0958.182.1963.2662.2805l3.9014 3.9014c.0842.0843.1847.1849.2806.2663.111.0943.2797.2198.5123.2954.3013.0979.6258.0979.927 0 .2327-.0756.4013-.2011.5124-.2954.0958-.0814.1964-.182.2805-.2663L22.1577 8.2564c.0843-.0842.1849-.1848.2663-.2806.0943-.1111.2198-.2797.2954-.5123a1.5 1.5 0 0 0 0-.9271c-.0756-.2326-.2011-.4012-.2954-.5123-.0814-.0958-.182-.1964-.2663-.2806l-3.9014-3.9014c-.0841-.0842-.1847-.1849-.2805-.2662-.1111-.0943-.2797-.2199-.5124-.2954m-2.6705 4.5124c.3905-.3905 1.0237-.3905 1.4142 0l1.5 1.5c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-1.5-1.5c-.3905-.3905-.3905-1.0237 0-1.4142m-1.5858 3c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l1.5 1.5c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142zm-4.4142 3c.3905-.3905 1.0237-.3905 1.4142 0l1.5 1.5c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-1.5-1.5c-.3905-.3905-.3905-1.0237 0-1.4142m-1.5858 3c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l1.5 1.5c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const Stand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1c.5523 0 1 .4477 1 1v1h5.8385c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 6.1795 23 6.6343 23 7.1614v6.6772c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 18 19.3658 18 18.8386 18h-1.4244l3.2929 3.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L14.5858 18H13v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4H9.4142l-4.707 4.7071c-.3906.3905-1.0238.3905-1.4143 0s-.3905-1.0237 0-1.4142L6.5858 18H5.1615c-.5271 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 14.8205 1 14.3657 1 13.8386V7.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 3 4.6343 3 5.1615 3H11V2c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const Telescope = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.1205 1.6759c.1434-.0261.3522-.0506.5914.0003a1.5 1.5 0 0 1 .8029.4635c.1636.1818.2469.3748.2959.512.0424.1184.0791.2558.1099.3709l1.4096 5.2607c.0309.115.0678.2524.0903.3761.0261.1434.0505.3522-.0003.5914a1.5 1.5 0 0 1-.4635.8029c-.1818.1636-.3748.2469-.512.2959-.1184.0423-.2558.0791-.3708.1099l-.0597.016c-.5092.1364-.9484.2541-1.3182.3215-.3902.0711-.7885.104-1.2039.0157a3 3 0 0 1-1.0185-.4238l-4.0243 1.0782a2.987 2.987 0 0 1 .5508 1.7329 2.986 2.986 0 0 1-.5802 1.7737l4.4065 6.4629c.3112.4563.1935 1.0784-.2628 1.3895s-1.0785.1935-1.3896-.2629l-4.4062-6.4623a3 3 0 0 1-.7677.0991 3 3 0 0 1-.7675-.0991l-4.4062 6.4623c-.311.4564-.9332.574-1.3895.2629s-.574-.9332-.263-1.3895l4.4065-6.4628A2.986 2.986 0 0 1 9.0001 13.2q0-.1397.0126-.2761l-2.1178.5675c-.115.0308-.2525.0677-.3762.0903-.1433.0261-.352.0505-.5913-.0004a1.5 1.5 0 0 1-.8029-.4635 1.36 1.36 0 0 1-.1205-.1552l-1.2657.3391c-.115.0309-.2524.0677-.3761.0903-.1433.0261-.3521.0505-.5914-.0003a1.5 1.5 0 0 1-.8028-.4635c-.1637-.1818-.247-.3748-.296-.512-.0423-.1184-.079-.2559-.1099-.3709l-.3743-1.397c-.0309-.1151-.0677-.2525-.0903-.3762-.0261-.1433-.0505-.3521.0003-.5914a1.5 1.5 0 0 1 .4635-.8028c.1818-.1637.3748-.247.512-.296.1184-.0423.2559-.079.371-.1098L3.71 8.1329a1.36 1.36 0 0 1 .0267-.1943 1.5 1.5 0 0 1 .4635-.8029c.1818-.1637.3749-.247.512-.296.1185-.0423.2559-.079.371-.1098l11.5787-3.1025a3 3 0 0 1 .6701-.8763c.3156-.2842.677-.4548 1.0505-.5884.3539-.1265.7931-.2442 1.3023-.3806l.0596-.016c.115-.0308.2525-.0677.3761-.0902m-.074 2.08c-.4491.1208-.7554.206-.9908.2901-.2567.0918-.3442.1542-.3854.1914a1 1 0 0 0-.3091.5352c-.0115.0543-.0218.1613.0271.4295.0509.2797.1465.6394.2958 1.1964l.1552.5795c.1493.557.2464.9163.3421 1.184.0917.2566.1542.3442.1913.3854.1413.157.3287.2651.5352.309.0543.0116.1614.022.4295-.027.2459-.0448.5538-.1241 1.0032-.244z"
      clipRule="evenodd"
    />
  </svg>
);

export const Trophy01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m7.4445 1-.09-.0002c-.313-.0013-.6987-.0029-1.0385.1208A2 2 0 0 0 5.1206 2.316c-.0799.2195-.1075.4582-.1167.684H3.4736c-.21 0-.4146 0-.5887.0118-.1904.013-.4161.0435-.6502.1404a2 2 0 0 0-1.0824 1.0824c-.097.234-.1274.4598-.1404.6502-.0118.174-.0118.3787-.0118.5887v.664c-.0005.7955-.0008 1.3861.1363 1.8978a4 4 0 0 0 2.8284 2.8284c.3806.102.8048.1279 1.3245.1344.7679 2.5828 2.9863 4.5413 5.7107 4.931V17h-.4444C8.0396 17 6 19.0396 6 21.5556 6 22.3533 6.6467 23 7.4444 23h9.1112C17.3533 23 18 22.3533 18 21.5556 18 19.0396 15.9604 17 13.4444 17H13v-1.0709c2.7245-.3897 4.9429-2.3482 5.7107-4.931.5197-.0065.944-.0324 1.3246-.1344a4 4 0 0 0 2.8284-2.8284c.1371-.5117.1368-1.1023.1363-1.8977v-.664c0-.2101 0-.4147-.0118-.5888-.013-.1904-.0435-.4161-.1404-.6502a2 2 0 0 0-1.0824-1.0824c-.2341-.0969-.4598-.1274-.6502-.1404C20.9411 3 20.7365 3 20.5265 3h-1.5304c-.0092-.2258-.0368-.4645-.1167-.684a2 2 0 0 0-1.1953-1.1954c-.3399-.1237-.7255-.122-1.0386-.1208L16.5556 1zM5 5.8c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C4.62 5 4.48 5 4.2 5h-.4565c-.2641 0-.3962 0-.5003.051a.507.507 0 0 0-.217.2059c-.0563.1013-.063.2291-.0763.4849-.0315.603-.0283 1.2285.1183 1.7758A2 2 0 0 0 4.4825 8.932c.1187.0318.26.049.5175.0582zm14 .0033c0-.281 0-.4216.0548-.5288a.5.5 0 0 1 .2195-.2186c.1074-.0543.2479-.0538.529-.0526l.4482.0018c.2631.001.3946.0016.4982.0527a.506.506 0 0 1 .2159.2056c.0561.101.0629.2284.0765.4834.0321.6038.0316 1.2416-.1102 1.7708a2 2 0 0 1-1.4143 1.4143c-.1187.0318-.26.049-.5176.0582z"
      clipRule="evenodd"
    />
  </svg>
);

export const Trophy02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.026 2c-.2335 0-.461 0-.654.0146-.2116.016-.4619.0537-.7172.1728a2 2 0 0 0-.9674.9674c-.1191.2553-.1568.5056-.1728.7172-.0146.193-.0146.4205-.0146.654V10.5c0 3.8031 2.8306 6.945 6.5 7.4339V20H7c-.5523 0-1 .4477-1 1s.4477 1 1 1h10c.5523 0 1-.4477 1-1s-.4477-1-1-1h-4v-2.0661c3.6694-.4889 6.5-3.6308 6.5-7.4339V4.526c0-.2334.0001-.461-.0146-.654-.016-.2116-.0537-.4619-.1728-.7172a2 2 0 0 0-.9674-.9674c-.2553-.1191-.5056-.1568-.7172-.1728C17.435 1.9999 17.2075 2 16.9739 2z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M2 4c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1V5c0-.5523.4477-1 1-1M22 4c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1V5c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const Brackets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5708 4c0-.5523.4477-1 1-1 1.8153 0 3.286 1.4707 3.286 3.286v4.1568l.8501.8501c.3905.3905.3905 1.0237 0 1.4142l-.8501.8501v4.1568c0 1.8156-1.472 3.286-3.286 3.286-.5523 0-1-.4477-1-1s.4477-1 1-1c.71 0 1.286-.5756 1.286-1.286v-4.571c0-.2652.1054-.5196.2929-.7071L20.5856 12l-.4359-.4359a1 1 0 0 1-.2929-.7071V6.286c0-.7107-.5753-1.286-1.286-1.286-.5523 0-1-.4477-1-1M2.143 6.286C2.143 4.4707 3.6137 3 5.429 3c.5523 0 1 .4477 1 1s-.4477 1-1 1c-.7107 0-1.286.5753-1.286 1.286v4.571a1 1 0 0 1-.2929.7071L3.4142 12l.436.4359a1 1 0 0 1 .2928.7071v4.571c0 .7107.5753 1.286 1.286 1.286.5523 0 1 .4477 1 1s-.4477 1-1 1c-1.8153 0-3.286-1.4707-3.286-3.286v-4.1568l-.8501-.8501a1 1 0 0 1 0-1.4142l.8501-.8501z"
      clipRule="evenodd"
    />
  </svg>
);

export const BracketsCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5708 4c0-.5523.4477-1 1-1 1.8153 0 3.286 1.4707 3.286 3.286v4.1568l.8501.8501c.3905.3905.3905 1.0237 0 1.4142l-.8501.8501v4.1568c0 1.8156-1.472 3.286-3.286 3.286-.5523 0-1-.4477-1-1s.4477-1 1-1c.71 0 1.286-.5756 1.286-1.286v-4.571c0-.2652.1054-.5196.2929-.7071L20.5856 12l-.4359-.4359a1 1 0 0 1-.2929-.7071V6.286c0-.7107-.5753-1.286-1.286-1.286-.5523 0-1-.4477-1-1M2.143 6.286C2.143 4.4707 3.6137 3 5.429 3c.5523 0 1 .4477 1 1s-.4477 1-1 1c-.7107 0-1.286.5753-1.286 1.286v4.571a1 1 0 0 1-.2929.7071L3.4142 12l.436.4359a1 1 0 0 1 .2928.7071v4.571c0 .7107.5753 1.286 1.286 1.286.5523 0 1 .4477 1 1s-.4477 1-1 1c-1.8153 0-3.286-1.4707-3.286-3.286v-4.1568l-.8501-.8501a1 1 0 0 1 0-1.4142l.8501-.8501z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.2071 8.2929c.3905.3905.3905 1.0237 0 1.4142l-5.4343 5.4343-.0164.0164c-.0842.0842-.1847.1849-.2806.2663-.111.0942-.2796.2198-.5123.2954a1.5 1.5 0 0 1-.927 0c-.2327-.0756-.4013-.2012-.5123-.2954-.0959-.0814-.1964-.182-.2806-.2663l-.0164-.0164-2.4343-2.4343c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L10.5 13.5858l5.2929-5.293c.3905-.3904 1.0237-.3904 1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const BracketsEllipses = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5708 4c0-.5523.4477-1 1-1 1.8153 0 3.286 1.4707 3.286 3.286v4.1568l.8501.8501c.3905.3905.3905 1.0237 0 1.4142l-.8501.8501v4.1568c0 1.8156-1.472 3.286-3.286 3.286-.5523 0-1-.4477-1-1s.4477-1 1-1c.71 0 1.286-.5756 1.286-1.286v-4.571c0-.2652.1054-.5196.2929-.7071L20.5856 12l-.4359-.4359a1 1 0 0 1-.2929-.7071V6.286c0-.7107-.5753-1.286-1.286-1.286-.5523 0-1-.4477-1-1M2.143 6.286C2.143 4.4707 3.6137 3 5.429 3c.5523 0 1 .4477 1 1s-.4477 1-1 1c-.7107 0-1.286.5753-1.286 1.286v4.571a1 1 0 0 1-.2929.7071L3.4142 12l.436.4359a1 1 0 0 1 .2928.7071v4.571c0 .7107.5753 1.286 1.286 1.286.5523 0 1 .4477 1 1s-.4477 1-1 1c-1.8153 0-3.286-1.4707-3.286-3.286v-4.1568l-.8501-.8501a1 1 0 0 1 0-1.4142l.8501-.8501z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 12c0-.8284.6716-1.5 1.5-1.5S9 11.1716 9 12s-.6716 1.5-1.5 1.5S6 12.8284 6 12M10.5 12c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5M15 12c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5S15 12.8284 15 12"
      clipRule="evenodd"
    />
  </svg>
);

export const BracketsMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5708 4c0-.5523.4477-1 1-1 1.8153 0 3.286 1.4707 3.286 3.286v4.1568l.8501.8501c.3905.3905.3905 1.0237 0 1.4142l-.8501.8501v4.1568c0 1.8156-1.472 3.286-3.286 3.286-.5523 0-1-.4477-1-1s.4477-1 1-1c.71 0 1.286-.5756 1.286-1.286v-4.571c0-.2652.1054-.5196.2929-.7071L20.5856 12l-.4359-.4359a1 1 0 0 1-.2929-.7071V6.286c0-.7107-.5753-1.286-1.286-1.286-.5523 0-1-.4477-1-1M2.143 6.286C2.143 4.4707 3.6137 3 5.429 3c.5523 0 1 .4477 1 1s-.4477 1-1 1c-.7107 0-1.286.5753-1.286 1.286v4.571a1 1 0 0 1-.2929.7071L3.4142 12l.436.4359a1 1 0 0 1 .2928.7071v4.571c0 .7107.5753 1.286 1.286 1.286.5523 0 1 .4477 1 1s-.4477 1-1 1c-1.8153 0-3.286-1.4707-3.286-3.286v-4.1568l-.8501-.8501a1 1 0 0 1 0-1.4142l.8501-.8501zM7 12c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BracketsPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.429 3C3.6137 3 2.143 4.4707 2.143 6.286v4.1568l-.8501.8501a1 1 0 0 0 0 1.4142l.8501.8501v4.1568C2.143 19.5293 3.6137 21 5.429 21c.5523 0 1-.4477 1-1s-.4477-1-1-1c-.7107 0-1.286-.5753-1.286-1.286v-4.571a1 1 0 0 0-.2929-.7071L3.4142 12l.436-.4359a1 1 0 0 0 .2928-.7071V6.286C4.143 5.5753 4.7183 5 5.429 5c.5523 0 1-.4477 1-1s-.4477-1-1-1M18.5708 3c-.5523 0-1 .4477-1 1s.4477 1 1 1c.7107 0 1.286.5753 1.286 1.286v4.571c0 .2652.1054.5196.2929.7071l.4359.4359-.4359.4359a1 1 0 0 0-.2929.7071v4.571c0 .7104-.576 1.286-1.286 1.286-.5523 0-1 .4477-1 1s.4477 1 1 1c1.814 0 3.286-1.4704 3.286-3.286v-4.1568l.8501-.8501c.3905-.3905.3905-1.0237 0-1.4142l-.8501-.8501V6.286c0-1.8153-1.4707-3.286-3.286-3.286M12 7c.5523 0 1 .4477 1 1v3h3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h3V8c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const BracketsSlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5708 4c0-.5523.4477-1 1-1 1.8153 0 3.286 1.4707 3.286 3.286v4.1568l.8501.8501c.3905.3905.3905 1.0237 0 1.4142l-.8501.8501v4.1568c0 1.8156-1.472 3.286-3.286 3.286-.5523 0-1-.4477-1-1s.4477-1 1-1c.71 0 1.286-.5756 1.286-1.286v-4.571c0-.2652.1054-.5196.2929-.7071L20.5856 12l-.4359-.4359a1 1 0 0 1-.2929-.7071V6.286c0-.7107-.5753-1.286-1.286-1.286-.5523 0-1-.4477-1-1M2.143 6.286C2.143 4.4707 3.6137 3 5.429 3c.5523 0 1 .4477 1 1s-.4477 1-1 1c-.7107 0-1.286.5753-1.286 1.286v4.571a1 1 0 0 1-.2929.7071L3.4142 12l.436.4359a1 1 0 0 1 .2928.7071v4.571c0 .7107.5753 1.286 1.286 1.286.5523 0 1 .4477 1 1s-.4477 1-1 1c-1.8153 0-3.286-1.4707-3.286-3.286v-4.1568l-.8501-.8501a1 1 0 0 1 0-1.4142l.8501-.8501zM15.5145 6.1425c.4736.2842.6271.8984.343 1.372l-6 10c-.2842.4736-.8984.6271-1.372.343-.4736-.2842-.6271-.8984-.343-1.372l6-10c.2842-.4736.8984-.6271 1.372-.343"
      clipRule="evenodd"
    />
  </svg>
);

export const BracketsX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.429 3C3.6137 3 2.143 4.4707 2.143 6.286v4.1568l-.8501.8501a1 1 0 0 0 0 1.4142l.8501.8501v4.1568C2.143 19.5293 3.6137 21 5.429 21c.5523 0 1-.4477 1-1s-.4477-1-1-1c-.7107 0-1.286-.5753-1.286-1.286v-4.571a1 1 0 0 0-.2929-.7071L3.4142 12l.436-.4359a1 1 0 0 0 .2928-.7071V6.286C4.143 5.5753 4.7183 5 5.429 5c.5523 0 1-.4477 1-1s-.4477-1-1-1M18.5708 3c-.5523 0-1 .4477-1 1s.4477 1 1 1c.7107 0 1.286.5753 1.286 1.286v4.571c0 .2652.1054.5196.2929.7071l.4359.4359-.4359.4359a1 1 0 0 0-.2929.7071v4.571c0 .7104-.576 1.286-1.286 1.286-.5523 0-1 .4477-1 1s.4477 1 1 1c1.814 0 3.286-1.4704 3.286-3.286v-4.1568l.8501-.8501c.3905-.3905.3905-1.0237 0-1.4142l-.8501-.8501V6.286c0-1.8153-1.4707-3.286-3.286-3.286M15.7071 8.2929c.3905.3905.3905 1.0237 0 1.4142L13.4142 12l2.2929 2.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 13.4142l-2.2929 2.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L10.5858 12l-2.293-2.2929c-.3904-.3905-.3904-1.0237 0-1.4142.3906-.3905 1.0238-.3905 1.4143 0L12 10.5858l2.2929-2.293c.3905-.3904 1.0237-.3904 1.4142 0"
    />
  </svg>
);

export const Browser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.2413 2H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642-.0177.2169-.0289.4343-.0358.652-.0172.542-.0258.813.0806 1.0339.0916.1902.2512.3549.4384.4525C1.7447 8 2.0298 8 2.6 8h18.8c.5702 0 .8553 0 1.0726-.1134a1.02 1.02 0 0 0 .4384-.4525c.1064-.2208.0978-.4919.0806-1.034a13 13 0 0 0-.0358-.652c-.0459-.562-.1445-1.0787-.3918-1.564a4 4 0 0 0-1.748-1.7481c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7107 2 18.0462 2 17.2413 2M23 11.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C22.2401 10 21.9601 10 21.4 10H2.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 10.7599 1 11.0399 1 11.6v4.6413c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9538 22 6.7588 22h10.4824c.805 0 1.4694 0 2.0106-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413z"
    />
  </svg>
);

export const Code01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2929 5.2929c.3905-.3905 1.0237-.3905 1.4142 0l6 6c.3905.3905.3905 1.0237 0 1.4142l-6 6c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L20.5858 12l-5.2929-5.2929c-.3905-.3905-.3905-1.0237 0-1.4142M8.7071 5.2929c.3905.3905.3905 1.0237 0 1.4142L3.4142 12l5.293 5.2929c.3904.3905.3904 1.0237 0 1.4142-.3906.3905-1.0238.3905-1.4143 0l-6-6c-.3905-.3905-.3905-1.0237 0-1.4142l6-6c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const Code02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2929 6.2931c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l4.2929-4.2929-4.2929-4.2929c-.3905-.3905-.3905-1.0237 0-1.4142M7.7071 6.2931c.3905.3905.3905 1.0237 0 1.4142l-4.2929 4.2929 4.293 4.2929c.3904.3905.3904 1.0237 0 1.4142-.3906.3905-1.0238.3905-1.4143 0l-5-5c-.3905-.3905-.3905-1.0237 0-1.4142l5-5c.3905-.3905 1.0237-.3905 1.4142 0M14.2169 2.024c.5392.1198.8791.654.7593 1.1931l-4 18c-.1198.5392-.654.8791-1.1931.7593s-.879-.654-.7593-1.1931l4-18c.1198-.5392.654-.879 1.1931-.7593"
      clipRule="evenodd"
    />
  </svg>
);

export const CodeBrowser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.2413 2H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642-.0177.2169-.0289.4343-.0358.652-.0172.542-.0258.813.0806 1.0339.0916.1902.2512.3549.4384.4525C1.7447 8 2.0298 8 2.6 8h18.8c.5702 0 .8553 0 1.0726-.1134a1.02 1.02 0 0 0 .4384-.4525c.1064-.2208.0978-.4919.0806-1.034a13 13 0 0 0-.0358-.652c-.0459-.562-.1445-1.0787-.3918-1.564a4 4 0 0 0-1.748-1.7481c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7107 2 18.0462 2 17.2413 2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 11.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C22.2401 10 21.9601 10 21.4 10H2.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 10.7599 1 11.0399 1 11.6v4.6413c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9538 22 6.7588 22h10.4824c.805 0 1.4694 0 2.0106-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413zm-9.7071.6929c.3905-.3905 1.0237-.3905 1.4142 0l2.5 2.5c.3905.3905.3905 1.0237 0 1.4142l-2.5 2.5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L15.0858 15.5l-1.7929-1.7929c-.3905-.3905-.3905-1.0237 0-1.4142m-2.5858 1.4142c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-2.5 2.5c-.3905.3905-.3905 1.0237 0 1.4142l2.5 2.5c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L8.9142 15.5z"
      clipRule="evenodd"
    />
  </svg>
);

export const CodeCircle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m-1.7929 8.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L7.9142 12zm5-1.4142c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L16.0858 12l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const CodeCircle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m-1.2929 6.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L8.4142 10zm4 2.5858c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L15.5858 14l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const CodeCircle03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m1.9806 6.1963c.1083-.5415-.2429-1.0684-.7845-1.1767s-1.0684.243-1.1767.7845l-2 10c-.1083.5415.2429 1.0684.7845 1.1767s1.0684-.2429 1.1767-.7845zM9.2071 8.2931c.3905.3905.3905 1.0237 0 1.4142l-2.2929 2.2929 2.293 2.2929c.3904.3905.3904 1.0237 0 1.4142-.3906.3905-1.0238.3905-1.4143 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142l3-3c.3905-.3905 1.0237-.3905 1.4142 0m5.5858 0c.3905-.3905 1.0237-.3905 1.4142 0l3 3c.3905.3905.3905 1.0237 0 1.4142l-3 3c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l2.2929-2.2929-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const CodeSquare01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2m-7.6314 7.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L7.9142 12zm5-1.4142c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L16.0858 12l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const CodeSquare02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2m-7.1314 5.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L8.4142 10zm4 2.5858c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L15.5858 14l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const Codepen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.457 1.2453a2 2 0 0 0-.914 0c-.3481.0817-.6517.2808-.8934.4392L2.1271 7.2242c-.2058.1328-.4646.2998-.6618.5357a2 2 0 0 0-.377.6946c-.0903.294-.0893.602-.0884.8469v5.3966c-.0009.2449-.002.553.0884.8469.0782.2543.2064.4904.377.6946.1972.2359.456.4029.6618.5357l8.5225 5.5397c.2417.1584.5453.3575.8934.4392.3006.0705.6134.0705.914 0 .3481-.0817.6517-.2808.8934-.4392l8.5225-5.5397c.2058-.1328.4647-.2998.6618-.5357a2 2 0 0 0 .377-.6946c.0903-.2939.0893-.602.0885-.8469V9.3014c.0008-.2449.0018-.553-.0885-.8469a2 2 0 0 0-.377-.6946c-.1971-.236-.456-.403-.6618-.5357l-8.5225-5.5397c-.2417-.1584-.5453-.3575-.8934-.4392M3 10.3425l.0042 4.6122L11 20.157v-4.6244zm10 9.8145 7.9961-5.2074L21 10.3425l-8 5.19z"
      clipRule="evenodd"
    />
  </svg>
);

export const Container = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.4029 1.185a2 2 0 0 0-.8058 0c-.3073.0632-.5819.217-.8003.3394l-.0595.0332c-1.7629.9794-4.7452 2.637-6.4266 3.5717-.4082.2269-.6124.3404-.6806.4903a.5.5 0 0 0-.001.4118c.0674.1503.2712.2649.6786.494l7.3001 4.1064c.143.0804.2146.1207.2904.1365a.5.5 0 0 0 .2035 0c.0759-.0158.1474-.0561.2905-.1365l7.3001-4.1064c.4074-.2292.6112-.3437.6786-.494a.5.5 0 0 0-.001-.4118c-.0682-.15-.2724-.2634-.6806-.4903-1.6814-.9346-4.6637-2.5923-6.4266-3.5717l-.0595-.0332c-.2184-.1223-.493-.2762-.8003-.3394M21.9959 8.8902c-.0004-.4484-.0006-.6726-.0951-.8034a.5.5 0 0 0-.3493-.2041c-.1604-.0181-.3562.092-.7477.3122l-7.396 4.1603c-.1485.0835-.2227.1253-.2767.1843a.5.5 0 0 0-.1061.1814c-.025.076-.025.1612-.025.3315v8.1753c0 .4472 0 .6708.094.8016a.5.5 0 0 0 .3479.2047c.16.0187.3549-.0895.7446-.3059 1.6663-.9253 4.695-2.6071 6.4762-3.5967l.0631-.0348c.2311-.1273.5218-.2874.7449-.5296.193-.2094.339-.4575.4283-.7279.1034-.3127.1021-.6445.1012-.9083L22 16.0586c0-1.963-.0025-5.3023-.0041-7.1684M9.8135 21.9281c.3897.2164.5846.3246.7446.3059a.5.5 0 0 0 .3479-.2047c.094-.1308.094-.3544.094-.8016v-8.1752c0-.1704 0-.2555-.025-.3316a.5.5 0 0 0-.1061-.1813c-.054-.0591-.1282-.1009-.2767-.1844L3.1962 8.195c-.3915-.2203-.5873-.3304-.7477-.3123a.5.5 0 0 0-.3493.204c-.0945.131-.0947.3551-.0951.8035A10602 10602 0 0 0 2 16.0586l-.0002.0722c-.001.2638-.0022.5956.1012.9083.0893.2704.2353.5185.4283.7279.2231.2422.5137.4022.7449.5296l.0631.0348c1.7812.9896 4.8099 2.6714 6.4762 3.5967"
    />
  </svg>
);

export const CpuChip01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 10.8c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C10.38 10 10.52 10 10.8 10h2.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C14 10.38 14 10.52 14 10.8v2.4c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C13.62 14 13.48 14 13.2 14h-2.4c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C10 13.62 10 13.48 10 13.2z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.0016c-.4755.0033-.891.0131-1.2518.0426-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642-.0295.3608-.0393.7763-.0426 1.2518H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v3H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v.2413c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.3608.0295.7763.0393 1.2518.0426V22c0 .5523.4477 1 1 1s1-.4477 1-1v-1h4v1c0 .5523.4477 1 1 1s1-.4477 1-1v-1.0016c.4755-.0033.891-.0131 1.2518-.0426.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 16.7106 21 16.0463 21 15.2413V15h1c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1v-3h1c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1.0016c-.0033-.4755-.0131-.891-.0426-1.2518-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918-.3608-.0295-.7763-.0393-1.2518-.0426V2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1h-4zm.5681 6c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698C8 10.0699 8 10.3157 8 10.568v2.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h2.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-2.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C13.9301 8 13.6843 8 13.4319 8z"
      clipRule="evenodd"
    />
  </svg>
);

export const CpuChip02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 1c.5523 0 1 .4477 1 1v2h4V2c0-.5523.4477-1 1-1s1 .4477 1 1v2.0271q.1302.0072.2518.017c.5621.046 1.0788.1446 1.5642.3919a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642q.0099.1216.0171.2518H22c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v3h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2.0016c-.0033.4755-.0131.891-.0426 1.2518-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918a10 10 0 0 1-.2518.0171V22c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2h-4v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2.0271a10 10 0 0 1-.2518-.0171c-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642-.0295-.3608-.0393-.7763-.0426-1.2518H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-3H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h2.0271a10 10 0 0 1 .017-.2518c.046-.5621.1446-1.0788.3919-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918A10 10 0 0 1 8 4.0272V2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Data = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.7769 9h2.4463c.1191 0 .2613 0 .3866.0101.1453.012.3533.0424.5712.1534.2822.1438.5117.3733.6555.6555.1111.218.1415.426.1534.5712.0102.1253.0102.2676.0101.3867v10.4462c.0001.1192.0001.2614-.0101.3867-.0119.1453-.0423.3533-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.2179.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3867.0101H10.7769c-.1192.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.111-.2179-.1415-.4259-.1534-.5712-.0102-.1253-.0101-.2675-.01-.3867v-2.4461999999999997c-.0001-.1191-.0002-.2614.01-.3867.012-.1452.0424-.3532.1534-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1534.1253-.0102.2676-.0101.3867-.0101H13v-2.2231c0-.1191-.0001-.2614.0101-.3867.0119-.1452.0424-.3532.1534-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1534.1253-.0102.2676-.0101.3867-.0101H17v-2.2231c0-.1191-.0001-.2614.0101-.3867.0119-.1452.0424-.3532.1534-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1534.1253-.0102.2676-.0101.3867-.01M10.7769 5h2.4463c.1191 0 .2613 0 .3866.0102.1453.0118.3533.0423.5712.1533a1.5 1.5 0 0 1 .6555.6555c.1111.218.1415.426.1534.5712.0102.1253.0102.2676.0101.3867v2.4463c.0001.119.0001.2613-.0101.3866-.0119.1453-.0423.3533-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.2179.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3866.0101h-2.4463c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.111-.218-.1415-.426-.1534-.5712C9 9.4845 9 9.3423 9.0002 9.2232V6.7769c-.0001-.1191-.0002-.2614.01-.3867.012-.1452.0424-.3532.1534-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1533.1253-.0103.2676-.0102.3867-.0102M3.7769 11h2.4463c.119 0 .2613-.0001.3866.0101.1453.0119.3533.0424.5712.1534.2822.1438.5117.3733.6555.6555.111.218.1415.426.1534.5712.0102.1253.0102.2676.0101.3867v2.4463c0 .1191.0001.2613-.0101.3866-.0119.1453-.0423.3533-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.1111-.426.1415-.5712.1534-.1253.0102-.2675.0102-.3866.0101H3.7769c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.111-.2179-.1415-.4259-.1534-.5712-.0102-.1253-.0101-.2675-.01-.3866v-2.4463c-.0001-.1191-.0002-.2614.01-.3867.012-.1452.0423-.3532.1534-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1534.1253-.0102.2676-.0101.3867-.0101M2.7769 1h2.4463c.119 0 .2613 0 .3866.0102.1453.0118.3533.0423.5712.1533a1.5 1.5 0 0 1 .6555.6555c.111.218.1415.426.1534.5712C7 2.5155 7 2.6578 7 2.7769v2.4463c0 .119.0001.2613-.0101.3866-.0119.1453-.0423.3533-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.111-.426.1415-.5712.1534C5.4845 7 5.3423 7 5.2232 7H2.7769c-.1191 0-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.111-.218-.1415-.426-.1533-.5712C.9999 5.4845 1 5.3423 1 5.2232V2.7769c0-.1191 0-.2614.0102-.3867.0118-.1452.0423-.3532.1533-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1533C2.5155.9999 2.6578 1 2.7769 1"
      clipRule="evenodd"
    />
  </svg>
);

export const Database01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.4149 13.5c.12 0 .233.053.317.1387.1113.1138.2295.2185.3502.3141.5788.4587 1.355.8274 2.2262 1.1182C7.0611 15.6562 9.4233 16 12 16c2.5768 0 4.9389-.3438 6.6917-.929.8712-.2908 1.6474-.6595 2.2262-1.1182a3.7 3.7 0 0 0 .3502-.3141c.0839-.0857.197-.1387.317-.1387a.415.415 0 0 1 .4149.4149V19c0 .8494-.5132 1.502-1.0821 1.9528-.5788.4587-1.355.8274-2.2262 1.1182C16.9389 22.6562 14.5768 23 12 23s-4.939-.3438-6.6917-.929c-.8712-.2908-1.6474-.6595-2.2262-1.1182C2.513 20.502 2 19.8494 2 19v-5.0851a.415.415 0 0 1 .4148-.4149"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.9117 3.0469C21.4811 3.4956 22 4.148 22 5v5c0 .8494-.5132 1.502-1.0821 1.9528-.5788.4587-1.355.8274-2.2262 1.1182C16.9389 13.6562 14.5768 14 12 14s-4.939-.3438-6.6917-.929c-.8712-.2908-1.6474-.6595-2.2262-1.1182C2.513 11.502 2 10.8494 2 10V5c0-.852.5189-1.5044 1.0883-1.9531.5807-.4577 1.359-.826 2.2315-1.1169C7.0754 1.3448 9.4372 1 12 1s4.9246.3448 6.6802.93c.8726.2909 1.6508.6592 2.2315 1.1169M4 4.9999s0-.0051.003-.0152a.3.3 0 0 1 .032-.0661c.0425-.0692.129-.1731.2912-.301.3302-.2601.87-.5382 1.626-.7902C7.454 3.3268 9.5923 3 12 3s4.546.3268 6.0477.8274c.7561.252 1.2959.53 1.6261.7903.1621.1278.2487.2317.2911.3009a.3.3 0 0 1 .032.0661.06.06 0 0 1 .0031.0155s-.0001.0055-.0031.015a.3.3 0 0 1-.032.0662c-.0424.0692-.129.1731-.2911.301-.3302.2601-.87.5382-1.6261.7902C16.546 6.6732 14.4077 7 12 7s-4.546-.3268-6.0477-.8274c-.7561-.252-1.2959-.53-1.626-.7903-.1622-.1278-.2488-.2317-.2912-.3009a.3.3 0 0 1-.032-.0661A.07.07 0 0 1 4 4.9999"
      clipRule="evenodd"
    />
  </svg>
);

export const Database02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 7V5c0-.852-.5189-1.5044-1.0883-1.9531-.5807-.4577-1.3589-.826-2.2315-1.1169C16.9246 1.3448 14.5629 1 12 1s-4.9246.3448-6.6802.93c-.8726.2909-1.6508.6592-2.2315 1.1169C2.5189 3.4956 2 4.148 2 5v2c0 .8494.5132 1.502 1.082 1.9528.579.4587 1.3551.8274 2.2263 1.1182C7.0611 10.6562 9.4233 11 12 11c2.5768 0 4.9389-.3438 6.6917-.929.8712-.2908 1.6474-.6595 2.2262-1.1182C21.4868 8.502 22 7.8494 22 7M4 5.0003s.0002.0055.003.015a.3.3 0 0 0 .032.0661c.0425.0692.129.1731.2912.301.3302.2601.87.5382 1.626.7902C7.454 6.6732 9.5923 7 12 7s4.546-.3268 6.0477-.8274c.7561-.252 1.2959-.53 1.6261-.7903.1621-.1278.2487-.2317.2911-.3009a.3.3 0 0 0 .032-.0661A.06.06 0 0 0 20 5s.0001-.005-.0031-.0153a.3.3 0 0 0-.032-.0661c-.0424-.0692-.129-.1731-.2911-.301-.3302-.2601-.87-.5382-1.6261-.7902C16.546 3.3268 14.4077 3 12 3s-4.546.3268-6.0477.8274c-.7561.252-1.2959.53-1.626.7903-.1622.1278-.2488.2317-.2912.3009a.3.3 0 0 0-.032.0661C4 4.9947 4 5.0003 4 5.0003"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M21.5917 10.5c-.1181 0-.2294.0521-.3119.1365a3.75 3.75 0 0 1-.353.3166c-.5794.4586-1.3564.8273-2.2285 1.1182-1.7545.5851-4.119.9289-6.6983.9289s-4.9439-.3438-6.6984-.9289c-.872-.2909-1.649-.6596-2.2285-1.1182a3.8 3.8 0 0 1-.3529-.3166c-.0825-.0844-.1938-.1365-.3119-.1365A.4083.4083 0 0 0 2 10.9083V13c0 .8494.5132 1.502 1.082 1.9528.579.4587 1.3551.8274 2.2263 1.1182C7.0611 16.6562 9.4233 17 12 17c2.5768 0 4.9389-.3438 6.6917-.929.8712-.2908 1.6474-.6595 2.2262-1.1182C21.4868 14.502 22 13.8494 22 13v-2.0917a.4083.4083 0 0 0-.4083-.4083"
    />
    <path
      fill="currentColor"
      d="M21.5917 16.5c-.1181 0-.2294.0521-.3119.1365a3.75 3.75 0 0 1-.353.3166c-.5794.4586-1.3564.8273-2.2285 1.1182-1.7545.5851-4.119.9289-6.6983.9289s-4.9439-.3438-6.6984-.9289c-.872-.2909-1.649-.6596-2.2285-1.1182a3.8 3.8 0 0 1-.3529-.3166c-.0825-.0844-.1938-.1365-.3119-.1365A.4083.4083 0 0 0 2 16.9083V19c0 .8494.5132 1.502 1.082 1.9528.579.4587 1.3551.8274 2.2263 1.1182C7.0611 22.6562 9.4233 23 12 23c2.5768 0 4.9389-.3438 6.6917-.929.8712-.2908 1.6474-.6595 2.2262-1.1182C21.4868 20.502 22 19.8494 22 19v-2.0917a.4083.4083 0 0 0-.4083-.4083"
    />
  </svg>
);

export const Database03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 14.9826c2.1847-.0767 4.1683-.403 5.6917-.9116.8712-.2908 1.6474-.6595 2.2262-1.1182C21.4868 12.502 22 11.8494 22 11V5c0-.852-.5189-1.5044-1.0883-1.9531-.5807-.4577-1.3589-.826-2.2315-1.1169C16.9246 1.3448 14.5629 1 12 1s-4.9246.3448-6.6802.93c-.8726.2909-1.6508.6592-2.2315 1.1169C2.5189 3.4956 2 4.148 2 5v6c0 .8494.5132 1.502 1.082 1.9528.579.4587 1.3551.8274 2.2263 1.1182 1.5233.5086 3.507.8349 5.6917.9116v2.1881A3.009 3.009 0 0 0 9.1707 19H3c-.5523 0-1 .4477-1 1s.4477 1 1 1h6.1707c.4118 1.1652 1.5231 2 2.8293 2s2.4175-.8348 2.8293-2H21c.5523 0 1-.4477 1-1s-.4477-1-1-1h-6.1707A3.009 3.009 0 0 0 13 17.1707zM4 4.9999s0-.0051.003-.0152a.3.3 0 0 1 .032-.0661c.0425-.0692.129-.1731.2912-.301.3302-.2601.87-.5382 1.626-.7902C7.454 3.3268 9.5923 3 12 3s4.546.3268 6.0477.8274c.7561.252 1.2959.53 1.6261.7903.1621.1278.2487.2317.2911.3009a.3.3 0 0 1 .032.0661C20 4.9947 20 5 20 5s-.0001.0058-.0031.0154a.3.3 0 0 1-.032.0661c-.0424.0692-.129.1731-.2911.301-.3302.2601-.87.5382-1.6261.7902C16.546 6.6732 14.4077 7 12 7s-4.546-.3268-6.0477-.8274c-.7561-.252-1.2959-.53-1.626-.7903-.1622-.1278-.2488-.2317-.2912-.3009a.3.3 0 0 1-.032-.0661A.07.07 0 0 1 4 4.9999"
      clipRule="evenodd"
    />
  </svg>
);

export const Dataflow01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.911 5.0376c.3302-.027.7315-.0346 1.26-.0368C16.5831 6.1656 17.6941 7 19 7c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3c-1.3065 0-2.4179.8352-2.8295 2.0007-.5473.0021-1.019.0105-1.4223.0435-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C11 7.2894 11 7.9537 11 8.7586V11H7.8293C7.4175 9.8348 6.3063 9 5 9c-1.6568 0-3 1.3431-3 3s1.3432 3 3 3c1.3062 0 2.4175-.8348 2.8293-2H11v2.2413c0 .8049 0 1.4693.0442 2.0105.0459.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.0021.3459 1.5642.3918.4033.033.875.0413 1.4223.0435C16.5821 22.1648 17.6935 23 19 23c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3c-1.3059 0-2.4169.8344-2.829 1.9992-.5285-.0022-.9298-.0098-1.26-.0367-.4384-.0359-.6626-.1008-.819-.1805a2 2 0 0 1-.874-.874c-.0797-.1564-.1446-.3806-.1804-.819C13.0008 16.6389 13 16.0566 13 15.2V13h3.1707c.4118 1.1652 1.5231 2 2.8293 2 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3c-1.3062 0-2.4175.8348-2.8293 2H13V8.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804"
      clipRule="evenodd"
    />
  </svg>
);

export const Dataflow02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.8293 3C7.4175 1.8348 6.3063 1 5 1 3.3432 1 2 2.3432 2 4s1.3432 3 3 3c1.3062 0 2.4175-.8348 2.8293-2H11v10.2413c0 .8049 0 1.4693.0442 2.0105.0459.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.0021.3459 1.5642.3918.4033.033.875.0413 1.4223.0435C16.5821 22.1648 17.6935 23 19 23c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3c-1.3059 0-2.4169.8344-2.829 1.9992-.5285-.0022-.9298-.0098-1.26-.0368-.4384-.0358-.6626-.1007-.819-.1804a2 2 0 0 1-.874-.874c-.0797-.1564-.1446-.3806-.1804-.819C13.0008 16.6389 13 16.0566 13 15.2V13h3.1707c.4118 1.1652 1.5231 2 2.8293 2 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3c-1.3062 0-2.4175.8348-2.8293 2H13V5h3.1707C16.5825 6.1652 17.6938 7 19 7c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3c-1.3062 0-2.4175.8348-2.8293 2z"
      clipRule="evenodd"
    />
  </svg>
);

export const Dataflow03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.5322 5.524c-.2834-.0232-.6556-.024-1.2322-.024H11c-.5523 0-1-.4477-1-1s.4477-1 1-1h7.3386c.5271 0 .9819 0 1.3564.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3746.0306.8293.0306 1.3565V9.032c0 .4386 0 .8171-.0213 1.1304-.0225.3298-.072.6597-.207.9857a3 3 0 0 1-1.6236 1.6236c-.326.135-.6559.1845-.9857.207C19.3491 13 18.9706 13 18.532 13H18.5c-.5523 0-1-.4477-1-1s.4477-1 1-1c.4796 0 .7893-.0005 1.0263-.0167.2279-.0156.3148-.0422.3564-.0594a1 1 0 0 0 .5412-.5412c.0172-.0416.0438-.1284.0594-.3564.0162-.237.0167-.5467.0167-1.0263V7.7c0-.5765-.0008-.9488-.0239-1.2321-.0222-.2717-.0599-.3724-.0851-.4219a1 1 0 0 0-.437-.437c-.0494-.0252-.1502-.0629-.4218-.085M5.468 11H5.5c.5523 0 1 .4477 1 1s-.4477 1-1 1c-.4796 0-.7892.0006-1.0262.0167-.228.0156-.3149.0422-.3565.0594a1 1 0 0 0-.5412.5412c-.0172.0416-.0438.1285-.0594.3565-.0162.237-.0167.5466-.0167 1.0262v1.3c0 .5766.0008.9488.024 1.2322.0221.2716.0598.3724.085.4218a1 1 0 0 0 .437.437c.0495.0252.1502.0629.4219.0851.2833.0231.6556.0239 1.2321.0239H13c.5523 0 1 .4477 1 1s-.4477 1-1 1H5.6615c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1.5 17.3205 1.5 16.8657 1.5 16.3386V14.968c0-.4386 0-.8171.0214-1.1304.0225-.3298.072-.6597.207-.9856a3 3 0 0 1 1.6236-1.6236c.3259-.135.6558-.1845.9856-.207C4.651 11 5.0294 11 5.468 11"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.2769 8.5h3.4463c.1191 0 .2613 0 .3866.0101.1453.012.3533.0424.5712.1534a1.5 1.5 0 0 1 .6555.6555c.1111.218.1415.426.1534.5712.0102.1253.0102.2676.0101.3867v3.4463c.0001.1191.0001.2613-.0101.3866-.0119.1453-.0423.3533-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.2179.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3866.0101h-3.4463c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.111-.2179-.1415-.4259-.1534-.5712-.0102-.1253-.0101-.2675-.01-.3866v-3.4463c-.0001-.1191-.0002-.2614.01-.3867.012-.1452.0424-.3532.1534-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1534.1253-.0102.2676-.0101.3867-.01M17.7769 16h3.4463c.1191 0 .2613-.0001.3866.0101.1453.0119.3533.0424.5712.1534.2822.1438.5117.3733.6555.6555.1111.218.1415.426.1534.5712.0102.1253.0102.2676.0101.3867v3.4463c.0001.1191.0001.2613-.0101.3866-.0119.1453-.0423.3533-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.2179.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3866.0101h-3.4463c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.111-.2179-.1415-.4259-.1534-.5712-.0102-.1253-.0101-.2675-.0101-.3866v-3.4463c0-.1191-.0001-.2614.0101-.3867.0119-.1452.0424-.3532.1534-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1534.1253-.0102.2676-.0101.3867-.0101M2.7769 1h3.4463c.119 0 .2613 0 .3866.0102.1453.0118.3533.0423.5712.1533a1.5 1.5 0 0 1 .6555.6555c.111.218.1415.426.1534.5712C8 2.5155 8 2.6578 8 2.7769v3.4463c0 .119.0001.2613-.0101.3866-.0119.1453-.0423.3533-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.111-.426.1415-.5712.1534C6.4845 8 6.3423 8 6.2232 8H2.7769c-.1191 0-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.111-.218-.1415-.426-.1533-.5712C.9999 6.4845 1 6.3423 1 6.2232V2.7769c0-.1191 0-.2614.0102-.3867.0118-.1452.0423-.3532.1533-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1533C2.5155.9999 2.6578 1 2.7769 1"
      clipRule="evenodd"
    />
  </svg>
);

export const Dataflow04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.032 1H5.968c-.4386 0-.8171 0-1.1304.0213-.3298.0226-.6597.072-.9857.207A3 3 0 0 0 2.2285 2.852c-.135.3259-.1846.6558-.207.9856C2 4.151 2 4.5294 2 4.968v.064c0 .4386 0 .8171.0213 1.1304.0225.3298.072.6597.207.9856A3 3 0 0 0 3.852 8.7717c.3259.135.6558.1845.9856.207C5.151 9 5.5294 9 5.968 9H11v3H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.0459-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.0021-.3918 1.5642-.033.4033-.0413.875-.0435 1.4223C1.8352 17.5821 1 18.6935 1 20c0 1.6569 1.3432 3 3 3s3-1.3431 3-3c0-1.3059-.8344-2.4169-1.9992-2.829.0022-.5285.0098-.9298.0368-1.26.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C7.3611 14.0008 7.9434 14 8.8 14H11v3.1707C9.8348 17.5825 9 18.6938 9 20c0 1.6569 1.3431 3 3 3s3-1.3431 3-3c0-1.3062-.8348-2.4175-2-2.8293V14h2.2c.8566 0 1.4389.0008 1.889.0376.4384.0358.6626.1007.819.1804.3763.1917.6823.4977.874.874.0797.1564.1446.3806.1804.819.027.3302.0346.7315.0368 1.26C17.8344 17.5831 17 18.6941 17 20c0 1.6569 1.3431 3 3 3s3-1.3431 3-3c0-1.3065-.8352-2.4179-2.0007-2.8295-.0022-.5473-.0105-1.019-.0435-1.4223-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 12 16.0463 12 15.2414 12H13V9h5.032c.4386 0 .8171 0 1.1304-.0213.3298-.0226.6597-.072.9857-.207a3 3 0 0 0 1.6235-1.6236c.135-.326.1845-.6559.2071-.9857C22 5.849 22 5.4706 22 5.032v-.064c0-.4386 0-.8171-.0213-1.1304-.0226-.3298-.0721-.6597-.2071-.9857a3 3 0 0 0-1.6235-1.6235c-.326-.135-.6559-.1845-.9857-.207C18.8491 1 18.4706 1 18.032 1"
      clipRule="evenodd"
    />
  </svg>
);

export const FileCode01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.9989 1.9523A1 1 0 0 1 13 2.0156v4.4163c0 .2524-.0001.4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.201.2081.017.4539.017.7063.017h4.4164c.0262 0 .0393 0 .0632.0012.4938.0235.9279.4578.9512.9516A1 1 0 0 1 21 10v7.2414c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C16.7106 23 16.0463 23 15.2413 23H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9537 1 8.7587 1H12c.0156 0 .0234 0 .0473.0011.4937.0234.928.4574.9516.9512M10.7071 13.207c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-2.5 2.5c-.3905.3905-.3905 1.0237 0 1.4142l2.5 2.5c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L8.9142 15zm4-1.4142c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L15.0858 15l-1.7929 1.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l2.5-2.5c.3905-.3905.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.4686 6.9263C19.3484 7 19.2016 7 18.908 7H15.8c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2186C15 6.62 15 6.48 15 6.2V3.092c0-.2936 0-.4404.0737-.5607.1042-.1698.3495-.2713.5432-.2248.1371.033.2328.1287.4241.3202l3.3323 3.3323c.1915.1913.2872.287.3202.4241.0465.1937-.055.439-.2249.5432"
    />
  </svg>
);

export const FileCode02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.6911 1.1106C14.2284.9995 13.7487.9997 13.1137 1h-3.355c-.805 0-1.4693 0-2.0105.0443-.5621.0459-1.0788.1444-1.5642.3917a4 4 0 0 0-1.748 1.7481c-.2473.4853-.3459 1.002-.3918 1.5641C4 5.2894 4 5.9538 4 6.7588v10.4826c0 .8049 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5641a4 4 0 0 0 1.748 1.7481c.4854.2473 1.002.3458 1.5642.3918.5412.0442 1.2055.0442 2.0105.0442h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.046 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.7481c.2473-.4853.3459-1.002.3918-1.5641C22 18.7107 22 18.0463 22 17.2414v-7.355c.0003-.635.0006-1.1148-.1105-1.5775a4 4 0 0 0-.4789-1.1562c-.2487-.4057-.5881-.7448-1.0373-1.1936L17.041 2.6268c-.4488-.4492-.7879-.7887-1.1936-1.0373a4 4 0 0 0-1.1563-.479m-2.984 9.0965c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-2.5 2.5c-.3905.3905-.3905 1.0237 0 1.4142l2.5 2.5c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L9.9142 12zm4-1.4142c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L16.0858 12l-1.7929 1.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l2.5-2.5c.3905-.3905.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderCode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617v10.0799c0 .8049 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5641a4 4 0 0 0 1.748 1.7481c.4854.2473 1.002.3458 1.5642.3918.5412.0442 1.2055.0442 2.0105.0441h10.4826c.805.0001 1.4693.0001 2.0105-.0441.5621-.046 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.7481c.2473-.4853.3459-1.002.3918-1.5641C23 17.7109 23 17.0465 23 16.2416v-4.4827c0-.8049 0-1.4693-.0442-2.0105-.0459-.562-.1445-1.0788-.3918-1.5641a4 4 0 0 0-1.748-1.748c-.4854-.2474-1.0021-.346-1.5642-.3919-.5412-.0442-1.2055-.0442-2.0105-.0442h-3.6232l-.8947-1.7896c-.2648-.5312-.4976-.9984-.8603-1.3536a3 3 0 0 0-1.121-.6928c-.4799-.1656-1.0019-.1649-1.5954-.164H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1797 1 5.6346 1 6.1617m9.7071 6.0457c.3905-.3906.3905-1.0237 0-1.4143s-1.0237-.3905-1.4142 0l-2.5 2.5c-.3905.3906-.3905 1.0237 0 1.4143l2.5 2.5c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4143l-1.7929-1.7929zm4-1.4143c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4143l1.7929 1.7928-1.7929 1.7929c-.3905.3906-.3905 1.0237 0 1.4143s1.0237.3905 1.4142 0l2.5-2.5c.3905-.3906.3905-1.0237 0-1.4143z"
      clipRule="evenodd"
    />
  </svg>
);

export const GitBranch01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v10.2413c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 19 6.9537 19 7.7587 19h6.3673c.4441 1.7252 2.0102 3 3.874 3 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4c-1.8638 0-3.4299 1.2748-3.874 3H7.8c-.8566 0-1.4389-.0008-1.889-.0376-.4384-.0358-.6626-.1007-.819-.1804a2 2 0 0 1-.874-.874c-.0797-.1564-.1446-.3806-.1804-.819C4.0008 14.6389 4 14.0566 4 13.2V9h10.126c.4441 1.7252 2.0102 3 3.874 3 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4c-1.8638 0-3.4299 1.2748-3.874 3H4z"
      clipRule="evenodd"
    />
  </svg>
);

export const GitBranch02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v11.126c-1.7252.4441-3 2.0102-3 3.874 0 2.2091 1.7909 4 4 4 1.8779 0 3.4535-1.2941 3.8838-3.0391a10 10 0 0 0 9.0771-9.077C20.7059 9.4534 22 7.8778 22 6c0-2.2091-1.7909-4-4-4s-4 1.7909-4 4c0 1.847 1.2519 3.4017 2.9535 3.8617a8 8 0 0 1-2.2966 4.7952 8 8 0 0 1-4.7952 2.2966C9.4877 15.57 8.3901 14.4838 7 14.126z"
      clipRule="evenodd"
    />
  </svg>
);

export const GitCommit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.9 11c-.4633-2.2822-2.481-4-4.9-4s-4.4367 1.7178-4.9 4H2.0002c-.5523 0-1 .4477-1 1s.4477 1 1 1H7.1c.4633 2.2822 2.481 4 4.9 4s4.4367-1.7178 4.9-4H22c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const GitMerge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.0465 9.8617C8.7481 9.4017 10 7.847 10 6c0-2.2091-1.7909-4-4-4S2 3.7909 2 6c0 1.8638 1.2748 3.43 3 3.874V21c0 .5523.4477 1 1 1s1-.4477 1-1v-5.9999a10.0002 10.0002 0 0 0 7.1162 3.9608C14.5465 20.7059 16.1221 22 18 22c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4c-1.847 0-3.4017 1.2519-3.8617 2.9535a8.0004 8.0004 0 0 1-7.0918-7.0918"
      clipRule="evenodd"
    />
  </svg>
);

export const GitPullRequest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 9.874C8.7252 9.43 10 7.8638 10 6c0-2.2091-1.7909-4-4-4S2 3.7909 2 6c0 1.8638 1.2748 3.43 3 3.874V21c0 .5523.4477 1 1 1s1-.4477 1-1zM14 18c0-1.8638 1.2748-3.4299 3-3.874V8a1 1 0 0 0-1-1h-3c-.5523 0-1-.4477-1-1s.4477-1 1-1h3a3 3 0 0 1 3 3v6.126c1.7252.4441 3 2.0102 3 3.874 0 2.2091-1.7909 4-4 4s-4-1.7909-4-4"
      clipRule="evenodd"
    />
  </svg>
);

export const Package = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.4029 1.185a2 2 0 0 0-.8058 0c-.3073.0632-.5819.217-.8003.3394l-.0595.0332-2.337 1.2986 8.9629 4.9794 2.3291-1.3102c.4074-.2292.6112-.3437.6786-.494a.5.5 0 0 0-.001-.4118c-.0682-.15-.2724-.2634-.6806-.4903-1.6814-.9346-4.6637-2.5923-6.4266-3.5717l-.0595-.0332c-.2184-.1223-.493-.2762-.8003-.3394M15.3169 8.9866 6.3417 4.0004l-2.031 1.1289c-.4082.2269-.6124.3404-.6806.4903a.5.5 0 0 0-.001.4118c.0674.1503.2712.2649.6786.494l7.3001 4.1064c.143.0804.2146.1207.2904.1365a.5.5 0 0 0 .2035 0c.0759-.0158.1474-.0561.2905-.1365zM21.9959 8.8901c-.0004-.4483-.0006-.6725-.0951-.8033a.5.5 0 0 0-.3493-.2041c-.1604-.0181-.3562.092-.7477.3122l-7.396 4.1603c-.1485.0835-.2227.1253-.2767.1843a.5.5 0 0 0-.1061.1814c-.025.076-.025.1612-.025.3315v8.1753c0 .4472 0 .6708.094.8016a.5.5 0 0 0 .3479.2047c.16.0187.3549-.0895.7446-.3059 1.6663-.9253 4.695-2.6071 6.4762-3.5967l.0631-.0348c.2311-.1273.5218-.2874.7449-.5296.193-.2094.339-.4575.4283-.7279.1034-.3127.1021-.6445.1012-.9083L22 16.0586c0-1.963-.0025-5.3023-.0041-7.1685M10.5581 22.234c-.16.0187-.3549-.0895-.7446-.3059-1.6663-.9253-4.695-2.6071-6.4762-3.5967l-.0631-.0348c-.2312-.1274-.5218-.2874-.745-.5296a2 2 0 0 1-.4282-.7279c-.1034-.3127-.1021-.6445-.1012-.9083L2 16.0586c0-1.963.0025-5.3023.0041-7.1684.0004-.4484.0006-.6725.0951-.8034a.5.5 0 0 1 .3493-.2041c.1604-.0181.3562.092.7477.3123l7.396 4.1602c.1485.0835.2227.1253.2767.1844a.5.5 0 0 1 .1061.1813c.025.0761.025.1612.025.3316v8.1752c0 .4472 0 .6708-.094.8016a.5.5 0 0 1-.3479.2047"
    />
  </svg>
);

export const PackageMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 18c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M11.5971 1.185a2 2 0 0 1 .8058 0c.3073.0632.5819.217.8003.3394l.0595.0332c1.7629.9794 4.7452 2.637 6.4266 3.5717.4082.2269.6124.3403.6806.4903a.5.5 0 0 1 .001.4118c-.0674.1503-.2712.2649-.6786.494l-2.3291 1.3101-8.9628-4.9793 2.3369-1.2986.0595-.0332c.2184-.1223.493-.2762.8003-.3394M6.3417 4.0004l8.9752 4.9862-2.9247 1.6452c-.1431.0804-.2146.1207-.2905.1365a.5.5 0 0 1-.2035 0c-.0758-.0158-.1474-.0561-.2904-.1365L4.3077 6.5255c-.4074-.2292-.6112-.3438-.6786-.4941a.5.5 0 0 1 .001-.4118c.0682-.15.2723-.2634.6806-.4903zM21.9959 8.8901c-.0004-.4483-.0006-.6725-.0951-.8033a.5.5 0 0 0-.3493-.2041c-.1604-.0181-.3562.092-.7477.3122l-7.396 4.1603c-.1485.0835-.2227.1253-.2767.1843a.5.5 0 0 0-.1061.1814c-.025.076-.025.1612-.025.3315v8.1753c0 .4472 0 .6708.094.8016a.5.5 0 0 0 .3479.2047c.16.0187.3549-.0895.7446-.3059l.2855-.1585c.4993-.2773.749-.4159.8176-.5277.0829-.1349.0906-.1712.0696-.3281-.0174-.1299-.2636-.4563-.7559-1.1091A2.987 2.987 0 0 1 14 18c0-1.6569 1.3431-3 3-3h4.1996c.2801 0 .4201 0 .5271-.0545a.5.5 0 0 0 .2185-.2186c.0545-.107.0544-.247.0543-.527-.0008-1.8187-.0025-3.9534-.0036-5.3098M9.8135 21.9281c.3897.2164.5846.3246.7446.3059a.5.5 0 0 0 .3479-.2047c.094-.1308.094-.3544.094-.8016v-8.1752c0-.1704 0-.2555-.025-.3316a.5.5 0 0 0-.1061-.1813c-.054-.0591-.1282-.1009-.2767-.1844L3.1962 8.195c-.3915-.2203-.5873-.3304-.7477-.3123a.5.5 0 0 0-.3493.204c-.0945.131-.0947.3551-.0951.8035A10602 10602 0 0 0 2 16.0586l-.0002.0722c-.001.2638-.0022.5956.1012.9083.0893.2704.2353.5185.4283.7279.2231.2422.5137.4022.7449.5296l.0631.0348c1.7812.9896 4.8099 2.6714 6.4762 3.5967"
    />
  </svg>
);

export const PackageCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.7071 15.2929c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L19 18.5858l3.2929-3.2929c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M11.5971 1.185a2 2 0 0 1 .8058 0c.3073.0632.5819.217.8003.3394l.0595.0332c1.7629.9794 4.7452 2.637 6.4266 3.5717.4082.2269.6124.3403.6806.4903a.5.5 0 0 1 .001.4118c-.0674.1503-.2712.2649-.6786.494l-2.3291 1.3101-8.9628-4.9793 2.3369-1.2986.0595-.0332c.2184-.1223.493-.2762.8003-.3394M6.3417 4.0004l8.9752 4.9862-2.9247 1.6452c-.1431.0804-.2146.1207-.2905.1365a.5.5 0 0 1-.2035 0c-.0758-.0158-.1474-.0561-.2904-.1365L4.3077 6.5255c-.4074-.2292-.6112-.3438-.6786-.4941a.5.5 0 0 1 .001-.4118c.0682-.15.2723-.2634.6806-.4903zM21.9959 8.8901c-.0004-.4483-.0006-.6725-.0951-.8033a.5.5 0 0 0-.3493-.2041c-.1604-.0181-.3562.092-.7477.3122l-7.396 4.1603c-.1485.0835-.2227.1253-.2767.1843a.5.5 0 0 0-.1061.1814c-.025.076-.025.1612-.025.3315v8.1753c0 .4472 0 .6708.094.8016a.5.5 0 0 0 .3479.2047c.16.0187.3549-.0895.7446-.3059l.6793-.3772c.3149-.1748.4723-.2622.5417-.3866a.5.5 0 0 0 .0502-.3579c-.0326-.1386-.1599-.266-.4145-.5206l-.1645-.1645c-1.1716-1.1716-1.1716-3.071 0-4.2426 1.1308-1.1309 2.9399-1.1702 4.1179-.1179l1.8821-1.8821a3 3 0 0 1 .6074-.4695c.2221-.1301.3332-.1951.3857-.2538.055-.0616.0775-.101.1028-.1795.0242-.075.0242-.1737.024-.371a15842 15842 0 0 0-.0027-3.7148M9.8135 21.9281c.3897.2164.5846.3246.7446.3059a.5.5 0 0 0 .3479-.2047c.094-.1308.094-.3544.094-.8016v-8.1752c0-.1704 0-.2555-.025-.3316a.5.5 0 0 0-.1061-.1813c-.054-.0591-.1282-.1009-.2767-.1844L3.1962 8.195c-.3915-.2203-.5873-.3304-.7477-.3123a.5.5 0 0 0-.3493.204c-.0945.131-.0947.3551-.0951.8035A10602 10602 0 0 0 2 16.0586l-.0002.0722c-.001.2638-.0022.5956.1012.9083.0893.2704.2353.5185.4283.7279.2231.2422.5137.4022.7449.5296l.0631.0348c1.7812.9896 4.8099 2.6714 6.4762 3.5967"
    />
  </svg>
);

export const PackagePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 15c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1v-2h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2zM11.5971 1.185a2 2 0 0 1 .8058 0c.3073.0632.5819.217.8003.3394l.0595.0332c1.7629.9794 4.7452 2.637 6.4266 3.5717.4082.2269.6124.3403.6806.4903a.5.5 0 0 1 .001.4118c-.0674.1503-.2712.2649-.6786.494l-2.3291 1.3101-8.9628-4.9793 2.3369-1.2986.0595-.0332c.2184-.1223.493-.2762.8003-.3394M6.3417 4.0004l8.9752 4.9862-2.9247 1.6452c-.1431.0804-.2146.1207-.2905.1365a.5.5 0 0 1-.2035 0c-.0758-.0158-.1474-.0561-.2904-.1365L4.3077 6.5255c-.4074-.2292-.6112-.3438-.6786-.4941a.5.5 0 0 1 .001-.4118c.0682-.15.2723-.2634.6806-.4903z"
    />
    <path
      fill="currentColor"
      d="M21.9959 8.8901c-.0004-.4483-.0006-.6725-.0951-.8033a.5.5 0 0 0-.3493-.2041c-.1604-.0181-.3562.092-.7477.3122l-7.396 4.1603c-.1485.0835-.2227.1253-.2767.1843a.5.5 0 0 0-.1061.1814c-.025.076-.025.1612-.025.3315v8.1753c0 .4472 0 .6708.094.8016a.5.5 0 0 0 .3479.2047c.16.0187.3549-.0895.7446-.3059l.2855-.1585c.4993-.2773.749-.4159.8176-.5277.0829-.1349.0906-.1712.0696-.3281-.0174-.1299-.2636-.4563-.7559-1.1091A2.987 2.987 0 0 1 14 18c0-1.6569 1.3431-3 3-3 0-1.6569 1.3431-3 3-3q.202.0002.3969.026c.7767.1027 1.1651.154 1.2864.1056.145-.0578.1748-.084.2511-.2202.0637-.114.0635-.3888.0631-.9385zM9.8135 21.9281c.3897.2164.5846.3246.7446.3059a.5.5 0 0 0 .3479-.2047c.094-.1308.094-.3544.094-.8016v-8.1752c0-.1704 0-.2555-.025-.3316a.5.5 0 0 0-.1061-.1813c-.054-.0591-.1282-.1009-.2767-.1844L3.1962 8.195c-.3915-.2203-.5873-.3304-.7477-.3123a.5.5 0 0 0-.3493.204c-.0945.131-.0947.3551-.0951.8035A10602 10602 0 0 0 2 16.0586l-.0002.0722c-.001.2638-.0022.5956.1012.9083.0893.2704.2353.5185.4283.7279.2231.2422.5137.4022.7449.5296l.0631.0348c1.7812.9896 4.8099 2.6714 6.4762 3.5967"
    />
  </svg>
);

export const PackageSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 14c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4a3.985 3.985 0 0 0 1.7052-.3806l.5877.5877c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-.4585-.4585A3.982 3.982 0 0 0 24 18c0-2.2091-1.7909-4-4-4m-2 4c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M11.5971 1.185a2 2 0 0 1 .8058 0c.3073.0632.5819.217.8003.3394l.0595.0332c1.7629.9794 4.7452 2.637 6.4266 3.5717.4082.2269.6124.3403.6806.4903a.5.5 0 0 1 .001.4118c-.0674.1503-.2712.2649-.6786.494l-2.3291 1.3101-8.9628-4.9793 2.3369-1.2986.0595-.0332c.2184-.1223.493-.2762.8003-.3394M6.3417 4.0004l8.9752 4.9862-2.9247 1.6452c-.1431.0804-.2146.1207-.2905.1365a.5.5 0 0 1-.2035 0c-.0758-.0158-.1474-.0561-.2904-.1365L4.3077 6.5255c-.4074-.2292-.6112-.3438-.6786-.4941a.5.5 0 0 1 .001-.4118c.0682-.15.2723-.2634.6806-.4903zM21.9959 8.8901c-.0004-.4483-.0006-.6725-.0951-.8033a.5.5 0 0 0-.3493-.2041c-.1604-.0181-.3562.092-.7477.3122l-7.396 4.1603c-.1485.0835-.2227.1253-.2767.1843a.5.5 0 0 0-.1061.1814c-.025.076-.025.1612-.025.3315v8.1753c0 .4472 0 .6708.094.8016a.5.5 0 0 0 .3479.2047c.16.0187.3549-.0895.7446-.3059l.1165-.0646c.268-.1489.402-.2233.4683-.319.0642-.0926.0896-.1743.0891-.287-.0005-.1165-.0785-.2731-.2346-.5865C14.2253 19.8666 14 18.9596 14 18c0-3.3137 2.6863-6 6-6 .3066 0 .6078.023.9021.0674.4346.0655.6519.0983.7752.0509.1204-.0462.1921-.108.2557-.2202.0651-.1149.065-.3062.0647-.689zM9.8135 21.9281c.3897.2164.5846.3246.7446.3059a.5.5 0 0 0 .3479-.2047c.094-.1308.094-.3544.094-.8016v-8.1752c0-.1704 0-.2555-.025-.3316a.5.5 0 0 0-.1061-.1813c-.054-.0591-.1282-.1009-.2767-.1844L3.1962 8.195c-.3915-.2203-.5873-.3304-.7477-.3123a.5.5 0 0 0-.3493.204c-.0945.131-.0947.3551-.0951.8035A10602 10602 0 0 0 2 16.0586l-.0002.0722c-.001.2638-.0022.5956.1012.9083.0893.2704.2353.5185.4283.7279.2231.2422.5137.4022.7449.5296l.0631.0348c1.7812.9896 4.8099 2.6714 6.4762 3.5967"
    />
  </svg>
);

export const PackageX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.2071 15.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L18.5858 18.5l-1.7929 1.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L20 19.9142l1.7929 1.7929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L21.4142 18.5l1.7929-1.7929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L20 17.0858zM11.5971 1.185a2 2 0 0 1 .8058 0c.3073.0632.5819.217.8003.3394l.0595.0332c1.7629.9794 4.7452 2.637 6.4266 3.5717.4082.2269.6124.3403.6806.4903a.5.5 0 0 1 .001.4118c-.0674.1503-.2712.2649-.6786.494l-2.3291 1.3101-8.9628-4.9793 2.3369-1.2986.0595-.0332c.2184-.1223.493-.2762.8003-.3394M6.3417 4.0004l8.9752 4.9862-2.9247 1.6452c-.1431.0804-.2146.1207-.2905.1365a.5.5 0 0 1-.2035 0c-.0758-.0158-.1474-.0561-.2904-.1365L4.3077 6.5255c-.4074-.2292-.6112-.3438-.6786-.4941a.5.5 0 0 1 .001-.4118c.0682-.15.2723-.2634.6806-.4903z"
    />
    <path
      fill="currentColor"
      d="M21.9959 8.8901c-.0004-.4483-.0006-.6725-.0951-.8033a.5.5 0 0 0-.3493-.2041c-.1604-.0181-.3562.092-.7477.3122l-7.396 4.1603c-.1485.0835-.2227.1253-.2767.1843a.5.5 0 0 0-.1061.1814c-.025.076-.025.1612-.025.3315v8.1753c0 .4472 0 .6708.094.8016a.5.5 0 0 0 .3479.2047c.16.0187.3549-.0895.7446-.3059.0708-.0393.1062-.0589.1291-.0753.1454-.1036.2048-.2154.2096-.3939.0007-.0281-.0042-.0854-.0141-.2001-.0733-.8516.2159-1.7284.8676-2.3801l.3787-.3787-.3787-.3787c-1.1716-1.1716-1.1716-3.071 0-4.2426s3.071-1.1716 4.2426 0l.3787.3787.3787-.3787a2.99 2.99 0 0 1 .971-.6503c.282-.1169.4229-.1753.4885-.2359.0692-.064.0971-.1058.1296-.1943.0309-.0838.0308-.2002.0307-.4332-.0008-1.2885-.0018-2.559-.0026-3.4749M9.8135 21.9281c.3897.2164.5846.3246.7446.3059a.5.5 0 0 0 .3479-.2047c.094-.1308.094-.3544.094-.8016v-8.1752c0-.1704 0-.2555-.025-.3316a.5.5 0 0 0-.1061-.1813c-.054-.0591-.1282-.1009-.2767-.1844L3.1962 8.195c-.3915-.2203-.5873-.3304-.7477-.3123a.5.5 0 0 0-.3493.204c-.0945.131-.0947.3551-.0951.8035A10602 10602 0 0 0 2 16.0586l-.0002.0722c-.001.2638-.0022.5956.1012.9083.0893.2704.2353.5185.4283.7279.2231.2422.5137.4022.7449.5296l.0631.0348c1.7812.9896 4.8099 2.6714 6.4762 3.5967"
    />
  </svg>
);

export const PuzzlePiece01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 4.5C6.5 2.567 8.067 1 10 1s3.5 1.567 3.5 3.5V5h.0343c.6698 0 1.2226 0 1.6752.0309.4693.032.9034.1005 1.3212.2736a4 4 0 0 1 2.1648 2.1648c.1731.4178.2416.8519.2736 1.3212.0146.2136.0223.4495.0264.7095H19.5c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5H19v.7413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C14.7106 23 14.0463 23 13.2413 23H12.5c-.5523 0-1-.4477-1-1v-1.75c0-.6904-.5596-1.25-1.25-1.25S9 19.5596 9 20.25V22c0 .5523-.4477 1-1 1H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 18.7106 1 18.0463 1 17.2413V15.5c0-.5523.4477-1 1-1h1.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5H2c-.5523 0-1-.4477-1-1v-.0343c0-.6698 0-1.2226.0309-1.6752.032-.4693.1005-.9034.2736-1.3212a4 4 0 0 1 2.1648-2.1648c.4178-.173.8519-.2416 1.3212-.2736.4526-.031 1.0054-.031 1.6752-.0309H6.5z"
      clipRule="evenodd"
    />
  </svg>
);

export const PuzzlePiece02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.2929 1.2929c.3905-.3905 1.0237-.3905 1.4142 0l2.6196 2.6196c.6323-.9843 1.4418-1.6055 2.363-1.8395 1.2666-.3218 2.4819.1594 3.2799.9574s1.2792 2.0133.9574 3.2799c-.234.9213-.8552 1.7307-1.8394 2.363l2.6195 2.6196c.3905.3905.3905 1.0237 0 1.4142l-3.6 3.6a1 1 0 0 1-1.6416-.3511c-.5272-1.384-1.1977-1.8303-1.6477-1.9446-.4678-.1189-.9837.0437-1.3732.4332s-.5521.9054-.4332 1.3732c.1143.45.5606 1.1205 1.9446 1.6477a1 1 0 0 1 .3511 1.6416l-3.6 3.6c-.3905.3905-1.0237.3905-1.4142 0l-2.6196-2.6195c-.6323.9842-1.4417 1.6054-2.363 1.8394-1.2666.3218-2.482-.1594-3.28-.9574s-1.2791-2.0133-.9573-3.2799c.234-.9212.8552-1.7307 1.8395-2.363l-2.6196-2.6196c-.3905-.3905-.3905-1.0237 0-1.4142l3.6-3.6a1 1 0 0 1 1.6416.3511c.5272 1.384 1.1977 1.8303 1.6477 1.9446.4678.1189.9837-.0437 1.3732-.4332s.5521-.9054.4332-1.3732c-.1143-.45-.5605-1.1205-1.9446-1.6477a1 1 0 0 1-.3511-1.6416z"
      clipRule="evenodd"
    />
  </svg>
);

export const QrCode01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M7 17c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1M11 21c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M20 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1M2 17c0-.5523.4477-1 1-1h1.5c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M14.5 12c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1M2 21c0-.5523.4477-1 1-1h5c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M12 1c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.5523.4477-1 1-1M17.5681 15h1.8638000000000001c.2524 0 .4982-.0001.7063.0169.2286.0187.4984.0628.7698.2011.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v1.8638000000000001c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-1.8638000000000001c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.4539-.017-.7063v-1.8638000000000001c0-.2524-.0001-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.2011.2081-.017.4539-.0169.7063-.0169M6 12c0-.5523.4477-1 1-1h5c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4H7c-.5523 0-1-.4477-1-1M17.5681 2h1.8638000000000001c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.454.0169.7063v1.8638000000000001c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.201-.2081.017-.4539.017-.7063.017h-1.8638000000000001c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063V4.5681c0-.2524-.0001-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201.2081-.017.4539-.017.7063-.017M4.5681 2H6.432c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201a2 2 0 0 1 .874.874c.1383.2714.1824.5412.201.7698.017.2081.017.454.017.7063v1.8638000000000001c0 .2524 0 .4982-.017.7063-.0186.2286-.0627.4984-.201.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.201C6.9301 9 6.6842 9 6.432 9H4.5681c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C2 6.9301 2 6.6842 2 6.432V4.5681c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201C4.0699 2 4.3158 2 4.568 2"
      clipRule="evenodd"
    />
  </svg>
);

export const QrCode02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.5681 2c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.0171.2081-.017.4539-.017.7062V8.432c0 .2524-.0001.4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h3.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.208.0169-.4538.0169-.7061V4.568c0-.2523.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C19.9301 2 19.6843 2 19.4319 2zM16.5 6.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M13 12c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zM17.5 16.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zM14 15.5c.5523 0 1 .4477 1 1V21c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4.5c0-.5523.4477-1 1-1M16.5 13c-.5523 0-1 .4477-1 1s.4477 1 1 1H21c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
    <path
      fill="currentColor"
      d="M21 16c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1h-4c-.5523 0-1-.4477-1-1s.4477-1 1-1h3v-3c0-.5523.4477-1 1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5681 2H8.432c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.454.0169.7063V8.432c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.454.0169-.7063.0169H4.568c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C2 8.9301 2 8.6842 2 8.432V4.5681c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201C4.0699 2 4.3158 2 4.568 2M5.5 6.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.5c-.5523 0-1-.4477-1-1M4.5681 13c-.2523 0-.4982-.0001-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.017.2081-.017.4539-.017.7063v3.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7062.0169H8.432c.2523 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-3.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201-.2081-.0171-.4539-.017-.7062-.017zM6.5 16.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Server01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.8385 1H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 4.1795 1 4.6343 1 5.1614v1.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 11 4.6343 11 5.1615 11h13.677c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 7.8205 23 7.3657 23 6.8386V5.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 1 19.3657 1 18.8385 1M6 4.75c-.6903 0-1.25.5597-1.25 1.25S5.3097 7.25 6 7.25 7.25 6.6904 7.25 6 6.6904 4.75 6 4.75M18.8385 13H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 16.1795 1 16.6343 1 17.1614v1.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 23 4.6343 23 5.1615 23h13.677c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 19.8205 23 19.3657 23 18.8386v-1.6772c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 13 19.3657 13 18.8385 13M4.75 18c0-.6904.5597-1.25 1.25-1.25s1.25.5596 1.25 1.25-.5596 1.25-1.25 1.25-1.25-.5596-1.25-1.25"
      clipRule="evenodd"
    />
  </svg>
);

export const Server02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 2C3.0147 2 1 4.0147 1 6.5S3.0147 11 5.5 11h13c2.4853 0 4.5-2.0147 4.5-4.5S20.9853 2 18.5 2zm-.75 4.5c0-.6904.5596-1.25 1.25-1.25s1.25.5596 1.25 1.25S6.6904 7.75 6 7.75 4.75 7.1904 4.75 6.5M5.5 13C3.0147 13 1 15.0147 1 17.5S3.0147 22 5.5 22h13c2.4853 0 4.5-2.0147 4.5-4.5S20.9853 13 18.5 13zm.5 3.25c-.6904 0-1.25.5596-1.25 1.25s.5596 1.25 1.25 1.25 1.25-.5596 1.25-1.25-.5596-1.25-1.25-1.25"
      clipRule="evenodd"
    />
  </svg>
);

export const Server03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.4407 2h9.1186c.7555 0 1.3808 0 1.8925.0406.5329.0422 1.0233.1329 1.4899.3586a4 4 0 0 1 1.7305 1.6152c.2573.45.3815.933.4603 1.4617.0757.5078.1187 1.1316.1707 1.8853l.2257 3.2736c.0418.6051.0626.9076-.0195 1.0432s-.1695.1974-.3246.23-.4759-.1054-1.1174-.3815C20.2798 11.1878 19.4118 11 18.5 11h-13c-.9118 0-1.7798.1878-2.5674.5267-.6415.2761-.9623.4142-1.1174.3815-.155-.0326-.2424-.0945-.3246-.2301s-.0613-.438-.0195-1.0431l.2257-3.2736c.052-.7537.095-1.3775.1707-1.8853.0788-.5286.203-1.0116.4603-1.4617a4 4 0 0 1 1.7305-1.6152c.4666-.2257.957-.3164 1.4899-.3586C6.0599 2 6.6852 2 7.4407 2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 17.5037v-.0058a4.5 4.5 0 0 0-.0383-.5876C22.6729 14.7037 20.7854 13 18.5 13h-13c-2.2854 0-4.1728 1.7036-4.4617 3.9102A4.5 4.5 0 0 0 1 17.5C1 19.9853 3.0147 22 5.5 22h13c2.4841 0 4.498-2.0127 4.5-4.4963M12 16.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-6-.25c-.6904 0-1.25.5596-1.25 1.25s.5596 1.25 1.25 1.25 1.25-.5596 1.25-1.25-.5596-1.25-1.25-1.25"
      clipRule="evenodd"
    />
  </svg>
);

export const Server04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.199 1.5h9.6019c.7175 0 1.3127 0 1.8015.0377.5098.0394.9796.1239 1.431.333a4 4 0 0 1 1.7109 1.5104c.2635.422.4056.8776.5079 1.3787.0793.388-.3822.6668-.7328.4826C20.6172 4.7683 19.5899 4.5 18.5 4.5h-13c-1.09 0-2.1172.2683-3.0194.7424-.3506.1842-.812-.0946-.7328-.4826.1023-.5011.2443-.9568.5079-1.3787a4 4 0 0 1 1.7109-1.5104c.4514-.2091.9211-.2936 1.431-.333C5.8864 1.5 6.4816 1.5 7.199 1.5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.0126 10.6602A4.6 4.6 0 0 0 1 11c0 1.4136.6518 2.675 1.6713 3.5C1.6518 15.325 1 16.5864 1 18c0 2.4853 2.0147 4.5 4.5 4.5h13c2.4853 0 4.5-2.0147 4.5-4.5 0-1.4136-.6518-2.675-1.6713-3.5C22.3482 13.675 23 12.4136 23 11q0-.1716-.0126-.3399C22.8136 8.3336 20.8709 6.5 18.5 6.5h-13c-2.371 0-4.3137 1.8337-4.4874 4.1602M11 11c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1m0 7c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1M6 9.75c-.6904 0-1.25.5596-1.25 1.25s.5596 1.25 1.25 1.25 1.25-.5596 1.25-1.25S6.6904 9.75 6 9.75M4.75 18c0-.6904.5596-1.25 1.25-1.25s1.25.5596 1.25 1.25-.5596 1.25-1.25 1.25-1.25-.5596-1.25-1.25"
      clipRule="evenodd"
    />
  </svg>
);

export const Server05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 9c0 4.0796-3.0537 7.446-7 7.9381v.2326A3.009 3.009 0 0 1 14.8293 19H21c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6.1707c-.4118 1.1652-1.5231 2-2.8293 2s-2.4175-.8348-2.8293-2H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h6.1707A3.009 3.009 0 0 1 11 17.1707v-.2326C7.0537 16.446 4 13.0796 4 9c0-4.4183 3.5817-8 8-8s8 3.5817 8 8M6.083 10h2.1796a11.71 11.71 0 0 0 1.4594 4.5524C7.8347 13.7773 6.4299 12.068 6.083 10m8.1975 4.5514A11.71 11.71 0 0 0 15.7392 10h2.1778c-.3467 2.0671-1.7505 3.7759-3.6365 4.5514M17.917 8c-.3468-2.0671-1.7505-3.7758-3.6365-4.5514A11.71 11.71 0 0 1 15.7392 8zM9.7219 3.4476C7.8347 4.2227 6.4299 5.932 6.0829 8h2.1797A11.71 11.71 0 0 1 9.722 3.4476m2.279.1404A9.71 9.71 0 0 1 13.7259 8h-3.45a9.71 9.71 0 0 1 1.725-4.412m0 10.8239a9.71 9.71 0 0 1-1.725-4.412h3.45a9.71 9.71 0 0 1-1.725 4.412"
      clipRule="evenodd"
    />
  </svg>
);

export const Server06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 1C2.3432 1 1 2.3432 1 4s1.3432 3 3 3c.1876 0 .3713-.0172.5494-.0502C3.5714 8.3898 3 10.1282 3 12s.5714 3.6102 1.5494 5.0502A3 3 0 0 0 4 17c-1.6568 0-3 1.3431-3 3s1.3432 3 3 3 3-1.3431 3-3c0-.1877-.0172-.3713-.0502-.5494C8.3898 20.4286 10.1282 21 12 21s3.6102-.5714 5.0502-1.5494A3 3 0 0 0 17 20c0 1.6569 1.3431 3 3 3s3-1.3431 3-3-1.3431-3-3-3c-.1877 0-.3713.0172-.5494.0502C20.4286 15.6102 21 13.8718 21 12s-.5714-3.6102-1.5494-5.0502c.1781.033.3617.0502.5494.0502 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3432-3 3c0 .1876.0172.3713.0502.5494C15.6102 3.5714 13.8718 3 12 3s-3.6102.5714-5.0502 1.5494A3 3 0 0 0 7 4c0-1.6568-1.3431-3-3-3m1.0709 10c.3756-2.6257 2.2083-4.7813 4.6527-5.6215A13.24 13.24 0 0 0 7.8575 11zm4.6528 7.6216C7.2792 17.7814 5.4465 15.6257 5.0709 13h2.7866a13.24 13.24 0 0 0 1.8662 5.6216M18.929 13c-.3755 2.6252-2.2076 4.7806-4.6514 5.6211A13.24 13.24 0 0 0 16.1436 13zm-4.6513-7.621c2.4437.8405 4.2758 2.9958 4.6513 5.621h-2.7855a13.24 13.24 0 0 0-1.8658-5.621M14.1329 11a11.24 11.24 0 0 0-2.1324-5.4282A11.24 11.24 0 0 0 9.8681 11zm-4.2648 2a11.24 11.24 0 0 0 2.1324 5.4282A11.24 11.24 0 0 0 14.1329 13z"
      clipRule="evenodd"
    />
  </svg>
);

export const Terminal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.2929 4.2929c.3905-.3905 1.0237-.3905 1.4142 0l6 6c.3905.3905.3905 1.0237 0 1.4142l-6 6c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L8.5858 11l-5.293-5.2929c-.3904-.3905-.3904-1.0237 0-1.4142M11 19c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-8c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const TerminalBrowser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.7587 2h10.4826c.8049 0 1.4694 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642.0177.2169.0289.4343.0358.652.0172.542.0258.813-.0806 1.0339a1.02 1.02 0 0 1-.4384.4525C22.2553 8 21.9702 8 21.4 8H2.6c-.5702 0-.8553 0-1.0726-.1134a1.02 1.02 0 0 1-.4384-.4525C.9826 7.2133.9912 6.9422 1.0084 6.4c.007-.2176.018-.435.0358-.652.046-.562.1445-1.0787.3918-1.564A4 4 0 0 1 3.184 2.436c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 2 5.9538 2 6.7587 2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 11.6v4.6413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 22 18.0462 22 17.2412 22H6.7588c-.805 0-1.4694 0-2.0106-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 17.7106 1 17.0463 1 16.2413V11.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C1.76 10 2.04 10 2.6 10h18.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.494.109 1.054m-16.2929.6929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L7.0858 15.5l-1.793 1.7929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0l2.5-2.5c.3905-.3905.3905-1.0237 0-1.4142zM11 17c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const TerminalCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M7.7071 8.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L8.5858 12l-2.293 2.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0l3-3c.3905-.3905.3905-1.0237 0-1.4142zM13 14c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const TerminalSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M7.7071 8.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L8.5858 12l-2.293 2.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0l3-3c.3905-.3905.3905-1.0237 0-1.4142zM13 14c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Variable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.8025 2.557c-.2448-.495-.8445-.698-1.3396-.4532s-.698.8445-.4533 1.3396C20.2832 6.0197 21 8.9243 21 12.0002s-.7168 5.9806-1.9904 8.5569c-.2447.495-.0418 1.0948.4533 1.3396s1.0948.0418 1.3396-.4533C22.2095 18.5974 23 15.3901 23 12.0002s-.7906-6.5971-2.1975-9.4431M4.9904 3.4434c.2447-.4951.0418-1.0949-.4533-1.3396-.4951-.2448-1.0949-.0418-1.3396.4533C1.7905 5.403 1 8.6104 1 12.0002c0 3.3899.7905 6.5972 2.1975 9.4432.2447.4951.8445.698 1.3396.4533.495-.2448.698-.8446.4533-1.3396C3.7167 17.9808 3 15.0762 3 12.0002s.7167-5.9805 1.9904-8.5568M13.9986 8.7619A3.234 3.234 0 0 1 16.459 7.625h.0896c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.0896c-.3596 0-.7026.1579-.9385.4345l-2.3401 2.7444.7409 2.6068a.12.12 0 0 0 .1142.0893h1.3941c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1.3941c-.9497 0-1.7793-.6326-2.038-1.5425l-.3765-1.3247-1.4753 1.7303A3.233 3.233 0 0 1 7.6853 17.5h-.0897c-.5522 0-1-.4477-1-1s.4478-1 1-1h.0897c.3596 0 .7026-.1579.9385-.4345l2.3402-2.7446-.7409-2.6066a.12.12 0 0 0-.1142-.0893h-1.394c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.394c.9497 0 1.7794.6326 2.038 1.5425l.3765 1.3246z"
    />
  </svg>
);

export const ArrowBlockDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.7769 2Q12 2.001 14.2232 2c.1191 0 .2613 0 .3867.0101.1452.012.3532.0423.5711.1534.2823.1438.5117.3733.6555.6555.1111.218.1415.426.1534.5712.0102.1253.0102.2676.0101.3867V13h3a1.0001 1.0001 0 0 1 .7071 1.7071l-7 7c-.3905.3905-1.0237.3905-1.4142 0l-7-7A1 1 0 0 1 5 13h3V3.7769c0-.1191 0-.2614.0102-.3867.0118-.1452.0423-.3532.1533-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1534.1253-.0102.2676-.0101.3867-.01"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowBlockLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.3827 4.0762A1 1 0 0 1 11 5v3h9.2231c.1192 0 .2614 0 .3867.0102.1452.0118.3532.0423.5712.1533.2822.1438.5117.3733.6555.6555.1111.218.1415.426.1534.5712.0102.1253.0102.2676.0101.3867a4707 4707 0 0 0 0 4.4463c.0001.1191.0001.2613-.0101.3867-.0119.1452-.0423.3532-.1534.5711a1.5 1.5 0 0 1-.6555.6555c-.218.1111-.426.1415-.5712.1534-.1253.0102-.2676.0102-.3867.0101H11v3a1 1 0 0 1-1.7071.7071l-7-7c-.3905-.3905-.3905-1.0237 0-1.4142l7-7a1 1 0 0 1 1.0898-.2168"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowBlockRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.6173 4.0762a1 1 0 0 1 1.0898.2167l7 7c.3905.3905.3905 1.0237 0 1.4142l-7 7A1 1 0 0 1 13 19v-3c-3.0744 0-6.1487-.0011-9.2231 0-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.111-.2179-.1415-.4259-.1534-.5711-.0102-.1254-.0101-.2676-.01-.3867Q2.0008 12 2 9.7769c-.0001-.1191-.0002-.2614.01-.3867.012-.1452.0423-.3532.1534-.5712a1.5 1.5 0 0 1 .6555-.6555c.218-.111.426-.1415.5712-.1533C3.5155 7.9999 3.6578 8 3.7769 8 6.8513 8.0012 9.9256 8 13 8V5c0-.4044.2437-.769.6173-.9238"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowBlockUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.2929 2.2929c.3905-.3905 1.0237-.3905 1.4142 0l7 7A1 1 0 0 1 19 11h-3v9.2231c.0001.1191.0001.2614-.0101.3867-.0119.1452-.0423.3532-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.2179.1111-.4259.1415-.5711.1534-.1254.0102-.2676.0102-.3867.0101a4707 4707 0 0 0-4.4463 0c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.111-.218-.1415-.426-.1533-.5712C7.9999 20.4845 8 20.3423 8 20.2231V11H5a1 1 0 0 1-.707-1.7071z"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowCircleBrokenDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.2757 1.34c.4992-.1272.7488-.1908 1.0166-.109.2137.0653.4462.246.5623.437C11 1.9073 11 2.2034 11 2.7955v10.7903l-2.2929-2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0l4-4c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L13 13.5858V2.7955c0-.5921 0-.8882.1454-1.1275.1161-.191.3486-.3717.5623-.437.2678-.0818.5174-.0182 1.0166.109C19.4817 2.552 23 6.8652 23 12c0 6.0751-4.9249 11-11 11S1 18.0751 1 12C1 6.8652 4.5183 2.552 9.2757 1.34"
    />
  </svg>
);

export const ArrowCircleBrokenDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.6114 2.5359c.4429.263.6644.3945.7959.6418.1049.1973.1415.4894.0886.7066-.0664.272-.2758.4813-.6944.9l-7.6299 7.6299V9.1716c0-.5523-.4477-1-1-1s-1 .4477-1 1v5.6568c0 .5523.4477 1 1 1h5.6568c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3.2426l7.6299-7.6298c.4187-.4187.628-.628.9001-.6945.2171-.053.5092-.0163.7066.0886.2472.1315.3787.353.6417.7959 2.5069 4.2211 1.9449 9.7587-1.6859 13.3896-4.2958 4.2957-11.2606 4.2957-15.5564 0s-4.2957-11.2606 0-15.5564C7.8527.591 13.3903.029 17.6114 2.5358"
    />
  </svg>
);

export const ArrowCircleBrokenDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.5359 6.3886c.263-.443.3945-.6644.6418-.7959.1973-.1049.4894-.1415.7066-.0886.272.0664.4813.2758.9.6944l7.6299 7.6299H9.1716c-.5523 0-1 .4477-1 1s.4477 1 1 1h5.6568c.5523 0 1-.4477 1-1V9.1716c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.2426L6.1986 4.7843c-.4187-.4187-.628-.628-.6945-.9-.053-.2172-.0163-.5093.0886-.7067.1315-.2472.353-.3787.7959-.6417 4.2211-2.507 9.7587-1.945 13.3896 1.686 4.2957 4.2957 4.2957 11.2605 0 15.5563s-11.2606 4.2957-15.5564 0C.591 16.1473.029 10.6097 2.5358 6.3886"
    />
  </svg>
);

export const ArrowCircleBrokenLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.66 9.2757c.1272.4992.1908.7488.109 1.0166-.0654.2137-.246.4462-.437.5623C22.0927 11 21.7966 11 21.2045 11H10.4142l2.2929-2.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L10.4142 13h10.7903c.5921 0 .8882 0 1.1275.1454.191.1161.3716.3486.437.5623.0818.2678.0182.5174-.109 1.0166C21.4479 19.4817 17.1348 23 12 23 5.9249 23 1 18.0751 1 12S5.9249 1 12 1c5.1348 0 9.4479 3.5183 10.66 8.2757"
    />
  </svg>
);

export const ArrowCircleBrokenRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.3399 14.7243c-.1272-.4992-.1908-.7488-.109-1.0166.0654-.2137.246-.4462.437-.5623C1.9074 13 2.2034 13 2.7954 13h10.7903l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l4-4c.3906-.3905.3906-1.0237 0-1.4142l-4-4c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L13.5857 11H2.7954c-.592 0-.8881 0-1.1274-.1454-.191-.1161-.3717-.3486-.437-.5623-.0819-.2678-.0183-.5174.1089-1.0166C2.552 4.5183 6.865 1 11.9999 1c6.0752 0 11 4.9249 11 11s-4.9248 11-11 11c-5.1348 0-9.4479-3.5183-10.66-8.2757"
    />
  </svg>
);

export const ArrowCircleBrokenUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.7243 22.66c-.4992.1272-.7488.1908-1.0166.109-.2137-.0654-.4462-.246-.5623-.437C13 22.0927 13 21.7966 13 21.2045V10.4142l2.2929 2.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-4-4c-.3905-.3905-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L11 10.4142v10.7903c0 .5921 0 .8882-.1454 1.1275-.1161.191-.3486.3716-.5623.437-.2678.0818-.5174.0182-1.0166-.109C4.5183 21.4479 1 17.1348 1 12 1 5.9249 5.9249 1 12 1s11 4.9249 11 11c0 5.1348-3.5183 9.4479-8.2757 10.66"
    />
  </svg>
);

export const ArrowCircleBrokenUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.4641 17.6114c-.263.4429-.3945.6644-.6417.7959-.1974.1049-.4895.1415-.7066.0886-.2721-.0664-.4814-.2758-.9001-.6944l-7.6299-7.6299h3.2426c.5523 0 1-.4477 1-1s-.4477-1-1-1H9.1716c-.5523 0-1 .4477-1 1v5.6568c0 .5523.4477 1 1 1s1-.4477 1-1v-3.2426l7.6299 7.6299c.4186.4187.628.628.6944.9001.0529.2171.0163.5092-.0886.7066-.1315.2472-.353.3787-.7959.6417-4.2211 2.5069-9.7587 1.9449-13.3896-1.6859-4.2957-4.2958-4.2957-11.2606 0-15.5564s11.2606-4.2957 15.5564 0c3.6308 3.6309 4.1928 9.1685 1.6859 13.3896"
    />
  </svg>
);

export const ArrowCircleBrokenUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.3886 21.4641c-.443-.263-.6644-.3945-.7959-.6417-.1049-.1974-.1415-.4895-.0886-.7066.0664-.2721.2758-.4814.6944-.9001l7.6299-7.6299v3.2426c0 .5523.4477 1 1 1s1-.4477 1-1V9.1716c0-.5523-.4477-1-1-1H9.1716c-.5523 0-1 .4477-1 1s.4477 1 1 1h3.2426l-7.6299 7.6299c-.4187.4186-.628.628-.9.6944-.2172.0529-.5093.0163-.7067-.0886-.2472-.1315-.3787-.353-.6417-.7959-2.507-4.2211-1.945-9.7587 1.686-13.3896 4.2957-4.2957 11.2605-4.2957 15.5563 0s4.2957 11.2606 0 15.5564c-3.6309 3.6308-9.1685 4.1928-13.3896 1.6859"
    />
  </svg>
);

export const ArrowCircleDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m0 6c.5523 0 1 .4477 1 1v5.5858l2.2929-2.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L11 13.5858V8c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowCircleDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.7782 4.2218c-4.2958-4.2957-11.2606-4.2957-15.5564 0s-4.2957 11.2606 0 15.5564 11.2606 4.2957 15.5564 0 4.2957-11.2606 0-15.5564m-4.2427 4.2427c.3906.3905.3906 1.0237 0 1.4142l-3.9497 3.9497h3.2426c.5523 0 1 .4477 1 1s-.4477 1-1 1H9.1716c-.5523 0-1-.4477-1-1V9.1716c0-.5523.4477-1 1-1s1 .4477 1 1v3.2426l3.9497-3.9497c.3905-.3906 1.0237-.3906 1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowCircleDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.2218 4.2218c-4.2957 4.2958-4.2957 11.2606 0 15.5564s11.2606 4.2957 15.5564 0 4.2957-11.2606 0-15.5564-11.2606-4.2957-15.5564 0m4.2427 4.2427c.3905-.3906 1.0237-.3906 1.4142 0l3.9497 3.9497V9.1716c0-.5523.4477-1 1-1s1 .4477 1 1v5.6568c0 .5523-.4477 1-1 1H9.1716c-.5523 0-1-.4477-1-1s.4477-1 1-1h3.2426L8.4645 9.8787c-.3906-.3905-.3906-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowCircleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 12c0-6.0751-4.9249-11-11-11S1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11m-6 0c0 .5523-.4477 1-1 1h-5.5858l2.2929 2.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142l4-4c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142L10.4142 11H16c.5523 0 1 .4477 1 1"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowCircleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12c0 6.0751 4.9249 11 11 11s11-4.9249 11-11S18.0751 1 12 1 1 5.9249 1 12m6 0c0-.5523.4477-1 1-1h5.5858l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L13.5858 13H8c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowCircleUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 23c6.0751 0 11-4.9249 11-11S18.0751 1 12 1 1 5.9249 1 12s4.9249 11 11 11m0-6c-.5523 0-1-.4477-1-1v-5.5858l-2.2929 2.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l4-4c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 10.4142V16c0 .5523-.4477 1-1 1"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowCircleUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.7782 19.7782c4.2957-4.2958 4.2957-11.2606 0-15.5564s-11.2606-4.2957-15.5564 0-4.2957 11.2606 0 15.5564 11.2606 4.2957 15.5564 0m-4.2427-4.2427c-.3905.3906-1.0237.3906-1.4142 0l-3.9497-3.9497v3.2426c0 .5523-.4477 1-1 1s-1-.4477-1-1V9.1716c0-.5523.4477-1 1-1h5.6568c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3.2426l3.9497 3.9497c.3906.3905.3906 1.0237 0 1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowCircleUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.2218 19.7782c4.2958 4.2957 11.2606 4.2957 15.5564 0s4.2957-11.2606 0-15.5564-11.2606-4.2957-15.5564 0-4.2957 11.2606 0 15.5564m4.2427-4.2427c-.3906-.3905-.3906-1.0237 0-1.4142l3.9497-3.9497H9.1716c-.5523 0-1-.4477-1-1s.4477-1 1-1h5.6568c.5523 0 1 .4477 1 1v5.6568c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3.2426l-3.9497 3.9497c-.3905.3906-1.0237.3906-1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 5c0-.5523-.4477-1-1-1s-1 .4477-1 1v11.5858l-5.2929-5.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l7 7c.3905.3905 1.0237.3905 1.4142 0l7-7c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L13 16.5858z"
    />
  </svg>
);

export const ArrowDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m9.4142 16 8.2929-8.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L8 14.5858V7c0-.5523-.4477-1-1-1s-1 .4477-1 1v10c0 .5523.4477 1 1 1h10c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const ArrowDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7071 6.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L14.5858 16H7c-.5523 0-1 .4477-1 1s.4477 1 1 1h10c.5523 0 1-.4477 1-1V7c0-.5523-.4477-1-1-1s-1 .4477-1 1v7.5858z"
    />
  </svg>
);

export const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.7071 5.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-7 7c-.3905.3905-.3905 1.0237 0 1.4142l7 7c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L7.4142 13H19c.5523 0 1-.4477 1-1s-.4477-1-1-1H7.4142z"
    />
  </svg>
);

export const ArrowNarrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 4c0-.5523-.4477-1-1-1s-1 .4477-1 1v13.5858l-4.2929-4.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l6 6c.3905.3905 1.0237.3905 1.4142 0l6-6c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L13 17.5858z"
    />
  </svg>
);

export const ArrowNarrowDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.7071 6.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L7 15.5858V10c0-.5523-.4477-1-1-1s-1 .4477-1 1v8c0 .5523.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1H8.4142z"
    />
  </svg>
);

export const ArrowNarrowDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.7071 5.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L15.5858 17H10c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1v-8c0-.5523-.4477-1-1-1s-1 .4477-1 1v5.5858z"
    />
  </svg>
);

export const ArrowNarrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.7071 6.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-6 6c-.3905.3905-.3905 1.0237 0 1.4142l6 6c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L6.4142 13H20c.5523 0 1-.4477 1-1s-.4477-1-1-1H6.4142z"
    />
  </svg>
);

export const ArrowNarrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.7071 5.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 11H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h13.5858l-4.2929 4.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l6-6c.3905-.3905.3905-1.0237 0-1.4142z"
    />
  </svg>
);

export const ArrowNarrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.7071 3.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-6 6c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L11 6.4142V20c0 .5523.4477 1 1 1s1-.4477 1-1V6.4142l4.2929 4.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
    />
  </svg>
);

export const ArrowNarrowUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 5c-.5523 0-1 .4477-1 1v8c0 .5523.4477 1 1 1s1-.4477 1-1V8.4142l10.2929 10.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L8.4142 7H14c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const ArrowNarrowUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h5.5858L5.2928 17.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0L17 8.4142V14c0 .5523.4477 1 1 1s1-.4477 1-1V6c0-.5523-.4477-1-1-1z"
    />
  </svg>
);

export const ArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.7071 4.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L16.5858 11H5c-.5523 0-1 .4477-1 1s.4477 1 1 1h11.5858l-5.2929 5.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l7-7c.3905-.3905.3905-1.0237 0-1.4142z"
    />
  </svg>
);

export const ArrowSquareDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M12 7c.5523 0 1 .4477 1 1v5.5858l2.2929-2.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L11 13.5858V8c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowSquareDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2m-2.1314 7.7071L11.4142 14h3.586c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5522 0-1-.4477-1-1V9c0-.5523.4478-1 1-1s1 .4477 1 1v3.5855l4.2927-4.2926c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowSquareDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M8.2931 8.2929c.3906-.3905 1.0237-.3905 1.4142 0l4.2929 4.2929V9c0-.5523.4478-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1h-6c-.5522 0-1-.4477-1-1s.4478-1 1-1h3.5858L8.2931 9.7071c-.3905-.3905-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowSquareLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2m-5.1314 5.2929c.3905.3905.3905 1.0237 0 1.4142L10.4142 11H16c.5523 0 1 .4477 1 1s-.4477 1-1 1h-5.5858l2.2929 2.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142l4-4c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowSquareRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2m-6.5456 5.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L13.5858 13H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h5.5858l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowSquareUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2m-6.5456 5.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 10.4142V16c0 .5523-.4477 1-1 1s-1-.4477-1-1v-5.5858l-2.2929 2.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowSquareUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M8.0003 9c0-.5523.4477-1 1-1h5.9999c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3.586l4.2929 4.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-4.2927-4.2926V15c0 .5523-.4477 1-1 1s-1-.4477-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowSquareUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M8.0003 9c0-.5523.4477-1 1-1h5.9999c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3.586l-4.293 4.2931c-.3906.3905-1.0238.3905-1.4143 0s-.3905-1.0237 0-1.4142L12.5858 10H9.0002c-.5522 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.7071 4.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-7 7c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L11 7.4142V19c0 .5523.4477 1 1 1s1-.4477 1-1V7.4142l5.2929 5.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
    />
  </svg>
);

export const ArrowUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 6c-.5523 0-1 .4477-1 1v10c0 .5523.4477 1 1 1s1-.4477 1-1V9.4142l8.2929 8.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L9.4142 8H17c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const ArrowUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h7.5858l-8.293 8.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0L16 9.4142V17c0 .5523.4477 1 1 1s1-.4477 1-1V7c0-.5523-.4477-1-1-1z"
    />
  </svg>
);

export const ArrowsDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m6 17.5858-2.2929-2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0l4-4c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L8 17.5858V4c0-.5523-.4477-1-1-1s-1 .4477-1 1zM18 12.5858l2.2929-2.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L16 12.5858V4c0-.5523.4477-1 1-1s1 .4477 1 1z"
    />
  </svg>
);

export const ArrowsLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.7071 3.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L11.4142 8H20c.5523 0 1-.4477 1-1s-.4477-1-1-1h-8.5858zM6.4142 16l2.293-2.2929c.3904-.3905.3904-1.0237 0-1.4142-.3906-.3905-1.0238-.3905-1.4143 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L6.4142 18H20c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const ArrowsRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L12.5858 6H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h8.5858l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l4-4c.3905-.3905.3905-1.0237 0-1.4142zM3 17c0-.5523.4477-1 1-1h13.5858l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L17.5858 18H4c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const ArrowsTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.8072 2.0828a3 3 0 0 1 2.3856 0c.5339.2313.9206.6501 1.2516 1.0947.3258.4378.6843 1.0244 1.1143 1.7281l.995 1.6283.4804-1.7926c.1429-.5335.6912-.8501 1.2247-.7072.5335.143.8501.6913.7071 1.2248l-1.0981 4.098c-.1429.5335-.6912.8501-1.2247.7072L12.545 8.966c-.5334-.143-.85-.6913-.7071-1.2247.143-.5335.6913-.8501 1.2248-.7072l1.7374.4656-.9229-1.5102c-.4616-.7553-.7727-1.2624-1.0372-1.6177-.2657-.357-.3952-.4335-.4424-.454a1 1 0 0 0-.7952 0c-.0472.0205-.1767.097-.4425.454-.2645.3553-.5756.8624-1.0371 1.6177L9.1029 7.6583c-.288.4713-.9034.6199-1.3747.3319s-.6198-.9035-.3318-1.3748l1.0449-1.7098c.43-.7037.7884-1.2903 1.1143-1.728.331-.4447.7176-.8635 1.2516-1.0948M3.0964 13.6519l.959-1.5693-1.7966.4814c-.5334.1429-1.0818-.1736-1.2247-.7071-.143-.5335.1736-1.0818.707-1.2247l4.0982-1.0981a1 1 0 0 1 1.2247.7071l.006.0222q.0297.0819.0449.1677l1.0472 3.9082c.143.5334-.1737 1.0818-.7071 1.2247s-1.0818-.1736-1.2248-.7071l-.4652-1.7364-.9364 1.5323c-.4966.8127-.832 1.3635-1.043 1.7923-.214.4352-.2199.594-.2157.6421a1 1 0 0 0 .4024.7174c.0389.0287.1774.1065.6603.1508.476.0436 1.1208.0446 2.0732.0446H8.5c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.6566c-.8907 0-1.6283.0001-2.2067-.053-.582-.0534-1.1746-.1711-1.6652-.5332a3 3 0 0 1-1.2072-2.1523c-.0531-.6076.1555-1.1745.4134-1.699.2564-.5212.641-1.1506 1.1055-1.9106M19.8811 11.9786c-.288-.4713-.9035-.6198-1.3748-.3319-.4712.288-.6198.9035-.3318 1.3748l.9969 1.6313c.4967.8127.8321 1.3634 1.043 1.7923.214.4352.2199.594.2157.6421a1 1 0 0 1-.4024.7174c-.0388.0287-.1774.1064-.6603.1508-.4759.0436-1.1208.0446-2.0732.0446h-2.38l1.2929-1.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L14.9142 20h2.4292c.8907 0 1.6283.0001 2.2067-.053.5821-.0534 1.1746-.1711 1.6653-.5332a3 3 0 0 0 1.2071-2.1523c.0531-.6076-.1555-1.1745-.4134-1.699-.2563-.5212-.6409-1.1504-1.1053-1.9103z"
    />
  </svg>
);

export const ArrowsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7071 3.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L6 6.4142V20c0 .5523.4477 1 1 1s1-.4477 1-1V6.4142l2.2929 2.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143zM17.7071 8.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L16 11.4142V20c0 .5523.4477 1 1 1s1-.4477 1-1v-8.5858l2.2929 2.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
    />
  </svg>
);

export const ChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.2929 8.2929c.3905-.3905 1.0237-.3905 1.4142 0L12 13.5858l5.2929-5.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143l-6 6c-.3905.3905-1.0237.3905-1.4142 0l-6-6c-.3905-.3905-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronDownDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.2929 12.2929c.3905-.3905 1.0237-.3905 1.4142 0L12 16.5858l4.2929-4.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0l-5-5c-.3905-.3905-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.2929 5.2929c.3905-.3905 1.0237-.3905 1.4142 0L12 9.5858l4.2929-4.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143l-5 5c-.3905.3905-1.0237.3905-1.4142 0l-5-5c-.3905-.3905-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.7071 5.2929c.3905.3905.3905 1.0237 0 1.4142L10.4142 12l5.2929 5.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-6-6c-.3905-.3905-.3905-1.0237 0-1.4142l6-6c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronLeftDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.7071 6.2929c.3905.3905.3905 1.0237 0 1.4142L14.4142 12l4.2929 4.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-5-5c-.3905-.3905-.3905-1.0237 0-1.4142l5-5c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.7071 6.2929c.3905.3905.3905 1.0237 0 1.4142L7.4142 12l4.2929 4.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-5-5c-.3905-.3905-.3905-1.0237 0-1.4142l5-5c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.2929 5.2929c.3905-.3905 1.0237-.3905 1.4142 0l6 6c.3905.3905.3905 1.0237 0 1.4142l-6 6c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L13.5858 12l-5.293-5.2929c-.3904-.3905-.3904-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronRightDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L9.5858 12l-4.293-4.2929c-.3904-.3905-.3904-1.0237 0-1.4142"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L16.5858 12l-4.2929-4.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronSelectorHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.7071 6.2929c.3905.3905.3905 1.0237 0 1.4142L5.4142 12l4.293 4.2929c.3904.3905.3904 1.0237 0 1.4142-.3906.3905-1.0238.3905-1.4143 0l-5-5c-.3905-.3905-.3905-1.0237 0-1.4142l5-5c.3905-.3905 1.0237-.3905 1.4142 0M14.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 12l-4.2929-4.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronSelectorVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.2929 14.2929c.3905-.3905 1.0237-.3905 1.4142 0L12 18.5858l4.2929-4.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0l-5-5c-.3905-.3905-.3905-1.0237 0-1.4142M6.2929 9.7071c.3905.3905 1.0237.3905 1.4142 0L12 5.4142l4.2929 4.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143l-5-5c-.3905-.3905-1.0237-.3905-1.4142 0l-5 5c-.3905.3905-.3905 1.0237 0 1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.2929 8.2929c.3905-.3905 1.0237-.3905 1.4142 0l6 6c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 10.4142l-5.2929 5.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronUpDouble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.2929 12.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 14.4142l-4.2929 4.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.2929 5.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 7.4142l-4.2929 4.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const CornerDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 4c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.4c0 1.6967-.0008 2.909-.0784 3.8594-.0767.9386-.2234 1.5333-.4666 2.0106a5 5 0 0 1-2.185 2.185c-.4773.2432-1.072.3899-2.0106.4666C13.309 13.9992 12.0967 14 10.4 14H6.4142l3.293-3.2929c.3904-.3905.3904-1.0237 0-1.4142-.3906-.3905-1.0238-.3905-1.4143 0l-5 5c-.3905.3905-.3905 1.0237 0 1.4142l5 5c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L6.4142 16h4.0302c1.6425 0 2.9365 0 3.9778-.0851 1.0624-.0868 1.9495-.2671 2.7557-.6779a7 7 0 0 0 3.0591-3.0591c.4108-.8062.5911-1.6933.6779-2.7557C21 8.381 21 7.087 21 5.4444z"
    />
  </svg>
);

export const CornerDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 4c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.4444c0 1.6425 0 2.9365.085 3.9778.0869 1.0624.2672 1.9495.678 2.7557a7 7 0 0 0 3.059 3.0591c.8063.4108 1.6934.5911 2.7558.6779C10.619 16 11.913 16 13.5556 16h4.0302l-3.2929 3.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l5-5c.3905-.3905.3905-1.0237 0-1.4142l-5-5c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 14H13.6c-1.6967 0-2.909-.0008-3.8594-.0784-.9386-.0767-1.5333-.2234-2.0106-.4666a5 5 0 0 1-2.185-2.185c-.2432-.4773-.3899-1.072-.4666-2.0106C5.0008 8.309 5 7.0967 5 5.4z"
    />
  </svg>
);

export const CornerLeftDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 3h-3.4444c-1.6426 0-2.9365 0-3.9778.085-1.0624.0869-1.9495.2672-2.7557.678A7 7 0 0 0 7.763 6.822c-.4108.8063-.5911 1.6934-.678 2.7558C7 10.619 7 11.913 7 13.5556v4.0302l-3.2929-3.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l5 5c.3905.3905 1.0237.3905 1.4142 0l5-5c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L9 17.5858V13.6c0-1.6967.0008-2.909.0784-3.8594.0767-.9386.2234-1.5333.4666-2.0106a5 5 0 0 1 2.185-2.185c.4773-.2432 1.072-.3899 2.0106-.4666C14.691 5.0008 15.9033 5 17.6 5H21c.5523 0 1-.4477 1-1s-.4477-1-1-1"
    />
  </svg>
);

export const CornerLeftUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.7071 3.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-5 5c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L7 6.4142v4.0302c0 1.6426 0 2.9365.085 3.9778.0869 1.0624.2672 1.9495.678 2.7557a7 7 0 0 0 3.0591 3.0591c.8062.4108 1.6933.5911 2.7557.6779C14.6191 21 15.913 21 17.5554 21H21c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3.4c-1.6967 0-2.909-.0008-3.8594-.0784-.9386-.0767-1.5333-.2234-2.0106-.4666a5 5 0 0 1-2.185-2.185c-.2432-.4773-.3899-1.072-.4666-2.0106C9.0008 13.309 9 12.0967 9 10.4V6.4142l3.2929 3.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143z"
    />
  </svg>
);

export const CornerRightDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.4 5c1.6967 0 2.909.0008 3.8594.0784.9386.0767 1.5333.2234 2.0106.4666a5 5 0 0 1 2.185 2.185c.2432.4773.3899 1.072.4666 2.0106.0776.9504.0784 2.1627.0784 3.8594v3.9858l-3.2929-3.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l5 5c.3905.3905 1.0237.3905 1.4142 0l5-5c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L17 17.5858v-4.0302c0-1.6426 0-2.9365-.0851-3.9778-.0868-1.0624-.2671-1.9495-.6779-2.7557a7 7 0 0 0-3.0591-3.0591c-.8062-.4108-1.6933-.5911-2.7557-.678C9.3809 3 8.087 3 6.4444 3H3c-.5523 0-1 .4477-1 1s.4477 1 1 1z"
    />
  </svg>
);

export const CornerRightUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.7071 3.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-5 5c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L15 6.4142V10.4c0 1.6967-.0008 2.909-.0784 3.8594-.0767.9386-.2234 1.5333-.4666 2.0106a5 5 0 0 1-2.185 2.185c-.4773.2432-1.072.3899-2.0106.4666C9.309 18.9992 8.0967 19 6.4 19H3c-.5523 0-1 .4477-1 1s.4477 1 1 1h3.4445c1.6425 0 2.9364 0 3.9777-.0851 1.0624-.0868 1.9495-.2671 2.7557-.6779a7 7 0 0 0 3.0591-3.0591c.4108-.8062.5911-1.6933.6779-2.7557C17 13.3809 17 12.087 17 10.4444V6.4142l3.2929 3.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143z"
    />
  </svg>
);

export const CornerUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.7071 4.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-5 5c-.3905.3905-.3905 1.0237 0 1.4142l5 5c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L6.4142 10H10.4c1.6967 0 2.909.0008 3.8594.0784.9386.0767 1.5333.2234 2.0106.4666a5 5 0 0 1 2.185 2.185c.2432.4773.3899 1.072.4666 2.0106.0776.9504.0784 2.1627.0784 3.8594V20c0 .5523.4477 1 1 1s1-.4477 1-1v-1.4444c0-1.6426 0-2.9365-.0851-3.9778-.0868-1.0624-.2671-1.9495-.6779-2.7557a7 7 0 0 0-3.0591-3.0592c-.8062-.4107-1.6933-.591-2.7557-.6778C13.3809 8 12.087 8 10.4444 8H6.4142z"
    />
  </svg>
);

export const CornerUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.7071 3.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 8h-4.0302c-1.6426 0-2.9365 0-3.9778.085-1.0624.0869-1.9495.2672-2.7557.678A7 7 0 0 0 3.763 11.822c-.4108.8062-.5911 1.6933-.678 2.7557C3 15.6191 3 16.913 3 18.5556V20c0 .5523.4477 1 1 1s1-.4477 1-1v-1.4c0-1.6967.0008-2.909.0784-3.8594.0767-.9386.2234-1.5333.4666-2.0106a5 5 0 0 1 2.185-2.185c.4773-.2432 1.072-.3899 2.0106-.4666C10.691 10.0008 11.9033 10 13.6 10h3.9858l-3.2929 3.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l5-5c.3905-.3905.3905-1.0237 0-1.4142z"
    />
  </svg>
);

export const Expand01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-5.2929 5.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 4H15c-.5523 0-1-.4477-1-1M5.4142 20l5.2929-5.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L4 18.5858V15c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Expand02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142L5.4142 20H9c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1v-6c0-.5523.4477-1 1-1s1 .4477 1 1v3.5858L18.5858 4H15c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const Expand03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587V10c0 .5523.4477 1 1 1s1-.4477 1-1V7.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C6.3611 4.0008 6.9434 4 7.8 4H10c.5523 0 1-.4477 1-1s-.4477-1-1-1M22 14c0-.5523-.4477-1-1-1s-1 .4477-1 1v2.2c0 .8566-.0008 1.4389-.0376 1.889-.0358.4384-.1007.6626-.1804.819a2 2 0 0 1-.874.874c-.1564.0797-.3806.1446-.819.1804-.4501.0368-1.0324.0376-1.889.0376H14c-.5523 0-1 .4477-1 1s.4477 1 1 1h2.2413c.8049 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 17.7106 22 17.0463 22 16.2414zM15 4h3.5858l-4.2929 4.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L20 5.4142V9c0 .5523.4477 1 1 1s1-.4477 1-1V3c0-.5523-.4477-1-1-1h-6c-.5523 0-1 .4477-1 1s.4477 1 1 1M5.4142 20l4.293-4.2929c.3904-.3905.3904-1.0237 0-1.4142-.3906-.3905-1.0238-.3905-1.4143 0L4 18.5858V15c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Expand04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-4.2929 4.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143L18.5858 4H15c-.5523 0-1-.4477-1-1M10 3H7.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C3 6.1795 3 6.6343 3 7.1615V10c0 .5523.4477 1 1 1s1-.4477 1-1V7.2c0-.5766.0008-.9488.024-1.2322.0221-.2716.0598-.3723.085-.4218a1 1 0 0 1 .437-.437c.0495-.0252.1502-.0629.4218-.085C6.2512 5.0007 6.6234 5 7.2 5H10c.5523 0 1-.4477 1-1s-.4477-1-1-1M19 14v2.8c0 .5766-.0008.9488-.0239 1.2322-.0222.2716-.0599.3723-.0851.4218a1 1 0 0 1-.437.437c-.0495.0252-.1502.0629-.4218.0851-.2834.0231-.6556.0239-1.2322.0239H14c-.5523 0-1 .4477-1 1s.4477 1 1 1h2.8385c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C21 17.8205 21 17.3657 21 16.8385V14c0-.5523-.4477-1-1-1s-1 .4477-1 1M9.7071 15.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L4 18.5858V15c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1H5.4142z"
    />
  </svg>
);

export const Expand05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 4H5.4142l4.293 4.2929c.3904.3905.3904 1.0237 0 1.4142-.3906.3905-1.0238.3905-1.4143 0L4 5.4142V9c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-4.2929 4.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143L18.5858 4H15c-.5523 0-1-.4477-1-1M9.7071 15.7071 5.4142 20H9c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1v-6c0-.5523.4477-1 1-1s1 .4477 1 1v3.5858l4.2929-4.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142M20 18.5858V15c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1s.4477-1 1-1h3.5858l-4.2929-4.2929c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0z"
    />
  </svg>
);

export const Expand06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 4H5.4142l3.293 3.2929c.3904.3905.3904 1.0237 0 1.4142-.3906.3905-1.0238.3905-1.4143 0L4 5.4142V8c0 .5523-.4477 1-1 1s-1-.4477-1-1V3a1 1 0 0 1 1-1h5c.5523 0 1 .4477 1 1s-.4477 1-1 1M15 3c0-.5523.4477-1 1-1h5c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-3.2929 3.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143L18.5858 4H16c-.5523 0-1-.4477-1-1M8.7071 16.7071 5.4142 20H8c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1v-5c0-.5523.4477-1 1-1s1 .4477 1 1v2.5858l3.2929-3.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142M20 18.5858V16c0-.5523.4477-1 1-1s1 .4477 1 1v5a1 1 0 0 1-1 1h-5c-.5523 0-1-.4477-1-1s.4477-1 1-1h2.5858l-3.2929-3.2929c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0z"
    />
  </svg>
);

export const FlipBackward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7071 5.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L5.4142 10H16.5c1.933 0 3.5 1.567 3.5 3.5S18.433 17 16.5 17H12c-.5523 0-1 .4477-1 1s.4477 1 1 1h4.5c3.0376 0 5.5-2.4624 5.5-5.5S19.5376 8 16.5 8H5.4142z"
    />
  </svg>
);

export const FlipForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.7071 4.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L18.5858 8H7.5C4.4624 8 2 10.4624 2 13.5S4.4624 19 7.5 19H12c.5523 0 1-.4477 1-1s-.4477-1-1-1H7.5C5.567 17 4 15.433 4 13.5S5.567 10 7.5 10h11.0858l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l4-4c.3905-.3905.3905-1.0237 0-1.4142z"
    />
  </svg>
);

export const Infinity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.439 7c-1.4749 0-2.622.6591-3.3736 1.6428-.7306.956-1.0652 2.1812-1.0652 3.3572s.3346 2.4012 1.0652 3.3572C2.817 16.3409 3.964 17 5.439 17c2.8694 0 4.9037-1.7936 6.5611-3.5342C13.6575 15.2064 15.6919 17 18.5612 17c1.4749 0 2.622-.6591 3.3737-1.6428C22.6654 14.4012 23 13.176 23 12s-.3346-2.4011-1.0651-3.3572C21.1832 7.6591 20.0361 7 18.5612 7c-2.8694 0-4.9037 1.7936-6.5611 3.5343C10.3428 8.7936 8.3084 7 5.439 7m0 8c-.8176 0-1.39-.3409-1.7845-.8572-.4157-.544-.6543-1.3188-.6543-2.1428s.2386-1.5988.6543-2.1428C4.049 9.3409 4.6214 9 5.439 9c2.0393 0 3.5477 1.2728 5.192 3-1.6443 1.7272-3.1527 3-5.192 3m13.1222 0c.8177 0 1.39-.3409 1.7845-.8572C20.7614 13.5988 21 12.824 21 12s-.2386-1.5988-.6543-2.1428C19.9512 9.3409 19.3789 9 18.5612 9c-2.0393 0-3.5477 1.2728-5.192 3 1.6444 1.7272 3.1528 3 5.192 3"
      clipRule="evenodd"
    />
  </svg>
);

export const RefreshCcw01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.341 6.3451C7.79 4.8951 9.7896 4 12 4c4.4183 0 8 3.5817 8 8s-3.5817 8-8 8c-3.6457 0-6.7243-2.4395-7.6874-5.7773-.1532-.5306-.7075-.8366-1.238-.6835-.5307.1531-.8368.7074-.6836 1.2381C3.5944 18.9481 7.4395 22 11.9999 22c5.5228 0 10-4.4772 10-10s-4.4772-10-10-10C9.2375 2 6.7351 3.1214 4.9264 4.9314 4.2904 5.5679 3.6058 6.3577 3 7.0944V4c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1H4.0307c.6841-.8586 1.5461-1.8901 2.3104-2.6549"
    />
  </svg>
);

export const RefreshCcw02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.0711 4.929c-3.9052-3.9053-10.2369-3.9053-14.1421 0C4.1309 5.727 3.4997 6.3951 3 6.9535V4c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1H3.8743c.5122-.6172 1.2908-1.4787 2.4689-2.6569 3.1242-3.1241 8.1895-3.1241 11.3137 0 1.108 1.108 1.8218 2.4575 2.1441 3.8782.1222.5386.6579.8761 1.1965.7539s.8761-.6579.7539-1.1965c-.4034-1.7778-1.2977-3.4672-2.6803-4.8498M4.199 13.7787c-.1221-.5386-.6578-.8761-1.1964-.7539s-.8762.6578-.754 1.1964c.4034 1.7779 1.2978 3.4673 2.6804 4.8498 3.9052 3.9053 10.2368 3.9053 14.1421 0 .7978-.7977 1.429-1.4659 1.9289-2.0246V20c0 .5523.4477 1 1 1s1-.4477 1-1v-6c0-.5523-.4477-1-1-1h-6c-.5523 0-1 .4477-1 1s.4477 1 1 1h4.1257c-.5115.6164-1.2899 1.4779-2.4688 2.6568-3.1242 3.1242-8.1895 3.1242-11.3137 0-1.108-1.108-1.8218-2.4574-2.1441-3.8781"
    />
  </svg>
);

export const RefreshCcw03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.071 19.0711c3.9053-3.9052 3.9053-10.2369 0-14.1421-.7981-.7981-1.4663-1.4293-2.0247-1.929H20c.5523 0 1-.4477 1-1s-.4477-1-1-1h-6c-.5523 0-1 .4477-1 1v6c0 .5523.4477 1 1 1s1-.4477 1-1V3.8743c.6172.5122 1.4787 1.2908 2.6568 2.4689 3.1242 3.1242 3.1242 8.1895 0 11.3137-1.108 1.108-2.4574 1.8218-3.8781 2.1441-.5386.1222-.8761.6579-.7539 1.1965s.6578.8761 1.1964.7539c1.7779-.4034 3.4673-1.2977 4.8498-2.6803M10.2213 4.199c.5386-.1221.8761-.6578.7539-1.1964s-.6579-.8762-1.1965-.754C8.001 2.652 6.3115 3.5464 4.929 4.929c-3.9052 3.9052-3.9052 10.2368 0 14.1421.7978.7978 1.466 1.429 2.0247 1.9289H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1v-6c0-.5523-.4477-1-1-1s-1 .4477-1 1v4.1257c-.6164-.5115-1.478-1.2899-2.6569-2.4688-3.1241-3.1242-3.1241-8.1895 0-11.3137 1.108-1.108 2.4575-1.8218 3.8782-2.1441"
    />
  </svg>
);

export const RefreshCcw04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.2929.8929c.3905-.3906 1.0237-.3906 1.4142 0s.3905 1.0237 0 1.4142l-.2969.2969C17.9882 3.2852 21.5 7.2325 21.5 12c0 3.1587-1.5426 5.9572-3.9111 7.6828-.4464.3253-1.0719.227-1.3971-.2193-.3253-.4464-.227-1.0719.2193-1.3971C18.2853 16.701 19.5 14.4924 19.5 12c0-3.6442-2.5991-6.6813-6.0447-7.3589l.2518.2518c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142zM6.4112 4.3172c.4463-.3252 1.0718-.227 1.397.2194s.227 1.0719-.2194 1.397C5.7149 7.2992 4.5 9.5077 4.5 12c0 3.6443 2.5991 6.6814 6.0447 7.3589l-.2518-.2518c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0l2 2c.3905.3905.3905 1.0237 0 1.4142l-2 2c-.3905.3906-1.0237.3906-1.4142 0s-.3905-1.0237 0-1.4142l.2968-.2968C6.0118 20.7148 2.5 16.7675 2.5 12c0-3.1586 1.5426-5.9572 3.9112-7.6828"
    />
  </svg>
);

export const RefreshCcw05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.7656 6.7001c.5335.143.8501.6913.7071 1.2248-.1429.5334-.6913.85-1.2247.707l-.4056-.1086c1.699 4.3052.0365 9.3202-4.0923 11.704-2.7355 1.5793-5.9304 1.6426-8.6091.4542-.5048-.2239-.7325-.8147-.5086-1.3196.224-.5048.8148-.7325 1.3197-.5085 2.1195.9403 4.6395.888 6.798-.3582 3.156-1.8221 4.4867-5.5915 3.3507-8.9143l-.0922.344c-.1429.5334-.6913.85-1.2247.7071-.5335-.143-.8501-.6913-.7071-1.2248l.732-2.732c.1429-.5335.6913-.85 1.2248-.7071zM15.8592 3.3185c.5048.224.7325.8148.5085 1.3196-.2239.5049-.8147.7326-1.3196.5086-2.1195-.9403-4.6396-.888-6.798.3582-3.156 1.822-4.4867 5.5915-3.3507 8.9143l.0922-.344c.143-.5335.6913-.8501 1.2247-.7071.5335.1429.85.6913.7071 1.2247l-.732 2.7321c-.143.5334-.6913.85-1.2248.7071l-2.732-.7321c-.5335-.1429-.85-.6912-.7071-1.2247s.6913-.8501 1.2247-.7071l.4055.1086c-1.699-4.3052-.0364-9.3201 4.0924-11.7039 2.7355-1.5793 5.9303-1.6427 8.6091-.4543"
    />
  </svg>
);

export const RefreshCw01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.6589 6.3451C16.21 4.8951 14.2105 4 12.0001 4c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8c3.6457 0 6.7243-2.4395 7.6874-5.7773.1532-.5306.7075-.8366 1.2381-.6835s.8367.7074.6835 1.2381C20.4056 18.9481 16.5606 22 12.0001 22c-5.5228 0-10-4.4772-10-10s4.4772-10 10-10c2.7624 0 5.2648 1.1214 7.0735 2.9314.6361.6365 1.3206 1.4263 1.9264 2.163V4c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1s.4477-1 1-1h3.9693c-.6841-.8586-1.5461-1.8901-2.3104-2.6549"
    />
  </svg>
);

export const RefreshCw02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.9289 4.929c3.9052-3.9053 10.2369-3.9053 14.1421 0 .7981.798 1.4293 1.4662 1.929 2.0246V4c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1s.4477-1 1-1h4.1257c-.5122-.6172-1.2908-1.4787-2.4689-2.6569-3.1242-3.1241-8.1895-3.1241-11.3137 0-1.108 1.108-1.8217 2.4575-2.1441 3.8782-.1222.5386-.6579.8761-1.1965.7539s-.8761-.6579-.754-1.1965C2.652 8.001 3.5464 6.3115 4.929 4.929M19.8009 13.7787c.1222-.5386.6579-.8761 1.1965-.7539s.8762.6578.754 1.1964c-.4034 1.7779-1.2978 3.4673-2.6804 4.8498-3.9052 3.9053-10.2369 3.9053-14.142 0C4.131 18.2733 3.5 17.6051 3 17.0464V20c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H3.8743c.5115.6164 1.29 1.4779 2.4688 2.6568 3.1242 3.1242 8.1895 3.1242 11.3137 0 1.108-1.108 1.8218-2.4574 2.1441-3.8781"
    />
  </svg>
);

export const RefreshCw03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.929 19.0711c-3.9053-3.9052-3.9053-10.2369 0-14.1421C5.727 4.1309 6.3951 3.4997 6.9535 3H4c-.5523 0-1-.4477-1-1s.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V3.8743c-.6172.5122-1.4787 1.2908-2.6569 2.4689-3.1241 3.1242-3.1241 8.1895 0 11.3137 1.108 1.108 2.4575 1.8218 3.8782 2.1441.5386.1222.8761.6579.7539 1.1965s-.6579.8761-1.1965.7539c-1.7778-.4034-3.4672-1.2977-4.8498-2.6803M13.7787 4.199c-.5386-.1221-.8761-.6578-.7539-1.1964s.6578-.8762 1.1964-.754c1.7779.4034 3.4673 1.2978 4.8498 2.6804 3.9053 3.9052 3.9053 10.2368 0 14.1421-.7977.7978-1.4659 1.429-2.0246 1.9289H20c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1v-6c0-.5523.4477-1 1-1s1 .4477 1 1v4.1257c.6164-.5115 1.4779-1.2899 2.6568-2.4688 3.1242-3.1242 3.1242-8.1895 0-11.3137-1.108-1.108-2.4574-1.8218-3.8781-2.1441"
    />
  </svg>
);

export const RefreshCw04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.7071.8929c-.3905-.3906-1.0237-.3906-1.4142 0s-.3905 1.0237 0 1.4142l.2969.2969C6.0118 3.2852 2.5 7.2325 2.5 12c0 3.1587 1.5426 5.9572 3.9112 7.6828.4463.3253 1.0718.227 1.397-.2193s.227-1.0719-.2194-1.3971C5.7149 16.701 4.5 14.4924 4.5 12c0-3.6442 2.599-6.6813 6.0447-7.3589l-.2518.2518c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l2-2c.3905-.3905.3905-1.0237 0-1.4142zM17.5889 4.3172c-.4464-.3252-1.0719-.227-1.3971.2194-.3253.4464-.227 1.0719.2193 1.397C18.2853 7.2992 19.5 9.5077 19.5 12c0 3.6443-2.5991 6.6814-6.0447 7.3589l.2518-.2518c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-2 2c-.3905.3905-.3905 1.0237 0 1.4142l2 2c.3905.3906 1.0237.3906 1.4142 0s.3905-1.0237 0-1.4142l-.2968-.2968C17.9882 20.7148 21.5 16.7675 21.5 12c0-3.1586-1.5426-5.9572-3.9111-7.6828"
    />
  </svg>
);

export const RefreshCw05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.4727 6.1928c.143-.5335-.1736-1.0818-.7071-1.2248s-1.0818.1737-1.2247.7071l-.1087.4056c-2.8789-3.624-8.0533-4.6917-12.1821-2.308-2.7355 1.5794-4.3878 4.3146-4.698 7.2286-.0584.5492.3394 1.0418.8886 1.1003s1.0418-.3394 1.1002-.8886c.2454-2.3057 1.5507-4.462 3.7092-5.7082 3.156-1.822 7.0858-1.0898 9.3953 1.5554l-.3439-.0922c-.5335-.143-1.0818.1737-1.2247.7071-.143.5335.1736 1.0819.7071 1.2248l2.732.732c.5335.143 1.0818-.1736 1.2248-.707zM21.448 12.9987c.0585-.5492-.3393-1.0418-.8885-1.1002s-1.0418.3393-1.1002.8885c-.2455 2.3057-1.5508 4.462-3.7092 5.7082-3.156 1.8221-7.0858 1.0898-9.3954-1.5554l.344.0922c.5335.1429 1.0818-.1737 1.2247-.7071.143-.5335-.1736-1.0818-.707-1.2248l-2.7321-.732c-.5335-.143-1.0818.1736-1.2248.7071l-.732 2.732c-.143.5335.1736 1.0818.707 1.2248.5336.1429 1.0819-.1737 1.2248-.7071l.1087-.4055c2.879 3.6239 8.0533 4.6916 12.1821 2.3079 2.7355-1.5794 4.3877-4.3145 4.6979-7.2286"
    />
  </svg>
);

export const ReverseLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.7071 3.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L6.4142 8H14c2.7614 0 5 2.2386 5 5s-2.2386 5-5 5H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h10c3.866 0 7-3.134 7-7s-3.134-7-7-7H6.4142z"
    />
  </svg>
);

export const ReverseRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 6H10c-3.866 0-7 3.134-7 7s3.134 7 7 7h10c.5523 0 1-.4477 1-1s-.4477-1-1-1H10c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5h7.5858l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l4-4c.3905-.3905.3905-1.0237 0-1.4142z"
    />
  </svg>
);

export const SwitchHorizontal01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 6H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h13.5858l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l4-4c.3905-.3905.3905-1.0237 0-1.4142zM8.7071 13.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L6.4142 18H20c.5523 0 1-.4477 1-1s-.4477-1-1-1H6.4142z"
    />
  </svg>
);

export const SwitchHorizontal02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.7071 3.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L6.4142 8H20c.5523 0 1-.4477 1-1s-.4477-1-1-1H6.4142zM16.7071 12.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 16H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h13.5858l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l4-4c.3905-.3905.3905-1.0237 0-1.4142z"
    />
  </svg>
);

export const SwitchVertical01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7071 3.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L6 6.4142V20c0 .5523.4477 1 1 1s1-.4477 1-1V6.4142l2.2929 2.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143zM18 17.5858V4c0-.5523-.4477-1-1-1s-1 .4477-1 1v13.5858l-2.2929-2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0l4-4c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0z"
    />
  </svg>
);

export const SwitchVertical02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.7071 3.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L16 6.4142V20c0 .5523.4477 1 1 1s1-.4477 1-1V6.4142l2.2929 2.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143zM8 4c0-.5523-.4477-1-1-1s-1 .4477-1 1v13.5858l-2.2929-2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0l4-4c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L8 17.5858z"
    />
  </svg>
);

export const Bank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.8253 2.032a2 2 0 0 1 .3494 0c.1337.0118.2613.0403.3625.063l7.4535 1.6563c.2004.0445.3996.0888.568.1394.188.0565.402.1386.6104.2888.2943.212.5255.5001.6686.8335.1014.236.1351.4627.1495.6584.0129.1754.0128.3795.0128.5848v1.1759c0 .2523.0001.498-.0169.7061-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.201A4 4 0 0 1 20 9.9919v6.0164a4 4 0 0 1 .1382.0088c.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.208.0169.4539.0169.7062v.8641c0 .2523.0001.4981-.0169.7061-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169H4.5681c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C2 19.9301 2 19.6843 2 19.4319v-.8638c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201A4 4 0 0 1 4 16.0082V9.9918a4 4 0 0 1-.1382-.0087c-.2286-.0187-.4984-.0628-.7698-.201a2 2 0 0 1-.874-.8741c-.1383-.2714-.1824-.5412-.201-.7698C2 7.9302 2 7.6843 2 7.432V6.2562c0-.2053 0-.4094.0128-.5848.0144-.1958.0481-.4224.1495-.6584a2 2 0 0 1 .6686-.8335c.2085-.1502.4224-.2323.6104-.2888.1684-.0506.3676-.0949.568-.1394l7.4535-1.6563c.1013-.0227.2288-.0512.3625-.063M6 10v6h2.5v-6zm4.5 0v6h3v-6zm5 0v6H18v-6z"
      clipRule="evenodd"
    />
  </svg>
);

export const BankNote01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 10.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 3c-2.163 0-4.0384.5425-5.6691 1.0442l-.3045.094C9.4858 4.6136 8.2346 5 7 5a12.44 12.44 0 0 1-2.3435-.2222l-.0314-.006c-.4881-.0938-.898-.1726-1.2166-.2147-.2795-.037-.6936-.0809-1.0724.0524-.1985.0699-.4132.1695-.6161.3372-.203.1677-.3414.3597-.4474.5415-.1948.3338-.2354.7122-.2534.9828C1 6.7609 1 7.1296 1 7.555v10.7957c0 .1971-.0001.4312.119.7609.059.1638.1565.3218.2127.4081s.1616.2392.2875.3594c.0814.0777.1743.1599.2855.2329.109.0715.2084.115.2517.134l.0079.0035C2.9841 20.6111 4.4545 21 7 21c2.163 0 4.0384-.5425 5.6691-1.0442l.3045-.0939C14.5142 19.3863 15.7654 19 17 19c.8858 0 1.6772.0942 2.3435.2222l.0315.006c.4881.0938.898.1726 1.2165.2147.2795.0369.6937.0809 1.0724-.0524.1985-.0699.4132-.1695.6162-.3372s.3413-.3597.4473-.5415c.1948-.3338.2354-.7122.2534-.9828C23 17.2391 23 16.8704 23 16.445V5.6493c.0001-.1971.0001-.4312-.1189-.761-.0592-.1637-.1566-.3217-.2128-.408s-.1615-.2392-.2875-.3594c-.0814-.0777-.1743-.1599-.2855-.2329-.109-.0715-.2084-.115-.2517-.134l-.0079-.0035C21.016 3.3889 19.5455 3 17 3m2 6c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1zM8.5 12c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5M6 10c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BankNote02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 10.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.1615 4h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 7.1795 23 7.6343 23 8.1614v7.6772c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 20 19.3657 20 18.8386 20H5.1613c-.527 0-.9818 0-1.3563-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 16.8205 1 16.3657 1 15.8386V8.1614c0-.5271 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 4 4.6343 4 5.1615 4M8.5 12c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5M6 9c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1m13 1c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const BankNote03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.1615 4h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 7.1795 23 7.6343 23 8.1614v7.6772c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 20 19.3657 20 18.8386 20H5.1613c-.527 0-.9818 0-1.3563-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 16.8205 1 16.3657 1 15.8386V8.1614c0-.5271 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 4 4.6343 4 5.1615 4M12 7c.5523 0 1 .4477 1 1h1c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2.5a.5.5 0 0 0 0 1h1c1.3807 0 2.5 1.1193 2.5 2.5 0 1.2095-.8589 2.2184-2 2.45V16c0 .5523-.4477 1-1 1s-1-.4477-1-1h-1c-.5523 0-1-.4477-1-1s.4477-1 1-1h2.5a.5.5 0 0 0 0-1h-1C10.1193 13 9 11.8807 9 10.5c0-1.2095.8589-2.2184 2-2.45V8c0-.5523.4477-1 1-1m4.5 5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5m-12 0c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Coins01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.2027 7.2027C3.6499 8.0183 1 11.1997 1 15c0 4.4183 3.5817 8 8 8 3.8003 0 6.9817-2.6499 7.7973-6.2027A8.03 8.03 0 0 0 17 15c0-4.4183-3.5817-8-8-8-.618 0-1.2196.07-1.7973.2027"
    />
    <path
      fill="currentColor"
      d="M8.0444 5.045C8.3589 5.0154 8.6777 5 9 5c5.5228 0 10 4.4772 10 10q-.0002.4837-.0451.9556C21.371 14.5789 23 11.9797 23 9c0-4.4183-3.5817-8-8-8-2.9797 0-5.579 1.629-6.9556 4.045"
    />
  </svg>
);

export const Coins02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 5q-.4837.0001-.9556.045C9.421 2.629 12.0203 1 15 1c4.4183 0 8 3.5817 8 8 0 2.9797-1.629 5.5789-4.0451 6.9556A10.1 10.1 0 0 0 19 15C19 9.4772 14.5228 5 9 5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 15c0-3.8003 2.6499-6.9817 6.2027-7.7973A8.03 8.03 0 0 1 9 7c4.4183 0 8 3.5817 8 8 0 .618-.0701 1.2196-.2027 1.7973C15.9817 20.3501 12.8003 23 9 23c-4.4183 0-8-3.5817-8-8m8.4719-3.8817A1 1 0 0 1 10 12v4.5h.5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3c-.5523 0-1-.4477-1-1s.4477-1 1-1H8v-2.6339c-.453.2621-1.0377.1301-1.332-.3114-.3064-.4595-.1822-1.0804.2773-1.3867l1.5-1a1 1 0 0 1 1.0266-.0497"
      clipRule="evenodd"
    />
  </svg>
);

export const Coins03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.2027 7.2027C3.6499 8.0183 1 11.1997 1 15c0 4.4183 3.5817 8 8 8 3.8003 0 6.9817-2.6499 7.7973-6.2027A8.03 8.03 0 0 0 17 15c0-4.4183-3.5817-8-8-8-.618 0-1.2196.07-1.7973.2027"
    />
    <path
      fill="currentColor"
      d="M8.0444 5.045C8.3589 5.0154 8.6777 5 9 5c5.5228 0 10 4.4772 10 10q-.0002.4837-.0451.9556C21.371 14.5789 23 11.9797 23 9c0-4.4183-3.5817-8-8-8-2.9797 0-5.579 1.629-6.9556 4.045"
    />
  </svg>
);

export const Coins04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 5q-.4837.0001-.9556.045C9.421 2.629 12.0203 1 15 1c4.4183 0 8 3.5817 8 8 0 2.9797-1.629 5.5789-4.0451 6.9556A10.1 10.1 0 0 0 19 15C19 9.4772 14.5228 5 9 5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 15c0-3.8003 2.6499-6.9817 6.2027-7.7973A8.03 8.03 0 0 1 9 7c4.4183 0 8 3.5817 8 8 0 .618-.0701 1.2196-.2027 1.7973C15.9817 20.3501 12.8003 23 9 23c-4.4183 0-8-3.5817-8-8m8.4719-3.8817A1 1 0 0 1 10 12v4.5h.5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3c-.5523 0-1-.4477-1-1s.4477-1 1-1H8v-2.6339c-.453.2621-1.0377.1301-1.332-.3114-.3064-.4595-.1822-1.0804.2773-1.3867l1.5-1a1 1 0 0 1 1.0266-.0497"
      clipRule="evenodd"
    />
  </svg>
);

export const CoinsHand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.4999 2c-2.4852 0-4.5 2.0147-4.5 4.5 0 2.4852 2.0148 4.5 4.5 4.5 2.4853 0 4.5-2.0148 4.5-4.5 0-2.4853-2.0147-4.5-4.5-4.5M12.0317 1.7793C10.7805 2.964 10 4.6408 10 6.5c0 1.197.3236 2.3186.8881 3.2818A4.5 4.5 0 0 1 9.5 10C7.0147 10 5 7.9852 5 5.5 5 3.0147 7.0147 1 9.5 1c.9388 0 1.8105.2875 2.5317.7793M17.7088 15.8932c0 .7913-.5234 1.4606-1.2448 1.6843l.4639-.0215c.5069 0 .9999-.1595 1.405-.4556l2.8289-2.0639c.706-.5148 1.6942-.4465 2.3183.1606.6932.6743.6932 1.7666 0 2.4397l-2.4272 2.3612c-.6534.6355-1.487 1.0695-2.3933 1.246l-3.4307.6675a4.81 4.81 0 0 1-2.0549-.0479l-3.1029-.754a4.76 4.76 0 0 0-1.1345-.1366c-.4065 0-.6098 0-.7728-.0583a1 1 0 0 1-.6056-.6055C7.5 20.1461 7.5 19.9429 7.5 19.5364v-3.4292c0-.2858 0-.4287.0367-.5604a1 1 0 0 1 .1577-.324c.081-.1102.1934-.1983.4184-.3747l1.1856-.9295s1.9647-.9187 3.0501-.9187c.4496 0 .8969.0548 1.3337.163l2.6836.6672c.7892.1956 1.343.9012 1.343 1.7104z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.4735 12.9999h.053c.21 0 .4146 0 .5887.0119.1904.013.4161.0434.6502.1404a2 2 0 0 1 1.0823 1.0824c.097.234.1275.4597.1404.6501.012.1741.0119.3787.0119.5887v5.053c0 .21 0 .4146-.0119.5887-.013.1904-.0434.4161-.1404.6502-.203.49-.5923.8794-1.0823 1.0823-.234.097-.4598.1275-.6502.1405-.174.0118-.3787.0118-.5887.0118h-.053c-.21 0-.4147 0-.5887-.0118-.1904-.013-.4161-.0435-.6502-.1405a2 2 0 0 1-1.0824-1.0823c-.0969-.2341-.1274-.4598-.1404-.6502C1 20.941 1 20.7364 1 20.5264v-5.053c0-.21 0-.4146.0118-.5887.013-.1904.0435-.4161.1404-.6501a2 2 0 0 1 1.0824-1.0824c.234-.097.4598-.1274.6502-.1404.174-.0119.3787-.0119.5887-.0119"
      clipRule="evenodd"
    />
  </svg>
);

export const CoinsStacked01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.7979 21.1334c.5102-.1245 1.0009-.2848 1.4377-.4859C13.3323 22.0778 15.0584 23 17 23c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6c-1.0929 0-2.1175.2922-3 .8027v-1.1053a.1974.1974 0 0 0-.1974-.1974.208.208 0 0 0-.1679.0887c-.1238.1723-.2681.3218-.415.4481-.403.3464-.9276.6131-1.4889.8172C10.6 12.2652 9.104 12.5 7.5 12.5s-3.1-.2348-4.2308-.646c-.5613-.2041-1.086-.4708-1.489-.8172-.1468-.1263-.291-.2758-.4149-.4481a.208.208 0 0 0-.1679-.0887.1974.1974 0 0 0-.1974.1974V13c0 .6772.3806 1.1931.7803 1.5368.403.3464.9276.6131 1.4889.8172C4.4 15.7652 5.896 16 7.5 16s3.1-.2348 4.2308-.646c.5613-.2041 1.0859-.4708 1.4889-.8172.1469-.1263.2912-.2758.415-.4481A.208.208 0 0 1 13.8026 14c.109 0 .1974.0884.1974.1974V15c0 .6772-.3806 1.1931-.7803 1.5368-.403.3464-.9276.6131-1.4889.8172C10.6 17.7652 9.104 18 7.5 18s-3.1-.2348-4.2308-.646c-.5613-.2041-1.086-.4708-1.489-.8172-.1513-.1301-.302-.2952-.4198-.4529A.205.205 0 0 0 1.1971 16a.1964.1964 0 0 0-.1962.1992C1.011 16.9659 1 17.7334 1 18.5c0 .6772.3806 1.1931.7803 1.5368.403.3464.9276.6131 1.4889.8172C4.4 21.2652 5.896 21.5 7.5 21.5c1.2021 0 2.3356-.1318 3.2979-.3666"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 7.5V5c0-.6772.3806-1.1931.7803-1.5368.3778-.3248.8625-.5794 1.384-.7782a7 7 0 0 1 .1049-.039C4.4 2.2348 5.896 2 7.5 2s3.1.2348 4.2308.646c.5613.2041 1.0859.4708 1.4889.8172C13.6194 3.807 14 4.3228 14 5v2.5c0 .6773-.3806 1.1931-.7803 1.5368-.403.3464-.9276.6131-1.4889.8172C10.6 10.2652 9.104 10.5 7.5 10.5s-3.1-.2348-4.2308-.646c-.5613-.2041-1.086-.4708-1.489-.8172C1.3807 8.693 1 8.1773 1 7.5"
      clipRule="evenodd"
    />
  </svg>
);

export const CoinsStacked02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 2c-1.604 0-3.1.2348-4.2308.646q-.0526.0191-.1048.039c-.5216.1987-1.0063.4534-1.3841.7782C1.3806 3.807 1 4.3228 1 5v1.5c0 .6772.3806 1.1931.7803 1.5368.403.3464.9276.6131 1.4889.8172C4.4 9.2652 5.896 9.5 7.5 9.5s3.1-.2348 4.2308-.646c.5613-.2041 1.0859-.4708 1.4889-.8172C13.6194 7.693 14 7.1773 14 6.5V5c0-.6772-.3806-1.1931-.7803-1.5368-.403-.3464-.9276-.6131-1.4889-.8172C10.6 2.2348 9.104 2 7.5 2"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 8.2024c-.6356.1083-1.2204.258-1.7308.4436-.5613.2041-1.0859.4708-1.4889.8172C10.3806 9.807 10 10.3228 10 11c0 .1014.0085.1993.0244.2935-.779.1343-1.6351.2065-2.5244.2065-1.604 0-3.1-.2348-4.2308-.646-.5809-.2112-1.1157-.4829-1.5309-.854a2.8 2.8 0 0 1-.3822-.4182A.2.2 0 0 0 1.197 9.5a.193.193 0 0 0-.1924.197C1.0156 10.2973 1 10.8997 1 11.5c0 .6772.3806 1.1931.7803 1.5368.403.3464.9276.6131 1.4889.8172C4.4 14.2652 5.896 14.5 7.5 14.5c.8548 0 1.679-.0667 2.4334-.1912.0236-.0039.0353-.0058.0442-.0117a.05.05 0 0 0 .018-.0212C10 14.2661 10 14.2541 10 14.2301v-.3785a.1016.1016 0 0 1 .1016-.1016.105.105 0 0 1 .0933.0585c.1482.2944.3639.5378.5854.7283.403.3464.9276.6131 1.4889.8172C13.4 15.7652 14.896 16 16.5 16s3.1-.2348 4.2308-.646c.5613-.2041 1.0859-.4708 1.4889-.8172C22.6194 14.1931 23 13.6772 23 13v-2c0-.6772-.3806-1.1931-.7803-1.5368-.403-.3464-.9276-.6131-1.4889-.8172C19.6 8.2348 18.104 8 16.5 8c-.88 0-1.7275.0707-2.5.2024"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M22.8026 16a.208.208 0 0 0-.1679.0887c-.1238.1723-.2681.3218-.415.4481-.403.3464-.9276.6131-1.4889.8172C19.6 17.7652 18.104 18 16.5 18s-3.1-.2348-4.2308-.646c-.5613-.2041-1.0859-.4708-1.4889-.8172-.1469-.1263-.2912-.2758-.415-.4481A.208.208 0 0 0 10.1974 16a.1974.1974 0 0 0-.1974.1974v.1002c-.7725.1317-1.62.2024-2.5.2024-1.604 0-3.1-.2348-4.2308-.646-.5613-.2041-1.086-.4708-1.489-.8172-.1468-.1263-.291-.2758-.4149-.4481a.208.208 0 0 0-.1679-.0887.1974.1974 0 0 0-.1974.1974V17c0 .6772.3806 1.1931.7803 1.5368.403.3464.9276.6131 1.4889.8172C4.4 19.7652 5.896 20 7.5 20c.9493 0 1.858-.0822 2.6744-.2334.1484.3133.3739.5708.6059.7702.403.3464.9276.6131 1.4889.8172C13.4 21.7652 14.896 22 16.5 22s3.1-.2348 4.2308-.646c.5613-.2041 1.0859-.4708 1.4889-.8172C22.6194 20.1931 23 19.6772 23 19v-2.8026A.1974.1974 0 0 0 22.8026 16"
    />
  </svg>
);

export const CoinsStacked03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 2c-1.604 0-3.1.2348-4.2308.646q-.0526.0191-.1048.039c-.5216.1987-1.0063.4534-1.3841.7782C1.3806 3.807 1 4.3228 1 5v1.5c0 .6772.3806 1.1931.7803 1.5368.403.3464.9276.6131 1.4889.8172C4.4 9.2652 5.896 9.5 7.5 9.5c.2321 0 .462-.005.6888-.0146.1399-.006.2099-.009.2726-.0286a.46.46 0 0 0 .154-.0798c.0522-.0399.1054-.109.212-.2472a4.66 4.66 0 0 1 .649-.6831c.6523-.5608 1.4207-.9299 2.1093-1.1803.5324-.1936 1.1182-.3507 1.7338-.4711.2529-.0495.3793-.0742.4655-.134a.484.484 0 0 0 .1729-.21C14 6.3553 14 6.233 14 5.9884V5c0-.6772-.3806-1.1931-.7803-1.5368-.403-.3464-.9276-.6131-1.4889-.8172C10.6 2.2348 9.104 2 7.5 2"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M7.9994 11.9924c.0002-.2735-.2259-.4924-.4994-.4924-1.604 0-3.1-.2348-4.2308-.646-.5613-.2041-1.086-.4708-1.489-.8172-.1468-.1263-.291-.2759-.4149-.4481-.039-.0544-.101-.0887-.1679-.0887A.1974.1974 0 0 0 1 9.6974V11.5c0 .6772.3806 1.1931.7803 1.5368.403.3464.9276.6131 1.4889.8172C4.4 14.2652 5.896 14.5 7.5 14.5l.0122-.0002c.2607-.0064.4812-.227.4875-.4877L8 13.9923c-.0003-.6666-.001-1.3333-.0005-1.9999M8 16.9924c0-.2736-.2263-.4924-.5-.4924-1.604 0-3.1-.2348-4.2308-.646-.5613-.2041-1.086-.4708-1.489-.8172-.1468-.1263-.291-.2758-.4149-.4481a.208.208 0 0 0-.1679-.0887.1974.1974 0 0 0-.1974.1974V17c0 .6772.3806 1.1931.7803 1.5368.403.3464.9276.6131 1.4889.8172C4.4 19.7652 5.896 20 7.5 20h.0295c.32-.001.5259-.2276.4963-.5463l-.0083-.0855A3.9 3.9 0 0 1 8 19z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.2071 8.1688C14.923 8.0587 15.698 8 16.5 8c1.604 0 3.1.2348 4.2308.646q.0526.019.1048.039c.5216.1987 1.0063.4534 1.3841.7782C22.6194 9.807 23 10.3228 23 11v2c0 .6772-.3806 1.1931-.7803 1.5368-.403.3464-.9276.6131-1.4889.8172C19.6 15.7652 18.104 16 16.5 16s-3.1-.2348-4.2308-.646c-.5613-.2041-1.0859-.4708-1.4889-.8172C10.3806 14.1931 10 13.6772 10 13v-2c0-.6772.3806-1.1931.7803-1.5368.403-.3464.9276-.6131 1.4889-.8172a8 8 0 0 1 .2162-.075c.4571-.1513.967-.2753 1.5146-.3686a13 13 0 0 1 .2071-.0336"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10.1974 16a.1974.1974 0 0 0-.1974.1974V18.5c0 .6772.3806 1.1931.7803 1.5368.403.3464.9276.6131 1.4889.8172 1.1308.4112 2.6268.646 4.2308.646s3.1-.2348 4.2308-.646c.5613-.2041 1.0859-.4708 1.4889-.8172.3997-.3437.7803-.8596.7803-1.5368v-2.3026A.1974.1974 0 0 0 22.8026 16a.208.208 0 0 0-.1679.0887c-.1238.1723-.2681.3218-.415.4481-.403.3464-.9276.6131-1.4889.8172C19.6 17.7652 18.104 18 16.5 18s-3.1-.2348-4.2308-.646c-.5613-.2041-1.0859-.4708-1.4889-.8172-.1469-.1263-.2912-.2758-.415-.4481A.208.208 0 0 0 10.1974 16"
    />
  </svg>
);

export const CoinsStacked04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.9653 3.084C3.4375 3.552 3 4.1971 3 5v2c0 .8029.4375 1.448.9653 1.916.529.469 1.2373.8456 2.0267 1.1416C7.5783 10.6525 9.7027 11 12 11s4.4217-.3475 6.008-.9424c.7894-.296 1.4978-.6726 2.0267-1.1416C20.5625 8.448 21 7.8029 21 7V5c0-.8029-.4375-1.448-.9653-1.916-.5289-.469-1.2373-.8456-2.0267-1.1416C16.4217 1.3474 14.2973 1 12 1s-4.4217.3475-6.008.9424c-.7894.296-1.4978.6726-2.0267 1.1416"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20.7528 10.25c-.0844 0-.1624.0436-.2111.1126-.5903.8365-1.6047 1.3467-2.5337 1.695C16.4217 12.6525 14.2973 13 12 13s-4.4217-.3475-6.008-.9424c-.929-.3483-1.9434-.8585-2.5337-1.695-.0487-.069-.1267-.1126-.2111-.1126A.247.247 0 0 0 3 10.4972V13c0 .8029.4375 1.4481.9653 1.916.529.469 1.2373.8456 2.0267 1.1416C7.5783 16.6525 9.7027 17 12 17s4.4217-.3475 6.008-.9424c.7894-.296 1.4978-.6726 2.0267-1.1416C20.5625 14.4481 21 13.8029 21 13v-2.5028a.247.247 0 0 0-.2472-.2472"
    />
    <path
      fill="currentColor"
      d="M20.7528 16.25c-.0844 0-.1624.0436-.2111.1126-.5903.8365-1.6047 1.3467-2.5337 1.695C16.4217 18.6525 14.2973 19 12 19s-4.4217-.3475-6.008-.9424c-.929-.3483-1.9434-.8585-2.5337-1.695-.0487-.069-.1267-.1126-.2111-.1126A.247.247 0 0 0 3 16.4972V19c0 .8029.4375 1.4481.9653 1.916.529.469 1.2373.8456 2.0267 1.1416C7.5783 22.6525 9.7027 23 12 23s4.4217-.3475 6.008-.9424c.7894-.296 1.4978-.6726 2.0267-1.1416C20.5625 20.4481 21 19.8029 21 19v-2.5028a.247.247 0 0 0-.2472-.2472"
    />
  </svg>
);

export const CoinsSwap01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.2929 1.2929c.3905-.3905 1.0237-.3905 1.4142 0l2 2c.3905.3905.3905 1.0237 0 1.4142l-2 2c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l.2598-.2598C4.108 5.2491 3 6.4951 3 8c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-2.6273 2.0264-4.7813 4.6014-4.9843L5.293 2.707c-.3905-.3905-.3905-1.0237 0-1.4142M18.7071 17.2929c.3905.3905.3905 1.0237 0 1.4142l-.2598.2598C19.892 18.7509 21 17.5048 21 16c0-.5523.4477-1 1-1s1 .4477 1 1c0 2.6273-2.0264 4.7813-4.6014 4.9843l.3085.3086c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-2-2a1 1 0 0 1 0-1.4142l2-2c.3905-.3905 1.0237-.3905 1.4142 0M9.0623 7.062C9.5206 3.6395 12.4521 1 16 1c3.866 0 7 3.134 7 7 0 3.5479-2.6395 6.4794-6.062 6.9377-.4847-4.1215-3.7542-7.391-7.8757-7.8757"
    />
    <path
      fill="currentColor"
      d="M8 9c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7"
    />
  </svg>
);

export const CoinsSwap02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.2929 1.2929c.3905-.3905 1.0237-.3905 1.4142 0l2 2c.3905.3905.3905 1.0237 0 1.4142l-2 2c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l.2598-.2598C4.108 5.2491 3 6.4951 3 8c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-2.6273 2.0264-4.7813 4.6014-4.9843L5.293 2.707c-.3905-.3905-.3905-1.0237 0-1.4142M18.7071 17.2929c.3905.3905.3905 1.0237 0 1.4142l-.2598.2598C19.892 18.7509 21 17.5048 21 16c0-.5523.4477-1 1-1s1 .4477 1 1c0 2.6273-2.0264 4.7813-4.6014 4.9843l.3085.3086c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-2-2a1 1 0 0 1 0-1.4142l2-2c.3905-.3905 1.0237-.3905 1.4142 0M9.0623 7.062C9.5206 3.6395 12.4521 1 16 1c3.866 0 7 3.134 7 7 0 3.5479-2.6395 6.4794-6.062 6.9377-.4847-4.1215-3.7542-7.391-7.8757-7.8757"
    />
    <path
      fill="currentColor"
      d="M8 9c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7"
    />
  </svg>
);

export const CreditCard01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.1615 4h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 7.1795 23 7.6343 23 8.1614A.8385.8385 0 0 1 22.1614 9H1.8386A.8386.8386 0 0 1 1 8.1614c0-.5271 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 4 4.6343 4 5.1615 4M2.6 11c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 11.7599 1 12.0399 1 12.6v3.2385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 20 4.6342 20 5.1613 20h13.6773c.527 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 16.8205 23 16.3657 23 15.8386V12.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C22.2401 11 21.9601 11 21.4 11z"
    />
  </svg>
);

export const CreditCard02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.8385 4H5.1615c-.5271 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 7.1795 1 7.6343 1 8.1614 1 8.6245 1.3755 9 1.8386 9h20.3228A.8385.8385 0 0 0 23 8.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 4 19.3657 4 18.8385 4"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.546 11.109C1.76 11 2.04 11 2.6 11h18.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.494.109 1.054v3.2386c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 20 19.3657 20 18.8386 20H5.1613c-.527 0-.9818 0-1.3563-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 16.8205 1 16.3657 1 15.8386V12.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437M6 14c-.5523 0-1 .4477-1 1s.4477 1 1 1h5c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const CreditCardCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.7071 15.2929c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L18 18.5858l3.2929-3.2929c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.1615 4h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 7.1795 23 7.6343 23 8.1614A.8385.8385 0 0 1 22.1614 9H1.8386A.8386.8386 0 0 1 1 8.1614c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 4 4.6344 4 5.1615 4M2.6 11c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 11.7599 1 12.0399 1 12.6v3.2385c0 .5271 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 20 4.6342 20 5.1612 20h6.8117c.5507 0 .826 0 .9399-.0638.1362-.0764.1623-.1062.2201-.2513.0483-.1213-.0034-.5101-.1066-1.2877-.1188-.8941.1653-1.8315.8524-2.5185 1.1308-1.1309 2.9399-1.1702 4.1179-.1179l1.8821-1.8821c.6997-.6998 1.6592-.9816 2.5681-.8454.2756.0413.5532-.1546.5532-.4333 0-.56 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C22.2401 11 21.9601 11 21.4 11z"
    />
  </svg>
);

export const CreditCardDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 15c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3a1 1 0 0 0 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L20 18.5858zM5.1615 4h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 7.1795 23 7.6343 23 8.1614A.8385.8385 0 0 1 22.1614 9H1.8386A.8386.8386 0 0 1 1 8.1614c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 4 4.6344 4 5.1615 4"
    />
    <path
      fill="currentColor"
      d="M2.6 11c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 11.7599 1 12.0399 1 12.6v3.2385c0 .5271 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 20 4.6342 20 5.1612 20h6.8117c.5507 0 .826 0 .9399-.0638.1362-.0764.1623-.1062.2201-.2513.0483-.1213-.0034-.5101-.1066-1.2877-.1188-.8941.1653-1.8315.8524-2.5185C14.4645 15.2929 15.2322 15 16 15c0-1.6569 1.3431-3 3-3s3 1.3431 3 3c.3919 0 .5878 0 .6704-.0299.1708-.0619.2378-.1289.2997-.2997.0299-.0826.0299-.228.0299-.5189V12.6c0-.56 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C22.2401 11 21.9601 11 21.4 11z"
    />
  </svg>
);

export const CreditCardDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 15c0-.5523-.4477-1-1-1s-1 .4477-1 1v4.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3a1 1 0 0 0 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L13 19.5858zM5.1615 2h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 5.1795 23 5.6343 23 6.1614A.8385.8385 0 0 1 22.1614 7H1.8386A.8386.8386 0 0 1 1 6.1614c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 2 4.6344 2 5.1615 2"
    />
    <path
      fill="currentColor"
      d="M2.6 9c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 9.76 1 10.04 1 10.6v3.2385c0 .5271 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 18 4.634 18 5.161 18h.4436c.1973 0 .2959 0 .3708-.0242.0786-.0254.118-.048.1795-.1029.0587-.0525.1236-.1636.2536-.3858a3 3 0 0 1 .47-.6084C7.4646 16.2929 8.2323 16 9 16v-1c0-1.6569 1.3431-3 3-3s3 1.3431 3 3v1c.7678 0 1.5355.2929 2.1213.8787.1864.1863.3431.3911.4701.6084.1299.2222.1949.3333.2536.3858.0616.0549.1009.0775.1794.1029.075.0242.1736.0242.3709.0242h.4433c.527 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 14.8205 23 14.3657 23 13.8386V10.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.2401 9 21.9601 9 21.4 9z"
    />
  </svg>
);

export const CreditCardEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.2929 13.2929c.9428-.9428 2.4714-.9428 3.4142 0s.9428 2.4714 0 3.4142l-4.1574 4.1575-.0265.0264c-.099.0995-.2239.2248-.3721.3282a2 2 0 0 1-.4138.2215c-.1683.066-.3418.1003-.4795.1276l-.0367.0073-2.025.405a1 1 0 0 1-1.1767-1.1767l.405-2.025.0073-.0367c.0273-.1377.0616-.3112.1276-.4795a2 2 0 0 1 .2215-.4138c.1034-.1482.2287-.273.3282-.3721l.0264-.0265z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.8385 4H5.1615c-.5271 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 7.1795 1 7.6343 1 8.1614 1 8.6245 1.3755 9 1.8386 9h20.3228A.8385.8385 0 0 0 23 8.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 4 19.3657 4 18.8385 4M1.546 11.109C1.76 11 2.04 11 2.6 11h14.9932c.3653 0 .5437.6206.2855.8788l-4.1575 4.1575-.019.0188c-.0847.0832-.3451.339-.5619.6499a4 4 0 0 0-.4429.8276c-.1384.3528-.2068.7113-.2291.8279l-.0051.0263-.194.9701c-.0458.2291-.0687.3436-.1285.4293a.5.5 0 0 1-.2098.172C11.8352 20 11.7184 20 11.4848 20H5.1613c-.527 0-.9818 0-1.3563-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 16.8205 1 16.3657 1 15.8386V12.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437"
    />
  </svg>
);

export const CreditCardLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.5 13c-1.5188 0-2.75 1.2312-2.75 2.75v.778c-.2025.024-.4296.0736-.658.19a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.0171.2081-.017.4539-.017.7063v.8638c0 .2524-.0001.4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h3.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2284-.1164-.4555-.166-.658-.19v-.778c0-1.5188-1.2312-2.75-2.75-2.75m.75 3.5v-.75a.75.75 0 0 0-1.5 0v.75z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.1615 2h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 5.1795 23 5.6343 23 6.1614A.8385.8385 0 0 1 22.1614 7H1.8386A.8386.8386 0 0 1 1 6.1614c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 2 4.6344 2 5.1615 2M2.6 9c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 9.76 1 10.04 1 10.6v3.2385c0 .5271 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 18 4.634 18 5.161 18h6.1737c.2461 0 .3691 0 .4592-.0364s.1421-.075.203-.151c.0607-.0758.1038-.2192.1898-.5059a3.74 3.74 0 0 1 .2492-.6226 4 4 0 0 1 1.3492-1.5149C14.0716 12.8198 16.0733 11 18.5 11c1.5776 0 2.9756.7691 3.8395 1.9529.2842.3894.4262.5841.4845.5951.0568.0107.0979-.0027.1373-.0448.0406-.0433.0406-.2678.0405-.7169C23.0016 12.0575 23 11.3288 23 10.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.2401 9 21.9601 9 21.4 9z"
    />
  </svg>
);

export const CreditCardMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 18c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.8385 4H5.1615c-.5271 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 7.1795 1 7.6343 1 8.1614 1 8.6245 1.3755 9 1.8386 9h20.3228A.8385.8385 0 0 0 23 8.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 4 19.3657 4 18.8385 4M1.546 11.109C1.76 11 2.04 11 2.6 11h18.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.494.109 1.054v1.5513c0 .2909 0 .4363-.0298.5187-.0619.1713-.1289.2383-.3002.3002C22.5876 15 22.3917 15 22 15h-6c-1.6569 0-3 1.3431-3 3q.0001.2029.0263.3987c.1031.7766.1546 1.1649.1064 1.2862-.0578.1451-.0839.1749-.2201.2513-.1139.0638-.3887.0638-.9384.0638h-6.813c-.527 0-.9817 0-1.3562-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 16.8205 1 16.3657 1 15.8386V12.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437"
    />
  </svg>
);

export const CreditCardPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 15c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1v-2h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2zM5.1615 4h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 7.1795 23 7.6343 23 8.1614A.8385.8385 0 0 1 22.1614 9H1.8386A.8386.8386 0 0 1 1 8.1614c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 4 4.6344 4 5.1615 4"
    />
    <path
      fill="currentColor"
      d="M2.6 11c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 11.7599 1 12.0399 1 12.6v3.2385c0 .5271 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 20 4.6342 20 5.1612 20h6.813c.5497 0 .8245 0 .9384-.0638.1362-.0764.1623-.1062.2201-.2513.0482-.1213-.0033-.5096-.1064-1.2862A3 3 0 0 1 13 18c0-1.6569 1.3431-3 3-3 0-1.6569 1.3431-3 3-3s3 1.3431 3 3c.3917 0 .5876 0 .67-.0298.1713-.0619.2383-.1289.3002-.3002.0298-.0824.0298-.2278.0298-.5187V12.6c0-.56 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C22.2401 11 21.9601 11 21.4 11z"
    />
  </svg>
);

export const CreditCardRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.2929 1.2929c.3905-.3905 1.0237-.3905 1.4142 0l2 2A.997.997 0 0 1 14 4h-2.4142l-1.2929-1.2929c-.3905-.3905-.3905-1.0237 0-1.4142M11.5858 4l-1.2929 1.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l2-2A.997.997 0 0 0 14 4h4.8385c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 7.1795 23 7.6343 23 8.1614A.8385.8385 0 0 1 22.1614 9H1.8386A.8386.8386 0 0 1 1 8.1614c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 4 4.6343 4 5.1615 4zm2.1213 13.2929c.3905.3905.3905 1.0237 0 1.4142L12.4142 20H10a.997.997 0 0 1 .2929-.7071l2-2c.3905-.3905 1.0237-.3905 1.4142 0M10 20H5.1613c-.527 0-.9818 0-1.3563-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 16.8205 1 16.3657 1 15.8386V12.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C1.76 11 2.04 11 2.6 11h18.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054v3.2386c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 20 19.3657 20 18.8386 20h-6.4244l1.2929 1.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-2-2A.997.997 0 0 1 10 20"
      clipRule="evenodd"
    />
  </svg>
);

export const CreditCardSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 14.5c-2.4853 0-4.5 2.0147-4.5 4.5s2.0147 4.5 4.5 4.5c.8805 0 1.702-.2529 2.3957-.69l.8972.8971c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-.8971-.8972A4.48 4.48 0 0 0 22.5 19c0-2.4853-2.0147-4.5-4.5-4.5M15.5 19c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5-1.1193 2.5-2.5 2.5-2.5-1.1193-2.5-2.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.1615 3h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 6.1795 23 6.6343 23 7.1614A.8385.8385 0 0 1 22.1614 8H1.8386A.8386.8386 0 0 1 1 7.1614c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 3 4.6343 3 5.1615 3M2.6 10c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 10.7599 1 11.0399 1 11.6v3.2385c0 .5271 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 19 4.634 19 5.1612 19H10.7c.2791 0 .4187 0 .5188-.0465.0958-.0445.1582-.0997.214-.1894.0583-.0937.0775-.25.1158-.5626C11.9421 14.9884 14.6805 12.5 18 12.5c1.6125 0 3.0879.5872 4.224 1.5594.2873.2459.431.3689.5199.371.0833.002.1473-.0274.1999-.092.0562-.069.0562-.2455.0562-.5985V11.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C22.2401 10 21.9601 10 21.4 10z"
    />
  </svg>
);

export const CreditCardShield = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m20.1496 13.1998 2.1869.7814a1 1 0 0 1 .6635.9417v2.5023c0 1.5391-1.0564 2.6899-1.8595 3.3597-.4264.3556-.8476.6312-1.1599.8172a8.6 8.6 0 0 1-.385.2167 7 7 0 0 1-.1627.0827l-.0015.0006-.0011.0006a1.001 1.001 0 0 1-.8611-.0003 6 6 0 0 1-.1648-.0836 8.6 8.6 0 0 1-.385-.2167c-.3123-.186-.7335-.4616-1.1599-.8172C16.0565 20.1151 15 18.9643 15 17.4252v-2.5023a1 1 0 0 1 .6633-.9416l2.1859-.7815a3.414 3.414 0 0 1 2.3004 0M18.8385 3H5.1615c-.5271 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 6.1795 1 6.6343 1 7.1614 1 7.6245 1.3755 8 1.8386 8h20.3228A.8385.8385 0 0 0 23 7.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 3 19.3657 3 18.8385 3"
    />
    <path
      fill="currentColor"
      d="M1.546 10.109C1.76 10 2.04 10 2.6 10h18.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.494.109 1.054 0 .2408-.2385.4088-.4653.3278l-1.7121-.6118a5.418 5.418 0 0 0-3.6475.0004l-2.1851.7812A3 3 0 0 0 13 14.9225v2.5024c0 .1766.0085.3491.0247.5174.0407.4247.0611.637.0109.7544-.0495.1157-.1095.1817-.22.2421-.112.0612-.295.0612-.6608.0612H5.1613c-.527 0-.9818 0-1.3563-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 15.8205 1 15.3657 1 14.8386V11.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437"
    />
  </svg>
);

export const CreditCardUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7071 14.2929a1 1 0 0 0-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L18 17.4142V21c0 .5523.4477 1 1 1s1-.4477 1-1v-3.5858l1.2929 1.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142zM18.8385 4H5.1615c-.5271 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 7.1795 1 7.6343 1 8.1614 1 8.6245 1.3755 9 1.8386 9h20.3228A.8385.8385 0 0 0 23 8.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 4 19.3657 4 18.8385 4"
    />
    <path
      fill="currentColor"
      d="M1.546 11.109C1.76 11 2.04 11 2.6 11h18.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.494.109 1.054v.226c0 .6058 0 .9087-.1198 1.049a.5.5 0 0 1-.4194.1737c-.1839-.0145-.3981-.2286-.8265-.657l-.513-.513a3 3 0 0 0-4.2426 0l-3 3c-.6871.687-.9712 1.6244-.8524 2.5185.1032.7776.1549 1.1664.1066 1.2877-.0578.1451-.0839.1749-.2201.2513-.1139.0638-.3892.0638-.9399.0638H5.1613c-.527 0-.9818 0-1.3563-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 16.8205 1 16.3657 1 15.8386V12.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437"
    />
  </svg>
);

export const CreditCardUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.7071 14.2929a1 1 0 0 0-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L11 17.4142V22c0 .5523.4477 1 1 1s1-.4477 1-1v-4.5858l1.2929 1.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142zM5.1615 2h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 5.1795 23 5.6343 23 6.1614A.8385.8385 0 0 1 22.1614 7H1.8386A.8386.8386 0 0 1 1 6.1614c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 2 4.6344 2 5.1615 2"
    />
    <path
      fill="currentColor"
      d="M2.6 9c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 9.76 1 10.04 1 10.6v3.2385c0 .5271 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 18 4.634 18 5.161 18H5.2c.2716 0 .4074 0 .499-.0378.0976-.0403.1406-.0731.205-.1567.0606-.0785.1076-.2511.2015-.5962a2.986 2.986 0 0 1 .7732-1.3306l3-3a3 3 0 0 1 4.2426 0l3 3c.3828.3828.6405.8432.7732 1.3306.0939.3451.1408.5177.2014.5962.0645.0836.1075.1164.2051.1567.0916.0378.2274.0378.499.0378h.0386c.527 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 14.8205 23 14.3657 23 13.8386V10.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.2401 9 21.9601 9 21.4 9z"
    />
  </svg>
);

export const CreditCardX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.2071 15.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 18.5l-1.7929 1.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L19 19.9142l1.7929 1.7929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L20.4142 18.5l1.7929-1.7929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L19 17.0858zM5.1615 4h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 7.1795 23 7.6343 23 8.1614A.8385.8385 0 0 1 22.1614 9H1.8386A.8386.8386 0 0 1 1 8.1614c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 4 4.6344 4 5.1615 4"
    />
    <path
      fill="currentColor"
      d="M2.6 11c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 11.7599 1 12.0399 1 12.6v3.2385c0 .5271 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 20 4.6342 20 5.1612 20h7.9435c.1973 0 .2959 0 .3708-.0242.0786-.0254.1179-.048.1795-.1029.0587-.0525.1237-.1636.2536-.3858a3 3 0 0 1 .4701-.6084l.3787-.3787-.3787-.3787c-1.1716-1.1716-1.1716-3.071 0-4.2426s3.071-1.1716 4.2426 0l.3787.3787.3787-.3787c.7811-.7811 1.8857-1.0414 2.8824-.781.3444.0899.7389-.1418.7389-.4977 0-.56 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C22.2401 11 21.9601 11 21.4 11z"
    />
  </svg>
);

export const Cryptocurrency01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.0548 3.9107c.4963-.242.7025-.8407.4604-1.3371s-.8408-.7025-1.3372-.4604a11 11 0 0 0-6.0708 11.4176c.0768.5469.5825.9279 1.1294.8511.547-.0769.928-.5825.851-1.1295a9 9 0 0 1 4.9672-9.3417M15.4849 2.5736c.2421-.4964.8408-.7025 1.3372-.4604a10.999 10.999 0 0 1 6.0708 11.4176c-.0768.5469-.5825.9279-1.1294.8511-.5469-.0769-.9279-.5825-.8511-1.1295a9 9 0 0 0-4.9671-9.3417c-.4964-.242-.7025-.8407-.4604-1.3371M5.3131 19.5026c.3246-.4468.95-.5458 1.3968-.2212a9 9 0 0 0 10.5802 0c.4468-.3246 1.0721-.2256 1.3968.2212s.2255 1.0722-.2213 1.3968a11 11 0 0 1-12.9312 0c-.4468-.3246-.5459-.95-.2213-1.3968M12 5.5c-3.5898 0-6.5 2.9101-6.5 6.5s2.9101 6.5 6.5 6.5 6.5-2.9101 6.5-6.5c0-3.5898-2.9101-6.5-6.5-6.5"
    />
  </svg>
);

export const Cryptocurrency02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.0548 3.9107c.4963-.242.7025-.8407.4604-1.3371s-.8408-.7025-1.3372-.4604a11 11 0 0 0-6.0708 11.4176c.0768.5469.5825.9279 1.1294.8511.547-.0769.928-.5825.851-1.1295a9 9 0 0 1 4.9672-9.3417M15.4849 2.5736c.2421-.4964.8408-.7025 1.3372-.4604a10.999 10.999 0 0 1 6.0708 11.4176c-.0768.5469-.5825.9279-1.1294.8511-.5469-.0769-.9279-.5825-.8511-1.1295a9 9 0 0 0-4.9671-9.3417c-.4964-.242-.7025-.8407-.4604-1.3371M5.3131 19.5026c.3246-.4468.95-.5458 1.3968-.2212a9 9 0 0 0 10.5802 0c.4468-.3246 1.0721-.2256 1.3968.2212s.2255 1.0722-.2213 1.3968a11 11 0 0 1-12.9312 0c-.4468-.3246-.5459-.95-.2213-1.3968M12.9758 5.5759c-.1111-.0943-.2797-.2199-.5123-.2954a1.5 1.5 0 0 0-.927 0c-.2327.0755-.4013.201-.5123.2954-.0959.0814-.1964.182-.2806.2662l-4.9014 4.9014c-.0843.0842-.1849.1847-.2663.2806-.0943.1111-.2198.2797-.2954.5123a1.5 1.5 0 0 0 0 .927c.0756.2327.2011.4013.2954.5124.0814.0958.182.1964.2663.2806l4.9013 4.9013c.0842.0843.1848.1849.2807.2663.111.0943.2796.2198.5123.2954.3012.0979.6257.0979.927 0 .2326-.0756.4012-.2011.5123-.2954.0959-.0814.1964-.182.2806-.2663l4.9014-4.9013c.0842-.0842.1849-.1848.2662-.2806.0943-.1111.2199-.2797.2955-.5124a1.5 1.5 0 0 0 0-.927c-.0756-.2326-.2012-.4012-.2955-.5123-.0813-.0959-.182-.1964-.2662-.2806l-4.9014-4.9014c-.0842-.0842-.1847-.1848-.2806-.2662"
    />
  </svg>
);

export const Cryptocurrency03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.2929 1.2929c.3905-.3905 1.0237-.3905 1.4142 0l2 2c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142M8 1c.5523 0 1 .4477 1 1v1.5c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.5523.4477-1 1-1M21.2929 1.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-2 2c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142zM19.5 8c0-.5523.4477-1 1-1H22c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1.5c-.5523 0-1-.4477-1-1M3.5 17H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.5c.5523 0 1 .4477 1 1s-.4477 1-1 1M4.7071 19.2929c.3905.3905.3905 1.0237 0 1.4142l-2 2c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l2-2c.3905-.3905 1.0237-.3905 1.4142 0M19.2929 19.2929c.3905-.3905 1.0237-.3905 1.4142 0l2 2c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142M16 19.5c.5523 0 1 .4477 1 1V22c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1.5c0-.5523.4477-1 1-1M17 16c0-.5523.4477-1 1-1h3.5c.5523 0 1 .4477 1 1s-.4477 1-1 1H18c-.5523 0-1-.4477-1-1M17 6V2c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1M1 8c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1M9 18c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1zM12 7c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5"
    />
  </svg>
);

export const Cryptocurrency04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142zM9 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.5c0 .5523.4477 1 1 1s1-.4477 1-1zM22.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-2 2c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l2-2c.3905-.3905.3905-1.0237 0-1.4142M20.5 7c-.5523 0-1 .4477-1 1s.4477 1 1 1H22c.5523 0 1-.4477 1-1s-.4477-1-1-1zM2 17h1.5c.5523 0 1-.4477 1-1s-.4477-1-1-1H2c-.5523 0-1 .4477-1 1s.4477 1 1 1M4.7071 20.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-2 2c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM20.7071 19.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142zM17 20.5c0-.5523-.4477-1-1-1s-1 .4477-1 1V22c0 .5523.4477 1 1 1s1-.4477 1-1zM18 15c-.5523 0-1 .4477-1 1s.4477 1 1 1h3.5c.5523 0 1-.4477 1-1s-.4477-1-1-1zM17 2v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.5523.4477-1 1-1s1 .4477 1 1M2 7c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1zM8 17c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1M12.4635 6.2805a1.5 1.5 0 0 0-.927 0c-.2327.0755-.4013.201-.5123.2954-.0959.0813-.1964.182-.2806.2662l-3.9014 3.9014c-.0843.0842-.1849.1847-.2663.2806-.0943.1111-.2198.2797-.2954.5123a1.5 1.5 0 0 0 0 .927c.0756.2327.2011.4013.2954.5124.0814.0958.182.1964.2663.2806l3.9013 3.9013c.0842.0843.1848.1849.2807.2663.111.0943.2796.2198.5123.2954.3012.0979.6257.0979.927 0 .2326-.0756.4012-.2011.5123-.2954.0959-.0814.1964-.182.2806-.2663l3.9014-3.9013c.0842-.0842.1849-.1848.2662-.2806.0943-.1111.2199-.2797.2955-.5124a1.5 1.5 0 0 0 0-.927c-.0756-.2326-.2012-.4012-.2955-.5123-.0813-.0959-.182-.1964-.2662-.2806l-3.9014-3.9014c-.0842-.0842-.1847-.1848-.2806-.2662-.1111-.0943-.2797-.2199-.5123-.2954"
    />
  </svg>
);

export const CurrencyBitcoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.5 1c.5523 0 1 .4477 1 1v1h2V2c0-.5523.4477-1 1-1s1 .4477 1 1v1.0247C17.0267 3.2755 19 5.4073 19 8c0 1.4307-.6009 2.7211-1.5641 3.6325C18.9657 12.4875 20 14.123 20 16c0 2.7614-2.2386 5-5 5h-.5v1c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1h-2v1c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1h-3c-.5523 0-1-.4477-1-1s.4477-1 1-1h1V5h-1c-.5523 0-1-.4477-1-1s.4477-1 1-1h3V2c0-.5523.4477-1 1-1m-1 4v6H14c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3zm0 8v6H15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3z"
      clipRule="evenodd"
    />
  </svg>
);

export const CurrencyBitcoinCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.5 14.25c0 .6904-.5596 1.25-1.25 1.25H10.5V13h3.75c.6904 0 1.25.5596 1.25 1.25M13.75 8.5H10.5V11h3.25c.6904 0 1.25-.5596 1.25-1.25s-.5596-1.25-1.25-1.25"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m-2 4c.5523 0 1 .4477 1 1v.5h1V6c0-.5523.4477-1 1-1s1 .4477 1 1v.5095c1.6781.1276 3 1.5297 3 3.2405a3.236 3.236 0 0 1-.6822 1.9925c.722.5961 1.1822 1.4981 1.1822 2.5075 0 1.7949-1.4551 3.25-3.25 3.25H14v.5c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.5h-1v.5c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.5H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h.5v-7H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h1V6c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const CurrencyDollar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1h-1C7.2386 3 5 5.2386 5 8s2.2386 5 5 5h1v6h-1c-1.6569 0-3-1.3431-3-3 0-.5523-.4477-1-1-1s-1 .4477-1 1c0 2.7614 2.2386 5 5 5h1v1c0 .5523.4477 1 1 1s1-.4477 1-1v-1h1c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5h-1V5h1c1.6569 0 3 1.3431 3 3 0 .5523.4477 1 1 1s1-.4477 1-1c0-2.7614-2.2386-5-5-5h-1zm-2 3h-1C8.3431 5 7 6.3431 7 8s1.3431 3 3 3h1zm2 8v6h1c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3z"
      clipRule="evenodd"
    />
  </svg>
);

export const CurrencyDollarCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m1 4.5c0-.5523-.4477-1-1-1s-1 .4477-1 1V6C9.067 6 7.5 7.567 7.5 9.5S9.067 13 11 13h2c.8284 0 1.5.6716 1.5 1.5S13.8284 16 13 16h-2.1667C10.097 16 9.5 15.403 9.5 14.6667c0-.5523-.4477-1-1-1s-1 .4477-1 1C7.5 16.5076 8.9924 18 10.8333 18H11v.5c0 .5523.4477 1 1 1s1-.4477 1-1V18c1.933 0 3.5-1.567 3.5-3.5S14.933 11 13 11h-2c-.8284 0-1.5-.6716-1.5-1.5S10.1716 8 11 8h2.1667C13.903 8 14.5 8.597 14.5 9.3333c0 .5523.4477 1 1 1s1-.4477 1-1C16.5 7.4923 15.0076 6 13.1667 6H13z"
      clipRule="evenodd"
    />
  </svg>
);

export const CurrencyEthereum = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.7474 1.3356a1 1 0 0 0-1.4948 0l-8 9.0002a1 1 0 0 0 .5049 1.6345l8 1.9998a1 1 0 0 0 .485 0l8-2a.9998.9998 0 0 0 .5049-1.6345z"
    />
    <path
      fill="currentColor"
      d="M5.7248 14.0257a1 1 0 0 0-.9576 1.6548l6.5001 7a1 1 0 0 0 1.4656 0l6.4999-7a1 1 0 0 0-.9577-1.6548L12 15.4738z"
    />
  </svg>
);

export const CurrencyEthereumCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m8.1174 11.1367 3.8828 1.7648 3.8825-1.7648-3.8825-4.5886z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m.0002 3a1 1 0 0 1 .7634.354l5.4998 6.5001a1 1 0 0 1-.3496 1.5563l-5.4998 2.5a1 1 0 0 1-.8276 0l-5.5002-2.5a1 1 0 0 1-.3496-1.5564l5.5002-6.5A1 1 0 0 1 12.0002 4M5.5896 15.086c.2286-.5028.8214-.7251 1.3242-.4966l5.0864 2.3119 5.086-2.3119c.5028-.2285 1.0956-.0062 1.3242.4965.2285.5028.0062 1.0957-.4966 1.3242l-5.4998 2.5a1 1 0 0 1-.8276 0l-5.5002-2.5c-.5028-.2285-.7251-.8214-.4966-1.3241"
      clipRule="evenodd"
    />
  </svg>
);

export const CurrencyEuro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.624 9c1.1574-2.6489 3.8005-4.5 6.876-4.5 1.8515 0 3.5441.6696 4.8526 1.7812.4209.3575 1.052.3062 1.4095-.1147.3576-.421.3062-1.052-.1147-1.4096C17.991 3.3499 15.8435 2.5 13.5 2.5 9.3016 2.5 5.7393 5.2234 4.4834 9H3c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.052A9.6 9.6 0 0 0 4 12c0 .3377.0176.6714.052 1H3c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.4834c1.256 3.7766 4.8182 6.5 9.0166 6.5 2.3435 0 4.491-.8498 6.1474-2.2569.4209-.3576.4723-.9886.1147-1.4095-.3575-.421-.9886-.4723-1.4095-.1148C17.0441 18.8304 15.3515 19.5 13.5 19.5c-3.0755 0-5.7186-1.8511-6.876-4.5H13c.5523 0 1-.4477 1-1s-.4477-1-1-1H6.066A7.6 7.6 0 0 1 6 12c0-.3391.0225-.6729.066-1H13c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const CurrencyEuroCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M8 12q.0001-.2541.031-.5H11c.5523 0 1-.4477 1-1s-.4477-1-1-1H8.8773C9.6103 8.5855 10.7368 8 12 8c1.0251 0 1.9581.3843 2.6664 1.0183.4115.3683 1.0437.3333 1.4121-.0782.3683-.4116.3333-1.0437-.0783-1.412C14.9394 6.5784 13.5361 6 12 6 9.5785 6 7.492 7.4345 6.544 9.5H6c-.5523 0-1 .4477-1 1s.4477 1 1 1h.0205a6.1 6.1 0 0 0 0 1H6c-.5523 0-1 .4477-1 1s.4477 1 1 1h.544C7.492 16.5655 9.5785 18 12 18c1.5361 0 2.9394-.5785 4.0002-1.528.4116-.3683.4466-1.0005.0783-1.4121s-1.0006-.4465-1.4121-.0782C13.9581 15.6157 13.0251 16 12 16c-1.2632 0-2.3896-.5855-3.1227-1.5H11c.5523 0 1-.4477 1-1s-.4477-1-1-1H8.031A4 4 0 0 1 8 12"
      clipRule="evenodd"
    />
  </svg>
);

export const CurrencyPound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.5275 5.3544c-.3614.3916-.642.9946-.6438 1.9443.0125.8454.3648 1.449.8933 2.3548l.04.0685c.4271.7325.9176 1.6074 1.1048 2.778H15c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4.0575c-.2242 1.9448-1.0674 3.5405-1.88 4.6733-.081.1131-.1622.222-.2427.3267H17.5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-11a1 1 0 0 1-.621-1.7839l.002-.0015.0203-.0167a5 5 0 0 0 .0907-.0774 8 8 0 0 0 .3513-.3284c.297-.2941.6957-.7291 1.0941-1.2845.6523-.9094 1.277-2.1033 1.4877-3.5076H6.5c-.5523 0-1-.4477-1-1s.4477-1 1-1h2.384c-.155-.6385-.4499-1.1792-.7947-1.7705l-.098-.1669c-.486-.8268-1.0898-1.854-1.1075-3.2449l-.0002-.0132c.0006-1.3785.4221-2.4916 1.1742-3.3065.7403-.8022 1.7224-1.2307 2.7061-1.4034 1.9064-.3347 4.1345.2428 5.3769 1.423.4005.3803.4167 1.0133.0364 1.4137s-1.0133.4167-1.4138.0363c-.7092-.6736-2.2643-1.147-3.6537-.9031-.6642.1166-1.2082.3847-1.5822.79"
    />
  </svg>
);

export const CurrencyPoundCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m-1.1046 7.9558c.0015-.5378.158-.8378.323-1.0165.1773-.1922.452-.3373.8254-.4029.8078-.1418 1.6953.1462 2.0601.4927.4004.3803 1.0334.364 1.4137-.0364.3804-.4004.3641-1.0333-.0363-1.4137-.8981-.853-2.4586-1.245-3.7833-1.0125-.6929.1217-1.4057.4273-1.9494 1.0164-.5554.6018-.853 1.4117-.8533 2.3787l.0001.0132c.0129 1.0082.3877 1.701.6622 2.2083l.0177.0327c.055.1017.1051.1955.1501.2842H9c-.5523 0-1 .4477-1 1s.4477 1 1 1h.8979c-.1517.7615-.4534 1.4655-.7736 2.0463a8.8 8.8 0 0 1-.6167.965 7 7 0 0 1-.1965.2543 4 4 0 0 1-.0498.0598l-.0103.0121-.0008.0009A.9999.9999 0 0 0 9 18.5h6c.5523 0 1-.4477 1-1s-.4477-1-1-1h-4.1177c.4255-.774.8724-1.8141 1.0444-3H14c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2.1315c-.1338-.4958-.3455-.8872-.5179-1.2058l-.0159-.0294c-.2706-.5006-.4317-.8181-.4393-1.309"
      clipRule="evenodd"
    />
  </svg>
);

export const CurrencyRuble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5 2.5c-.5523 0-1 .4477-1 1v7h-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v2h-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v4c0 .5523.4477 1 1 1s1-.4477 1-1v-4h4c.5523 0 1-.4477 1-1s-.4477-1-1-1h-4v-2h5c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5zm1 8h5c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3h-5z"
      clipRule="evenodd"
    />
  </svg>
);

export const CurrencyRubleCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.5 10.5v-3H14c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M8.5 6.5c0-.5523.4477-1 1-1H14c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5h-3.5v1.25H13c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2.5v1.75c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1.75H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h.5V12.5H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h.5z"
      clipRule="evenodd"
    />
  </svg>
);

export const CurrencyRupeeCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M7.5 6.5c0-.5523.4477-1 1-1h7c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1.8407c.2805.4653.4703.9766.5753 1.5H15.5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1.2654c-.1485.7403-.4667 1.4564-.9713 2.0524-.5331.6297-1.2515 1.0965-2.1262 1.3132l3.4962 2.8605c.4274.3497.4904.9797.1407 1.4072s-.9798.4904-1.4072.1407l-5.494-4.4951a.996.996 0 0 1-.2723-.3415A1 1 0 0 1 7.5 13.5v-.0012q0-.0502.005-.1003a.997.997 0 0 1 .2694-.5866.99.99 0 0 1 .2728-.2037A.996.996 0 0 1 8.5 12.5H10c.8223 0 1.3747-.312 1.7369-.7399.1828-.2159.3276-.4747.4288-.7601H8.5c-.5523 0-1-.4477-1-1s.4477-1 1-1h3.6657c-.1012-.2854-.246-.5442-.4288-.7601C11.3747 7.812 10.8223 7.5 10 7.5H8.5c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const CurrencyRupee = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 2c-.5523 0-1 .4477-1 1s.4477 1 1 1h3c1.3954 0 2.3685.5133 3.0028 1.2269.4375.4922.7377 1.1075.8873 1.7731H6c-.5523 0-1 .4477-1 1s.4477 1 1 1h6.8901c-.1496.6656-.4498 1.2809-.8873 1.7731C11.3685 11.4867 10.3954 12 9 12H6a.996.996 0 0 0-.713.2989A.997.997 0 0 0 5 13a.996.996 0 0 0 .3078.7217l.0087.0083 8.4981 7.9982c.4022.3785 1.0351.3593 1.4136-.0428s.3593-1.0351-.0428-1.4136L8.5216 14H9c1.9381 0 3.4651-.7367 4.4976-1.8981.7847-.8828 1.2536-1.9759 1.4265-3.1019H18c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3.0759c-.1663-1.083-.6065-2.1357-1.3381-3H18c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const CurrencyYen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.8696 2.724c.4286-.3484 1.0584-.2832 1.4067.1454l5.7239 7.0448 5.7238-7.0448c.3483-.4286.9781-.4938 1.4067-.1455s.4938.978.1456 1.4067L14.1012 10.5H18c.5523 0 1 .4477 1 1s-.4477 1-1 1h-5v2h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4H7c-.5523 0-1-.4477-1-1s.4477-1 1-1h4v-2H6c-.5523 0-1-.4477-1-1s.4477-1 1-1h3.8992L4.724 4.1306c-.3482-.4286-.283-1.0584.1456-1.4067"
    />
  </svg>
);

export const CurrencyYenCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M7.3753 6.2192c.4312-.345 1.0605-.2751 1.4055.1561L12 10.3993l3.2191-4.024c.345-.4312.9743-.5011 1.4056-.1561s.5012.9743.1561 1.4055L14.0806 11H16c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3v1h2.5c.5523 0 1 .4477 1 1s-.4477 1-1 1H13v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2H8.5c-.5523 0-1-.4477-1-1s.4477-1 1-1H11v-1H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.9193L7.2191 7.6247c-.345-.4312-.275-1.0605.1562-1.4055"
      clipRule="evenodd"
    />
  </svg>
);

export const Diamond01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.6127 2h-1.2254l-2 6h5.2254zM14.6125 10h-5.225L12 17.8375zM7.2792 8l2-6h-2.045a1.5 1.5 0 0 0-1.1523.5397L2.215 7.18C1.9437 7.5056 2.1752 8 2.599 8zM2.215 10.8201C1.9438 10.4944 2.1753 10 2.5993 10h4.6801l3.5117 10.535c.0766.2299-.1754.3848-.3247.194a8 8 0 0 0-.1555-.194zM16.7207 10h4.6802c.4239 0 .6555.4944.3841.8201l-8.0958 9.7149a8 8 0 0 0-.1555.194c-.1493.1908-.4013.0358-.3247-.194zM21.785 7.18c.2714.3256.0398.82-.3841.82h-4.6801l-2-6h2.045c.4452 0 .8674.1977 1.1524.5397z"
    />
  </svg>
);

export const Diamond02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 22c0-.5523.4477-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.6127 1h-1.2254l-2 6h5.2254zM14.7208 1l2 6h4.68c.4239 0 .6555-.4944.3841-.82l-3.8668-4.6403A1.5 1.5 0 0 0 16.7658 1zM21.682 9.8363c.292-.3211.0641-.8363-.37-.8363h-4.6011l-3.2303 9.2871c-.0715.2056.1904.3613.3369.2002zM10.1826 18.4875c.1464.1611.4084.0054.3369-.2002L7.2891 9H2.688c-.4341 0-.662.5152-.37.8363zM2.215 6.18c-.2714.3256-.0398.82.3841.82h4.68l2-6h-2.045a1.5 1.5 0 0 0-1.1523.5397zM9.4067 9h5.1866L12 16.4559z"
    />
  </svg>
);

export const Gift01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.6695 5A3.03 3.03 0 0 1 5.5 4c0-.7899.308-1.551.8619-2.115C6.9164 1.3206 7.6722 1 8.4643 1 10.259 1 11.3725 2.2185 12 3.2722 12.6275 2.2185 13.741 1 15.5357 1c.7921 0 1.548.3205 2.1024.885.5539.564.8619 1.3251.8619 2.115 0 .3434-.0582.6813-.1695 1h2.196c.21 0 .4147 0 .5887.0118.1904.013.4161.0435.6502.1405.49.203.8794.5923 1.0824 1.0823.0969.234.1274.4598.1404.6502.0119.174.0118.3786.0118.5885v.0534c0 .2099.0001.4146-.0118.5885-.013.1904-.0435.4161-.1404.6502-.203.49-.5924.8794-1.0824 1.0824-.2341.097-.4598.1274-.6502.1404-.174.0118-.3786.0118-.5887.0118H3.4735c-.21 0-.4146 0-.5887-.0118-.1904-.013-.4161-.0435-.6502-.1404a2 2 0 0 1-1.0823-1.0824c-.097-.234-.1275-.4598-.1405-.6502C1 7.9412 1 7.7366 1 7.5266v-.0532c0-.21 0-.4146.0118-.5886.013-.1904.0435-.4161.1404-.6502a2 2 0 0 1 1.0824-1.0823c.234-.097.4598-.1275.6502-.1405C3.0588 5 3.2636 5 3.4735 5zm2.7948-2c-.2499 0-.4932.1009-.6755.2865C7.6058 3.4727 7.5 3.729 7.5 4s.1059.5273.2888.7135c.1823.1856.4256.2865.6755.2865h2.17a6.1 6.1 0 0 0-.2507-.5247C9.8976 3.5758 9.274 3 8.4643 3m4.9015 2a6 6 0 0 1 .2507-.5247C14.1023 3.5758 14.726 3 15.5357 3c.2499 0 .4933.1009.6755.2865.1829.1862.2888.4425.2888.7135s-.1059.5273-.2888.7135c-.1822.1856-.4256.2865-.6755.2865z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M3 13c0-.5523.4477-1 1-1h6.2c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C11 12.38 11 12.52 11 12.8v9.4c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C10.62 23 10.48 23 10.2 23H7.1614c-.527 0-.982 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C3 19.8205 3 19.3657 3 18.8385zM18.195 22.9694C17.8205 23 17.3657 23 16.8385 23H13.8c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C13 22.62 13 22.48 13 22.2v-9.4c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C13.38 12 13.52 12 13.8 12H20c.5523 0 1 .4477 1 1v5.8386c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964"
    />
  </svg>
);

export const Gift02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4.1314a10 10 0 0 0-.0613-.1133C11.1927 2.6617 9.8061 1 7.5 1a3.5 3.5 0 0 0-3.1597 5.0055 9 9 0 0 0-.5353.025c-.3954.0324-.7886.1037-1.167.2965a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 9.1795 1 9.6343 1 10.1614V12.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C1.38 13 1.52 13 1.8 13H11V8.8c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C11.38 8 11.52 8 11.8 8h.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C13 8.38 13 8.52 13 8.8V13h9.2c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C23 12.62 23 12.48 23 12.2v-2.0386c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964a9 9 0 0 0-.5353-.0251A3.4999 3.4999 0 0 0 16.5 1c-2.3061 0-3.6927 1.6617-4.4387 3.018A10 10 0 0 0 12 4.1315m-5.5607-.692A1.5 1.5 0 0 1 7.5 3c1.1939 0 2.0573.8383 2.6863 1.982.1911.3474.3456.6986.4677 1.018H7.5a1.5 1.5 0 0 1-1.0607-2.5607M16.5 6h-3.154c.1221-.3194.2766-.6706.4677-1.018C14.4427 3.8382 15.3061 3 16.5 3a1.5001 1.5001 0 0 1 1.0607 2.5607A1.5 1.5 0 0 1 16.5 6"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M1.8 15c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C1 15.38 1 15.52 1 15.8v3.0385c0 .5271 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 23 4.6343 23 5.1614 23h13.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 19.8205 23 19.3657 23 18.8386V15.8c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C22.62 15 22.48 15 22.2 15H13v5.2c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C12.62 21 12.48 21 12.2 21h-.4c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C11 20.62 11 20.48 11 20.2V15z"
    />
  </svg>
);

export const PiggyBank01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.5 9C13.433 9 15 7.433 15 5.5S13.433 2 11.5 2 8 3.567 8 5.5 9.567 9 11.5 9"
    />
    <path
      fill="currentColor"
      d="M6.9755 8.628c-.2387-.3446-.358-.5168-.4865-.5738a.49.49 0 0 0-.357-.0183c-.1336.0434-.2388.166-.449.4114-.844.9847-1.4196 2.2068-1.6121 3.5529H4c-.5523 0-1-.4477-1-1a.999.999 0 0 1 .5007-.8668c.478-.2766.6414-.8883.365-1.3664-.2766-.478-.8884-.6414-1.3664-.3649C1.6052 8.9193 1 9.8885 1 11.0002c0 1.6568 1.3432 3 3 3h.071c.2159 1.5082.9128 2.8621 1.929 3.899v2.3242c-.0001.1191-.0002.2613.01.3867.012.1452.0424.3532.1534.5711.1438.2823.3733.5117.6555.6555.218.1111.426.1415.5712.1534.1253.0102.2675.0102.3866.0101h1.9464c.119.0001.2614.0001.3867-.0101.1452-.0119.3532-.0423.5711-.1534a1.5 1.5 0 0 0 .6555-.6555c.1111-.2179.1415-.4259.1534-.5711.0102-.1254.0102-.2676.0101-.3867v-.2232H12.5l-.0001.2228c0 .1191-.0001.2614.0102.3867.0118.1452.0423.3532.1533.5712.1439.2822.3733.5117.6556.6555.2179.111.4259.1415.5711.1533.1253.0103.2675.0102.3866.0102h1.9465c.1191 0 .2614.0001.3867-.0102.1452-.0118.3532-.0423.5711-.1533a1.5 1.5 0 0 0 .6555-.6555c.1111-.218.1415-.426.1534-.5712.0102-.1253.0102-.2676.0101-.3867v-.897a7.026 7.026 0 0 0 2.7452-2.3261h.478c.1191 0 .2613.0001.3867-.0102.1452-.0118.3532-.0423.5711-.1533a1.5 1.5 0 0 0 .6555-.6555c.1111-.218.1415-.426.1534-.5712.0102-.1253.0102-.2675.0101-.3866v-3.4595c.0001-.1134.0001-.2489-.0092-.3684-.0107-.1382-.0383-.3364-.1394-.5462a1.5 1.5 0 0 0-.7005-.7006c-.2098-.101-.408-.1286-.5462-.1393A4 4 0 0 0 21.3262 10 7.01 7.01 0 0 0 20 8.1009V7.0323c.0001-.1548.0001-.33-.0133-.4808-.0148-.1665-.0536-.4238-.2116-.6788a1.5 1.5 0 0 0-.8657-.653c-.2886-.082-.5467-.0485-.7108-.017-.1487.0285-.3171.0767-.466.1193l-.1558.0445c-.205.0585-.3075.0878-.3796.1406-.0696.051-.1122.1012-.151.1782-.0403.0798-.0541.2015-.0819.4448C16.6517 8.871 14.3245 11 11.5 11c-1.8755 0-3.5317-.9387-4.5245-2.372"
    />
  </svg>
);

export const PiggyBank02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.5 2C9.0147 2 7 4.0147 7 6.5c0 .2431.0194.4821.0567.7155-1.5848 1.0824-2.702 2.7992-2.9859 4.7847H4c-.5523 0-1-.4477-1-1a.999.999 0 0 1 .5007-.8668c.478-.2766.6414-.8883.365-1.3664-.2766-.478-.8884-.6414-1.3664-.3649C1.6052 8.9193 1 9.8885 1 11.0002c0 1.6568 1.3432 3 3 3h.071c.216 1.5081.9129 2.8619 1.929 3.8988v2.3241c-.0001.1192-.0002.2614.01.3867.012.1452.0424.3532.1534.5712.1438.2822.3733.5117.6555.6555.218.1111.426.1415.5712.1534.1253.0102.2676.0102.3867.0101H9.723c.1191.0001.2614.0001.3867-.0101.1452-.0119.3532-.0423.5711-.1534a1.5 1.5 0 0 0 .6555-.6555c.1111-.218.1415-.426.1534-.5712.0102-.1253.0102-.2675.0101-.3867V20H12.5l-.0001.223c0 .1191-.0001.2614.0102.3867.0118.1452.0423.3532.1533.5712.1439.2822.3733.5117.6556.6555.2179.111.4259.1415.5711.1533.1253.0103.2676.0102.3867.0102h1.9465c.1191 0 .2613.0001.3866-.0102.1452-.0118.3532-.0423.5711-.1533a1.5 1.5 0 0 0 .6555-.6555c.1111-.218.1415-.426.1534-.5712.0102-.1253.0102-.2676.0101-.3867v-.897a7.026 7.026 0 0 0 2.7452-2.3261h.478c.1191 0 .2613.0001.3867-.0102.1452-.0118.3532-.0423.5711-.1533a1.5 1.5 0 0 0 .6555-.6555c.1111-.218.1415-.426.1534-.5712.0102-.1253.0102-.2676.0101-.3867v-3.4594c.0001-.1134.0001-.2489-.0092-.3684-.0107-.1382-.0383-.3364-.1394-.5462a1.5 1.5 0 0 0-.7005-.7006c-.2098-.101-.408-.1286-.5462-.1393A4 4 0 0 0 21.3262 10 7.01 7.01 0 0 0 20 8.1009V7.0323c.0001-.1548.0001-.33-.0133-.4808-.0148-.1665-.0536-.4238-.2116-.6788a1.5 1.5 0 0 0-.8657-.653c-.2886-.082-.5467-.0485-.7108-.017-.1487.0285-.3171.0767-.466.1193l-1.782.509C15.6275 3.663 13.758 2 11.5 2"
    />
  </svg>
);

export const Receipt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.2413 2H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 6.2894 3 6.9537 3 7.7587V21a1 1 0 0 0 1.5882.8087l2.133-1.5512 1.9041 1.5234a1 1 0 0 0 1.2129.0278L12 20.2365l2.1618 1.5722a1 1 0 0 0 1.2129-.0278l1.9042-1.5234 2.1329 1.5512A.9999.9999 0 0 0 21 21V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 2 16.0463 2 15.2413 2"
    />
  </svg>
);

export const ReceiptCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.7587 2h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 6.2894 21 6.9537 21 7.7587V21a1.0001 1.0001 0 0 1-1.5882.8087l-2.1329-1.5512-1.9042 1.5234a1 1 0 0 1-1.2129.0278L12 20.2365l-2.1618 1.5722a1 1 0 0 1-1.2129-.0278l-1.9042-1.5234-2.133 1.5512A.9998.9998 0 0 1 3 21V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 2 7.9538 2 8.7587 2m7.4484 6.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 11.0858l-1.2929-1.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const Safe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.5 10.5C7.5 9.6716 8.1716 9 9 9s1.5.6716 1.5 1.5S9.8284 12 9 12s-1.5-.6716-1.5-1.5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5271 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v8.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 19 5.6342 19 6.1613 19h11.6772c.5271 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 15.8205 22 15.3657 22 14.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M18.5 6.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v8c0 .5523.4477 1 1 1s1-.4477 1-1zM9 7c-1.933 0-3.5 1.567-3.5 3.5S7.067 14 9 14s3.5-1.567 3.5-3.5S10.933 7 9 7"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5 21c0-.5523.4477-1 1-1h3c.5523 0 1 .4477 1 1s-.4477 1-1 1H6c-.5523 0-1-.4477-1-1M14 21c0-.5523.4477-1 1-1h3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const Sale01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m4.7071 7.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-8 8c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM7.5 9c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5S7.5 9.8284 7.5 9m6 6c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Sale02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.8659 2.1543c1.806-1.539 4.4622-1.539 6.2682 0a2.832 2.832 0 0 0 1.6117.6676c2.3653.1887 4.2436 2.067 4.4323 4.4323.0474.594.281 1.158.6676 1.6117 1.5391 1.806 1.5391 4.4622 0 6.2682a2.83 2.83 0 0 0-.6676 1.6117c-.1887 2.3653-2.067 4.2436-4.4323 4.4323a2.83 2.83 0 0 0-1.6117.6676c-1.806 1.5391-4.4622 1.5391-6.2682 0a2.83 2.83 0 0 0-1.6117-.6676c-2.3653-.1887-4.2436-2.067-4.4323-4.4323a2.832 2.832 0 0 0-.6676-1.6117c-1.539-1.806-1.539-4.4622 0-6.2682a2.832 2.832 0 0 0 .6676-1.6117c.1887-2.3653 2.067-4.2436 4.4323-4.4323a2.832 2.832 0 0 0 1.6117-.6676m7.8412 6.5528c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-8 8c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM7.5 9c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5S7.5 9.8284 7.5 9m6 6c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Sale03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5395 1.2309a3.033 3.033 0 0 1 2.3211 0l1.7431.722c.253.1044.5373.1043.7901-.0006l.002-.0008 1.7446-.7196a3.0326 3.0326 0 0 1 3.9617 1.641l.7052 1.7026a1 1 0 0 1 .018.041c.1045.2527.3051.4537.5577.5588l1.7449.7228a3.033 3.033 0 0 1 1.6413 3.9624l-.7224 1.744a1.03 1.03 0 0 0 0 .7895l.0008.0021.7208 1.7427a3.034 3.034 0 0 1 .0004 2.322 3.032 3.032 0 0 1-1.6418 1.6416l-1.744.7223a1.034 1.034 0 0 0-.5593.5577l-.7229 1.7453a3.0325 3.0325 0 0 1-3.9623 1.6413l-1.7431-.7221a1.033 1.033 0 0 0-.7901.0006l-.001.0005-1.7452.7218a3.0326 3.0326 0 0 1-3.96-1.6402l-.7233-1.7463a1.034 1.034 0 0 0-.5585-.5597L2.873 18.101a3.0327 3.0327 0 0 1-1.642-3.9605l.7222-1.7438a1.034 1.034 0 0 0-.0006-.7902l-.7214-1.7468a3.0328 3.0328 0 0 1 1.6415-3.9635l1.7439-.7224a1.034 1.034 0 0 0 .5591-.5572l.7226-1.7445A3.033 3.033 0 0 1 7.5395 1.231m9.1676 7.4762c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-8 8c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM7.5 9c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5S7.5 9.8284 7.5 9m6 6c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Sale04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m14.5305 2.394-1.2475-.958c-.7563-.5808-1.8099-.582-2.5667.0006l-1.245.956a.117.117 0 0 1-.0836.0226L7.8273 2.21c-.9462-.1247-1.857.4024-2.2222 1.2826l-.5993 1.4518a.117.117 0 0 1-.0616.0617l-1.4517.5993c-.8802.3652-1.4074 1.2757-1.2827 2.2219l.2053 1.5604a.112.112 0 0 1-.021.081l-.958 1.2478A2.106 2.106 0 0 0 1 12.0004a2.103 2.103 0 0 0 .4361 1.2832l.958 1.2478a.112.112 0 0 1 .021.0809l-.2053 1.5605c-.1247.9461.4025 1.8566 1.2827 2.2218l1.4517.5994a.117.117 0 0 1 .0616.0616l.5993 1.4518c.3651.8802 1.276 1.4074 2.2222 1.2826l1.5604-.2053a.117.117 0 0 1 .0836.0227l1.245.956c.7568.5826 1.8104.5813 2.5667.0005l1.2475-.9579a.1.1 0 0 1 .0737-.02l.0057.0008 1.5617.2055c.9447.1245 1.8586-.4013 2.223-1.2846l.6011-1.4534a.103.103 0 0 1 .0566-.0566l.001-.0005 1.4542-.6015c.8802-.3652 1.4074-1.2757 1.2827-2.2218l-.2058-1.5642a.105.105 0 0 1 .0213-.078l.9574-1.247A2.102 2.102 0 0 0 23 12a2.1 2.1 0 0 0-.4369-1.2847l-.9574-1.247a.105.105 0 0 1-.0213-.0781l.2058-1.5641c.1247-.9462-.4025-1.8567-1.2827-2.2219l-1.4542-.6015-.001-.0004a.103.103 0 0 1-.0566-.0566l-.6011-1.4535c-.3644-.8833-1.2783-1.409-2.223-1.2845l-1.5617.2054-.0057.0008a.1.1 0 0 1-.0737-.02m2.1766 6.3131c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-8 8c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM7.5 9c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5S7.5 9.8284 7.5 9m6 6c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Scales01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v4.153l-5.146.8577a1 1 0 0 0-.7223.4932L1.527 14.8124c-.1312.2292-.247.4316-.331.6524a3 3 0 0 0-.1596.601c-.0366.2333-.0365.4665-.0363.7306v.2124C1.0048 19.7662 3.2415 22 6 22c2.7614 0 5-2.2386 5-5v-.252c0-.2445-.0019-.4633-.0363-.6822a3 3 0 0 0-.1596-.601c-.084-.2208-.1998-.4232-.331-.6524L7.5806 9.7505l8.506-1.4177-2.5597 4.4796c-.1313.2292-.247.4316-.331.6524a3 3 0 0 0-.1596.601c-.0366.2333-.0365.4664-.0363.7306v.2124C13.0048 17.7662 15.2415 20 18 20c2.7614 0 5-2.2386 5-5v-.2608c0-.2409-.0024-.4571-.0363-.6734a3 3 0 0 0-.1596-.601c-.084-.2208-.1998-.4232-.331-.6524l-3.5952-6.2916A.9999.9999 0 0 0 18.0034 6H18q-.0932 0-.1829.0168L13 6.8197zm7.2768 10L18 9.0156 15.7232 13zm-12 2L6 11.0156 3.7232 15z"
      clipRule="evenodd"
    />
  </svg>
);

export const Scales02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.645 5.5H4c-.5523 0-1-.4477-1-1s.4477-1 1-1h4.645C9.0751 2.0543 10.4144 1 12 1s2.9248 1.0543 3.3551 2.5H20c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4.6449C15.0191 6.6289 14.1289 7.519 13 7.855V20h7c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1s.4477-1 1-1h7V7.855C9.8711 7.519 8.981 6.629 8.645 5.5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 7a1 1 0 0 1 .8391.4561l3.0038 4.6344c.1629.2511.3097.4773.4303.8342.0522.1545.0891.3467.1113.4845.0223.1379.0476.3319.0466.495-.0009.1417-.0059.2684-.0225.3924-.0166.1244-.0423.2223-.0582.2831l-.0024.0094C9.3396 16.5355 7.6014 18 5.5 18s-3.8397-1.4645-4.348-3.4109l-.0024-.0093a2.2 2.2 0 0 1-.0582-.2832c-.0166-.124-.0216-.2507-.0225-.3924-.001-.1631.0243-.3571.0465-.495.0223-.1378.0591-.33.1113-.4845.1207-.3569.2675-.5831.4303-.8342l3.0038-4.6344A1 1 0 0 1 5.5 7m0 2.8386L4.099 12H6.901zM19.3391 7.4561a1 1 0 0 0-1.6783 0l-3.0038 4.6344c-.1628.2511-.3096.4773-.4303.8342-.0522.1545-.0891.3467-.1113.4845-.0222.1379-.0475.3319-.0465.495.0009.1417.0059.2684.0225.3924.0166.1244.0423.2224.0582.2832l.0024.0093C14.6603 16.5355 16.3986 18 18.5 18s3.8396-1.4645 4.348-3.4109l.0024-.0093c.0159-.0607.0416-.1588.0582-.2832.0166-.124.0216-.2507.0225-.3924.001-.1631-.0243-.3571-.0466-.495-.0222-.1378-.0591-.33-.1113-.4845-.1206-.3569-.2674-.5831-.4303-.8342zM17.0991 12 18.5 9.8386 19.9009 12z"
      clipRule="evenodd"
    />
  </svg>
);

export const ShoppingBag01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.8.9998 6.7386.9997c-.2269-.0008-.5124-.0017-.7878.077a2 2 0 0 0-.6597.3298c-.2282.1731-.3987.4021-.5343.584l-.0368.0493L3.2498 4c-.1364.182-.2046.2729-.23.3604-.0711.2443.0656.5177.3036.6075C3.4087 5 3.5238 5 3.754 5H20.246c.2302 0 .3453 0 .4305-.0321.2381-.0898.3748-.3632.3037-.6075-.0254-.0875-.0936-.1785-.2301-.3604L19.28 2.0398l-.0367-.0493c-.1356-.1819-.3062-.4109-.5343-.584a2 2 0 0 0-.6597-.3298c-.2754-.0787-.5609-.0778-.7878-.077H6.8"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.0001 8.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C21.2401 7 20.9601 7 20.4001 7H3.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 7.76 2 8.04 2 8.6v10.2383c0 .5272 0 .9819.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7717.2641 1.167.2964.3746.0306.8293.0306 1.3565.0306h11.6771c.5271 0 .9819 0 1.3565-.0306.3953-.0323.7885-.1036 1.1669-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2642-.7716.2965-1.167.0306-.3746.0305-.8293.0305-1.3564zm-14 1.4c.5522 0 1 .4477 1 1A3 3 0 0 0 15 11c0-.5523.4477-1 1-1s1 .4477 1 1a5 5 0 1 1-10 0c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ShoppingBag02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.0981 5.0094C7.5577 2.7224 9.5777 1 12 1s4.4423 1.7225 4.9019 4.0094c.2223.0058.428.015.6178.0299.5226.041 1.0038.1288 1.4637.3472a4 4 0 0 1 1.7224 1.5684c.2603.4375.3927.9084.4822 1.4249.086.4956.1431 1.1047.212 1.8399l.6077 6.4822c.0819.8731.1492 1.5907.1544 2.176.0055.6056-.052 1.1672-.2814 1.7011a4 4 0 0 1-1.7599 1.9327c-.5102.2782-1.064.3879-1.6674.439C17.8701 23 17.1493 23 16.2724 23H7.7276c-.8769 0-1.5977 0-2.181-.0493-.6034-.0511-1.1572-.1608-1.6674-.439a4 4 0 0 1-1.76-1.9327c-.2293-.5339-.2868-1.0955-.2813-1.7011.0053-.5853.0726-1.3029.1544-2.176L2.6 10.2197c.069-.7352.126-1.3443.212-1.84.0896-.5164.222-.9873.4823-1.4248a4 4 0 0 1 1.7223-1.5684c.46-.2184.9411-.3062 1.4637-.3472.1898-.0149.3955-.0241.6178-.0299M9.1707 5C9.5825 3.8348 10.6938 3 12 3s2.4175.8348 2.8293 2z"
      clipRule="evenodd"
    />
  </svg>
);

export const ShoppingBag03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.3774 2h7.2453c.7455 0 1.363 0 1.8687.0398.5269.0415 1.012.1306 1.4747.352a4 4 0 0 1 1.7259 1.588c.2591.4428.3881.9188.4732 1.4404.0817.5007.133 1.116.1949 1.859l.7068 8.4822c.0722.8657.1315 1.5776.1309 2.1581-.0006.6008-.0629 1.1576-.2946 1.6861a4 4 0 0 1-1.7593 1.912c-.5075.2747-1.0571.3831-1.6558.4336C17.9096 22 17.1953 22 16.3266 22H7.6734c-.8686 0-1.583 0-2.1614-.0488-.5988-.0505-1.1484-.1589-1.6559-.4336a4 4 0 0 1-1.7593-1.912c-.2316-.5285-.294-1.0853-.2946-1.6861-.0006-.5806.0588-1.2924.1309-2.1581l.7068-8.4822c.062-.743.1132-1.3583.195-1.859.085-.5216.214-.9976.4732-1.4404a4 4 0 0 1 1.7258-1.588c.4628-.2214.9478-.3105 1.4747-.352C7.0143 2 7.6318 2 8.3773 2M9 8c0-.5523-.4477-1-1-1s-1 .4477-1 1a5 5 0 0 0 5 5 4.9997 4.9997 0 0 0 5-5c0-.5523-.4477-1-1-1s-1 .4477-1 1a3 3 0 0 1-6 0"
      clipRule="evenodd"
    />
  </svg>
);

export const ShoppingCart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 3h1.1327l.4483 3.1381 1.0562 7.7632c.0627.4606.1171.861.188 1.1903.0752.3499.1829.6927.3888 1.0169a3 3 0 0 0 1.2799 1.1176c.349.1603.7032.2207 1.06.2481.3359.0258.74.0258 1.2048.0258h8.6274c.4421 0 .8275 0 1.1489-.024.3422-.0255.6817-.0819 1.0189-.2304a3 3 0 0 0 1.262-1.0443c.209-.3035.3279-.6264.417-.9578.0837-.3112.1558-.6897.2385-1.124l1.335-7.0087c.0266-.1395.0574-.3006.0718-.4426.0162-.1597.0256-.4025-.068-.6677a1.5 1.5 0 0 0-.6591-.7964c-.243-.1417-.4833-.1779-.6432-.1918C21.3657 4.9999 21.2018 5 21.0597 5H5.4387l-.3536-2.475c-.0146-.1033-.0326-.2293-.0572-.3401-.029-.1306-.081-.3109-.1992-.495a1.5 1.5 0 0 0-.6389-.5542c-.199-.091-.3848-.117-.5182-.1271C3.5584.9999 3.4311 1 3.327 1H2c-.5523 0-1 .4477-1 1s.4477 1 1 1M7 21c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M15 21c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
    />
  </svg>
);

export const ShoppingCart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 3h1.1455l2.7633 17.501c.016.1015.0356.2258.0614.3351.0305.1289.0844.3062.203.487.1563.2381.377.4267.6366.5439.197.089.3807.1146.5127.1246.112.0085.2378.0085.3406.0084H19c.5523 0 1-.4477 1-1s-.4477-1-1-1H7.8545l-.3158-2h9.825c.4456 0 .8339 0 1.1576-.0242.3444-.0259.6862-.0829 1.0254-.2332a3 3 0 0 0 1.265-1.0558c.2086-.3067.3258-.6328.4128-.9671.0818-.3141.1512-.696.2309-1.1344l1.3617-7.4892c.0253-.1387.0545-.299.0677-.4402.0148-.1593.0221-.4006-.0725-.6637a1.5 1.5 0 0 0-.6594-.79c-.2418-.1402-.4806-.1762-.6399-.19C21.3716 4.9999 21.2087 5 21.0678 5H5.4861l-.395-2.501c-.0159-.1015-.0355-.2257-.0613-.335-.0305-.129-.0844-.3063-.203-.4871a1.5 1.5 0 0 0-.6366-.544c-.197-.089-.3807-.1144-.5127-.1245C3.5655 1 3.4397 1 3.3369 1H2c-.5523 0-1 .4477-1 1s.4477 1 1 1"
      clipRule="evenodd"
    />
  </svg>
);

export const ShoppingCart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 3h1.0606l.8958 14.3343c.007.1122.0154.2474.0324.3666.0199.1391.0606.3349.1754.5378.1497.2646.3763.4774.6497.6103.2096.102.4077.1304.5477.1416.12.0095.2556.0095.368.0094H19c.5523 0 1-.4477 1-1s-.4477-1-1-1H5.9395l-.125-2h12.3573c.4757 0 .8887 0 1.2314-.0266.3637-.0283.7248-.0906 1.0792-.2566a3 3 0 0 0 1.2871-1.1521c.2041-.3339.306-.6859.3743-1.0442.0643-.3377.1099-.748.1624-1.2207l.5917-5.326c.0147-.1312.0318-.285.0353-.4205.004-.1545-.0047-.3834-.1067-.6288a1.5 1.5 0 0 0-.6602-.7377c-.2326-.1284-.4591-.1623-.6132-.1754C21.418 3.9999 21.2633 4 21.1313 4H5.127l-.0834-1.3343c-.007-.1121-.0154-.2474-.0324-.3665-.0199-.1391-.0606-.335-.1754-.5379a1.5 1.5 0 0 0-.6497-.6103c-.2096-.102-.4077-.1304-.5477-.1416C3.5184 1 3.3829 1 3.2705 1H2c-.5523 0-1 .4477-1 1s.4477 1 1 1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M7.5 20c-.8284 0-1.5.6716-1.5 1.5S6.6716 23 7.5 23 9 22.3284 9 21.5 8.3284 20 7.5 20M16.5 20c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
    />
  </svg>
);

export const Tag01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.327 2.6381a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 1 4.6343 1 5.1614 1h4.5964c.4069-.0004.7656-.0008 1.1141.0829.3061.0735.5987.1947.8671.3592.3056.1872.559.4411.8465.7291l7.7567 7.7568c.5692.5692 1.039 1.0389 1.3904 1.4529.365.4299.6606.865.829 1.383a4 4 0 0 1 0 2.4722c-.1684.518-.464.9531-.829 1.383-.3514.414-.8212.8837-1.3904 1.4529l-2.2702 2.2702c-.5692.5692-1.039 1.039-1.4529 1.3904-.4299.365-.865.6607-1.3831.829a4 4 0 0 1-2.4721 0c-.518-.1683-.9531-.464-1.383-.829-.414-.3514-.8837-.8212-1.453-1.3904l-7.7567-7.7567c-.288-.2875-.542-.5409-.7291-.8464a3 3 0 0 1-.3592-.8672c-.0837-.3484-.0833-.7072-.083-1.114V5.1615c0-.5272 0-.982.0307-1.3565.0323-.3954.1036-.7886.2964-1.167M8 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Tag02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.442 4.761c.1873-.3055.4412-.559.7292-.8464l1.7433-1.7433c.2874-.288.5409-.5419.8464-.7291a3 3 0 0 1 .8672-.3592C5.9765.9993 6.3353.9997 6.742 1h3.0157c.4069-.0003.7656-.0007 1.1141.083.3061.0735.5987.1947.8671.3592.3056.1872.559.4411.8465.7291l7.7567 7.7568c.5692.5692 1.039 1.0389 1.3904 1.4529.365.4299.6606.865.829 1.383a4 4 0 0 1 0 2.4722c-.1684.518-.464.9531-.829 1.383-.3514.4139-.8212.8837-1.3904 1.4529l-2.2703 2.2702c-.5691.5692-1.0389 1.039-1.4528 1.3904-.43.365-.865.6607-1.3831.829a4 4 0 0 1-2.4721 0c-.518-.1683-.9531-.464-1.383-.829-.414-.3514-.8838-.8212-1.453-1.3904l-7.7567-7.7567c-.288-.2875-.542-.5409-.7291-.8464a3 3 0 0 1-.3592-.8672c-.0837-.3484-.0833-.7072-.083-1.114V6.7422c-.0003-.407-.0007-.7657.083-1.1141a3 3 0 0 1 .3592-.8672M8 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Tag03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 2c0-.5522.4477-1 1-1h4.1137c.6349-.0003 1.1147-.0005 1.5774.1106.4082.098.7984.2596 1.1563.4789.4057.2486.7448.588 1.1936 1.0373l7.6661 7.6662c.3905.3905.3905 1.0236 0 1.4142s-1.0237.3905-1.4142 0l-7.5941-7.5941c-.5525-.5526-.7181-.709-.8964-.8183a2 2 0 0 0-.5782-.2395c-.2034-.0488-.4311-.0552-1.2124-.0552H6c-.5523 0-1-.4478-1-1"
    />
    <path
      fill="currentColor"
      d="M3.638 4.8271a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7717-.2965 1.167C2 7.6797 2 8.1344 2 8.6616v2.0964c-.0005.4069-.0008.7656.0829 1.1141.0735.3061.1947.5987.3592.8671.1872.3055.4411.559.729.8464l7.8863 7.8862c.3727.3727.6943.6943.9808.9375.3024.2567.6308.4844 1.0347.6156a3 3 0 0 0 1.8541 0c.4039-.1312.7324-.3589 1.0348-.6156.2865-.2432.608-.5648.9807-.9375l2.5291-2.5291c.3728-.3727.6943-.6943.9376-.9808.2567-.3024.4843-.6308.6155-1.0347a3 3 0 0 0 0-1.8541c-.1312-.4039-.3588-.7324-.6155-1.0348-.2433-.2865-.5648-.608-.9376-.9807l-7.3861-7.3862c-.2875-.288-.5409-.542-.8465-.7292a3 3 0 0 0-.8671-.3592c-.3485-.0836-.7072-.0833-1.1141-.083l-3.0964.0001c-.5271 0-.9819 0-1.3565.0306-.3953.0323-.7885.1036-1.1669.2964"
    />
  </svg>
);

export const Wallet01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.1615 3h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167q.0039.0477.0073.0956c.0362.5202.0544.7804-.0486 1.0094-.0866.1926-.2534.3716-.4396.4713C22.2672 7.5 21.9781 7.5 21.4 7.5H2.6c-.5781 0-.8672 0-1.0885-.1187-.1862-.0998-.353-.2787-.4396-.4713-.103-.229-.0848-.4892-.0486-1.0094a8 8 0 0 1 .0073-.0956c.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 3 4.6343 3 5.1615 3M1.8 9.5c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C1 9.88 1 10.02 1 10.3v.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545h3.821c.4684-.0002.8227-.0003 1.1726.0621.3091.0551.6106.1464.8984.272.3258.1422.6204.3388 1.01.5987l.6435.429c.478.3187.6192.4085.7627.4712.1438.0628.2946.1084.4491.136.1541.0274.3214.031.896.031h1.0934c.5746 0 .7418-.0036.8959-.031a2 2 0 0 0 .4492-.136c.1435-.0627.2846-.1525.7627-.4712l.6434-.429c.3897-.2599.6843-.4565 1.0101-.5987a4 4 0 0 1 .8984-.272c.3499-.0624.7041-.0623 1.1725-.0621H22.2c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C23 11.12 23 10.98 23 10.7v-.4c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C22.62 9.5 22.48 9.5 22.2 9.5zM23 15.1c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437c-.2139-.109-.4939-.109-1.054-.109h-2.9467c-.5746 0-.7419.0036-.896.031a2 2 0 0 0-.4491.136c-.1435.0627-.2846.1525-.7627.4712l-.6434.429c-.3897.2599-.6843.4565-1.0101.5987a4 4 0 0 1-.8984.272c-.3499.0624-.7041.0623-1.1725.0621H11.379c-.4685.0002-.8227.0003-1.1726-.0621a4 4 0 0 1-.8984-.272c-.3258-.1422-.6204-.3388-1.01-.5987l-.6435-.429c-.478-.3187-.6192-.4085-.7627-.4712a2 2 0 0 0-.4492-.136c-.154-.0274-.3213-.031-.896-.031H2.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 14.2599 1 14.5399 1 15.1v1.7385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 21 4.6343 21 5.1614 21h13.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 17.8205 23 17.3657 23 16.8386z"
    />
  </svg>
);

export const Wallet02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 14.9998v2.8388c0 .5271 0 .9819.0306 1.3564.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386v-6.6772c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 7 18.3657 7 17.8385 7H17V4.4598c0-.3808 0-.732-.0261-1.018-.027-.2963-.0914-.6701-.3243-1.01a2 2 0 0 0-1.3141-.8408c-.4062-.069-.7726.0292-1.053.1288-.2706.0961-.5894.2433-.9352.403L4.323 6.2876c-.5568.256-1.0463.4811-1.4199.8462a3 3 0 0 0-.7299 1.1408C1.9983 8.7669 1.999 9.3057 2 9.9185zM14.952 3.6044c-.1738.0617-.4083.1689-.8035.3513L7.5525 7H15V4.5004c0-.4352-.001-.693-.0178-.8767l-.0028-.0288zM16.5 13c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Wallet03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 4c-.5523 0-1 .4477-1 1s.4477 1 1 1h14c1.6569 0 3 1.3431 3 3v10c0 1.6569-1.3431 3-3 3H5c-1.6568 0-3-1.3431-3-3V5c0-1.6568 1.3432-3 3-3h12c.5523 0 1 .4477 1 1s-.4477 1-1 1zm11.5 8.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5S18 14.8284 18 14s-.6716-1.5-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Wallet04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.8385 3H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 6.1795 1 6.6343 1 7.1614v9.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 21 4.6343 21 5.1614 21h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C21 17.8205 21 17.3657 21 16.8386v-1.51a3 3 0 0 0 1.9424-2.2432c.0582-.2929.058-.6207.0577-1.0014L23 12.0001l.0001-.0839c.0003-.3807.0005-.7085-.0577-1.0014A3 3 0 0 0 21 8.6716V7.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C17.8205 3 17.3657 3 16.8385 3m-.0336 7.5193c.0723-.0144.1825-.0192.6951-.0192h2c.5126 0 .6229.0048.6951.0192a1 1 0 0 1 .7857.7857c.0144.0722.0192.1825.0192.6951s-.0048.6228-.0192.6951a1 1 0 0 1-.7857.7857c-.0722.0143-.1825.0192-.6951.0192h-2c-.5126 0-.6228-.0049-.6951-.0192a1 1 0 0 1-.7857-.7857c-.0143-.0723-.0192-.1825-.0192-.6951s.0049-.6229.0192-.6951a1 1 0 0 1 .7857-.7857"
      clipRule="evenodd"
    />
  </svg>
);

export const Wallet05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.6702 5.5018c-.1723.0024-.3338.008-.4782.0209-.2716.0242-.6042.0817-.9197.2772a2 2 0 0 0-.8707 1.1543c-.1013.357-.0652.6927-.0139.9604.0564.294.0846.441.1703.5883.1118.1921.3234.367.5331.4407C4.252 9 4.4337 9 4.7972 9h14.4056c.3635 0 .5453 0 .706-.0564.2098-.0737.4214-.2485.5332-.4407.0857-.1473.1139-.2943.1702-.5883.0513-.2677.0874-.6033-.0139-.9604a2 2 0 0 0-.8706-1.1543c-.3156-.1955-.6482-.253-.9197-.2772-.1444-.0129-.3059-.0185-.4782-.0209A3.03 3.03 0 0 0 18.5 4.5c0-.7899-.308-1.551-.8619-2.115-.5544-.5645-1.3103-.885-2.1024-.885C13.741 1.5 12.6275 2.7185 12 3.7722 11.3725 2.7185 10.259 1.5 8.4643 1.5c-.792 0-1.548.3205-2.1024.885C5.808 2.949 5.5 3.7102 5.5 4.5c0 .344.0584.6826.1702 1.0018m2.1186-1.7153c.1823-.1856.4256-.2865.6755-.2865.8097 0 1.4334.5758 1.9193 1.4753.095.1759.1783.3533.2507.5247h-2.17c-.2499 0-.4932-.1009-.6755-.2865C7.6058 5.0273 7.5 4.771 7.5 4.5s.1059-.5273.2888-.7135M13.3658 5.5a6 6 0 0 1 .2507-.5247C14.1023 4.0758 14.726 3.5 15.5357 3.5c.2499 0 .4933.1009.6755.2865.1829.1862.2888.4425.2888.7135s-.1059.5273-.2888.7135c-.1822.1856-.4256.2865-.6755.2865z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M21.2323 11.7768c-.1699-.2833-.2549-.4249-.3719-.5278a1 1 0 0 0-.3561-.2016C20.3559 11 20.1907 11 19.8603 11H4.1397c-.3303 0-.4955 0-.644.0474a1 1 0 0 0-.356.2016c-.117.1029-.202.2445-.372.5278l-.5476.9127c-.3615.6018-.6346 1.0563-.78 1.5586a4 4 0 0 0-.1497 1.3644c.033.5219.2009 1.0248.4232 1.6907l.3.8999c.3372 1.0145.5911 1.778 1.0802 2.3629a4 4 0 0 0 1.6045 1.1564c.7096.2791 1.5142.2785 2.5833.2777h9.4369c1.069.0008 1.8737.0014 2.5833-.2776a4 4 0 0 0 1.6044-1.1565c.4891-.5849.743-1.3484 1.0803-2.3629l.2999-.8999c.2224-.6659.3903-1.1688.4233-1.6907a4 4 0 0 0-.1498-1.3644c-.1454-.5022-.4184-.9568-.7799-1.5585z"
    />
  </svg>
);

export const Activity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 2a1 1 0 0 1 .9487.6838L15 17.8377l2.0513-6.1539A1 1 0 0 1 18 11h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3.2792l-2.7721 8.3162a1 1 0 0 1-1.8974 0L9 6.1622l-2.0513 6.154A1 1 0 0 1 6 13H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h3.2792l2.7721-8.3162A1 1 0 0 1 9 2"
      clipRule="evenodd"
    />
  </svg>
);

export const ActivityHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.505 3.5497c2.6874-2.296 6.1479-1.8776 8.4878.1673 2.3372-2.0457 5.7608-2.4345 8.478-.176 2.9736 2.4714 3.3307 6.6865 1.0409 9.633-.7951 1.0231-2.2744 2.5087-3.7573 3.9228-1.4995 1.43-3.0582 2.8389-4.0503 3.7242l-.022.0196c-.1625.1451-.3251.2902-.475.4039-.1685.1277-.3754.2592-.6393.3384a2.015 2.015 0 0 1-1.1493 0c-.2639-.0792-.4708-.2107-.6393-.3384-.1499-.1137-.3124-.2587-.475-.4039l-.022-.0196c-.9921-.8853-2.5508-2.2942-4.0503-3.7242-1.4829-1.4141-2.9623-2.8997-3.7573-3.9228C.176 10.2161.5983 6.0333 3.505 3.5497m8.4437 4.634a1 1 0 0 0-1.8431-.1309L8.882 10.5H8.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h1a1 1 0 0 0 .8944-.5528l.4204-.8406 1.2365 3.7096a1.0002 1.0002 0 0 0 1.8431.131L15.118 12.5h.382c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1a1 1 0 0 0-.8944.5528l-.4204.8407z"
      clipRule="evenodd"
    />
  </svg>
);

export const Anchor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 5c0 1.8638-1.2748 3.43-3 3.874v12.0703a9 9 0 0 0 5.364-2.5803A9 9 0 0 0 20.9443 13H19c-.5523 0-1-.4477-1-1s.4477-1 1-1h3c.5523 0 1 .4477 1 1a11 11 0 1 1-22 0 1 1 0 0 1 1-1h3c.5523 0 1 .4477 1 1s-.4477 1-1 1H3.0557A9.0005 9.0005 0 0 0 11 20.9443V8.874C9.2748 8.43 8 6.8638 8 5c0-2.2091 1.7909-4 4-4s4 1.7909 4 4m-4-2c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Archive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 5c0-1.6568 1.3432-3 3-3h16c1.6569 0 3 1.3432 3 3s-1.3431 3-3 3H4C2.3432 8 1 6.6569 1 5M4 10c-.5523 0-1 .4477-1 1v5.2413c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 22 7.9537 22 8.7587 22h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 17.7106 21 17.0463 21 16.2413V11c0-.5523-.4477-1-1-1zm6 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Asterisk01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v7.5858l-5.364-5.364c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4143L9.5858 11H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h7.5858l-5.364 5.364c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L11 14.4142V22c0 .5523.4477 1 1 1s1-.4477 1-1v-7.5858l5.364 5.364c.3905.3905 1.0236.3905 1.4142 0s.3905-1.0237 0-1.4142L14.4142 13H22c.5523 0 1-.4477 1-1s-.4477-1-1-1h-7.5858l5.364-5.364c.3905-.3905.3905-1.0236 0-1.4142s-1.0237-.3905-1.4142 0L13 9.5859z"
    />
  </svg>
);

export const Asterisk02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 4c0-.5523-.4477-1-1-1s-1 .4477-1 1v5.5858l-4.2929-4.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143L9.5858 11H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h5.5858l-4.293 4.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0L11 14.4142V20c0 .5523.4477 1 1 1s1-.4477 1-1v-5.5858l4.2929 4.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L14.4142 13H20c.5523 0 1-.4477 1-1s-.4477-1-1-1h-5.5858l4.2929-4.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L13 9.5858z"
    />
  </svg>
);

export const AtSign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.4999 1.2885a11 11 0 1 0 4.1881 19.4454c.4385-.3358.5217-.9634.1859-1.4019s-.9634-.5217-1.4019-.1859a9.0002 9.0002 0 0 1-14.2702-5.2505A9 9 0 1 1 21 12.0001V13a2 2 0 0 1-4 0V8c0-.5523-.4477-1-1-1s-.9998.4475-1 .9996A4.978 4.978 0 0 0 12 7c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5c1.4881 0 2.8244-.6501 3.7403-1.6817a3.9996 3.9996 0 0 0 6.0881.5101A4 4 0 0 0 23 13v-1.0001a11.0005 11.0005 0 0 0-8.5001-10.7114M15 11.9958v.0084C14.9977 13.6591 13.6555 15 12 15c-1.6569 0-3-1.3431-3-3s1.3431-3 3-3c1.6555 0 2.9977 1.3409 3 2.9958"
      clipRule="evenodd"
    />
  </svg>
);

export const Bookmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.7587 2h4.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C20 6.2894 20 6.9537 20 7.7587V21a1 1 0 0 1-1.4961.8682L12 18.1518l-6.5039 3.7164A1 1 0 0 1 4 21V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C8.2894 2 8.9537 2 9.7587 2"
      clipRule="evenodd"
    />
  </svg>
);

export const BookmarkAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.2413 2H9.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C4 6.2894 4 6.9537 4 7.7587V21a1 1 0 0 0 1.4961.8682L12 18.1518l6.5039 3.7164A.9998.9998 0 0 0 20 21V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C15.7106 2 15.0463 2 14.2413 2M12 6c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2V7c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const BookmarkCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.2413 2H9.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C4 6.2894 4 6.9537 4 7.7587V21a1 1 0 0 0 1.4961.8682L12 18.1518l6.5039 3.7164A.9998.9998 0 0 0 20 21V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C15.7106 2 15.0463 2 14.2413 2m1.9658 6.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 11.0858l-1.2929-1.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const BookmarkMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.2413 2H9.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C4 6.2894 4 6.9537 4 7.7587V21a1 1 0 0 0 1.4961.8682L12 18.1518l6.5039 3.7164A.9998.9998 0 0 0 20 21V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C15.7106 2 15.0463 2 14.2413 2M9 9c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const BookmarkX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.2413 2H9.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C4 6.2894 4 6.9537 4 7.7587V21a1 1 0 0 0 1.4961.8682L12 18.1518l6.5039 3.7164A.9998.9998 0 0 0 20 21V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C15.7106 2 15.0463 2 14.2413 2M8.7929 6.7929c.3905-.3905 1.0237-.3905 1.4142 0L12 8.5858l1.7929-1.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L13.4142 10l1.7929 1.7929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 11.4142l-1.7929 1.7929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L10.5858 10l-1.793-1.7929c-.3904-.3905-.3904-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const Building01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.1615 2h7.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C20 5.1795 20 5.6344 20 6.1615V20h1c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h1V6.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C7.1795 2 7.6343 2 8.1615 2M8 8c0-.8284.6716-1.5 1.5-1.5S11 7.1716 11 8s-.6716 1.5-1.5 1.5S8 8.8284 8 8m5.4 6h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 14.7599 9 15.0399 9 15.6V20h6v-4.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C14.2401 14 13.9601 14 13.4 14m1.1-7.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5S16 8.8284 16 8s-.6716-1.5-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Building02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.1615 2h11.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1795 22 5.6343 22 6.1614V7c0 .9263-.9969 2-2.6667 2s-2.6666-1.0737-2.6666-2c0-.5523-.4477-1-1-1s-1 .4477-1 1c0 .9263-.997 2-2.6667 2S9.3333 7.9263 9.3333 7c0-.5523-.4477-1-1-1s-1 .4477-1 1c0 .9263-.9969 2-2.6666 2C2.9969 9 2 7.9263 2 7v-.8386c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1795 2 5.6343 2 6.1615 2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.3333 11c.9504 0 1.8858-.2571 2.6667-.7179v7.5565c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C18.8205 22 18.3657 22 17.8386 22H6.1614c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8386v-7.5565c.7809.4608 1.7163.7179 2.6667.7179 1.4054 0 2.778-.5621 3.6666-1.514C9.222 10.4379 10.5946 11 12 11s2.778-.5621 3.6667-1.514c.8886.9519 2.2612 1.514 3.6666 1.514M10.6 14h2.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054V20H9v-4.4c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C9.76 14 10.04 14 10.6 14"
      clipRule="evenodd"
    />
  </svg>
);

export const Building03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.1615 2h9.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C21 5.1795 21 5.6343 21 6.1614V20h1c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h1V6.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C6.1795 2 6.6343 2 7.1615 2M7.25 6c-.5523 0-1 .4477-1 1s.4477 1 1 1H10c.5523 0 1-.4477 1-1s-.4477-1-1-1zm0 4c-.5523 0-1 .4477-1 1s.4477 1 1 1H10c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1H10c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.25c-.5523 0-1-.4477-1-1M14 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h2.75c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h2.75c.5523 0 1 .4477 1 1s-.4477 1-1 1H14c-.5523 0-1-.4477-1-1m1 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h2.75c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Building04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.1615 2h5.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C19 5.1795 19 5.6344 19 6.1615V20h1c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1s.4477-1 1-1h1V6.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C8.1795 2 8.6343 2 9.1615 2M8 7c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1m1 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Building05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.8386 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1796 2 5.6343 2 6.1615V20c-.5523 0-1 .4477-1 1s.4477 1 1 1h20c.5523 0 1-.4477 1-1s-.4477-1-1-1v-5.8385c0-.5272 0-.9819-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 10 18.3657 10 17.8385 10H14V6.1615c0-.5272 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C10.8205 2 10.3657 2 9.8385 2M5 7c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1H6c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1H6c-.5523 0-1-.4477-1-1m1 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Building06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.1615 2h3.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1796 22 5.6343 22 6.1615V20c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1s.4477-1 1-1v-5.8385c0-.5272 0-.9819.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1795 10 5.6343 10 6.1615 10H10V6.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C13.1795 2 13.6343 2 14.1615 2M19 7c0-.5523-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1m0 4c0-.5523-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1m-1 3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4c-.5523 0-1-.4477-1-1s.4477-1 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Building07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.3385 2h-2.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C6.5 5.1796 6.5 5.6343 6.5 6.1615V10H4.568c-.2523 0-.498 0-.7062.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2715-.1824.5412-.201.7698-.017.2081-.017.4539-.017.7063V20c-.5523 0-1 .4477-1 1s.4477 1 1 1h20c.5523 0 1-.4477 1-1s-.4477-1-1-1v-7.432c0-.2523.0001-.4981-.0169-.7062-.0187-.2286-.0628-.4983-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201-.2081-.017-.4539-.017-.7063-.017H17.5V6.1613c0-.527 0-.9818-.0306-1.3563-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C14.3205 2 13.8657 2 13.3385 2M10 7c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1m1 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Building08 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 21c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M6 9c.5523 0 1 .4477 1 1v8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-8c0-.5523.4477-1 1-1M10 9c.5523 0 1 .4477 1 1v8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-8c0-.5523.4477-1 1-1M14 9c.5523 0 1 .4477 1 1v8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-8c0-.5523.4477-1 1-1M18 9c.5523 0 1 .4477 1 1v8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-8c0-.5523.4477-1 1-1M11.6676 1.1269a1.5 1.5 0 0 1 .6648 0c.2598.059.4838.2021.5918.2711l.0298.019 7.576 4.735A1 1 0 0 1 20 8H4a1 1 0 0 1-.53-1.848l7.576-4.735.0298-.019c.108-.069.332-.212.5918-.2711"
      clipRule="evenodd"
    />
  </svg>
);

export const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.7071 5.2929c.3905.3905.3905 1.0237 0 1.4142l-11 11c-.3905.3905-1.0237.3905-1.4142 0l-5-5c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L9 15.5858l10.2929-10.293c.3905-.3904 1.0237-.3904 1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const CheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m5.2071 8.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L10.5 13.5858l-2.2929-2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const CheckCircleBroken = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11c0-1.4512-.281-2.8368-.7916-4.1053-.2134-.53-.32-.795-.5725-.9662-.1999-.1355-.5168-.2001-.7538-.1536-.2993.0587-.5321.2917-.9978.7578l-7.1768 7.1841a1.0005 1.0005 0 0 1-1.4146.0003l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0l2.2925 2.2925 6.978-6.9849c.3757-.376.5635-.5641.6352-.81.0575-.1979.0439-.4648-.0336-.6556-.0963-.2374-.2761-.384-.6357-.6769C17.05 1.9251 14.633 1 12 1"
    />
  </svg>
);

export const CheckDone01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.8385 7h-7.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 10.1795 1 10.6343 1 11.1614v7.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 23 4.6342 23 5.1614 23h7.6771c.5271 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C17 19.8205 17 19.3657 17 18.8385v-7.677c0-.5272 0-.9819-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C13.8205 7 13.3657 7 12.8385 7m.3686 6.2071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L8 15.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.8385 1h-7.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C7.003 4.1408 7.0003 4.541 7 5h5.8809c.4886-.0001 1.0184-.0002 1.477.0372.519.0424 1.2047.1474 1.912.5078A5 5 0 0 1 18.455 7.73c.3604.7074.4654 1.3931.5078 1.9121.0375.4586.0373.9884.0372 1.4771V17c.459-.0003.8593-.0031 1.195-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 13.8205 23 13.3658 23 12.8386V5.1615c0-.5271 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 1 19.3657 1 18.8385 1"
    />
  </svg>
);

export const CheckDone02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.8385 7h-7.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C7 10.1795 7 10.6343 7 11.1614v7.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964.3745.0306.8293.0306 1.3564.0306h7.6771c.5271 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 19.8205 23 19.3657 23 18.8385v-7.677c0-.5272 0-.9819-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 7 19.3657 7 18.8385 7m.3686 6.2071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L14 15.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.1615 1h7.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0275.3358.0303.736.0306 1.195h-5.8809c-.4886-.0001-1.0184-.0002-1.477.0372-.519.0424-1.2047.1474-1.912.5078A5 5 0 0 0 5.545 7.73c-.3604.7074-.4654 1.3931-.5078 1.9121-.0375.4586-.0373.9884-.0372 1.4771V17c-.459-.0003-.8593-.0031-1.195-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 13.8205 1 13.3658 1 12.8386V5.1615c0-.5271 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 1 4.6343 1 5.1615 1"
    />
  </svg>
);

export const CheckHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.505 3.5498c2.6874-2.2961 6.1479-1.8777 8.4878.1672 2.3372-2.0456 5.7608-2.4344 8.478-.176 2.9736 2.4715 3.3307 6.6866 1.0409 9.6331-.7951 1.023-2.2744 2.5087-3.7573 3.9228-1.4995 1.43-3.0582 2.8388-4.0503 3.7242l-.022.0195c-.1625.1452-.3251.2903-.475.4039-.1685.1278-.3754.2593-.6393.3385a2.015 2.015 0 0 1-1.1493 0c-.2639-.0792-.4708-.2107-.6393-.3385-.1499-.1136-.3124-.2587-.475-.4038l-.022-.0196c-.9921-.8854-2.5508-2.2942-4.0503-3.7242-1.4829-1.4141-2.9623-2.8998-3.7573-3.9228C.176 10.2162.5983 6.0334 3.505 3.5498M16.2072 9.207c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 11.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const CheckSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2m-.6314 7.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L10.5 13.5858l-2.2929-2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const CheckSquareBroken = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386v-7.6772c0-.1521 0-1.6003-.0007-2.8585-.0004-.5768-.0005-.8652-.1203-1.0053a.503.503 0 0 0-.4194-.1736c-.1839.0145-.3881.2187-.7965.6271l-7.956 7.956c-.3905.3905-1.0237.3905-1.4142 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L12 12.5858l8.4319-8.4193c.279-.2786.4185-.4179.4855-.6882.049-.1976-.014-.5958-.1215-.7687-.147-.2364-.2427-.2852-.4339-.3826-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2"
    />
  </svg>
);

export const CheckVerified01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.1341 2.1543c-1.806-1.539-4.4622-1.539-6.2682 0a2.832 2.832 0 0 1-1.6117.6676c-2.3653.1887-4.2436 2.067-4.4323 4.4323a2.832 2.832 0 0 1-.6676 1.6117c-1.539 1.806-1.539 4.4622 0 6.2682a2.832 2.832 0 0 1 .6676 1.6117c.1887 2.3653 2.067 4.2436 4.4323 4.4323.594.0474 1.158.281 1.6117.6676 1.806 1.5391 4.4622 1.5391 6.2682 0a2.83 2.83 0 0 1 1.6117-.6676c2.3653-.1887 4.2436-2.067 4.4323-4.4323a2.83 2.83 0 0 1 .6676-1.6117c1.5391-1.806 1.5391-4.4622 0-6.2682a2.83 2.83 0 0 1-.6676-1.6117c-.1887-2.3653-2.067-4.2436-4.4323-4.4323a2.832 2.832 0 0 1-1.6117-.6676m1.073 8.0528c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 12.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const CheckVerified02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.0315 12a1.03 1.03 0 0 0-.0788-.3935l-.7215-1.7468a3.0328 3.0328 0 0 1 1.6415-3.9635l1.7439-.7224a1.034 1.034 0 0 0 .5591-.5572l.7226-1.7445A3.0326 3.0326 0 0 1 9.8606 1.231l1.7431.722c.253.1044.5373.1043.7901-.0006l.002-.0008 1.7446-.7196a3.0326 3.0326 0 0 1 3.9617 1.641l.7052 1.7026a1 1 0 0 1 .018.041c.1045.2527.3051.4537.5577.5588l1.7449.7228a3.033 3.033 0 0 1 1.6413 3.9624l-.7224 1.744a1.035 1.035 0 0 0 0 .791l.7224 1.744a3.0327 3.0327 0 0 1-1.6413 3.9624l-1.7449.7228a1.033 1.033 0 0 0-.5577.5589 1 1 0 0 1-.018.0409l-.7052 1.7025a3.0324 3.0324 0 0 1-3.9617 1.6411l-1.7446-.7196-.002-.0008a1.033 1.033 0 0 0-.7901-.0006l-1.743.722a3.0327 3.0327 0 0 1-3.9623-1.6412l-.7227-1.7445a1.034 1.034 0 0 0-.5591-.5572l-1.744-.7224a3.034 3.034 0 0 1-1.6418-1.6416 3.033 3.033 0 0 1 .0004-2.322l.7214-1.7467A1.03 1.03 0 0 0 2.0316 12m14.1756-1.7929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 12.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const CheckVerified03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.596 1.4775A2.297 2.297 0 0 1 12 1a2.297 2.297 0 0 1 1.404.4775l1.1736.9011 1.4708-.1935c1.0351-.1364 2.0309.4404 2.4302 1.4029l.565 1.3687 1.3666.5642.002.0008c.9625.3994 1.5391 1.3956 1.4027 2.4306l-.1934 1.4696.9017 1.1744c.2382.3102.3873.6662.447 1.0337.0435.2679.0394.542-.0123.8088a2.3 2.3 0 0 1-.4347.9649l-.9017 1.1744.1934 1.4696c.1364 1.035-.4402 2.0313-1.4027 2.4306l-.002.0008-1.3666.5642-.565 1.3687c-.3993.9625-1.3951 1.5393-2.4302 1.4029l-1.4708-.1935-1.1736.9011A2.297 2.297 0 0 1 12 23a2.297 2.297 0 0 1-1.404-.4775l-1.1736-.9011-1.4708.1935c-1.0351.1364-2.0309-.4404-2.4302-1.4029l-.565-1.3687-1.3666-.5642-.002-.0008c-.9625-.3993-1.539-1.3956-1.4027-2.4306l.1934-1.4696-.9017-1.1744a2.3 2.3 0 0 1-.4607-1.1315 2.303 2.303 0 0 1 .4607-1.6759l.9017-1.1744-.1934-1.4696c-.1364-1.035.4402-2.0312 1.4027-2.4306l.002-.0008 1.3666-.5642.565-1.3687c.3993-.9625 1.395-1.5393 2.4302-1.4029l1.4708.1935zm5.6111 8.7296c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 12.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const CloudBlank01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.2492 9.143C6.0632 6.1782 8.7764 4 12 4s5.9368 2.1782 6.7508 5.143C21.1861 9.7096 23 11.8925 23 14.5c0 3.0376-2.4624 5.5-5.5 5.5h-11C3.4624 20 1 17.5376 1 14.5c0-2.6075 1.8139-4.7904 4.2492-5.357"
      clipRule="evenodd"
    />
  </svg>
);

export const CloudBlank02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 11.5C1 6.8056 4.8056 3 9.5 3c3.0447 0 5.7141 1.6011 7.2144 4.0035C20.205 7.1166 23 9.9819 23 13.5c0 3.5899-2.9102 6.5-6.5 6.5h-7C4.8056 20 1 16.1944 1 11.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Copy01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.1615 8h6.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3746.0306.8293.0306 1.3565v6.677c0 .5272 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8204 23 19.3657 23 18.8385 23h-6.677c-.5272 0-.9819 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C8 19.8205 8 19.3657 8 18.8385v-6.677c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C11.1795 8 11.6343 8 12.1615 8"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M11.8385 1h-6.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 4.1795 1 4.6343 1 5.1614v6.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 16 4.6343 16 5.1615 16H6v-3.8808c-.0001-.4887-.0003-1.0185.0372-1.4771.0424-.519.1474-1.2047.5078-1.912A5 5 0 0 1 8.73 6.545c.7074-.3604 1.3931-.4654 1.9121-.5078.4586-.0374.9884-.0373 1.477-.0372H16v-.8385c0-.5272 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C12.8205 1 12.3657 1 11.8385 1"
    />
  </svg>
);

export const Copy02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.8385 7h-7.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C7 10.1795 7 10.6343 7 11.1614v7.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964.3745.0306.8293.0306 1.3564.0306h7.6771c.5271 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 19.8205 23 19.3657 23 18.8385v-7.677c0-.5272 0-.9819-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 7 19.3657 7 18.8385 7"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.1615 1h7.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0275.3358.0303.736.0306 1.195h-5.8809c-.4886-.0001-1.0184-.0002-1.477.0372-.519.0424-1.2047.1474-1.912.5078A5 5 0 0 0 5.545 7.73c-.3604.7074-.4654 1.3931-.5078 1.9121-.0375.4586-.0373.9884-.0372 1.4771V17c-.459-.0003-.8593-.0031-1.195-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 13.8205 1 13.3658 1 12.8386V5.1615c0-.5271 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 1 4.6343 1 5.1615 1"
    />
  </svg>
);

export const Copy03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.1615 7h7.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3745.0306.8293.0306 1.3564v7.6771c0 .5272 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C13.8205 23 13.3658 23 12.8386 23H5.1615c-.5271 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 19.8205 1 19.3657 1 18.8385v-7.677c0-.5272 0-.9819.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 7 4.6343 7 5.1615 7"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.8385 1h-7.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C7.003 4.1408 7.0003 4.541 7 5h5.8809c.4886-.0001 1.0184-.0002 1.477.0372.519.0424 1.2047.1474 1.9121.5078a5 5 0 0 1 2.185 2.185c.3604.7074.4654 1.3931.5078 1.9121.0375.4586.0373.9884.0372 1.4771V17c.459-.0003.8593-.0031 1.195-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 13.8205 23 13.3658 23 12.8386V5.1615c0-.5271 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 1 19.3657 1 18.8385 1"
    />
  </svg>
);

export const Copy04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.8385 17h-7.677c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C7 13.8205 7 13.3657 7 12.8386V5.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C10.1795 1 10.6343 1 11.1614 1h7.6771c.5271 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 4.1795 23 4.6343 23 5.1615v7.677c0 .5272 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 17 19.3657 17 18.8385 17"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.1615 23h7.677c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167.0275-.3358.0303-.736.0306-1.195h-5.8809c-.4886.0001-1.0184.0002-1.477-.0372-.519-.0424-1.2047-.1474-1.912-.5078a5 5 0 0 1-2.1851-2.1851c-.3604-.7073-.4654-1.393-.5078-1.912C4.9997 13.8993 5 13.3695 5 12.8808V7c-.459.0003-.8593.0031-1.195.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 10.1795 1 10.6342 1 11.1614v7.6771c0 .5271 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 23 4.6343 23 5.1615 23"
    />
  </svg>
);

export const Copy05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.1615 17h7.677c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C17 13.8205 17 13.3657 17 12.8386V5.1615c0-.5272 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C13.8205 1 13.3658 1 12.8386 1H5.1615c-.5271 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 4.1795 1 4.6343 1 5.1615v7.677c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 17 4.6343 17 5.1615 17"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.8385 23h-7.677c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C7.003 19.8592 7.0003 19.459 7 19h5.8809c.4886.0001 1.0184.0002 1.477-.0372.519-.0424 1.2047-.1474 1.9121-.5078a5 5 0 0 0 2.185-2.1851c.3604-.7073.4654-1.393.5078-1.912.0375-.4586.0373-.9884.0372-1.4771V7c.459.0003.8593.0031 1.195.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3745.0306.8292.0306 1.3564v7.6771c0 .5271 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 23 19.3657 23 18.8385 23"
    />
  </svg>
);

export const Copy06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.1458 4.0512C16.5289 4.0008 15.7366 4 14.6 4H7.5c-.5523 0-1-.4477-1-1s.4477-1 1-1h7.1428c1.0838 0 1.9579 0 2.6658.0578.7289.0596 1.3691.1854 1.9614.4872a5 5 0 0 1 2.185 2.185c.3018.5923.4276 1.2325.4872 1.9614C22 7.3993 22 8.2734 22 9.3572V16.5c0 .5523-.4477 1-1 1s-1-.4477-1-1V9.4c0-1.1366-.0008-1.929-.0512-2.5458-.0494-.6051-.1416-.9528-.2758-1.2162a3 3 0 0 0-1.311-1.311c-.2634-.1342-.6111-.2264-1.2162-.2758"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.1615 5.5h8.177c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3746.0306.8293.0306 1.3565v8.177c0 .5272 0 .9819-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C15.3205 22 14.8657 22 14.3385 22h-8.177c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8385v-8.177c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1796 5.5 5.6343 5.5 6.1615 5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Copy07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.1615 7h7.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3745.0306.8293.0306 1.3564v7.6771c0 .5272 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C13.8205 23 13.3658 23 12.8386 23H5.1615c-.5271 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 19.8205 1 19.3657 1 18.8385v-7.677c0-.5272 0-.9819.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 7 4.6343 7 5.1615 7M13.0001 2c0-.5523.4477-1 1-1H16c.5522 0 1 .4477 1 1s-.4478 1-1 1h-1.9999c-.5523 0-1-.4477-1-1m-1.5002-.0108c.0075.5523-.4341 1.006-.9863 1.0135-.694.0094-.8742.0587-.9676.1063a1 1 0 0 0-.437.437c-.0476.0935-.0969.2737-.1063.9676-.0075.5522-.4612.9938-1.0135.9863s-.9938-.4612-.9863-1.0135c.0089-.6562.0378-1.2864.324-1.8484A3 3 0 0 1 8.638 1.327c.562-.2863 1.1922-.3152 1.8485-.3241.5522-.0075 1.0059.4341 1.0134.9864m7.0002 0c.0075-.5522.4612-.9938 1.0135-.9863.6562.0089 1.2865.0378 1.8484.324a3 3 0 0 1 1.311 1.3111c.2863.562.3152 1.1922.3241 1.8484.0075.5523-.4341 1.006-.9863 1.0135s-1.006-.4341-1.0135-.9864c-.0094-.6938-.0587-.874-.1063-.9675a1 1 0 0 0-.437-.437c-.0934-.0476-.2737-.0969-.9675-.1063-.5523-.0075-.9939-.4612-.9864-1.0134M22 7c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V8c0-.5523.4477-1 1-1m.0108 5.5001c.5522.0075.9938.4612.9863 1.0134-.0089.6563-.0378 1.2865-.3241 1.8485a3 3 0 0 1-1.311 1.311c-.5619.2863-1.1922.3152-1.8484.3241-.5523.0075-1.006-.4341-1.0135-.9863s.4341-1.006.9864-1.0135c.6938-.0094.8741-.0587.9675-.1063a1 1 0 0 0 .437-.437c.0476-.0934.0969-.2737.1063-.9676.0075-.5522.4612-.9938 1.0135-.9863"
      clipRule="evenodd"
    />
  </svg>
);

export const Divide01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 6c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M10 18c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M3 12c0-.5523.4477-1 1-1h16c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Divide02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 12c0-.5523.4477-1 1-1h16c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.5 5.5C14.5 6.8807 13.3807 8 12 8S9.5 6.8807 9.5 5.5 10.6193 3 12 3s2.5 1.1193 2.5 2.5M14.5 18.5c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5S10.6193 16 12 16s2.5 1.1193 2.5 2.5"
    />
  </svg>
);

export const Divide03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m-1.5 7c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5m0 8c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5M7 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h10c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const DotsGrid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 5c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M10 12c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M10 19c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M17 5c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M17 12c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M17 19c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M3 5c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M3 12c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M3 19c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const DotsHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 12c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M17 12c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M3 12c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const DotsVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 12c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M10 5c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M10 19c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Download01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v9.5858l-3.2929-3.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143l5 5c.3905.3905 1.0237.3905 1.4142 0l5-5c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L13 12.5858z"
    />
    <path
      fill="currentColor"
      d="M3 14c.5523 0 1 .4477 1 1v1.2c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C6.3611 19.9992 6.9434 20 7.8 20h8.4c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V15c0-.5523.4477-1 1-1s1 .4477 1 1v1.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V15c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const Download01Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.226 14.4687c-.173-.173-.2594-.2595-.3603-.3213a1 1 0 0 0-.289-.1197C6.4614 14 6.3391 14 6.0946 14h-.7618c-.3045-.0002-.5666-.0003-.8022.037a3 3 0 0 0-2.4938 2.4938c-.0373.2356-.0371.4976-.037.8021v.1497c0 .4769-.0002.8304.0493 1.1432.2711 1.7116 1.6135 3.0539 3.325 3.325.3128.0495.6663.0494 1.1433.0493h10.965c.477.0001.8305.0002 1.1432-.0493 1.7116-.2711 3.054-1.6134 3.325-3.325.0496-.3127.0495-.6662.0493-1.1431v-.1497c.0002-.3046.0004-.5666-.0369-.8022a3 3 0 0 0-2.4938-2.4938c-.2357-.0373-.4977-.0372-.8022-.037h-.7617c-.2446 0-.3669 0-.482.0277a1 1 0 0 0-.2891.1197c-.1009.0618-.1874.1483-.3603.3213l-2.6527 2.6526c-1.1716 1.1716-3.071 1.1716-4.2426 0z"
    />
    <path
      fill="currentColor"
      d="M13 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v9.5858l-3.2929-3.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143l5 5c.3905.3905 1.0237.3905 1.4142 0l5-5c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L13 12.5858z"
    />
  </svg>
);

export const Download02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v11.5858l-4.2929-4.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l6 6c.3905.3905 1.0237.3905 1.4142 0l6-6c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L13 14.5858zM2 21c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const Download03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m0 6c.5523 0 1 .4477 1 1v5.5858l2.2929-2.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L11 13.5858V8c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Share04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-6.2929 6.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 4H15c-.5523 0-1-.4477-1-1"
    />
    <path
      fill="currentColor"
      d="M7.7587 4H10c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.8c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 8.3611 4 8.9434 4 9.8v6.4c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C6.3611 19.9992 6.9434 20 7.8 20h6.4c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V14c0-.5523.4477-1 1-1s1 .4477 1 1v2.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C15.7106 22 15.0463 22 14.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V9.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 4 6.9537 4 7.7587 4"
    />
  </svg>
);

export const Share04Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-6.2929 6.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 4H15c-.5523 0-1-.4477-1-1"
    />
    <path
      fill="currentColor"
      d="M11.9544 7.803c.3961-.3961.5941-.5941.6683-.8224a1 1 0 0 0 0-.618c-.0742-.2284-.2722-.4264-.6683-.8224l-.7787-.7787-.036-.0362c-.1339-.1346-.3026-.3042-.5089-.4306a2 2 0 0 0-.5781-.2395c-.2354-.0565-.4745-.0558-.6644-.0554L9.3373 4H7.7587c-.805 0-1.4693 0-2.0105.0441-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.0021-.3918 1.5642C2 8.2893 2 8.9537 2 9.7586v6.4826c0 .805 0 1.4694.0442 2.0106.046.5621.1445 1.0788.3918 1.5641a4 4 0 0 0 1.748 1.7481c.4854.2473 1.002.3458 1.5642.3918.5412.0442 1.2055.0442 2.0105.0441h6.4826c.805.0001 1.4693.0001 2.0105-.0441.5621-.046 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.7481c.2473-.4853.3459-1.002.3918-1.5641C20 17.7106 20 17.0462 20 16.2413v-1.5786l.0001-.051c.0005-.19.0011-.4291-.0554-.6644a2 2 0 0 0-.2394-.5781c-.1265-.2064-.296-.375-.4307-.509l-.0361-.036-.7787-.7786c-.396-.3961-.594-.5941-.8223-.6683a1 1 0 0 0-.6181 0c-.2283.0742-.4263.2722-.8223.6683l-1.0758 1.0757c-1.1716 1.1716-3.071 1.1716-4.2426 0s-1.1716-3.071 0-4.2426z"
    />
  </svg>
);

export const Share05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7587 2H10c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.8c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 6.3611 4 6.9434 4 7.8v8.4c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C6.3611 19.9992 6.9434 20 7.8 20h8.4c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V14c0-.5523.4477-1 1-1s1 .4477 1 1v2.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2"
    />
    <path
      fill="currentColor"
      d="m18.5858 7-1.2929 1.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142l-3-3c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L18.5858 5h-.8271c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C12 9.2894 12 9.9537 12 10.7587V12c0 .5523.4477 1 1 1s1-.4477 1-1v-1.2c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C16.3611 7.0008 16.9434 7 17.8 7z"
    />
  </svg>
);

export const Share06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.3373 3.1395a1.5 1.5 0 0 1 1.1999-.552c.4066.0101.7137.214.8683.324.1648.1173.3525.2782.5386.4377l.0273.0235 8.4904 7.2774c.1044.0895.2257.1934.3235.293.1106.1127.2654.2917.3581.5498a1.5 1.5 0 0 1 0 1.0142c-.0927.2581-.2475.4371-.3581.5498-.0978.0996-.2191.2035-.3235.2929l-8.5178 7.301c-.186.1595-.3737.3204-.5385.4377-.1546.1101-.4617.3138-.8683.3239a1.5 1.5 0 0 1-1.1999-.5519c-.257-.3153-.3021-.681-.3192-.87-.0182-.2016-.0182-.4487-.0181-.6939v-3.1002a10.4 10.4 0 0 0-6.2306 3.6053A1 1 0 0 1 2 19.163v-.612a10.666 10.666 0 0 1 8-10.3225V4.7034c0-.2452 0-.4924.0181-.6939.0171-.189.0622-.5548.3192-.87"
      clipRule="evenodd"
    />
  </svg>
);

export const Share07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 5c0-2.2091 1.7909-4 4-4s4 1.7909 4 4-1.7909 4-4 4c-1.1115 0-2.117-.4533-2.8419-1.1852l-5.3078 3.0975A4 4 0 0 1 10 12c0 .3768-.0521.7415-.1495 1.0871l5.3108 3.0948C15.886 15.452 16.8902 15 18 15c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4-4-1.7909-4-4c0-.3786.0526-.745.1509-1.0921l-5.3085-3.0935C8.1174 15.5465 7.1117 16 6 16c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4c1.1115 0 2.117.4533 2.842 1.1851l5.3077-3.0974A4 4 0 0 1 14 5"
    />
  </svg>
);

export const SlashCircle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M6.3823 4.9681C7.922 3.7365 9.875 3 12 3c4.9706 0 9 4.0294 9 9 0 2.125-.7365 4.078-1.9681 5.6177zM4.9681 6.3823C3.7365 7.922 3 9.875 3 12c0 4.9706 4.0294 9 9 9 2.125 0 4.078-.7365 5.6177-1.9681z"
      clipRule="evenodd"
    />
  </svg>
);

export const SlashCircle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M6.3823 4.9681C7.922 3.7365 9.875 3 12 3s4.078.7365 5.6176 1.968L12 10.5858zM4.9681 6.3823C3.7365 7.922 3 9.875 3 12s.7365 4.078 1.968 5.6176L10.5858 12zM6.3823 19.032C7.922 20.2635 9.875 21 12 21s4.078-.7365 5.6177-1.9681L12 13.4142zm12.6496-1.4142C20.2635 16.078 21 14.125 21 12s-.7365-4.078-1.9681-5.6177L13.4142 12z"
      clipRule="evenodd"
    />
  </svg>
);

export const SlashDivider = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.4472 1.1056c.494.247.6942.8476.4472 1.3416l-10 20c-.247.494-.8477.6942-1.3416.4472-.494-.247-.6942-.8477-.4473-1.3416l10-20c.247-.494.8477-.6942 1.3417-.4472"
      clipRule="evenodd"
    />
  </svg>
);

export const SlashOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8.5228 1-.051-.0001c-.19-.0006-.4291-.0012-.6645.0553a2 2 0 0 0-.578.2395c-.2064.1264-.375.296-.509.4306l-.036.0362-4.9228 4.9227-.0361.036c-.1347.134-.3042.3026-.4307.509a2 2 0 0 0-.2394.578c-.0565.2354-.0559.4745-.0554.6645L1 8.5227v7.0055c-.0006.19-.0012.4291.0553.6644a2 2 0 0 0 .2394.5781c.1265.2064.296.375.4307.509l.0361.036 4.9228 4.9227.036.0362c.134.1346.3026.3042.509.4306.1789.1097.374.1905.578.2395.2354.0565.4745.0558.6644.0553l.051-.0001h6.9546l.051.0001c.1899.0005.4291.0012.6644-.0553a2 2 0 0 0 .5781-.2395c.2063-.1264.375-.296.5089-.4306l.036-.0362 4.9228-4.9227.0361-.036c.1347-.134.3042-.3026.4307-.509a2 2 0 0 0 .2394-.5781c.0565-.2353.0559-.4745.0554-.6644L23 15.4772V8.5227l.0001-.051c.0005-.19.0011-.4291-.0554-.6644a2 2 0 0 0-.2394-.5781c-.1265-.2064-.296-.375-.4306-.509l-.0362-.036-4.9228-4.9227-.036-.0362c-.1339-.1346-.3026-.3042-.5089-.4306a2 2 0 0 0-.5781-.2395C15.9574.9987 15.7182.9993 15.5283 1H8.5228M19.07 17.6556l1.7543-1.7542c.0926-.0927.1387-.1391.1707-.1742l.0024-.0026.0002-.0036c.0022-.0475.0024-.1129.0024-.2439V8.5227c0-.131-.0002-.1964-.0024-.2439l-.0002-.0036-.0024-.0026c-.032-.0351-.0781-.0815-.1707-.1742l-4.9228-4.9227c-.0926-.0926-.139-.1387-.1741-.1708l-.0027-.0024-.0036-.0001c-.0475-.0022-.1128-.0025-.2438-.0025H8.5228c-.131 0-.1964.0003-.244.0025l-.0035.0001-.0027.0024c-.669.6106-1.9284 1.925-1.9284 1.925zM4.93 6.3442l12.7258 12.7257-1.7543 1.7543c-.0926.0926-.139.1387-.1741.1708l-.0027.0024-.0036.0001c-.0475.0022-.1128.0024-.2438.0024H8.5228c-.131 0-.1964-.0002-.244-.0024l-.0035-.0001-.0027-.0024c-.035-.0321-.0815-.0782-.1741-.1708l-4.9228-4.9227c-.0926-.0927-.1387-.1391-.1707-.1742l-.0024-.0026-.0002-.0036C3.0002 15.6736 3 15.6082 3 15.4772V8.5227c0-.131.0002-.1964.0024-.2439l.0002-.0036.0024-.0026c.032-.0351.0781-.0815.1707-.1742z"
      clipRule="evenodd"
    />
  </svg>
);

export const Speedometer01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m1 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2.25c0 .5523.4477 1 1 1s1-.4477 1-1zm0 15.75c0-.5523-.4477-1-1-1s-1 .4477-1 1V21c0 .5523.4477 1 1 1s1-.4477 1-1zM2 12c0-.5523.4477-1 1-1h2.25c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1m16.75-1c-.5523 0-1 .4477-1 1s.4477 1 1 1H21c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-2.6829 5.0671c.3905-.3906 1.0237-.3906 1.4142 0l1.5964 1.5963c.3905.3906.3905 1.0237 0 1.4142-.3905.3906-1.0237.3906-1.4142 0l-1.5964-1.5963c-.3905-.3905-.3905-1.0237 0-1.4142m-8.1326 1.4126c.3906-.3905.3906-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-1.598 1.5979c-.3905.3906-.3905 1.0237 0 1.4143s1.0237.3905 1.4143 0zM4.9224 4.9928c.3905-.3905 1.0236-.3905 1.4142 0l1.5628 1.5629c.3905.3905.3905 1.0236 0 1.4142s-1.0237.3905-1.4142 0L4.9224 6.407c-.3906-.3906-.3906-1.0237 0-1.4143M19.0727 6.412c.3932-.3877.3977-1.0208.01-1.4141s-1.0209-.3978-1.4142-.01l-5.0207 4.95a1 1 0 0 0-.1142.1341A2 2 0 0 0 12 10c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2c0-.1849-.0251-.3639-.072-.5339a1 1 0 0 0 .124-.104z"
      clipRule="evenodd"
    />
  </svg>
);

export const Speedometer02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11c0 2.363-.7451 4.552-2.0131 6.3448-.1623.2294-.2434.3441-.3647.4002-.1015.0469-.232.058-.3399.0289-.129-.0348-.2355-.1413-.4484-.3542l-.3328-.3328c-.6141-.6145-1.0392-1.0399-1.5455-1.3501a5 5 0 0 0-1.4452-.5986c-.5773-.1386-1.1787-.1384-2.0474-.1382H9.537c-.8688-.0002-1.47-.0004-2.0474.1382a5 5 0 0 0-1.4452.5987c-.5062.3102-.9313.7355-1.5455 1.35l-.3328.3328c-.213.213-.3194.3194-.4484.3542-.108.0291-.2384.018-.3399-.0289-.1213-.0561-.2024-.1708-.3647-.4002C1.7452 16.552 1 14.363 1 12m12-9c0-.5523-.4477-1-1-1s-1 .4477-1 1v2.25c0 .5523.4477 1 1 1s1-.4477 1-1zM3 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h2.25c.5523 0 1-.4477 1-1s-.4477-1-1-1zm15.75 0c-.5523 0-1 .4477-1 1s.4477 1 1 1H21c.5523 0 1-.4477 1-1s-.4477-1-1-1zM6.3366 4.9928c-.3906-.3905-1.0237-.3905-1.4142 0-.3906.3906-.3906 1.0237 0 1.4143l1.5628 1.5628c.3905.3905 1.0236.3905 1.4142 0s.3905-1.0237 0-1.4142zM19.0727 6.412c.3932-.3877.3977-1.0208.01-1.4141s-1.0209-.3978-1.4142-.01l-5.0207 4.95a1 1 0 0 0-.1142.1341A2 2 0 0 0 12 10c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2c0-.1849-.0251-.3639-.072-.5339a1 1 0 0 0 .124-.104z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m18.1674 19.5817.2523.2522c.2129.213.3194.3194.3541.4484.0291.108.018.2385-.0289.3399-.056.1213-.1707.2024-.4002.3647C16.5519 22.2549 14.363 23 12 23s-4.552-.7451-6.3447-2.0131c-.2294-.1623-.3442-.2434-.4002-.3647-.047-.1014-.058-.2319-.029-.3399.0348-.129.1413-.2354.3542-.4483l.2523-.2523c.7255-.7255.9775-.9684 1.2568-1.1396a3 3 0 0 1 .8671-.3591c.3185-.0765.6685-.0829 1.6944-.0829L14.349 18c1.026 0 1.376.0065 1.6945.0829.3061.0735.5987.1947.8671.3592.2793.1712.5314.4141 1.2568 1.1396"
    />
  </svg>
);

export const Speedometer03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M6 12c0-3.3137 2.6863-6 6-6 .5523 0 1-.4477 1-1s-.4477-1-1-1c-4.4183 0-8 3.5817-8 8 0 .5523.4477 1 1 1s1-.4477 1-1m11.207-3.7929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3.2749 3.2748A2 2 0 0 0 12 10c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2c0-.1792-.0236-.3529-.0678-.5181z"
      clipRule="evenodd"
    />
  </svg>
);

export const Speedometer04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M6 12c0-3.3137 2.6863-6 6-6 .363 0 .7177.0321 1.0615.0934.5438.097 1.0631-.2652 1.1601-.8089s-.2652-1.063-.809-1.16A8.04 8.04 0 0 0 12 4c-4.4183 0-8 3.5817-8 8 0 1.6984.5304 3.2759 1.4345 4.5721.316.453.9393.564 1.3923.2481.453-.316.564-.9393.248-1.3923C6.3974 14.4564 6 13.2761 6 12m13.8159-1.7133c-.1178-.5396-.6507-.8815-1.1903-.7637s-.8815.6507-.7637 1.1903c.0903.4136.1381.844.1381 1.2867 0 1.2761-.3973 2.4564-1.0749 3.4279-.3159.453-.2048 1.0763.2481 1.3923.453.3159 1.0764.2048 1.3923-.2481C19.4696 15.2759 20 13.6984 20 12a8.03 8.03 0 0 0-.1841-1.7133M17.207 8.2071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3.2749 3.2748A2 2 0 0 0 12 10c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2c0-.1792-.0236-.3529-.0678-.5181z"
      clipRule="evenodd"
    />
  </svg>
);

export const Target01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11-4.9249 11-11 11S1 18.0751 1 12m14 0c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4c-.5523 0-1-.4477-1-1M4 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1zm8-8c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V4c0-.5523.4477-1 1-1m1 13c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Target02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1c.5523 0 1 .4477 1 1v1.055c4.1716.461 7.4839 3.7734 7.9451 7.945H22c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1.0549c-.4612 4.1716-3.7735 7.4839-7.9451 7.9451V22c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1.0549C6.8284 20.4839 3.516 17.1716 3.055 13H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.055C3.516 6.8284 6.8283 3.516 11 3.055V2c0-.5523.4477-1 1-1m1 17.9291V18c0-.5523-.4477-1-1-1s-1 .4477-1 1v.9291C7.9343 18.4906 5.5094 16.0657 5.0709 13H6c.5523 0 1-.4477 1-1s-.4477-1-1-1h-.9291C5.5094 7.9343 7.9343 5.5094 11 5.0709V6c0 .5523.4477 1 1 1s1-.4477 1-1v-.9291c3.0657.4385 5.4906 2.8634 5.9291 5.9291H18c-.5523 0-1 .4477-1 1s.4477 1 1 1h.9291c-.4385 3.0657-2.8634 5.4906-5.9291 5.9291"
      clipRule="evenodd"
    />
  </svg>
);

export const Target03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 12c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1c.5523 0 1 .4477 1 1v1.055c4.1716.461 7.4839 3.7734 7.9451 7.945H22c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1.0549c-.4612 4.1716-3.7735 7.4839-7.9451 7.9451V22c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1.0549C6.8284 20.4839 3.516 17.1716 3.055 13H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.055C3.516 6.8284 6.8283 3.516 11 3.055V2c0-.5523.4477-1 1-1m1 17.9291V18c0-.5523-.4477-1-1-1s-1 .4477-1 1v.9291C7.9343 18.4906 5.5094 16.0657 5.0709 13H6c.5523 0 1-.4477 1-1s-.4477-1-1-1h-.9291C5.5094 7.9343 7.9343 5.5094 11 5.0709V6c0 .5523.4477 1 1 1s1-.4477 1-1v-.9291c3.0657.4385 5.4906 2.8634 5.9291 5.9291H18c-.5523 0-1 .4477-1 1s.4477 1 1 1h.9291c-.4385 3.0657-2.8634 5.4906-5.9291 5.9291"
      clipRule="evenodd"
    />
  </svg>
);

export const Target04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.1601 1.013c.3173.0514.5905.2523.7343.5398l.8509 1.7019 1.7019.8509a1 1 0 0 1 .2598 1.6015l-3 3a1 1 0 0 1-.7071.293h-2.5857l-3.7071 3.707c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l3.707-3.707V5c0-.2652.1054-.5196.2929-.707l3-3a1 1 0 0 1 .8673-.28"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M3 12c0-4.9706 4.0294-9 9-9 .5523 0 1-.4477 1-1s-.4477-1-1-1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11c0-.5523-.4477-1-1-1s-1 .4477-1 1c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9"
    />
    <path
      fill="currentColor"
      d="M8 12c0-2.2091 1.7909-4 4-4 .5523 0 1-.4477 1-1s-.4477-1-1-1c-3.3137 0-6 2.6863-6 6s2.6863 6 6 6 6-2.6863 6-6c0-.5523-.4477-1-1-1s-1 .4477-1 1c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4"
    />
  </svg>
);

export const Target05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3c-4.9706 0-9 4.0294-9 9s4.0294 9 9 9 9-4.0294 9-9-4.0294-9-9-9M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11-4.9249 11-11 11S1 18.0751 1 12"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 7c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5m-7 5c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7-7-3.134-7-7"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 12c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3"
      clipRule="evenodd"
    />
  </svg>
);

export const Toggle01Left = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 6c-3.3137 0-6 2.6863-6 6s2.6863 6 6 6h10c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6zm4.4722 10C12.4223 14.9385 13 13.5367 13 12s-.5777-2.9385-1.5278-4H17c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4z"
      clipRule="evenodd"
    />
  </svg>
);

export const Toggle01Right = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 6c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6H7c-3.3137 0-6-2.6863-6-6s2.6863-6 6-6zm-4.4722 10C11.5777 14.9385 11 13.5367 11 12s.5777-2.9385 1.5278-4H7c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4z"
      clipRule="evenodd"
    />
  </svg>
);

export const Toggle02Left = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 6c-3.3137 0-6 2.6863-6 6s2.6863 6 6 6c1.2267 0 2.3675-.3682 3.3178-1H18c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5h-7.6822C9.3675 6.3682 8.2268 6 7 6m5.1973 3c.5105.8825.8027 1.9071.8027 3s-.2922 2.1175-.8027 3H18c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3z"
      clipRule="evenodd"
    />
  </svg>
);

export const Toggle02Right = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 6c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6c-1.2267 0-2.3675-.3682-3.3178-1H6c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5h7.6822c.9503-.6318 2.0911-1 3.3178-1m-5.1973 3C11.2922 9.8825 11 10.9071 11 12s.2922 2.1175.8027 3H6c-1.6569 0-3-1.3431-3-3s1.3431-3 3-3z"
      clipRule="evenodd"
    />
  </svg>
);

export const Toggle03Left = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 5c-3.866 0-7 3.134-7 7s3.134 7 7 7h8c3.866 0 7-3.134 7-7s-3.134-7-7-7zm4 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
      clipRule="evenodd"
    />
  </svg>
);

export const Toggle03Right = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 5c3.866 0 7 3.134 7 7s-3.134 7-7 7H8c-3.866 0-7-3.134-7-7s3.134-7 7-7zm-4 7c0 2.2091 1.7909 4 4 4s4-1.7909 4-4-1.7909-4-4-4-4 1.7909-4 4"
      clipRule="evenodd"
    />
  </svg>
);

export const Tool01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 8c0-3.866 3.134-7 7-7 .8236 0 1.6161.1427 2.3527.4055a.9998.9998 0 0 1 .371 1.649l-2.2435 2.2673c-.3182.3215-.4773.4823-.5523.6605a1 1 0 0 0 .0022.7809c.076.1777.236.3375.556.6573.3206.3204.4809.4805.659.5564a1 1 0 0 0 .7819.0008c.1782-.0755.3388-.2354.66-.555l2.3041-2.293a1 1 0 0 1 1.6398.3465A6.99 6.99 0 0 1 23 8c0 3.866-3.134 7-7 7a7.02 7.02 0 0 1-1.6618-.1987c-.2531-.0616-.4131-.1004-.53-.1239a2 2 0 0 0-.0535-.0101l-.0123.011c-.0621.0561-.1437.1372-.2875.281l-6.2478 6.2478c-1.219 1.219-3.1953 1.219-4.4142 0s-1.219-3.1953 0-4.4142l6.2478-6.2478c.1438-.1438.225-.2254.281-.2875.0156-.0173.0068-.0367.0009-.0658-.0235-.1169-.0623-.277-.124-.53A7.01 7.01 0 0 1 9 8"
      clipRule="evenodd"
    />
  </svg>
);

export const Tool02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.5 1C12.9101 1 10 3.9101 10 7.5c0 .4077.0376.8074.1099 1.1957L7 5.5858V3a1 1 0 0 0-.6837-.9487l-3-1a1 1 0 0 0-1.0234.2416l-1 1a1 1 0 0 0-.2416 1.0234l1 3A1 1 0 0 0 3 7h2.5858l3.5 3.5-6.293 6.2929c-1.2189 1.2189-1.2189 3.1952 0 4.4142 1.219 1.2189 3.1953 1.2189 4.4143 0L12 16.4141l4.7929 4.7929c1.2189 1.219 3.1953 1.2189 4.4142 0s1.2189-3.1953 0-4.4142l-3.0152-3.0152C20.9614 13.0331 23 10.5046 23 7.5c0-.638-.0923-1.2564-.2648-1.8414a1 1 0 0 0-1.6663-.4242l-1.986 1.9752c-.2417.2403-.3625.3604-.49.4293a1 1 0 0 1-.9521-.0013c-.1274-.0692-.2478-.1897-.4888-.4306-.241-.241-.3615-.3615-.4307-.489a1 1 0 0 1-.0012-.952c.0688-.1276.189-.2484.4294-.49l2.1469-2.1582a1 1 0 0 0-.327-1.632A6.48 6.48 0 0 0 16.5 1"
    />
  </svg>
);

export const Translate01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h8.2791c-.4654 1.9747-1.2475 3.7967-2.303 5.413-.8894-.8348-1.6436-1.8285-2.055-2.8022-.215-.5087-.8016-.7469-1.3103-.532-.5088.215-.747.8017-.532 1.3104.5538 1.3106 1.5418 2.5918 2.696 3.6363-1.4224 1.681-3.1842 3.0673-5.2199 4.079-.4945.2458-.6962.846-.4504 1.3405.2457.4946.846.6963 1.3405.4505 2.3161-1.151 4.3139-2.7346 5.9186-4.6517.4067.26.8187.4851 1.2266.6684.5037.2263 1.0956.0014 1.3219-.5024s.0015-1.0956-.5023-1.322c-.28-.1257-.5634-.2775-.8452-.4508 1.3087-1.9674 2.2507-4.2073 2.7636-6.637H14c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2.4835a1 1 0 0 0-.0354 0H9z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.1523 9.308a1.5 1.5 0 0 0-1.3046 0c-.3585.1732-.5528.4748-.6494.637-.1011.1702-.2049.3872-.3068.6005l-2.8716 6.0042a1 1 0 0 0-.0186.0388l-1.9034 3.98c-.2383.4982-.0276 1.0953.4706 1.3336s1.0953.0275 1.3336-.4707l1.6412-3.4315h5.9134l1.6412 3.4315c.2382.4982.8353.709 1.3335.4707.4983-.2383.709-.8354.4707-1.3336l-1.9034-3.98a1 1 0 0 0-.0186-.0388l-2.8716-6.0042c-.1019-.2132-.2057-.4304-.3069-.6004-.0965-.1623-.2909-.464-.6493-.637M16.5 11.8178l2.0002 4.1822h-4.0004z"
      clipRule="evenodd"
    />
  </svg>
);

export const Translate02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 1c-.5523 0-1 .4477-1 1s.4477 1 1 1h1c.5523 0 1-.4477 1-1s-.4477-1-1-1zM9.2229 7.3629 10.1315 6H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h9.9853a1 1 0 0 1 .0313 0H14c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1.4648l-1.7031 2.5547a1 1 0 0 1-.125.1524L8.9142 10.5l1.7929 1.7929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-1.793-1.7929-2.7928 2.7929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L6.0858 10.5l-1.793-1.7929c-.3904-.3905-.3904-1.0237 0-1.4142.3906-.3905 1.0238-.3905 1.4143 0L7.5 9.0858z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.8477 9.308a1.5 1.5 0 0 1 1.3046 0c.3584.1732.5528.4748.6493.637.1012.1701.205.3872.3069.6004l2.8716 6.0043q.0097.0192.0186.0388l1.9034 3.98c.2383.4982.0276 1.0953-.4707 1.3336-.4982.2383-1.0953.0275-1.3335-.4707l-1.6412-3.4315h-5.9134l-1.6412 3.4315c-.2383.4982-.8353.709-1.3336.4707s-.709-.8354-.4706-1.3336l1.9034-3.98a1 1 0 0 1 .0186-.0388l2.8716-6.0042c.1019-.2133.2057-.4303.3068-.6004.0966-.1623.2909-.464.6494-.637M18.5002 16 16.5 11.8177l-2.0002 4.1822z"
      clipRule="evenodd"
    />
  </svg>
);

export const Trash01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.1615 1h1.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0275.3357.0303.736.0306 1.195h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1v10.2413c0 .8049 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C15.7106 23 15.0463 23 14.2413 23H9.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C4 18.7106 4 18.0463 4 17.2413V7H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h4c.0003-.459.0031-.8593.0306-1.195.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C10.1795 1 10.6343 1 11.1615 1M10 10.5c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1v-5c0-.5523.4477-1 1-1m5 1c0-.5523-.4477-1-1-1s-1 .4477-1 1v5c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Trash02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.1615 1h1.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0275.3357.0303.736.0306 1.195h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1v10.2413c0 .8049 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C15.7106 23 15.0463 23 14.2413 23H9.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C4 18.7106 4 18.0463 4 17.2413V7H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h4c.0003-.459.0031-.8593.0306-1.195.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C10.1795 1 10.6343 1 11.1615 1"
      clipRule="evenodd"
    />
  </svg>
);

export const Trash03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 6c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1.0644l-.6417 9.6255c-.0504.7554-.092 1.3806-.1667 1.8894-.0778.5298-.2012 1.0139-.4583 1.4651a4 4 0 0 1-1.7311 1.6196c-.4673.2265-.9586.3174-1.4924.3598-.5127.0407-1.1392.0406-1.8963.0406H10.451c-.7571 0-1.3837.0001-1.8964-.0406-.5338-.0424-1.025-.1333-1.4923-.3598A4 4 0 0 1 5.331 19.98c-.257-.4512-.3804-.9353-.4582-1.4651-.0747-.5088-.1164-1.134-.1667-1.8894L4.0645 7H3c-.5523 0-1-.4477-1-1m8 3.5c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1v-5c0-.5523.4477-1 1-1m5 1c0-.5523-.4477-1-1-1s-1 .4477-1 1v5c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Trash04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 6c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1.0644l-.6417 9.6255c-.0504.7554-.092 1.3806-.1667 1.8894-.0778.5298-.2012 1.0139-.4583 1.4651a4 4 0 0 1-1.7311 1.6196c-.4673.2265-.9586.3174-1.4924.3598-.5127.0407-1.1392.0406-1.8963.0406H10.451c-.7571 0-1.3837.0001-1.8964-.0406-.5338-.0424-1.025-.1333-1.4923-.3598A4 4 0 0 1 5.331 19.98c-.257-.4512-.3804-.9353-.4582-1.4651-.0747-.5088-.1164-1.134-.1667-1.8894L4.0645 7H3c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Upload01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.2929 2.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 5.4142V15c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-3.2929 3.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143z"
    />
    <path
      fill="currentColor"
      d="M3 14c.5523 0 1 .4477 1 1v1.2c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C6.3611 19.9992 6.9434 20 7.8 20h8.4c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V15c0-.5523.4477-1 1-1s1 .4477 1 1v1.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V15c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const Upload01Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.2929 2.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 5.4142V15c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-3.2929 3.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143z"
    />
    <path
      fill="currentColor"
      d="M8 14c.5523 0 1 .4477 1 1 0 1.6569 1.3431 3 3 3s3-1.3431 3-3c0-.5523.4477-1 1-1h2.6671c.3045-.0002.5665-.0003.8022.037a3 3 0 0 1 2.4938 2.4938c.0373.2356.0371.4976.0369.8022v.1497c.0002.4769.0003.8304-.0493 1.1431-.271 1.7116-1.6134 3.0539-3.325 3.325-.3127.0495-.6662.0494-1.1432.0493H6.5175c-.477.0001-.8305.0002-1.1432-.0493-1.7116-.2711-3.054-1.6134-3.325-3.325-.0496-.3128-.0495-.6663-.0493-1.1432v-.1497c-.0002-.3045-.0004-.5665.037-.8021a3 3 0 0 1 2.4937-2.4938c.2356-.0373.4977-.0372.8022-.037z"
    />
  </svg>
);

export const Upload02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 3c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M5.2929 13.7071c.3905.3905 1.0237.3905 1.4142 0L11 9.4142V21c0 .5523.4477 1 1 1s1-.4477 1-1V9.4142l4.2929 4.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-6-6c-.3905-.3905-1.0237-.3905-1.4142 0l-6 6c-.3905.3905-.3905 1.0237 0 1.4142"
    />
  </svg>
);

export const Upload03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M7.2929 11.2929l4-4c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 10.4142V16c0 .5523-.4477 1-1 1s-1-.4477-1-1v-5.5858l-2.2929 2.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const Upload04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.3788 22.0939c-.7623.3312-1.1435.4968-1.7455.3845-.4393-.0819-1.0403-.476-1.2905-.8464C13 21.1246 13 20.5677 13 19.4538v-9.0396l2.2929 2.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-4-4c-.3905-.3905-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L11 10.4142l-.0001 8.9304c-.001 1.261-.0018 2.2566.7341 3.2974.0877.1239.1918.2438.3062.3579L12 23C5.9249 23 1 18.0751 1 12S5.9249 1 12 1s11 4.9249 11 11c0 4.5189-2.7249 8.4013-6.6212 10.0939"
    />
  </svg>
);

export const UploadCloud01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.4914 8.1868C22.0836 8.8498 24 11.2011 24 14c0 3.3137-2.6863 6-6 6H6.5C2.9102 20 0 17.0899 0 13.5c0-3.0623 2.1176-5.63 4.9684-6.3185C6.324 4.6905 8.9646 3 12 3c3.4283 0 6.3528 2.1564 7.4914 5.1868M7.2929 12.7071c.3905.3905 1.0237.3905 1.4142 0L11 10.4142V16c0 .5523.4477 1 1 1s1-.4477 1-1v-5.5858l2.2929 2.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-4-4c-.3905-.3905-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const UploadCloud02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 21c-4.9706 0-9-4.0294-9-9s4.0294-9 9-9c2.6837 0 5.0931 1.1746 6.742 3.0378A7.6 7.6 0 0 1 16.5 6c4.1421 0 7.5 3.3579 7.5 7.5S20.6421 21 16.5 21zm-1.7071-7.2929c.3905.3905 1.0237.3905 1.4142 0L11 11.4142V17c0 .5523.4477 1 1 1s1-.4477 1-1v-5.5858l2.2929 2.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-4-4c-.3905-.3905-1.0237-.3905-1.4142 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const Virus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 3.0548a9 9 0 0 0-.8731.1402c-.5403.1143-1.071-.231-1.1853-.7714s.231-1.071.7714-1.1853A11.04 11.04 0 0 1 12 1c.7832 0 1.5484.082 2.287.2383.5404.1143.8857.645.7714 1.1853s-.645.8857-1.1853.7714A9 9 0 0 0 13 3.0548V7.1a4.97 4.97 0 0 1 1.7573.7284l2.8604-2.8604a9 9 0 0 0-.7164-.5177c-.4629-.3013-.594-.9207-.2928-1.3836.3012-.463.9206-.594 1.3836-.2928a11.055 11.055 0 0 1 3.235 3.2355c.3011.463.1699 1.0824-.293 1.3836-.463.3011-1.0824.17-1.3836-.293a9 9 0 0 0-.5186-.7178l-2.8603 2.8604A4.97 4.97 0 0 1 16.9 11h4.0452a9 9 0 0 0-.1402-.8732c-.1143-.5403.231-1.071.7713-1.1854.5404-.1143 1.0711.231 1.1854.7714C22.918 10.4515 23 11.2167 23 12c0 .783-.082 1.5479-.2381 2.2863-.1143.5404-.645.8858-1.1853.7715s-.8857-.645-.7715-1.1853A9 9 0 0 0 20.9452 13H16.9a4.97 4.97 0 0 1-.7284 1.7573l2.8604 2.8604a9 9 0 0 0 .516-.7138c.3014-.4628.9209-.5937 1.3837-.2923s.5937.9208.2923 1.3836a11.05 11.05 0 0 1-3.2344 3.2325c-.4629.3011-1.0824.1698-1.3834-.2932-.3011-.463-.1699-1.0824.2931-1.3835a9 9 0 0 0 .7185-.5191l-2.8604-2.8603A4.97 4.97 0 0 1 13 16.9v4.0452a9 9 0 0 0 .8704-.1396c.5403-.1142 1.0709.2314 1.1851.7717.1141.5404-.2314 1.071-.7718 1.1851A11.04 11.04 0 0 1 12 23c-.785 0-1.5518-.0824-2.292-.2393-.5402-.1146-.8853-.6454-.7708-1.1857.1146-.5403.6454-.8854 1.1857-.7708.2873.0609.5799.1082.8771.141V16.9a4.97 4.97 0 0 1-1.7574-.7284l-2.8604 2.8603c.23.184.4693.357.7169.5181.463.3012.594.9206.2928 1.3835-.3011.463-.9206.5941-1.3835.2929a11.055 11.055 0 0 1-3.2315-3.2298c-.3015-.4628-.1707-1.0823.292-1.3837.4628-.3015 1.0824-.1707 1.3838.2921.1603.2461.3324.484.5153.7127l2.8604-2.8604A4.97 4.97 0 0 1 7.1 13H3.0548q.0492.4439.1402.8732c.1143.5403-.231 1.071-.7713 1.1854-.5404.1143-1.071-.2311-1.1854-.7714A11.04 11.04 0 0 1 1 12c0-.7844.0823-1.5508.239-2.2905.1145-.5403.6453-.8854 1.1856-.771.5403.1145.8855.6453.771 1.1856A9 9 0 0 0 3.0548 11H7.1a4.97 4.97 0 0 1 .7284-1.7574L4.9681 6.3822c-.184.23-.357.4693-.5181.717-.3012.463-.9207.594-1.3836.2929-.463-.3012-.594-.9206-.2929-1.3836a11.05 11.05 0 0 1 3.2338-3.2342c.463-.3012 1.0824-.1702 1.3836.2927.3013.4629.1702 1.0824-.2927 1.3836a9 9 0 0 0-.7159.5174l2.8604 2.8604A4.97 4.97 0 0 1 11 7.1z"
    />
  </svg>
);

export const XCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m3.7071 7.2929c.3905.3905.3905 1.0237 0 1.4142L13.4142 12l2.2929 2.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 13.4142l-2.2929 2.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L10.5858 12l-2.293-2.2929c-.3904-.3905-.3904-1.0237 0-1.4142.3906-.3905 1.0238-.3905 1.4143 0L12 10.5858l2.2929-2.293c.3905-.3904 1.0237-.3904 1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const XClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.7071 6.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L12 10.5858l-5.2929-5.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143L10.5858 12l-5.293 5.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0L12 13.4142l5.2929 5.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L13.4142 12z"
    />
  </svg>
);

export const X = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.7071 7.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L12 10.5858l-4.2929-4.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143L10.5858 12l-4.293 4.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0L12 13.4142l4.2929 4.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L13.4142 12z"
    />
  </svg>
);

export const XSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M8.2929 8.2929c.3905-.3905 1.0237-.3905 1.4142 0L12 10.5858l2.2929-2.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L13.4142 12l2.2929 2.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 13.4142l-2.2929 2.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L10.5858 12l-2.293-2.2929c-.3904-.3905-.3904-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const Zap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.3982 1.0828c.4072.1767.6491.6008.5941 1.0413L13.1328 9h6.1949c.241 0 .4851-.0001.6846.018.1886.017.5497.0622.863.3153.3585.2897.5639.7283.557 1.1893-.0061.4026-.2026.709-.3102.8648-.1138.1648-.2701.3523-.4244.5374l-8.9295 10.7153a1 1 0 0 1-1.7605-.7642l.8595-6.8759h-6.195c-.241 0-.485.0001-.6845-.018-.1886-.0171-.5498-.0623-.863-.3154a1.5 1.5 0 0 1-.557-1.1893c.006-.4026.2026-.709.3102-.8648.1138-.1648.27-.3523.4244-.5374l.023-.0275 8.9065-10.6878a1 1 0 0 1 1.1664-.2771"
      clipRule="evenodd"
    />
  </svg>
);

export const ZapCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M7.3616 12.2468 12 5.5v5h3.9791c.4929 0 .7394 0 .8737.1025a.5.5 0 0 1 .196.3727c.0084.1688-.1312.3719-.4104.778L12 18.5v-5H8.0208c-.4929 0-.7393 0-.8737-.1025a.5.5 0 0 1-.196-.3727c-.0084-.1688.1312-.3719.4105-.778"
      clipRule="evenodd"
    />
  </svg>
);

export const ZapFast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.5 17.5001c0-.5523.4477-1 1-1H9c.5523 0 1 .4477 1 1s-.4477 1-1 1H3.5c-.5523 0-1-.4477-1-1M1 12.0001c0-.5523.4477-1 1-1h4.5c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1M3 6.5c0-.5522.4477-1 1-1h5c.5523 0 1 .4478 1 1 0 .5524-.4477 1-1 1H4c-.5523 0-1-.4476-1-1M17.3676 2.07a1 1 0 0 1 .6236 1.0623L17.1422 9.5h3.8377c.2208 0 .4496-.0001.6386.0172.1859.017.5241.062.8264.2953.3526.2721.566.6868.5825 1.1319.0141.3816-.1458.683-.24.8442-.0958.1638-.2288.3499-.3572.5295l-.02.0281-6.5965 9.235a1 1 0 0 1-1.8049-.7134l.849-6.3678h-3.8377c-.2208 0-.4496.0001-.6386-.0172-.1859-.017-.524-.062-.8264-.2954a1.5 1.5 0 0 1-.5825-1.1318c-.0141-.3817.1458-.6831.24-.8442.0958-.1638.2288-.35.3572-.5296l.02-.028 6.5965-9.235a1 1 0 0 1 1.1813-.3488"
      clipRule="evenodd"
    />
  </svg>
);

export const ZapOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l4.3543 4.3543-3.3449 4.0138c-.1543.1851-.3106.3726-.4244.5374-.1076.1558-.3041.4622-.3102.8648a1.5 1.5 0 0 0 .557 1.1893c.3132.2531.6744.2983.863.3154.1994.018.4435.018.6845.0179h6.195l-.8595 6.876a1 1 0 0 0 1.7605.7642l4.299-5.1588 4.2257 4.2257c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m18.6385 14.3959 2.0592-2.471c.1543-.1851.3106-.3726.4244-.5374.1076-.1558.3041-.4622.3102-.8648a1.5 1.5 0 0 0-.557-1.1893c-.3133-.2531-.6744-.2983-.863-.3154C19.8128 9 19.5687 9 19.3277 9h-6.085zM13.145 8.9023l.8473-6.7782a1.0001 1.0001 0 0 0-1.7605-.7642l-3.0133 3.616z"
    />
  </svg>
);

export const ZapSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M7.4336 12.2269 12 6v4.5h3.9213c.5091 0 .7636 0 .899.1053a.5.5 0 0 1 .1928.3805c.0049.1715-.1456.3768-.4467.7873L12 18v-4.5H8.0787c-.509 0-.7635 0-.899-.1053a.5.5 0 0 1-.1928-.3805c-.0048-.1715.1457-.3768.4467-.7873"
      clipRule="evenodd"
    />
  </svg>
);

export const LinkBroken01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 1c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.5523.4477-1 1-1M15 19c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1M2 8h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1s.4477-1 1-1M19 15c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1M2.7929 2.7929c.3905-.3905 1.0237-.3905 1.4142 0L5.6213 4.207c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L2.793 4.2071c-.3905-.3905-.3905-1.0237 0-1.4142M18.3787 18.3787c.3905-.3905 1.0237-.3905 1.4142 0l1.4142 1.4142c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-1.4142-1.4142c-.3905-.3905-.3905-1.0237 0-1.4142M13.4142 3.5147c1.9526-1.9526 5.1185-1.9526 7.0711 0s1.9526 5.1185 0 7.0711l-2.1213 2.1213c-.3906.3905-1.0237.3905-1.4143 0s-.3905-1.0237 0-1.4142l2.1214-2.1213c1.1715-1.1716 1.1715-3.0711 0-4.2427-1.1716-1.1715-3.0711-1.1715-4.2427 0l-2.1213 2.1214c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4143zm-6.364 7.7782c.3906.3905.3906 1.0237 0 1.4142L4.929 14.8284c-1.1715 1.1716-1.1715 3.0711 0 4.2427 1.1716 1.1715 3.0711 1.1715 4.2427 0l2.1213-2.1214c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4143l-2.1213 2.1213c-1.9526 1.9526-5.1185 1.9526-7.071 0-1.9527-1.9526-1.9527-5.1185 0-7.0711l2.1212-2.1213c.3906-.3905 1.0237-.3905 1.4143 0"
      clipRule="evenodd"
    />
  </svg>
);

export const LinkBroken02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2071 7.7929c.3905.3905.3905 1.0237 0 1.4142l-7 7c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l7-7c.3905-.3906 1.0237-.3906 1.4142 0M9 1c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.5523.4477-1 1-1M15 19c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1M2 8h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1s.4477-1 1-1M19 15c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1M2.7929 2.7929c.3905-.3905 1.0237-.3905 1.4142 0L5.6213 4.207c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L2.793 4.2071c-.3905-.3905-.3905-1.0237 0-1.4142M18.3787 18.3786c.3905-.3905 1.0237-.3905 1.4142 0l1.4142 1.4142c.3906.3905.3906 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-1.4142-1.4142c-.3905-.3905-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.4142 3.5146c1.9527-1.9526 5.1185-1.9526 7.0711 0s1.9526 5.1185 0 7.0711L18.364 12.707c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l2.1213-2.1213c1.1716-1.1716 1.1716-3.071 0-4.2427-1.1716-1.1715-3.0711-1.1715-4.2426 0l-2.1214 2.1214c-.3905.3905-1.0236.3905-1.4142 0s-.3905-1.0237 0-1.4142zm-6.364 7.7782c.3906.3905.3906 1.0237 0 1.4142L4.929 14.8283c-1.1716 1.1716-1.1716 3.0711 0 4.2427s3.071 1.1716 4.2426 0l2.1213-2.1213c.3906-.3906 1.0237-.3906 1.4142 0 .3906.3905.3906 1.0236 0 1.4142l-2.1213 2.1213c-1.9526 1.9526-5.1184 1.9526-7.071 0-1.9527-1.9526-1.9527-5.1185 0-7.0711l2.1213-2.1213c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const LinkExternal01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-6.2929 6.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 4H15c-.5523 0-1-.4477-1-1"
    />
    <path
      fill="currentColor"
      d="M7.7587 4H10c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.8c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 8.3611 4 8.9434 4 9.8v6.4c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C6.3611 19.9992 6.9434 20 7.8 20h6.4c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V14c0-.5523.4477-1 1-1s1 .4477 1 1v2.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C15.7106 22 15.0463 22 14.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V9.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 4 6.9537 4 7.7587 4"
    />
  </svg>
);

export const LinkExternal01Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-6.2929 6.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 4H15c-.5523 0-1-.4477-1-1"
    />
    <path
      fill="currentColor"
      d="M11.9544 7.803c.3961-.3961.5941-.5941.6683-.8224a1 1 0 0 0 0-.618c-.0742-.2284-.2722-.4264-.6683-.8224l-.7787-.7787-.036-.0362c-.1339-.1346-.3026-.3042-.5089-.4306a2 2 0 0 0-.5781-.2395c-.2354-.0565-.4745-.0558-.6644-.0554L9.3373 4H7.7587c-.805 0-1.4693 0-2.0105.0441-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.0021-.3918 1.5642C2 8.2893 2 8.9537 2 9.7586v6.4826c0 .805 0 1.4694.0442 2.0106.046.5621.1445 1.0788.3918 1.5641a4 4 0 0 0 1.748 1.7481c.4854.2473 1.002.3458 1.5642.3918.5412.0442 1.2055.0442 2.0105.0441h6.4826c.805.0001 1.4693.0001 2.0105-.0441.5621-.046 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.7481c.2473-.4853.3459-1.002.3918-1.5641C20 17.7106 20 17.0462 20 16.2413v-1.5786l.0001-.051c.0005-.19.0011-.4291-.0554-.6644a2 2 0 0 0-.2394-.5781c-.1265-.2064-.296-.375-.4307-.509l-.0361-.036-.7787-.7786c-.396-.3961-.594-.5941-.8223-.6683a1 1 0 0 0-.6181 0c-.2283.0742-.4263.2722-.8223.6683l-1.0758 1.0757c-1.1716 1.1716-3.071 1.1716-4.2426 0s-1.1716-3.071 0-4.2426z"
    />
  </svg>
);

export const LinkExternal02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7587 2H10c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.8c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 6.3611 4 6.9434 4 7.8v8.4c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C6.3611 19.9992 6.9434 20 7.8 20h8.4c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V14c0-.5523.4477-1 1-1s1 .4477 1 1v2.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2"
    />
    <path
      fill="currentColor"
      d="M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-7.2929 7.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 4H15c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const Loading01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1.25c.5523 0 1 .4477 1 1v2.5c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2.5c0-.5523.4477-1 1-1M12 17c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1M1.25 12c0-.5523.4477-1 1-1h3.5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3.5c-.5523 0-1-.4477-1-1M18.75 12c0-.5523.4477-1 1-1h1.5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1.5c-.5523 0-1-.4477-1-1M17.0429 17.0429c.3905-.3905 1.0237-.3905 1.4142 0l.7071.7071c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-.7071-.7071c-.3905-.3905-.3905-1.0237 0-1.4142M19.3713 4.7087c.3905.3905.3905 1.0237 0 1.4142L17.9571 7.537c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l1.4142-1.4142c.3905-.3905 1.0237-.3905 1.4142 0M8.4571 15.5429c.3905.3905.3905 1.0237 0 1.4142l-2.8284 2.8284c-.3906.3906-1.0237.3906-1.4142 0-.3906-.3905-.3906-1.0237 0-1.4142l2.8284-2.8284c.3905-.3905 1.0237-.3905 1.4142 0M4.4216 4.5016c.3905-.3906 1.0237-.3906 1.4142 0L7.957 6.6229c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L4.4216 5.9158c-.3906-.3905-.3906-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const Loading02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.5523.4477-1 1-1M12 17c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1M1 12c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1M17 12c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4c-.5523 0-1-.4477-1-1M15.5429 15.5429c.3905-.3905 1.0237-.3905 1.4142 0l2.8284 2.8284c.3906.3905.3906 1.0237 0 1.4142-.3905.3906-1.0237.3906-1.4142 0l-2.8284-2.8284c-.3905-.3905-.3905-1.0237 0-1.4142M19.7855 4.2928c.3906.3906.3906 1.0237 0 1.4143l-2.8284 2.8284c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l2.8284-2.8285c.3905-.3905 1.0237-.3905 1.4142 0M8.4571 15.5429c.3905.3905.3905 1.0237 0 1.4142l-2.8284 2.8284c-.3906.3906-1.0237.3906-1.4142 0-.3906-.3905-.3906-1.0237 0-1.4142l2.8284-2.8284c.3905-.3905 1.0237-.3905 1.4142 0M4.2145 4.2928c.3905-.3905 1.0237-.3905 1.4142 0L8.457 7.1213c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L4.2145 5.707c-.3906-.3905-.3906-1.0236 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const Loading03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.7776 4.222c-4.2959-4.296-11.2598-4.296-15.5557 0-4.2959 4.2958-4.2959 11.2597 0 15.5556s11.2598 4.2959 15.5557 0 4.2959-11.2598 0-15.5557M13.123 3.07c1.9158.2396 3.7693 1.095 5.2404 2.5661a9.01 9.01 0 0 1 1.4045 1.8153q.0128.025.027.0497c.9909 1.7124.4878 3.9001-1.1528 5.0108a1 1 0 0 0-.0248.0173c-1.2606.8378-2.8936.84-4.1517.0207a4 4 0 0 1-.1612-.111l-.9065-.6591.6596-.9071c1.4298-1.966 1.4752-4.6169.1144-6.6319a1 1 0 0 0-.0221-.0314A5.78 5.78 0 0 0 13.123 3.07M7.4311 4.2435a9.02 9.02 0 0 0-1.795 1.3926c-1.4716 1.4716-2.327 3.3258-2.5664 5.2423a5.78 5.78 0 0 1 1.1392-1.027 1 1 0 0 1 .0313-.022c2.0143-1.3613 4.6652-1.3154 6.632.114l.9081.6603.6596-.9072a4 4 0 0 0 .111-.1611c.8193-1.2581.8171-2.8911-.0207-4.1518a1 1 0 0 1-.0173-.0247C11.4021 3.7183 9.2145 3.2152 7.5021 4.206a1 1 0 0 1-.071.0374M4.2376 16.5584a9.02 9.02 0 0 0 1.3985 1.805c1.4714 1.4713 3.3253 2.3268 5.2414 2.5663a5.78 5.78 0 0 1-1.0251-1.1376 1 1 0 0 1-.0221-.0314c-1.3612-2.0142-1.3153-4.6652.114-6.632l.6599-.9074-.9078-.6601c-1.2787-.9292-2.9992-.9641-4.3128-.0905a1 1 0 0 1-.0248.0173c-1.6392 1.1104-2.1424 3.2963-1.1524 5.0119q.0167.029.0312.0585m12.294 3.2192a9.02 9.02 0 0 0 1.8318-1.4142c1.4709-1.4709 2.3262-3.324 2.566-5.2395a5.78 5.78 0 0 1-1.1378 1.0249 1 1 0 0 1-.0314.0221c-2.015 1.3608-4.6659 1.3154-6.6319-.1144l-.9065-.6591-.6596.9072c-.9292 1.2787-.9642 2.9991-.0905 4.3128l.0104.0147.0069.0101c1.1104 1.6392 3.2963 2.1424 5.0119 1.1524a1 1 0 0 1 .0307-.017"
      clipRule="evenodd"
    />
  </svg>
);

export const LogIn01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.089 4.0376C17.6389 4.0008 17.0566 4 16.2 4H15c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.2413c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2893 22 6.9537 22 7.7586v8.4827c0 .8049 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H15c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.2c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1805-.819.0367-.4501.0375-1.0324.0375-1.889V7.8c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804"
    />
    <path
      fill="currentColor"
      d="M9.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L12.5858 13H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h9.5858l-3.293-3.2929c-.3904-.3905-.3904-1.0237 0-1.4142"
    />
  </svg>
);

export const LogIn01Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.5307 2.037c.2356-.0374.4977-.0372.8022-.037h.1496c.477-.0002.8305-.0003 1.1432.0492 1.7116.2711 3.054 1.6135 3.325 3.325.0496.3128.0495.6663.0493 1.1433v10.965c.0002.477.0003.8305-.0493 1.1432-.271 1.7116-1.6134 3.054-3.325 3.325-.3127.0496-.6663.0495-1.1432.0493h-.1496c-.3045.0002-.5666.0004-.8022-.0369a3 3 0 0 1-2.4938-2.4938c-.0373-.2357-.0371-.4977-.0369-.8022v-.7617c0-.2446 0-.3669.0276-.482a1 1 0 0 1 .1197-.289c.0619-.1009.1483-.1874.3213-.3604l2.6527-2.6527c1.1716-1.1716 1.1716-3.071 0-4.2426L14.4686 7.226c-.173-.173-.2594-.2595-.3213-.3604a1 1 0 0 1-.1197-.289C14 6.4615 14 6.3392 14 6.0946v-.7617c-.0002-.3045-.0004-.5666.0369-.8022a3 3 0 0 1 2.4938-2.4938"
    />
    <path
      fill="currentColor"
      d="M9.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L12.5858 13H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h9.5858l-3.293-3.2929c-.3904-.3905-.3904-1.0237 0-1.4142"
    />
  </svg>
);

export const LogIn02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.8624 2h6.3789c.8049 0 1.4693 0 2.0105.0442.5621.0459 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4853.3459 1.002.3918 1.5641C22 6.2894 22 6.9538 22 7.7588v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5641a4 4 0 0 1-1.7481 1.7481c-.4853.2473-1.002.3459-1.5641.3918C17.7106 22 17.0463 22 16.2413 22H9.8624c-.7954.0005-1.386.0008-1.8977-.1363a4 4 0 0 1-2.8284-2.8284c-.1371-.5117-.1368-1.1024-.1364-1.8977V17c0-.5523.4478-1 1-1 .5524 0 1 .4477 1 1 0 .9943.0087 1.2953.0682 1.5176a2 2 0 0 0 1.4142 1.4142C8.7046 19.9914 9.0056 20 10 20h6.2c.8566 0 1.4388-.0008 1.8889-.0376.4385-.0358.6627-.1007.8191-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.8191.0368-.4501.0376-1.0323.0376-1.8889V7.8c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1447-.8191-.1805C17.6388 4.0008 17.0566 4 16.2 4H10c-.9944 0-1.2954.0086-1.5177.0681a2 2 0 0 0-1.4142 1.4142C7.0086 5.7046 7 6.0056 7 7c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.1376c-.0005-.7954-.0008-1.386.1363-1.8977a4 4 0 0 1 2.8284-2.8284c.5117-.1371 1.1023-.1368 1.8977-.1364"
    />
    <path
      fill="currentColor"
      d="M11.2929 7.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L13.5858 13H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h10.5858l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogIn02Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.9647 2.1363c.5117-.1371 1.1023-.1368 1.8977-.1364h6.3789c.8049 0 1.4693 0 2.0105.0443.5621.0459 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4853.3459 1.002.3918 1.5641C22 6.2894 22 6.9538 22 7.7588v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5641a4 4 0 0 1-1.7481 1.7481c-.4853.2473-1.002.3459-1.5641.3918C17.7106 22 17.0463 22 16.2413 22H9.8624c-.7954.0005-1.386.0008-1.8977-.1363a4 4 0 0 1-2.8284-2.8284c-.1371-.5117-.1368-1.1024-.1364-1.8977V16.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C5.76 15 6.04 15 6.6 15h1.4405c.3706 0 .556 0 .6609.052.1155.0573.156.0963.2174.2096.0559.103.065.3518.0834.8495a2.99 2.99 0 0 0 .8766 2.0102c1.1716 1.1716 3.071 1.1716 4.2426 0l4-4A2.99 2.99 0 0 0 19 12.0138v-.0236c-.0025-.7645-.2954-1.5282-.8787-2.1115l-4-4c-1.1716-1.1716-3.071-1.1716-4.2426 0a2.99 2.99 0 0 0-.8766 2.0102c-.0184.4977-.0275.7466-.0834.8495-.0614.1133-.102.1523-.2174.2096C8.5963 9 8.411 9 8.0404 9H6.5999c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C5 8.24 5 7.96 5 7.4v-.5376c-.0004-.7954-.0007-1.386.1364-1.8977a4 4 0 0 1 2.8284-2.8284"
    />
    <path
      fill="currentColor"
      d="M11.2929 7.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L13.5858 13H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h10.5858l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogIn03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.8146 3.4782c-.5073.0239-1.1612.1102-2.1168.2376l-6.592.879c-.3717.0495-.4839.0658-.571.0866a2 2 0 0 0-1.5243 1.741C7.0013 6.5116 7 6.625 7 7c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.0513C5 6.6473 5 6.423 5.021 6.2183a4 4 0 0 1 3.0485-3.482c.2002-.0479.4225-.0775.7213-.1172l6.6867-.8916c.9009-.1201 1.6401-.2187 2.2432-.247.623-.0294 1.203.0087 1.7573.2291a4 4 0 0 1 2.0111 1.7607c.2918.5204.4062 1.0903.4595 1.7116C22 5.7836 22 6.5293 22 7.4382v9.1236c0 .9089 0 1.6546-.0515 2.2563-.0533.6213-.1677 1.1912-.4595 1.7116a4 4 0 0 1-2.0111 1.7607c-.5543.2204-1.1343.2585-1.7573.2292-.6031-.0284-1.3423-.127-2.2432-.2471l-6.6869-.8916c-.2985-.0397-.521-.0693-.721-.1172a4 4 0 0 1-3.0486-3.482C5 17.577 5 17.3527 5 17.0513V17c0-.5523.4477-1 1-1s1 .4477 1 1c0 .3751.0013.4884.0105.5776a2 2 0 0 0 1.5242 1.741c.0872.0208.1994.0371.5712.0867l6.5919.8789c.9556.1274 1.6095.2137 2.1168.2376.4974.0234.7506-.0208.9244-.0899a2 2 0 0 0 1.0055-.8803c.0915-.1632.1687-.4083.2113-.9044.0434-.506.0442-1.1656.0442-2.1297v-9.035c0-.964-.0008-1.6237-.0442-2.1297-.0426-.496-.1198-.7412-.2113-.9043a2 2 0 0 0-1.0055-.8804c-.1738-.0691-.427-.1133-.9244-.0899"
    />
    <path
      fill="currentColor"
      d="M11.2929 7.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L13.5858 13H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h10.5858l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogIn03Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.7206 1.4804c.623-.0293 1.203.0088 1.7573.2292a4 4 0 0 1 2.0111 1.7607c.2918.5204.4062 1.0903.4595 1.7116C22 5.7835 22 6.5294 22 7.4382v9.1238c0 .9088 0 1.6545-.0515 2.2561-.0533.6213-.1677 1.1912-.4595 1.7116a4 4 0 0 1-2.0111 1.7607c-.5543.2204-1.1343.2585-1.7573.2292-.6031-.0284-1.3423-.127-2.2432-.2471l-6.6337-.8845-.0022-.0003-.051-.0068c-.2987-.0397-.521-.0693-.721-.1172a4 4 0 0 1-3.0486-3.482C5 17.577 5 17.3527 5 17.0513V16.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C5.76 15 6.04 15 6.6 15h1.4404c.3706 0 .556 0 .6609.052.1155.0573.156.0963.2174.2096.0559.103.065.3518.0834.8495a2.99 2.99 0 0 0 .8766 2.0102c1.1716 1.1716 3.071 1.1716 4.2426 0l4-4c1.1716-1.1716 1.1716-3.071 0-4.2426l-4-4c-1.1716-1.1716-3.071-1.1716-4.2426 0a2.99 2.99 0 0 0-.8766 2.0102c-.0184.4977-.0275.7466-.0834.8495-.0614.1133-.102.1523-.2174.2096C8.5963 9 8.411 9 8.0404 9H6.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C5 8.24 5 7.96 5 7.4v-.4513C5 6.6473 5 6.423 5.021 6.2183a4 4 0 0 1 3.0485-3.482c.2002-.0479.4225-.0775.7213-.1172l6.6867-.8916c.9009-.1201 1.6401-.2187 2.2432-.247"
    />
    <path
      fill="currentColor"
      d="M11.2929 7.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L13.5858 13H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h10.5858l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogIn04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 3C8.67 3 5.761 4.808 4.2034 7.5007c-.2765.478-.8883.6415-1.3663.365-.478-.2766-.6414-.8884-.3649-1.3664C4.3727 3.214 7.9272 1 12 1c6.0751 0 11 4.9249 11 11s-4.9249 11-11 11c-4.0728 0-7.6273-2.214-9.5278-5.4993-.2765-.478-.1132-1.0898.3649-1.3663s1.0898-.1132 1.3663.3649C5.7611 19.192 8.67 21 12 21c4.9706 0 9-4.0294 9-9s-4.0294-9-9-9"
    />
    <path
      fill="currentColor"
      d="M11.2929 7.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L13.5858 13H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h10.5858l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogIn04Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.3399 14.7243c-.1272-.4992-.1908-.7488-.109-1.0166.0654-.2137.246-.4462.437-.5623C1.9074 13 2.2034 13 2.7954 13h10.7903l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l4-4c.3906-.3905.3906-1.0237 0-1.4142l-4-4c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L13.5857 11H2.7954c-.592 0-.8881 0-1.1274-.1454-.191-.1161-.3717-.3486-.437-.5623-.0819-.2678-.0183-.5174.1089-1.0166C2.552 4.5183 6.865 1 11.9999 1c6.0752 0 11 4.9249 11 11s-4.9248 11-11 11c-5.1348 0-9.4479-3.5183-10.66-8.2757"
    />
  </svg>
);

export const LogOut01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7587 2H9c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.8c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 6.3611 4 6.9434 4 7.8v8.4c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C6.3611 19.9992 6.9434 20 7.8 20H9c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2"
    />
    <path
      fill="currentColor"
      d="M15.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 13H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h9.5858l-3.2929-3.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogOut01Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.4693 2.037c-.2357-.0373-.4977-.0372-.8022-.037h-.1496c-.477-.0001-.8305-.0002-1.1433.0493-1.7115.271-3.0539 1.6134-3.325 3.325-.0495.3128-.0494.6663-.0492 1.1432v10.9651c-.0002.4769-.0003.8304.0492 1.1432.2711 1.7116 1.6135 3.0539 3.325 3.325.3128.0495.6662.0494 1.1432.0493h.1497c.3045.0002.5665.0003.8022-.037a3 3 0 0 0 2.4937-2.4937c.0374-.2357.0372-.4977.037-.8022V16c0-.5523-.4477-1-1-1-1.6569 0-3-1.3431-3-3s1.3431-3 3-3c.5523 0 1-.4477 1-1V5.333c.0002-.3046.0004-.5666-.037-.8022A3 3 0 0 0 7.4693 2.037"
    />
    <path
      fill="currentColor"
      d="M15.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 13H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h9.5858l-3.2929-3.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogOut02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.5176 4.0681C9.2954 4.0086 8.9944 4 8 4h-.5c-.7126 0-1.197.0005-1.5734.0262-.3674.025-.5585.0707-.692.126a2 2 0 0 0-1.0824 1.0824c-.0553.1335-.1009.3245-.126.692C4.0005 6.303 4 6.7874 4 7.5v9c0 .7126.0005 1.1969.0262 1.5734.0251.3674.0707.5584.126.6919a2 2 0 0 0 1.0824 1.0824c.1335.0553.3245.101.692.126C6.303 19.9994 6.7874 20 7.5 20H8c.9944 0 1.2954-.0086 1.5176-.0682a2 2 0 0 0 1.4143-1.4142C10.9914 18.2953 11 17.9943 11 17c0-.5523.4477-1 1-1s1 .4477 1 1l.0001.1375c.0004.7954.0007 1.3861-.1364 1.8978a4 4 0 0 1-2.8284 2.8284c-.5117.1371-1.1023.1368-1.8977.1363h-.6719c-.6698 0-1.2226 0-1.6752-.0309-.4693-.032-.9034-.1005-1.3212-.2736a4 4 0 0 1-2.1648-2.1648c-.173-.4178-.2416-.8519-.2736-1.3212-.031-.4526-.031-1.0055-.0309-1.6752V7.4657c0-.6698 0-1.2227.0309-1.6753.032-.4692.1005-.9033.2736-1.3212a4 4 0 0 1 2.1648-2.1647c.4178-.1731.8519-.2416 1.3212-.2737C6.243 2 6.7959 2 7.4657 2h.6719c.7954-.0005 1.386-.0008 1.8977.1363a4 4 0 0 1 2.8284 2.8284c.1371.5117.1368 1.1023.1364 1.8977L13 7c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-.9944-.0086-1.2954-.0681-1.5177a2 2 0 0 0-1.4143-1.4142"
    />
    <path
      fill="currentColor"
      d="M15.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 13H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h9.5858l-3.2929-3.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogOut02Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.1376 2c.7954-.0005 1.386-.0008 1.8977.1363a4 4 0 0 1 2.8284 2.8284c.1371.5117.1368 1.1023.1364 1.8977V7.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.4371.437C12.2401 9 11.9601 9 11.4001 9H9c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3h2.4001c.56 0 .84 0 1.0539.109a1 1 0 0 1 .4371.437c.109.2139.109.4939.109 1.054v.5376c.0004.7953.0007 1.386-.1364 1.8977a4 4 0 0 1-2.8284 2.8284c-.5117.1371-1.1023.1368-1.8977.1363h-.6719c-.6698 0-1.2226 0-1.6752-.0309-.4693-.032-.9034-.1005-1.3212-.2736a4 4 0 0 1-2.1648-2.1648c-.173-.4178-.2416-.8519-.2736-1.3212-.031-.4526-.031-1.0055-.0309-1.6752V7.4657c0-.6698 0-1.2227.0309-1.6753.032-.4692.1005-.9033.2736-1.3212a4 4 0 0 1 2.1648-2.1647c.4178-.1731.8519-.2416 1.3212-.2737C6.243 2 6.7959 2 7.4657 2z"
    />
    <path
      fill="currentColor"
      d="M15.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 13H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h9.5858l-3.2929-3.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogOut03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m8.0712 2.5573 1.1006.1223c.252.028.4393.0487.6083.0823 1.7464.3472 3.053 1.807 3.2053 3.5812.0147.1717.0147.3601.0146.6136V7c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-.3156-.0009-.4112-.0073-.486A2 2 0 0 0 9.39 4.7236c-.0736-.0146-.1684-.026-.482-.061l-1.0215-.1134c-.7816-.0869-1.3157-.1456-1.7317-.1621-.4083-.0162-.6194.0135-.7644.06a2 2 0 0 0-1.2163 1.0886c-.062.139-.115.3455-.144.753C4.0006 6.704 4 7.2414 4 8.0277v7.9447c0 .7864.0006 1.3237.0301 1.739.029.4076.0819.6141.144.7531a2 2 0 0 0 1.2163 1.0886c.145.0464.3561.0762.7644.06.416-.0165.9501-.0753 1.7317-.1621l1.0214-.1135c.3136-.0348.4086-.0463.4821-.0609a2 2 0 0 0 1.6027-1.7906C10.9991 17.4111 11 17.3156 11 17c0-.5523.4477-1 1-1s1 .4477 1 1v.0432c.0001.2535.0001.442-.0146.6137-.1523 1.7741-1.4589 3.2339-3.2054 3.5812-.169.0336-.3564.0544-.6083.0823l-1.1005.1223c-.7365.0818-1.3415.149-1.8371.1687-.5113.0203-.9886-.0049-1.4532-.1535a4 4 0 0 1-2.4327-2.1773c-.199-.4454-.2767-.917-.313-1.4274C2 17.3585 2 16.7497 2 16.0087V7.9913c0-.741 0-1.3498.0352-1.8445.0363-.5105.114-.982.313-1.4274A4 4 0 0 1 4.781 2.5421c.4646-.1487.9418-.1738 1.4532-.1536.4955.0197 1.1006.087 1.8371.1688"
    />
    <path
      fill="currentColor"
      d="M15.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 13H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h9.5858l-3.2929-3.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogOut03Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.2341 2.3886c.4955.0196 1.1006.0869 1.8371.1687l1.1006.1223c.252.028.4393.0487.6083.0823 1.7464.3472 3.053 1.807 3.2053 3.5812.0147.1717.0147.3601.0146.6136V7.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C12.2401 9 11.9601 9 11.4 9H9c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3h2.4c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054v.4432c.0001.2535.0001.442-.0146.6137-.1523 1.7741-1.4589 3.2339-3.2054 3.5812-.169.0336-.3563.0543-.6082.0823l-1.0625.118-.002.0003-.0362.004c-.7365.0818-1.3415.149-1.837.1687-.5114.0203-.9886-.0049-1.4532-.1535a4 4 0 0 1-2.4327-2.1773c-.199-.4454-.2767-.917-.313-1.4274C2 17.3585 2 16.7497 2 16.0087V7.9913c0-.741 0-1.3498.0352-1.8445.0363-.5105.114-.982.313-1.4274A4 4 0 0 1 4.781 2.5421c.4646-.1487.9418-.1738 1.4532-.1536"
    />
    <path
      fill="currentColor"
      d="M15.2929 6.2929c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 13H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h9.5858l-3.2929-3.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogOut04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1 12C1 6.513 5.2927 2 10.6667 2c1.7666 0 3.4238.4911 4.8482 1.3468.4735.2844.6267.8988.3423 1.3722s-.8987.6267-1.3721.3423C13.36 4.3854 12.0572 4 10.6667 4 6.4677 4 3 7.5458 3 12s3.4677 8 7.6667 8c1.3905 0 2.6933-.3854 3.8184-1.0613.4734-.2844 1.0877-.1311 1.3721.3423s.1312 1.0878-.3423 1.3722C14.0905 21.5089 12.4333 22 10.6667 22 5.2927 22 1 17.4869 1 12"
    />
    <path
      fill="currentColor"
      d="M17.2929 7.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L19.5858 13H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h10.5858l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LogOut04Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1 12C1 6.513 5.2927 2 10.6667 2a9.36 9.36 0 0 1 3.4563.6584c.2796.1108.4194.1661.5537.2875.1083.098.2146.2544.2657.3912.0635.1695.0635.345.0635.6957V7.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C14.246 9 13.9659 9 13.4059 9H9c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3h4.4016c.5595 0 .8393 0 1.0531.1089a1 1 0 0 1 .437.4365c.1091.2137.1093.4935.1099 1.053l.0033 3.3677c.0004.3511.0005.5267-.0628.6964-.0512.137-.1575.2936-.2659.3917-.1343.1215-.2743.177-.5542.2878a9.36 9.36 0 0 1-3.4553.658C5.2927 22 1 17.4869 1 12"
    />
    <path
      fill="currentColor"
      d="M17.2929 7.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L19.5858 13H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h10.5858l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const MedicalCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m1.7788 5.773c.0545.107.0545.247.0545.527v2.0667c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545H16.7c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185c.0545.1069.0545.2469.0545.527v2.0666c0 .2801 0 .4201-.0545.527a.5.5 0 0 1-.2185.2185c-.107.0545-.247.0545-.527.0545h-2.0667c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185c-.0545.107-.0545.247-.0545.527V16.7c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185c-.1069.0545-.2469.0545-.527.0545h-2.0666c-.2801 0-.4201 0-.527-.0545a.5.5 0 0 1-.2185-.2185c-.0545-.107-.0545-.247-.0545-.527v-2.0667c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185c-.107-.0545-.247-.0545-.527-.0545H7.3c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185c-.0545-.1069-.0545-.2469-.0545-.527v-2.0666c0-.2801 0-.4201.0545-.527a.5.5 0 0 1 .2185-.2185c.107-.0545.247-.0545.527-.0545h2.0667c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527V7.3c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185c.1069-.0545.2469-.0545.527-.0545h2.0666c.2801 0 .4201 0 .527.0545a.5.5 0 0 1 .2185.2185"
      clipRule="evenodd"
    />
  </svg>
);

export const MedicalCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.5681 2h2.8638c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.454.0169.7063l.0115 3.4205L19.4319 8c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v2.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169l-3.4204.0115L16 19.4319c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-2.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C8 19.9301 8 19.6843 8 19.4319L8.017 16H4.568c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C2 13.9301 2 13.6843 2 13.4319v-2.8638c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201C4.0699 8 4.3158 8 4.568 8l3.4205-.0114L8 4.568c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201C10.0699 2 10.3157 2 10.568 2"
      clipRule="evenodd"
    />
  </svg>
);

export const MedicalSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2m-4.0597 4.773c.0545.107.0545.247.0545.527v2.0667c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545H16.7c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185c.0545.1069.0545.2469.0545.527v2.0666c0 .2801 0 .4201-.0545.527a.5.5 0 0 1-.2185.2185c-.107.0545-.247.0545-.527.0545h-2.0667c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185c-.0545.107-.0545.247-.0545.527V16.7c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185c-.1069.0545-.2469.0545-.527.0545h-2.0666c-.2801 0-.4201 0-.527-.0545a.5.5 0 0 1-.2185-.2185c-.0545-.107-.0545-.247-.0545-.527v-2.0667c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185c-.107-.0545-.247-.0545-.527-.0545H7.3c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185c-.0545-.1069-.0545-.2469-.0545-.527v-2.0666c0-.2801 0-.4201.0545-.527a.5.5 0 0 1 .2185-.2185c.107-.0545.247-.0545.527-.0545h2.0667c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527V7.3c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185c.1069-.0545.2469-.0545.527-.0545h2.0666c.2801 0 .4201 0 .527.0545a.5.5 0 0 1 .2185.2185"
      clipRule="evenodd"
    />
  </svg>
);

export const Menu01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 6c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 18c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Menu02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 6c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 18c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Menu03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 6c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 18c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Menu04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 6c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M8 18c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Menu05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 8.5c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 15.5c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Minus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 12c0-.5523.4477-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const MinusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M8 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const MinusSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M8 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Percent01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.7071 4.2929c.3905.3905.3905 1.0237 0 1.4142l-14 14c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l14-14c.3905-.3905 1.0237-.3905 1.4142 0M4.5 6.5c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M15.5 17.5c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Percent02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.7071 4.2929c.3905.3905.3905 1.0237 0 1.4142l-14 14c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l14-14c.3905-.3905 1.0237-.3905 1.4142 0M4 7c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3M14 17c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3"
      clipRule="evenodd"
    />
  </svg>
);

export const Percent03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m4.7071 7.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-8 8c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM7.5 9c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5S7.5 9.8284 7.5 9m6 6c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Pin01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.3236 1c-.3616 0-.6977 0-.9728.025-.2879.026-.6472.0882-.9788.308a2 2 0 0 0-.8531 1.2601c-.081.3896-.0052.7462.0774 1.0232.079.2648.2039.5768.3382.9125l1.0226 2.5565c.0137.0343.0353.0723.0424.1089.0004.022.0005.0521.0005.114v2.1306c0 .0698.001.14-.0019.2098l-.0017.0023a6 6 0 0 1-.1279.1627L5.271 11.8105c-.309.3863-.5827.7283-.7746 1.0185-.1873.2833-.4153.6843-.4158 1.1688a2 2 0 0 0 .7523 1.5653c.3787.3023.8343.3748 1.1725.4055.3464.0315.7844.0314 1.2791.0314H11v6c0 .5523.4477 1 1 1s1-.4477 1-1v-6h3.7155c.4946 0 .9327.0001 1.2791-.0314.3383-.0307.7938-.1032 1.1725-.4055.476-.38.7529-.9562.7523-1.5653-.0005-.4845-.2285-.8855-.4158-1.1688-.1918-.2902-.4655-.6322-.7746-1.0185l-1.5975-1.997c-.0437-.0545-.0882-.1086-.1296-.165l-.0001-.0029A6 6 0 0 1 17 9.4388V7.308c0-.0618.0001-.092.0006-.114v-.0014c.0134-.036.028-.0717.0423-.1074l1.0226-2.5565c.1344-.3357.2592-.6477.3382-.9125.0826-.277.1584-.6336.0774-1.0232a2 2 0 0 0-.8531-1.26c-.3316-.22-.6909-.282-.9788-.3082C16.3741 1 16.038 1 15.6764 1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Pin02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.3838 2.4103c-.2557-.2558-.4933-.4934-.7055-.6703-.2221-.1851-.5201-.3952-.91-.4743a2 2 0 0 0-1.4943.2878c-.3327.2182-.5313.524-.6687.7783-.1314.243-.2637.552-.4062.8843L11.1145 5.747a6 6 0 0 1-.0454.1045l-.0006.0014-.001.001a6 6 0 0 1-.0802.081l-1.5609 1.561a6 6 0 0 1-.1273.1254l-.0018.0017-.0024.0005a6 6 0 0 1-.175.0364l-3.707.7414c-.4396.0879-.835.167-1.1454.2591-.3106.0923-.7118.244-1.0152.586a2 2 0 0 0-.4851 1.6021c.0628.4528.3125.8016.5197 1.0507.207.2489.4922.534.8093.851l2.8663 2.8663-4.9498 4.9498c-.3905.3905-.3905 1.0236 0 1.4142s1.0237.3905 1.4143 0l4.9497-4.9498 2.8664 2.8664c.317.3171.6021.6022.851.8093.2491.2073.5979.4569 1.0507.5197a2 2 0 0 0 1.6021-.4851c.342-.3034.4937-.7046.586-1.0152.0922-.3104.1712-.7058.2591-1.1455l.7414-3.7068a6 6 0 0 1 .0364-.1751l.0005-.0024.0017-.0018a6 6 0 0 1 .1255-.1273l1.5609-1.5609c.0437-.0437.065-.065.0809-.0802l.0011-.001.0014-.0006a6 6 0 0 1 .1045-.0454l2.5308-1.0846c.3324-.1425.6413-.2748.8843-.4062.2544-.1374.5601-.336.7783-.6687a2 2 0 0 0 .2878-1.4943c-.0791-.39-.2892-.688-.4743-.91-.1769-.2122-.4145-.4498-.6703-.7055z"
      clipRule="evenodd"
    />
  </svg>
);

export const Placeholder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3c-4.9706 0-9 4.0294-9 9s4.0294 9 9 9 9-4.0294 9-9-4.0294-9-9-9M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11-4.9249 11-11 11S1 18.0751 1 12"
      clipRule="evenodd"
    />
  </svg>
);

export const Plus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 5c0-.5523-.4477-1-1-1s-1 .4477-1 1v6H5c-.5523 0-1 .4477-1 1s.4477 1 1 1h6v6c0 .5523.4477 1 1 1s1-.4477 1-1v-6h6c.5523 0 1-.4477 1-1s-.4477-1-1-1h-6z"
    />
  </svg>
);

export const PlusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m0 6c.5523 0 1 .4477 1 1v3h3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h3V8c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const PlusSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M12 7c.5523 0 1 .4477 1 1v3h3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h3V8c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Save01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.8719 2.083c-.3484-.0837-.7072-.0833-1.1141-.083l-6.9991.0001c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2895 2 6.9538 2 7.7588v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.5412.0442 1.2055.0442 2.0105.0442h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 17.7107 22 17.0464 22 16.2414l.0001-6.9991c.0003-.407.0007-.7657-.083-1.1141a3 3 0 0 0-.3592-.8672c-.1872-.3055-.4411-.559-.7291-.8464l-3.2433-3.2433c-.2875-.288-.5409-.5419-.8464-.7291a3 3 0 0 0-.8672-.3592m-.4669 1.9446C15.3167 4.0064 15.2113 4 14.6745 4H7.8c-.2978 0-.5625 0-.8.0018v2.3981c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h6.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054v-.9857l-.7698-.7698c-.3796-.3796-.4587-.4496-.5361-.497a1 1 0 0 0-.2891-.1198M8.6 13h6.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054v5.4H7v-5.4c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437c.214-.109.494-.109 1.054-.109"
      clipRule="evenodd"
    />
  </svg>
);

export const Save02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.8719 2.083c-.3484-.0837-.7072-.0833-1.1141-.083l-6.9991.0001c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2895 2 6.9538 2 7.7588v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.5412.0442 1.2055.0442 2.0105.0442h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 17.7107 22 17.0464 22 16.2414l.0001-6.9991c.0003-.407.0007-.7657-.083-1.1141a3 3 0 0 0-.3592-.8672c-.1872-.3055-.4411-.559-.7291-.8464l-3.2433-3.2433c-.2875-.288-.5409-.5419-.8464-.7291a3 3 0 0 0-.8672-.3592M7 4c.5523 0 1 .4477 1 1v2h9c.5523 0 1 .4477 1 1s-.4477 1-1 1H8.5681c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4983-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C6 6.9301 6 6.6842 6 6.432V5c0-.5523.4477-1 1-1m8.4 9H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 13.7599 7 14.0399 7 14.6V20h10v-5.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C16.2401 13 15.9601 13 15.4 13"
      clipRule="evenodd"
    />
  </svg>
);

export const Save03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.405 4.0277c-.0883-.0212-.1937-.0276-.7305-.0276H7c-.5523 0-1-.4477-1-1s.4477-1 1-1h7.7578c.4069-.0004.7657-.0008 1.1141.0829.3061.0735.5988.1947.8672.3592.3055.1872.5589.4411.8464.7291l.0589.059 3.1254 3.1254.059.059c.288.2874.5419.5408.7291.8463a3 3 0 0 1 .3592.8672c.0837.3484.0833.7072.083 1.114L22 9.3257V17c0 .5523-.4477 1-1 1s-1-.4477-1-1V9.3256c0-.5368-.0064-.6422-.0276-.7305a1 1 0 0 0-.1198-.289c-.0474-.0775-.1174-.1566-.497-.5362l-3.1254-3.1254c-.3796-.3796-.4587-.4496-.5361-.497a1 1 0 0 0-.2891-.1198"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.8883 5.5c.1899-.0005.429-.0012.6644.0553.2041.049.3991.1298.5781.2395.2063.1264.375.296.5089.4306l.036.0362 2.0628 2.0627.0361.036c.1347.134.3042.3026.4307.509.1096.179.1904.374.2394.578.0565.2354.0559.4745.0554.6645l-.0001.051v7.6759c0 .5271 0 .9818-.0306 1.3564-.0323.3953-.1036.7885-.2964 1.1669a3 3 0 0 1-1.311 1.3111c-.3784.1928-.7716.2641-1.167.2964-.3745.0306-.8294.0306-1.3565.0305H6.1614c-.5271.0001-.9819.0001-1.3564-.0305-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.3111c-.1928-.3784-.2641-.7716-.2964-1.1669C2 18.8205 2 18.3657 2 17.8386V9.6615c0-.5272 0-.982.0306-1.3565.0323-.3953.1036-.7885.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.264 1.167-.2964.3746-.0306.8293-.0306 1.3565-.0305h7.6758zM11.9 15H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 15.76 7 16.04 7 16.6001v3.4h6.5v-3.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437c-.2139-.109-.4939-.109-1.054-.109m-3.9-6.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v.0265c0 .21 0 .4147.0118.5887.013.1904.0435.4161.1405.6502.203.49.5923.8794 1.0823 1.0824.234.0969.4598.1274.6502.1404.174.0118.3787.0118.5887.0118H12.5c.5523 0 1-.4477 1-1s-.4477-1-1-1H8z"
      clipRule="evenodd"
    />
  </svg>
);

export const SearchLg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.5 2C6.2533 2 2 6.2533 2 11.5S6.2533 21 11.5 21c2.2631 0 4.3415-.7914 5.9733-2.1125l2.8196 2.8196c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-2.8196-2.8196C20.2086 15.8415 21 13.7631 21 11.5 21 6.2533 16.7467 2 11.5 2M4 11.5C4 7.3579 7.3579 4 11.5 4S19 7.3579 19 11.5 15.6421 19 11.5 19 4 15.6421 4 11.5"
      clipRule="evenodd"
    />
  </svg>
);

export const SearchMd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 2c-4.9706 0-9 4.0294-9 9s4.0294 9 9 9c2.125 0 4.078-.7365 5.6177-1.9681l3.6752 3.6752c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-3.6752-3.6752C19.2635 15.078 20 13.125 20 11c0-4.9706-4.0294-9-9-9m-7 9c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7-7-3.134-7-7"
      clipRule="evenodd"
    />
  </svg>
);

export const SearchRefraction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 6c0-.5523.4477-1 1-1 3.3137 0 6 2.6863 6 6 0 .5523-.4477 1-1 1s-1-.4477-1-1c0-2.2091-1.7909-4-4-4-.5523 0-1-.4477-1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 11c0-4.9706 4.0294-9 9-9s9 4.0294 9 9c0 2.125-.7365 4.078-1.9681 5.6177l3.6752 3.6752c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-3.6752-3.6752C15.078 19.2635 13.125 20 11 20c-4.9706 0-9-4.0294-9-9m9-7c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7"
      clipRule="evenodd"
    />
  </svg>
);

export const SearchSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 2c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8c1.8487 0 3.551-.6271 4.9056-1.6801l5.3873 5.3872c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-5.3872-5.3873C17.3729 13.551 18 11.8487 18 10c0-4.4183-3.5817-8-8-8m-6 8c0-3.3137 2.6863-6 6-6s6 2.6863 6 6-2.6863 6-6 6-6-2.6863-6-6"
      clipRule="evenodd"
    />
  </svg>
);

export const Settings01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.286 15.9606A1.65 1.65 0 0 1 19.4 15a1.65 1.65 0 0 1 1.51-1H21a2 2 0 0 0 0-4h-.17a1.65 1.65 0 0 1-1.51-1v-.08a1.65 1.65 0 0 1 .33-1.82l.06-.06a1.9991 1.9991 0 0 0 .4341-2.1809A2 2 0 0 0 19.71 4.21a1.9995 1.9995 0 0 0-2.1809-.4341 2 2 0 0 0-.6491.4341l-.06.06A1.65 1.65 0 0 1 15 4.6a1.65 1.65 0 0 1-1-1.51V3a1.9999 1.9999 0 1 0-4 0v.17a1.65 1.65 0 0 1-1 1.51h-.08a1.65 1.65 0 0 1-1.82-.33l-.06-.06a2 2 0 0 0-2.83 0 2 2 0 0 0 0 2.83l.06.06A1.65 1.65 0 0 1 4.6 9a1.65 1.65 0 0 1-1.51 1.08H3a1.9999 1.9999 0 1 0 0 4h.17a1.65 1.65 0 0 1 1.51 1 1.65 1.65 0 0 1-.33 1.82l-.06.06a1.9995 1.9995 0 0 0-.4341 2.1809c.1006.2428.2481.4634.4341.6491a1.9991 1.9991 0 0 0 2.1809.4341A2 2 0 0 0 7.12 19.79l.06-.06A1.65 1.65 0 0 1 9 19.4a1.65 1.65 0 0 1 1.08 1.51V21a2 2 0 0 0 4 0v-.17a1.65 1.65 0 0 1 1-1.51 1.65 1.65 0 0 1 1.82.33l.06.06a1.9993 1.9993 0 0 0 2.83 0 1.9993 1.9993 0 0 0 0-2.83l-.06-.06a1.65 1.65 0 0 1-.444-.8594M15 12c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
      clipRule="evenodd"
    />
  </svg>
);

export const Settings02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m9.7423 21.5541-.6526-1.4459a2.682 2.682 0 0 0-1.1214-1.2283 2.75 2.75 0 0 0-1.6412-.3435l-1.5966.1675a2.504 2.504 0 0 1-1.3805-.252A2.457 2.457 0 0 1 2.3314 17.5a2.404 2.404 0 0 1-.328-1.3449 2.41 2.41 0 0 1 .4694-1.3037l.9453-1.2796A2.645 2.645 0 0 0 3.9366 12a2.645 2.645 0 0 0-.5185-1.5718l-.9453-1.2797a2.41 2.41 0 0 1-.4694-1.3036A2.404 2.404 0 0 1 2.3314 6.5a2.455 2.455 0 0 1 1.0184-.9523 2.5 2.5 0 0 1 1.3807-.2516l1.6015.1675A2.75 2.75 0 0 0 7.9734 5.12a2.682 2.682 0 0 0 1.1164-1.2283l.6525-1.446a2.444 2.444 0 0 1 .9113-1.0527A2.497 2.497 0 0 1 12 1c.478 0 .9457.1365 1.3465.3931.4007.2567.7173.6224.9113 1.0528l.6574 1.4459A2.682 2.682 0 0 0 16.0317 5.12a2.75 2.75 0 0 0 1.6412.3435l1.5966-.1675a2.5 2.5 0 0 1 1.3807.2515 2.455 2.455 0 0 1 1.0184.9524 2.403 2.403 0 0 1 .328 1.345 2.41 2.41 0 0 1-.4694 1.3036l-.9453 1.2796A2.645 2.645 0 0 0 20.0634 12a2.645 2.645 0 0 0 .5136 1.5779l.9453 1.2797c.2812.3806.4442.8334.4693 1.3036a2.404 2.404 0 0 1-.3279 1.3449 2.454 2.454 0 0 1-1.0185.9524 2.5 2.5 0 0 1-1.3807.2515l-1.5965-.1674a2.75 2.75 0 0 0-1.6413.3434 2.682 2.682 0 0 0-1.1164 1.2222l-.6525 1.4459a2.445 2.445 0 0 1-.9113 1.0528A2.497 2.497 0 0 1 12 23a2.497 2.497 0 0 1-1.3465-.3931 2.444 2.444 0 0 1-.9112-1.0528M15 12c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
      clipRule="evenodd"
    />
  </svg>
);

export const Settings03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.6713 3H5.5C3.567 3 2 4.567 2 6.5S3.567 10 5.5 10h9.1713c.7729.6254 1.7571 1 2.8287 1 2.4853 0 4.5-2.0147 4.5-4.5S19.9853 2 17.5 2a4.48 4.48 0 0 0-2.8287 1m-1.4152 2A4.49 4.49 0 0 0 13 6.5c0 .526.0902 1.0308.2561 1.5H5.5C4.6716 8 4 7.3284 4 6.5S4.6716 5 5.5 5zM6.5 13a4.48 4.48 0 0 1 2.8287 1H18.5c1.933 0 3.5 1.567 3.5 3.5S20.433 21 18.5 21H9.3287c-.7729.6254-1.757 1-2.8287 1C4.0147 22 2 19.9853 2 17.5S4.0147 13 6.5 13m4.5 4.5c0-.526-.0902-1.0308-.2561-1.5H18.5c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5h-7.7561A4.49 4.49 0 0 0 11 17.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Settings04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.126 9H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h11.126c.4441-1.7252 2.0102-3 3.874-3 2.2091 0 4 1.7909 4 4s-1.7909 4-4 4c-1.8638 0-3.4299-1.2748-3.874-3M6 12c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4c1.8638 0 3.43-1.2748 3.874-3H21c.5523 0 1-.4477 1-1s-.4477-1-1-1H9.874C9.43 13.2748 7.8638 12 6 12"
    />
  </svg>
);

export const Share01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.2929 2.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 5.4142V15c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-2.2929 2.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143z"
    />
    <path
      fill="currentColor"
      d="M3 11c.5523 0 1 .4477 1 1v4.2c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C6.3611 19.9992 6.9434 20 7.8 20h8.4c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V12c0-.5523.4477-1 1-1s1 .4477 1 1v4.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V12c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const Share01Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.2929 2.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 5.4142V15c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-2.2929 2.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143z"
    />
    <path
      fill="currentColor"
      d="M9 12.5343c0-.4982 0-.7472-.0868-.9417a1 1 0 0 0-.5058-.5058C8.213 11 7.964 11 7.4657 11c-.6697 0-1.2226 0-1.6752.0309-.4693.032-.9034.1005-1.3212.2736a4 4 0 0 0-2.1648 2.1648c-.173.4178-.2416.8519-.2736 1.3212-.031.4526-.031 1.0054-.0309 1.6752v.0686c0 .6697 0 1.2226.0309 1.6752.032.4693.1005.9034.2736 1.3212a4 4 0 0 0 2.1648 2.1648c.4178.1731.8519.2416 1.3212.2736C6.243 22 6.7959 22 7.4657 22h9.0686c.6698 0 1.2226 0 1.6752-.0309.4693-.032.9034-.1005 1.3212-.2736a4 4 0 0 0 2.1648-2.1648c.1731-.4178.2416-.8519.2736-1.3212C22 17.7569 22 17.2041 22 16.5343v-.0686c0-.6698 0-1.2226-.0309-1.6752-.032-.4693-.1005-.9034-.2736-1.3212a4 4 0 0 0-2.1648-2.1648c-.4178-.1731-.8519-.2416-1.3212-.2736C17.7569 11 17.2041 11 16.5343 11c-.4982 0-.7473 0-.9417.0868a1 1 0 0 0-.5058.5058C15 11.787 15 12.0361 15 12.5343V15c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3z"
    />
  </svg>
);

export const Share02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.2929 2.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 5.4142V15c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-2.2929 2.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143z"
    />
    <path
      fill="currentColor"
      d="M6.8624 10 7 10.0001c.5523 0 1 .4477 1 1s-.4477 1-1 1c-.9944 0-1.2954.0086-1.5177.0681a2 2 0 0 0-1.4142 1.4143C4.0086 13.7047 4 14.0057 4 15.0001v1.2c0 .8566.0008 1.4389.0375 1.889.0358.4384.1008.6626.1805.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804.4501.0368 1.0324.0376 1.889.0376h8.4c.8566 0 1.4388-.0008 1.8889-.0376.4385-.0358.6627-.1007.8191-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889v-1.2c0-.9944-.0086-1.2954-.0682-1.5176a2 2 0 0 0-1.4142-1.4143c-.2223-.0595-.5233-.0681-1.5176-.0681-.5523 0-1-.4477-1-1s.4477-1 1-1L17.1376 10c.7953-.0004 1.386-.0007 1.8977.1364a4 4 0 0 1 2.8284 2.8284c.1371.5117.1368 1.1023.1363 1.8977v1.3789c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.7481 1.748c-.4853.2473-1.002.3459-1.5641.3918-.5412.0442-1.2056.0442-2.0105.0442H7.7587c-.805 0-1.4694 0-2.0106-.0442-.562-.0459-1.0788-.1445-1.564-.3918a4 4 0 0 1-1.7481-1.748c-.2473-.4854-.346-1.0021-.3918-1.5642C1.9999 17.7107 2 17.0464 2 16.2414v-1.3789c-.0005-.7954-.0008-1.386.1363-1.8977a4 4 0 0 1 2.8284-2.8284C5.4764 9.9993 6.067 9.9996 6.8624 10"
    />
  </svg>
);

export const Share02Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.2929 2.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 5.4142V15c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-2.2929 2.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143z"
    />
    <path
      fill="currentColor"
      d="M9 11.6c0-.56 0-.84-.109-1.0539a1 1 0 0 0-.437-.4371C8.24 10 7.96 10 7.4 10h-.5376c-.7954-.0004-1.386-.0007-1.8977.1364a4 4 0 0 0-2.8284 2.8284c-.1371.5117-.1368 1.1023-.1364 1.8977v1.3789c0 .805 0 1.4693.0443 2.0105.0459.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4853.2473 1.002.3459 1.5641.3918.5412.0442 1.2056.0442 2.0106.0442h8.4826c.8049 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5641-.3918a4 4 0 0 0 1.7481-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 17.7107 22 17.0464 22 16.2414v-1.3789c.0005-.7954.0008-1.386-.1363-1.8977a4 4 0 0 0-2.8284-2.8284c-.5117-.1371-1.1024-.1368-1.8977-.1364H16.6c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.4371C15 10.76 15 11.04 15 11.6V15c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3z"
    />
  </svg>
);

export const Share03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7587 2H10c.5523 0 1 .4477 1 1s-.4477 1-1 1H7.8c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 6.3611 4 6.9434 4 7.8v8.4c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C6.3611 19.9992 6.9434 20 7.8 20h8.4c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V14c0-.5523.4477-1 1-1s1 .4477 1 1v2.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2"
    />
    <path
      fill="currentColor"
      d="M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-7.2929 7.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 4H15c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const Download04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.6212 1.906c.7623-.3311 1.1435-.4967 1.7455-.3844.4393.0819 1.0403.476 1.2905.8464C11 2.8754 11 3.4323 11 4.5462v9.0396l-2.2929-2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0l4-4c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L13 13.5858l.0001-8.9304c.001-1.261.0018-2.2566-.7341-3.2974-.0877-.124-.1918-.2438-.3062-.358H12c6.0751 0 11 4.9249 11 11s-4.9249 11-11 11S1 18.0751 1 12C1 7.4811 3.7249 3.5986 7.6212 1.906"
    />
  </svg>
);

export const DownloadCloud01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 14c0-2.7989-1.9164-5.1501-4.5086-5.8132C18.3528 5.1564 15.4283 3 12 3 8.9646 3 6.324 4.6906 4.9684 7.1815 2.1176 7.87 0 10.4377 0 13.5 0 17.0899 2.9101 20 6.5 20H18c3.3137 0 6-2.6863 6-6M12 7c.5523 0 1 .4477 1 1v5.5858l2.2929-2.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L11 13.5858V8c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const DownloadCloud02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 12c0 4.9706 4.0294 9 9 9h7.5c4.1421 0 7.5-3.3579 7.5-7.5S20.6421 6 16.5 6a7.6 7.6 0 0 0-.758.0378C14.0931 4.1746 11.6837 3 9 3c-4.9706 0-9 4.0294-9 9m12-4c.5523 0 1 .4477 1 1v5.5858l2.2929-2.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L11 14.5858V9c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Edit01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2929 2.2929c1.4951-1.4951 3.9191-1.4951 5.4142 0s1.4951 3.9191 0 5.4142L8.5008 20.9134l-.0498.0499c-.245.2453-.461.4616-.7176.6309a3 3 0 0 1-.7276.3497c-.2925.0947-.5964.1282-.9409.1662l-.0701.0077-3.3844.3761a1.0002 1.0002 0 0 1-1.1043-1.1043l.376-3.3844.0078-.0701c.038-.3445.0715-.6484.1662-.9409a3 3 0 0 1 .3497-.7276c.1692-.2567.3856-.4727.6309-.7176l.0499-.0498z"
      clipRule="evenodd"
    />
  </svg>
);

export const Edit02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.7071 2.2929c-1.4951-1.4951-3.9191-1.4951-5.4142 0l-1.1615 1.1615c-.396.396-.5941.594-.6682.8224a1 1 0 0 0 0 .618c.0741.2283.2722.4263.6682.8224l3.1514 3.1514c.3961.396.5941.594.8224.6682a1 1 0 0 0 .618 0c.2284-.0741.4264-.2722.8224-.6682l1.1615-1.1615c1.4951-1.495 1.4951-3.9191 0-5.4142M16.8686 12.5456c.396-.396.5941-.594.6682-.8224a1 1 0 0 0 0-.618c-.0741-.2283-.2722-.4263-.6682-.8224l-3.1514-3.1514c-.3961-.396-.5941-.594-.8224-.6683a1 1 0 0 0-.618 0c-.2284.0742-.4264.2722-.8224.6683L3.0367 15.549c-.2453.2449-.4617.4609-.631.7176a3 3 0 0 0-.3496.7276c-.0947.2925-.1282.5964-.1662.9409l-.3838 3.4545a1 1 0 0 0 1.1043 1.1043l3.4545-.3838c.3445-.038.6484-.0715.941-.1662a3 3 0 0 0 .7275-.3497c.2567-.1693.4727-.3856.7176-.6309z"
    />
  </svg>
);

export const Edit03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 20c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1s-.4477 1-1 1h-9c-.5523 0-1-.4477-1-1M15.793 2.7929c1.2189-1.219 3.1952-1.219 4.4142 0 1.2189 1.219 1.2189 3.1952 0 4.4142L7.6444 19.7698l-.0588.059c-.2875.288-.541.5419-.8465.7291a3 3 0 0 1-.8671.3592c-.3485.0836-.7072.0833-1.1141.0829H3c-.5522 0-1-.4477-1-1v-1.7578c-.0004-.4069-.0007-.7657.083-1.1141a3 3 0 0 1 .3591-.8672c.1873-.3055.4412-.559.7292-.8464l.0589-.0589z"
      clipRule="evenodd"
    />
  </svg>
);

export const Edit04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.6747 17.2619c.4077.3726.436 1.0052.0634 1.4128l-1.0001 1.094C20.0284 20.5448 19.0458 21 18.0002 21c-1.0453 0-2.0276-.4548-2.7371-1.2304-.3519-.3833-.8082-.5795-1.2629-.5795-.4548 0-.9113.1963-1.2633.58-.3734.4069-1.006.4342-1.4129.0608s-.4342-1.006-.0608-1.4129c.7103-.7742 1.6923-1.2279 2.737-1.2279s2.0267.4537 2.7371 1.2279l.0011.0012c.3513.3842.8074.5808 1.2618.5808.4543 0 .9104-.1966 1.2616-.5807l1.0001-1.094c.3727-.4076 1.0052-.436 1.4128-.0634M15.793 2.7929c1.2189-1.219 3.1952-1.219 4.4142 0 1.2189 1.219 1.2189 3.1952 0 4.4142L7.6444 19.7698l-.0588.059c-.2875.288-.541.5419-.8465.7291a3 3 0 0 1-.8671.3592c-.3485.0836-.7072.0833-1.1141.0829H3c-.5522 0-1-.4477-1-1v-1.7578c-.0004-.4069-.0007-.7657.083-1.1141a3 3 0 0 1 .3591-.8672c.1873-.3055.4412-.559.7292-.8464l.0589-.0589z"
      clipRule="evenodd"
    />
  </svg>
);

export const Edit05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 3H11c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.8c-.8566 0-1.4389.0008-1.889.0375-.4384.0359-.6626.1008-.819.1805a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C3.0008 7.3611 3 7.9434 3 8.8v8.4c0 .8566.0008 1.4389.0375 1.8889.0359.4385.1008.6627.1805.8191.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C5.3611 20.9992 5.9434 21 6.8 21h8.4c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.8191.0368-.45.0376-1.0323.0376-1.8889V13c0-.5523.4477-1 1-1s1 .4477 1 1v4.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5641a4 4 0 0 1-1.748 1.7481c-.4854.2473-1.0021.3459-1.5642.3918C16.7106 23 16.0463 23 15.2413 23H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.7481c-.2473-.4853-.3459-1.002-.3918-1.5641C1 18.7106 1 18.0463 1 17.2413V8.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 3 5.9537 3 6.7587 3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.7929 1.7929c1.2189-1.219 3.1953-1.219 4.4142 0s1.219 3.1952 0 4.4142l-9.5627 9.5627-.0589.059c-.2875.288-.5409.5419-.8464.7291a3 3 0 0 1-.8672.3592c-.3484.0836-.7072.0833-1.114.0829H8c-.5523 0-1-.4477-1-1v-1.7578c-.0005-.4069-.0008-.7657.0829-1.1141a3 3 0 0 1 .3592-.8672c.1872-.3055.4411-.559.729-.8464l.059-.0589z"
      clipRule="evenodd"
    />
  </svg>
);

export const Equal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 9c0-.5523.4477-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1M4 15c0-.5523.4477-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const EqualNot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7071 5.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L14.5858 8H5c-.5523 0-1 .4477-1 1s.4477 1 1 1h7.5858l-4 4H5c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5858l-2.293 2.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0L9.4142 16H19c.5523 0 1-.4477 1-1s-.4477-1-1-1h-7.5858l4-4H19c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1.5858z"
    />
  </svg>
);

export const Eye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 12c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4C9.1383 4 6.8054 5.2647 5.0768 6.7074 3.3504 8.1482 2.167 9.8143 1.5741 10.7528l-.024.038c-.1177.1852-.2704.4256-.3476.7624-.0623.2719-.0623.6217 0 .8936.0772.3368.23.5772.3475.7624l.0241.038c.5928.9385 1.7763 2.6046 3.5025 4.0454C6.8055 18.7353 9.1383 20 12 20s5.1947-1.2647 6.9233-2.7074c1.7262-1.4408 2.9097-3.1069 3.5025-4.0454l.0241-.038c.1176-.1852.2703-.4255.3475-.7624.0623-.2719.0623-.6217 0-.8936-.0772-.3369-.2299-.5772-.3475-.7624l-.0241-.038c-.5928-.9385-1.7763-2.6046-3.5025-4.0454C17.1947 5.2647 14.8617 4 12 4m0 4c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4 4-1.7909 4-4-1.7909-4-4-4"
      clipRule="evenodd"
    />
  </svg>
);

export const EyeOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.2929 2.2929c.3905-.3905 1.0237-.3905 1.4142 0l18 18c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-3.1537-3.1537C15.6943 19.3988 13.9716 20 12 20c-2.8617 0-5.1947-1.2647-6.9233-2.7074-1.7262-1.4408-2.9097-3.1069-3.5025-4.0454l-.024-.038c-.1177-.1852-.2705-.4256-.3476-.7624-.0624-.272-.0623-.6218 0-.8938.0773-.3369.2304-.5779.3484-.7635l.0242-.0383c.6024-.9535 1.8257-2.676 3.6202-4.1416L2.2929 3.707c-.3905-.3905-.3905-1.0237 0-1.4142m6.261 7.6752A3.985 3.985 0 0 0 8 12c0 2.2092 1.7909 4 4 4a3.986 3.986 0 0 0 2.0318-.5539l-1.5136-1.5136a2 2 0 0 1-.5182.0675c-1.1046 0-2-.8954-2-2 0-.1795.0235-.3531.0675-.5181z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M15.9923 11.7496c-.1241-2.0097-1.7322-3.6178-3.7419-3.7419L8.7916 4.549C9.7712 4.207 10.8424 4 12 4c2.8617 0 5.1947 1.2647 6.9233 2.7074 1.7262 1.4408 2.9097 3.1069 3.5025 4.0454l.0241.038c.1176.1852.2703.4255.3475.7624.0623.2719.0623.6217 0 .8936-.0772.3369-.2299.5772-.3475.7624l-.0241.038c-.4235.6705-1.1486 1.7125-2.1577 2.7783z"
    />
  </svg>
);

export const FilterFunnel01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.568 2H20.432c.2524 0 .4982 0 .7063.017.2286.0186.4983.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.201.7698.017.2081.017.454.017.7063v.7013l.0001.0562c.0006.2083.0014.4706-.0658.7262a2 2 0 0 1-.2833.6204c-.1491.2181-.3478.3893-.5056.5253l-.0426.0367-6.3958 5.543c-.1087.0942-.1631.1417-.201.178l-.0029.0028-.0002.0041c-.0026.0524-.0029.1246-.0029.2685v5.2278l.0003.038c.0014.1375.0045.4229-.0949.6894a1.5 1.5 0 0 1-.3967.5858c-.2104.1913-.4766.2945-.6048.3442l-.0354.0138-3.4279 1.3712c-.1589.0636-.3346.1339-.4895.1802-.1667.0497-.4405.1147-.7563.0491a1.5 1.5 0 0 1-.945-.6398c-.1783-.2689-.2196-.5473-.2353-.7205-.0146-.161-.0146-.3502-.0145-.5214v-6.6178c0-.1439-.0003-.2161-.0029-.2685l-.0002-.0041-.003-.0028c-.0378-.0363-.0922-.0838-.201-.178l-6.3957-5.543-.0426-.0367c-.1578-.136-.3565-.3072-.5056-.5253a2 2 0 0 1-.2833-.6204c-.0672-.2556-.0664-.5179-.0658-.7262v-.7575c0-.2524 0-.4982.017-.7063.0187-.2286.0628-.4984.201-.7698a2 2 0 0 1 .8741-.874c.2714-.1383.5412-.1824.7698-.201C3.0699 2 3.3158 2 3.568 2"
      clipRule="evenodd"
    />
  </svg>
);

export const FilterFunnel02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5334 2h14.9332c.5284 0 .9917 0 1.3551.0326.3488.0314.8273.105 1.2151.4252a2 2 0 0 1 .725 1.6216c-.0199.5024-.2842.9082-.4933 1.189-.218.2926-.5269.6378-.8793 1.0316l-5.7364 6.4112c-.0807.0903-.1207.1353-.1485.1692l-.0021.0025-.0001.0033c-.0019.0437-.0021.1039-.0021.2251v5.3471l.0003.038c.0014.1375.0045.4229-.0949.6894a1.5 1.5 0 0 1-.3966.5858c-.2105.1913-.4767.2945-.6049.3442l-.0354.0138-3.4279 1.3712c-.1589.0636-.3345.1339-.4895.1802-.1667.0497-.4405.1147-.7563.0491a1.5 1.5 0 0 1-.945-.6398c-.1783-.2689-.2196-.5473-.2353-.7205-.0146-.161-.0146-.3502-.0145-.5214v-6.7371c0-.1212-.0002-.1814-.002-.2251l-.0002-.0033-.002-.0025c-.0279-.0339-.0679-.0789-.1487-.1692L2.641 6.3337l-.03-.0337c-.3525-.3938-.6614-.739-.8794-1.0316-.2092-.2808-.4734-.6866-.4933-1.189a2 2 0 0 1 .725-1.6216c.3878-.3202.8663-.3938 1.215-.4252C3.5418 2 4.005 2 4.5335 2"
      clipRule="evenodd"
    />
  </svg>
);

export const FilterLines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 12c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H6c-.5523 0-1-.4477-1-1M2 6c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M8 18c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const GoogleChrome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.3758 10.0948 4.626 5.4829c-.2202-.3693-.3303-.5539-.355-.7663-.0202-.1725.016-.3902.0907-.547.0922-.193.2356-.3147.5224-.5582C6.8023 1.9826 9.2864 1 12 1c3.8074 0 7.1629 1.9343 9.1376 4.8739.218.3246.327.4868.3174.6547-.0079.1379-.087.2864-.1971.3698C21.124 7 20.9137 7 20.4932 7H12c-2.0868 0-3.875 1.2784-4.6242 3.0948M1 12c0-1.6886.3805-3.2884 1.0604-4.7182.1676-.3524.2514-.5286.4004-.606.1225-.0635.2904-.0714.4182-.0196.1557.0631.2632.2434.4782.604l4.2381 7.108C8.4395 15.9351 10.0954 17 12 17a5.1 5.1 0 0 0 .6064-.0364l-2.675 4.6614c-.2137.3725-.3206.5588-.4936.6845-.1404.102-.3484.1773-.5216.1888-.2134.0142-.3894-.0511-.7413-.1816C3.9855 20.7628 1 16.7301 1 12M11.7268 22.5147c-.1239.2159.0243.4853.2732.4853 6.0751 0 11-4.9249 11-11 0-.6198-.0513-1.2277-.1498-1.8196-.0617-.3705-.0925-.5558-.211-.734-.0962-.1446-.265-.2877-.4234-.3588C22.0205 9 21.8056 9 21.3757 9h-5.3753A4.978 4.978 0 0 1 17 12c0 .9795-.2817 1.8933-.7685 2.6647z"
    />
    <path
      fill="currentColor"
      d="M15 12c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
    />
  </svg>
);

export const Hash01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 2c.5523 0 1 .4477 1 1v4h6V3c0-.5523.4477-1 1-1s1 .4477 1 1v4h3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3v6h3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4H9v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4H4c-.5523 0-1-.4477-1-1s.4477-1 1-1h3V9H4c-.5523 0-1-.4477-1-1s.4477-1 1-1h3V3c0-.5523.4477-1 1-1m7 13V9H9v6z"
      clipRule="evenodd"
    />
  </svg>
);

export const Hash02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.4864 3.1644c.0908-.5447-.2773-1.06-.822-1.1508s-1.06.2773-1.1508.822L7.8196 7H3.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h3.9862l-1 6H2.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h3.6529l-.6393 3.8356c-.0908.5448.2772 1.06.822 1.1508s1.06-.2772 1.1508-.822L8.1804 17h5.9725l-.6393 3.8356c-.0908.5448.2772 1.06.822 1.1508s1.06-.2772 1.1508-.822L16.1804 17H19.5c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2.9862l1-6H20.5c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2.6529l.6393-3.8356c.0908-.5447-.2773-1.06-.822-1.1508s-1.06.2773-1.1508.822L15.8195 7H9.8471zM14.4862 15l1-6H9.5138l-1 6z"
      clipRule="evenodd"
    />
  </svg>
);

export const Heart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.9928 3.717c-2.34-2.0449-5.8004-2.4633-8.4877-.1672C.5983 6.0334.176 10.2162 2.4746 13.174c.8725 1.1227 2.5755 2.8095 4.2121 4.3543 1.6558 1.5628 3.3078 3.0396 4.1224 3.7611l.0156.0138c.0765.0679.1719.1524.2633.2212.1094.0824.2665.1847.4763.2473.2789.0832.5787.0832.8577 0 .2098-.0626.3669-.1649.4763-.2473.0914-.0688.1867-.1533.2633-.2212l.0156-.0138c.8146-.7215 2.4666-2.1983 4.1224-3.7611 1.6366-1.5448 3.3396-3.2316 4.2121-4.3543 2.2898-2.9465 1.9327-7.1616-1.0409-9.633-2.7172-2.2585-6.1408-1.8697-8.478.176"
      clipRule="evenodd"
    />
  </svg>
);

export const HeartCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M8.0773 8.655c1.2526-1.0702 2.9196-.7558 3.9193.413.9997-1.1688 2.6451-1.472 3.9192-.413s1.4289 2.8595.4453 4.1252c-.6301.8107-2.2435 2.314-3.3222 3.2902-.3584.3243-.5377.4865-.7523.5516a1.024 1.024 0 0 1-.58 0c-.2147-.0651-.3939-.2273-.7524-.5516-1.0786-.9762-2.692-2.4795-3.3221-3.2902-.9836-1.2657-.8073-3.055.4452-4.1252"
      clipRule="evenodd"
    />
  </svg>
);

export const HeartHand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5354 2.306c-.9576-1.111-2.5246-1.6332-4.0857-.8881-1.815.8661-2.6088 2.9461-1.8388 4.7732.3873.9191 1.4352 2.5955 2.1262 3.669l.0161.025c.1167.1814.2343.3643.349.5139.13.1696.2956.3508.5304.4969a2.024 2.024 0 0 0 1.1228.3008c.2764-.0091.5103-.0832.7077-.1651.1741-.0722.3675-.1718.5591-.2705l.0265-.0136c1.1352-.5843 2.8809-1.512 3.6759-2.1144 1.5689-1.1886 1.9668-3.3953.7864-5.0643-.9935-1.4049-2.5931-1.7462-3.9756-1.2628"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M17.7088 15.8932c0 .7913-.5234 1.4606-1.2449 1.6843l.4639-.0215c.507 0 1-.1595 1.4051-.4556l2.8289-2.0639c.706-.5148 1.6942-.4465 2.3183.1606.6932.6743.6932 1.7666 0 2.4397l-2.4272 2.3612c-.6534.6355-1.4871 1.0695-2.3933 1.246l-3.4307.6675a4.81 4.81 0 0 1-2.0549-.0479l-3.1029-.754a4.76 4.76 0 0 0-1.1345-.1367c-.4065 0-.6098 0-.7729-.0582a1 1 0 0 1-.6055-.6055C7.5 20.1461 7.5 19.9428 7.5 19.5364v-3.4292c0-.2858 0-.4287.0367-.5604a1 1 0 0 1 .1577-.324c.081-.1102.1934-.1984.4184-.3747l1.1856-.9295s1.9647-.9187 3.0501-.9187c.4496 0 .8969.0547 1.3336.163l2.6837.6672c.7892.1956 1.343.9012 1.343 1.7103z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.4735 12.9999h.053c.21 0 .4146 0 .5887.0119.1904.0129.4161.0434.6502.1404.49.203.8794.5923 1.0823 1.0824.097.234.1275.4597.1404.6501.012.1741.0119.3787.0119.5887v5.053c0 .21 0 .4146-.0119.5887-.013.1904-.0434.4161-.1404.6501a2 2 0 0 1-1.0823 1.0824c-.2341.097-.4598.1274-.6502.1404-.174.0119-.3787.0119-.5887.0119h-.053c-.21 0-.4147 0-.5887-.0119-.1904-.013-.4161-.0434-.6502-.1404a2 2 0 0 1-1.0824-1.0824c-.0969-.234-.1274-.4597-.1404-.6501C1 20.941 1 20.7364 1 20.5264v-5.053c0-.21 0-.4146.0118-.5887.013-.1904.0435-.4161.1404-.6501a2 2 0 0 1 1.0824-1.0824c.234-.097.4598-.1275.6502-.1404.174-.0119.3787-.0119.5887-.0119"
      clipRule="evenodd"
    />
  </svg>
);

export const HeartHexagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.4029 1.185a2 2 0 0 0-.8058 0c-.3073.0631-.5819.217-.8003.3392l-.0595.0333-7.4 4.1111-.0631.0349c-.2311.1273-.5218.2874-.745.5295a2 2 0 0 0-.4282.728c-.1034.3126-.1021.6444-.1012.9083L2 7.9414v8.1171l-.0002.0721c-.001.2639-.0022.5957.1012.9084.0893.2704.2353.5185.4283.7279.2231.2422.5137.4022.7449.5295l.0631.0349 7.4 4.1111.0595.0333c.2184.1223.493.2761.8003.3393.2658.0547.54.0547.8058 0 .3073-.0632.5819-.217.8003-.3393l.0595-.0333 7.4-4.1111.0631-.0348c.2311-.1274.5218-.2874.7449-.5296.193-.2094.339-.4575.4283-.7279.1033-.3127.1021-.6445.1012-.9084L22 16.0585v-8.117l.0002-.0722c.0009-.2639.0021-.5957-.1012-.9084a2 2 0 0 0-.4283-.7279c-.2231-.2421-.5138-.4022-.7449-.5295l-.0631-.0349-7.4-4.1111-.0595-.0333c-.2184-.1222-.493-.276-.8003-.3393m-4.3256 7.47c1.2526-1.0702 2.9196-.7558 3.9193.413.9997-1.1688 2.6451-1.472 3.9192-.413s1.4289 2.8595.4453 4.1252c-.6301.8107-2.2435 2.314-3.3222 3.2902-.3584.3243-.5377.4865-.7523.5516a1.024 1.024 0 0 1-.58 0c-.2147-.0651-.3939-.2273-.7524-.5516-1.0786-.9762-2.692-2.4795-3.3221-3.2902-.9836-1.2657-.8073-3.055.4452-4.1252"
      clipRule="evenodd"
    />
  </svg>
);

export const HeartOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8.5228 1-.051-.0001c-.19-.0006-.4291-.0012-.6645.0553a2 2 0 0 0-.578.2395c-.2064.1264-.375.296-.509.4306l-.036.0362-4.9228 4.9227-.0361.036c-.1347.134-.3042.3026-.4307.509a2 2 0 0 0-.2394.578c-.0565.2354-.0559.4745-.0554.6645L1 8.5227v7.0055c-.0006.19-.0012.4291.0553.6644a2 2 0 0 0 .2394.5781c.1265.2064.296.375.4307.509l.0361.036 4.9228 4.9227.036.0362c.134.1346.3026.3042.509.4306.1789.1097.374.1905.578.2395.2354.0565.4745.0558.6644.0553l.051-.0001h6.9546l.051.0001c.1899.0005.4291.0012.6644-.0553a2 2 0 0 0 .5781-.2395c.2063-.1264.375-.296.5089-.4306l.036-.0362 4.9228-4.9227.0361-.036c.1347-.134.3042-.3026.4307-.509a2 2 0 0 0 .2394-.5781c.0565-.2353.0559-.4745.0554-.6644L23 15.4772V8.5227l.0001-.051c.0005-.19.0011-.4291-.0554-.6644a2 2 0 0 0-.2394-.5781c-.1265-.2064-.296-.375-.4306-.509l-.0362-.036-4.9228-4.9227-.036-.0362c-.1339-.1346-.3026-.3042-.5089-.4306a2 2 0 0 0-.5781-.2395C15.9574.9987 15.7182.9993 15.5283 1H8.5228m-.4455 7.655c1.2526-1.0702 2.9196-.7558 3.9193.413.9997-1.1688 2.6451-1.472 3.9192-.413s1.4289 2.8595.4453 4.1252c-.6301.8107-2.2435 2.314-3.3222 3.2902-.3584.3243-.5377.4865-.7523.5516a1.024 1.024 0 0 1-.58 0c-.2147-.0651-.3939-.2273-.7524-.5516-1.0786-.9762-2.692-2.4795-3.3221-3.2902-.9836-1.2657-.8073-3.055.4452-4.1252"
      clipRule="evenodd"
    />
  </svg>
);

export const HeartRounded = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 9.48C1 5.9711 3.6577 2 7.8889 2 9.7159 2 11.066 2.7105 12 3.5108 12.9339 2.7105 14.2841 2 16.1111 2 20.3423 2 23 5.9711 23 9.48c0 1.8454-.7146 3.5497-1.707 5.0291-.9932 1.4806-2.3006 2.7908-3.5819 3.8707-1.285 1.0831-2.5714 1.9574-3.5475 2.5613-.4887.3024-.904.5396-1.2078.7036a10 10 0 0 1-.3787.1957 3 3 0 0 1-.1452.0664 1.4 1.4 0 0 1-.0951.0363 1.1 1.1 0 0 1-.0912.0268A1.03 1.03 0 0 1 12 22c-.1237 0-.2195-.0237-.2449-.0299a1.2 1.2 0 0 1-.0919-.027 1.4 1.4 0 0 1-.0951-.0363 3 3 0 0 1-.1452-.0664 10 10 0 0 1-.3787-.1957c-.3038-.164-.7191-.4012-1.2078-.7036-.9761-.6039-2.2624-1.4782-3.5475-2.5613-1.2813-1.0799-2.5887-2.3901-3.5819-3.8707C1.7146 13.0297 1 11.3254 1 9.48"
      clipRule="evenodd"
    />
  </svg>
);

export const HeartSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M8.0774 8.655c1.2525-1.0702 2.9195-.7558 3.9192.413.9997-1.1688 2.6451-1.472 3.9192-.413s1.4289 2.8595.4453 4.1252c-.6301.8107-2.2435 2.314-3.3222 3.2902-.3584.3243-.5377.4865-.7523.5516a1.024 1.024 0 0 1-.58 0c-.2147-.0651-.3939-.2273-.7524-.5516-1.0786-.9762-2.692-2.4795-3.3221-3.2902-.9836-1.2657-.8073-3.055.4452-4.1252"
      clipRule="evenodd"
    />
  </svg>
);

export const Hearts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.992 10.5455c-.8446-2.199-2.991-3.7496-5.6588-3.2546-2.9492.5473-4.8827 3.2278-4.4805 6.1447.144 1.0437.597 2.7154 1.0616 4.2792.4719 1.5878.9805 3.1446 1.2632 3.9948l.0066.0197c.0323.0975.0726.2187.1173.3243.0535.1263.1384.294.289.4536.2001.2119.4606.3622.7441.4296.2135.0507.4012.0403.5374.0235.1138-.0141.2389-.0398.3394-.0605l.0204-.0042c.8777-.1802 2.4802-.5182 4.0912-.9035 1.5867-.3794 3.2609-.823 4.2367-1.2202 2.7139-1.1046 4.1291-4.1152 3.0766-6.9653-.9382-2.5405-3.3194-3.6306-5.6442-3.2611"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.5953 1.4928c-2.4597-1.133-4.9144-.22-6.297 1.6851-2.1521-.9577-4.7662-.5364-6.3027 1.7C.2971 7.3504.8254 10.613 3.1724 12.3912c.4196.3179 1.0068.6935 1.6709 1.088-.4188-3.8968 2.2134-7.4288 6.125-8.1546 2.8048-.5204 5.1639.5834 6.662 2.403.5966-2.4736-.5665-5.0976-3.035-6.2347"
    />
  </svg>
);

export const HelpCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m-1.0934 7.2712A2 2 0 0 1 13.92 9.9985V10c0 .4691-.3651.9582-1.0547 1.4179-.3144.2096-.6359.371-.8827.4807a6 6 0 0 1-.2897.12 4 4 0 0 1-.0902.033c-.5233.1751-.8059.741-.6314 1.2646.1747.5239.741.8071 1.2649.6324l.1687-.061a8 8 0 0 0 .39-.1613c.3156-.1403.7442-.3539 1.1798-.6443.8102-.5401 1.9448-1.5508 1.9453-3.0811a4 4 0 0 0-7.7733-1.3328c-.1833.521.0905 1.092.6115 1.2752.521.1833 1.0919-.0905 1.2751-.6115a2 2 0 0 1 .8733-1.0606M12 16c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4478 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const HelpHexagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.4029 1.185a2 2 0 0 0-.8058 0c-.3073.0631-.5819.217-.8003.3392l-.0595.0333-7.4 4.1111-.0631.0349c-.2311.1273-.5218.2874-.745.5295a2 2 0 0 0-.4282.728c-.1034.3126-.1021.6444-.1012.9083L2 7.9414v8.1171l-.0002.0721c-.001.2639-.0022.5957.1012.9084.0893.2704.2353.5185.4283.7279.2231.2422.5137.4022.7449.5295l.0631.0349 7.4 4.1111.0595.0333c.2184.1223.493.2761.8003.3393.2658.0547.54.0547.8058 0 .3073-.0632.5819-.217.8003-.3393l.0595-.0333 7.4-4.1111.0631-.0348c.2311-.1274.5218-.2874.7449-.5296.193-.2094.339-.4575.4283-.7279.1033-.3127.1021-.6445.1012-.9084L22 16.0585v-8.117l.0002-.0722c.0009-.2639.0021-.5957-.1012-.9084a2 2 0 0 0-.4283-.7279c-.2231-.2421-.5138-.4022-.7449-.5295l-.0631-.0349-7.4-4.1111-.0595-.0333c-.2184-.1222-.493-.276-.8003-.3393m-1.4963 7.0862A2 2 0 0 1 13.92 9.9985V10c0 .4691-.3651.9582-1.0547 1.4179-.3144.2096-.6359.371-.8827.4807a6 6 0 0 1-.2897.12 4 4 0 0 1-.0902.033c-.5233.1751-.8059.741-.6314 1.2646.1747.5239.741.8071 1.2649.6324l.1687-.061a8 8 0 0 0 .39-.1613c.3156-.1403.7442-.3539 1.1798-.6443.8102-.5401 1.9448-1.5508 1.9453-3.0811a4 4 0 0 0-7.7733-1.3328c-.1833.521.0905 1.092.6115 1.2752.521.1833 1.0919-.0905 1.2751-.6115a2 2 0 0 1 .8733-1.0606M12 16c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4478 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const HelpOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8.5228 1-.051-.0001c-.19-.0006-.4291-.0012-.6645.0553a2 2 0 0 0-.578.2395c-.2064.1264-.375.296-.509.4306l-.036.0362-4.9228 4.9227-.0361.036c-.1347.134-.3042.3026-.4307.509a2 2 0 0 0-.2394.578c-.0565.2354-.0559.4745-.0554.6645L1 8.5227v7.0055c-.0006.19-.0012.4291.0553.6644a2 2 0 0 0 .2394.5781c.1265.2064.296.375.4307.509l.0361.036 4.9228 4.9227.036.0362c.134.1346.3026.3042.509.4306.1789.1097.374.1905.578.2395.2354.0565.4745.0558.6644.0553l.051-.0001h6.9546l.051.0001c.1899.0005.4291.0012.6644-.0553a2 2 0 0 0 .5781-.2395c.2063-.1264.375-.296.5089-.4306l.036-.0362 4.9228-4.9227.0361-.036c.1347-.134.3042-.3026.4307-.509a2 2 0 0 0 .2394-.5781c.0565-.2353.0559-.4745.0554-.6644L23 15.4772V8.5227l.0001-.051c.0005-.19.0011-.4291-.0554-.6644a2 2 0 0 0-.2394-.5781c-.1265-.2064-.296-.375-.4306-.509l-.0362-.036-4.9228-4.9227-.036-.0362c-.1339-.1346-.3026-.3042-.5089-.4306a2 2 0 0 0-.5781-.2395C15.9574.9987 15.7182.9993 15.5283 1H8.5228m2.3838 7.2712A2 2 0 0 1 13.92 9.9985V10c0 .4691-.3651.9582-1.0547 1.4179-.3144.2096-.6359.371-.8827.4807a6 6 0 0 1-.2897.12 4 4 0 0 1-.0902.033c-.5233.1751-.8059.741-.6314 1.2646.1747.5239.741.8071 1.2649.6324l.1687-.061a8 8 0 0 0 .39-.1613c.3156-.1403.7442-.3539 1.1798-.6443.8102-.5401 1.9448-1.5508 1.9453-3.0811a4 4 0 0 0-7.7733-1.3328c-.1833.521.0905 1.092.6115 1.2752.521.1833 1.0919-.0905 1.2751-.6115a2 2 0 0 1 .8733-1.0606M12 16c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4478 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const HelpSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2m-6.9319 6.2712A2 2 0 0 1 13.92 9.9985V10c0 .4691-.3651.9582-1.0547 1.4179-.3144.2096-.6359.371-.8827.4808a6 6 0 0 1-.2897.1199 4 4 0 0 1-.0902.033c-.5233.1751-.8059.741-.6314 1.2646.1747.5239.741.8071 1.2649.6324l.1687-.061a8 8 0 0 0 .39-.1613c.3156-.1403.7442-.3539 1.1798-.6443.8102-.5401 1.9448-1.5508 1.9453-3.0811a4 4 0 0 0-7.7733-1.3328c-.1833.521.0905 1.092.6115 1.2752.521.1833 1.0919-.0905 1.2751-.6115a2 2 0 0 1 .8733-1.0606M12 16c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4478 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Home01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.4773 1.3364a2 2 0 0 1 1.0454 0c.3973.1076.7319.3702.9989.5798l.0746.0585 6.7823 5.275.0777.0604c.3767.2923.7085.5498.9557.8841.217.2934.3787.6239.477.9753.1121.4004.1117.8204.1112 1.2972L22 10.5651v7.2735c0 .5271 0 .9818-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C18.8204 22 18.3657 22 17.8386 22H6.1614c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1.9999 18.8204 2 18.3657 2 17.8385v-7.3718c-.0006-.4768-.001-.8968.111-1.2972a3 3 0 0 1 .477-.9753c.2473-.3343.5791-.5918.9557-.884l.0777-.0604 6.7823-5.2751q.0365-.0284.0747-.0585c.267-.2096.6015-.4722.9989-.5798"
      clipRule="evenodd"
    />
  </svg>
);

export const Home02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5227 1.3364a2 2 0 0 0-1.0454 0c-.3974.1076-.7319.3702-.9989.5798l-.0747.0585-6.86 5.3354c-.3766.2923-.7084.5498-.9557.8841a3 3 0 0 0-.477.9753c-.112.4004-.1116.8204-.111 1.2972v7.3718c0 .5272 0 .9819.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9818 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8204 22 18.3657 22 17.8386l.0001-7.3719c.0005-.4768.0009-.8968-.1112-1.2972a3 3 0 0 0-.477-.9753c-.2472-.3343-.579-.5918-.9557-.884l-6.86-5.3355-.0746-.0585c-.267-.2096-.6016-.4722-.9989-.5798M9 13.6V20h6v-6.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C14.2401 12 13.9601 12 13.4 12h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 12.7599 9 13.0399 9 13.6"
      clipRule="evenodd"
    />
  </svg>
);

export const Home03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.4909 1.3159a2 2 0 0 1 1.0182 0c.3873.102.7158.3506.9779.549l.073.0551.6068.455q.1145.0853.2325.1743l.1207.0907L22.6 8.7c.4418.3314.5314.9582.2 1.4s-.9582.5314-1.4.2L21 10v7.8386c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C17.8205 22 17.3657 22 16.8386 22H7.1614c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C3 18.8205 3 18.3657 3 17.8385V10l-.4.3c-.4418.3314-1.0686.2418-1.4-.2s-.2418-1.0686.2-1.4l8.08-6.06.1207-.0907q.1179-.0889.2325-.1742L10.44 1.92l.073-.0551c.2621-.1984.5906-.447.9779-.549M9 13.6V20h6v-6.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C14.2401 12 13.9601 12 13.4 12h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 12.7599 9 13.0399 9 13.6"
      clipRule="evenodd"
    />
  </svg>
);

export const Home04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5227 1.3364a2 2 0 0 0-1.0454 0c-.3974.1076-.7319.3702-.9989.5798l-.0747.0585-6.86 5.3354c-.3766.2923-.7084.5498-.9557.8841a3 3 0 0 0-.477.9753c-.112.4004-.1116.8204-.111 1.2972v7.3718c0 .5272 0 .9819.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9818 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8204 22 18.3657 22 17.8386l.0001-7.3719c.0005-.4768.0009-.8968-.1112-1.2972a3 3 0 0 0-.477-.9753c-.2472-.3343-.579-.5918-.9557-.884l-6.86-5.3355-.0746-.0585c-.267-.2096-.6016-.4722-.9989-.5798M15 13c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
      clipRule="evenodd"
    />
  </svg>
);

export const Home05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.4773 1.3364a2 2 0 0 1 1.0454 0c.3973.1076.7319.3702.9989.5798 2.3034 1.8084 4.6211 3.5985 6.9346 5.394.3767.2922.7085.5497.9557.884.217.2934.3787.6239.477.9753.1121.4004.1117.8204.1112 1.2972C21.9975 12.924 22 15.3813 22 17.8386c0 .5271 0 .9818-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964-.8015.0655-1.6145.0302-2.4182.0306-.1191 0-.2613.0001-.3866-.0101-.1453-.0119-.3533-.0424-.5712-.1534a1.5 1.5 0 0 1-.6555-.6555c-.1111-.218-.1415-.426-.1534-.5712-.0102-.1253-.0102-.2676-.0101-.3867l.0079-5.5962c.0008-.5608.0011-.8412-.1077-1.0554a1 1 0 0 0-.4371-.4377c-.2141-.1092-.4945-.1092-1.0552-.1092H10.608c-.5593 0-.839 0-1.0528.1088a1 1 0 0 0-.4369.4363c-.1091.2136-.1095.4933-.1103 1.0526L9 20.2231c0 .1191 0 .2614-.0101.3867-.012.1452-.0424.3532-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.111-.426.1415-.5712.1534-.1253.0102-.2675.0101-.3867.0101-.8036-.0004-1.6166.0349-2.4181-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1.9999 18.8204 2 18.3657 2 17.8385c0-2.4573.0026-4.9146 0-7.3718-.0006-.4768-.001-.8968.111-1.2972a3 3 0 0 1 .477-.9753c.2473-.3343.5791-.5918.9557-.884 2.3135-1.7954 4.6314-3.5856 6.9347-5.394.267-.2096.6015-.4722.9989-.5798"
      clipRule="evenodd"
    />
  </svg>
);

export const HomeLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5227 1.3364a2 2 0 0 0-1.0454 0c-.3974.1076-.7319.3702-.9989.5798l-.0747.0585-6.86 5.3354c-.3766.2923-.7084.5498-.9557.8841a3 3 0 0 0-.477.9753c-.112.4004-.1116.8204-.111 1.2972v7.3718c0 .5272 0 .9819.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9818 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8204 22 18.3657 22 17.8386l.0001-7.3719c.0005-.4768.0009-.8968-.1112-1.2972a3 3 0 0 0-.477-.9753c-.2472-.3343-.579-.5918-.9557-.884l-6.86-5.3355-.0746-.0585c-.267-.2096-.6016-.4722-.9989-.5798M8 16c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const HomeSmile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5227 1.3364a2 2 0 0 0-1.0454 0c-.3974.1076-.7319.3702-.9989.5798l-.0747.0585-6.86 5.3354c-.3766.2923-.7084.5498-.9557.8841a3 3 0 0 0-.477.9753c-.112.4004-.1116.8204-.111 1.2972v7.3718c0 .5272 0 .9819.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9818 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8204 22 18.3657 22 17.8386l.0001-7.3719c.0005-.4768.0009-.8968-.1112-1.2972a3 3 0 0 0-.477-.9753c-.2472-.3343-.579-.5918-.9557-.884l-6.86-5.3355-.0746-.0585c-.267-.2096-.6016-.4722-.9989-.5798M9.0944 13.7507c-.1376-.5348-.6828-.8568-1.2176-.7191-.535.1376-.8569.6828-.7192 1.2177C7.7126 16.4056 9.6688 18 12 18s4.2874-1.5944 4.8424-3.7507c.1377-.5349-.1843-1.0801-.7192-1.2177-.5348-.1377-1.08.1843-1.2177.7191C14.5724 15.0449 13.3965 16 12 16s-2.5725-.9551-2.9056-2.2493"
      clipRule="evenodd"
    />
  </svg>
);

export const InfoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m0 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zm1 5c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const InfoHexagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.5971 1.185a2 2 0 0 1 .8058 0c.3073.0632.5819.217.8003.3394l.0595.0332 7.4 4.1111.0631.0349c.2311.1273.5218.2874.7449.5296.193.2093.339.4575.4283.7279.1033.3126.1021.6444.1012.9083L22 7.9415v8.1171l.0002.0722c.0009.2638.0021.5956-.1012.9083a2 2 0 0 1-.4283.7279c-.2231.2422-.5137.4022-.7448.5296l-.0632.0348-7.4 4.1112-.0595.0332c-.2184.1223-.493.2761-.8003.3393a2 2 0 0 1-.8058 0c-.3073-.0632-.5819-.217-.8003-.3393l-.0595-.0332-7.4-4.1112-.0631-.0348c-.2311-.1273-.5218-.2874-.745-.5296a2 2 0 0 1-.4282-.7279c-.1034-.3127-.1021-.6445-.1012-.9083L2 16.0586v-8.117l-.0002-.0722c-.001-.2639-.0022-.5956.1012-.9083a2 2 0 0 1 .4283-.728c.2231-.2421.5138-.4022.7449-.5295l.0631-.0349 7.4-4.111.0595-.0333c.2184-.1223.493-.2762.8003-.3394M12 11c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1m0-4c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const InfoOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8.5228 1-.051-.0001c-.19-.0006-.4291-.0012-.6645.0553a2 2 0 0 0-.578.2395c-.2064.1264-.375.296-.509.4306l-.036.0362-4.9228 4.9227-.0361.036c-.1347.134-.3042.3026-.4307.509a2 2 0 0 0-.2394.578c-.0565.2354-.0559.4745-.0554.6645L1 8.5227v7.0055c-.0006.19-.0012.4291.0553.6644a2 2 0 0 0 .2394.5781c.1265.2064.296.375.4307.509l.0361.036 4.9228 4.9227.036.0362c.134.1346.3026.3042.509.4306.1789.1097.374.1905.578.2395.2354.0565.4745.0558.6644.0553l.051-.0001h6.9546l.051.0001c.1899.0005.4291.0012.6644-.0553a2 2 0 0 0 .5781-.2395c.2063-.1264.375-.296.5089-.4306l.036-.0362 4.9228-4.9227.0361-.036c.1347-.134.3042-.3026.4307-.509a2 2 0 0 0 .2394-.5781c.0565-.2353.0559-.4745.0554-.6644L23 15.4772V8.5227l.0001-.051c.0005-.19.0011-.4291-.0554-.6644a2 2 0 0 0-.2394-.5781c-.1265-.2064-.296-.375-.4306-.509l-.0362-.036-4.9228-4.9227-.036-.0362c-.1339-.1346-.3026-.3042-.5089-.4306a2 2 0 0 0-.5781-.2395C15.9574.9987 15.7182.9993 15.5283 1H8.5228M12 7c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zm1 5c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const InfoSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M12 7c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zm1 5c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const LifeBuoy01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.1996 4.7854c-.419-.4189-.6284-.6283-.6947-.9003-.053-.2172-.0165-.5092.0885-.7066.1314-.2472.353-.3789.7962-.6422C8.0323 1.5604 9.9506 1 12 1s3.9678.5604 5.6105 1.5364c.4432.2633.6648.395.7962.6422.105.1974.1416.4893.0886.7065-.0664.272-.2759.4815-.6948.9004l-2.8911 2.8911c-.2897.2898-.4346.4346-.5694.5054-.1566.0822-.208.097-.3844.1112-.1517.0122-.4584-.057-1.0719-.1953A4 4 0 0 0 12 8a4 4 0 0 0-.8836.098c-.6134.1382-.9202.2074-1.0719.1952-.1764-.0142-.2277-.0291-.3844-.1113-.1348-.0707-.2796-.2156-.5693-.5053zM4.7854 6.1997c-.419-.419-.6284-.6284-.9004-.6948-.2172-.053-.5091-.0164-.7065.0885-.2473.1315-.379.3531-.6422.7963C1.5603 8.0323 1 9.9507 1 12c0 2.0494.5604 3.9678 1.5364 5.6105.2633.4432.395.6648.6422.7962.1974.105.4893.1416.7065.0886.272-.0664.4815-.2759.9004-.6948l2.8911-2.8911c.2898-.2897.4346-.4346.5054-.5694.0822-.1566.097-.208.1112-.3844.0122-.1517-.057-.4584-.1953-1.0719A4 4 0 0 1 8 12c0-.3036.0338-.5993.098-.8835.1382-.6135.2074-.9202.1951-1.072-.0142-.1763-.029-.2277-.1112-.3843-.0708-.1348-.2156-.2797-.5053-.5694zM11.1166 15.9021c-.6135-.1383-.9202-.2074-1.0719-.1952-.1764.0142-.2277.0291-.3844.1113-.1348.0707-.2796.2156-.5693.5053l-2.8912 2.8912c-.419.4189-.6284.6284-.6948.9004-.053.2172-.0164.5091.0886.7065.1314.2473.353.3789.7962.6422C8.0324 22.4396 9.9508 23 12 23c2.0493 0 3.9677-.5604 5.6103-1.5363.4432-.2633.6648-.3949.7962-.6422.105-.1974.1416-.4893.0886-.7065-.0664-.272-.2759-.4815-.6948-.9004l-2.8911-2.8912c-.2897-.2897-.4346-.4345-.5694-.5053-.1566-.0822-.208-.097-.3843-.1112-.1518-.0123-.4585.0569-1.072.1952A4 4 0 0 1 12 16a4 4 0 0 1-.8834-.0979M15.9021 12.8836c-.1383.6134-.2075.9202-.1953 1.0719.0142.1764.0291.2277.1113.3844.0707.1348.2156.2796.5053.5694l2.8912 2.8911c.4189.4189.6283.6284.9004.6947.2171.0531.5091.0165.7065-.0885.2472-.1314.3789-.353.6422-.7962C22.4396 15.9677 23 14.0493 23 12c0-2.0492-.5603-3.9676-1.5362-5.6102-.2633-.4432-.3949-.6648-.6422-.7962-.1974-.105-.4893-.1416-.7065-.0886-.272.0664-.4815.2759-.9004.6948L16.3235 9.091c-.2897.2897-.4346.4345-.5053.5693-.0822.1567-.0971.208-.1113.3844-.0122.1517.0569.4584.1952 1.0719A4 4 0 0 1 16 12c0 .3036-.0338.5993-.0979.8836"
    />
  </svg>
);

export const LifeBuoy02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1c-2.0493 0-3.9677.5604-5.6104 1.5363-.4432.2633-.6648.395-.7962.6422-.105.1974-.1415.4894-.0885.7066.0663.272.2758.4814.6947.9003l2.1183 2.1184c.3139.3138.4708.4707.6216.5442.1653.0804.244.099.4278.1008.1677.0016.4609-.0963 1.0471-.2922A5 5 0 0 1 12 7c.5542 0 1.0874.0902 1.5857.2567.5862.1959.8794.2938 1.0471.2922.1839-.0019.2625-.0204.4278-.1009.1508-.0734.3078-.2303.6216-.5442l2.1183-2.1183c.4189-.4189.6284-.6283.6948-.9004.053-.2172.0164-.5091-.0886-.7065-.1314-.2472-.353-.3789-.7962-.6422C15.9678 1.5604 14.0494 1 12 1M17.0962 15.6821c-.3138-.3139-.4707-.4708-.5442-.6216-.0804-.1653-.099-.244-.1008-.4278-.0017-.1677.0963-.4609.2922-1.0471A5 5 0 0 0 17 12a5 5 0 0 0-.2566-1.5854c-.1958-.5863-.2938-.8794-.2921-1.047.0018-.184.0204-.2626.1008-.4279.0734-.1508.2304-.3077.5442-.6216l2.1184-2.1183c.4189-.419.6284-.6284.9004-.6948.2172-.053.5091-.0164.7065.0886.2473.1314.3789.353.6422.7962C22.4397 8.0324 23 9.9508 23 12c0 2.0493-.5604 3.9677-1.5363 5.6104-.2633.4432-.395.6648-.6422.7962-.1974.105-.4894.1416-.7065.0885-.2721-.0663-.4815-.2758-.9004-.6947zM8.3181 17.0963c.3139-.3138.4708-.4708.6216-.5442.1653-.0804.244-.099.4278-.1008.1677-.0017.4608.0963 1.0471.2921A5 5 0 0 0 12 17a5 5 0 0 0 1.5855-.2566c.5863-.1959.8794-.2938 1.0471-.2922.1839.0019.2625.0204.4278.1009.1508.0734.3077.2303.6216.5442l2.1183 2.1183c.4189.4189.6284.6284.6948.9004.053.2172.0164.5091-.0886.7065-.1314.2473-.353.3789-.7962.6422C15.9677 22.4396 14.0493 23 12 23s-3.9676-.5603-5.6102-1.5362c-.4432-.2633-.6648-.3949-.7962-.6422-.105-.1974-.1416-.4893-.0886-.7065.0664-.272.2759-.4815.6948-.9004zM6.9037 8.318c.3139.3139.4708.4708.5442.6216.0805.1653.099.244.1009.4278.0016.1677-.0963.4608-.2922 1.0471A5 5 0 0 0 7 12c0 .5542.0902 1.0874.2567 1.5857.1959.5862.2938.8794.2922 1.0471-.0019.1839-.0204.2625-.1009.4278-.0734.1508-.2303.3078-.5442.6216l-2.1183 2.1183c-.4189.4189-.6283.6284-.9004.6948-.2172.053-.5091.0164-.7065-.0886-.2472-.1314-.3789-.353-.6422-.7962C1.5604 15.9678 1 14.0494 1 12s.5604-3.9677 1.5363-5.6103c.2633-.4432.395-.6648.6422-.7963.1973-.1049.4893-.1415.7065-.0885.272.0664.4815.2759.9004.6948z"
    />
  </svg>
);

export const Link01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2071 7.7928c.3905.3906.3905 1.0237 0 1.4143l-7 6.9999c-.3905.3906-1.0237.3906-1.4142 0s-.3905-1.0236 0-1.4142l7-7c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.3431 10.5858c.3906.3905.3906 1.0236 0 1.4142L4.929 13.4142c-1.562 1.5621-1.562 4.0947 0 5.6568s4.0948 1.5621 5.6569 0L12 17.6568c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142L12 20.4852c-2.3431 2.3432-6.1421 2.3432-8.4853 0-2.3431-2.3431-2.3431-6.1421 0-8.4852l1.4142-1.4142c.3906-.3906 1.0237-.3906 1.4142 0M12 3.5147c2.3431-2.3432 6.1421-2.3432 8.4853 0 2.3431 2.3431 2.3431 6.1421 0 8.4853l-1.4142 1.4142c-.3906.3905-1.0237.3905-1.4143 0s-.3905-1.0237 0-1.4142l1.4143-1.4142c1.5621-1.5622 1.5621-4.0948 0-5.6569s-4.0948-1.5621-5.6569 0L12 6.3431c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const Link02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 12c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 8c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-3.3137 0-6-2.6863-6-6s2.6863-6 6-6h2c.5523 0 1 .4477 1 1s-.4477 1-1 1zM14 7c0-.5523.4477-1 1-1h2c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6h-2c-.5523 0-1-.4477-1-1s.4477-1 1-1h2c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4h-2c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Link03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.7753 2.7507a6 6 0 0 1 8.484 8.484l-.0122.0124-2.9999 2.9998a5.9995 5.9995 0 0 1-7.1201 1.0236 6 6 0 0 1-1.9279-1.6716c-.3308-.4422-.2404-1.0689.2018-1.3997s1.0689-.2405 1.3998.2018a4.0005 4.0005 0 0 0 4.601 1.3518 4 4 0 0 0 1.431-.9198l2.9936-2.9937a4.0001 4.0001 0 0 0-5.6568-5.6548L12.455 5.8891c-.3916.3894-1.0248.3876-1.4142-.004-.3894-.3918-.3875-1.025.0041-1.4143l1.72-1.71z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.8991 8.3733a6 6 0 0 1 6.9017 2.0277c.3308.4422.2404 1.0689-.2018 1.3997s-1.069.2405-1.3998-.2018a4 4 0 0 0-4.601-1.3518 4 4 0 0 0-1.431.9198l-2.9936 2.9937a4 4 0 0 0 5.6557 5.6558l1.7036-1.7035c.3905-.3906 1.0237-.3906 1.4142 0s.3905 1.0236 0 1.4142l-1.71 1.71-.0124.0122a6 6 0 0 1-8.484-8.484l.0122-.0124 2.9999-3A6 6 0 0 1 7.899 8.3734"
      clipRule="evenodd"
    />
  </svg>
);

export const Link04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 8c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4h2c2.2091 0 4-1.7909 4-4 0-.5523.4477-1 1-1s1 .4477 1 1c0 3.3137-2.6863 6-6 6H7c-3.3137 0-6-2.6863-6-6s2.6863-6 6-6h.5c.5523 0 1 .4477 1 1s-.4477 1-1 1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 8h-2c-2.2091 0-4 1.7909-4 4 0 .5523-.4477 1-1 1s-1-.4477-1-1c0-3.3137 2.6863-6 6-6h2c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6h-.5c-.5523 0-1-.4477-1-1s.4477-1 1-1h.5c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4"
      clipRule="evenodd"
    />
  </svg>
);

export const Link05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 8c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-3.3137 0-6-2.6863-6-6s2.6863-6 6-6h2c.5523 0 1 .4477 1 1s-.4477 1-1 1z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 12c0-.5523.4477-1 1-1h6V7.7778C14 6.7959 14.7959 6 15.7778 6H17c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6h-1.2222C14.7959 18 14 17.2041 14 16.2222V13H8c-.5523 0-1-.4477-1-1m9 1v3h1c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4h-1v3h2c.5523 0 1 .4477 1 1s-.4477 1-1 1z"
      clipRule="evenodd"
    />
  </svg>
);

export const AlertCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m1 7c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 7c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const AlertHexagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.4029 1.185a2 2 0 0 0-.8058 0c-.3073.0632-.5819.217-.8003.3394l-.0595.0332-7.4 4.1111-.0631.0349c-.2311.1273-.5218.2874-.745.5296a2 2 0 0 0-.4282.7279c-.1034.3126-.1021.6444-.1012.9083L2 7.9415v8.1171l-.0002.0722c-.001.2638-.0022.5956.1012.9083.0893.2704.2353.5185.4283.7279.2231.2422.5137.4022.7449.5296l.0631.0348 7.4 4.1112.0595.0332c.2184.1223.493.2761.8003.3393.2658.0547.54.0547.8058 0 .3073-.0632.5819-.217.8003-.3393l.0595-.0332 7.4-4.1112.0631-.0348c.2311-.1273.5218-.2874.7449-.5296.193-.2094.339-.4575.4283-.7279.1033-.3127.1021-.6445.1012-.9083L22 16.0586v-8.117l.0002-.0722c.0009-.2639.0021-.5956-.1012-.9083a2 2 0 0 0-.4283-.728c-.2231-.2421-.5138-.4022-.7449-.5295l-.0631-.0349-7.4-4.111-.0595-.0333c-.2184-.1223-.493-.2762-.8003-.3394M13 8c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 7c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const AlertOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8.5227 1-.051-.0001c-.19-.0006-.4291-.0012-.6644.0553a2 2 0 0 0-.5781.2395c-.2064.1264-.375.296-.509.4306l-.036.0362-4.9227 4.9227-.0362.036c-.1346.134-.3042.3026-.4306.509a2 2 0 0 0-.2395.578c-.0565.2354-.0559.4745-.0553.6645v7.0565c-.0006.19-.0012.4291.0553.6644a2 2 0 0 0 .2395.5781c.1264.2064.296.375.4306.509l.0362.036 4.9227 4.9227.036.0362c.134.1346.3026.3042.509.4306.179.1097.374.1905.578.2395.2354.0565.4745.0558.6645.0553l.051-.0001h6.9545l.051.0001c.1899.0005.4291.0012.6644-.0553a2 2 0 0 0 .5781-.2395c.2064-.1264.375-.296.509-.4306l.036-.0362 4.9227-4.9227.0362-.036c.1346-.134.3042-.3026.4306-.509a2 2 0 0 0 .2395-.5781c.0565-.2353.0558-.4745.0553-.6644l-.0001-.051V8.5227L23 8.4717c.0005-.19.0012-.4291-.0553-.6644a2 2 0 0 0-.2395-.5781c-.1264-.2064-.296-.375-.4306-.509l-.0362-.036-4.9227-4.9227-.036-.0362c-.134-.1346-.3026-.3042-.509-.4306a2 2 0 0 0-.5781-.2395C15.9573.9987 15.7182.9993 15.5282 1H8.5227M13 8c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 7c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const AlertSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M13 8c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 7c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const AlertTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.8126 1.6684a2 2 0 0 0-1.6252 0c-.3996.1776-.6591.4905-.8397.7455-.1776.2507-.3677.5791-.5767.9403L1.5038 17.634c-.2099.3625-.4006.6919-.53.9715-.1314.2841-.274.666-.2286 1.102a2 2 0 0 0 .813 1.4102c.3546.2577.7566.3257 1.0683.3543.3068.0281.6874.0281 1.1063.0281h16.5343c.4189 0 .7996 0 1.1063-.0281.3118-.0286.7138-.0966 1.0683-.3543a2 2 0 0 0 .813-1.4102c.0455-.436-.0971-.8179-.2286-1.102-.1293-.2796-.32-.609-.5299-.9715L14.229 3.3542c-.2091-.3612-.3992-.6896-.5768-.9403-.1806-.255-.4401-.5679-.8396-.7455M13 9c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 7c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Announcement01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 7c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V8c0-.5523.4477-1 1-1M16.5669 2.1413c.2924-.132.7182-.3019 1.1762-.2458.5733.0702 1.0475.3518 1.3835.8216.264.369.3218.8068.3469 1.1225.0265.3337.0265.7588.0265 1.2465v9.8277c0 .4878 0 .9128-.0265 1.2466-.0251.3157-.0829.7535-.3469 1.1225-.336.4697-.8102.7513-1.3835.8215-.458.0561-.8838-.1138-1.1762-.2457-.3176-.1433-.71-.3572-1.1667-.6062l-.0345-.0189c-1.5687-.8551-3.4096-1.6423-4.8657-1.7262 0 1.0948-.0004 2.1897 0 3.2845.0001.1903.0002.3539-.0144.5021-.1403 1.4244-1.2672 2.5513-2.6915 2.6915-.159.0157-.3357.0145-.5441.0145s-.385.0012-.544-.0145c-1.4244-.1402-2.5513-1.2671-2.6916-2.6915C3.9999 19.1458 4 18.9822 4 18.7919c.0004-1.1014 0-2.2028 0-3.3042a7 7 0 0 1-.1624-.0091c-.3298-.0225-.6597-.072-.9857-.207a3 3 0 0 1-1.6235-1.6236c-.135-.3259-.1845-.6558-.207-.9856C1 12.3491 1 11.9706 1 11.532v-1.2733c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 4.5 5.9537 4.5 6.7587 4.5H10.25c1.4911 0 3.4558-.8288 5.1157-1.7337l.0345-.0188c.4568-.249.8491-.4629 1.1667-.6062"
      clipRule="evenodd"
    />
  </svg>
);

export const Announcement02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.0376 14.2736C1.7945 13.2652 1 11.7254 1 10c0-3.0376 2.4624-5.5 5.5-5.5h3.75c1.8006 0 3.6077-.9116 5.1502-1.7525.4568-.249.8491-.4629 1.1667-.6062.2924-.132.7182-.3019 1.1762-.2458.5733.0702 1.0475.3518 1.3835.8216.264.369.3218.8068.3469 1.1225.0468.5882.0265 1.1822.0265 1.772C21.504 6.0661 23 7.8583 23 10s-1.496 3.9338-3.5 4.3885c0 .5897.0203 1.1836-.0265 1.7719-.0251.3157-.0829.7535-.3469 1.1225-.336.4697-.8102.7513-1.3835.8215-.458.0561-.8838-.1138-1.1762-.2457-.4113-.1856-.8054-.4092-1.2012-.6251-1.394-.7598-3.0028-1.4661-4.3657-1.6729 0 1.5589.1366 3.176-.014 4.7289-.1385 1.4279-1.2685 2.5579-2.6964 2.6964-.3173.0308-.655.03-.9726.004A3 3 0 0 1 4.72 20.9624c-.0397-.1171-.0713-.2439-.1078-.39zM19.5 12.292c.883-.3858 1.5-1.2668 1.5-2.292s-.617-1.9062-1.5-2.292z"
      clipRule="evenodd"
    />
  </svg>
);

export const Announcement03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.5286 2.0002c1.4965.014 2.627 1.13 3.3268 2.4296.7262 1.3486 1.1447 3.143 1.1447 5.0703s-.4185 3.7217-1.1447 5.0703c-.7013 1.3023-1.8351 2.4202-3.3362 2.4297-2.4001.0434-5.0692-.9019-7.4262-1.3304l.2742 3.5644c.0999 1.2968-.2674 2.6179-1.8081 2.7476-1.0689.0899-2.1989.0873-3.2645.0029-1.2728-.1008-1.8122-1.1939-1.896-2.3689l-.3752-5.2535c-.2906-.0731-.549-.1588-.787-.2756a4 4 0 0 1-2.0842-2.4974c-.3344-1.1774-.3361-2.9947 0-4.1783a4 4 0 0 1 2.0843-2.4974c.5028-.247 1.0977-.3548 1.8935-.499C9.5312 3.6143 17 2.0001 18.5286 2.0002m.0443 12.9967-.472-.0858c-.3652-.1572-.7923-.5405-1.1952-1.2889-.5406-1.0039-.9056-2.4595-.9056-4.122s.365-3.1182.9056-4.1222c.3336-.6196.6838-.989 1.0017-1.187.1239-.0771.2666-.1153.4102-.1414.1691-.0307.3448-.0474.5068.0101.3808.1354.8392.5182 1.2701 1.3183.5405 1.004.9056 2.4596.9056 4.1221 0 1.6626-.3651 3.1182-.9056 4.1221-.531.986-1.1038 1.3383-1.5216 1.3747"
      clipRule="evenodd"
    />
  </svg>
);

export const Bell01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.6044 20.3383c.3655-.4141.9974-.4535 1.4115-.088A2.985 2.985 0 0 0 12 21a2.985 2.985 0 0 0 1.9841-.7497c.414-.3655 1.046-.3261 1.4114.088.3655.414.3261 1.046-.088 1.4114C14.4267 22.5272 13.2674 23 12 23s-2.4268-.4728-3.3076-1.2503c-.414-.3654-.4534-.9974-.088-1.4114M7.0502 3.0503A7.0001 7.0001 0 0 1 19 8c0 2.9127.732 4.8439 1.4994 6.0771l.0118.0191c.3573.5742.6398 1.0281.8302 1.3585.0954.1655.1823.325.2467.4668.0321.0707.0681.1575.0962.2518.0233.0782.0677.2454.051.449-.0112.1368-.0391.3705-.1732.612-.1342.2415-.3179.3887-.4281.4704-.2503.1857-.5377.2282-.6337.2423l-.0044.0007c-.1474.0218-.3147.0327-.4834.0392C19.6772 18 19.2131 18 18.6358 18H5.3641c-.5772 0-1.0413 0-1.3766-.0131-.1687-.0065-.336-.0174-.4834-.0392l-.0045-.0007c-.0959-.0141-.3833-.0566-.6336-.2423-.1103-.0817-.294-.2289-.4281-.4704-.1342-.2415-.162-.4752-.1733-.612-.0166-.2036.0278-.3708.051-.449a2 2 0 0 1 .0963-.2518c.0643-.1418.1512-.3013.2467-.4668.1904-.3304.4729-.7844.8302-1.3586l.0118-.019C4.268 12.8439 5 10.9127 5 8a7 7 0 0 1 2.0502-4.9497"
      clipRule="evenodd"
    />
  </svg>
);

export const Bell02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 21c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4c-.5523 0-1-.4477-1-1M7.0502 3.0503A7.0001 7.0001 0 0 1 19 8c0 2.9127.732 4.8439 1.4994 6.0771l.0118.0191c.3573.5742.6398 1.0281.8302 1.3585.0954.1655.1823.325.2467.4668.0321.0707.0681.1575.0962.2518.0233.0782.0677.2454.051.449-.0112.1368-.0391.3705-.1732.612-.1342.2415-.3179.3887-.4281.4704-.2503.1857-.5377.2282-.6337.2423l-.0044.0007c-.1474.0218-.3147.0327-.4834.0392C19.6772 18 19.2131 18 18.6358 18H5.3641c-.5772 0-1.0413 0-1.3766-.0131-.1687-.0065-.336-.0174-.4834-.0392l-.0045-.0007c-.0959-.0141-.3833-.0566-.6336-.2423-.1103-.0817-.294-.2289-.4281-.4704-.1342-.2415-.162-.4752-.1733-.612-.0166-.2036.0278-.3708.051-.449a2 2 0 0 1 .0963-.2518c.0643-.1418.1512-.3013.2467-.4668.1904-.3304.4729-.7844.8302-1.3586l.0118-.019C4.268 12.8439 5 10.9127 5 8a7 7 0 0 1 2.0502-4.9497"
      clipRule="evenodd"
    />
  </svg>
);

export const Bell03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.7193 5.7215A3.49 3.49 0 0 1 8.5 4.5C8.5 2.567 10.067 1 12 1s3.5 1.567 3.5 3.5c0 .4294-.0776.841-.2193 1.2215.5859.2748 1.1314.625 1.6169 1.0459C18.2222 7.9154 19 9.5057 19 11.2c0 2.1077.5203 3.5999 1.1327 4.6357l.0103.0173c.3937.6659.7013 1.1861.9076 1.5595.1031.1866.1938.3596.2598.5078.0327.0734.0688.1616.0969.2553.021.0698.0726.2509.0511.4703-.0118.1205-.0388.3598-.1781.6041s-.3316.3893-.4293.4608c-.1593.1164-.3186.1664-.398.1883a1.9 1.9 0 0 1-.2601.0514c-.1509.0202-.3266.0305-.5097.0368-.365.0127-.8754.0127-1.5186.0127H15.874c-.4441 1.7252-2.0102 3-3.874 3s-3.43-1.2748-3.874-3H5.8355c-.6431 0-1.1536 0-1.5187-.0127-.1831-.0063-.3588-.0166-.5097-.0368a1.9 1.9 0 0 1-.2601-.0514c-.0794-.0219-.2387-.0719-.398-.1883-.0977-.0715-.29-.2166-.4292-.4608-.1394-.2443-.1664-.4836-.1782-.6041-.0214-.2194.0302-.4005.0511-.4703a2.2 2.2 0 0 1 .097-.2553c.0659-.1482.1566-.3212.2597-.5078.2063-.3734.5139-.8935.9077-1.5595l.0102-.0173C4.4797 14.7999 5 13.3077 5 11.2c0-1.6943.7778-3.2846 2.1024-4.4326.4855-.4208 1.031-.7711 1.617-1.046M10.5 4.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5c0 .221-.0474.4305-.133.6191A7.9 7.9 0 0 0 12 5c-.4611 0-.9189.0403-1.367.1191A1.49 1.49 0 0 1 10.5 4.5M12 21c.7403 0 1.3866-.4022 1.7324-1h-3.4648c.3458.5978.9921 1 1.7324 1"
      clipRule="evenodd"
    />
  </svg>
);

export const Bell04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.1912 4.8575a3.49 3.49 0 0 0-.1043-1.2366C11.5866 1.7538 9.6674.6457 7.8003 1.146S4.8251 3.5655 5.3254 5.4326c.1112.4148.2927.7924.528 1.1232-.4947.417-.931.8966-1.291 1.4287-.9824 1.4517-1.322 3.1892-.8836 4.8257.5455 2.0359.4292 3.6119.1057 4.7709l-.0053.0193c-.208.7452-.3705 1.3273-.4731 1.7414-.0513.2069-.0942.3975-.1196.5577a2.2 2.2 0 0 0-.0275.2717c-.0022.0729-.0052.2611.0724.4675.0425.1134.1306.3375.3284.5374s.421.2902.5339.334c.184.0712.3508.0782.4331.0789.0972.0008.1891-.0079.2646-.0177.151-.0195.3233-.0551.5018-.0963.3559-.0823.8488-.2143 1.47-.3808l1.2467-.3341c.8755 1.5516 2.7182 2.3776 4.5185 1.8952s2.9832-2.1191 2.9655-3.9005l3.1785-.8516c.6213-.1665 1.1143-.2986 1.4637-.4053.1752-.0536.3422-.109.4827-.1675a1.95 1.95 0 0 0 .238-.117c.071-.0417.212-.1312.3356-.2849.0759-.0943.2241-.2842.2954-.5562.0714-.272.0356-.5102.0158-.6296-.0361-.2175-.1328-.3791-.1711-.4411a2.2 2.2 0 0 0-.1597-.2215c-.1021-.126-.2345-.2697-.3824-.4233-.2959-.3072-.7276-.73-1.2803-1.2714l-.0144-.0141c-.8596-.8419-1.7484-2.1487-2.2939-4.1845-.4385-1.6366-1.6014-2.9714-3.178-3.7375-.5779-.2808-1.1955-.478-1.8326-.5918M8.3179 3.078c-.8001.2144-1.275 1.0369-1.0606 1.837.0572.2136.1573.4037.2888.5637a7.9 7.9 0 0 1 1.2895-.4688 7.9 7.9 0 0 1 1.3512-.2388 1.49 1.49 0 0 0-.0317-.6325c-.2144-.8002-1.037-1.275-1.8371-1.0606m5.1075 16.2312-3.3469.8968c.4888.4879 1.2172.7092 1.9323.5176s1.2353-.7475 1.4146-1.4144"
      clipRule="evenodd"
    />
  </svg>
);

export const BellMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 5c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12 1a7 7 0 0 0-7 7c0 2.9127-.732 4.8439-1.4994 6.0771l-.0118.019c-.3573.5742-.6398 1.0282-.8302 1.3586-.0955.1655-.1824.325-.2467.4668a2 2 0 0 0-.0962.2518c-.0233.0782-.0677.2454-.051.449.0111.1368.039.3705.1732.612s.3178.3887.428.4704c.2504.1857.5378.2282.6337.2423l.0045.0007c.1474.0218.3146.0327.4834.0392C4.3227 18 4.7867 18 5.3637 18h13.2721c.5771 0 1.0415 0 1.3767-.0131.1687-.0065.336-.0174.4834-.0392l.0044-.0007c.096-.0141.3834-.0566.6337-.2423.1102-.0817.2939-.2289.4281-.4704s.162-.4752.1732-.612c.0167-.2036-.0277-.3708-.051-.449a2 2 0 0 0-.0962-.2518c-.0644-.1418-.1513-.3013-.2467-.4668-.1904-.3304-.4728-.7842-.83-1.3582l-.012-.0194C19.732 12.8439 19 10.9127 19 8h-4c-1.6569 0-3-1.3431-3-3s1.3431-3 3-3c.1703 0 .2266-.2143.0737-.289A7 7 0 0 0 12 1M10.0159 20.2503c-.414-.3655-1.046-.3261-1.4115.088-.3654.414-.326 1.046.088 1.4114C9.5732 22.5272 10.7326 23 12 23s2.4267-.4728 3.3075-1.2503c.4141-.3654.4535-.9974.088-1.4114-.3654-.4141-.9974-.4535-1.4114-.088A2.985 2.985 0 0 1 12 21a2.985 2.985 0 0 1-1.9841-.7497"
    />
  </svg>
);

export const BellOff01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L5.149 6.5632A7 7 0 0 0 5 8.0002c0 2.9126-.732 4.8438-1.4994 6.077l-.0118.019c-.3573.5742-.6398 1.0282-.8302 1.3586-.0955.1655-.1824.325-.2467.4668a2 2 0 0 0-.0962.2518c-.0233.0782-.0677.2454-.051.449.0111.1368.039.3705.1732.612s.3178.3887.428.4704c.2504.1857.5378.2282.6337.2423l.0045.0007c.1474.0218.3146.0327.4834.0392.3352.0131.7993.0131 1.3764.0131h11.222l3.707 3.707c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L6.9979 5.5837a1 1 0 0 0-.0668-.0668z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.6044 20.3383c.3655-.4141.9974-.4535 1.4115-.088A2.985 2.985 0 0 0 12 21a2.985 2.985 0 0 0 1.9841-.7497c.414-.3655 1.046-.3261 1.4114.088.3655.414.3261 1.046-.088 1.4115C14.4267 22.5272 13.2673 23 12 23s-2.4268-.4728-3.3076-1.2502c-.414-.3655-.4535-.9975-.088-1.4115M21.5306 17.2879c.1248-.2011.1856-.4312.2047-.6656.0167-.2036-.0277-.3708-.051-.449a2 2 0 0 0-.0962-.2518c-.0644-.1418-.1513-.3013-.2467-.4668-.1904-.3304-.4728-.7842-.83-1.3582l-.012-.0194C19.732 12.8439 19 10.9127 19 8A6.9999 6.9999 0 0 0 7.173 2.9304z"
    />
  </svg>
);

export const BellOff02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L5.149 6.5632A7 7 0 0 0 5 8.0002c0 2.9126-.732 4.8438-1.4994 6.077l-.0118.019c-.3573.5742-.6398 1.0282-.8302 1.3586-.0955.1655-.1824.325-.2467.4668a2 2 0 0 0-.0962.2518c-.0233.0782-.0677.2454-.051.449.0111.1368.039.3705.1732.612s.3178.3887.428.4704c.2504.1857.5378.2282.6337.2423l.0045.0007c.1474.0218.3146.0327.4834.0392.3352.0131.7993.0131 1.3764.0131h11.222l3.707 3.707c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L6.9979 5.5837a1 1 0 0 0-.0668-.0668z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10 22c-.5523 0-1-.4477-1-1s.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1zM21.5306 17.2879a1.3 1.3 0 0 0 .0315-.0536c.1341-.2415.162-.4752.1732-.612.0167-.2036-.0277-.3708-.051-.449a2 2 0 0 0-.0962-.2518c-.0644-.1418-.1513-.3013-.2467-.4668-.1904-.3304-.4728-.7842-.83-1.3582l-.012-.0194C19.732 12.8439 19 10.9127 19 8A6.9999 6.9999 0 0 0 7.173 2.9304z"
    />
  </svg>
);

export const BellOff03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.874 20h3.6208l.8408.7474c.4128.3669 1.0449.3298 1.4118-.083s.3298-1.0449-.083-1.4118l-18-16c-.4128-.367-1.0449-.3297-1.4118.083s-.3297 1.0449.083 1.4118l3.6639 3.2567C5.3566 8.9523 5 10.054 5 11.2c0 2.1076-.5202 3.5999-1.1327 4.6357l-.0102.0172c-.3938.6659-.7014 1.1862-.9077 1.5596-.103.1866-.1938.3596-.2598.5077a2.2 2.2 0 0 0-.0969.2554c-.021.0698-.0725.2508-.051.4703.0117.1205.0387.3598.178.6041.1394.2442.3316.3893.4293.4607.1593.1165.3186.1664.398.1884.0937.026.1847.0413.2601.0514.151.0202.3266.0305.5097.0368C4.6818 20 5.1922 20 5.8353 20H8.126c.444 1.7252 2.0102 3 3.874 3s3.43-1.2748 3.874-3M12 21c-.7403 0-1.3866-.4022-1.7324-1h3.4648c-.3458.5978-.9921 1-1.7324 1M8.522 4.8946l11.0851 9.8534C19.2498 13.8256 19 12.6606 19 11.2c0-1.6943-.7778-3.2846-2.1024-4.4326-.4855-.4208-1.031-.7712-1.6169-1.046A3.49 3.49 0 0 0 15.5 4.5C15.5 2.567 13.933 1 12 1S8.5 2.567 8.5 4.5q.0001.2001.022.3946M12 3c-.8284 0-1.5.6716-1.5 1.5 0 .221.0474.4305.133.6191A7.9 7.9 0 0 1 12 5c.4611 0 .9189.0403 1.367.1191.0856-.1886.133-.398.133-.6191 0-.8284-.6716-1.5-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const BellPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1V6h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2z"
    />
    <path
      fill="currentColor"
      d="M15.0057 1.8133c.0048-.0785-.0366-.1529-.1082-.1855A7.0001 7.0001 0 0 0 5 8c0 2.9127-.732 4.8439-1.4994 6.0771l-.0118.019c-.3573.5742-.6398 1.0282-.8302 1.3586-.0955.1655-.1824.325-.2467.4668a2 2 0 0 0-.0962.2518c-.0233.0782-.0677.2454-.051.449.0111.1368.039.3705.1732.612s.3178.3887.428.4704c.2504.1857.5378.2282.6337.2423l.0045.0007c.1474.0218.3146.0327.4834.0392C4.3227 18 4.7867 18 5.3637 18h13.2721c.577 0 1.0415 0 1.3767-.0131.1687-.0065.336-.0174.4834-.0392l.0044-.0007c.096-.0141.3834-.0566.6337-.2423.1102-.0817.2939-.2289.4281-.4704s.162-.4752.1732-.612c.0167-.2036-.0277-.3708-.051-.449a2 2 0 0 0-.0962-.2518c-.0644-.1418-.1513-.3013-.2467-.4668-.1904-.3304-.4728-.7842-.83-1.3582l-.012-.0194c-.3768-.6055-.745-1.3792-1.0223-2.3548-.099-.3485-.1486-.5227-.2155-.6037-.0778-.094-.1089-.1155-.2244-.1547-.0995-.0338-.3245-.0143-.7744.0248A3 3 0 0 1 18 11c-1.6569 0-3-1.3431-3-3-1.6569 0-3-1.3431-3-3 0-1.5944 1.2438-2.8983 2.814-2.9943a.206.206 0 0 0 .1917-.1924M8.6044 20.3383c.3655-.4141.9974-.4535 1.4115-.088A2.985 2.985 0 0 0 12 21a2.985 2.985 0 0 0 1.9841-.7497c.414-.3655 1.046-.3261 1.4114.088.3655.414.3261 1.046-.088 1.4114C14.4267 22.5272 13.2674 23 12 23s-2.4268-.4728-3.3076-1.2503c-.414-.3654-.4534-.9974-.088-1.4114"
    />
  </svg>
);

export const BellRinging01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.6044 20.3383c.3655-.4141.9974-.4535 1.4115-.088A2.985 2.985 0 0 0 12 21a2.985 2.985 0 0 0 1.9841-.7497c.4141-.3655 1.046-.3261 1.4115.088.3654.414.326 1.046-.088 1.4114C14.4268 22.5272 13.2674 23 12 23s-2.4267-.4728-3.3076-1.2503c-.414-.3654-.4534-.9974-.088-1.4114M5.197 1.8086c.2714.481.1015 1.091-.3795 1.3623-.9467.5342-1.5344 1.552-1.5236 2.6391.0054.5523-.4379 1.0044-.9901 1.0098s-1.0044-.4378-1.0099-.99C1.276 4.014 2.2533 2.3214 3.8347 1.429c.481-.2714 1.091-.1015 1.3623.3795M18.799 1.8086c.2714-.481.8813-.651 1.3623-.3795 1.5814.8923 2.5587 2.585 2.5408 4.4007-.0055.5522-.4576.9955-1.0098.99-.5523-.0054-.9956-.4575-.9901-1.0098.0107-1.087-.5769-2.1049-1.5237-2.639-.481-.2715-.6509-.8814-.3795-1.3624M7.0503 3.0503A7 7 0 0 1 19 8c0 2.9127.732 4.8439 1.4994 6.0771l.0119.0191c.3572.5742.6397 1.0281.8301 1.3585.0954.1655.1824.325.2467.4668.0322.0707.0681.1575.0962.2518.0233.0782.0677.2454.0511.449-.0112.1368-.0391.3705-.1733.612-.1341.2415-.3179.3887-.4281.4704-.2503.1857-.5377.2282-.6337.2423l-.0044.0007c-.1474.0218-.3147.0327-.4834.0392C19.6772 18 19.2131 18 18.6359 18H5.3642c-.5773 0-1.0414 0-1.3767-.0131-.1687-.0065-.336-.0174-.4834-.0392l-.0044-.0007c-.096-.0141-.3834-.0566-.6337-.2423-.1102-.0817-.294-.2289-.4281-.4704-.1342-.2415-.162-.4752-.1732-.612-.0167-.2036.0277-.3708.051-.449.0281-.0943.064-.1811.0962-.2518.0643-.1418.1513-.3013.2467-.4668.1904-.3304.4729-.7844.8302-1.3586l.0118-.019C4.268 12.8439 5 10.9127 5 8a7 7 0 0 1 2.0503-4.9497"
      clipRule="evenodd"
    />
  </svg>
);

export const BellRinging02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 21c0-.5523.4478-1 1.0001-1h4c.5522 0 1 .4477 1 1s-.4478 1-1 1h-4c-.5523 0-1-.4477-1-1M5.197 1.8086c.2714.481.1015 1.091-.3795 1.3623-.9467.5342-1.5344 1.552-1.5236 2.6391.0054.5523-.4379 1.0044-.9901 1.0098s-1.0044-.4378-1.0099-.99C1.276 4.014 2.2533 2.3214 3.8347 1.429c.481-.2714 1.091-.1015 1.3623.3795M18.7991 1.8086c.2714-.481.8814-.651 1.3624-.3795 1.5814.8923 2.5587 2.585 2.5407 4.4007-.0054.5522-.4576.9955-1.0098.99-.5523-.0054-.9955-.4575-.9901-1.0098.0108-1.087-.5769-2.1049-1.5237-2.639-.481-.2715-.6509-.8814-.3795-1.3624M7.0503 3.0503A7 7 0 0 1 19.0001 8c0 2.9127.732 4.8439 1.4993 6.0771l.0119.0191c.3573.5742.6397 1.0281.8302 1.3585.0954.1655.1823.325.2467.4668.0321.0707.068.1575.0961.2518.0233.0782.0677.2454.0511.449-.0112.1368-.0391.3705-.1732.612-.1342.2415-.3179.3887-.4282.4704-.2502.1857-.5377.2282-.6336.2423l-.0044.0007c-.1474.0218-.3147.0327-.4835.0392C19.6773 18 19.2131 18 18.6359 18H5.3642c-.5772 0-1.0414 0-1.3766-.0131-.1688-.0065-.336-.0174-.4835-.0392l-.0044-.0007c-.096-.0141-.3833-.0566-.6336-.2423-.1103-.0817-.294-.2289-.4282-.4704-.1341-.2415-.162-.4752-.1732-.612-.0166-.2036.0278-.3708.051-.449.0282-.0943.0641-.1811.0962-.2518.0644-.1418.1513-.3013.2468-.4668.1904-.3304.4728-.7844.8302-1.3586l.0118-.019C4.268 12.8439 5 10.9127 5 8a7 7 0 0 1 2.0503-4.9497"
      clipRule="evenodd"
    />
  </svg>
);

export const BellRinging03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2806 5.7215A3.49 3.49 0 0 0 15.4999 4.5c0-1.933-1.567-3.5-3.5-3.5s-3.5 1.567-3.5 3.5c0 .4294.0776.841.2194 1.2215-.586.2748-1.1314.625-1.617 1.0459C5.7778 7.9154 5 9.5057 5 11.2c0 2.1077-.5203 3.5999-1.1328 4.6357l-.0101.0172c-.3938.6659-.7014 1.1862-.9077 1.5596-.1031.1866-.1939.3596-.2598.5078a2.2 2.2 0 0 0-.097.2553c-.021.0698-.0725.2509-.051.4703.0117.1205.0388.3598.1781.6041s.3316.3893.4293.4608c.1592.1164.3186.1664.398.1883.0936.026.1846.0413.26.0514.151.0202.3266.0305.5097.0368C4.6819 20 5.1922 20 5.8355 20H8.126c.444 1.7252 2.0101 3 3.8739 3s3.43-1.2748 3.874-3h2.2906c.6431 0 1.1536 0 1.5186-.0127.1832-.0063.3588-.0166.5097-.0368a1.9 1.9 0 0 0 .2602-.0514c.0793-.0219.2387-.0719.3979-.1883.0977-.0715.29-.2166.4293-.4608s.1664-.4836.1781-.6041c.0215-.2194-.0301-.4005-.0511-.4703a2.2 2.2 0 0 0-.0969-.2553c-.0659-.1482-.1567-.3212-.2598-.5078-.2063-.3734-.5138-.8935-.9076-1.5595l-.0102-.0173C19.5202 14.7999 19 13.3077 19 11.2c0-1.6943-.7778-3.2846-2.1025-4.4326-.4855-.4208-1.031-.7712-1.6169-1.046M11.9999 3c-.8284 0-1.5.6716-1.5 1.5 0 .221.0475.4305.1331.6191A7.9 7.9 0 0 1 12 5c.461 0 .9188.0403 1.3669.1191.0856-.1886.133-.398.133-.6191 0-.8284-.6715-1.5-1.5-1.5m-1.7324 17c.3458.5978.9922 1 1.7324 1s1.3867-.4022 1.7325-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.0703 5.674c.481-.2714.651-.8814.3795-1.3624-.2714-.481-.8813-.6509-1.3623-.3795-1.5814.8923-2.5587 2.585-2.5407 4.4007.0054.5523.4575.9955 1.0098.99.5522-.0054.9955-.4575.99-1.0098-.0107-1.087.577-2.1048 1.5237-2.639M18.55 4.3117c.2714-.481.8813-.6509 1.3623-.3795 1.5814.8923 2.5587 2.585 2.5408 4.4007-.0055.5523-.4576.9956-1.0099.9901s-.9955-.4576-.99-1.0098c.0107-1.087-.577-2.105-1.5237-2.6391-.481-.2714-.6509-.8814-.3795-1.3624"
    />
  </svg>
);

export const BellRinging04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.1083 6.5557a3.49 3.49 0 0 1-.528-1.123C6.08 3.5654 7.188 1.6462 9.055 1.146s3.7864.6078 4.2867 2.4749c.1111.4148.1427.8325.1042 1.2367.6371.1137 1.2546.311 1.8325.5917 1.5766.766 2.7395 2.101 3.178 3.7375.5455 2.0358 1.4343 3.3426 2.2939 4.1845l.0144.0141c.5527.5414.9844.9642 1.2803 1.2714.1479.1536.2804.2973.3824.4233.0506.0625.1083.1383.1597.2215.0383.062.135.2236.1711.4411.0198.1194.0556.3576-.0157.6296-.0714.272-.2195.4619-.2954.5562-.1237.1537-.2647.2432-.3357.2849a1.94 1.94 0 0 1-.238.117c-.1405.0585-.3075.1139-.4827.1675-.3494.1067-.8424.2388-1.4637.4053l-3.1782.8516c.0176 1.7813-1.1652 3.4179-2.9655 3.9003-1.8003.4823-3.6429-.3436-4.5184-1.895l-1.2468.334c-.6211.1665-1.1144.2986-1.4702.3809-.1785.0412-.351.0768-.5019.0963a1.95 1.95 0 0 1-.2645.0177c-.0824-.0007-.2492-.0077-.4332-.0789-.1129-.0438-.3361-.1341-.534-.334-.1977-.1999-.2858-.424-.3283-.5374-.0775-.2064-.0746-.3946-.0724-.4675.003-.0978.015-.1923.0275-.2717.0254-.1602.0683-.3508.1196-.5577.1026-.4141.265-.9962.473-1.7414l.0054-.0193c.3236-1.159.4399-2.735-.1056-4.7709-.4386-1.6365-.0989-3.374.8835-4.8257.36-.5321.7963-1.0117 1.2912-1.4288M8.512 4.915c-.2144-.8002.2605-1.6227 1.0607-1.8371.8002-.2145 1.6227.2604 1.8371 1.0606.0572.2136.0656.4281.0317.6325a7.9 7.9 0 0 0-1.3512.2388 7.9 7.9 0 0 0-1.2895.4688 1.49 1.49 0 0 1-.2888-.5636m2.8215 15.2908c.4888.4878 1.2171.709 1.9321.5174.7151-.1916 1.2353-.7473 1.4146-1.4142z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M3.8229 6.9875c.3866.3943.3804 1.0275-.014 1.4141-.7763.761-1.0804 1.8963-.7887 2.9435.1482.532-.163 1.0835-.695 1.2317s-1.0835-.1629-1.2317-.695c-.4872-1.7491.0187-3.6371 1.3152-4.9083.3944-.3867 1.0275-.3804 1.4142.014M16.4766 3.597c.1376-.5349.6828-.8568 1.2177-.7192 1.7584.4526 3.1406 1.8347 3.5931 3.5932.1377.5348-.1843 1.08-.7191 1.2177-.5349.1376-1.0801-.1843-1.2177-.7192-.271-1.0528-1.1021-1.8838-2.1548-2.1548-.5349-.1377-.8569-.6828-.7192-1.2177"
    />
  </svg>
);

export const NotificationBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.1213 2.8787c1.1716 1.1716 1.1716 3.071 0 4.2426s-3.071 1.1716-4.2426 0-1.1716-3.071 0-4.2426 3.071-1.1716 4.2426 0"
    />
    <path
      fill="currentColor"
      d="M22 10.6031c0-.5227 0-.784-.0785-.907-.0807-.1267-.1542-.1796-.2999-.2161-.1415-.0355-.4391.0638-1.0343.2625-1.7405.5811-3.7371.1787-5.1228-1.207s-1.7881-3.3823-1.207-5.1228c.1987-.5952.298-.8928.2625-1.0343-.0365-.1457-.0894-.2191-.216-.3C14.181 2 13.9196 2 13.3969 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386z"
    />
  </svg>
);

export const NotificationMessage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.1213 2.8787c1.1716 1.1716 1.1716 3.071 0 4.2426s-3.071 1.1716-4.2426 0-1.1716-3.071 0-4.2426 3.071-1.1716 4.2426 0"
    />
    <path
      fill="currentColor"
      d="M22.0001 10.6031c0-.5227 0-.7841-.0785-.9071-.0808-.1266-.1542-.1796-.2999-.216-.1415-.0356-.4391.0638-1.0343.2625-1.7405.5811-3.7372.1788-5.1229-1.207-1.3857-1.3857-1.7881-3.3823-1.207-5.1228.1987-.5952.298-.8928.2625-1.0343-.0365-.1457-.0894-.2191-.216-.3C14.181 2 13.9196 2 13.3969 2H7.7588c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v6.3789c-.0005.7954-.0008 1.386.1363 1.8977a4 4 0 0 0 2.8284 2.8284c.3075.0824.6435.1152 1.0353.1281v1.3792c0 .2352-.0001.475.0178.6715.017.188.0622.5427.3099.853a1.5 1.5 0 0 0 1.174.5642c.3969-.0004.7021-.1867.8596-.2908.1646-.1089.3518-.2587.5355-.4057l2.4131-1.9305c.5186-.4149.6726-.532.8325-.6137a2 2 0 0 1 .5079-.1782c.1759-.0361.3693-.0408 1.0334-.0408h2.5576c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0442-.5412.0442-1.2055.0442-2.0105z"
    />
  </svg>
);

export const NotificationText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.1213 2.8787c1.1716 1.1716 1.1716 3.071 0 4.2426s-3.071 1.1716-4.2426 0-1.1716-3.071 0-4.2426 3.071-1.1716 4.2426 0"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21 10.8055c0-.4088 0-.6132-.0664-.7288-.0666-.1162-.1343-.1735-.2599-.22-.125-.0463-.364-.0062-.8419.074-1.5405.2585-3.1787-.2065-4.3673-1.3952s-1.6537-2.8269-1.3952-4.3673c.0802-.478.1203-.717.074-.842-.0465-.1255-.1038-.1932-.22-.2598C13.8077 3 13.6033 3 13.1945 3H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 7.2894 2 7.9537 2 8.7587v7.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 22 6.9537 22 7.7587 22h7.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 17.7106 21 17.0463 21 16.2413zM6 13c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ThumbsDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 2.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.2401 1 14.9601 1 14.4 1H8.0805c-.6987 0-1.279 0-1.7562.0363-.4984.038-.9578.1193-1.4013.3203a4 4 0 0 0-1.6992 1.4577c-.266.4078-.4163.8495-.5296 1.3363-.1085.4663-.1967 1.0397-.303 1.7303l-.5355 3.4814c-.1408.915-.2562 1.6651-.297 2.2773-.0421.6316-.0146 1.221.2009 1.7859a4 4 0 0 0 1.7601 2.0517c.5256.2988 1.104.4157 1.7346.4701C5.8656 16 6.6245 16 7.5503 16H8.4c.2965 0 .4588.0008.5754.0103l.0132.0012.0011.0131c.0095.1166.0103.2789.0103.5754v2.9342C9.0001 21.4483 10.5518 23 12.466 23a1.822 1.822 0 0 0 1.665-1.082l3.3607-7.5617c.0816-.1834.1241-.278.159-.3447l.0031-.0058.0067-.0005c.075-.0048.1788-.0053.3795-.0053h.7987c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167.0306-.3745.0306-.8293.0306-1.3564V5.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8206 1 19.3658 1 18.8387 1A.8387.8387 0 0 0 18 1.8387V10c0 .5523-.4477 1-1 1s-1-.4477-1-1z"
    />
  </svg>
);

export const ThumbsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.5342 1a1.822 1.822 0 0 0-1.665 1.082L6.5085 9.6437c-.0815.1834-.1241.278-.159.3446l-.0031.006-.0066.0004c-.075.0048-.1788.0053-.3796.0053h-.7987c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 13.1795 1 13.6343 1 14.1614v4.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 23 4.6343 23 5.1614 23A.8385.8385 0 0 0 6 22.1614V14c0-.5523.4477-1 1-1s1 .4477 1 1v7.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C8.76 23 9.04 23 9.6 23h6.3196c.6988 0 1.2789 0 1.7562-.0363.4984-.038.9578-.1193 1.4013-.3203a4 4 0 0 0 1.6992-1.4577c.266-.4078.4163-.8495.5296-1.3363.1085-.4662.1967-1.0396.3029-1.7302l.5356-3.4815c.1408-.915.2562-1.6651.297-2.2773.0422-.6316.0146-1.221-.2009-1.7859a4 4 0 0 0-1.7601-2.0517c-.5256-.2988-1.1039-.4157-1.7346-.47C18.1345 8 17.3756 8 16.4498 8H15.6c-.2965 0-.4588-.0008-.5754-.0103l-.0131-.0011-.0012-.0132C15.0008 7.8588 15 7.6965 15 7.4V4.4658C15 2.5518 13.4483 1 11.5342 1"
    />
  </svg>
);

export const Circle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1"
    />
  </svg>
);

export const Cube01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.4029 1.185a2 2 0 0 0-.8058 0c-.3073.0632-.5819.217-.8003.3394l-.0595.0332c-1.7629.9794-4.7452 2.637-6.4266 3.5717-.4082.2269-.6124.3404-.6806.4903a.5.5 0 0 0-.001.4118c.0674.1503.2712.2649.6786.494l7.3001 4.1064c.143.0804.2146.1207.2904.1365a.5.5 0 0 0 .2035 0c.0759-.0158.1474-.0561.2905-.1365l7.3001-4.1064c.4074-.2292.6112-.3437.6786-.494a.5.5 0 0 0-.001-.4118c-.0682-.15-.2724-.2634-.6806-.4903-1.6814-.9346-4.6637-2.5923-6.4266-3.5717l-.0595-.0332c-.2184-.1223-.493-.2762-.8003-.3394M21.9959 8.8902c-.0004-.4484-.0006-.6726-.0951-.8034a.5.5 0 0 0-.3493-.2041c-.1604-.0181-.3562.092-.7477.3122l-7.396 4.1603c-.1485.0835-.2227.1253-.2767.1843a.5.5 0 0 0-.1061.1814c-.025.076-.025.1612-.025.3315v8.1753c0 .4472 0 .6708.094.8016a.5.5 0 0 0 .3479.2047c.16.0187.3549-.0895.7446-.3059 1.6663-.9253 4.695-2.6071 6.4762-3.5967l.0631-.0348c.2311-.1273.5218-.2874.7449-.5296.193-.2094.339-.4575.4283-.7279.1034-.3127.1021-.6445.1012-.9083L22 16.0586c0-1.963-.0025-5.3023-.0041-7.1684M9.8135 21.9281c.3897.2164.5846.3246.7446.3059a.5.5 0 0 0 .3479-.2047c.094-.1308.094-.3544.094-.8016v-8.1752c0-.1704 0-.2555-.025-.3316a.5.5 0 0 0-.1061-.1813c-.054-.0591-.1282-.1009-.2767-.1844L3.1962 8.195c-.3915-.2203-.5873-.3304-.7477-.3123a.5.5 0 0 0-.3493.204c-.0945.131-.0947.3551-.0951.8035A10602 10602 0 0 0 2 16.0586l-.0002.0722c-.001.2638-.0022.5956.1012.9083.0893.2704.2353.5185.4283.7279.2231.2422.5137.4022.7449.5296l.0631.0348c1.7812.9896 4.8099 2.6714 6.4762 3.5967"
    />
  </svg>
);

export const Cube02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 2.262c0-.3814-.4098-.6224-.743-.437L3.686 5.4808c-.3426.1906-.3425.6835.0003.874l6.5709 3.6506c.3333.1851.7428-.0559.7428-.4371zM2.7432 8.1188c-.3333-.1852-.743.0559-.7428.4372l.0027 7.1219c.0001.3812.4096.622.7428.4369l6.4083-3.5602c.3429-.1905.3429-.6836 0-.8741zM3.8926 17.7657c-.343.1905-.343.6836 0 .8741l6.3646 3.5359c.3333.1852.7428-.0558.7428-.437v-7.0719c0-.3812-.4095-.6222-.7428-.437zM13 21.7387c0 .3812.4096.6222.7429.437l6.3646-3.5359c.3429-.1905.3429-.6836 0-.8741l-6.3646-3.5359c-.3333-.1852-.7429.0558-.7429.437zM21.2542 16.1148c.3332.1851.7427-.0557.7428-.4369l.0027-7.1219c.0002-.3813-.4095-.6224-.7428-.4372l-6.411 3.5617c-.3429.1905-.3429.6836 0 .8741zM20.3138 6.3548c.3428-.1905.3429-.6834.0003-.874l-6.571-3.6558c-.3332-.1854-.7431.0556-.7431.437v7.3063c0 .3812.4096.6222.7429.4371z"
    />
  </svg>
);

export const Cube03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7302 2.8556c.3149-.315.0919-.8535-.3535-.8535L8.4142 2A2 2 0 0 0 7 2.5858L3.4393 6.1465c-.315.315-.0919.8535.3536.8535h11.5858a.5.5 0 0 0 .3535-.1464zM2.5 9a.5.5 0 0 0-.5.5v11c0 .8284.6716 1.5 1.5 1.5h11a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5zM17 20.2071c0 .4455.5386.6685.8536.3536L21.4142 17A2 2 0 0 0 22 15.5858l-.0021-10.9625c0-.4454-.5386-.6684-.8535-.3535l-3.998 3.998A.5.5 0 0 0 17 8.6213z"
    />
  </svg>
);

export const Cube04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 2.5857 3.4393 6.1463c-.315.315-.0919.8536.3536.8536H7zM9 6.9999V2l10.3767.002c.4454 0 .6684.5386.3535.8535l-3.998 3.998a.5.5 0 0 1-.3535.1464zM7 8.9999H2.5a.5.5 0 0 0-.5.5l.002 9.8767c.0001.4454.5386.6684.8536.3535l3.998-3.998A.5.5 0 0 0 7 15.3786zM4.2698 21.1443c-.315.3149-.092.8535.3535.8536l9.8767.002a.5.5 0 0 0 .5-.5v-4.5H8.6213a.5.5 0 0 0-.3535.1464zM15 14.9999H9.5a.5.5 0 0 1-.5-.5v-5.5h5.5a.5.5 0 0 1 .5.5zM17 16.9999v3.2071c0 .4454.5386.6685.8536.3535l2.7071-2.7071c.3149-.3149.0919-.8535-.3536-.8535zM21.9998 14.4998a.5.5 0 0 1-.5.5001H17V8.6212a.5.5 0 0 1 .1464-.3535l3.998-3.998c.3149-.315.8535-.092.8535.3535z"
    />
  </svg>
);

export const CubeOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.4029 1.185a2 2 0 0 0-.8058 0c-.3073.0632-.5819.217-.8003.3394l-.0595.0332-1.473.8183c-.4827.2682-.6567.877-.3885 1.3598.2683.4828.877.6568 1.3598.3885l1.473-.8183c.1516-.0842.2289-.1267.2866-.1545L12 3.149l.0048.0023c.0577.0278.135.0703.2866.1545l1.473.8183c.4827.2683 1.0915.0943 1.3598-.3885s.0942-1.0916-.3886-1.3598l-1.4729-.8183-.0595-.0332c-.2184-.1223-.493-.2762-.8003-.3394M19.2356 4.876c-.4827-.2683-1.0915-.0943-1.3598.3884s-.0942 1.0916.3886 1.3598L18.9408 7l-.6764.3758c-.4828.2682-.6567.877-.3885 1.3598s.877.6567 1.3598.3885L20 8.6995V9.5c0 .5523.4477 1 1 1s1-.4477 1-1V7.9415l.0002-.0721c.0006-.1828.0014-.3981-.0325-.6172a.996.996 0 0 0-.0935-.7379.997.997 0 0 0-.6249-.4828c-.1749-.136-.3635-.2398-.5235-.3279l-.0631-.0349zM5.7357 6.6242c.4827-.2682.6567-.877.3885-1.3598-.2683-.4827-.877-.6567-1.3598-.3885l-1.427.7928-.0632.0349c-.16.0881-.3486.192-.5235.328a.997.997 0 0 0-.6248.4827.997.997 0 0 0-.0936.7376c-.034.2192-.0331.4347-.0325.6175L2 7.9415v1.5586c0 .5523.4477 1 1 1s1-.4477 1-1v-.8007l.7644.4247c.4828.2682 1.0916.0943 1.3598-.3885s.0943-1.0916-.3885-1.3598L5.0593 7zM4 14.5001c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.5585l-.0002.0722c-.001.2638-.0022.5956.1012.9083.0893.2704.2353.5185.4283.7279.2231.2422.5137.4022.7449.5296l.0631.0348 1.427.7928c.4828.2683 1.0916.0943 1.3599-.3885.2682-.4828.0942-1.0916-.3886-1.3598l-1.427-.7928c-.16-.0888-.2416-.1347-.2989-.1712l-.0048-.0031-.0004-.0057C4.0005 16.3353 4 16.2416 4 16.0586zM22 14.5001c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.5585c0 .183-.0004.2767-.0045.3445l-.0004.0057-.0048.0031c-.0573.0365-.139.0824-.2989.1712l-1.427.7928c-.4828.2682-.6568.877-.3886 1.3598s.8771.6568 1.3598.3885l1.4271-.7928.0631-.0348c.2311-.1273.5218-.2874.7449-.5296.193-.2094.339-.4575.4283-.7279.1034-.3127.1021-.6445.1012-.9083L22 16.0586zM10.2356 19.8759c-.4827-.2682-1.0915-.0942-1.3597.3885s-.0943 1.0916.3885 1.3598l1.4729.8184.0595.0332c.1504.0842.3275.1834.5236.2577a.997.997 0 0 0 .6797.2664.997.997 0 0 0 .6797-.2665c.196-.0742.373-.1734.5234-.2576l.0595-.0332 1.4729-.8184c.4828-.2682.6568-.877.3886-1.3598s-.8771-.6567-1.3598-.3885l-.7643.4246v-.8006c0-.5522-.4478-1-1-1s-1 .4478-1 1v.8007zM10.2357 9.8758c-.4828-.2682-1.0916-.0943-1.3598.3885s-.0943 1.0916.3885 1.3598l1.7357.9642v1.9116c0 .5523.4477 1 1 1s1-.4477 1-1v-1.9116l1.7356-.9642c.4828-.2682.6567-.877.3885-1.3598s-.877-.6567-1.3598-.3885l-1.7643.9802z"
    />
  </svg>
);

export const Dice1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M12 10.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Dice2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M15.5 7c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5S17 9.3284 17 8.5 16.3284 7 15.5 7m-7 7c-.8284 0-1.5.6716-1.5 1.5S7.6716 17 8.5 17s1.5-.6716 1.5-1.5S9.3284 14 8.5 14"
      clipRule="evenodd"
    />
  </svg>
);

export const Dice4 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M6 7.5C6 6.6716 6.6716 6 7.5 6S9 6.6716 9 7.5 8.3284 9 7.5 9 6 8.3284 6 7.5M16.5 6c-.8284 0-1.5.6716-1.5 1.5S15.6716 9 16.5 9 18 8.3284 18 7.5 17.3284 6 16.5 6m0 9c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m-9 0c-.8284 0-1.5.6716-1.5 1.5S6.6716 18 7.5 18 9 17.3284 9 16.5 8.3284 15 7.5 15"
      clipRule="evenodd"
    />
  </svg>
);

export const Dice3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M15 7.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5S17.3284 9 16.5 9 15 8.3284 15 7.5M10.5 12c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5m-3 3c-.8284 0-1.5.6716-1.5 1.5S6.6716 18 7.5 18 9 17.3284 9 16.5 8.3284 15 7.5 15"
      clipRule="evenodd"
    />
  </svg>
);

export const Dice5 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M15 7.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5S17.3284 9 16.5 9 15 8.3284 15 7.5M10.5 12c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5m-3 3c-.8284 0-1.5.6716-1.5 1.5S6.6716 18 7.5 18 9 17.3284 9 16.5 8.3284 15 7.5 15m9 0c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5M9 7.5C9 6.6716 8.3284 6 7.5 6S6 6.6716 6 7.5 6.6716 9 7.5 9 9 8.3284 9 7.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Dice6 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M7.5 8C8.3284 8 9 7.3284 9 6.5S8.3284 5 7.5 5 6 5.6716 6 6.5 6.6716 8 7.5 8m9 0c.8284 0 1.5-.6716 1.5-1.5S17.3284 5 16.5 5 15 5.6716 15 6.5 15.6716 8 16.5 8M9 17.5c0 .8284-.6716 1.5-1.5 1.5S6 18.3284 6 17.5 6.6716 16 7.5 16s1.5.6716 1.5 1.5m7.5 1.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5M9 12c0 .8284-.6716 1.5-1.5 1.5S6 12.8284 6 12s.6716-1.5 1.5-1.5S9 11.1716 9 12m7.5 1.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Hexagon01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.5971 1.185a2 2 0 0 1 .8058 0c.3073.0632.5819.217.8003.3394q.0304.017.0595.0332l7.4 4.1111q.0307.017.0631.0349c.2311.1273.5218.2874.7449.5296.193.2093.339.4575.4283.7279.1033.3126.1021.6444.1012.9083L22 7.9415v8.1171l.0002.0722c.0009.2638.0021.5956-.1012.9083a2 2 0 0 1-.4283.7279c-.2231.2422-.5138.4023-.7449.5296l-.0631.0348-7.4 4.1112-.0595.0332c-.2184.1223-.493.2761-.8003.3393a2 2 0 0 1-.8058 0c-.3073-.0632-.5819-.217-.8003-.3393l-.0595-.0332-7.4-4.1112-.0631-.0348c-.2311-.1273-.5217-.2874-.745-.5296a2 2 0 0 1-.4282-.7279c-.1034-.3127-.1021-.6445-.1012-.9083L2 16.0586v-8.117q0-.0352-.0002-.0722c-.001-.2639-.0022-.5956.1012-.9083a2 2 0 0 1 .4283-.728c.2231-.2421.5138-.4022.7449-.5295q.0324-.0178.0631-.0349l7.4-4.111.0595-.0333c.2184-.1223.493-.2762.8003-.3394"
      clipRule="evenodd"
    />
  </svg>
);

export const Hexagon02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m7.9414 1.9999-.0721-.0002c-.2639-.001-.5957-.0022-.9084.1011a2 2 0 0 0-.7279.4284c-.2421.2231-.4022.5137-.5295.7449l-.0349.0631-4.1111 7.4-.0333.0595c-.1222.2184-.276.493-.3393.8003a2 2 0 0 0 0 .8058c.0632.3073.217.5819.3393.8002l.0333.0596 4.1111 7.4.0349.0631c.1273.2311.2874.5217.5295.7449.2094.193.4576.339.728.4283.3126.1033.6444.1021.9083.1012l.0721-.0002h8.1171l.0721.0002c.2639.0009.5957.0021.9084-.1012a2 2 0 0 0 .7279-.4283c.2422-.2232.4022-.5138.5295-.7449l.0349-.0632 4.1111-7.3999.0333-.0596c.1223-.2183.2761-.4929.3393-.8002a2 2 0 0 0 0-.8058c-.0632-.3073-.217-.5819-.3393-.8003l-.0333-.0595-4.1111-7.4-.0348-.0631c-.1274-.2311-.2874-.5218-.5296-.745a2 2 0 0 0-.7279-.4283c-.3127-.1033-.6445-.102-.9084-.1011l-.0721.0002z"
    />
  </svg>
);

export const Octagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m8.5227 1-.051-.0001c-.19-.0006-.4291-.0012-.6644.0553a2 2 0 0 0-.5781.2395c-.2064.1264-.375.296-.509.4306l-.036.0362-4.9227 4.9227-.0362.036c-.1346.134-.3042.3026-.4306.509a2 2 0 0 0-.2395.578c-.0565.2354-.0559.4745-.0553.6645v7.0565c-.0006.19-.0012.4291.0553.6644a2 2 0 0 0 .2395.5781c.1264.2064.296.375.4306.509l.0362.036 4.9227 4.9227.036.0362c.134.1346.3026.3042.509.4306.179.1097.374.1905.578.2395.2354.0565.4745.0558.6645.0553l.051-.0001h6.9545l.051.0001c.1899.0005.4291.0012.6644-.0553a2 2 0 0 0 .5781-.2395c.2064-.1264.375-.296.509-.4306l.036-.0362 4.9227-4.9227.0362-.036c.1346-.134.3042-.3026.4306-.509a2 2 0 0 0 .2395-.5781c.0565-.2353.0558-.4745.0553-.6644l-.0001-.051V8.5227L23 8.4717c.0005-.19.0012-.4291-.0553-.6644a2 2 0 0 0-.2395-.5781c-.1264-.2064-.296-.375-.4306-.509l-.0362-.036-4.9227-4.9227-.036-.0362c-.134-.1346-.3026-.3042-.509-.4306a2 2 0 0 0-.5781-.2395C15.9573.9987 15.7182.9993 15.5282 1H8.5227"
    />
  </svg>
);

export const Pentagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.497 1.5483a2 2 0 0 0-.9939 0c-.3781.097-.7012.3336-.9587.5222l-.0715.0522-8.1186 5.892-.072.0518c-.2595.1867-.5852.421-.7947.751a2 2 0 0 0-.3077.9466c-.0246.3902.1012.7711.2014 1.0747l.0277.0843 3.1003 9.5312.0271.0843c.0975.3042.2198.6857.4688.9866a2 2 0 0 0 .8047.5844c.3632.1438.7638.142 1.0832.1407l.0887-.0003h10.0365l.0886.0003c.3194.0013.7201.0031 1.0832-.1407.3132-.1239.59-.3249.8047-.5844.249-.3009.3713-.6824.4688-.9866l.0272-.0843 3.1003-9.5312.0277-.0843c.1002-.3036.2259-.6845.2014-1.0747a2 2 0 0 0-.3077-.9466c-.2096-.33-.5352-.5643-.7948-.751l-.072-.0519-8.1185-5.8919-.0716-.0522c-.2575-.1886-.5805-.4252-.9586-.5222"
    />
  </svg>
);

export const Square = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.2413 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 22 6.9537 22 7.7587 22h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 17.7106 22 17.0463 22 16.2413V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 2 17.0463 2 16.2413 2"
    />
  </svg>
);

export const Star01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.6456 1.7757a1.5 1.5 0 0 0-1.2911 0c-.3531.1683-.5477.4605-.6458.6208-.1015.1658-.2057.377-.3072.5827L8.2458 7.3465l-4.822.7048c-.227.0331-.46.0671-.6489.1125-.1828.044-.5207.139-.7896.4229a1.5 1.5 0 0 0-.3982 1.228c.0512.3876.269.6629.3913.8057.1263.1476.295.3118.4593.4719l3.4878 3.3971-.823 4.7983c-.0388.2262-.0787.4583-.094.6521-.0149.1874-.0292.5383.1575.882.216.3976.5998.6765 1.0447.7589.3846.0713.7139-.0508.8875-.1228.1796-.0745.388-.1842.5912-.2911L12 18.8999l4.3107 2.2669c.2032.1069.4116.2166.5911.2911.1737.072.5029.1941.8875.1228a1.5 1.5 0 0 0 1.0447-.7589c.1867-.3437.1724-.6946.1576-.882-.0154-.1938-.0552-.4259-.0941-.6521l-.823-4.7983 3.4879-3.3972c.1643-.16.333-.3242.4593-.4718.1222-.1428.34-.4181.3912-.8057a1.5 1.5 0 0 0-.3982-1.228c-.2689-.2839-.6068-.379-.7895-.4229-.189-.0454-.4219-.0794-.6489-.1125l-4.822-.7048-2.1557-4.3672c-.1015-.2058-.2057-.417-.3072-.5828-.0982-.1603-.2928-.4525-.6458-.6208"
    />
  </svg>
);

export const Star02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.6113 1.6336a1.5 1.5 0 0 0-1.2225 0c-.3266.1458-.5208.3951-.6258.5443-.1024.1457-.2081.3296-.3073.5023L8.542 6.0104l-3.8408-.0077c-.1993-.0005-.4113-.001-.5887.015-.1817.0162-.4947.0597-.7843.2697a1.5 1.5 0 0 0-.6112 1.0587c-.0372.3558.0817.6486.1585.8141.0749.1616.1813.345.2813.5173l1.9272 3.3224-1.9272 3.3224c-.1.1723-.2064.3557-.2813.5173-.0768.1655-.1957.4583-.1585.8141a1.5 1.5 0 0 0 .6112 1.0587c.2896.21.6026.2535.7843.2698.1774.0159.3894.0154.5886.015l3.841-.0078 1.9136 3.3301c.0992.1728.2049.3567.3073.5024.105.1492.2992.3985.6258.5443a1.5 1.5 0 0 0 1.2225 0c.3267-.1458.5208-.3951.6258-.5443.1024-.1457.2081-.3296.3073-.5024l1.9137-3.3301 3.8409.0078c.1992.0004.4113.0009.5886-.015.1817-.0163.4947-.0598.7843-.2698a1.5 1.5 0 0 0 .6112-1.0587c.0371-.3558-.0817-.6486-.1585-.8141-.0749-.1616-.1813-.345-.2813-.5173l-1.9272-3.3224 1.9272-3.3224c.1-.1723.2064-.3558.2813-.5173.0768-.1655.1956-.4583.1585-.8141a1.5 1.5 0 0 0-.6112-1.0587c-.2896-.21-.6026-.2535-.7843-.2698-.1774-.0159-.3894-.0154-.5886-.015l-3.8409.0078-1.9137-3.3301c-.0992-.1728-.2049-.3567-.3073-.5024-.105-.1492-.2991-.3985-.6258-.5443"
    />
  </svg>
);

export const Star03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.6344 1.7252a1.5 1.5 0 0 0-1.2687 0c-.3442.1606-.539.438-.6396.5949-.1019.1588-.2067.3605-.3075.5547L8.9588 5.6847l-3.107-.6106c-.2147-.0422-.4377-.0861-.6254-.1055-.1854-.0191-.5238-.0398-.864.1292a1.5 1.5 0 0 0-.791.992c-.089.3691.0064.6944.0663.8709.0607.1787.1531.3864.242.5863l1.2867 2.8932-2.4145 2.0484c-.167.1416-.3403.2886-.4725.4233-.1305.133-.3576.3846-.4376.7559a1.5 1.5 0 0 0 .2823 1.2369c.2332.2998.547.428.7223.4912.1775.064.3975.1213.6093.1764l3.0642.7979.096 3.165c.0067.2187.0135.4459.0364.6332.0226.185.0778.5195.3182.8135a1.5 1.5 0 0 0 1.143.5505c.3798.0046.6757-.1608.8344-.2585.1608-.0989.3426-.2352.5177-.3663l2.5345-1.8983 2.5343 1.8982c.1751.1312.357.2675.5178.3664.1587.0977.4546.2631.8343.2585a1.5 1.5 0 0 0 1.1431-.5505c.2404-.294.2956-.6285.3182-.8135.0229-.1873.0297-.4145.0363-.6332l.0961-3.165 3.0643-.7979c.2117-.0551.4317-.1124.6092-.1764.1753-.0632.4891-.1914.7223-.4912a1.5 1.5 0 0 0 .2823-1.2369c-.08-.3713-.3071-.6229-.4376-.7559-.1322-.1347-.3056-.2817-.4724-.4232l-2.4146-2.0485 1.2866-2.8932c.089-.1999.1814-.4076.2421-.5863.0599-.1765.1553-.5018.0663-.871a1.5 1.5 0 0 0-.7911-.992c-.3401-.1688-.6785-.1482-.8638-.129-.1878.0193-.4108.0632-.6255.1054l-3.107.6106-1.4598-2.8099c-.1008-.1942-.2056-.3959-.3075-.5547-.1006-.1569-.2954-.4343-.6396-.5949"
    />
  </svg>
);

export const Star04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.9333 1.641a.9999.9999 0 0 0-1.8666 0l-2.012 5.2311c-.3004.781-.3948 1.0061-.524 1.1877a2 2 0 0 1-.4709.471c-.1816.1291-.4066.2235-1.1877.5239l-5.231 2.012a.9999.9999 0 0 0 0 1.8666l5.231 2.012c.781.3004 1.0061.3948 1.1877.5239a2 2 0 0 1 .471.471c.1291.1816.2235.4067.5239 1.1877l2.012 5.2311a.9998.9998 0 0 0 1.8666 0l2.012-5.2311c.3004-.781.3948-1.0061.5239-1.1877a2 2 0 0 1 .471-.471c.1816-.1291.4067-.2235 1.1877-.5239l5.2311-2.012a.9998.9998 0 0 0 0-1.8666l-5.2311-2.012c-.781-.3004-1.0061-.3948-1.1877-.524a2 2 0 0 1-.471-.4709c-.1291-.1816-.2235-.4066-.5239-1.1877z"
    />
  </svg>
);

export const Star05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.9701 1.7575a1 1 0 0 0-1.9402 0l-1.3015 5.206c-.271 1.084-.3623 1.3979-.5176 1.6406a2 2 0 0 1-.6067.6067c-.2427.1553-.5566.2466-1.6406.5176l-5.206 1.3015a.9998.9998 0 0 0 0 1.9402l5.206 1.3015c1.084.271 1.3979.3623 1.6406.5176.2437.156.4507.363.6067.6067.1553.2427.2466.5566.5176 1.6406l1.3015 5.206a1 1 0 0 0 1.9402 0l1.3015-5.206c.271-1.084.3623-1.3979.5176-1.6406.156-.2437.363-.4507.6067-.6067.2427-.1553.5566-.2466 1.6406-.5176l5.206-1.3015a.9998.9998 0 0 0 0-1.9402l-5.206-1.3015c-1.084-.271-1.3979-.3623-1.6406-.5176a2 2 0 0 1-.6067-.6067c-.1553-.2427-.2466-.5566-.5176-1.6406z"
    />
  </svg>
);

export const Star06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.5 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.5H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5V7c0 .5523.4477 1 1 1s1-.4477 1-1V5.5H7c.5523 0 1-.4477 1-1s-.4477-1-1-1H5.5zM5.5 17c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.5H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5V22c0 .5523.4477 1 1 1s1-.4477 1-1v-1.5H7c.5523 0 1-.4477 1-1s-.4477-1-1-1H5.5zM13.9333 2.641a.9999.9999 0 0 0-1.8666 0L10.3325 7.15c-.3004.781-.3948 1.0061-.524 1.1877a2 2 0 0 1-.471.471c-.1815.129-.4066.2235-1.1876.5239L3.641 11.0667a.9999.9999 0 0 0 0 1.8666L8.15 14.6675c.781.3004 1.0061.3948 1.1877.5239a2 2 0 0 1 .471.471c.129.1816.2235.4067.5239 1.1877l1.7342 4.5089a.9998.9998 0 0 0 1.8666 0l1.7342-4.5089c.3004-.781.3948-1.0061.5239-1.1877a2 2 0 0 1 .471-.471c.1816-.1291.4067-.2235 1.1877-.5239l4.5089-1.7342a.9998.9998 0 0 0 0-1.8666l-4.5089-1.7342c-.781-.3004-1.0061-.3948-1.1877-.524a2 2 0 0 1-.471-.471c-.1291-.1815-.2235-.4066-.5239-1.1876z"
    />
  </svg>
);

export const Star07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.5523.4477-1 1-1M5.6358 4.2219c-.3905-.3906-1.0237-.3906-1.4142 0s-.3905 1.0236 0 1.4142l1.4142 1.4142c.3905.3905 1.0237.3905 1.4142 0 .3906-.3906.3906-1.0237 0-1.4142zM1 12c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1M20 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1zM18.3638 16.9496c-.3905-.3905-1.0236-.3905-1.4142 0s-.3905 1.0237 0 1.4142l1.4142 1.4143c.3906.3905 1.0237.3905 1.4143 0s.3905-1.0237 0-1.4143zM19.7781 5.636c.3905-.3905.3905-1.0236 0-1.4142s-1.0237-.3905-1.4143 0l-1.4142 1.4143c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM12 19c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1M7.05 18.3638c.3906-.3905.3906-1.0236 0-1.4142s-1.0237-.3905-1.4142 0l-1.4142 1.4142c-.3905.3906-.3905 1.0237 0 1.4143s1.0237.3905 1.4142 0zM12.8967 6.5574a1 1 0 0 0-1.7934 0l-1.3125 2.659-2.9354.4291a1 1 0 0 0-.5531 1.7059l2.1232 2.068-.501 2.9216a1.0001 1.0001 0 0 0 1.451 1.0541L12 16.0148l2.6246 1.3803a1 1 0 0 0 1.451-1.0541l-.501-2.9216 2.1232-2.068a1 1 0 0 0-.5531-1.7059l-2.9354-.429z"
    />
  </svg>
);

export const Triangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.8126 1.6684a2 2 0 0 0-1.6252 0c-.3996.1776-.6591.4905-.8397.7455-.1776.2507-.3677.5791-.5767.9403L1.5038 17.634c-.2099.3625-.4006.6919-.53.9715-.1314.2841-.274.666-.2286 1.102a2 2 0 0 0 .813 1.4102c.3546.2577.7566.3257 1.0683.3543.3068.0281.6874.0281 1.1063.0281h16.5343c.4189 0 .7996 0 1.1063-.0281.3118-.0286.7138-.0966 1.0683-.3543a2 2 0 0 0 .813-1.4102c.0455-.436-.0971-.8179-.2286-1.102-.1293-.2796-.3201-.6091-.53-.9716L14.229 3.3542c-.2091-.3612-.3992-.6896-.5768-.9403-.1806-.255-.4401-.5679-.8396-.7455"
    />
  </svg>
);

export const FaceContent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m-1.2246 8.8715c.3488-.4282.2843-1.058-.1439-1.4069-.4282-.3487-1.058-.2843-1.4069.144C8.9948 8.8907 8.7272 9 8.5 9c-.2171 0-.4788-.101-.7363-.4056-.3565-.4217-.9875-.4746-1.4093-.118-.4217.3565-.4746.9874-.118 1.4092C6.7987 10.551 7.5871 11 8.5 11c.9029 0 1.7153-.4407 2.2754-1.1285m6.8561-1.4069c.4282.3488.4927.9787.1439 1.407C17.2153 10.5592 16.4029 11 15.5 11c-.9128 0-1.7012-.449-2.2637-1.1144-.3565-.4218-.3036-1.0527.1181-1.4093.4218-.3565 1.0528-.3036 1.4093.1181.2575.3047.5192.4056.7363.4056.2272 0 .4948-.1092.7246-.3915.3488-.4282.9787-.4926 1.4069-.1439M8.7969 13.396c-.3322-.4383-.9564-.5262-1.3969-.1959-.4418.3314-.5314.9582-.2 1.4q.0504.0655.1034.1288a5.6 5.6 0 0 0 .248.2756c.2122.2213.522.5128.923.8044C9.2723 16.3891 10.4744 17 12 17c1.5256 0 2.7278-.6109 3.5257-1.1912a6.95 6.95 0 0 0 .9229-.8044 5.7 5.7 0 0 0 .2481-.2756L16.8 14.6c.3314-.4418.2419-1.0686-.2-1.4-.4404-.3303-1.0647-.2424-1.3968.1959l-.0047.0059a2 2 0 0 1-.0338.0413 3.7 3.7 0 0 1-.1601.1775 4.95 4.95 0 0 1-.6553.5707C13.7723 14.611 12.9745 15 12 15s-1.7722-.389-2.3493-.8087a4.95 4.95 0 0 1-.6553-.5707 3.7 3.7 0 0 1-.16-.1775 2 2 0 0 1-.0339-.0413z"
      clipRule="evenodd"
    />
  </svg>
);

export const FaceFrown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M7.5 9c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6715 1.5-1.5 1.5S7.5 9.8284 7.5 9m6 0c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6715 1.5-1.5 1.5-1.5-.6716-1.5-1.5m-6.1 7.7999c.4405.3303 1.0647.2424 1.397-.1958l.0046-.006a2 2 0 0 1 .0338-.0413 3.7 3.7 0 0 1 .16-.1775 4.95 4.95 0 0 1 .6553-.5707c.5771-.4196 1.3749-.8087 2.3494-.8087.9744 0 1.7722.3891 2.3493.8087.2866.2085.5079.417.6552.5707.0733.0764.127.138.1601.1775q.0249.0299.0339.0413l.0046.006c.3322.4382.9564.5261 1.3969.1958.4418-.3314.5313-.9582.2-1.4l-.1034-.1288a5.6 5.6 0 0 0-.2481-.2756 6.94 6.94 0 0 0-.9229-.8043c-.7979-.5803-2.0001-1.1913-3.5256-1.1913-1.5256 0-2.7278.611-3.5257 1.1913a6.94 6.94 0 0 0-.9229.8043 5.7 5.7 0 0 0-.248.2756 4 4 0 0 0-.1034.1288c-.3314.4418-.2419 1.0686.2 1.4"
      clipRule="evenodd"
    />
  </svg>
);

export const FaceHappy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.4466 15.6021c-.2378-.1952-.4269-.3997-.5715-.6021h6.2498c-.1446.2024-.3337.4069-.5715.6021-.6428.5273-1.546.8979-2.5534.8979s-1.9106-.3706-2.5534-.8979"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11-4.9249 11-11 11S1 18.0751 1 12m8-4.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5S9.8284 7.5 9 7.5m6 0c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5M7.5 13c-.5523 0-1 .4477-1 1 0 1.2245.7156 2.3585 1.678 3.1482C9.16 17.9541 10.5069 18.5 12 18.5s2.8399-.5459 3.822-1.3518C16.7844 16.3585 17.5 15.2245 17.5 14c0-.5523-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const FaceNeutral = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m1.5 8c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5M7 15c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1m.5-6c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5S7.5 9.8284 7.5 9"
      clipRule="evenodd"
    />
  </svg>
);

export const FaceSad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m-1.3685 7.4646c.4282.3488.4927.9787.1439 1.407C10.2153 10.5592 9.4029 11 8.5 11c-.9128 0-1.7012-.449-2.2637-1.1144-.3565-.4218-.3036-1.0527.1181-1.4093.4218-.3565 1.0528-.3036 1.4093.1181C8.0212 8.8991 8.283 9 8.5 9c.2272 0 .4948-.1092.7246-.3915.3488-.4282.9787-.4926 1.4069-.1439m7 0c.4282.3488.4927.9787.1439 1.407C17.2153 10.5592 16.4029 11 15.5 11c-.9128 0-1.7012-.449-2.2637-1.1144-.3565-.4218-.3036-1.0527.1181-1.4093.4218-.3565 1.0528-.3036 1.4093.1181.2575.3047.5192.4056.7363.4056.2272 0 .4948-.1092.7246-.3915.3488-.4282.9787-.4926 1.4069-.1439M7.4001 16.8c.4404.3304 1.0647.2424 1.3968-.1958l.0047-.0059a2 2 0 0 1 .0338-.0413 3.7 3.7 0 0 1 .1601-.1776 4.95 4.95 0 0 1 .6553-.5706C10.2278 15.3891 11.0256 15 12 15s1.7722.3891 2.3493.8088c.2866.2084.508.4169.6553.5706a3.8 3.8 0 0 1 .1601.1776q.0248.0297.0338.0413l.0046.0059c.3322.4382.9564.5262 1.3969.1958.4418-.3313.5314-.9581.2-1.4l-.1034-.1288a5.6 5.6 0 0 0-.2481-.2756 6.94 6.94 0 0 0-.9228-.8043C14.7278 13.611 13.5256 13 12.0001 13s-2.7278.611-3.5257 1.1913a6.94 6.94 0 0 0-.9229.8043 5.7 5.7 0 0 0-.248.2756A4 4 0 0 0 7.2 15.4c-.3314.4419-.2419 1.0687.2 1.4"
      clipRule="evenodd"
    />
  </svg>
);

export const FaceSmile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M7.5 9c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5S7.5 9.8284 7.5 9m6 0c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5m-6.1 4.2001c.4405-.3304 1.0647-.2424 1.397.1958l.0046.0059a2 2 0 0 0 .0338.0413c.0331.0395.0869.1011.16.1776.1474.1537.3687.3622.6553.5706.5771.4197 1.3749.8088 2.3494.8088.9744 0 1.7722-.3891 2.3493-.8088a4.95 4.95 0 0 0 .6552-.5706 3.6 3.6 0 0 0 .1601-.1776 2 2 0 0 0 .0339-.0413l.0046-.0059c.3322-.4382.9564-.5262 1.3969-.1958.4418.3313.5313.9581.2 1.4l-.1034.1288a5.7 5.7 0 0 1-.2481.2756 6.95 6.95 0 0 1-.9229.8043c-.7979.5803-2.0001 1.1913-3.5256 1.1913-1.5256 0-2.7278-.611-3.5257-1.1913a6.95 6.95 0 0 1-.9229-.8043 5.7 5.7 0 0 1-.248-.2756 4 4 0 0 1-.1034-.1288c-.3314-.4419-.2419-1.0687.2-1.4"
      clipRule="evenodd"
    />
  </svg>
);

export const FaceWink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m1.5 8c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5M7 9c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1m.4 4.2001c.4405-.3304 1.0647-.2424 1.397.1958l.0046.0059a2 2 0 0 0 .0338.0413c.0331.0395.0869.1011.16.1776.1474.1537.3687.3622.6553.5706.5771.4197 1.3749.8088 2.3494.8088.9744 0 1.7722-.3891 2.3493-.8088a4.95 4.95 0 0 0 .6552-.5706 3.6 3.6 0 0 0 .1601-.1776 2 2 0 0 0 .0339-.0413l.0046-.0059c.3322-.4382.9564-.5262 1.3969-.1958.4418.3313.5313.9581.2 1.4l-.1034.1288a5.7 5.7 0 0 1-.2481.2756 6.95 6.95 0 0 1-.9229.8043c-.7979.5803-2.0001 1.1913-3.5256 1.1913-1.5256 0-2.7278-.611-3.5257-1.1913a6.95 6.95 0 0 1-.9229-.8043 5.7 5.7 0 0 1-.248-.2756 4 4 0 0 1-.1034-.1288c-.3314-.4419-.2419-1.0687.2-1.4"
      clipRule="evenodd"
    />
  </svg>
);

export const User01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.786 14.5q3.214.0008 6.4279 0c.7267-.0002 1.2219-.0003 1.6543.076 2.0701.365 3.6908 1.9857 4.0558 4.0558.0762.4324.0761.9275.076 1.6542-.0001.1584.0048.3178-.0228.4745a1.5 1.5 0 0 1-1.2168 1.2167c-.1361.024-.2796.0233-.351.0229a1381 1381 0 0 0-14.819 0c-.0713.0004-.2147.0011-.351-.0229a1.5 1.5 0 0 1-1.2167-1.2167C2.9951 20.6038 3 20.4444 3 20.286c-.0001-.7267-.0002-1.2218.076-1.6542.365-2.0701 1.9858-3.6908 4.0558-4.0558.4324-.0763.9276-.0762 1.6543-.076M6.5 7.5C6.5 4.4624 8.9624 2 12 2s5.5 2.4624 5.5 5.5S15.0375 13 12 13s-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const User02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.4181 18.3031C5.3911 15.692 8.4988 14 12 14s6.6089 1.692 8.5818 4.3031l.0269.0355c.1696.2244.3515.4649.4815.697.1573.2809.274.6058.2667 1.001-.0058.3176-.102.615-.2189.8498s-.2961.4908-.546.687c-.3334.2616-.6963.3542-1.0187.3928-.2828.0339-.618.0339-.955.0338H5.3816c-.337.0001-.6721.0001-.955-.0338-.3224-.0386-.6853-.1312-1.0186-.3928-.25-.1962-.4292-.4522-.546-.687-.117-.2348-.2132-.5322-.219-.8498-.0072-.3952.1094-.7201.2667-1.001.13-.2321.312-.4726.4815-.697zM6.5 7.5C6.5 4.4624 8.9624 2 12 2s5.5 2.4624 5.5 5.5S15.0375 13 12 13s-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Users03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.1064 15.388c.2479-.4935.8489-.6926 1.3425-.4447 1.6344.8211 3.016 2.1282 4.0159 3.7389.1515.244.372.5699.4404 1.0115.0733.4728-.055.9249-.2462 1.2687s-.5077.6912-.948.8783c-.4187.1779-.8741.1593-1.211.1593-.5523 0-1-.4477-1-1s.4477-1 1-1c.2152 0 .3283-.0006.4091-.0061l.0021-.0037c.0191-.0344-.1262-.2219-.1456-.2532-.8223-1.3246-1.9372-2.3648-3.2145-3.0065-.4935-.2479-.6926-.849-.4447-1.3425M15.1045 3.0227c.2457-.4945.8459-.6962 1.3405-.4504C18.2536 3.471 19.5 5.339 19.5 7.5s-1.2464 4.029-3.055 4.9278c-.4946.2457-1.0948.0441-1.3405-.4505s-.0441-1.0948.4504-1.3406C16.7098 10.0628 17.5 8.8727 17.5 7.5c0-1.3728-.7902-2.5628-1.9451-3.1367-.4945-.2458-.6962-.846-.4504-1.3406"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 7.5C4 4.4624 6.4624 2 9.5 2S15 4.4624 15 7.5 12.5375 13 9.5 13 4 10.5376 4 7.5M9.5 14c3.1962 0 6.0535 1.8041 7.7971 4.4201.1536.2305.3174.4763.4319.7099.1379.2811.2369.6041.2137.9898-.0184.3077-.1205.5931-.2418.8197-.1214.2266-.3023.4698-.5482.6557-.3293.249-.6842.3363-.9979.3728-.2762.0321-.6034.0321-.9329.032-3.8131-.0007-7.6292-.0007-11.4439 0-.3295.0001-.6566.0001-.9329-.032-.3137-.0365-.6686-.1238-.9979-.3728-.2458-.1859-.4268-.4291-.5481-.6557s-.2234-.512-.2419-.8197c-.0232-.3857.0758-.7087.2137-.9898.1145-.2336.2783-.4794.432-.7099C3.4463 15.8041 6.3036 14 9.4998 14"
      clipRule="evenodd"
    />
  </svg>
);

export const User03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.2724 19.314C4.7783 16.6562 8.2052 15 12 15s7.2218 1.6562 9.7276 4.314A1 1 0 0 1 21 21H3a1 1 0 0 1-.7276-1.686M6.5 7.5C6.5 4.4624 8.9625 2 12 2s5.5 2.4624 5.5 5.5S15.0376 13 12 13s-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Users02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.1045 3.0227c.2458-.4945.846-.6962 1.3405-.4504C18.2536 3.471 19.5 5.339 19.5 7.5s-1.2464 4.029-3.055 4.9278c-.4945.2457-1.0947.0441-1.3405-.4505s-.0441-1.0948.4505-1.3406C16.7098 10.0628 17.5 8.8727 17.5 7.5c0-1.3728-.7902-2.5628-1.945-3.1367-.4946-.2458-.6963-.846-.4505-1.3406M17.0889 16.3541c.2277-.5031.8202-.7265 1.3234-.4988 1.6779.7593 3.1618 1.984 4.374 3.5269.3412.4343.2658 1.0629-.1685 1.4041s-1.0629.2658-1.4041-.1685c-1.0427-1.3271-2.281-2.3317-3.626-2.9403-.5031-.2277-.7264-.8202-.4988-1.3234"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 7.5C4 4.4624 6.4624 2 9.5 2S15 4.4624 15 7.5 12.5376 13 9.5 13 4 10.5376 4 7.5M1.2137 19.3822C3.3055 16.7198 6.217 15 9.5 15s6.1946 1.7198 8.2863 4.3822A1 1 0 0 1 17 21H2a1 1 0 0 1-.7863-1.6178"
      clipRule="evenodd"
    />
  </svg>
);

export const UserCheck01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.7072 15.2929c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3906.3905-1.0237.3905-1.4143 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4143 0L18 18.5858l3.2929-3.2929c.3906-.3905 1.0237-.3905 1.4143 0M6.786 14.5c1.4791.0003 2.9582.0006 4.4372 0 .1191-.0001.2614-.0001.3867.0101.1452.0119.3532.0423.5711.1534.2823.1438.5117.3733.6556.6555.111.218.1415.426.1533.5712.0103.1253.0102.2676.0102.3867a5191 5191 0 0 0 0 3.9462c0 .1192.0001.2614-.0102.3867-.0118.1453-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101-2.8774-.001-5.7553-.0153-8.6326.0001-.0714.0004-.2148.0011-.351-.0229a1.5 1.5 0 0 1-1.2168-1.2167c-.024-.1362-.0232-.2796-.0228-.351.0031-.5909-.027-1.1932.076-1.7777.365-2.0701 1.9858-3.6908 4.0558-4.0558.4324-.0763.9276-.0762 1.6543-.076M4.5 7.5C4.5 4.4624 6.9626 2 10.0002 2s5.5 2.4624 5.5 5.5-2.4625 5.5-5.5 5.5-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserCheck02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.707 3.2929c.3906.3905.3906 1.0237 0 1.4142l-4 4c-.3905.3905-1.0236.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0l1.2929 1.2929 3.2929-3.293c.3906-.3904 1.0237-.3904 1.4142 0M6.7586 14h4.4826c.805 0 1.4694 0 2.0106.0442.5621.0459 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4854.3458 1.0021.3917 1.5642.0443.5412.0443 1.2055.0442 2.0105 0 .2827.0129.5691-.0101.8511-.0119.1452-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101q-6.2232-.0023-12.4463 0c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5711-.1534a1.5 1.5 0 0 1-.6556-.6555c-.111-.218-.1415-.426-.1533-.5712-.023-.282-.0102-.5685-.0102-.8511 0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.0021-.3459 1.5642-.3918C5.2893 14 5.9537 14 6.7586 14M4.5 7.5C4.5 5.0147 6.5146 3 9 3c2.4852 0 4.4999 2.0147 4.4999 4.5s-2.0147 4.5-4.5 4.5c-2.4852 0-4.5-2.0147-4.5-4.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 9.5c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M3 12c0-4.9706 4.0294-9 9-9s9 4.0294 9 9c0 2.2211-.8046 4.2543-2.1382 5.824C17.9457 16.7114 16.5564 16 15 16H9c-1.5563 0-2.9456.7114-3.8617 1.8241C3.8046 16.2543 3 14.2211 3 12"
      clipRule="evenodd"
    />
  </svg>
);

export const UserDown01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 15c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3a1 1 0 0 0 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L20 18.5858z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.786 14.5c1.4791.0003 2.9582.0006 4.4372 0 .1191-.0001.2614-.0001.3867.0101.1452.0119.3532.0423.5711.1534.2823.1438.5117.3733.6556.6555.111.218.1415.426.1533.5712.0103.1253.0102.2676.0102.3867a5191 5191 0 0 0 0 3.9462c0 .1192.0001.2614-.0102.3867-.0118.1453-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101-2.8774-.001-5.7553-.0153-8.6326.0001-.0714.0004-.2148.0011-.351-.0229a1.5 1.5 0 0 1-1.2168-1.2167c-.024-.1362-.0232-.2796-.0228-.351.0031-.5909-.027-1.1932.076-1.7777.365-2.0701 1.9858-3.6908 4.0558-4.0558.4324-.0763.9276-.0762 1.6543-.076M4.5 7.5C4.5 4.4624 6.9626 2 10.0002 2s5.5 2.4624 5.5 5.5-2.4625 5.5-5.5 5.5-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserDown02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 4c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5858l-1.2929-1.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143l3 3a1 1 0 0 0 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L20 7.5858z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7586 14h4.4826c.805 0 1.4694 0 2.0106.0442.5621.0459 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4854.3458 1.0021.3917 1.5642.0443.5412.0443 1.2055.0442 2.0105 0 .2827.0129.5691-.0101.8511-.0119.1452-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101q-6.2232-.0023-12.4463 0c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5711-.1534a1.5 1.5 0 0 1-.6556-.6555c-.111-.218-.1415-.426-.1533-.5712-.023-.282-.0102-.5685-.0102-.8511 0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.0021-.3459 1.5642-.3918C5.2893 14 5.9537 14 6.7586 14M4.5 7.5C4.5 5.0147 6.5146 3 9 3c2.4852 0 4.4999 2.0147 4.4999 4.5s-2.0147 4.5-4.5 4.5c-2.4852 0-4.5-2.0147-4.5-4.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.0429 10.0429c1.0809-1.0809 2.8333-1.0809 3.9142 0s1.081 2.8334 0 3.9143c-2.1598 2.1598-4.3233 4.316-6.4795 6.4794-.0851.0855-.1924.1931-.3179.2853a2 2 0 0 1-.3491.2053c-.1415.065-.2877.1065-.4037.1395-1.0446.2965-2.0881.5965-3.1322.8948a.9999.9999 0 0 1-1.2362-1.2362c.2983-1.0441.5983-2.0876.8948-3.1322.033-.116.0745-.2622.1395-.4037a2 2 0 0 1 .2053-.3491c.0922-.1255.1998-.2328.2853-.3179 2.1635-2.1562 4.3197-4.3197 6.4795-6.4795M6.6099 14.5101c.1452.0119.3532.0423.5711.1534.2823.1438.5118.3733.6556.6555.111.218.1414.426.1533.5712.0103.1253.0102.2676.0102.3867a5297 5297 0 0 0 0 3.9462c0 .1192 0 .2614-.0102.3867-.0118.1453-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.218.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101-2.8774-.001-.7553-.0153-3.6326.0001-.0714.0004-.2148.0011-.351-.0229a1.5 1.5 0 0 1-1.2168-1.2167c-.024-.1362-.0232-.2796-.0228-.351.0031-.5909-.027-1.1932.076-1.7777.365-2.0701 1.9858-3.6908 4.0558-4.0558.6468-.1141 1.21-.0878 1.478-.0659M4.5 7.5C4.5 4.4624 6.9626 2 10.0002 2s5.5 2.4624 5.5 5.5-2.4625 5.5-5.5 5.5-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserLeft01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7071 15.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3a1 1 0 0 0 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L18.4142 19H22c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3.5858z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.786 14.5c1.4791.0003 2.9582.0006 4.4372 0 .1191-.0001.2614-.0001.3867.0101.1452.0119.3532.0423.5711.1534.2823.1438.5117.3733.6556.6555.111.218.1415.426.1533.5712.0103.1253.0102.2676.0102.3867a5191 5191 0 0 0 0 3.9462c0 .1192.0001.2614-.0102.3867-.0118.1453-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101-2.8774-.001-5.7553-.0153-8.6326.0001-.0714.0004-.2148.0011-.351-.0229a1.5 1.5 0 0 1-1.2168-1.2167c-.024-.1362-.0232-.2796-.0228-.351.0031-.5909-.027-1.1932.076-1.7777.365-2.0701 1.9858-3.6908 4.0558-4.0558.4324-.0763.9276-.0762 1.6543-.076M4.5 7.5C4.5 4.4624 6.9626 2 10.0002 2s5.5 2.4624 5.5 5.5-2.4625 5.5-5.5 5.5-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserLeft02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7071 3.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3a1 1 0 0 0 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L18.4142 7H22c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3.5858z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7586 14h4.4826c.805 0 1.4694 0 2.0106.0442.5621.0459 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4854.3458 1.0021.3917 1.5642.0443.5412.0443 1.2055.0442 2.0105 0 .2827.0129.5691-.0101.8511-.0119.1452-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101q-6.2232-.0023-12.4463 0c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5711-.1534a1.5 1.5 0 0 1-.6556-.6555c-.111-.218-.1415-.426-.1533-.5712-.023-.282-.0102-.5685-.0102-.8511 0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.0021-.3459 1.5642-.3918C5.2893 14 5.9537 14 6.7586 14M4.5 7.5C4.5 5.0147 6.5146 3 9 3c2.4852 0 4.4999 2.0147 4.4999 4.5s-2.0147 4.5-4.5 4.5c-2.4852 0-4.5-2.0147-4.5-4.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserMinus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 18c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1M6.786 14.5c1.4791.0003 2.9582.0006 4.4372 0 .1191-.0001.2614-.0001.3867.0101.1452.0119.3532.0423.5711.1534.2823.1438.5117.3733.6556.6555.111.218.1415.426.1533.5712.0103.1253.0102.2676.0102.3867a5191 5191 0 0 0 0 3.9462c0 .1192.0001.2614-.0102.3867-.0118.1453-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101-2.8774-.001-5.7553-.0153-8.6326.0001-.0714.0004-.2148.0011-.351-.0229a1.5 1.5 0 0 1-1.2168-1.2167c-.024-.1362-.0232-.2796-.0228-.351.0031-.5909-.027-1.1932.076-1.7777.365-2.0701 1.9858-3.6908 4.0558-4.0558.4324-.0763.9276-.0762 1.6543-.076M4.5 7.5C4.5 4.4624 6.9626 2 10.0002 2s5.5 2.4624 5.5 5.5-2.4625 5.5-5.5 5.5-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserMinus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 7c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1M6.7586 14h4.4826c.805 0 1.4694 0 2.0106.0442.5621.0459 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4854.3458 1.0021.3917 1.5642.0443.5412.0443 1.2055.0442 2.0105 0 .2827.0129.5691-.0101.8511-.0119.1452-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101q-6.2232-.0023-12.4463 0c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5711-.1534a1.5 1.5 0 0 1-.6556-.6555c-.111-.218-.1415-.426-.1533-.5712-.023-.282-.0102-.5685-.0102-.8511 0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.0021-.3459 1.5642-.3918C5.2893 14 5.9537 14 6.7586 14M4.5 7.5C4.5 5.0147 6.5146 3 9 3c2.4852 0 4.4999 2.0147 4.4999 4.5s-2.0147 4.5-4.5 4.5c-2.4852 0-4.5-2.0147-4.5-4.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserPlus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 15c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1v-2h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.786 14.5c1.4791.0003 2.9582.0006 4.4372 0 .1191-.0001.2614-.0001.3867.0101.1452.0119.3532.0423.5711.1534.2823.1438.5117.3733.6556.6555.111.218.1415.426.1533.5712.0103.1253.0102.2676.0102.3867a5191 5191 0 0 0 0 3.9462c0 .1192.0001.2614-.0102.3867-.0118.1453-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101-2.8774-.001-5.7553-.0153-8.6326.0001-.0714.0004-.2148.0011-.351-.0229a1.5 1.5 0 0 1-1.2168-1.2167c-.024-.1362-.0232-.2796-.0228-.351.0031-.5909-.027-1.1932.076-1.7777.365-2.0701 1.9858-3.6908 4.0558-4.0558.4324-.0763.9276-.0762 1.6543-.076M4.5 7.5C4.5 4.4624 6.9626 2 10.0002 2s5.5 2.4624 5.5 5.5-2.4625 5.5-5.5 5.5-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserPlus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 4c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1V8h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7586 14h4.4826c.805 0 1.4694 0 2.0106.0442.5621.0459 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4854.3458 1.0021.3917 1.5642.0443.5412.0443 1.2055.0442 2.0105 0 .2827.0129.5691-.0101.8511-.0119.1452-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101q-6.2232-.0023-12.4463 0c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5711-.1534a1.5 1.5 0 0 1-.6556-.6555c-.111-.218-.1415-.426-.1533-.5712-.023-.282-.0102-.5685-.0102-.8511 0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.0021-.3459 1.5642-.3918C5.2893 14 5.9537 14 6.7586 14M4.5 7.5C4.5 5.0147 6.5146 3 9 3c2.4852 0 4.4999 2.0147 4.4999 4.5s-2.0147 4.5-4.5 4.5c-2.4852 0-4.5-2.0147-4.5-4.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserRight01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7071 14.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L19.5858 17H16c-.5523 0-1 .4477-1 1s.4477 1 1 1h3.5858l-1.2929 1.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3a1 1 0 0 0 0-1.4142z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.786 14.5c1.4791.0003 2.9582.0006 4.4372 0 .1191-.0001.2614-.0001.3867.0101.1452.0119.3532.0423.5711.1534.2823.1438.5117.3733.6556.6555.111.218.1415.426.1533.5712.0103.1253.0102.2676.0102.3867a5191 5191 0 0 0 0 3.9462c0 .1192.0001.2614-.0102.3867-.0118.1453-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101-2.8774-.001-5.7553-.0153-8.6326.0001-.0714.0004-.2148.0011-.351-.0229a1.5 1.5 0 0 1-1.2168-1.2167c-.024-.1362-.0232-.2796-.0228-.351.0031-.5909-.027-1.1932.076-1.7777.365-2.0701 1.9858-3.6908 4.0558-4.0558.4324-.0763.9276-.0762 1.6543-.076M4.5 7.5C4.5 4.4624 6.9626 2 10.0002 2s5.5 2.4624 5.5 5.5-2.4625 5.5-5.5 5.5-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserRight02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L19.5858 5H16c-.5523 0-1 .4477-1 1s.4477 1 1 1h3.5858l-1.2929 1.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3a1 1 0 0 0 0-1.4142z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7586 14h4.4826c.805 0 1.4694 0 2.0106.0442.5621.0459 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4854.3458 1.0021.3917 1.5642.0443.5412.0443 1.2055.0442 2.0105 0 .2827.0129.5691-.0101.8511-.0119.1452-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101q-6.2232-.0023-12.4463 0c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5711-.1534a1.5 1.5 0 0 1-.6556-.6555c-.111-.218-.1415-.426-.1533-.5712-.023-.282-.0102-.5685-.0102-.8511 0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.0021-.3459 1.5642-.3918C5.2893 14 5.9537 14 6.7586 14M4.5 7.5C4.5 5.0147 6.5146 3 9 3c2.4852 0 4.4999 2.0147 4.4999 4.5s-2.0147 4.5-4.5 4.5c-2.4852 0-4.5-2.0147-4.5-4.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 9.5c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.2413 1H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 5.2894 1 5.9537 1 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 23 5.9537 23 6.7587 23h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 18.7106 23 18.0463 23 17.2413V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 1 18.0463 1 17.2413 1M4.092 3.218c.1564-.0797.3806-.1446.819-.1804C5.3611 3.0008 5.9434 3 6.8 3h10.4c.8566 0 1.4389.0008 1.889.0375.4384.0359.6626.1008.819.1805.3763.1917.6823.4977.874.874.0797.1564.1446.3806.1804.819C20.9992 5.3611 21 5.9434 21 6.8v10.4c0 .8566-.0008 1.4389-.0376 1.889-.0259.3176-.0671.5227-.1182.6712-.5132-2.0104-2.2364-3.5275-4.3541-3.7361-.2454-.0242-.5236-.0241-.9322-.0241H8.4422c-.4086 0-.687-.0001-.9323.0241-2.1177.2086-3.8409 1.7257-4.3541 3.7361-.051-.1484-.0923-.3536-.1183-.6712C3.0008 18.6389 3 18.0566 3 17.2V6.8c0-.8566.0008-1.4389.0375-1.889.0359-.4384.1008-.6626.1805-.819a2 2 0 0 1 .874-.874"
      clipRule="evenodd"
    />
  </svg>
);

export const UserUp01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7071 14.2929a1 1 0 0 0-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L18 17.4142V21c0 .5523.4477 1 1 1s1-.4477 1-1v-3.5858l1.2929 1.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.786 14.5c1.4791.0003 2.9582.0006 4.4372 0 .1191-.0001.2614-.0001.3867.0101.1452.0119.3532.0423.5711.1534.2823.1438.5117.3733.6556.6555.111.218.1415.426.1533.5712.0103.1253.0102.2676.0102.3867a5191 5191 0 0 0 0 3.9462c0 .1192.0001.2614-.0102.3867-.0118.1453-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101-2.8774-.001-5.7553-.0153-8.6326.0001-.0714.0004-.2148.0011-.351-.0229a1.5 1.5 0 0 1-1.2168-1.2167c-.024-.1362-.0232-.2796-.0228-.351.0031-.5909-.027-1.1932.076-1.7777.365-2.0701 1.9858-3.6908 4.0558-4.0558.4324-.0763.9276-.0762 1.6543-.076M4.5 7.5C4.5 4.4624 6.9626 2 10.0002 2s5.5 2.4624 5.5 5.5-2.4625 5.5-5.5 5.5-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserUp02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7071 2.2929a1 1 0 0 0-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L18 5.4142V9c0 .5523.4477 1 1 1s1-.4477 1-1V5.4142l1.2929 1.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7586 14h4.4826c.805 0 1.4694 0 2.0106.0442.5621.0459 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4854.3458 1.0021.3917 1.5642.0443.5412.0443 1.2055.0442 2.0105 0 .2827.0129.5691-.0101.8511-.0119.1452-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101q-6.2232-.0023-12.4463 0c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5711-.1534a1.5 1.5 0 0 1-.6556-.6555c-.111-.218-.1415-.426-.1533-.5712-.023-.282-.0102-.5685-.0102-.8511 0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.0021-.3459 1.5642-.3918C5.2893 14 5.9537 14 6.7586 14M4.5 7.5C4.5 5.0147 6.5146 3 9 3c2.4852 0 4.4999 2.0147 4.4999 4.5s-2.0147 4.5-4.5 4.5c-2.4852 0-4.5-2.0147-4.5-4.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserX01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.2071 15.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 18.5l-1.7929 1.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L19 19.9142l1.7929 1.7929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L20.4142 18.5l1.7929-1.7929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L19 17.0858z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.786 14.5c1.4791.0003 2.9582.0006 4.4372 0 .1191-.0001.2614-.0001.3867.0101.1452.0119.3532.0423.5711.1534.2823.1438.5117.3733.6556.6555.111.218.1415.426.1533.5712.0103.1253.0102.2676.0102.3867a5191 5191 0 0 0 0 3.9462c0 .1192.0001.2614-.0102.3867-.0118.1453-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101-2.8774-.001-5.7553-.0153-8.6326.0001-.0714.0004-.2148.0011-.351-.0229a1.5 1.5 0 0 1-1.2168-1.2167c-.024-.1362-.0232-.2796-.0228-.351.0031-.5909-.027-1.1932.076-1.7777.365-2.0701 1.9858-3.6908 4.0558-4.0558.4324-.0763.9276-.0762 1.6543-.076M4.5 7.5C4.5 4.4624 6.9626 2 10.0002 2s5.5 2.4624 5.5 5.5-2.4625 5.5-5.5 5.5-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
    />
  </svg>
);

export const UserX02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.2071 3.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 6.5l-1.7929 1.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L19 7.9142l1.7929 1.793c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143L20.4142 6.5l1.7929-1.7929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L19 5.0858z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7586 14h4.4826c.805 0 1.4694 0 2.0106.0442.5621.0459 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4854.3458 1.0021.3917 1.5642.0443.5412.0443 1.2055.0442 2.0105 0 .2827.0129.5691-.0101.8511-.0119.1452-.0423.3532-.1533.5712a1.5 1.5 0 0 1-.6556.6555c-.2179.1111-.4259.1415-.5711.1534-.1253.0102-.2676.0102-.3867.0101q-6.2232-.0023-12.4463 0c-.1191.0001-.2614.0001-.3867-.0101-.1452-.0119-.3532-.0423-.5711-.1534a1.5 1.5 0 0 1-.6556-.6555c-.111-.218-.1415-.426-.1533-.5712-.023-.282-.0102-.5685-.0102-.8511 0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.0021-.3459 1.5642-.3918C5.2893 14 5.9537 14 6.7586 14M4.5 7.5C4.5 5.0147 6.5146 3 9 3c2.4852 0 4.4999 2.0147 4.4999 4.5s-2.0147 4.5-4.5 4.5c-2.4852 0-4.5-2.0147-4.5-4.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Users01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.0316 14.8768c.1377-.5349.6828-.8569 1.2177-.7192C21.4056 14.7126 23 16.6688 23 19v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-1.3965-.9551-2.5725-2.2492-2.9055-.5349-.1377-.8569-.6829-.7192-1.2177M14.5731 2.9155c.2072-.5119.7902-.7589 1.3022-.5517C17.7058 3.1048 19 4.9001 19 7c0 2.1-1.2942 3.8952-3.1247 4.6362-.512.2072-1.095-.0398-1.3022-.5517s.0398-1.095.5517-1.3022C16.2261 9.3365 17 8.2574 17 7s-.7739-2.3365-1.8752-2.7823c-.5119-.2072-.7589-.7902-.5517-1.3022M7.179 14q2.321.0008 4.6421 0c1.0906-.0004 1.8348-.0006 2.473.1704a5 5 0 0 1 3.5356 3.5355c.2302.8593.1636 1.7777.1705 2.6582.0009.1069.0026.3231-.0513.5241a1.5 1.5 0 0 1-1.0606 1.0607c-.201.0539-.4173.0521-.5242.0513a861 861 0 0 0-13.7281 0c-.107.0008-.3232.0026-.5242-.0513a1.5 1.5 0 0 1-1.0607-1.0607c-.0538-.201-.052-.4172-.0512-.5241.007-.8783-.0594-1.8002.1705-2.6582a5 5 0 0 1 3.5355-3.5355c.6383-.171 1.3825-.1708 2.473-.1704"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2385 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const UsersCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.181 14.1635c.2822.1438.5117.3733.6555.6555.1531.3004.1636.6286.1635.9579V15.8c0 1.4744-.0005 2.9488 0 4.4231.0001.1191.0001.2614-.0101.3867-.0119.1452-.0423.3532-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3867.0101q-4.223-.0015-8.4463 0c-.1193.0001-.2618.0001-.3874-.0102-.1458-.012-.3542-.0426-.5725-.1542a1.5 1.5 0 0 1-.6558-.6589c-.1103-.2182-.1402-.4261-.1516-.5721-.0098-.1255-.009-.2677-.0085-.3861.0052-1.0393-.0258-2.1532.3796-3.1319a5 5 0 0 1 2.706-2.706c.5097-.2111 1.048-.2987 1.6567-.3402C6.3353 14 7.0627 14 7.9645 14c1.0862 0 2.1724.0004 3.2586 0 .3293-.0001.6575.0104.9579.1635M22.7071 15.2929c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L18 18.5858l3.2929-3.2929c.3905-.3905 1.0237-.3905 1.4142 0M14.5731 2.9155c.2072-.5119.7902-.7589 1.3021-.5517C17.7058 3.1048 19 4.9001 19 7c0 2.1-1.2942 3.8952-3.1248 4.6362-.5119.2072-1.0949-.0398-1.3021-.5517s.0398-1.095.5517-1.3022C16.2261 9.3365 17 8.2574 17 7s-.7739-2.3365-1.8752-2.7823c-.5119-.2072-.759-.7902-.5517-1.3022"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const UsersDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 14c.5523 0 1 .4477 1 1v3.5858l1.2929-1.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-3 3a1 1 0 0 1-1.4142 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L18 18.5858V15c0-.5523.4477-1 1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.181 14.1635c.2822.1438.5117.3733.6555.6555.1531.3004.1636.6286.1635.9579V15.8c0 1.4744-.0005 2.9488 0 4.4231.0001.1191.0001.2614-.0101.3867-.0119.1452-.0423.3532-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3867.0101q-4.223-.0015-8.4463 0c-.1193.0001-.2618.0001-.3874-.0102-.1458-.012-.3542-.0426-.5725-.1542a1.5 1.5 0 0 1-.6558-.6589c-.1103-.2182-.1402-.4261-.1516-.5721-.0098-.1255-.009-.2677-.0085-.3861.0052-1.0393-.0258-2.1532.3796-3.1319a5 5 0 0 1 2.706-2.706c.5097-.2111 1.048-.2987 1.6567-.3402C6.3353 14 7.0627 14 7.9645 14c1.0862 0 2.1724.0004 3.2586 0 .3293-.0001.6575.0104.9579.1635M14.5731 2.9155c.2072-.5119.7902-.7589 1.3021-.5517C17.7058 3.1048 19 4.9001 19 7c0 2.1-1.2942 3.8952-3.1248 4.6362-.5119.2072-1.0949-.0398-1.3021-.5517s.0398-1.095.5517-1.3022C16.2261 9.3365 17 8.2574 17 7s-.7739-2.3365-1.8752-2.7823c-.5119-.2072-.759-.7902-.5517-1.3022"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const UsersEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.7929 11.2929c.9428-.9428 2.4714-.9428 3.4142-.0001.9429.9429.9429 2.4715 0 3.4144-2.2279 2.2279-4.4603 4.4515-6.6839 6.6838-.0991.0995-.2239.2249-.3721.3282a2 2 0 0 1-.4138.2215c-.1836.072-.3734.1063-.5162.1349l-2.0251.405a1.0002 1.0002 0 0 1-1.1767-1.1768c.1375-.6872.2763-1.3742.4124-2.0617.0273-.1377.0616-.3112.1276-.4794a2 2 0 0 1 .2215-.4138c.1033-.1482.2286-.273.3281-.3721 2.2324-2.2236 4.456-4.456 6.684-6.6839M8.181 14.1635a1.5 1.5 0 0 1 .6555.6555c.153.3004.1636.6286.1635.9579V15.8c0 1.4744-.0005 2.9488 0 4.4231 0 .1191.0001.2614-.0101.3867-.0119.1452-.0423.3532-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.1111-.426.1415-.5712.1534-.1253.0102-.2675.0102-.3866.0101H2.7768c-.1193.0001-.2618.0001-.3874-.0102-.1458-.012-.3542-.0426-.5725-.1542a1.5 1.5 0 0 1-.6558-.6589c-.1103-.2182-.1402-.4261-.1516-.5721-.0098-.1255-.009-.2677-.0085-.3861.0052-1.0393-.0258-2.1532.3796-3.1319a5 5 0 0 1 2.706-2.706c.5097-.2111 1.048-.2987 1.6567-.3402L7.2232 14c.3292-.0001.6574.0104.9578.1635M14.5731 2.9155c.2072-.5119.7902-.7589 1.3021-.5517C17.7058 3.1048 19 4.9001 19 7c0 2.1-1.2942 3.8952-3.1248 4.6362-.5119.2072-1.0949-.0398-1.3021-.5517s.0398-1.095.5517-1.3022C16.2261 9.3365 17 8.2574 17 7s-.7739-2.3365-1.8752-2.7823c-.5119-.2072-.759-.7902-.5517-1.3022"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const UsersLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7071 15.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3a1 1 0 0 0 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L18.4142 19H22c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3.5858z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.181 14.1635c.2822.1438.5117.3733.6555.6555.1531.3004.1636.6286.1635.9579V15.8c0 1.4744-.0005 2.9488 0 4.4231.0001.1191.0001.2614-.0101.3867-.0119.1452-.0423.3532-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3867.0101q-4.223-.0015-8.4463 0c-.1193.0001-.2618.0001-.3874-.0102-.1458-.012-.3542-.0426-.5725-.1542a1.5 1.5 0 0 1-.6558-.6589c-.1103-.2182-.1402-.4261-.1516-.5721-.0098-.1255-.009-.2677-.0085-.3861.0052-1.0393-.0258-2.1532.3796-3.1319a5 5 0 0 1 2.706-2.706c.5097-.2111 1.048-.2987 1.6567-.3402C6.3353 14 7.0627 14 7.9645 14c1.0862 0 2.1724.0004 3.2586 0 .3293-.0001.6575.0104.9579.1635M14.5731 2.9155c.2072-.5119.7902-.7589 1.3021-.5517C17.7058 3.1048 19 4.9001 19 7c0 2.1-1.2942 3.8952-3.1248 4.6362-.5119.2072-1.0949-.0398-1.3021-.5517s.0398-1.095.5517-1.3022C16.2261 9.3365 17 8.2574 17 7s-.7739-2.3365-1.8752-2.7823c-.5119-.2072-.759-.7902-.5517-1.3022"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const UsersMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 18c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1M12.181 14.1635c.2822.1438.5117.3733.6555.6555.1531.3004.1636.6286.1635.9579V15.8c0 1.4744-.0005 2.9488 0 4.4231.0001.1191.0001.2614-.0101.3867-.0119.1452-.0423.3532-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3867.0101q-4.223-.0015-8.4463 0c-.1193.0001-.2618.0001-.3874-.0102-.1458-.012-.3542-.0426-.5725-.1542a1.5 1.5 0 0 1-.6558-.6589c-.1103-.2182-.1402-.4261-.1516-.5721-.0098-.1255-.009-.2677-.0085-.3861.0052-1.0393-.0258-2.1532.3796-3.1319a5 5 0 0 1 2.706-2.706c.5097-.2111 1.048-.2987 1.6567-.3402C6.3353 14 7.0627 14 7.9645 14c1.0862 0 2.1724.0004 3.2586 0 .3293-.0001.6575.0104.9579.1635M14.5731 2.9155c.2072-.5119.7902-.7589 1.3021-.5517C17.7058 3.1048 19 4.9001 19 7c0 2.1-1.2942 3.8952-3.1248 4.6362-.5119.2072-1.0949-.0398-1.3021-.5517s.0398-1.095.5517-1.3022C16.2261 9.3365 17 8.2574 17 7s-.7739-2.3365-1.8752-2.7823c-.5119-.2072-.759-.7902-.5517-1.3022"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const UsersPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 15c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1v-2h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.181 14.1635c.2822.1438.5117.3733.6555.6555.1531.3004.1636.6286.1635.9579V15.8c0 1.4744-.0005 2.9488 0 4.4231.0001.1191.0001.2614-.0101.3867-.0119.1452-.0423.3532-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3867.0101q-4.223-.0015-8.4463 0c-.1193.0001-.2618.0001-.3874-.0102-.1458-.012-.3542-.0426-.5725-.1542a1.5 1.5 0 0 1-.6558-.6589c-.1103-.2182-.1402-.4261-.1516-.5721-.0098-.1255-.009-.2677-.0085-.3861.0052-1.0393-.0258-2.1532.3796-3.1319a5 5 0 0 1 2.706-2.706c.5097-.2111 1.048-.2987 1.6567-.3402C6.3353 14 7.0627 14 7.9645 14c1.0862 0 2.1724.0004 3.2586 0 .3293-.0001.6575.0104.9579.1635M14.5731 2.9155c.2072-.5119.7902-.7589 1.3021-.5517C17.7058 3.1048 19 4.9001 19 7c0 2.1-1.2942 3.8952-3.1248 4.6362-.5119.2072-1.0949-.0398-1.3021-.5517s.0398-1.095.5517-1.3022C16.2261 9.3365 17 8.2574 17 7s-.7739-2.3365-1.8752-2.7823c-.5119-.2072-.759-.7902-.5517-1.3022"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const UsersRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7071 14.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L19.5858 17H16c-.5523 0-1 .4477-1 1s.4477 1 1 1h3.5858l-1.2929 1.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3a1 1 0 0 0 0-1.4142z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.181 14.1635c.2822.1438.5117.3733.6555.6555.1531.3004.1636.6286.1635.9579V15.8c0 1.4744-.0005 2.9488 0 4.4231.0001.1191.0001.2614-.0101.3867-.0119.1452-.0423.3532-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3867.0101q-4.223-.0015-8.4463 0c-.1193.0001-.2618.0001-.3874-.0102-.1458-.012-.3542-.0426-.5725-.1542a1.5 1.5 0 0 1-.6558-.6589c-.1103-.2182-.1402-.4261-.1516-.5721-.0098-.1255-.009-.2677-.0085-.3861.0052-1.0393-.0258-2.1532.3796-3.1319a5 5 0 0 1 2.706-2.706c.5097-.2111 1.048-.2987 1.6567-.3402C6.3353 14 7.0627 14 7.9645 14c1.0862 0 2.1724.0004 3.2586 0 .3293-.0001.6575.0104.9579.1635M14.5731 2.9155c.2072-.5119.7902-.7589 1.3021-.5517C17.7058 3.1048 19 4.9001 19 7c0 2.1-1.2942 3.8952-3.1248 4.6362-.5119.2072-1.0949-.0398-1.3021-.5517s.0398-1.095.5517-1.3022C16.2261 9.3365 17 8.2574 17 7s-.7739-2.3365-1.8752-2.7823c-.5119-.2072-.759-.7902-.5517-1.3022"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const UsersUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.7071 14.2929a1 1 0 0 0-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L18 17.4142V21c0 .5523.4477 1 1 1s1-.4477 1-1v-3.5858l1.2929 1.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.181 14.1635c.2822.1438.5117.3733.6555.6555.1531.3004.1636.6286.1635.9579V15.8c0 1.4744-.0005 2.9488 0 4.4231.0001.1191.0001.2614-.0101.3867-.0119.1452-.0423.3532-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3867.0101q-4.223-.0015-8.4463 0c-.1193.0001-.2618.0001-.3874-.0102-.1458-.012-.3542-.0426-.5725-.1542a1.5 1.5 0 0 1-.6558-.6589c-.1103-.2182-.1402-.4261-.1516-.5721-.0098-.1255-.009-.2677-.0085-.3861.0052-1.0393-.0258-2.1532.3796-3.1319a5 5 0 0 1 2.706-2.706c.5097-.2111 1.048-.2987 1.6567-.3402C6.3353 14 7.0627 14 7.9645 14c1.0862 0 2.1724.0004 3.2586 0 .3293-.0001.6575.0104.9579.1635M14.5731 2.9155c.2072-.5119.7902-.7589 1.3021-.5517C17.7058 3.1048 19 4.9001 19 7c0 2.1-1.2942 3.8952-3.1248 4.6362-.5119.2072-1.0949-.0398-1.3021-.5517s.0398-1.095.5517-1.3022C16.2261 9.3365 17 8.2574 17 7s-.7739-2.3365-1.8752-2.7823c-.5119-.2072-.759-.7902-.5517-1.3022"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const UsersX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.2071 15.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 18.5l-1.7929 1.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L19 19.9142l1.7929 1.7929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L20.4142 18.5l1.7929-1.7929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L19 17.0858z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.181 14.1635c.2822.1438.5117.3733.6555.6555.1531.3004.1636.6286.1635.9579V15.8c0 1.4744-.0005 2.9488 0 4.4231.0001.1191.0001.2614-.0101.3867-.0119.1452-.0423.3532-.1534.5712a1.5 1.5 0 0 1-.6555.6555c-.218.1111-.4259.1415-.5712.1534-.1253.0102-.2675.0102-.3867.0101q-4.223-.0015-8.4463 0c-.1193.0001-.2618.0001-.3874-.0102-.1458-.012-.3542-.0426-.5725-.1542a1.5 1.5 0 0 1-.6558-.6589c-.1103-.2182-.1402-.4261-.1516-.5721-.0098-.1255-.009-.2677-.0085-.3861.0052-1.0393-.0258-2.1532.3796-3.1319a5 5 0 0 1 2.706-2.706c.5097-.2111 1.048-.2987 1.6567-.3402C6.3353 14 7.0627 14 7.9645 14c1.0862 0 2.1724.0004 3.2586 0 .3293-.0001.6575.0104.9579.1635M14.5731 2.9155c.2072-.5119.7902-.7589 1.3021-.5517C17.7058 3.1048 19 4.9001 19 7c0 2.1-1.2942 3.8952-3.1248 4.6362-.5119.2072-1.0949-.0398-1.3021-.5517s.0398-1.095.5517-1.3022C16.2261 9.3365 17 8.2574 17 7s-.7739-2.3365-1.8752-2.7823c-.5119-.2072-.759-.7902-.5517-1.3022"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const Airplay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.4851 14.3722a1.5 1.5 0 0 1 1.0298 0c.2629.0961.4436.2566.5563.3702.1001.1009.2044.2262.2947.3347l.0169.0202 3.292 3.9504.0229.0275c.1543.1851.3106.3726.4244.5373.1076.1559.3041.4622.3102.8649a1.5 1.5 0 0 1-.557 1.1893c-.3132.2531-.6744.2983-.863.3153-.1994.0181-.4435.018-.6845.018H8.6722c-.241 0-.485.0001-.6845-.018-.1886-.017-.5498-.0622-.863-.3153a1.5 1.5 0 0 1-.557-1.1893c.006-.4027.2026-.709.3102-.8649.1138-.1647.2701-.3522.4244-.5373l.023-.0275 3.2919-3.9504.0169-.0203c.0903-.1084.1947-.2337.2947-.3346.1127-.1136.2934-.2741.5563-.3702"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M17.2413 2H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 6.2894 1 6.9537 1 7.7587v5.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.3849.1961.8021.2993 1.2268.3558.1684.0225.2525.0337.3345.0172a.474.474 0 0 0 .2-.0892c.067-.0499.1315-.1445.2607-.3335l.0264-.0384c.1685-.2439.3825-.5003.5217-.667l3.3268-3.992.0206-.0248c.0808-.0973.2415-.2909.4078-.4584.201-.2026.6271-.598 1.2893-.84a3.5 3.5 0 0 1 2.403 0c.6622.242 1.0883.6374 1.2894.84.1662.1675.3269.3611.4077.4583l.0206.0249 3.3268 3.992c.1392.1667.3532.423.5217.667l.0264.0384c.1292.189.1938.2835.2608.3335a.474.474 0 0 0 .2.0892c.0819.0165.1661.0052.3344-.0172.4246-.0565.8418-.1597 1.2266-.3558a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 14.7106 23 14.0463 23 13.2413V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 2 18.0463 2 17.2413 2"
    />
  </svg>
);

export const Airpods = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 7.625C1 4.7945 3.2945 2.5 6.125 2.5s5.125 2.2945 5.125 5.125v11.25c0 1.4497-1.1753 2.625-2.625 2.625S6 20.3247 6 18.875v-6.1265c-2.7727-.0664-5-2.3348-5-5.1235M12.75 7.625c0-2.8305 2.2945-5.125 5.125-5.125S23 4.7945 23 7.625c0 2.7887-2.2273 5.0571-5 5.1235v6.1265c0 1.4497-1.1753 2.625-2.625 2.625s-2.625-1.1753-2.625-2.625z"
      clipRule="evenodd"
    />
  </svg>
);

export const BatteryCharging01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.2413 5H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 9.2894 1 9.9537 1 10.7587v2.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 19 5.9537 19 6.7587 19h7.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C20 14.7106 20 14.0463 20 13.2413v-2.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C15.7106 5 15.0463 5 14.2413 5m-3.2005 4.4856c.2682-.4828.0943-1.0916-.3885-1.3598s-1.0916-.0943-1.3598.3885l-1.6667 3A1 1 0 0 0 8.5 12.9999h2.3005l-.8413 1.5144c-.2682.4828-.0943 1.0916.3885 1.3598s1.0916.0943 1.3598-.3885l1.6667-3a1.0002 1.0002 0 0 0-.8742-1.4857h-2.3005z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M23 11c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1z"
    />
  </svg>
);

export const BatteryCharging02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.0541 6.236c.2615-.4023.3922-.6034.3809-.7699a.5.5 0 0 0-.1986-.3659C10.103 5 9.8631 5 9.3834 5H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 9.2894 1 9.9537 1 10.7587v2.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 19 5.9537 19 6.7587 19h.1305c.3173 0 .4759 0 .6195-.0442a1 1 0 0 0 .3473-.1884c.1154-.0964.2018-.2294.3747-.4954l3.4267-5.2719H7.5001a1 1 0 0 1-.8384-1.545z"
    />
    <path
      fill="currentColor"
      d="M10.9463 17.764c-.2615.4023-.3922.6034-.3809.7699a.5.5 0 0 0 .1986.3659c.1334.1002.3733.1002.853.1002h2.6243c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C20 14.7106 20 14.0463 20 13.2413v-2.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C15.7106 5 15.0463 5 14.2413 5h-.1301c-.3173 0-.4759 0-.6196.0442a1 1 0 0 0-.3473.1884c-.1153.0964-.2017.2294-.3746.4954l-3.4269 5.2721h4.1573a1 1 0 0 1 .8385 1.545zM22 10c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const BatteryEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.2413 5H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 9.2894 1 9.9537 1 10.7587v2.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 19 5.9537 19 6.7587 19h7.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C20 14.7106 20 14.0463 20 13.2413v-2.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C15.7106 5 15.0463 5 14.2413 5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M23 11c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1z"
    />
  </svg>
);

export const BatteryFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 5h7.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C20 9.2894 20 9.9537 20 10.7587v2.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C15.7106 19 15.0463 19 14.2413 19H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 14.7106 1 14.0463 1 13.2413v-2.4826c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 5 5.9538 5 6.7587 5M6.5 9c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1m4 0c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1m5 1c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M22 10c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const BatteryLow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 5h7.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C20 9.2894 20 9.9537 20 10.7587v2.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C15.7106 19 15.0463 19 14.2413 19H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 14.7106 1 14.0463 1 13.2413v-2.4826c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 5 5.9538 5 6.7587 5M7.5 10c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M22 10c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const BatteryMid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 5h7.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C20 9.2894 20 9.9537 20 10.7587v2.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C15.7106 19 15.0463 19 14.2413 19H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 14.7106 1 14.0463 1 13.2413v-2.4826c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 5 5.9538 5 6.7587 5M7.5 10c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1zm4 0c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M22 10c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const BluetoothConnect = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H18c-.5523 0-1-.4477-1-1M14 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H15c-.5523 0-1-.4477-1-1M20 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H21c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5759 1.0944a1 1 0 0 1 1.0643.1374l6 5a1 1 0 0 1 0 1.5364L10.5621 12l5.0781 4.2318a1 1 0 0 1 0 1.5364l-6 5A1 1 0 0 1 8 22v-7.8649l-4.3598 3.6331c-.4243.3536-1.0548.2963-1.4084-.128s-.2962-1.0548.128-1.4084L7.438 12 2.3598 7.7682c-.4242-.3535-.4816-.9841-.128-1.4084.3536-.4242.9841-.4816 1.4084-.128L8 9.865V2a1 1 0 0 1 .5759-.9056M10 14.1351 13.438 17 10 19.865zm0-4.2701v-5.73L13.438 7z"
      clipRule="evenodd"
    />
  </svg>
);

export const BluetoothOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.5758 1.0944a1 1 0 0 1 1.0644.1374l6 5a1 1 0 0 1 0 1.5364l-2.9183 2.432c-.4243.3535-1.0549.2962-1.4084-.1281s-.2963-1.0548.128-1.4084L16.438 7 13 4.135V7c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.388.2245-.741.5758-.9056"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.7009 11.2867 3.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l8.2257 8.2257-5.1588 4.299c-.4242.3536-.4816.9841-.128 1.4084s.9841.4816 1.4084.128L11 14.1351V22a1 1 0 0 0 1.6402.7682l4.753-3.9608 2.8997 2.8997c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-8.994-8.994zm3.2723 6.1007L13 19.865v-5.4508z"
      clipRule="evenodd"
    />
  </svg>
);

export const BluetoothOn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.5759 1.0944a1 1 0 0 1 1.0643.1374l6 5a1 1 0 0 1 0 1.5364L13.5621 12l5.0781 4.2318a1 1 0 0 1 0 1.5364l-6 5A.9999.9999 0 0 1 11 22v-7.8649l-4.3598 3.6331c-.4243.3536-1.0548.2963-1.4084-.128s-.2962-1.0548.128-1.4084L10.438 12 5.3598 7.7682c-.4242-.3535-.4816-.9841-.128-1.4084.3536-.4242.9841-.4816 1.4084-.128L11 9.865V2a1 1 0 0 1 .5759-.9056M13 14.1351 16.438 17 13 19.865zm0-4.2701v-5.73L16.438 7z"
      clipRule="evenodd"
    />
  </svg>
);

export const BluetoothSignal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.5606 5.6882c.4483-.3225 1.0732-.2205 1.3957.2278 1.232 1.7125 1.9578 3.815 1.9578 6.084s-.7258 4.3715-1.9578 6.084c-.3225.4483-.9474.5503-1.3957.2278s-.5503-.9474-.2278-1.3958c.9953-1.3835 1.5813-3.0799 1.5813-4.916s-.586-3.5324-1.5813-4.916c-.3225-.4483-.2205-1.0732.2278-1.3958M16.4279 8.037c.453-.3159 1.0763-.2048 1.3923.2481.7347 1.0533 1.1657 2.3353 1.1657 3.715a6.475 6.475 0 0 1-1.1657 3.715c-.316.4529-.9393.564-1.3923.2481-.4529-.316-.564-.9394-.2481-1.3923.5082-.7285.8061-1.6134.8061-2.5708s-.2979-1.8423-.8061-2.5708c-.3159-.453-.2048-1.0763.2481-1.3922M7.5759 1.0944a1 1 0 0 1 1.0643.1374l6 5a1 1 0 0 1 0 1.5364L9.5621 12l5.0781 4.2318a1 1 0 0 1 0 1.5364l-6 5A1 1 0 0 1 7 22v-7.8649l-4.3598 3.6331c-.4243.3536-1.0548.2963-1.4084-.128s-.2962-1.0548.128-1.4084L6.438 12 1.3598 7.7682c-.4242-.3535-.4816-.9841-.128-1.4084.3536-.4242.9841-.4816 1.4084-.128L7 9.865V2a1 1 0 0 1 .5759-.9056M9 14.1351 12.438 17 9 19.865zM9 9.865v-5.73L12.438 7z"
      clipRule="evenodd"
    />
  </svg>
);

export const ChromeCast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.2413 2H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 6.2894 1 6.9537 1 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 2 18.0463 2 17.2413 2M4.0061 9.9393c.061-.5488.5555-.9443 1.1044-.8833a10 10 0 0 1 8.8333 8.8334c.0611.5489-.3344 1.0433-.8833 1.1044-.5489.061-1.0434-.3345-1.1044-.8834a8 8 0 0 0-7.0667-7.0666c-.5489-.0611-.9444-.5555-.8833-1.1044m.014 3.9608c.1104-.5412.6385-.8904 1.1797-.78a6 6 0 0 1 4.68 4.6799c.1104.5412-.2389 1.0693-.78 1.1797s-1.0693-.2388-1.1797-.78a4 4 0 0 0-3.12-3.12c-.5411-.1104-.8903-.6385-.78-1.1796M5 16.9999c-.5522 0-1 .4477-1 1s.4478 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Clapperboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7887 2.957c.0656-.328.0984-.492.054-.6204a.5.5 0 0 0-.2195-.2678C7.506 2 7.3388 2 7.0042 2h-.2455c-.805 0-1.4693 0-2.0105.0442-.5621.0459-1.0788.1445-1.5642.3917a4 4 0 0 0-1.748 1.7481c-.2473.4853-.3459 1.002-.3918 1.5641-.0148.181-.0222.2713-.01.3718.0491.4067.391.7777.7923.8598C1.9257 7 2.0353 7 2.2545 7h4.0698c.2336 0 .3504 0 .4462-.0419a.5.5 0 0 0 .2097-.172c.0598-.0856.0827-.2002.1285-.4292zM9.2111 6.0432c-.0656.328-.0984.492-.054.6203a.5.5 0 0 0 .2196.2679C9.4938 7 9.661 7 9.9956 7h3.3287c.2336 0 .3504 0 .4462-.0419a.5.5 0 0 0 .2097-.172c.0598-.0856.0827-.2002.1285-.4292l.68-3.4c.0656-.328.0984-.492.054-.6204a.5.5 0 0 0-.2195-.2678C14.506 2 14.3388 2 14.0043 2h-3.3287c-.2336 0-.3505 0-.4462.0418a.5.5 0 0 0-.2098.172c-.0598.0856-.0827.2002-.1285.4293zM17.6756 1.9982c-.2341.0005-.3511.0007-.4466.0426a.5.5 0 0 0-.2093.172c-.0596.0856-.0826.2005-.1286.4304l-.68 3.4c-.0656.328-.0984.492-.054.6203a.5.5 0 0 0 .2196.2679C16.4938 7 16.6611 7 16.9956 7h4.7499c.2192 0 .3288 0 .428-.0203.4013-.0821.7432-.453.7923-.8597.0122-.1006.0048-.191-.01-.3718-.0459-.5621-.1445-1.0789-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.346-1.5642-.3918-.5237-.0428-1.0502-.0472-1.5762-.0461M22.891 9.546c.109.214.109.494.109 1.0541v5.6413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5641a4 4 0 0 1-1.748 1.7481c-.4854.2473-1.0021.3459-1.5642.3918-.5412.0442-1.2055.0442-2.0105.0442H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.7481c-.2473-.4853-.3459-1.002-.3918-1.5641C1 17.7107 1 17.0463 1 16.2414v-5.6413c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C1.76 9 2.04 9 2.6 9h18.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437"
    />
  </svg>
);

export const Disc01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m3 11c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
      clipRule="evenodd"
    />
  </svg>
);

export const Disc02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11-4.9249 11-11 11S1 18.0751 1 12m11 3c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3m3.4291-10.2297c-.4989-.237-1.0954-.0247-1.3324.4742-.2369.4988-.0246 1.0953.4742 1.3323C16.6003 7.541 18 9.608 18 12c0 .5523.4477 1 1 1s1-.4477 1-1c0-3.1928-1.8704-5.9467-4.5709-7.2296M6 12c0-.5523-.4477-1-1-1s-1 .4477-1 1c0 2.9113 1.5557 5.4582 3.8763 6.8565.473.2851 1.0876.1326 1.3726-.3404s.1327-1.0876-.3404-1.3726C7.1635 16.0919 6 14.1813 6 11.9999"
      clipRule="evenodd"
    />
  </svg>
);

export const FastBackward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.9251 4.2282a2 2 0 0 1 1.6183.7267c.3191.3872.3927.8644.424 1.2125.0326.3624.0326.824.0325 1.3504v8.9643c.0001.5264.0001.988-.0325 1.3504-.0313.3481-.1049.8253-.424 1.2125a2 2 0 0 1-1.6183.7267c-.5014-.0187-.9069-.2808-1.1879-.4886-.2925-.2164-.6375-.5232-1.031-.8729l-5.051-4.4898c-.2104-.187-.4127-.3668-.5696-.5322-.1703-.1795-.3576-.4126-.4675-.7257a2 2 0 0 1 0-1.3251c.1099-.3131.2972-.5462.4675-.7257.1569-.1654.3592-.3452.5696-.5322l.0257-.0228 5.0254-4.467c.3934-.3497.7384-.6564 1.031-.8728.281-.208.6864-.47 1.1878-.4887M20.9251 4.2282a2 2 0 0 1 1.6183.7267c.3191.3872.3927.8644.424 1.2125.0326.3624.0326.824.0325 1.3504v8.9643c.0001.5264.0001.988-.0325 1.3504-.0313.3481-.1049.8253-.424 1.2125a2 2 0 0 1-1.6183.7267c-.5014-.0187-.9069-.2808-1.1879-.4886-.2925-.2164-.6375-.5232-1.0309-.8729l-5.051-4.4898c-.2105-.187-.4128-.3668-.5697-.5322-.1703-.1795-.3576-.4126-.4675-.7257a2 2 0 0 1 0-1.3251c.1099-.3131.2972-.5462.4675-.7257.1569-.1654.3592-.3452.5696-.5322l.0257-.0228 5.0254-4.467c.3934-.3497.7384-.6564 1.0309-.8728.281-.208.6865-.47 1.1879-.4887"
      clipRule="evenodd"
    />
  </svg>
);

export const FastForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.0748 4.2282a2 2 0 0 0-1.6183.7267c-.3191.3872-.3926.8644-.4239 1.2125C12 6.5298 12 6.9914 12 7.5178v8.9643c0 .5264 0 .988.0326 1.3504.0313.3481.1048.8253.4239 1.2125.3966.4813.9951.75 1.6183.7267.5014-.0187.9069-.2808 1.1879-.4886.2925-.2164.6376-.5232 1.031-.8729l5.051-4.4898c.2104-.187.4128-.3668.5696-.5322.1703-.1795.3576-.4126.4676-.7257a2 2 0 0 0 0-1.3251c-.11-.3131-.2973-.5462-.4676-.7257-.1568-.1654-.3592-.3452-.5696-.5322l-.0257-.0228-5.0253-4.467c-.3934-.3497-.7385-.6564-1.031-.8728-.281-.208-.6865-.47-1.1879-.4887M3.0748 4.2282a2 2 0 0 0-1.6183.7267c-.319.3872-.3926.8644-.424 1.2125C1 6.5298 1 6.9914 1 7.5178v8.9643c0 .5264 0 .988.0326 1.3504.0313.3481.1048.8253.424 1.2125a2 2 0 0 0 1.6182.7267c.5014-.0187.907-.2808 1.1879-.4886.2925-.2164.6376-.5232 1.031-.8729l5.051-4.4898c.2104-.187.4128-.3668.5696-.5322.1703-.1795.3576-.4126.4676-.7257a2 2 0 0 0 0-1.3251c-.11-.3131-.2973-.5462-.4676-.7257-.1568-.1654-.3592-.3452-.5696-.5322l-.0257-.0228-5.0254-4.467c-.3933-.3497-.7384-.6564-1.031-.8728-.2809-.208-.6864-.47-1.1878-.4887"
      clipRule="evenodd"
    />
  </svg>
);

export const Film01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 1c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 5.2894 1 5.9537 1 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 23 5.9537 23 6.7587 23h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 18.7106 23 18.0463 23 17.2413V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 1 18.0463 1 17.2413 1zM18 6V3.0018c.4455.003.7954.0118 1.089.0358.4384.0358.6626.1007.819.1804.3763.1917.6823.4977.874.874.0797.1564.1446.3806.1804.819.024.2936.0327.6435.0358 1.089zm0 2v3h3V8zm0 8v-3h3v3zm0 2v2.9982c.4455-.0031.7954-.0118 1.089-.0358.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.024-.2936.0327-.6435.0358-1.089zM4.911 3.0376c.2936-.024.6435-.0327 1.089-.0358V6H3.0018c.003-.4455.0118-.7954.0358-1.089.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804M3 8h3v3H3zm0 5h3v3H3zm.0018 5H6v2.9982c-.4455-.0031-.7954-.0118-1.089-.0358-.4384-.0358-.6626-.1007-.819-.1804a2 2 0 0 1-.874-.874c-.0797-.1564-.1446-.3806-.1804-.819-.024-.2936-.0327-.6435-.0358-1.089"
      clipRule="evenodd"
    />
  </svg>
);

export const Film02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 1 18.0463 1 17.2413 1H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 5.2894 1 5.9537 1 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 23 5.9537 23 6.7587 23h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 18.7106 23 18.0463 23 17.2413zM18 18h2.9982c-.0031.4455-.0118.7954-.0358 1.089-.0358.4384-.1007.6626-.1804.819a2 2 0 0 1-.874.874c-.1564.0797-.3806.1446-.819.1804-.2936.024-.6435.0327-1.089.0358zm-2 0h-3v3h3zm-8 0h3v3H8zm-2 0H3.0018c.003.4455.0118.7954.0358 1.089.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804.2936.024.6435.0327 1.089.0358zM20.9624 4.911c.024.2936.0327.6435.0358 1.089H18V3.0018c.4455.003.7954.0118 1.089.0358.4384.0358.6626.1007.819.1804.3763.1917.6823.4977.874.874.0797.1564.1446.3806.1804.819M16 3v3h-3V3zm-5 0v3H8V3zm-5 .0018V6H3.0018c.003-.4455.0118-.7954.0358-1.089.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804.2936-.024.6435-.0327 1.089-.0358"
      clipRule="evenodd"
    />
  </svg>
);

export const Film03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.1382 1.017c.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698q.0053.0667.0087.1382h4.2495c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C23 7.2894 23 7.9537 23 8.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 23 18.0463 23 17.2413 23h-3.6732c-.2523 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698A4 4 0 0 1 11.0082 21H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 16.7106 1 16.0463 1 15.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 1 5.9537 1 6.7587 1h3.6732c.2524 0 .4982 0 .7063.017M8 3v2h3V3zm-3.089.0376c.2936-.024.6435-.0327 1.089-.0358V5H3.0309a7 7 0 0 1 .0067-.089c.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804M8 17h3v2H8zm-2 0v1.9982c-.4455-.0031-.7954-.0118-1.089-.0357-.4384-.0359-.6626-.1008-.819-.1805a2 2 0 0 1-.874-.874c-.0797-.1564-.1446-.3806-.1804-.819A7 7 0 0 1 3.0309 17zm7 2v2h3v-2zm5 1.9982c.4455-.0031.7954-.0118 1.089-.0358.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1805-.819a7 7 0 0 0 .0066-.089H18zM13 7h3V5h-3zm5-1.9982V7h2.9691a7 7 0 0 0-.0066-.089c-.0359-.4384-.1008-.6626-.1805-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804-.2936-.024-.6435-.0327-1.089-.0358"
      clipRule="evenodd"
    />
  </svg>
);

export const GamingPad01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.593 4h-3.1861c-1.2768 0-2.2941 0-3.1187.0653-.8458.067-1.5696.2071-2.2416.5316A6 6 0 0 0 2.452 7.0127c-.3716.6472-.563 1.3591-.69 2.198-.1239.8179-.1964 1.8326-.2873 3.1062l-.249 3.4864C1.0637 18.071 2.8597 20 5.1333 20a3.918 3.918 0 0 0 3.0096-1.4096l.3752-.4502c.3654-.4385.4752-.565.5902-.6629a2 2 0 0 1 .957-.4482c.1489-.0257.3163-.0291.8871-.0291h2.0949c.5708 0 .7382.0034.8871.0291.3534.0609.6839.2157.957.4482.115.0979.2248.2244.5902.6629l.3752.4502A3.918 3.918 0 0 0 18.8665 20c2.2735 0 4.0696-1.929 3.9077-4.1967l-.2491-3.4865c-.0909-1.2735-.1634-2.2882-.2873-3.106-.1271-.839-.3184-1.5509-.69-2.198a6 6 0 0 0-2.5945-2.4159c-.672-.3245-1.3958-.4646-2.2416-.5316C15.8871 4 14.8698 4 13.593 4M9 9c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H6c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v1c0 .5523.4477 1 1 1s1-.4477 1-1v-1h1c.5523 0 1-.4477 1-1s-.4477-1-1-1H9zm5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H15c-.5523 0-1-.4477-1-1m3-2c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H18c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const GamingPad02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.8385 5H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 8.1795 1 8.6343 1 9.1614v5.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 19 4.6343 19 5.1615 19h13.677c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 15.8205 23 15.3657 23 14.8386V9.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 5 19.3657 5 18.8385 5M9 10c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H6c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v1c0 .5523.4477 1 1 1s1-.4477 1-1v-1h1c.5523 0 1-.4477 1-1s-.4477-1-1-1H9zm5 3c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H15c-.5523 0-1-.4477-1-1m3-2c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H18c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const HardDrive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.8141 2.9998c-.9277-.0006-1.627-.001-2.2642.2187a4 4 0 0 0-1.4946.9237c-.4816.4717-.794 1.0974-1.2082 1.9274-.6335 1.267-1.2923 2.5248-1.9173 3.7973-.1812.369-.2718.5535-.2481.7086a.504.504 0 0 0 .2086.3348C2.019 11 2.227 11 2.6429 11h18.7143c.4159 0 .6239 0 .7526-.0897a.504.504 0 0 0 .2086-.3348c.0237-.1551-.0669-.3396-.2482-.7086-.6249-1.2725-1.2837-2.5304-1.9172-3.7972-.4143-.83-.7266-1.4558-1.2082-1.9275a4 4 0 0 0-1.4946-.9237c-.6372-.2198-1.3366-.2193-2.2643-.2187z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.0001 14.5996c0-.5597 0-.8396-.1089-1.0535a1 1 0 0 0-.4371-.4371C22.2402 13 21.9603 13 21.4004 13H2.5996c-.5598 0-.8398 0-1.0537.109a1 1 0 0 0-.437.4371C1 13.76 1 14.0399 1 14.5996v.6416c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.0021.3459 1.5642.3918.5412.0442 1.2056.0442 2.0105.0442h10.4827c.8049 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5641-.3918a4 4 0 0 0 1.7481-1.748c.2473-.4854.3458-1.0021.3917-1.5642.0443-.5412.0443-1.2055.0442-2.0105zm-17 .4004c-.5524 0-1 .4477-1 1s.4476 1 1 1H10c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Headphones01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12C2 6.4772 6.4772 2 12 2s10 4.4772 10 10v6.5c0 1.933-1.567 3.5-3.5 3.5S15 20.433 15 18.5v-2c0-1.933 1.567-3.5 3.5-3.5.5368 0 1.0454.1208 1.5.3368V12c0-4.4183-3.5817-8-8-8s-8 3.5817-8 8v1.3368A3.486 3.486 0 0 1 5.5 13C7.433 13 9 14.567 9 16.5v2C9 20.433 7.433 22 5.5 22S2 20.433 2 18.5z"
      clipRule="evenodd"
    />
  </svg>
);

export const Headphones02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1 13C1 6.9249 5.9249 2 12 2s11 4.9249 11 11v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-4.9706-4.0294-9-9-9s-9 4.0294-9 9v4c0 .5523-.4477 1-1 1s-1-.4477-1-1z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 15.5C4 13.567 5.567 12 7.5 12s3.5 1.567 3.5 3.5v3c0 1.933-1.567 3.5-3.5 3.5S4 20.433 4 18.5zM16.5 12c-1.933 0-3.5 1.567-3.5 3.5v3c0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5v-3c0-1.933-1.567-3.5-3.5-3.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Keyboard01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.8385 5H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 8.1795 1 8.6343 1 9.1614v5.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 19 4.6343 19 5.1615 19h13.677c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 15.8205 23 15.3657 23 14.8386V9.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 5 19.3657 5 18.8385 5M5 10c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H6c-.5523 0-1-.4477-1-1m2 4c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1m3-5c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zm1 5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1m3-5c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zm1 5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H16c-.5523 0-1-.4477-1-1m3-5c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Keyboard02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.8385 5H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 8.1795 1 8.6343 1 9.1614v5.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 19 4.6343 19 5.1615 19h13.677c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 15.8205 23 15.3657 23 14.8386V9.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 5 19.3657 5 18.8385 5M5 10c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H6c-.5523 0-1-.4477-1-1m1 4.5c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1M10 9c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zm3 1c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H14c-.5523 0-1-.4477-1-1m5-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Laptop01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.1614 3h11.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3745.0306.8293.0306 1.3564V13.4c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.4371c-.2139.1089-.494.1089-1.054.1089h-4.7883000000000004c-.1899-.0006-.4291-.0012-.6644.0553a2 2 0 0 0-.5781.2395c-.2063.1264-.375.296-.5089.4306-.1767.177-.419.2722-.6691.2722h-2.3824c-.2501 0-.4924-.0952-.6691-.2722-.1339-.1346-.3026-.3042-.509-.4306a2 2 0 0 0-.578-.2395c-.2354-.0565-.4745-.0559-.6644-.0553H3.5999c-.56 0-.84 0-1.054-.1089a1 1 0 0 1-.437-.4371c-.109-.2139-.109-.4939-.109-1.054V7.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1794 3 5.6342 3 6.1613 3M2.5338 17.0004c-.542-.0001-.8129-.0002-1.0424.1299-.1788.1013-.3666.3193-.4403.511-.0947.2463-.0625.4609.0018.89.0134.0894.0296.1724.0491.2452a3 3 0 0 0 2.1213 2.1213c.3856.1033.8236.1029 1.3313.1023H19.445c.5077.0006.9457.001 1.3313-.1023a3 3 0 0 0 2.1213-2.1213 2.2 2.2 0 0 0 .0487-.2449c.0638-.4301.0957-.6452.0007-.8912-.074-.1916-.2616-.409-.4404-.5101-.2295-.1299-.5007-.1297-1.0432-.1293l-5.6672.0037c-.2469.0002-.4822.0952-.6566.2699-.1339.1346-.3026.3042-.5089.4306a2 2 0 0 1-.5781.2395c-.2354.0565-.4745.0558-.6644.0553l-.0511-.0001h-2.6745l-.051.0001c-.1899.0005-.4291.0012-.6644-.0553a2 2 0 0 1-.578-.2395c-.2064-.1264-.375-.296-.509-.4306-.1765-.1772-.419-.2723-.6691-.2724z"
    />
  </svg>
);

export const Laptop02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.1614 3h11.6771c.5271 0 .9819 0 1.3564.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3745.0306.8293.0306 1.3564V13.4c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437C21.24 15 20.96 15 20.3999 15h-16.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437c-.109-.2139-.109-.4939-.109-1.054V7.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1794 3 5.6342 3 6.1614 3M2.4161 17c-.478 0-.717 0-.949.1338-.1705.0983-.3722.3383-.4397.5232-.0918.2515-.0611.4271.0002.7782.021.12.046.2346.0746.3413a3 3 0 0 0 2.1213 2.1213c.3855.1033.8235.1029 1.3313.1023H19.445c.5077.0006.9458.001 1.3313-.1023a3 3 0 0 0 2.1213-2.1213 4 4 0 0 0 .0743-.3404c.0614-.3519.0921-.5279.0002-.7793-.0676-.185-.2691-.4247-.4397-.5231C22.3006 17 22.0612 17 21.5826 17z"
    />
  </svg>
);

export const Lightbulb01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.5 9.5C3.5 4.8056 7.3056 1 12 1s8.5 3.8056 8.5 8.5c0 2.0452-.7241 3.9727-1.9369 5.4804-.1349.1676-.2023.2514-.3116.3304-.0882.0636-.2157.1247-.3206.1535-.13.0357-.2568.0357-.5105.0357H6.5797c-.2538 0-.3806 0-.5106-.0357-.1049-.0288-.2324-.0899-.3206-.1535-.1093-.079-.1767-.1628-.3116-.3304C4.2241 13.4727 3.5 11.5452 3.5 9.5M9.532 17.5c-.496 0-.744 0-.9378.086a1 1 0 0 0-.5082.5082C8 18.288 8 18.536 8 19.032c0 .4386 0 .8171.0213 1.1304.0226.3298.072.6597.207.9857a3 3 0 0 0 1.6236 1.6235c.326.135.6559.1845.9857.2071.3133.0213.6918.0213 1.1304.0213h.064c.4386 0 .8171 0 1.1304-.0213.3298-.0226.6597-.0721.9857-.2071a3 3 0 0 0 1.6235-1.6235c.135-.326.1845-.6559.2071-.9857C16 19.8491 16 19.4706 16 19.032c0-.496 0-.744-.086-.9378a1 1 0 0 0-.5082-.5082c-.1938-.086-.4418-.086-.9378-.086z"
    />
  </svg>
);

export const Lightbulb02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 5c-3.866 0-7 3.134-7 7 0 2.7924 1.635 5.2029 4 6.3264v1.6737c0 1.6569 1.3431 3 3 3s3-1.3431 3-3v-1.6737c2.3649-1.1235 4-3.534 4-6.3264 0-3.866-3.134-7-7-7M12 1c.5523 0 1 .4477 1 1v1c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.5523.4477-1 1-1M1 12c0-.5523.4477-1 1-1h1c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1M4.1928 4.1928c.3905-.3905 1.0237-.3905 1.4142 0l.6001.6c.3905.3906.3905 1.0238 0 1.4143s-1.0237.3905-1.4142 0l-.6001-.6c-.3905-.3906-.3905-1.0238 0-1.4143M19.8074 4.1929c.3905.3906.3904 1.0237-.0001 1.4142l-.6003.6001c-.3906.3905-1.0237.3904-1.4142-.0002s-.3904-1.0237.0002-1.4142l.6002-.6c.3906-.3906 1.0238-.3905 1.4142 0M20 12c0-.5523.4477-1 1-1h1c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Lightbulb03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5 22c0-.5523.4477-1 1-1h5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-5c-.5523 0-1-.4477-1-1M4 9c0-4.4183 3.5817-8 8-8s8 3.5817 8 8c0 2.9626-1.6104 5.5473-4 6.9295v.1025c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9857a3 3 0 0 1-1.6235 1.6235c-.326.135-.6559.1845-.9857.2071C12.8491 20 12.4706 20 12.032 20h-.064c-.4386 0-.8171 0-1.1304-.0213-.3298-.0226-.6597-.0721-.9856-.2071a3 3 0 0 1-1.6236-1.6235c-.135-.326-.1845-.6559-.207-.9857C8 16.8491 8 16.4706 8 16.032v-.1025C5.6104 14.5473 4 11.9626 4 9"
      clipRule="evenodd"
    />
  </svg>
);

export const Lightbulb04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C7.5817 1 4 4.5817 4 9c0 2.9626 1.6104 5.5473 4 6.9295v.1025c0 .4386 0 .8171.0213 1.1304.0226.3298.072.6597.207.9857a3 3 0 0 0 1.6236 1.6235c.326.135.6559.1845.9857.2071.3133.0213.6918.0213 1.1304.0213h.064c.4386 0 .8171 0 1.1304-.0213.3298-.0226.6597-.0721.9857-.2071a3 3 0 0 0 1.6235-1.6235c.135-.326.1845-.6559.2071-.9857C16 16.8491 16 16.4707 16 16.032v-.1025c2.3896-1.3822 4-3.9669 4-6.9295 0-4.4183-3.5817-8-8-8m-3 9c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1v-5h-1c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9.5 21c-.5523 0-1 .4477-1 1s.4477 1 1 1h5c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Lightbulb05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1c0 .5523.4477 1 1 1s1-.4477 1-1zM2 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h1c.5523 0 1-.4477 1-1s-.4477-1-1-1zM4.1928 4.1928c.3905-.3905 1.0237-.3905 1.4142 0l.6001.6c.3905.3906.3905 1.0238 0 1.4143s-1.0237.3905-1.4142 0l-.6001-.6c-.3905-.3906-.3905-1.0238 0-1.4143M19.8073 5.6071c.3905-.3905.3906-1.0236.0001-1.4142s-1.0236-.3907-1.4142-.0002l-.6002.6001c-.3906.3905-.3907 1.0236-.0002 1.4142s1.0236.3907 1.4142.0002zM20 12c0-.5523.4477-1 1-1h1c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1c-.5523 0-1-.4477-1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 5c-3.866 0-7 3.134-7 7 0 2.1532.973 4.0792 2.5 5.3621v1.4764c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964.3745.0306.8293.0306 1.3564.0306h.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167.0306-.3745.0306-.8293.0306-1.3564v-1.4765C18.0269 16.0792 19 14.1532 19 12c0-3.866-3.134-7-7-7m-3 8.5c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4h-1c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Microphone01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C9.7909 1 8 2.7909 8 5v7c0 2.2091 1.7909 4 4 4s4-1.7909 4-4V5c0-2.2091-1.7909-4-4-4"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M6 10c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 4.0803 3.0547 7.4471 7.0019 7.9383A1 1 0 0 0 11 20v1H8c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3v-1a1 1 0 0 0-.0019-.0617C16.9453 19.4471 20 16.0803 20 12v-2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6z"
    />
  </svg>
);

export const Microphone02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 11c.5523 0 1 .4477 1 1v1c0 3.866 3.134 7 7 7s7-3.134 7-7v-1c0-.5523.4477-1 1-1s1 .4477 1 1v1c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9v-1c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 7c0-2.7614 2.2386-5 5-5s5 2.2386 5 5v6c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5z"
      clipRule="evenodd"
    />
  </svg>
);

export const MicrophoneOff01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L8 9.4142V12c0 2.2092 1.7909 4 4 4a3.985 3.985 0 0 0 2.0318-.5539l1.4447 1.4446C14.4957 17.5892 13.2958 18 12 18c-3.3137 0-6-2.6863-6-6v-2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 4.0796 3.0537 7.446 7 7.9381V21H8c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3v-1.0619c1.4607-.1821 2.7991-.7581 3.9056-1.6182l4.3873 4.3872c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-4.3872-4.3873C19.3729 15.551 20 13.8487 20 12v-2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 1.2958-.4108 2.4957-1.1093 3.4765l-4.736-4.7362q-4.7234-4.724-9.4476-9.4474"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M16 11.7574V5c0-2.2091-1.7909-4-4-4-1.8306 0-3.374 1.2297-3.8492 2.9082z"
    />
  </svg>
);

export const MicrophoneOff02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L7 8.4142V13c0 2.7615 2.2386 5 5 5 1.2758 0 2.4397-.4783 3.3223-1.2635l1.4161 1.4161C15.4909 19.3006 13.8275 20 12 20c-3.866 0-7-3.134-7-7v-1c0-.5523-.4477-1-1-1s-1 .4477-1 1v1c0 4.9706 4.0294 9 9 9 2.3801 0 4.5449-.9248 6.1535-2.4323l3.1394 3.1394c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m17 12.7574-8.894-8.894C9.0225 2.727 10.4264 2 12 2c2.7614 0 5 2.2386 5 5z"
    />
  </svg>
);

export const Modem01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.6358 1.2219c.3905.3905.3905 1.0236 0 1.4142C2.2399 6.0319 2.125 11.4665 5.2913 15H11v-6c0-.5523.4477-1 1-1s1 .4477 1 1v6h5.7087c3.1662-3.5336 3.0513-8.9682-.3445-12.364-.3906-.3906-.3906-1.0237 0-1.4142.3905-.3906 1.0236-.3906 1.4142 0 3.8034 3.8033 4.2393 9.6989 1.3078 13.982q.0309.0117.0618.0246a3 3 0 0 1 1.6236 1.6235c.135.326.1845.6559.207.9857.0214.3133.0214.6918.0214 1.1304v.064c0 .4386 0 .8171-.0214 1.1304-.0225.3298-.072.6597-.207.9856a3 3 0 0 1-1.6236 1.6236c-.3259.135-.6558.1845-.9856.207-.3133.0214-.6917.0214-1.1303.0214H4.968c-.4386 0-.8172 0-1.1304-.0214-.3298-.0225-.6597-.072-.9857-.207a3 3 0 0 1-1.6236-1.6236c-.135-.3259-.1845-.6558-.207-.9856C1 19.8492 1 19.4707 1 19.0321v-.064c0-.4386 0-.8171.0213-1.1304.0225-.3298.072-.6597.207-.9857a3 3 0 0 1 1.6855-1.6481C-.0178 10.9208.4182 5.0252 4.2216 1.2219c.3905-.3906 1.0237-.3906 1.4142 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.4644 5.4645c.3906-.3905.3906-1.0237 0-1.4142s-1.0236-.3905-1.4142 0c-2.7336 2.7337-2.7336 7.1658 0 9.8995.3906.3905 1.0237.3905 1.4142 0 .3906-.3905.3906-1.0237 0-1.4142-1.9526-1.9526-1.9526-5.1184 0-7.071M16.9498 4.0503c-.3906-.3905-1.0237-.3905-1.4143 0s-.3905 1.0237 0 1.4142c1.9527 1.9527 1.9527 5.1185 0 7.0711-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4143 0c2.7336-2.7337 2.7336-7.1658 0-9.8995"
    />
  </svg>
);

export const Modem02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.1026 1.6912c.4167.3624.4608.994.0984 1.4108-2.0151 2.3176-2.6483 5.4236-1.8934 8.2386.143.5334-.1734 1.0818-.7068 1.2248s-1.0819-.1734-1.225-.7068c-.921-3.4345-.151-7.2318 2.316-10.069.3624-.4167.994-.4608 1.4108-.0984M8.073 5.904c.3426-.4332.269-1.062-.1641-1.4046s-1.062-.2692-1.4047.164c-1.4037 1.775-1.8236 4.0694-1.2655 6.1532.1429.5334.6912.8501 1.2247.7072s.8501-.6912.7072-1.2246c-.3998-1.4928-.097-3.1314.9024-4.3952M16.0911 4.4994c-.4332.3425-.5067.9714-.1641 1.4046.9994 1.2638 1.3022 2.9024.9024 4.3952-.1429.5334.1737 1.0817.7072 1.2246s1.0818-.1738 1.2247-.7072c.5581-2.0838.1382-4.3781-1.2655-6.1532-.3426-.4332-.9715-.5066-1.4047-.164M20.3047 1.7897c-.3624-.4168-.994-.4609-1.4108-.0985s-.4608.994-.0985 1.4108c2.0152 2.3176 2.6484 5.4236 1.8935 8.2386-.1431.5334.1734 1.0818.7068 1.2248s1.0819-.1734 1.2249-.7068c.921-3.4345.1511-7.2318-2.3159-10.069"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 9c0-.5523-.4477-1-1-1s-1 .4477-1 1v5H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 17.1795 1 17.6343 1 18.1615v.677c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 23 4.6343 23 5.1614 23h13.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 19.8205 23 19.3657 23 18.8386v-.6772c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 14 19.3657 14 18.8385 14H13zm-7.5 8.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Monitor01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.2413 2H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 6.2894 1 6.9537 1 7.7587v4.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 18 5.9537 18 6.7587 18H11v2H8c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3v-2h4.2413c.8049 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 13.7106 23 13.0463 23 12.2413V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 2 18.0463 2 17.2413 2"
      clipRule="evenodd"
    />
  </svg>
);

export const Monitor02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 21c-1.438 0-2.7937.3252-3.9957.9017-.498.2388-1.0953.0287-1.3341-.4692s-.0288-1.0953.4692-1.3342C8.607 19.3944 10.2579 19 12 19s3.393.3944 4.8606 1.0983c.498.2389.7081.8362.4692 1.3342s-.8361.708-1.3341.4692C14.7937 21.3252 13.438 21 12 21M6.7587 2h10.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C23 6.2894 23 6.9537 23 7.7587v4.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 18 18.0463 18 17.2413 18H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 13.7106 1 13.0463 1 12.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 2 5.9537 2 6.7587 2"
      clipRule="evenodd"
    />
  </svg>
);

export const Monitor03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.2413 2H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 6.2894 1 6.9537 1 7.7587V11.4c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C1.76 13 2.04 13 2.6 13h18.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C23 12.2401 23 11.9601 23 11.4V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 2 18.0463 2 17.2413 2M22.8805 15.8398c.0465-.2549.0697-.3823.0243-.5089-.037-.1029-.1252-.2086-.2198-.2635C22.5687 15 22.4216 15 22.1275 15H1.8725c-.2941 0-.4412 0-.5575.0674-.0946.0549-.1828.1606-.2198.2635-.0454.1266-.0222.254.0243.5089.0616.3376.159.6672.3165.9762a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 19 5.9537 19 6.7587 19h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.1575-.309.2549-.6386.3165-.9762M8 20c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Monitor04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.8385 2H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1795 1 5.6343 1 6.1614v7.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 18 4.6342 18 5.1614 18H8v3c0 .5523.4477 1 1 1h6c.5523 0 1-.4477 1-1v-3h2.8385c.5271 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 14.8205 23 14.3657 23 13.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 2 19.3657 2 18.8385 2M10 18h4v2h-4z"
      clipRule="evenodd"
    />
  </svg>
);

export const Monitor05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.8385 3h-3.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C11 6.1795 11 6.6342 11 7.1613v9.6772c0 .5271 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964.3745.0306.8293.0306 1.3564.0306h3.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 17.8205 23 17.3657 23 16.8386V7.1615c0-.5272 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C19.8205 3 19.3657 3 18.8385 3M15.75 8.25c0-.6903.5596-1.25 1.25-1.25s1.25.5597 1.25 1.25S17.6904 9.5 17 9.5s-1.25-.5596-1.25-1.25M17 12.5c-1.3807 0-2.5 1.1193-2.5 2.5s1.1193 2.5 2.5 2.5 2.5-1.1193 2.5-2.5-1.1193-2.5-2.5-2.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8 5H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 8.1795 1 8.6343 1 9.1614v3.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C4.1795 17 4.6343 17 5.1615 17H8c.5523 0 1-.4477 1-1V6c0-.5523-.4477-1-1-1M5.5 19c-.5523 0-1 .4477-1 1s.4477 1 1 1H8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Mouse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C7.5817 1 4 4.5817 4 9v6c0 4.4183 3.5817 8 8 8s8-3.5817 8-8V9c0-4.4183-3.5817-8-8-8m1 5c0-.5523-.4477-1-1-1s-1 .4477-1 1v3c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const MusicNote01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.968 4.1988c-.1383.011-.3286.0418-.6666.0981l-8.8 1.4667c-.2524.042-.3869.0651-.4828.0887l-.0097.0024-.0008.01c-.0074.0984-.0081.235-.0081.4907v11.6482C9.998 20.2111 8.208 22 6 22c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4a3.98 3.98 0 0 1 2 .5351V6.327c0-.2161 0-.43.0138-.6131.0154-.2038.0516-.4406.1614-.6854a2 2 0 0 1 .7173-.8467c.2234-.1486.451-.2232.6495-.272.1784-.0437.3894-.0788.6025-.1143l8.8629-1.4772c.2903-.0484.5679-.0947.8032-.1133.2541-.02.5641-.0189.8858.1006a2 2 0 0 1 1.0385.8798c.1707.2977.2228.6033.2448.8572.0204.235.0203.5164.0203.8107V16a1 1 0 0 1-.0133.1634C21.901 18.2968 20.1444 20 17.99 20c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4c.7327 0 1.4194.197 2.01.5409V4.8888c0-.3427-.0009-.5356-.0128-.6737l-.0017-.0175z"
    />
  </svg>
);

export const MusicNote02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.7259 3.245c-.3516-.176-.6742-.3373-.948-.4442-.282-.1102-.654-.2228-1.0702-.1613a2 2 0 0 0-1.3466.8322c-.2412.3448-.3068.7279-.3344 1.0294-.0268.2927-.0267.6535-.0267 1.0466v8.9874A3.98 3.98 0 0 0 9 14c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4c2.2081 0 3.9983-1.7891 4-3.9968V5.5888c0-.448.001-.7153.0184-.9054l.0031-.0307.0287.011c.1779.0695.4173.188.8181.3885l3.6845 1.8422c.494.247 1.0946.0468 1.3416-.4472s.0468-1.0947-.4472-1.3416z"
      clipRule="evenodd"
    />
  </svg>
);

export const MusicNotePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.2779 2.8008c.2738.107.5964.2683.948.4441l3.7213 1.8607c.494.247.6942.8476.4472 1.3416s-.8476.6942-1.3416.4472l-3.6845-1.8422c-.4008-.2004-.6402-.319-.8181-.3885l-.0287-.011-.0031.0306c-.0174.1902-.0184.4574-.0184.9055v12.414399999999999C15.4983 20.2109 13.7081 22 11.5 22c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4c.7286 0 1.4117.1948 2 .5351V5.5477c0-.3931-.0001-.7539.0267-1.0466.0276-.3015.0932-.6846.3344-1.0294a2 2 0 0 1 1.3466-.8322c.4162-.0615.7882.0511 1.0702.1613M6.5 3c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V8h-2c-.5523 0-1-.4477-1-1s.4477-1 1-1h2V4c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const PauseCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m-1.5 8c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1s1-.4477 1-1zm5 0c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const PauseSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M10.5 9c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1s1-.4477 1-1zm5 0c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Phone01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.8385 1h-7.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C4 4.1795 4 4.6343 4 5.1614v13.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C7.1795 23 7.6343 23 8.1614 23h7.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C20 19.8205 20 19.3658 20 18.8386V5.1615c0-.5271 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C16.8205 1 16.3657 1 15.8385 1M12 16c-.8284 0-1.5.6716-1.5 1.5S11.1716 19 12 19s1.5-.6716 1.5-1.5S12.8284 16 12 16"
      clipRule="evenodd"
    />
  </svg>
);

export const Phone02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.8385 1h-7.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C4 4.1795 4 4.6343 4 5.1614v13.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C7.1795 23 7.6343 23 8.1614 23h7.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C20 19.8205 20 19.3658 20 18.8386V5.1615c0-.5271 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C16.8205 1 16.3657 1 15.8385 1M15 3v.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C14.2401 5 13.9601 5 13.4 5h-2.8c-.5601 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C9 4.24 9 3.96 9 3.4V3z"
      clipRule="evenodd"
    />
  </svg>
);

export const Play = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8.0063 2.8024.036.024L18.591 9.859c.3052.2034.5882.3921.8055.5674.2269.1829.4943.4366.6482.8077a2 2 0 0 1 0 1.5323c-.1539.3711-.4213.6247-.6482.8077-.2173.1753-.5003.3639-.8055.5673L8.0063 21.1978c-.3731.2487-.7086.4724-.9932.6267-.285.1544-.676.3308-1.1323.3035a2 2 0 0 1-1.4758-.7898c-.2758-.3646-.346-.7878-.3755-1.1104C3.9999 19.9053 4 19.5021 4 19.0537V4.9465c0-.4484 0-.8516.0295-1.174.0296-.3227.0997-.7459.3755-1.1105a2 2 0 0 1 1.4758-.7898c.4564-.0273.8474.1491 1.1323.3035.2846.1543.62.378.9932.6267"
      clipRule="evenodd"
    />
  </svg>
);

export const PlayCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M9.5997 8.116C9.5 8.2494 9.5 8.488 9.5 8.9653v6.0694c0 .4773 0 .7159.0997.8491a.5.5 0 0 0 .3647.1991c.166.0119.3667-.1172.7682-.3753l4.7206-3.0347c.3484-.2239.5226-.3359.5827-.4783a.5.5 0 0 0 0-.3892c-.0601-.1424-.2343-.2544-.5827-.4783l-4.7206-3.0347c-.4015-.2581-.6022-.3871-.7682-.3753a.5.5 0 0 0-.3647.199"
      clipRule="evenodd"
    />
  </svg>
);

export const PlaySquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M9.5997 8.116C9.5 8.2494 9.5 8.488 9.5 8.9653v6.0694c0 .4773 0 .7159.0997.8491a.5.5 0 0 0 .3647.1991c.166.0119.3667-.1172.7682-.3753l4.7206-3.0347c.3484-.2239.5226-.3359.5827-.4783a.5.5 0 0 0 0-.3892c-.0601-.1424-.2343-.2544-.5827-.4783l-4.7206-3.0347c-.4015-.2581-.6022-.3871-.7682-.3753a.5.5 0 0 0-.3647.199"
      clipRule="evenodd"
    />
  </svg>
);

export const Podcast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 18c0-1.6569 1.3431-3 3-3s3 1.3431 3 3v2c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 10.785C2 5.3583 6.5002 1 12 1s10 4.3584 10 9.785c0 3.3469-1.7212 6.2851-4.3209 8.0433-.4575.3094-1.0792.1894-1.3886-.2681s-.1893-1.0791.2681-1.3885C18.6458 15.7601 20 13.4239 20 10.785 20 6.5082 16.4411 3 12 3c-4.441 0-8 3.5082-8 7.785 0 2.6389 1.3542 4.9751 3.4414 6.3867.4574.3094.5775.931.268 1.3885-.3093.4575-.931.5775-1.3885.2681C3.7212 17.0701 2 14.1319 2 10.785"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 7c-2.2577 0-4 1.727-4 3.7505 0 .9746.4002 1.8686 1.0706 2.5462.3884.3926.385 1.0258-.0076 1.4142s-1.0258.385-1.4142-.0076C6.6373 13.6809 6 12.2922 6 10.7505 6 7.5272 8.7354 5 12 5s6 2.5272 6 5.7505c0 1.5426-.6374 2.9305-1.6488 3.9528-.3884.3926-1.0216.396-1.4142.0076s-.396-1.0216-.0076-1.4142C15.5999 12.619 16 11.7259 16 10.7505 16 8.727 14.2578 7 12 7"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 11c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Power01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.0001 1c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.3371 5.9328c.3906.3904.3907 1.0236.0002 1.4142a8 8 0 1 0 11.3156 0c-.3905-.3906-.3904-1.0238.0002-1.4142.3906-.3905 1.0238-.3904 1.4142.0002a10 10 0 0 1-1.5168 15.3848 9.9998 9.9998 0 0 1-14.7939-4.4873A10 10 0 0 1 4.923 5.933c.3905-.3906 1.0236-.3907 1.4142-.0002"
      clipRule="evenodd"
    />
  </svg>
);

export const Power02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m1 6c0-.5523-.4477-1-1-1s-1 .4477-1 1v5c0 .5523.4477 1 1 1s1-.4477 1-1zM8.7995 9.6002c.3317-.4416.2427-1.0684-.1988-1.4002s-1.0684-.2427-1.4002.1988A5.978 5.978 0 0 0 6 12c0 3.3137 2.6863 6 6 6s6-2.6863 6-6a5.978 5.978 0 0 0-1.2005-3.6012c-.3318-.4415-.9586-.5305-1.4002-.1988s-.5305.9586-.1988 1.4002A3.978 3.978 0 0 1 16 12c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4c0-.9018.2972-1.7313.7995-2.3998"
      clipRule="evenodd"
    />
  </svg>
);

export const Power03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m1 6c0-.5523-.4477-1-1-1s-1 .4477-1 1v10c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Printer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.1615 1h5.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C19 4.1795 19 4.6342 19 5.1613v.8658q.1302.0072.2519.0171c.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642.0442.5412.0442 1.2055.0442 2.0105v2.3789c.0005.7954.0008 1.386-.1363 1.8977a4 4 0 0 1-2.8284 2.8284c-.3075.0824-.6436.1152-1.0354.1281-.0003.4625-.003.8655-.0306 1.2032-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C15.8205 23 15.3658 23 14.8387 23H9.1614c-.527 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167-.0276-.3377-.0303-.7407-.0306-1.2032-.3918-.013-.7277-.0457-1.0352-.1281a4 4 0 0 1-2.8284-2.8284C.9993 15.5236.9996 14.933 1 14.1376v-2.3789c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918A10 10 0 0 1 5 6.0272v-.8657c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C8.1795 1 8.6343 1 9.1615 1M7 6h10v-.8c0-.5766-.0008-.9488-.0239-1.2322-.0222-.2716-.0599-.3723-.0851-.4218a1 1 0 0 0-.437-.437c-.0495-.0252-.1502-.0629-.4218-.085C15.7488 3.0007 15.3766 3 14.8 3H9.2c-.5765 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4218C7.0007 4.2512 7 4.6235 7 5.2zm0 12.8c0 .5766.0008.9488.024 1.2322.0221.2716.0598.3723.085.4218a1 1 0 0 0 .437.437c.0495.0252.1502.0629.4218.0851.2834.0231.6556.0239 1.2322.0239h5.6c.5766 0 .9488-.0008 1.2322-.0239.2716-.0222.3723-.0599.4218-.0851a1 1 0 0 0 .437-.437c.0252-.0495.0629-.1502.0851-.4218.0231-.2834.0239-.6556.0239-1.2322v-1.6c0-.5766-.0008-.9488-.0239-1.2322-.0222-.2716-.0599-.3723-.0851-.4218a1 1 0 0 0-.437-.437c-.0495-.0252-.1502-.0629-.4218-.0851a5 5 0 0 0-.1107-.0076c-.2689-.0157-.617-.0163-1.1214-.0163h-5.6c-.5763 0-.9486.0008-1.2318.0239q-.0002 0 0 0c-.2717.0222-.3727.0599-.4222.0851a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4218C7.0008 16.2512 7 16.6234 7 17.2zm7-8.3c0-.5523.4477-1 1-1h3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Recording01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 9c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1M7.5 5c.5523 0 1 .4477 1 1v12c0 .5523-.4477 1-1 1s-1-.4477-1-1V6c0-.5523.4477-1 1-1M12 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M16.5 5c.5523 0 1 .4477 1 1v12c0 .5523-.4477 1-1 1s-1-.4477-1-1V6c0-.5523.4477-1 1-1M21 9c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Recording02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 9c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1M7.5 10c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1M12 5c.5523 0 1 .4477 1 1v12c0 .5523-.4477 1-1 1s-1-.4477-1-1V6c0-.5523.4477-1 1-1M16.5 2c.5523 0 1 .4477 1 1v18c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M21 9c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Recording03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m2 5c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V7c0-.5523.4477-1 1-1m-3 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1s1-.4477 1-1zm-4 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1zm12 0c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Repeat01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.2929 1.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 7H7.8c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 9.3611 4 9.9434 4 10.8v.2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.2413c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 5 6.9537 5 7.7587 5h10.8271l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142M21 12c-.5523 0-1 .4477-1 1v.2c0 .8566-.0008 1.4389-.0376 1.889-.0358.4384-.1007.6626-.1804.819a2 2 0 0 1-.874.874c-.1564.0797-.3806.1446-.819.1804-.4501.0368-1.0324.0376-1.889.0376H5.4142l2.293-2.2929c.3904-.3905.3904-1.0237 0-1.4142-.3906-.3905-1.0238-.3905-1.4143 0l-4 4c-.3905.3905-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L5.4142 19h10.8271c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 14.7106 22 14.0463 22 13.2413V13c0-.5523-.4477-1-1-1"
    />
  </svg>
);

export const Repeat02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.2929 1.2929c.3905-.3905 1.0237-.3905 1.4142 0l3 3c.3905.3905.3905 1.0237 0 1.4142l-3 3c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L11.5858 6H6.8c-.8566 0-1.4388.0008-1.889.0376-.4383.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3807-.1804.819C3.0008 8.3613 3 8.9436 3 9.8v5.7c0 .4962.0022.6475.0171.7611a2 2 0 0 0 1.7219 1.7218c.1136.015.2648.0171.761.0171.5523 0 1 .4477 1 1s-.4477 1-1 1h-.0687c-.3975.0001-.692.0002-.9534-.0342-1.795-.2363-3.2073-1.6487-3.4437-3.4437C.9998 16.2607 1 15.9662 1 15.5688v-5.81c0-.805 0-1.4694.0442-2.0106.046-.5621.1445-1.0788.3918-1.5641A4 4 0 0 1 3.184 4.436c.4854-.2473 1.0021-.3459 1.5642-.3918C5.2894 4 5.9538 4 6.7587 4h4.8271l-1.2929-1.2929c-.3905-.3905-.3905-1.0237 0-1.4142M19.2611 6.0171c-.1136-.015-.2649-.017-.7611-.017-.5523 0-1-.4478-1-1 0-.5524.4477-1 1-1h.0688c.3974-.0002.6919-.0003.9533.0341 1.795.2363 3.2074 1.6488 3.4437 3.4437.0344.2615.0343.556.0342.9533v5.8101c0 .805 0 1.4694-.0442 2.0106-.0459.562-.1445 1.0788-.3917 1.5641a4 4 0 0 1-1.7481 1.748c-.4853.2473-1.0021.3459-1.5641.3918C18.7106 20 18.0463 20 17.2413 20h-4.8271l1.2929 1.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142l3-3c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142L12.4142 18H17.2c.8566 0 1.4389-.0008 1.889-.0375.4384-.0358.6626-.1008.819-.1805a2 2 0 0 0 .874-.874c.0797-.1564.1447-.3806.1805-.819.0367-.4501.0375-1.0324.0375-1.889V8.5c0-.4962-.0021-.6474-.0171-.761a2 2 0 0 0-1.7218-1.7219"
    />
  </svg>
);

export const Repeat03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L11.5858 4H9c-4.4183 0-8 3.5817-8 8 0 3.1928 1.8704 5.9468 4.571 7.2296.4988.237 1.0953.0247 1.3323-.4741s.0247-1.0954-.4742-1.3324C4.3997 16.459 3 14.392 3 12c0-3.3137 2.6863-6 6-6h2.5858l-1.2929 1.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142zM18.4291 4.7703c-.4989-.237-1.0954-.0247-1.3324.4742-.2369.4988-.0246 1.0953.4742 1.3323C19.6003 7.541 21 9.608 21 12c0 3.3138-2.6863 6-6 6h-2.5857l1.2928-1.2928c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-1.2929-1.293H15c4.4183 0 8-3.5817 8-8 0-3.1928-1.8704-5.9467-4.5709-7.2296"
    />
  </svg>
);

export const Repeat04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.7071.893c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l.2968.2968C6.0118 3.2853 2.5 7.2325 2.5 12c0 3.1587 1.5426 5.9572 3.9111 7.6828.4464.3253 1.072.227 1.3971-.2193.3252-.4464.227-1.0719-.2194-1.3971C5.7149 16.701 4.5 14.4924 4.5 12c0-3.6442 2.5992-6.6814 6.0448-7.359l-.2519.252c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l2-2c.3905-.3905.3905-1.0237 0-1.4142zM17.5889 4.317c-.4464-.3251-1.0719-.227-1.3971.2195-.3253.4463-.227 1.0718.2193 1.397C18.2853 7.299 19.5 9.5076 19.5 12c0 3.6442-2.5991 6.6814-6.0447 7.3589l.2518-.2518c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-2 2c-.3905.3905-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-.2968-.2968c4.5779-.6813 8.0897-4.6286 8.0897-9.3961 0-3.1587-1.5426-5.9572-3.9111-7.6828"
    />
  </svg>
);

export const Rss01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 11c0-.5523.4477-1 1-1a10.0003 10.0003 0 0 1 10 10c0 .5523-.4477 1-1 1s-1-.4477-1-1a8.0004 8.0004 0 0 0-8-8c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 4c0-.5523.4477-1 1-1a17 17 0 0 1 17 17c0 .5523-.4477 1-1 1s-1-.4477-1-1A15 15 0 0 0 4 5c-.5523 0-1-.4477-1-1M3 19c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Rss02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 19c0-1.6566 1.3434-3 3-3s3 1.3434 3 3-1.3434 3-3 3-3-1.3433-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.518 15.4814c-1.1837-1.1837-3.0373-1.8206-5.369-1.47-.5462.0821-1.0555-.2941-1.1376-.8402-.0822-.5462.294-1.0555.8402-1.1376 2.8532-.429 5.3773.3302 7.0807 2.0337 1.7032 1.7034 2.4624 4.2277 2.034 7.0808-.082.5462-.5912.9225-1.1374.8405s-.9224-.5913-.8404-1.1374c.3501-2.3319-.2868-4.186-1.4705-5.3698"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.0431 11.9569C9.9265 9.8403 6.7944 8.6701 3.098 9.0331c-.5496.054-1.039-.3478-1.093-.8975s.3479-1.039.8975-1.093c4.2413-.4165 7.98.9253 10.5548 3.5001s3.9166 6.3135 3.5 10.5548c-.054.5496-.5433.9514-1.0929.8975s-.9515-.5433-.8975-1.093c.363-3.6964-.8072-6.8285-2.9238-8.9451"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.9506 20.9273c.7342-10.0834-6.7944-17.612-16.8777-16.8778-.5509.0401-1.03-.3739-1.07-.9247s.3739-1.0299.9247-1.07c11.3-.8228 19.8405 7.7177 19.0177 19.0177-.0401.5508-.5191.9648-1.07.9247-.5508-.0401-.9648-.5191-.9247-1.0699"
      clipRule="evenodd"
    />
  </svg>
);

export const Shuffle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l1.293 1.293h-.1489c-.8107-.0005-1.4225-.0009-1.9938.1726a4 4 0 0 0-1.3775.7372c-.4613.3791-.8003.8884-1.2496 1.5632L8.5929 15.308c-.5555.8332-.7262 1.0709-.9285 1.2372a2 2 0 0 1-.6888.3686c-.2506.0761-.543.0863-1.5445.0863H3c-.5523 0-1 .4477-1 1s.4477 1 1 1l2.563.0001c.8107.0004 1.4225.0008 1.9938-.1727a4 4 0 0 0 1.3775-.7372c.4613-.3791.8003-.8884 1.2496-1.5632l5.2232-7.8349c.5555-.8332.7262-1.0709.9285-1.2372a2 2 0 0 1 .6888-.3686c.2506-.0761.543-.0863 1.5445-.0863h.0168l-1.2928 1.2928c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142zM18.7071 14.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l1.293 1.293h-.017c-1.0015 0-1.2939-.0102-1.5445-.0863a2 2 0 0 1-.6888-.3686c-.2023-.1663-.373-.404-.9285-1.2372l-.2417-.3626c-.3064-.4595-.9272-.5837-1.3868-.2773s-.5837.9272-.2773 1.3867l.3148.4723c.4493.6748.7883 1.1841 1.2496 1.5632a4 4 0 0 0 1.3775.7372c.5713.1735 1.1831.1731 1.9938.1727l.1487-.0001-1.2928 1.2928c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142z"
    />
    <path
      fill="currentColor"
      d="M6.9756 7.0864c-.2506-.0761-.543-.0863-1.5445-.0863H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h2.563c.8106-.0005 1.4225-.0009 1.9938.1726a4 4 0 0 1 1.3775.7372c.4613.3791.8003.8884 1.2496 1.5632l.3148.4723c.3064.4595.1822 1.0804-.2773 1.3868s-1.0804.1821-1.3868-.2774l-.2417-.3626c-.5555-.8332-.7262-1.0709-.9285-1.2372a2 2 0 0 0-.6888-.3686"
    />
  </svg>
);

export const Shuffle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 2h5c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142L3.7071 21.7071c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.5858 4H16c-.5523 0-1-.4477-1-1s.4477-1 1-1M3.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l6 6c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142zM15.7071 14.2929 20 18.5858V16c0-.5523.4477-1 1-1s1 .4477 1 1v5c0 .5523-.4477 1-1 1h-5c-.5523 0-1-.4477-1-1s.4477-1 1-1h2.5858l-4.2929-4.2929c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0"
    />
  </svg>
);

export const Signal01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.5355 7.0503c.3906-.3906 1.0237-.3906 1.4142 0 2.7337 2.7337 2.7337 7.1658 0 9.8995-.3905.3905-1.0236.3905-1.4142 0s-.3905-1.0237 0-1.4142c1.9527-1.9527 1.9527-5.1185 0-7.0711-.3905-.3905-.3905-1.0237 0-1.4142M8.4645 7.0502c.3905.3906.3905 1.0237 0 1.4142-1.9527 1.9527-1.9527 5.1185 0 7.0711.3905.3905.3905 1.0237 0 1.4142-.3906.3906-1.0237.3906-1.4142 0-2.7337-2.7336-2.7337-7.1658 0-9.8995.3905-.3905 1.0236-.3905 1.4142 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.636 4.2219c.3906.3905.3906 1.0236 0 1.4142-3.5147 3.5147-3.5147 9.2132 0 12.7279.3906.3905.3906 1.0237 0 1.4142s-1.0236.3905-1.4142 0c-4.2957-4.2958-4.2957-11.2606 0-15.5563.3906-.3906 1.0237-.3906 1.4142 0M18.364 4.2219c.3905-.3905 1.0237-.3905 1.4142 0 4.2957 4.2958 4.2957 11.2606 0 15.5563-.3905.3906-1.0237.3906-1.4142 0-.3906-.3905-.3906-1.0236 0-1.4142 3.5147-3.5147 3.5147-9.2132 0-12.7279-.3906-.3905-.3906-1.0237 0-1.4142M9 12c0-1.6568 1.3431-3 3-3s3 1.3432 3 3-1.3431 3-3 3-3-1.3431-3-3"
      clipRule="evenodd"
    />
  </svg>
);

export const Signal02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.6358 2.2219c.3905.3905.3905 1.0236 0 1.4142-3.5147 3.5147-3.5147 9.2132 0 12.7279.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0c-4.2958-4.2958-4.2958-11.2606 0-15.5563.3905-.3906 1.0237-.3906 1.4142 0"
    />
    <path
      fill="currentColor"
      d="M8.4644 6.4645c.3906-.3905.3906-1.0237 0-1.4142s-1.0236-.3905-1.4142 0c-2.7336 2.7337-2.7336 7.1658 0 9.8995.3906.3905 1.0237.3905 1.4142 0 .3906-.3905.3906-1.0237 0-1.4142-1.9526-1.9526-1.9526-5.1185 0-7.071M16.9498 5.0503c-.3906-.3905-1.0237-.3905-1.4143 0s-.3905 1.0237 0 1.4142c1.9527 1.9526 1.9527 5.1185 0 7.0711-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4143 0c2.7336-2.7337 2.7336-7.1658 0-9.8995"
    />
    <path
      fill="currentColor"
      d="M19.7784 2.2219c-.3906-.3906-1.0237-.3906-1.4142 0-.3906.3905-.3906 1.0236 0 1.4142 3.5147 3.5147 3.5147 9.2132 0 12.7279-.3906.3905-.3906 1.0237 0 1.4142s1.0236.3905 1.4142 0c4.2957-4.2958 4.2957-11.2606 0-15.5563"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 12.8294c1.1652-.4118 2-1.5231 2-2.8293 0-1.6569-1.3432-3-3-3s-3 1.3431-3 3c0 1.3062.8348 2.4175 2 2.8293v8.1707c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Signal03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.5355 8.4645c-1.9526-1.9527-5.1184-1.9527-7.071 0-1.9527 1.9526-1.9527 5.1184 0 7.071.3905.3906.3905 1.0237 0 1.4142-.3906.3906-1.0237.3906-1.4142 0-2.7337-2.7336-2.7337-7.1658 0-9.8994s7.1658-2.7337 9.8994 0 2.7337 7.1658 0 9.8994c-.3905.3906-1.0236.3906-1.4142 0s-.3905-1.0236 0-1.4142c1.9527-1.9526 1.9527-5.1184 0-7.071"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.7071 11.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142.3905 1.0237 0 1.4142-1.0237.3905-1.4142 0c-1.1716-1.1716-1.1716-3.071 0-4.2426s3.071-1.1716 4.2426 0 1.1716 3.071 0 4.2426c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.364 5.636c-3.5148-3.5147-9.2132-3.5147-12.728 0-3.5147 3.5148-3.5147 9.2132 0 12.728.3906.3905.3906 1.0236 0 1.4142s-1.0236.3905-1.4142 0c-4.2957-4.2958-4.2957-11.2606 0-15.5564s11.2606-4.2957 15.5564 0 4.2957 11.2606 0 15.5564c-.3906.3905-1.0237.3905-1.4142 0-.3906-.3906-.3906-1.0237 0-1.4142 3.5147-3.5148 3.5147-9.2132 0-12.728"
      clipRule="evenodd"
    />
  </svg>
);

export const Simcard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="currentColor" d="M9 17v-3h6v3z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.6911 1.1106C13.2284.9995 12.7487.9997 12.1137 1h-3.355c-.805 0-1.4693 0-2.0105.0443-.5621.0459-1.0788.1444-1.5642.3917a4 4 0 0 0-1.748 1.7481c-.2473.4853-.3459 1.002-.3918 1.5641C3 5.2894 3 5.9538 3 6.7588v10.4826c0 .8049 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5641a4 4 0 0 0 1.748 1.7481c.4854.2473 1.002.3458 1.5642.3918.5412.0442 1.2055.0442 2.0105.0442h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.046 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.7481c.2473-.4853.3459-1.002.3918-1.5641C21 18.7107 21 18.0463 21 17.2414v-7.355c.0003-.635.0006-1.1148-.1105-1.5775a4 4 0 0 0-.4789-1.1562c-.2487-.4057-.5881-.7448-1.0373-1.1936L16.041 2.6268c-.4488-.4492-.7879-.7887-1.1936-1.0373a4 4 0 0 0-1.1563-.479M8.7769 12c-.1191 0-.2614-.0001-.3867.0101-.1452.0119-.3532.0424-.5712.1534a1.5 1.5 0 0 0-.6555.6555c-.111.218-.1415.426-.1533.5712-.0103.1253-.0102.2676-.0102.3867v3.4463c0 .1191 0 .2613.0102.3866.0118.1453.0423.3533.1533.5712a1.5 1.5 0 0 0 .6555.6555c.218.1111.426.1415.5712.1534.1253.0102.2675.0102.3866.0101h6.4464c.1191.0001.2613.0001.3866-.0101.1453-.0119.3533-.0423.5712-.1534a1.5 1.5 0 0 0 .6555-.6555c.1111-.2179.1415-.4259.1534-.5712.0102-.1253.0102-.2675.0101-.3867v-3.4462c.0001-.1191.0001-.2614-.0101-.3867-.0119-.1452-.0423-.3532-.1534-.5712a1.5 1.5 0 0 0-.6555-.6555c-.2179-.111-.4259-.1415-.5712-.1534-.1253-.0102-.2675-.0101-.3866-.0101z"
      clipRule="evenodd"
    />
  </svg>
);

export const SkipBack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 4c.5523 0 1 .4477 1 1v14c0 .5523-.4477 1-1 1s-1-.4477-1-1V5c0-.5523.4477-1 1-1M17.9978 4.0806a2 2 0 0 1 1.5653.7523c.3023.3787.3748.8343.4055 1.1725.0315.3464.0314.7845.0314 1.2791v9.431c0 .4947.0001.9327-.0314 1.2791-.0307.3383-.1032.7938-.4055 1.1725-.38.476-.9562.7529-1.5653.7523-.4845-.0005-.8855-.2285-1.1688-.4158-.2902-.1918-.6322-.4655-1.0185-.7746l-5.902-4.7215c-.2422-.1938-.4723-.3778-.6501-.5477-.1907-.1821-.4053-.424-.5305-.7582a2 2 0 0 1 0-1.4032c.1252-.3342.3398-.5761.5305-.7582.1778-.1699.4078-.3539.6501-.5477l.0285-.0228 5.8735-4.6987c.3863-.309.7283-.5828 1.0185-.7746.2833-.1873.6843-.4153 1.1688-.4158"
      clipRule="evenodd"
    />
  </svg>
);

export const SkipForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 4c-.5523 0-1 .4477-1 1v14c0 .5523.4477 1 1 1s1-.4477 1-1V5c0-.5523-.4477-1-1-1M6.0022 4.0806a2 2 0 0 0-1.5653.7523c-.3022.3787-.3748.8343-.4055 1.1725C4 6.3518 4 6.79 4 7.2845v9.431c0 .4947 0 .9327.0314 1.2791.0307.3383.1033.7938.4055 1.1725.38.476.9562.7529 1.5653.7523.4845-.0005.8855-.2285 1.1689-.4158.29-.1918.6321-.4655 1.0184-.7746l5.9019-4.7215c.2423-.1938.4724-.3778.6502-.5477.1907-.1821.4053-.424.5305-.7582a2 2 0 0 0 0-1.4032c-.1252-.3342-.3398-.5761-.5305-.7582-.1778-.1699-.4078-.3539-.6501-.5477l-.0285-.0228L8.1895 5.271c-.3863-.309-.7283-.5828-1.0185-.7746-.2833-.1873-.6843-.4153-1.1688-.4158"
      clipRule="evenodd"
    />
  </svg>
);

export const Sliders01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 2c.5523 0 1 .4477 1 1v7c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M6 15h2c.5523 0 1-.4477 1-1s-.4477-1-1-1H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v6c0 .5523.4477 1 1 1s1-.4477 1-1zM13 12c0-.5523-.4477-1-1-1s-1 .4477-1 1v9c0 .5523.4477 1 1 1s1-.4477 1-1zM12 2c.5523 0 1 .4477 1 1v4h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2V3c0-.5523.4477-1 1-1M22 15c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4h-2c-.5523 0-1-.4477-1-1s.4477-1 1-1zM19 2c.5523 0 1 .4477 1 1v9c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const Sliders02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 2c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 15.8293C7.1652 15.4175 8 14.3062 8 13c0-1.6569-1.3431-3-3-3s-3 1.3431-3 3c0 1.3062.8348 2.4175 2 2.8293V21c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M13 15c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1s1-.4477 1-1z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2c.5523 0 1 .4477 1 1v3.1707c1.1652.4118 2 1.523 2 2.8293 0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c0-1.3062.8348-2.4175 2-2.8293V3c0-.5523.4477-1 1-1M22 15c0 1.3062-.8348 2.4175-2 2.8293V21c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3.1707c-1.1652-.4118-2-1.5231-2-2.8293 0-1.6569 1.3431-3 3-3s3 1.3431 3 3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19 2c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const Sliders03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.5 3h5.0597c.4833 0 .725 0 .8489.0802.1217.0787.182.1644.2151.3055.0338.1437-.0592.4037-.2453.9237A6.49 6.49 0 0 0 11 6.5c0 .7687.1334 1.5061.3784 2.1906.1861.52.2791.78.2453.9237-.0331.141-.0934.2267-.2151.3055C11.2847 10 11.043 10 10.5597 10H5.5C3.567 10 2 8.433 2 6.5S3.567 3 5.5 3M17.5 11c2.4853 0 4.5-2.0147 4.5-4.5S19.9853 2 17.5 2a4.48 4.48 0 0 0-2.8205.9934L14.6713 3C13.6518 3.825 13 5.0864 13 6.5s.6518 2.675 1.6713 3.5c.7729.6254 1.7571 1 2.8287 1M6.5 13a4.48 4.48 0 0 1 2.8287 1C10.3482 14.825 11 16.0864 11 17.5s-.6518 2.675-1.6713 3.5c-.7729.6254-1.757 1-2.8287 1C4.0147 22 2 19.9853 2 17.5S4.0147 13 6.5 13M13.4403 14c-.4833 0-.725 0-.8489.0802-.1217.0787-.182.1644-.2151.3055-.0338.1437.0592.4037.2453.9237A6.49 6.49 0 0 1 13 17.5a6.49 6.49 0 0 1-.3784 2.1906c-.1861.52-.2791.78-.2453.9237.0331.1411.0934.2268.2151.3055.1239.0802.3656.0802.8489.0802H18.5c1.933 0 3.5-1.567 3.5-3.5S20.433 14 18.5 14z"
    />
  </svg>
);

export const Sliders04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 9h11.126c.4441 1.7252 2.0102 3 3.874 3 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4c-1.8638 0-3.4299 1.2748-3.874 3H3c-.5523 0-1 .4477-1 1s.4477 1 1 1M21 15H9.874C9.43 13.2748 7.8638 12 6 12c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4c1.8638 0 3.43-1.2748 3.874-3H21c.5523 0 1-.4477 1-1s-.4477-1-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Speaker01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1M12 4.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m4 9.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
      clipRule="evenodd"
    />
  </svg>
);

export const Speaker02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 12c0-2.2091 1.7909-4 4-4s4 1.7909 4 4-1.7909 4-4 4-4-1.7909-4-4m4-1.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M12 6c-3.3137 0-6 2.6863-6 6s2.6863 6 6 6 6-2.6863 6-6-2.6863-6-6-6M4.75 6c0-.6904.5596-1.25 1.25-1.25S7.25 5.3096 7.25 6 6.6904 7.25 6 7.25 4.75 6.6904 4.75 6M6 16.75c-.6904 0-1.25.5596-1.25 1.25s.5596 1.25 1.25 1.25 1.25-.5596 1.25-1.25-.5596-1.25-1.25-1.25M16.75 6c0-.6904.5596-1.25 1.25-1.25s1.25.5596 1.25 1.25-.5596 1.25-1.25 1.25-1.25-.5596-1.25-1.25M18 16.75c-.6904 0-1.25.5596-1.25 1.25s.5596 1.25 1.25 1.25 1.25-.5596 1.25-1.25-.5596-1.25-1.25-1.25"
      clipRule="evenodd"
    />
  </svg>
);

export const Speaker03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 10c0-2.2091 1.7909-4 4-4s4 1.7909 4 4-1.7909 4-4 4-4-1.7909-4-4m2.5 0c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 1h8.4826c.8049 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 5.2894 22 5.9537 22 6.7587v6.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.2621.1336-.5334.2237-.816.2857v1.5822c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169H7.5681c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4983-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698C5 20.9301 5 20.6843 5 20.4319v-1.5822c-.2826-.062-.5539-.1521-.816-.2857a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 14.7106 2 14.0463 2 13.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 1 6.9538 1 7.7587 1M7 18.9984V20.4c0 .2965.0008.4588.0103.5754l.0011.0132.0132.0011c.1166.0095.2789.0103.5754.0103h8.8c.2965 0 .4588-.0008.5754-.0103l.0132-.0011.0011-.0132c.0095-.1166.0103-.2789.0103-.5754v-1.4016C16.7623 19 16.5096 19 16.2413 19H7.7587c-.2683 0-.521 0-.7587-.0016M12 4c-3.3137 0-6 2.6863-6 6s2.6863 6 6 6 6-2.6863 6-6-2.6863-6-6-6"
      clipRule="evenodd"
    />
  </svg>
);

export const Stop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.1615 2h11.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C22 5.1795 22 5.6343 22 6.1614v11.6772c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C18.8205 22 18.3657 22 17.8386 22H6.1614c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C2 18.8205 2 18.3657 2 17.8385V6.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C5.1796 2 5.6343 2 6.1615 2"
      clipRule="evenodd"
    />
  </svg>
);

export const StopCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M8.109 8.546C8 8.76 8 9.04 8 9.6v4.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C8.76 16 9.04 16 9.6 16h4.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C16 15.2401 16 14.9601 16 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.2401 8 14.9601 8 14.4 8H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437"
      clipRule="evenodd"
    />
  </svg>
);

export const StopSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.8385 2H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 5.1795 2 5.6343 2 6.1614v11.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6343 22 6.1614 22h11.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C22 18.8205 22 18.3657 22 17.8386V6.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C18.8205 2 18.3657 2 17.8385 2M8.109 8.546C8 8.76 8 9.04 8 9.6v4.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C8.76 16 9.04 16 9.6 16h4.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C16 15.2401 16 14.9601 16 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.2401 8 14.9601 8 14.4 8H9.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437"
      clipRule="evenodd"
    />
  </svg>
);

export const Tablet01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.8385 1h-9.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C3 4.1795 3 4.6343 3 5.1614v13.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C6.1795 23 6.6343 23 7.1614 23h9.6772c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C21 19.8205 21 19.3657 21 18.8386V5.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C17.8205 1 17.3657 1 16.8385 1M12 16c-.8284 0-1.5.6716-1.5 1.5S11.1716 19 12 19s1.5-.6716 1.5-1.5S12.8284 16 12 16"
      clipRule="evenodd"
    />
  </svg>
);

export const Tablet02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.1615 1h9.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C21 4.1795 21 4.6343 21 5.1614v13.6772c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C17.8205 23 17.3657 23 16.8386 23H7.1614c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C3 19.8205 3 19.3657 3 18.8386V5.1614c0-.527 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C6.1795 1 6.6343 1 7.1615 1M15 3v.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C14.2401 5 13.9601 5 13.4 5h-2.8c-.5601 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C9 4.24 9 3.96 9 3.4V3z"
      clipRule="evenodd"
    />
  </svg>
);

export const Tv01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.2413 2H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 6.2894 1 6.9537 1 7.7587v4.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918q.1216.0099.2518.0171v1.459c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2715.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h8.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-1.459a10 10 0 0 0 .2518-.0171c.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 13.7106 23 13.0463 23 12.2413V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 2 18.0463 2 17.2413 2M17 18H7v1.4c0 .2965.0008.4588.0103.5754l.0011.0132.0132.0011c.1166.0095.2789.0103.5754.0103h8.8c.2965 0 .4588-.0008.5754-.0103l.0132-.0011.0011-.0132c.0095-.1166.0103-.2789.0103-.5754z"
      clipRule="evenodd"
    />
  </svg>
);

export const Tv02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.2413 2H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 6.2894 1 6.9537 1 7.7587v4.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 18 5.9537 18 6.7587 18h2.3906l-2.774 2.2191c-.4312.345-.5011.9743-.1561 1.4056s.9743.5012 1.4055.1562L12 18.2806l4.3753 3.5003c.4313.345 1.0606.2751 1.4056-.1562s.2751-1.0606-.1562-1.4056L14.8508 18h2.3905c.8049 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 13.7106 23 13.0463 23 12.2413V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 2 18.0463 2 17.2413 2"
    />
  </svg>
);

export const Tv03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.6247 2.2192c-.4312-.345-1.0605-.2751-1.4055.1561S5.944 3.436 6.3753 3.781L9.1493 6H6.7586c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 10.2894 1 10.9537 1 11.7587v4.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.8049 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-2.3904l2.7738-2.219c.4313-.3451.5012-.9744.1562-1.4057s-.9743-.5011-1.4056-.1561L12 5.7194z"
    />
  </svg>
);

export const UsbFlashDrive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 4c.5523 0 1 .4477 1 1v1c0 .5523-.4477 1-1 1s-1-.4477-1-1V5c0-.5523.4477-1 1-1M15 5c0-.5523-.4477-1-1-1s-1 .4477-1 1v1c0 .5523.4477 1 1 1s1-.4477 1-1z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5681 1h8.8638c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.4538.0169.7062v4.6103c.1219.0392.2427.0879.362.1487a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3745.0306.8293.0306 1.3564v5.0799c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C16.7106 23 16.0463 23 15.2414 23H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2414v-5.0799c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311A2.44 2.44 0 0 1 5 8.1783V3.568c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2715-.1383.5412-.1824.7698-.201C7.0699 1 7.3158 1 7.568 1m-.568 7H17V3.6c0-.2965-.0008-.4588-.0103-.5754l-.0011-.0131-.0132-.0012C16.8588 3.0008 16.6965 3 16.4 3H7.6c-.2965 0-.4588.0008-.5754.0103l-.0132.0011-.001.0132C7.0007 3.1412 7 3.3035 7 3.6z"
      clipRule="evenodd"
    />
  </svg>
);

export const VideoRecorder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.2413 4H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 8.2894 1 8.9537 1 9.7587v4.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 20 5.9537 20 6.7587 20h5.4826c.8049 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.041-.5019.044-1.1099.0442-1.8377l1.9535 1.9536c.1912.1912.3791.3791.5438.517.1469.1231.4564.3698.885.4035a1.5 1.5 0 0 0 1.2583-.5212c.2792-.3269.3236-.7202.3405-.9111.019-.214.0189-.4797.0189-.7501V8.8941c0-.2704.0001-.5362-.0189-.7501-.0169-.191-.0613-.5842-.3405-.9111a1.5 1.5 0 0 0-1.2583-.5212c-.4286.0337-.7381.2804-.885.4034-.1647.1379-.3526.3258-.5437.517L18 9.5857c-.0002-.7277-.0032-1.3356-.0442-1.8375-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C13.7106 4 13.0463 4 12.2413 4"
      clipRule="evenodd"
    />
  </svg>
);

export const VideoRecorderOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.5351 17.2924a1.5 1.5 0 0 0 1.1055-.5254c.2792-.3269.3236-.7202.3405-.9111.019-.2139.0189-.4797.0189-.75V8.8941c0-.2704.0001-.5362-.0189-.7501-.0169-.191-.0613-.5842-.3405-.9111a1.5 1.5 0 0 0-1.2583-.5212c-.4286.0337-.7381.2804-.885.4034-.1647.1379-.3526.3258-.5437.517L18 9.5857c-.0002-.7277-.0032-1.3356-.0442-1.8375-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C13.7106 4 13.0463 4 12.2413 4H8.2426zM2.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l1.785 1.785a4 4 0 0 0-1.642 1.692c-.2472.4853-.3458 1.002-.3917 1.564C1 8.2895 1 8.9538 1 9.7587v4.4827c0 .8049 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 20 5.9537 20 6.7587 20h5.4826c.8049 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.2901-1.0437l4.1868 4.1868c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
    />
  </svg>
);

export const Voicemail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 12a4.978 4.978 0 0 1-.9996 3h3.9992A4.978 4.978 0 0 1 13 12c0-2.7614 2.2386-5 5-5s5 2.2386 5 5c0 2.7603-2.2368 4.9982-4.9968 5H5.9969C3.2369 16.9983 1 14.7604 1 12c0-2.7614 2.2386-5 5-5s5 2.2386 5 5"
      clipRule="evenodd"
    />
  </svg>
);

export const VolumeMax = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.1639 4.1882c.4484-.3226 1.0733-.2206 1.3958.2278C22.0953 6.5507 23 9.171 23 11.9999s-.9047 5.4493-2.4403 7.584c-.3225.4483-.9474.5503-1.3958.2278s-.5503-.9474-.2278-1.3957C20.2352 16.6102 21 14.3959 21 11.9999s-.7648-4.6102-2.0639-6.416c-.3225-.4483-.2205-1.0732.2278-1.3957M15.1732 7.1798c.453-.316 1.0763-.205 1.3923.248C17.4696 8.724 18 10.3015 18 12s-.5304 3.2759-1.4345 4.5721c-.316.453-.9393.5641-1.3923.2481-.453-.3159-.564-.9393-.2481-1.3923C15.6027 14.4564 16 13.276 16 11.9999s-.3973-2.4564-1.0749-3.4279c-.3159-.453-.2049-1.0763.2481-1.3922M10.3823 2.7117a1.5 1.5 0 0 1 1.2583.5212c.2793.327.3236.7202.3405.911.019.214.0189.4798.0189.7502v14.2117c0 .2704.0001.5361-.0189.7501-.0169.1909-.0612.5842-.3405.9111a1.5 1.5 0 0 1-1.2583.5212c-.4286-.0337-.738-.2804-.885-.4035-.1647-.1379-.3526-.3258-.5438-.517l-3.192-3.192c-.0926-.0927-.139-.1387-.1741-.1708l-.0027-.0024-.0036-.0002c-.0475-.0021-.1128-.0024-.2438-.0024H3.568C3.3157 17 3.07 17 2.8618 16.983c-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5411-.201-.7697C1 14.93 1 14.6842 1 14.4318V9.568c0-.2523 0-.4981.017-.7063.0186-.2286.0627-.4983.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201.2081-.017.454-.017.7063-.017h1.7692c.131 0 .1963-.0002.2438-.0024l.0036-.0001.0027-.0025c.0351-.032.0815-.078.1741-.1707l3.1657-3.1657.0263-.0263c.1912-.1912.379-.3792.5438-.517.147-.1231.4564-.3698.885-.4035"
      clipRule="evenodd"
    />
  </svg>
);

export const VolumeMin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.673 7.1798c.453-.316 1.0763-.205 1.3923.248.9041 1.2962 1.4345 2.8737 1.4345 4.5721s-.5304 3.2759-1.4345 4.5721c-.316.453-.9393.5641-1.3923.2481-.453-.3159-.564-.9393-.2481-1.3923.6777-.9714 1.0749-2.1518 1.0749-3.4279s-.3972-2.4564-1.0749-3.4279c-.3159-.453-.2049-1.0763.2481-1.3922M12.8823 2.7117a1.5 1.5 0 0 1 1.2583.5212c.2793.327.3236.7202.3405.911.019.214.0189.4798.0189.7502v14.2117c0 .2704.0001.5361-.0189.7501-.0169.1909-.0612.5842-.3405.9111a1.5 1.5 0 0 1-1.2583.5212c-.4286-.0337-.7381-.2804-.885-.4035-.1647-.1379-.3526-.3258-.5438-.517l-3.192-3.192c-.0926-.0927-.139-.1387-.1741-.1708l-.0027-.0024-.0036-.0002c-.0474-.0021-.1128-.0024-.2438-.0024H6.068C5.8157 17 5.57 17 5.3618 16.983c-.2286-.0187-.4983-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5411-.201-.7697-.017-.2082-.017-.454-.017-.7064V9.568c0-.2523 0-.4981.017-.7063.0186-.2286.0627-.4983.201-.7698a2 2 0 0 1 .874-.874c.2715-.1383.5412-.1824.7698-.201.2081-.017.454-.017.7063-.017h1.7692c.131 0 .1963-.0002.2438-.0024l.0036-.0001.0027-.0025c.0351-.032.0815-.078.1741-.1707l3.1657-3.1657.0263-.0263c.1912-.1912.3791-.3792.5438-.517.1469-.1231.4564-.3698.885-.4035"
      clipRule="evenodd"
    />
  </svg>
);

export const VolumeMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.6406 3.2329a1.5 1.5 0 0 0-1.2583-.5212c-.4286.0337-.738.2804-.885.4034-.1647.138-.3526.3259-.5438.517l-3.192 3.1921c-.0926.0926-.139.1387-.1741.1707l-.0027.0024-.0036.0002C5.5336 6.9997 5.4683 7 5.3373 7H3.568c-.2524 0-.4982 0-.7063.017-.2286.0187-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2715-.1824.5412-.201.7698C1 9.0699 1 9.3157 1 9.568v4.8638c0 .2524 0 .4982.017.7064.0186.2286.0627.4983.201.7697.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.454.017.7063.0169h1.7692c.131 0 .1963.0003.2438.0024l.0036.0002.0027.0024c.0351.0321.0815.0781.1741.1708l3.192 3.192c.1912.1912.3791.3792.5438.517.147.1231.4564.3698.885.4035a1.5 1.5 0 0 0 1.2583-.5212c.2793-.3269.3236-.7202.3405-.9111.019-.214.0189-.4797.0189-.7501V4.8941c0-.2704.0001-.5362-.0189-.7501-.0169-.191-.0612-.5842-.3405-.9111"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M15 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h7c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const VolumePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.6406 3.2329a1.5 1.5 0 0 0-1.2583-.5212c-.4286.0337-.738.2804-.885.4034-.1647.138-.3526.3259-.5438.517l-3.192 3.1921c-.0926.0926-.139.1387-.1741.1707l-.0027.0024-.0036.0002C5.5336 6.9997 5.4683 7 5.3373 7H3.568c-.2524 0-.4982 0-.7063.017-.2286.0187-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2715-.1824.5412-.201.7698C1 9.0699 1 9.3157 1 9.568v4.8638c0 .2524 0 .4982.017.7064.0186.2286.0627.4983.201.7697.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.454.017.7063.0169h1.7692c.131 0 .1963.0003.2438.0024l.0036.0002.0027.0024c.0351.0321.0815.0781.1741.1708l3.192 3.192c.1912.1912.3791.3792.5438.517.147.1231.4564.3698.885.4035a1.5 1.5 0 0 0 1.2583-.5212c.2793-.3269.3236-.7202.3405-.9111.019-.214.0189-.4797.0189-.7501V4.8941c0-.2704.0001-.5362-.0189-.7501-.0169-.191-.0612-.5842-.3405-.9111"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.5 7.5c.5523 0 1 .4477 1 1V11H22c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2.5v2.5c0 .5523-.4477 1-1 1s-1-.4477-1-1V13H15c-.5523 0-1-.4477-1-1s.4477-1 1-1h2.5V8.5c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const VolumeX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.6406 3.2329a1.5 1.5 0 0 0-1.2583-.5212c-.4286.0337-.738.2804-.885.4034-.1647.138-.3526.3259-.5438.517l-3.192 3.1921c-.0926.0926-.139.1387-.1741.1707l-.0027.0024-.0036.0002C5.5336 6.9997 5.4683 7 5.3373 7H3.568c-.2524 0-.4982 0-.7063.017-.2286.0187-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2715-.1824.5412-.201.7698C1 9.0699 1 9.3157 1 9.568v4.8638c0 .2524 0 .4982.017.7064.0186.2286.0627.4983.201.7697.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.454.017.7063.0169h1.7692c.131 0 .1963.0003.2438.0024l.0036.0002.0027.0024c.0351.0321.0815.0781.1741.1708l3.192 3.192c.1912.1912.3791.3792.5438.517.147.1231.4564.3698.885.4035a1.5 1.5 0 0 0 1.2583-.5212c.2793-.3269.3236-.7202.3405-.9111.019-.214.0189-.4797.0189-.7501V4.8941c0-.2704.0001-.5362-.0189-.7501-.0169-.191-.0612-.5842-.3405-.9111"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M22.7071 8.2929c.3905.3905.3905 1.0237 0 1.4142L20.4142 12l2.2929 2.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L19 13.4142l-2.2929 2.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L17.5858 12l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L19 10.5858l2.2929-2.293c.3905-.3904 1.0237-.3904 1.4142 0"
    />
  </svg>
);

export const Webcam01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21 10c0 4.6326-3.5 8.4476-8 8.9451V21h4c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1s.4477-1 1-1h4v-2.0549C6.5 18.4476 3 14.6326 3 10c0-4.9706 4.0294-9 9-9s9 4.0294 9 9m-6 0c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
      clipRule="evenodd"
    />
  </svg>
);

export const Webcam02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1c-5.2467 0-9.5 4.2533-9.5 9.5S6.7533 20 12 20s9.5-4.2533 9.5-9.5S17.2467 1 12 1m3.1875 9.5c0 1.7604-1.4271 3.1875-3.1875 3.1875S8.8125 12.2604 8.8125 10.5 10.2396 7.3125 12 7.3125s3.1875 1.427 3.1875 3.1875"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8 21c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Wifi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 19.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M11.9999 5.5c-3.906 0-7.4612 1.4916-10.131 3.938-.4071.3731-1.0397.3455-1.4128-.0616C.083 8.9692.1106 8.3366.5178 7.9635 3.5418 5.1924 7.5744 3.5 11.9999 3.5S20.458 5.1924 23.482 7.9635c.4072.3731.4348 1.0057.0617 1.4129s-1.0057.4347-1.4129.0616C19.4611 6.9916 15.9058 5.5 11.9999 5.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 10.5c-2.5334 0-4.8445.9407-6.607 2.4933-.4145.3651-1.0464.3251-1.4114-.0893s-.325-1.0463.0893-1.4114C6.1847 9.6306 8.9615 8.5 12 8.5s5.8153 1.1306 7.929 2.9926c.4145.3651.4545.997.0894 1.4114s-.997.4544-1.4114.0893C16.8445 11.4407 14.5333 10.5 12 10.5M11.9999 15.5c-1.1813 0-2.2645.4084-3.12 1.0926-.4313.3449-1.0606.2749-1.4055-.1565s-.2749-1.0606.1564-1.4055A6.975 6.975 0 0 1 12 13.5a6.975 6.975 0 0 1 4.3154 1.4881c.4346.3407.5108.9693.1701 1.4039-.3408.4347-.9693.5108-1.404.1701-.8493-.6657-1.9177-1.0621-3.0815-1.0621"
      clipRule="evenodd"
    />
  </svg>
);

export const WifiOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l1.7607 1.7607A17.04 17.04 0 0 0 .5178 7.9634C.1106 8.3365.083 8.969.456 9.3763s1.0057.4347 1.4129.0616a15.03 15.03 0 0 1 3.6736-2.481l2.2877 2.2876a12 12 0 0 0-3.7594 2.248c-.4144.3651-.4544.997-.0893 1.4114.365.4144.997.4544 1.4114.0894 1.1425-1.0065 2.5152-1.7554 4.0281-2.158l2.6652 2.6652a6.9748 6.9748 0 0 0-4.4554 1.5301c-.4314.3449-.5014.9742-.1565 1.4055s.9743.5014 1.4056.1565a5 5 0 0 1 .1575-.121 1 1 0 0 0 .0715-.0464 5 5 0 0 1 5.224-.3489c.2643.1398.5147.3026.7484.4858.0566.0443.1164.0816.1784.1119l5.0331 5.0331c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142zM10.3098 5.5982a15.0002 15.0002 0 0 1 11.6088 3.652c.4143.3652 1.0462.3254 1.4114-.089.3652-.4142.3254-1.0461-.0889-1.4113a17 17 0 0 0-13.1566-4.139c-.5488.0622-.9432.5575-.881 1.1063s.5575.9432 1.1063.881M15.6095 9.0453c-.5273-.1643-1.0879.13-1.2522.6573s.13 1.0879.6573 1.2522a10 10 0 0 1 3.4255 1.8636c.4244.3535 1.0549.296 1.4084-.1284.3534-.4243.296-1.0549-.1284-1.4084a12 12 0 0 0-4.1106-2.2363"
    />
    <path
      fill="currentColor"
      d="M12 18.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Youtube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.0114 4.006a143 143 0 0 0-.4421-.0036A1 1 0 0 0 12.5 4h-1a1 1 0 0 0-.0728.0026 126.064 126.064 0 0 0-2.7793.0499c-.8861.0262-1.8305.0658-2.657.1259-.7986.058-1.572.1402-2.0661.2719l-.0138.0037a3.53 3.53 0 0 0-1.5712.9345 3.515 3.515 0 0 0-.891 1.5955 1 1 0 0 0-.0141.0656 27.16 27.16 0 0 0-.4342 4.9678 27.16 27.16 0 0 0 .4342 5.0055 1 1 0 0 0 .0225.0967 3.516 3.516 0 0 0 .9122 1.5371 3.53 3.53 0 0 0 1.5498.8916l.0056.0014c.4942.1317 1.2675.2139 2.0661.2719.8265.0601 1.7709.0997 2.657.1259.8877.0263 1.7249.0394 2.3398.0459.1631.0018.3106.0031.4395.004Q11.4632 20 11.5 20h1q.0368 0 .0728-.0026c.1289-.0009.2764-.0022.4395-.004a125 125 0 0 0 2.3398-.0459c.8861-.0262 1.8305-.0658 2.657-.1259.7986-.058 1.5719-.1402 2.0661-.2719l.0138-.0038a3.53 3.53 0 0 0 1.5712-.9344 3.514 3.514 0 0 0 .891-1.5955 1 1 0 0 0 .0141-.0656 27.16 27.16 0 0 0 .4342-4.9309 27.16 27.16 0 0 0-.4342-5.0062 1 1 0 0 0-.0141-.0655 3.514 3.514 0 0 0-.891-1.5955 3.53 3.53 0 0 0-1.5712-.9345 1 1 0 0 0-.0349-.0091c-.4863-.1183-1.2523-.193-2.0513-.246-.8248-.0548-1.7677-.0909-2.6532-.1148-.887-.024-1.7237-.036-2.3382-.042m-3.1617 4.61c-.0997.1333-.0997.372-.0997.8492v5.0694c0 .4773 0 .7159.0997.8491a.5.5 0 0 0 .3647.1991c.166.0119.3667-.1172.7682-.3753l3.9428-2.5347c.3484-.2239.5226-.3359.5828-.4783a.5.5 0 0 0 0-.3892c-.0602-.1424-.2344-.2544-.5828-.4783l-3.9428-2.5347c-.4015-.2581-.6022-.3871-.7682-.3753a.5.5 0 0 0-.3647.199"
      clipRule="evenodd"
    />
  </svg>
);

export const Camera01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.5577 1c-.1102 0-.206 0-.2975.0055A3 3 0 0 0 6.658 2.881c-.0342.085-.0645.176-.0993.2806l-.0074.0222c-.0464.1391-.0564.168-.065.1892a1 1 0 0 1-.8673.6252C5.5962 3.9995 5.5623 4 5.4056 4h-.0559c-.3148 0-.5462-.0001-.744.0195-1.8973.188-3.3982 1.6889-3.5862 3.5861-.0196.1979-.0196.42-.0195.7198v7.9159c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-7.916c.0001-.2998.0001-.5218-.0195-.7197-.188-1.8972-1.6888-3.3981-3.5861-3.5861-.1979-.0196-.4293-.0196-.7441-.0195h-.0559c-.1568 0-.1907-.0004-.2133-.0018a1 1 0 0 1-.8674-.6252c-.0086-.0213-.0186-.05-.065-.1892l-.0074-.0222c-.0348-.1046-.0651-.1956-.0993-.2806a3 3 0 0 0-2.6021-1.8755C14.6484 1 14.5525 1 14.4423 1zM16 12.5c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
      clipRule="evenodd"
    />
  </svg>
);

export const Camera02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5577 1c-.1102 0-.206 0-.2975.0055A3 3 0 0 0 5.658 2.881c-.0342.085-.0645.176-.0993.2806l-.0968.2906A.801.801 0 0 1 4.7018 4C2.6573 4 1 5.6574 1 7.7018v8.5395c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413V7.7018C23 5.6573 21.3427 4 19.2982 4a.801.801 0 0 1-.7601-.5478l-.0968-.2907c-.0349-.1045-.0651-.1955-.0993-.2805a3 3 0 0 0-2.6022-1.8755C15.6484 1 15.5525 1 15.4423 1zM16.5 12c0 2.4853-2.0147 4.5-4.5 4.5S7.5 14.4853 7.5 12 9.5147 7.5 12 7.5s4.5 2.0147 4.5 4.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Camera03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 2h10.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C23 6.2894 23 6.9537 23 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 22 18.0463 22 17.2413 22H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 17.7106 1 17.0463 1 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 2 5.9538 2 6.7587 2M16 12c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
      clipRule="evenodd"
    />
  </svg>
);

export const CameraLens = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.7782 4.2218c4.2957 4.2958 4.2957 11.2606 0 15.5564s-11.2606 4.2957-15.5564 0-4.2957-11.2606 0-15.5564 11.2606-4.2957 15.5564 0M18.3639 5.636c-1.4182-1.4182-3.1919-2.2641-5.0343-2.5378 1.8607 1.7503 3.0173 4.1622 3.1835 6.7464a4.99 4.99 0 0 1 .4439 1.4994c1.1661-1.5238 1.7866-3.4454 1.6719-5.4317a9 9 0 0 0-.265-.2763m-4.4531 1.7421c-.7365-1.7715-2.0904-3.2697-3.8679-4.1639-1.615.3582-3.1505 1.1654-4.4069 2.4218a9.1 9.1 0 0 0-.682.7633c2.4472-.7375 5.1159-.5334 7.4384.616a5 5 0 0 1 1.5184.3628m-4.9576.6568c-1.9034-.2479-3.8786.1763-5.5421 1.27-.6122 1.9567-.5406 4.0812.2147 5.9987.5847-2.4879 2.0956-4.6969 4.2512-6.1338a5.03 5.03 0 0 1 .5875-.7053 5.05 5.05 0 0 1 .4887-.4296M7.043 12.656c-1.1662 1.5237-1.7868 3.4452-1.6722 5.4314q.1292.1404.2652.2765c1.4182 1.4182 3.1918 2.2641 5.0341 2.5379-1.8607-1.7505-3.0173-4.1625-3.1833-6.7467a4.99 4.99 0 0 1-.4438-1.4991m3.046 3.9658c.7365 1.7716 2.0904 3.2698 3.8679 4.164 1.6151-.3581 3.1506-1.1654 4.407-2.4219a9.1 9.1 0 0 0 .6823-.7634c-2.4472.7375-5.1159.5335-7.4383-.6158a5 5 0 0 1-1.5189-.3629m4.958-.6568a5 5 0 0 0 .4885-.4295 5 5 0 0 0 .5873-.7051c2.1558-1.437 3.6667-3.6462 4.2513-6.1343.7554 1.9175.827 4.042.2149 5.9988-1.6635 1.0937-3.6386 1.5179-5.542 1.2701"
      clipRule="evenodd"
    />
  </svg>
);

export const CameraOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l20 20c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-.6791-.6792A3.988 3.988 0 0 0 23 18V8.3253c.0001-.2997.0001-.5218-.0195-.7197-.188-1.8972-1.6889-3.3981-3.5861-3.5861-.1979-.0196-.4293-.0196-.7441-.0195h-.0559c-.1568 0-.1907-.0004-.2133-.0018a1 1 0 0 1-.8674-.6252c-.0086-.0213-.0186-.05-.065-.1892l-.0074-.0222c-.0348-.1046-.0651-.1955-.0993-.2806a3 3 0 0 0-2.6022-1.8755C14.6483 1 14.5525 1 14.4423 1H9.5577c-.1102 0-.206 0-.2975.0055A3 3 0 0 0 6.658 2.881c-.0342.085-.0645.176-.0993.2805l-.033.0992a4 4 0 0 1-.0268.0795 1 1 0 0 1-.915.6595A3 3 0 0 1 5.528 4h-.1139zM16.5 12c0 .8805-.2529 1.702-.6901 2.3957L9.6043 8.1901A4.48 4.48 0 0 1 12 7.5c2.4853 0 4.5 2.0147 4.5 4.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M1.6191 5.8617a3.99 3.99 0 0 0-.5996 1.7438c-.0196.1979-.0196.42-.0195.7198v7.9159c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.5412.0442 1.2055.0442 2.0105.0442h10.4826q.268.0001.5155-.0005l-5.5072-5.5072a4 4 0 0 1-.2496.0077c-2.2091 0-4-1.7909-4-4q0-.1258.0077-.2496z"
    />
  </svg>
);

export const CameraPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1V6h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.5 2.2545A.2546.2546 0 0 0 14.2455 2H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 6.2894 1 6.9537 1 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413V8.8487c0-.2909 0-.4363-.0298-.5187-.0619-.1713-.1289-.2383-.3002-.3002C22.5876 8 22.3917 8 22 8c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c-1.6569 0-3-1.3431-3-3 0-1.0579.5476-1.9879 1.3747-2.522.0764-.0493.1253-.1326.1253-.2235M12 16c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4"
      clipRule="evenodd"
    />
  </svg>
);

export const Colors = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.4494 13.2298A6.22 6.22 0 0 1 12 13.3999c-1.7196 0-3.2767-.7002-4.4005-1.8322C6.4872 10.4471 5.8 8.9038 5.8 7.2001 5.8 3.7759 8.5758 1 12 1c3.4241 0 6.2 2.7759 6.2 6.2 0 1.2457-.3673 2.4055-.9995 3.3771-.834 1.2817-2.129 2.236-3.6499 2.6276a7 7 0 0 1-.1012.0251M15.1476 14.7743c1.517-.6312 2.8037-1.7048 3.6989-3.0597.1539-.2329.2308-.3494.3297-.408a.51.51 0 0 1 .2886-.0687c.1147.0078.2125.0636.408.1754C21.7413 12.4817 23 14.4946 23 16.7999 23 20.2241 20.2242 23 16.8 23c-.8877 0-1.7311-.1861-2.4941-.5218-.251-.1104-.3765-.1656-.4557-.2733a.51.51 0 0 1-.0963-.3272c.0083-.1333.1026-.2759.2911-.561a8.156 8.156 0 0 0 1.3467-4.1444 8 8 0 0 0 .0083-.349v-.0234a8.22 8.22 0 0 0-.2524-2.0256M4.1272 11.4133c.1955-.1118.2933-.1676.408-.1754a.51.51 0 0 1 .2886.0687c.0989.0586.1758.1751.3297.408C6.6208 13.9352 9.1394 15.4001 12 15.4001c.4146 0 .822-.0307 1.2201-.0901l.0062.0257c.1135.4688.1737.959.1737 1.4642v.0215a6 6 0 0 1-.0059.2514C13.2513 20.3704 10.5327 23 7.2 23 3.7758 23 1 20.2241 1 16.7999c0-2.3053 1.2587-4.3182 3.1272-5.3866"
    />
  </svg>
);

export const Flash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.9923 2.124a1.0001 1.0001 0 0 0-1.7605-.7641L3.3023 12.0752c-.1543.1851-.3106.3726-.4244.5374-.1076.1558-.3041.4622-.3102.8648-.007.461.1984.8996.557 1.1893.3132.2531.6744.2983.863.3154.1994.0181.4435.018.6845.018h6.195l-.8595 6.8759a1.0001 1.0001 0 0 0 1.7605.7642l8.9295-10.7153c.1543-.1851.3106-.3726.4244-.5374.1076-.1558.3041-.4622.3102-.8648a1.5 1.5 0 0 0-.557-1.1893c-.3133-.2531-.6744-.2983-.863-.3154C19.8128 9 19.5687 9 19.3277 9h-6.1949z"
    />
  </svg>
);

export const FlashOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l4.3543 4.3543-3.3449 4.0138c-.1543.1851-.3106.3726-.4244.5374-.1076.1558-.3041.4622-.3102.8648a1.5 1.5 0 0 0 .557 1.1893c.3132.2531.6744.2983.863.3154.1994.018.4435.018.6845.0179h6.195l-.8595 6.876a1 1 0 0 0 1.7605.7642l4.299-5.1588 4.2257 4.2257c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m18.6385 14.3959 2.0592-2.471c.1543-.1851.3106-.3726.4244-.5374.1076-.1558.3041-.4622.3102-.8648a1.5 1.5 0 0 0-.557-1.1893c-.3133-.2531-.6744-.2983-.863-.3154C19.8128 9 19.5687 9 19.3277 9h-6.085zM13.145 8.9023l.8473-6.7782a1.0001 1.0001 0 0 0-1.7605-.7642l-3.0133 3.616z"
    />
  </svg>
);

export const Image01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5 5.5c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3-1.3431-3-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9538 22 7.7588v7.2305l.0001.0105v1.2414c0 .8049 0 1.4693-.0442 2.0105-.0269.3288-.0718.6421-.1539.9426a3.3 3.3 0 0 1-.152.4382 3 3 0 0 1-.086.1835 4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7499l-.3468-.0001h-.509c-.2703 0-.536 0-.75-.0189l-.0219-.002a10 10 0 0 1-.374-.0232c-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2M20 7.8v4.7856l-2.184-2.1841c-.1785-.1784-.3522-.3523-.5115-.4874-.1748-.1484-.3967-.308-.6864-.4021a2 2 0 0 0-1.2361 0c-.2897.094-.5116.2537-.6864.402-.1592.1352-.333.3091-.5115.4875l-8.5518 8.5519c-.1912.1911-.3792.379-.517.5437-.0427.0509-.1.1213-.1584.2094a2 2 0 0 1-.739-.7985c-.0796-.1564-.1445-.3806-.1803-.819C4.0008 17.6389 4 17.0566 4 16.2V7.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C6.3611 4.0008 6.9434 4 7.8 4h8.4c.8566 0 1.4389.0008 1.889.0376.4384.0358.6626.1007.819.1804.3763.1917.6823.4977.874.874.0797.1564.1446.3806.1804.819C19.9992 6.3611 20 6.9434 20 7.8"
      clipRule="evenodd"
    />
  </svg>
);

export const Image02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 8.5c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M3 12c0-4.9706 4.0294-9 9-9s9 4.0294 9 9c0 .4994-.0407.9894-.1189 1.4667l-3.0651-3.0651c-.1784-.1785-.3523-.3524-.5115-.4875-.1748-.1484-.3967-.308-.6864-.4021a2 2 0 0 0-1.2361 0c-.2897.094-.5116.2537-.6864.402-.1592.1352-.333.3091-.5115.4875l-8.2485 8.2486C4.1318 17.0042 3 14.6343 3 12"
      clipRule="evenodd"
    />
  </svg>
);

export const Image03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 6C6.3431 6 5 7.3431 5 9s1.3431 3 3 3 3-1.3431 3-3-1.3431-3-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.2413 2H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 6.2894 1 6.9537 1 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918q.178.0145.374.0232l.0219.002c.214.0189.4797.0189.75.0189l.5064-.0001q.1742.0003.3582.0002h10.4826l.3555-.0001h.5091c.2704 0 .5362 0 .7501-.0189l.022-.002q.196-.0087.3738-.0232c.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 2 18.0463 2 17.2413 2M21 12.5856V7.8c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804C18.6389 4.0008 18.0566 4 17.2 4H6.8c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C3.0008 6.3611 3 6.9434 3 7.8v8.4c0 .8566.0008 1.4389.0375 1.889.0359.4384.1008.6626.1805.819.1682.3302.4244.6062.739.7985a2.3 2.3 0 0 1 .1582-.2094c.138-.1647.3259-.3525.517-.5437l5.5519-5.5518c.1785-.1785.3523-.3523.5115-.4875.1748-.1484.3967-.308.6864-.4022a2 2 0 0 1 1.2361 0c.2897.0942.5116.2538.6864.4022.1593.1351.333.309.5115.4874l.184.1841 2.1841-2.184c.1784-.1785.3522-.3523.5114-.4875.1749-.1484.3967-.308.6865-.4022a2 2 0 0 1 1.236 0c.2897.0942.5116.2538.6865.4022.1592.1352.333.309.5114.4875z"
      clipRule="evenodd"
    />
  </svg>
);

export const Image04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9538 22 7.7588v8.4824c0 .805 0 1.4694-.0442 2.0106-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2M5.911 4.0376c-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 6.3611 4 6.9434 4 7.8v8.4c0 .8566.0008 1.4389.0376 1.889.0358.4384.1007.6626.1804.819.1917.3763.4977.6823.874.874.1564.0797.3806.1446.819.1804C6.3611 19.9992 6.9434 20 7.8 20h8.4c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V7.8c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804C17.6389 4.0008 17.0566 4 16.2 4H7.8c-.8566 0-1.4389.0008-1.889.0376"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.3575 6.9855a1 1 0 0 0-1.6712-.0667l-1.9051 2.667L9.6 8.7a1 1 0 0 0-1.4779.3212l-3 5.5A1 1 0 0 0 6 16h12a1 1 0 0 0 .8575-1.5145z"
    />
  </svg>
);

export const Image05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18 2c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4 4-1.7909 4-4-1.7909-4-4-4M17.7662 11.9553a2 2 0 0 0-1.5323 0c-.3711.1539-.6248.4213-.8077.6481-.1608.1994-.3329.4541-.5173.7304l-2.7935-4.035c-.2017-.2914-.3896-.563-.564-.7718-.1832-.2193-.4348-.4752-.7982-.623a2 2 0 0 0-1.5063 0c-.3635.1478-.6151.4037-.7983.623-.1744.2089-.3623.4804-.564.7717l-5.9933 8.6571c-.2603.3759-.4936.7129-.6551.9988-.161.2848-.3473.678-.3254 1.1401.028.589.3144 1.1357.7828 1.494.3674.281.7968.3516 1.1226.3814.327.03.7368.0299 1.194.0299h16.0435c.4484 0 .8515 0 1.174-.0295.3226-.0296.7458-.0997 1.1104-.3755a2 2 0 0 0 .7899-1.4758c.0272-.4564-.1492-.8474-.3036-1.1323-.1542-.2846-.3779-.6201-.6267-.9932l-3.0565-4.5847c-.2034-.3052-.3921-.5883-.5673-.8056-.183-.2268-.4366-.4942-.8077-.6481"
    />
  </svg>
);

export const ImageCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.7071 2.2929c.3905.3905.3905 1.0237 0 1.4142l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L18 5.5858l3.2929-3.293c.3905-.3904 1.0237-.3904 1.4142 0M5.5 8.5c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.1754.0143.3637.024.5655.0306.2093.0139.4597.0138.7177.0138L17 22h.1376c.7954.0005 1.386.0008 1.8977-.1363a4 4 0 0 0 2.8284-2.8284c.1753-.6543.1365-1.3548.1363-2.0258.0018-.1893.0001-.3787.0001-.568.0005-.4689.001-.8821-.1078-1.2768a3 3 0 0 0-.4633-.964c-.2403-.3315-.5632-.5893-.9297-.8818l-2.831-2.2648c-.1699-.1359-.3379-.2703-.4904-.3744-.1696-.1158-.3784-.2361-.6397-.3031a2 2 0 0 0-1.1145.0352c-.2566.0833-.4574.2165-.6194.3427-.1457.1136-.3048.2583-.4658.4047l-8.508 7.7346c-.2135.194-.4199.3816-.5716.5457-.0608.0659-.1532.1682-.2396.3035a2 2 0 0 1-.8013-.835c-.0797-.1564-.1446-.3806-.1804-.819C4.0008 17.6389 4 17.0566 4 16.2V7.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C6.3611 4.0008 6.9434 4 7.8 4h4.7c.5523 0 1-.4477 1-1s-.4477-1-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ImageDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 8.5c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.1754.0143.3637.024.5655.0306.2093.0139.4597.0138.7177.0138L17 22h.1376c.7954.0005 1.386.0008 1.8977-.1363a4 4 0 0 0 2.8284-2.8284c.1753-.6543.1365-1.3548.1363-2.0258.0018-.1893.0001-.3787.0001-.568.0005-.4689.001-.8821-.1078-1.2768a3 3 0 0 0-.4633-.964c-.2403-.3315-.5632-.5893-.9297-.8818l-2.831-2.2648c-.1699-.1359-.3379-.2703-.4904-.3744-.1696-.1158-.3784-.2361-.6397-.3031a2 2 0 0 0-1.1145.0352c-.2566.0833-.4574.2165-.6194.3427-.1457.1136-.3048.2583-.4658.4047l-8.508 7.7346c-.2135.194-.4199.3816-.5716.5457-.0608.0659-.1532.1682-.2396.3035a2 2 0 0 1-.8013-.835c-.0797-.1564-.1446-.3806-.1804-.819C4.0008 17.6389 4 17.0566 4 16.2V7.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C6.3611 4.0008 6.9434 4 7.8 4h4.7c.5523 0 1-.4477 1-1s-.4477-1-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5858l-1.2929-1.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143l3 3a1 1 0 0 0 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L20 5.5858z"
    />
  </svg>
);

export const ImageLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 8.5c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.1754.0143.3637.024.5655.0306.2093.0139.4597.0138.7177.0138L17 22h.1376c.7954.0005 1.386.0008 1.8977-.1363a4 4 0 0 0 2.8284-2.8284c.1753-.6543.1365-1.3548.1363-2.0258.0018-.1893.0001-.3787.0001-.568.0005-.4689.001-.8821-.1078-1.2768a3 3 0 0 0-.4633-.964c-.2403-.3315-.5632-.5893-.9297-.8818l-2.831-2.2648c-.1699-.1359-.3379-.2703-.4904-.3744-.1696-.1158-.3784-.2361-.6397-.3031a2 2 0 0 0-1.1145.0352c-.2566.0833-.4574.2165-.6194.3427-.1457.1136-.3048.2583-.4658.4047l-8.508 7.7346c-.2135.194-.4199.3816-.5716.5457-.0608.0659-.1532.1682-.2396.3035a2 2 0 0 1-.8013-.835c-.0797-.1564-.1446-.3806-.1804-.819C4.0008 17.6389 4 17.0566 4 16.2V7.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C6.3611 4.0008 6.9434 4 7.8 4h4.7c.5523 0 1-.4477 1-1s-.4477-1-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.7071 2.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3a1 1 0 0 0 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L18.4142 6H22c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3.5858z"
    />
  </svg>
);

export const ImagePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 8.5c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.1754.0143.3637.024.5655.0306.2093.0139.4597.0138.7177.0138L17 22h.1376c.7954.0005 1.386.0008 1.8977-.1363a4 4 0 0 0 2.8284-2.8284c.1753-.6543.1365-1.3548.1363-2.0258.0018-.1893.0001-.3787.0001-.568.0005-.4689.001-.8821-.1078-1.2768a3 3 0 0 0-.4633-.964c-.2403-.3315-.5632-.5893-.9297-.8818l-2.831-2.2648c-.1699-.1359-.3379-.2703-.4904-.3744-.1696-.1158-.3784-.2361-.6397-.3031a2 2 0 0 0-1.1145.0352c-.2566.0833-.4574.2165-.6194.3427-.1457.1136-.3048.2583-.4658.4047l-8.508 7.7346c-.2135.194-.4199.3816-.5716.5457-.0608.0659-.1532.1682-.2396.3035a2 2 0 0 1-.8013-.835c-.0797-.1564-.1446-.3806-.1804-.819C4.0008 17.6389 4 17.0566 4 16.2V7.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C6.3611 4.0008 6.9434 4 7.8 4h4.7c.5523 0 1-.4477 1-1s-.4477-1-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1V6h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2z"
    />
  </svg>
);

export const ImageRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 8.5c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.1754.0143.3637.024.5655.0306.2093.0139.4597.0138.7177.0138L17 22h.1376c.7954.0005 1.386.0008 1.8977-.1363a4 4 0 0 0 2.8284-2.8284c.1753-.6543.1365-1.3548.1363-2.0258.0018-.1893.0001-.3787.0001-.568.0005-.4689.001-.8821-.1078-1.2768a3 3 0 0 0-.4633-.964c-.2403-.3315-.5632-.5893-.9297-.8818l-2.831-2.2648c-.1699-.1359-.3379-.2703-.4904-.3744-.1696-.1158-.3784-.2361-.6397-.3031a2 2 0 0 0-1.1145.0352c-.2566.0833-.4574.2165-.6194.3427-.1457.1136-.3048.2583-.4658.4047l-8.508 7.7346c-.2135.194-.4199.3816-.5716.5457-.0608.0659-.1532.1682-.2396.3035a2 2 0 0 1-.8013-.835c-.0797-.1564-.1446-.3806-.1804-.819C4.0008 17.6389 4 17.0566 4 16.2V7.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C6.3611 4.0008 6.9434 4 7.8 4h4.7c.5523 0 1-.4477 1-1s-.4477-1-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L19.5858 4H16c-.5523 0-1 .4477-1 1s.4477 1 1 1h3.5858l-1.2929 1.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3a1 1 0 0 0 0-1.4142z"
    />
  </svg>
);

export const ImageUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 8.5c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.1754.0143.3637.024.5655.0306.2093.0139.4597.0138.7177.0138L17 22h.1376c.7954.0005 1.386.0008 1.8977-.1363a4 4 0 0 0 2.8284-2.8284c.1753-.6543.1365-1.3548.1363-2.0258.0018-.1893.0001-.3787.0001-.568.0005-.4689.001-.8821-.1078-1.2768a3 3 0 0 0-.4633-.964c-.2403-.3315-.5632-.5893-.9297-.8818l-2.831-2.2648c-.1699-.1359-.3379-.2703-.4904-.3744-.1696-.1158-.3784-.2361-.6397-.3031a2 2 0 0 0-1.1145.0352c-.2566.0833-.4574.2165-.6194.3427-.1457.1136-.3048.2583-.4658.4047l-8.508 7.7346c-.2135.194-.4199.3816-.5716.5457-.0608.0659-.1532.1682-.2396.3035a2 2 0 0 1-.8013-.835c-.0797-.1564-.1446-.3806-.1804-.819C4.0008 17.6389 4 17.0566 4 16.2V7.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C6.3611 4.0008 6.9434 4 7.8 4h4.7c.5523 0 1-.4477 1-1s-.4477-1-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.7071 1.2929a1 1 0 0 0-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L18 4.4142V8c0 .5523.4477 1 1 1s1-.4477 1-1V4.4142l1.2929 1.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143z"
    />
  </svg>
);

export const ImageUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 9.5c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.2413 1H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 5.2894 1 5.9537 1 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 23 5.9537 23 6.7587 23h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 18.7106 23 18.0463 23 17.2413V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 1 18.0463 1 17.2413 1M4.092 3.218c.1564-.0797.3806-.1446.819-.1804C5.3611 3.0008 5.9434 3 6.8 3h10.4c.8566 0 1.4389.0008 1.889.0375.4384.0359.6626.1008.819.1805.3763.1917.6823.4977.874.874.0797.1564.1446.3806.1804.819C20.9992 5.3611 21 5.9434 21 6.8v10.4c0 .8566-.0008 1.4389-.0376 1.889-.0259.3179-.0672.5232-.1184.6717a5 5 0 0 0-3.8685-3.6646c-.4848-.0964-1.0421-.0963-1.8597-.0961H8.8843c-.8176-.0002-1.375-.0003-1.8597.0961a5 5 0 0 0-3.8686 3.6647c-.0512-.1485-.0925-.3538-.1185-.6718C3.0008 18.6389 3 18.0566 3 17.2V6.8c0-.8566.0008-1.4389.0375-1.889.0359-.4384.1008-.6626.1805-.819a2 2 0 0 1 .874-.874"
      clipRule="evenodd"
    />
  </svg>
);

export const ImageUserCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 1H12c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.8c-.8566 0-1.4389.0008-1.889.0375-.4384.0359-.6626.1008-.819.1805a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C3.0008 5.3611 3 5.9434 3 6.8v10.1996A4.977 4.977 0 0 1 5.9998 16h7.5579c.4088 0 .6871-.0001.9326.0241 2.3736.2339 4.2516 2.1117 4.4856 4.4854.0135.1373.0195.2848.0221.4598a7 7 0 0 0 .091-.0069c.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V12c0-.5523.4477-1 1-1s1 .4477 1 1v5.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 23 18.0463 23 17.2413 23H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 18.7106 1 18.0463 1 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 1 5.9537 1 6.7587 1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M22.7071 3.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L18 5.5858l-1.2929-1.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143l2 2c.3905.3905 1.0237.3905 1.4142 0z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 4.5c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const ImageUserDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 1H12c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.8c-.8566 0-1.4389.0008-1.889.0375-.4384.0359-.6626.1008-.819.1805a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C3.0008 5.3611 3 5.9434 3 6.8v10.1996A4.977 4.977 0 0 1 5.9998 16h7.5579c.4088 0 .6871-.0001.9326.0241 2.3736.2339 4.2516 2.1117 4.4856 4.4854.0135.1373.0195.2848.0221.4598a7 7 0 0 0 .091-.0069c.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V12c0-.5523.4477-1 1-1s1 .4477 1 1v5.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 23 18.0463 23 17.2413 23H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 18.7106 1 18.0463 1 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 1 5.9537 1 6.7587 1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 4.5c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5858l-1.2929-1.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143l3 3a1 1 0 0 0 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L20 5.5858z"
    />
  </svg>
);

export const ImageUserLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 1H12c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.8c-.8566 0-1.4389.0008-1.889.0375-.4384.0359-.6626.1008-.819.1805a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C3.0008 5.3611 3 5.9434 3 6.8v10.1996A4.977 4.977 0 0 1 5.9998 16h7.5579c.4088 0 .6871-.0001.9326.0241 2.3736.2339 4.2516 2.1117 4.4856 4.4854.0135.1373.0195.2848.0221.4598a7 7 0 0 0 .091-.0069c.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V12c0-.5523.4477-1 1-1s1 .4477 1 1v5.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 23 18.0463 23 17.2413 23H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 18.7106 1 18.0463 1 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 1 5.9537 1 6.7587 1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 4.5c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.7071 2.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3a1 1 0 0 0 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L18.4142 6H22c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3.5858z"
    />
  </svg>
);

export const ImageUserPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 1H12c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.8c-.8566 0-1.4389.0008-1.889.0375-.4384.0359-.6626.1008-.819.1805a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C3.0008 5.3611 3 5.9434 3 6.8v10.1996A4.977 4.977 0 0 1 5.9998 16h7.5579c.4088 0 .6871-.0001.9326.0241 2.3736.2339 4.2516 2.1117 4.4856 4.4854.0135.1373.0195.2848.0221.4598a7 7 0 0 0 .091-.0069c.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V12c0-.5523.4477-1 1-1s1 .4477 1 1v5.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 23 18.0463 23 17.2413 23H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 18.7106 1 18.0463 1 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 1 5.9537 1 6.7587 1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 4.5c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1V6h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2z"
    />
  </svg>
);

export const ImageUserRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 1H12c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.8c-.8566 0-1.4389.0008-1.889.0375-.4384.0359-.6626.1008-.819.1805a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C3.0008 5.3611 3 5.9434 3 6.8v10.1996A4.977 4.977 0 0 1 5.9998 16h7.5579c.4088 0 .6871-.0001.9326.0241 2.3736.2339 4.2516 2.1117 4.4856 4.4854.0135.1373.0195.2848.0221.4598a7 7 0 0 0 .091-.0069c.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V12c0-.5523.4477-1 1-1s1 .4477 1 1v5.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 23 18.0463 23 17.2413 23H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 18.7106 1 18.0463 1 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 1 5.9537 1 6.7587 1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 4.5c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L19.5858 4H16c-.5523 0-1 .4477-1 1s.4477 1 1 1h3.5858l-1.2929 1.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3a1 1 0 0 0 0-1.4142z"
    />
  </svg>
);

export const ImageUserUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 1H12c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.8c-.8566 0-1.4389.0008-1.889.0375-.4384.0359-.6626.1008-.819.1805a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C3.0008 5.3611 3 5.9434 3 6.8v10.1996A4.977 4.977 0 0 1 5.9998 16h7.5579c.4088 0 .6871-.0001.9326.0241 2.3736.2339 4.2516 2.1117 4.4856 4.4854.0135.1373.0195.2848.0221.4598a7 7 0 0 0 .091-.0069c.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V12c0-.5523.4477-1 1-1s1 .4477 1 1v5.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 23 18.0463 23 17.2413 23H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 18.7106 1 18.0463 1 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 1 5.9537 1 6.7587 1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 4.5c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.7071 1.2929a1 1 0 0 0-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L18 4.4142V8c0 .5523.4477 1 1 1s1-.4477 1-1V4.4142l1.2929 1.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143z"
    />
  </svg>
);

export const ImageUserX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 1H12c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.8c-.8566 0-1.4389.0008-1.889.0375-.4384.0359-.6626.1008-.819.1805a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C3.0008 5.3611 3 5.9434 3 6.8v10.1996A4.977 4.977 0 0 1 5.9998 16h7.5579c.4088 0 .6871-.0001.9326.0241 2.3736.2339 4.2516 2.1117 4.4856 4.4854.0135.1373.0195.2848.0221.4598a7 7 0 0 0 .091-.0069c.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V12c0-.5523.4477-1 1-1s1 .4477 1 1v5.2413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 23 18.0463 23 17.2413 23H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 18.7106 1 18.0463 1 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 1 5.9537 1 6.7587 1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 4.5c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M17.2071 1.7929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 5l-1.7929 1.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L19 6.4142l1.7929 1.793c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143L20.4142 5l1.7929-1.7929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L19 3.5858z"
    />
  </svg>
);

export const ImageX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 8.5c0-1.6569 1.3431-3 3-3s3 1.3431 3 3-1.3431 3-3 3-3-1.3431-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.1754.0143.3637.024.5655.0306.2093.0139.4597.0138.7177.0138L17 22h.1376c.7954.0005 1.386.0008 1.8977-.1363a4 4 0 0 0 2.8284-2.8284c.1753-.6543.1365-1.3548.1363-2.0258.0018-.1893.0001-.3787.0001-.568.0005-.4689.001-.8821-.1078-1.2768a3 3 0 0 0-.4633-.964c-.2403-.3315-.5632-.5893-.9297-.8818l-2.831-2.2648c-.1699-.1359-.3379-.2703-.4904-.3744-.1696-.1158-.3784-.2361-.6397-.3031a2 2 0 0 0-1.1145.0352c-.2566.0833-.4574.2165-.6194.3427-.1457.1136-.3048.2583-.4658.4047l-8.508 7.7346c-.2135.194-.4199.3816-.5716.5457-.0608.0659-.1532.1682-.2396.3035a2 2 0 0 1-.8013-.835c-.0797-.1564-.1446-.3806-.1804-.819C4.0008 17.6389 4 17.0566 4 16.2V7.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C6.3611 4.0008 6.9434 4 7.8 4h4.7c.5523 0 1-.4477 1-1s-.4477-1-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M17.2071 1.7929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L17.5858 5l-1.7929 1.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L19 6.4142l1.7929 1.793c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143L20.4142 5l1.7929-1.7929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L19 3.5858z"
    />
  </svg>
);

export const Annotation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v5.7756c0 .6698 0 1.2226-.0309 1.6752-.032.4693-.1005.9034-.2736 1.3212a4 4 0 0 1-2.1648 2.1648c-.4178.1731-.8519.2416-1.3212.2736C17.7569 19 17.2041 19 16.5343 19H16.5c-.5366 0-.6431.0063-.7298.0268a1 1 0 0 0-.4109.2054c-.0684.0571-.1374.1386-.4593.5678l-1.4769 1.9692c-.0934.1246-.1989.2654-.3005.3784-.112.1245-.2982.3079-.5789.4171a1.5 1.5 0 0 1-1.0874 0c-.2807-.1092-.4669-.2926-.5789-.4171-.1016-.113-.2071-.2538-.3005-.3784L9.1 19.8c-.322-.4292-.3909-.5107-.4592-.5678a1 1 0 0 0-.411-.2054C8.143 19.0063 8.0366 19 7.5 19h-.0343c-.6698 0-1.2226 0-1.6752-.0309-.4693-.032-.9034-.1005-1.3212-.2736a4 4 0 0 1-2.1648-2.1648c-.173-.4178-.2416-.8519-.2736-1.3212-.031-.4526-.031-1.0054-.0309-1.6752V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2"
      clipRule="evenodd"
    />
  </svg>
);

export const AnnotationAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2413 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v5.7756c0 .6698 0 1.2226.0309 1.6752.032.4693.1005.9034.2736 1.3212a4 4 0 0 0 2.1648 2.1648c.4178.1731.8519.2416 1.3212.2736C6.243 19 6.7959 19 7.4657 19H7.5c.5366 0 .643.0063.7297.0268a1 1 0 0 1 .411.2054c.0684.0571.1374.1386.4593.5678l1.4769 1.9692c.0934.1246.1989.2654.3005.3784.112.1245.2982.3079.5789.4171a1.5 1.5 0 0 0 1.0874 0c.2807-.1092.4669-.2926.5789-.4171.1016-.113.2071-.2538.3005-.3784L14.9 19.8c.3219-.4292.3909-.5107.4593-.5678a1 1 0 0 1 .4109-.2054c.0867-.0205.1932-.0268.7298-.0268h.0343c.6698 0 1.2226 0 1.6752-.0309.4693-.032.9034-.1005 1.3212-.2736a4 4 0 0 0 2.1648-2.1648c.1731-.4178.2416-.8519.2736-1.3212C22 14.7569 22 14.2041 22 13.5343V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 2 17.0463 2 16.2413 2M13 7c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const AnnotationCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2413 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v5.7756c0 .6698 0 1.2226.0309 1.6752.032.4693.1005.9034.2736 1.3212a4 4 0 0 0 2.1648 2.1648c.4178.1731.8519.2416 1.3212.2736C6.243 19 6.7959 19 7.4657 19H7.5c.5366 0 .643.0063.7297.0268a1 1 0 0 1 .411.2054c.0684.0571.1374.1386.4593.5678l1.4769 1.9692c.0934.1246.1989.2654.3005.3784.112.1245.2982.3079.5789.4171a1.5 1.5 0 0 0 1.0874 0c.2807-.1092.4669-.2926.5789-.4171.1016-.113.2071-.2538.3005-.3784L14.9 19.8c.3219-.4292.3909-.5107.4593-.5678a1 1 0 0 1 .4109-.2054c.0867-.0205.1932-.0268.7298-.0268h.0343c.6698 0 1.2226 0 1.6752-.0309.4693-.032.9034-.1005 1.3212-.2736a4 4 0 0 0 2.1648-2.1648c.1731-.4178.2416-.8519.2736-1.3212C22 14.7569 22 14.2041 22 13.5343V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 2 17.0463 2 16.2413 2m-.0342 7.2071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 11.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const AnnotationDots = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2413 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v5.7756c0 .6698 0 1.2226.0309 1.6752.032.4693.1005.9034.2736 1.3212a4 4 0 0 0 2.1648 2.1648c.4178.1731.8519.2416 1.3212.2736C6.243 19 6.7959 19 7.4657 19H7.5c.5366 0 .643.0063.7297.0268a1 1 0 0 1 .411.2054c.0684.0571.1374.1386.4593.5678l1.4769 1.9692c.0934.1246.1989.2654.3005.3784.112.1245.2982.3079.5789.4171a1.5 1.5 0 0 0 1.0874 0c.2807-.1092.4669-.2926.5789-.4171.1016-.113.2071-.2538.3005-.3784L14.9 19.8c.3219-.4292.3909-.5107.4593-.5678a1 1 0 0 1 .4109-.2054c.0867-.0205.1932-.0268.7298-.0268h.0343c.6698 0 1.2226 0 1.6752-.0309.4693-.032.9034-.1005 1.3212-.2736a4 4 0 0 0 2.1648-2.1648c.1731-.4178.2416-.8519.2736-1.3212C22 14.7569 22 14.2041 22 13.5343V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 2 17.0463 2 16.2413 2M6 10.5C6 9.6716 6.6716 9 7.5 9S9 9.6716 9 10.5 8.3284 12 7.5 12 6 11.3284 6 10.5m4.5 0c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5S12.8284 12 12 12s-1.5-.6716-1.5-1.5m6-1.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5S17.3284 9 16.5 9"
      clipRule="evenodd"
    />
  </svg>
);

export const AnnotationHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2413 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v5.7756c0 .6698 0 1.2226.0309 1.6752.032.4693.1005.9034.2736 1.3212a4 4 0 0 0 2.1648 2.1648c.4178.1731.8519.2416 1.3212.2736C6.243 19 6.7959 19 7.4657 19H7.5c.5366 0 .643.0063.7297.0268a1 1 0 0 1 .411.2054c.0684.0571.1374.1386.4593.5678l1.4769 1.9692c.0934.1246.1989.2654.3005.3784.112.1245.2982.3079.5789.4171a1.5 1.5 0 0 0 1.0874 0c.2807-.1092.4669-.2926.5789-.4171.1016-.113.2071-.2538.3005-.3784L14.9 19.8c.3219-.4292.3909-.5107.4593-.5678a1 1 0 0 1 .4109-.2054c.0867-.0205.1932-.0268.7298-.0268h.0343c.6698 0 1.2226 0 1.6752-.0309.4693-.032.9034-.1005 1.3212-.2736a4 4 0 0 0 2.1648-2.1648c.1731-.4178.2416-.8519.2736-1.3212C22 14.7569 22 14.2041 22 13.5343V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 2 17.0463 2 16.2413 2M8.8619 8.0094c1.002-.8323 2.3356-.5878 3.1354.3212.7997-.909 2.1161-1.1448 3.1353-.3212s1.1431 2.2241.3562 3.2085c-.4679.5854-1.614 1.6352-2.4662 2.39-.3518.3116-.5277.4674-.7394.5306a1.028 1.028 0 0 1-.5718 0c-.2118-.0632-.3877-.219-.7395-.5306-.8522-.7548-1.9983-1.8046-2.4662-2.39-.787-.9844-.6458-2.376.3562-3.2085"
      clipRule="evenodd"
    />
  </svg>
);

export const AnnotationInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2413 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v5.7756c0 .6698 0 1.2226.0309 1.6752.032.4693.1005.9034.2736 1.3212a4 4 0 0 0 2.1648 2.1648c.4178.1731.8519.2416 1.3212.2736C6.243 19 6.7959 19 7.4657 19H7.5c.5366 0 .643.0063.7297.0268a1 1 0 0 1 .411.2054c.0684.0571.1374.1386.4593.5678l1.4769 1.9692c.0934.1246.1989.2654.3005.3784.112.1245.2982.3079.5789.4171a1.5 1.5 0 0 0 1.0874 0c.2807-.1092.4669-.2926.5789-.4171.1016-.113.2071-.2538.3005-.3784L14.9 19.8c.3219-.4292.3909-.5107.4593-.5678a1 1 0 0 1 .4109-.2054c.0867-.0205.1932-.0268.7298-.0268h.0343c.6698 0 1.2226 0 1.6752-.0309.4693-.032.9034-.1005 1.3212-.2736a4 4 0 0 0 2.1648-2.1648c.1731-.4178.2416-.8519.2736-1.3212C22 14.7569 22 14.2041 22 13.5343V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 2 17.0463 2 16.2413 2M12 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zm1 4.5c0-.5523-.4477-1-1-1s-1 .4477-1 1V14c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const AnnotationPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2413 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v5.7756c0 .6698 0 1.2226.0309 1.6752.032.4693.1005.9034.2736 1.3212a4 4 0 0 0 2.1648 2.1648c.4178.1731.8519.2416 1.3212.2736C6.243 19 6.7959 19 7.4657 19H7.5c.5366 0 .643.0063.7297.0268a1 1 0 0 1 .411.2054c.0684.0571.1374.1386.4593.5678l1.4769 1.9692c.0934.1246.1989.2654.3005.3784.112.1245.2982.3079.5789.4171a1.5 1.5 0 0 0 1.0874 0c.2807-.1092.4669-.2926.5789-.4171.1016-.113.2071-.2538.3005-.3784L14.9 19.8c.3219-.4292.3909-.5107.4593-.5678a1 1 0 0 1 .4109-.2054c.0867-.0205.1932-.0268.7298-.0268h.0343c.6698 0 1.2226 0 1.6752-.0309.4693-.032.9034-.1005 1.3212-.2736a4 4 0 0 0 2.1648-2.1648c.1731-.4178.2416-.8519.2736-1.3212C22 14.7569 22 14.2041 22 13.5343V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 2 17.0463 2 16.2413 2M12 6.5c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const AnnotationQuestion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2413 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v5.7756c0 .6698 0 1.2226.0309 1.6752.032.4693.1005.9034.2736 1.3212a4 4 0 0 0 2.1648 2.1648c.4178.1731.8519.2416 1.3212.2736C6.243 19 6.7959 19 7.4657 19H7.5c.5366 0 .643.0063.7297.0268a1 1 0 0 1 .411.2054c.0684.0571.1374.1386.4593.5678l1.4769 1.9692c.0934.1246.1989.2654.3005.3784.112.1245.2982.3079.5789.4171a1.5 1.5 0 0 0 1.0874 0c.2807-.1092.4669-.2926.5789-.4171.1016-.113.2071-.2538.3005-.3784L14.9 19.8c.3219-.4292.3909-.5107.4593-.5678a1 1 0 0 1 .4109-.2054c.0867-.0205.1932-.0268.7298-.0268h.0343c.6698 0 1.2226 0 1.6752-.0309.4693-.032.9034-.1005 1.3212-.2736a4 4 0 0 0 2.1648-2.1648c.1731-.4178.2416-.8519.2736-1.3212C22 14.7569 22 14.2041 22 13.5343V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 2 17.0463 2 16.2413 2m-4.7529 6.1721a1.2485 1.2485 0 0 1 1.8809 1.078v.0016c0 .2186-.1772.5197-.6789.8542-.2204.1469-.4479.2614-.6243.3398a4.3 4.3 0 0 1-.2045.0847 2 2 0 0 1-.0504.0186l-.0092.0032.0016-.0005c-.5232.1751-.8059.741-.6313 1.2645.1746.524.7409.8071 1.2649.6325l.0012-.0004a4 4 0 0 0 .1351-.0489c.0761-.029.1809-.071.3049-.1261.2452-.109.5797-.2755.9214-.5033.6224-.415 1.5693-1.2378 1.5695-2.5179a3.2483 3.2483 0 0 0-6.3126-1.0817c-.1833.521.0905 1.0919.6115 1.2752s1.0919-.0905 1.2752-.6115a1.248 1.248 0 0 1 .545-.662m.6615 5.3279c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const AnnotationX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2413 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v5.7756c0 .6698 0 1.2226.0309 1.6752.032.4693.1005.9034.2736 1.3212a4 4 0 0 0 2.1648 2.1648c.4178.1731.8519.2416 1.3212.2736C6.243 19 6.7959 19 7.4657 19H7.5c.5366 0 .643.0063.7297.0268a1 1 0 0 1 .411.2054c.0684.0571.1374.1386.4593.5678l1.4769 1.9692c.0934.1246.1989.2654.3005.3784.112.1245.2982.3079.5789.4171a1.5 1.5 0 0 0 1.0874 0c.2807-.1092.4669-.2926.5789-.4171.1016-.113.2071-.2538.3005-.3784L14.9 19.8c.3219-.4292.3909-.5107.4593-.5678a1 1 0 0 1 .4109-.2054c.0867-.0205.1932-.0268.7298-.0268h.0343c.6698 0 1.2226 0 1.6752-.0309.4693-.032.9034-.1005 1.3212-.2736a4 4 0 0 0 2.1648-2.1648c.1731-.4178.2416-.8519.2736-1.3212C22 14.7569 22 14.2041 22 13.5343V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 2 17.0463 2 16.2413 2M8.7929 7.2929c.3905-.3905 1.0237-.3905 1.4142 0L12 9.0858l1.7929-1.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L13.4142 10.5l1.7929 1.7929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 11.9142l-1.7929 1.7929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L10.5858 10.5l-1.793-1.7929c-.3904-.3905-.3904-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const Inbox01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.8141 3c-.9277-.0007-1.627-.0012-2.2642.2186a4 4 0 0 0-1.4946.9237c-.4816.4717-.794 1.0974-1.2082 1.9275a6059 6059 0 0 0-1.8842 3.7738c-.191.3827-.2864.574-.2633.7298a.5.5 0 0 0 .2081.3364C2.0367 11 2.2508 11 2.679 11h3.203a2.809 2.809 0 0 1 2.5125 1.5528A.809.809 0 0 0 9.118 13h5.764a.809.809 0 0 0 .7236-.4472A2.809 2.809 0 0 1 18.1181 11h3.203c.4281 0 .6422 0 .7713-.0902a.5.5 0 0 0 .2081-.3364c.0231-.1558-.0724-.3471-.2633-.7298a5687 5687 0 0 0-1.8842-3.7738c-.4143-.83-.7266-1.4558-1.2082-1.9275a4 4 0 0 0-1.4946-.9237c-.6372-.2198-1.3366-.2193-2.2643-.2187z"
    />
    <path
      fill="currentColor"
      d="M23.0001 14.5996c0-.5597 0-.8396-.1089-1.0535a1 1 0 0 0-.4371-.4371C22.2402 13 21.9603 13 21.4004 13h-3.2823a.809.809 0 0 0-.7237.4472A2.809 2.809 0 0 1 14.882 15H9.118a2.809 2.809 0 0 1-2.5124-1.5528A.809.809 0 0 0 5.882 13H2.5996c-.5598 0-.8398 0-1.0537.109a1 1 0 0 0-.437.4371C1 13.76 1 14.0399 1 14.5996v.6417c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.0021.3459 1.5642.3918C5.2894 21 5.9538 21 6.7587 21h10.4827c.8049 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5641-.3918a4 4 0 0 0 1.7481-1.748c.2473-.4854.3458-1.0021.3917-1.5642.0443-.5412.0443-1.2055.0442-2.0105z"
    />
  </svg>
);

export const Inbox02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.2413 3H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 7.2894 1 7.9537 1 8.7587V9.4c0 .56 0 .8401.109 1.054a1 1 0 0 0 .437.437C1.76 11 2.04 11 2.6 11h3.282a2.809 2.809 0 0 1 2.5124 1.5528A.809.809 0 0 0 9.118 13h5.764a.809.809 0 0 0 .7236-.4472A2.809 2.809 0 0 1 18.118 11H21.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C23 10.2401 23 9.96 23 9.4v-.6413c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 3 18.0463 3 17.2413 3M23 14.6c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C22.2401 13 21.9601 13 21.4 13h-3.282a.809.809 0 0 0-.7236.4472A2.809 2.809 0 0 1 14.882 15H9.118a2.809 2.809 0 0 1-2.5124-1.5528A.809.809 0 0 0 5.882 13H2.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 13.7599 1 14.0399 1 14.6v.6413c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 21 5.9537 21 6.7587 21h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 16.7106 23 16.0463 23 15.2413z"
    />
  </svg>
);

export const Mail01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.1335 8.1814c-.3-.2142-.4499-.3213-.5806-.3352a.506.506 0 0 0-.4882.2512C1 8.212 1 8.3942 1 8.7587v6.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 21 5.9537 21 6.7587 21h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 16.7106 23 16.0463 23 15.2413V8.7587c0-.1787 0-.268-.0164-.3304-.074-.282-.3806-.4427-.6546-.343-.0606.022-.135.0736-.2837.1765l-7.7421 5.3601c-.549.3813-1.031.716-1.5785.8487a3 3 0 0 1-1.4562-.0107c-.5456-.1408-1.0226-.4825-1.5658-.8718z"
    />
    <path
      fill="currentColor"
      d="M22.1328 5.7687c.1846-.1278.2769-.1917.3336-.2945.044-.0798.0692-.2062.0591-.2967-.013-.1167-.0625-.1937-.1617-.3478-.3799-.59-.9265-1.0771-1.5478-1.3937-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 3 18.0463 3 17.2413 3H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4.005 4.005 0 0 0-1.4096 1.1974c-.1156.1575-.1734.2363-.1925.3558-.0149.0935.006.2234.0493.3075.0554.1077.1515.1763.3437.3136l8.7751 6.268c.7273.5194.8816.6098 1.0181.645a1 1 0 0 0 .4854.0036c.1371-.0332.2928-.1213 1.0275-.63z"
    />
  </svg>
);

export const Mail02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.0655 8.2115c-.2421-.171-.3632-.2564-.4664-.2773-.2275-.046-.463.076-.5566.2884C1 8.319 1 8.4656 1 8.7586v6.4827c0 .805 0 1.4693.0442 2.0105.0237.2904.3622.4072.578.2116l5.1943-4.7053c.253-.2292.3796-.3439.4199-.4755a.5.5 0 0 0-.0213-.3499c-.056-.1257-.1954-.2242-.4744-.4211zM2.6912 19.1938c-.2037.1844-.3055.2767-.3458.4085-.0312.1022-.0219.2528.0218.3504.0563.1258.1491.191.3349.3214.153.1074.314.2043.482.2899.4853.2473 1.002.3459 1.564.3918C5.2895 21 5.9538 21 6.7588 21h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 .4819-.2899c.1858-.1304.2786-.1956.3349-.3214.0437-.0976.0531-.2482.0218-.3504-.0403-.1318-.1421-.2241-.3457-.4085L15.1892 13.65c-.117-.1059-.1754-.1589-.2387-.1899a.5.5 0 0 0-.3844-.0233c-.0666.0231-.1311.0687-.2599.1597-.5473.3875-1.0279.7278-1.5759.8653a3 3 0 0 1-1.4604 0c-.5481-.1375-1.0286-.4778-1.5759-.8653-.129-.0911-.1934-.1366-.26-.1598a.5.5 0 0 0-.3843.0233c-.0633.031-.1219.084-.2388.19zM22.3777 17.4634c.2159.1956.5544.0787.5781-.2116C23 16.7106 23 16.0463 23 15.2413V8.7587c0-.293 0-.4395-.0424-.5359-.0936-.2124-.3292-.3345-.5567-.2884-.1032.0208-.2243.1063-.4663.2771l-4.6752 3.3002c-.279.1969-.4185.2953-.4744.4211a.5.5 0 0 0-.0213.3499c.0403.1316.1669.2462.4199.4755zM22.2796 4.7073c.1092.1559.1638.2338.1806.3524.0131.0924-.0094.2212-.053.3037-.0559.1059-.1504.1726-.3396.3061l-8.7988 6.211c-.7327.5172-.8881.607-1.0253.6414a1 1 0 0 1-.4868 0c-.1372-.0344-.2926-.1242-1.0253-.6414l-8.799-6.211c-.1891-.1335-.2837-.2003-.3396-.3062-.0436-.0825-.066-.2113-.053-.3037.0169-.1186.0715-.1965.1806-.3524A4.03 4.03 0 0 1 3.184 3.436c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 3 5.9537 3 6.7587 3h10.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4.03 4.03 0 0 1 1.4636 1.2713"
    />
  </svg>
);

export const Mail03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.0214 8.2162c-.2137-.1425-.3206-.2138-.4104-.2342-.2403-.0548-.4905.079-.5782.3094C1 8.3775 1 8.5046 1 8.7587v6.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 21 5.9537 21 6.7587 21h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 16.7106 23 16.0463 23 15.2413V8.7587c0-.254 0-.381-.0327-.467-.0878-.2305-.338-.3644-.5784-.3096-.0897.0205-.1965.0917-.4102.2341l-4.6683 3.1123c-.2499.1668-.4703.314-.7156.421a3 3 0 0 1-.6738.2041c-.2635.0469-.5285.0467-.8289.0465h-6.184c-.3003.0002-.5654.0004-.8289-.0465a3 3 0 0 1-.6738-.2041c-.2453-.107-.4657-.2542-.7155-.421z"
    />
    <path
      fill="currentColor"
      d="M22.0949 5.735c.1919-.1279.2878-.1918.3466-.2964.0456-.0813.0715-.2104.0606-.303-.0139-.1191-.0661-.1976-.1706-.3545-.3782-.568-.9108-1.037-1.5155-1.3451-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 3 18.0463 3 17.2413 3H6.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918-.6047.3081-1.1372.777-1.5154 1.345-.1045.157-.1568.2354-.1707.3546-.0108.0925.015.2216.0607.3028.0587.1047.1547.1686.3466.2966l5.8434 3.8956c.3283.2189.3946.2587.457.286.072.0314.1473.0542.2246.068.067.012.1442.0155.5388.0155h6.0622c.3946 0 .4718-.0036.5388-.0155a1 1 0 0 0 .2246-.068c.0624-.0273.1287-.0671.457-.286z"
    />
  </svg>
);

export const Mail04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.6855.9646a3 3 0 0 0-1.371 0c-.5151.121-.9729.4194-1.4938.759-2.2553 1.466-4.5166 2.923-6.7684 4.3944-.3405.2224-.5107.3336-.57.475a.5.5 0 0 0 0 .3865c.0592.1414.2296.2528.5705.4757l7.7433 5.0629c.698.4564.8446.5351.9744.5657.1509.0356.3081.0356.4591 0 .1298-.0306.2763-.1093.9744-.5657l7.7433-5.0629c.3408-.2228.5112-.3343.5705-.4757a.5.5 0 0 0-.0001-.3864c-.0593-.1414-.2295-.2527-.57-.4751-2.2518-1.4713-4.5131-2.9284-6.7684-4.3944-.5209-.3396-.9787-.638-1.4938-.759"
    />
    <path
      fill="currentColor"
      d="M22.9974 9.9817c-.0003-.4801-.0005-.7201-.1009-.8536a.5.5 0 0 0-.3666-.1981c-.1667-.011-.3679.1206-.7703.3837l-7.5712 4.9505c-.5228.3429-.9823.6442-1.4997.7662a3 3 0 0 1-1.3774 0c-.5174-.122-.9768-.4233-1.4996-.7662L2.2404 9.3136c-.4024-.2631-.6036-.3946-.7703-.3837a.5.5 0 0 0-.3665.1982c-.1005.1334-.1007.3734-.101.8535C1.0016 11.7067 1 14.5406 1 16.2412c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5641a4 4 0 0 0 1.748 1.7481c.4854.2473 1.002.3459 1.5642.3918.5412.0442 1.2055.0442 2.0105.0442h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.7481c.2473-.4853.3459-1.002.3918-1.5641C23 17.7105 23 17.0462 23 16.2412c0-1.7006-.0016-4.5345-.0026-6.2595"
    />
  </svg>
);

export const Mail05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.6855.9648a3 3 0 0 0-1.371 0c-.5151.1209-.9729.4193-1.4938.759-2.2484 1.4615-4.4993 2.9194-6.7464 4.3829-.3414.2224-.5122.3336-.5716.4749a.5.5 0 0 0-.0007.3864c.059.1415.2294.2534.5703.477l7.7207 5.0668c.6997.4592.8466.5383.9768.5691.1514.0358.3091.0358.4605 0 .1301-.0308.2771-.1099.9768-.5691l7.7206-5.0667c.3409-.2237.5114-.3356.5704-.477a.5.5 0 0 0-.0007-.3865c-.0595-.1413-.2302-.2525-.5717-.4749-2.2471-1.4635-4.4979-2.9215-6.7464-4.383-.5209-.3396-.9787-.638-1.4938-.759M22.9965 9.9597c-.0003-.4808-.0005-.7211-.1012-.8546a.5.5 0 0 0-.367-.198c-.1668-.0107-.3681.1214-.7706.3855l-4.6385 3.044c-.2956.194-.4434.2911-.5035.4183a.5.5 0 0 0-.027.3568c.0404.1349.172.253.4351.4891l5.402 4.848c.1983.178.5083.0686.53-.197C23 17.7106 23 17.0463 23 16.2413c0-1.7054-.0021-4.5509-.0035-6.2816M21.3424 21.2424c.1829-.1321.2743-.1982.3289-.3239.0424-.0976.0504-.2474.0185-.3489-.041-.1309-.1427-.2221-.3459-.4045l-6.5321-5.8622-.0082-.0072a.5.5 0 0 0-.6096-.0393c-.524.3449-.9845.6481-1.5033.7708a3 3 0 0 1-1.3813 0c-.5189-.1227-.9794-.4259-1.5034-.7708l-.0093-.0061a.5.5 0 0 0-.6086.0526l-6.532 5.8622c-.2033.1824-.305.2736-.346.4044-.0318.1015-.0239.2513.0185.3489.0546.1258.146.1918.3289.3239.1662.1201.3421.2278.5265.3217.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 .5264-.3216M1.0442 18.2518c.0217.2656.3316.3749.5299.197l5.402-4.848c.2632-.2362.3948-.3543.4351-.4892a.5.5 0 0 0-.0269-.3567c-.0601-.1273-.208-.2243-.5036-.4184l-4.6384-3.044c-.4025-.264-.6038-.3962-.7706-.3854a.5.5 0 0 0-.367.198c-.1007.1334-.1009.3738-.1012.8545A9490 9490 0 0 0 1 16.2413c0 .805 0 1.4693.0442 2.0105"
    />
  </svg>
);

export const MessageAlertCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2C7.2533 2 3 6.2533 3 11.5c0 1.06.174 2.0814.4958 3.036.0566.1679.09.2673.1116.3406l.007.0246-.0037.0078c-.0257.053-.064.1242-.1354.2565L1.8235 18.223c-.1024.1894-.2092.3871-.2827.5589-.073.1708-.1913.4842-.1331.8557.0682.4354.3245.8188.7008 1.0483.321.1959.6558.2064.8415.2042.1869-.0022.4103-.0253.6245-.0475l5.155-.5329a7 7 0 0 1 .1573-.0153l.004-.0003.0124.0043c.0389.014.0915.0342.1825.0693C10.1466 20.7764 11.2984 21 12.5 21c5.2468 0 9.5-4.2533 9.5-9.5S17.7468 2 12.5 2m1 5.5c0-.5523-.4477-1-1-1s-1 .4477-1 1V11c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageAlertSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2414 2H7.7588c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v6.3789c-.0005.7954-.0008 1.386.1363 1.8977a4 4 0 0 0 2.8284 2.8284c.3075.0824.6435.1152 1.0353.1281v1.3792c0 .2352-.0001.475.0178.6715.017.188.0622.5427.3099.853a1.5 1.5 0 0 0 1.174.5642c.3969-.0004.7021-.1867.8596-.2908.1646-.1089.3518-.2587.5355-.4057l2.4131-1.9305c.5186-.4149.6726-.532.8325-.6137a2 2 0 0 1 .5079-.1782c.1759-.0361.3693-.0408 1.0334-.0408h2.5576c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0442-.5412.0442-1.2055.0442-2.0105V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7107 2 17.0464 2 16.2414 2M13 7c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageChatCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.2632 16.5c0-3.5669 2.8285-6.5 6.3684-6.5S14 12.9331 14 16.5 11.1715 23 7.6316 23a6.25 6.25 0 0 1-2.0821-.3556 15 15 0 0 0-.2242-.078l-.022-.0071-.0055.0006a8 8 0 0 0-.1677.0219l-2.9948.409a.9998.9998 0 0 1-1.1116-1.2069l.6113-2.7617a8 8 0 0 0 .041-.1919l-.007-.0237a14 14 0 0 0-.08-.2493A6.62 6.62 0 0 1 1.2632 16.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.1475 8.3726C5.9251 8.1307 6.754 8 7.618 8 12.3313 8 16 11.8907 16 16.5a8.59 8.59 0 0 1-.3285 2.3563 9.03 9.03 0 0 0 1.5722-.4317c.0712-.0267.1422-.0539.2141-.0785.058.0067.1158.0158.1736.0242l3.2129.471c.1517.0223.3238.0476.4738.0561.1661.0095.4244.0084.698-.1092a1.5 1.5 0 0 0 .7714-.7539c.1239-.2708.1309-.5289.1253-.6952-.0051-.1503-.0264-.3229-.0452-.4751l-.406-3.2979a8 8 0 0 1-.0192-.1637c.0176-.0723.0506-.1422.077-.2115A8.94 8.94 0 0 0 23.1053 10c0-4.9767-4.0592-9-9.0527-9-4.4357 0-8.1343 3.1748-8.905 7.3726"
    />
  </svg>
);

export const MessageChatSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.1615 10h5.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167.0306.3745.0306.8293.0306 1.3565v2.7848c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9856a3 3 0 0 1-1.6235 1.6236c-.326.135-.6559.1845-.9857.207A7 7 0 0 1 20 20.902V22a.9998.9998 0 0 1-1.5708.8211l-2.1764-1.5132c-.3353-.233-.4031-.2755-.4672-.3045a1 1 0 0 0-.2313-.0726c-.0692-.0127-.1491-.0165-.5574-.0165h-1.8354c-.5272 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C9 17.7347 9 17.28 9 16.7528v-2.5913c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C12.1795 10 12.6343 10 13.1615 10"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.2413 1H6.7587c-.805 0-1.4693 0-2.0105.0442-.562.046-1.0788.1445-1.5641.3918A4 4 0 0 0 1.436 3.184c-.2473.4854-.3458 1.002-.3918 1.5642C1 5.2894 1 5.9537 1 6.7587v4.7621c-.0001.4417-.0002.7689.0423 1.0589.2561 1.7486 1.6294 3.1219 3.378 3.3781.0715.0104.116.0373.1353.0533v1.5778c0 .2726-.0001.54.019.755.0168.191.061.5867.3422.9146a1.5 1.5 0 0 0 1.263.5186c.4304-.0358.74-.2862.8862-.4102a4 4 0 0 0 .129-.115c-.0925-.3607-.1345-.6952-.1578-.9797C6.9998 17.8136 7 17.2838 7 16.7952v-2.676c-.0001-.4887-.0002-1.0185.0372-1.4771.0424-.519.1474-1.2047.5078-1.912A5 5 0 0 1 9.73 8.545c.7074-.3604 1.3931-.4654 1.9121-.5078.4586-.0374.9884-.0373 1.477-.0372h5.7618c.3657 0 .7544-.0002 1.1191.0155V6.7587c0-.805.0001-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3917-1.5642a4 4 0 0 0-1.7481-1.748c-.4853-.2473-1.002-.3459-1.5641-.3918C15.7107 1 15.0463 1 14.2413 1"
    />
  </svg>
);

export const MessageCheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2C7.2533 2 3 6.2533 3 11.5c0 1.06.174 2.0814.4958 3.036.0566.1679.09.2673.1116.3406l.007.0246-.0037.0078c-.0257.053-.064.1242-.1354.2565L1.8235 18.223c-.1024.1894-.2092.3871-.2827.5589-.073.1708-.1913.4842-.1331.8557.0682.4354.3245.8188.7008 1.0483.321.1959.6558.2064.8415.2042.1869-.0022.4103-.0253.6245-.0475l5.155-.5329a7 7 0 0 1 .1573-.0153l.004-.0003.0124.0043c.0389.014.0915.0342.1825.0693C10.1466 20.7764 11.2984 21 12.5 21c5.2468 0 9.5-4.2533 9.5-9.5S17.7468 2 12.5 2m4.2071 7.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11.5 12.0858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageCheckSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2414 2H7.7588c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v6.3789c-.0005.7954-.0008 1.386.1363 1.8977a4 4 0 0 0 2.8284 2.8284c.3075.0824.6435.1152 1.0353.1281v1.3792c0 .2352-.0001.475.0178.6715.017.188.0622.5427.3099.853a1.5 1.5 0 0 0 1.174.5642c.3969-.0004.7021-.1867.8596-.2908.1646-.1089.3518-.2587.5355-.4057l2.4131-1.9305c.5186-.4149.6726-.532.8325-.6137a2 2 0 0 1 .5079-.1782c.1759-.0361.3693-.0408 1.0334-.0408h2.5576c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0442-.5412.0442-1.2055.0442-2.0105V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7107 2 17.0464 2 16.2414 2m-.0343 6.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 11.0858l-1.2929-1.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageCircle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 11.5C3 6.2533 7.2534 2 12.5 2S22 6.2533 22 11.5 17.7468 21 12.5 21c-1.2016 0-2.3534-.2236-3.4143-.6323a10 10 0 0 0-.1825-.0693l-.0124-.0043-.004.0003a7 7 0 0 0-.1574.0153l-5.155.5329c-.2141.0222-.4375.0453-.6244.0475-.1857.0022-.5205-.0083-.8415-.2042a1.5 1.5 0 0 1-.7008-1.0483c-.0582-.3715.06-.6849.133-.8557.0736-.1718.1804-.3694.2828-.5589l1.6518-3.0575c.0715-.1323.1097-.2035.1354-.2565l.0037-.0078-.007-.0246c-.0217-.0733-.055-.1727-.1116-.3406A9.49 9.49 0 0 1 3 11.5"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageCircle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12C2 6.4772 6.4772 2 12 2s10 4.4772 10 10-4.4772 10-10 10c-1.3283 0-2.5985-.2595-3.7608-.7316a10 10 0 0 0-.2241-.089l-.0048.0006a7 7 0 0 0-.1833.0293l-3.5865.5978c-.1606.0268-.3404.0568-.4965.0686-.1701.0128-.4409.0173-.727-.1054a1.5 1.5 0 0 1-.7873-.7873c-.1227-.2861-.1182-.5569-.1054-.727.0118-.1561.0418-.3358.0686-.4964l.0048-.0288.593-3.5578a7 7 0 0 0 .0293-.1833l.0006-.0048-.005-.0138a10 10 0 0 0-.084-.2103C2.2596 14.5985 2 13.3283 2 12"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageDotsCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2C6.4772 2 2 6.4772 2 12c0 1.3283.2595 2.5985.7316 3.7608a10 10 0 0 1 .084.2103l.005.0138-.0006.0048a7 7 0 0 1-.0293.1833l-.5978 3.5866c-.0268.1606-.0568.3403-.0686.4964-.0128.1701-.0173.4409.1054.727a1.5 1.5 0 0 0 .7873.7873c.2861.1227.5569.1182.727.1054.1561-.0118.3359-.0418.4965-.0686l3.5866-.5978c.096-.016.1463-.0243.1832-.0293l.0047-.0006.0139.0051c.0447.0168.1053.0413.2103.0839C9.4015 21.7405 10.6717 22 12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2M6 12c0-.8284.6716-1.5 1.5-1.5S9 11.1716 9 12s-.6716 1.5-1.5 1.5S6 12.8284 6 12m4.5 0c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5m6-1.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5S18 12.8284 18 12s-.6716-1.5-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageDotsSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2414 2H7.7588c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v6.3789c-.0005.7954-.0008 1.386.1363 1.8977a4 4 0 0 0 2.8284 2.8284c.3075.0824.6435.1152 1.0353.1281v1.3792c0 .2352-.0001.475.0178.6715.017.188.0622.5427.3099.853a1.5 1.5 0 0 0 1.174.5642c.3969-.0004.7021-.1867.8596-.2908.1646-.1089.3518-.2587.5355-.4057l2.4131-1.9305c.5186-.4149.6726-.532.8325-.6137a2 2 0 0 1 .5079-.1782c.1759-.0361.3693-.0408 1.0334-.0408h2.5576c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0442-.5412.0442-1.2055.0442-2.0105V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7107 2 17.0464 2 16.2414 2M6 10.5C6 9.6716 6.6716 9 7.5 9S9 9.6716 9 10.5 8.3284 12 7.5 12 6 11.3284 6 10.5m4.5 0c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5S12.8284 12 12 12s-1.5-.6716-1.5-1.5m6-1.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5S17.3284 9 16.5 9"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageHeartCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2C7.2533 2 3 6.2533 3 11.5c0 1.06.174 2.0814.4958 3.036.0566.1679.09.2673.1116.3406l.007.0246-.0037.0078c-.0257.053-.064.1242-.1354.2565L1.8235 18.223c-.1024.1894-.2092.3871-.2827.5589-.073.1708-.1913.4842-.1331.8557.0682.4354.3245.8188.7008 1.0483.321.1959.6558.2064.8415.2042.1869-.0022.4103-.0253.6245-.0475l5.155-.5329a7 7 0 0 1 .1573-.0153l.004-.0003.0124.0043c.0389.014.0915.0342.1825.0693C10.1466 20.7764 11.2984 21 12.5 21c5.2468 0 9.5-4.2533 9.5-9.5S17.7468 2 12.5 2M8.9696 8.5822c1.1273-.9512 2.6276-.6718 3.5273.367.8997-1.0388 2.3807-1.3082 3.5273-.367 1.1467.9413 1.286 2.5418.4007 3.6669-.5484.697-1.925 1.97-2.893 2.8379-.3556.3187-.5334.4781-.7468.5423a1.026 1.026 0 0 1-.5764 0c-.2134-.0642-.3911-.2236-.7467-.5423-.9681-.8679-2.3447-2.1409-2.8931-2.8379-.8853-1.1251-.7266-2.7156.4007-3.6669"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageHeartSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2414 2H7.7588c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v6.3789c-.0005.7954-.0008 1.386.1363 1.8977a4 4 0 0 0 2.8284 2.8284c.3075.0824.6435.1152 1.0353.1281v1.3792c0 .2352-.0001.475.0178.6715.017.188.0622.5427.3099.853a1.5 1.5 0 0 0 1.174.5642c.3969-.0004.7021-.1867.8596-.2908.1646-.1089.3518-.2587.5355-.4057l2.4131-1.9305c.5186-.4149.6726-.532.8325-.6137a2 2 0 0 1 .5079-.1782c.1759-.0361.3693-.0408 1.0334-.0408h2.5576c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0442-.5412.0442-1.2055.0442-2.0105V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7107 2 17.0464 2 16.2414 2M8.4696 7.3322c1.1273-.9512 2.6276-.6718 3.5273.367.8997-1.0388 2.3807-1.3082 3.5273-.367 1.1467.9413 1.286 2.5418.4007 3.6669-.5484.697-1.925 1.97-2.893 2.8379-.3556.3187-.5334.4781-.7468.5423a1.026 1.026 0 0 1-.5764 0c-.2134-.0642-.3911-.2236-.7467-.5423-.9681-.8679-2.3447-2.1409-2.8931-2.8379-.8853-1.1251-.7266-2.7156.4007-3.6669"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageNotificationCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.1213 2.8787c1.1716 1.1716 1.1716 3.071 0 4.2426s-3.071 1.1716-4.2426 0-1.1716-3.071 0-4.2426 3.071-1.1716 4.2426 0"
    />
    <path
      fill="currentColor"
      d="M21.9249 10.2994c-.043-.3413-.0646-.5119-.1496-.6205-.0791-.1012-.1738-.159-.3-.183-.1355-.026-.343.0498-.758.2012-1.7703.6459-3.8325.2587-5.2528-1.1616S13.657 5.053 14.3029 3.2828c.1514-.415.2271-.6226.2012-.7581-.0241-.1261-.0819-.2208-.183-.3-.1086-.085-.2793-.1065-.6205-.1496A9.6 9.6 0 0 0 12.5 2C7.2533 2 3 6.2533 3 11.5c0 1.06.174 2.0814.4958 3.036.0566.1679.09.2673.1116.3406l.007.0246-.0037.0078c-.0257.053-.064.1242-.1354.2565L1.8235 18.223c-.1024.1894-.2092.3871-.2827.5589-.073.1708-.1913.4842-.1331.8557.0682.4354.3245.8188.7008 1.0483.321.1959.6558.2064.8415.2042.1869-.0022.4103-.0253.6245-.0475l5.155-.5329a7 7 0 0 1 .1573-.0153l.004-.0003.0124.0043c.0389.014.0915.0342.1825.0693C10.1466 20.7764 11.2984 21 12.5 21c5.2468 0 9.5-4.2533 9.5-9.5a9.6 9.6 0 0 0-.0751-1.2006"
    />
  </svg>
);

export const MessageNotificationSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.1213 2.8787c1.1716 1.1716 1.1716 3.071 0 4.2426s-3.071 1.1716-4.2426 0-1.1716-3.071 0-4.2426 3.071-1.1716 4.2426 0"
    />
    <path
      fill="currentColor"
      d="M22.0001 10.6031c0-.5227 0-.7841-.0785-.9071-.0808-.1266-.1542-.1796-.2999-.216-.1415-.0356-.4391.0638-1.0343.2625-1.7405.5811-3.7372.1788-5.1229-1.207-1.3857-1.3857-1.7881-3.3823-1.207-5.1228.1987-.5952.298-.8928.2625-1.0343-.0365-.1457-.0894-.2191-.216-.3C14.181 2 13.9196 2 13.3969 2H7.7588c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v6.3789c-.0005.7954-.0008 1.386.1363 1.8977a4 4 0 0 0 2.8284 2.8284c.3075.0824.6435.1152 1.0353.1281v1.3792c0 .2352-.0001.475.0178.6715.017.188.0622.5427.3099.853a1.5 1.5 0 0 0 1.174.5642c.3969-.0004.7021-.1867.8596-.2908.1646-.1089.3518-.2587.5355-.4057l2.4131-1.9305c.5186-.4149.6726-.532.8325-.6137a2 2 0 0 1 .5079-.1782c.1759-.0361.3693-.0408 1.0334-.0408h2.5576c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0442-.5412.0442-1.2055.0442-2.0105z"
    />
  </svg>
);

export const MessagePlusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2C7.2533 2 3 6.2533 3 11.5c0 1.06.174 2.0814.4958 3.036.0566.1679.09.2673.1116.3406l.007.0246-.0037.0078c-.0257.053-.064.1242-.1354.2565L1.8235 18.223c-.1024.1894-.2092.3871-.2827.5589-.073.1708-.1913.4842-.1331.8557.0682.4354.3245.8188.7008 1.0483.321.1959.6558.2064.8415.2042.1869-.0022.4103-.0253.6245-.0475l5.155-.5329a7 7 0 0 1 .1573-.0153l.004-.0003.0124.0043c.0389.014.0915.0342.1825.0693C10.1466 20.7764 11.2984 21 12.5 21c5.2468 0 9.5-4.2533 9.5-9.5S17.7468 2 12.5 2m0 5.5c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2h-2c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const MessagePlusSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2414 2H7.7588c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v6.3789c-.0005.7954-.0008 1.386.1363 1.8977a4 4 0 0 0 2.8284 2.8284c.3075.0824.6435.1152 1.0353.1281v1.3792c0 .2352-.0001.475.0178.6715.017.188.0622.5427.3099.853a1.5 1.5 0 0 0 1.174.5642c.3969-.0004.7021-.1867.8596-.2908.1646-.1089.3518-.2587.5355-.4057l2.4131-1.9305c.5186-.4149.6726-.532.8325-.6137a2 2 0 0 1 .5079-.1782c.1759-.0361.3693-.0408 1.0334-.0408h2.5576c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0442-.5412.0442-1.2055.0442-2.0105V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7107 2 17.0464 2 16.2414 2M12 6.5c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageQuestionCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2C7.2533 2 3 6.2533 3 11.5c0 1.06.174 2.0814.4958 3.036.0566.1679.09.2673.1116.3406l.007.0246-.0037.0078c-.0257.053-.064.1242-.1354.2565L1.8235 18.223c-.1024.1894-.2092.3871-.2827.5589-.073.1708-.1913.4842-.1331.8557.0682.4354.3245.8188.7008 1.0483.321.1959.6558.2064.8415.2042.1869-.0022.4103-.0253.6245-.0475l5.155-.5329a7 7 0 0 1 .1573-.0153l.004-.0003.0124.0043c.0389.014.0915.0342.1825.0693C10.1466 20.7764 11.2984 21 12.5 21c5.2468 0 9.5-4.2533 9.5-9.5S17.7468 2 12.5 2m-.5116 6.6721a1.2485 1.2485 0 0 1 1.8809 1.078v.0016c0 .2186-.1772.5197-.6789.8542-.2204.1469-.4479.2614-.6243.3398a4.3 4.3 0 0 1-.2045.0847 2 2 0 0 1-.0504.0186l-.0092.0032.0016-.0005c-.5232.1751-.8059.741-.6313 1.2645.1729.5188.7493.8039 1.2661.6321a4 4 0 0 0 .1351-.0489c.0761-.029.1809-.071.3049-.1261.2452-.109.5797-.2755.9214-.5033.6224-.415 1.5693-1.2378 1.5695-2.5179a3.2483 3.2483 0 0 0-6.3126-1.0817c-.1833.521.0905 1.0919.6115 1.2752s1.0919-.0905 1.2752-.6115a1.248 1.248 0 0 1 .545-.662M12.6499 14c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageQuestionSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2414 2H7.7588c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v6.3789c-.0005.7954-.0008 1.386.1363 1.8977a4 4 0 0 0 2.8284 2.8284c.3075.0824.6435.1152 1.0353.1281v1.3792c0 .2352-.0001.475.0178.6715.017.188.0622.5427.3099.853a1.5 1.5 0 0 0 1.174.5642c.3969-.0004.7021-.1867.8596-.2908.1646-.1089.3518-.2587.5355-.4057l2.4131-1.9305c.5186-.4149.6726-.532.8325-.6137a2 2 0 0 1 .5079-.1782c.1759-.0361.3693-.0408 1.0334-.0408h2.5576c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0442-.5412.0442-1.2055.0442-2.0105V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7107 2 17.0464 2 16.2414 2m-4.7527 5.6721a1.2482 1.2482 0 0 1 1.8808 1.078v.0016c0 .2186-.1772.5197-.6788.8542-.2205.147-.448.2614-.6243.3398a4 4 0 0 1-.2046.0847 2 2 0 0 1-.0504.0186l-.0091.0032.0015-.0005c-.5232.1751-.8058.741-.6313 1.2645.1729.5188.7493.8039 1.2661.6321a4 4 0 0 0 .1352-.0489 6 6 0 0 0 .3048-.1261c.2452-.109.5798-.2755.9215-.5033.6224-.415 1.5692-1.2378 1.5694-2.5179a3.2483 3.2483 0 0 0-6.3126-1.0817c-.1832.521.0905 1.0919.6115 1.2752s1.0919-.0905 1.2752-.6115a1.248 1.248 0 0 1 .5451-.662M12.1502 13c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageSmileCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2C7.2533 2 3 6.2533 3 11.5c0 1.06.174 2.0814.4958 3.036.0566.1679.09.2673.1116.3406l.007.0246-.0037.0078c-.0257.053-.064.1242-.1354.2565L1.8235 18.223c-.1024.1894-.2092.3871-.2827.5589-.073.1708-.1913.4842-.1331.8557.0682.4354.3245.8188.7008 1.0483.321.1959.6558.2064.8415.2042.1869-.0022.4103-.0253.6245-.0475l5.155-.5329a7 7 0 0 1 .1573-.0153l.004-.0003.0124.0043c.0389.014.0915.0342.1825.0693C10.1466 20.7764 11.2984 21 12.5 21c5.2468 0 9.5-4.2533 9.5-9.5S17.7467 2 12.5 2m1.4927 7c0-.8284.6715-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5m-6.1 4.2001c.4404-.3304 1.0647-.2424 1.3968.1958.0617.0787.1295.1527.1986.2248a4.94 4.94 0 0 0 .6553.5706c.577.4197 1.3748.8088 2.3493.8088s1.7723-.3891 2.3493-.8088a4.95 4.95 0 0 0 .6553-.5706c.069-.0721.1369-.1462.1985-.2248.3322-.4382.9564-.5262 1.3969-.1958.4418.3313.5314.9581.2 1.4.0025-.0033-.0034.0042-.0136.017a9 9 0 0 1-.0898.1118 5.7 5.7 0 0 1-.2481.2756 6.94 6.94 0 0 1-.9228.8043c-.798.5803-2.0002 1.1913-3.5257 1.1913s-2.7277-.611-3.5257-1.1913a6.95 6.95 0 0 1-.9229-.8043 5.7 5.7 0 0 1-.248-.2756 4 4 0 0 1-.07-.0857c-.3454-.4463-.299-1.0939.1666-1.4431m1.6-5.7001c-.8285 0-1.5.6716-1.5 1.5s.6715 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageSmileSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2414 2H7.7588c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v6.3789c-.0005.7954-.0008 1.386.1363 1.8977a4 4 0 0 0 2.8284 2.8284c.3075.0824.6435.1152 1.0353.1281v1.3792c0 .2352-.0001.475.0178.6715.017.188.0622.5427.3099.853a1.5 1.5 0 0 0 1.174.5642c.3969-.0004.7021-.1867.8596-.2908.1646-.1089.3518-.2587.5355-.4057l2.4131-1.9305c.5186-.4149.6726-.532.8325-.6137a2 2 0 0 1 .5079-.1782c.1759-.0361.3693-.0408 1.0334-.0408h2.5576c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0442-.5412.0442-1.2055.0442-2.0105V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7107 2 17.0464 2 16.2414 2m-2.7487 5.5c0-.8284.6715-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5m-6.1 4.2001c.4404-.3304 1.0647-.2424 1.3968.1958.0617.0787.1295.1527.1986.2248.1473.1537.3687.3622.6553.5706.577.4197 1.3748.8088 2.3493.8088s1.7723-.3891 2.3493-.8088a4.95 4.95 0 0 0 .6553-.5706c.069-.0721.1369-.1462.1985-.2248.3322-.4382.9564-.5262 1.3969-.1958.4418.3313.5314.9581.2 1.4.0025-.0033-.0034.0042-.0136.017a9 9 0 0 1-.0898.1118 5.7 5.7 0 0 1-.2481.2756 6.94 6.94 0 0 1-.9228.8043c-.798.5803-2.0002 1.1913-3.5257 1.1913s-2.7277-.611-3.5257-1.1913a6.95 6.95 0 0 1-.9229-.8043 5.7 5.7 0 0 1-.248-.2756 4 4 0 0 1-.07-.0857c-.3454-.4463-.299-1.0939.1666-1.4431M8.9927 6c-.8285 0-1.5.6716-1.5 1.5s.6715 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageSquare01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v5.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 19 17.0463 19 16.2413 19H9.6838c-.6641 0-.8575.0047-1.0335.0408a2 2 0 0 0-.5078.1782c-.16.0817-.314.1988-.8326.6137l-2.4131 1.9305c-.1837.147-.371.2969-.5355.4057-.1574.1041-.4627.2904-.8597.2908a1.5 1.5 0 0 1-1.174-.5642c-.2476-.3103-.2928-.665-.3098-.853C1.9999 20.846 2 20.6062 2 20.371V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageSquare02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7588 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642.0442.5412.0442 1.2055.0442 2.0105v5.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7107 19 17.0464 19 16.2414 19h-2.5576c-.6641 0-.8575.0047-1.0334.0408a2 2 0 0 0-.5079.1782c-.1599.0817-.3139.1988-.8325.6137l-2.4131 1.9305c-.1837.147-.371.2968-.5355.4057-.1575.1041-.4627.2904-.8597.2908a1.5 1.5 0 0 1-1.174-.5642c-.2476-.3103-.2928-.665-.3098-.853C6 20.846 6 20.6062 6 20.371v-1.3792c-.3918-.0129-.7278-.0457-1.0353-.1281a4 4 0 0 1-2.8284-2.8284c-.1371-.5117-.1368-1.1023-.1364-1.8977L2.0002 14V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2895 2 6.9538 2 7.7588 2"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageTextCircle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2C7.2533 2 3 6.2533 3 11.5c0 1.06.174 2.0814.4958 3.036.0566.1679.09.2673.1116.3406l.007.0246-.0037.0078c-.0257.053-.064.1242-.1354.2565L1.8235 18.223c-.1024.1894-.2092.3871-.2827.5589-.073.1708-.1913.4842-.1331.8557.0682.4354.3245.8188.7008 1.0483.321.1959.6558.2064.8415.2042.1869-.0022.4103-.0253.6245-.0475l5.155-.5329a7 7 0 0 1 .1573-.0153l.004-.0003.0124.0043c.0389.014.0915.0342.1825.0693C10.1466 20.7764 11.2984 21 12.5 21c5.2468 0 9.5-4.2533 9.5-9.5S17.7468 2 12.5 2M8 8.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1zM8 12c-.5523 0-1 .4477-1 1s.4477 1 1 1h7c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageTextCircle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2C6.4772 2 2 6.4772 2 12c0 1.3283.2595 2.5985.7316 3.7608a10 10 0 0 1 .084.2103l.005.0138-.0006.0048a7 7 0 0 1-.0293.1833l-.5978 3.5866c-.0268.1606-.0568.3403-.0686.4964-.0128.1701-.0173.4409.1054.727a1.5 1.5 0 0 0 .7873.7873c.2861.1227.5569.1182.727.1054.1561-.0118.3359-.0418.4965-.0686l3.5866-.5978c.096-.016.1463-.0243.1832-.0293l.0047-.0006.0139.0051c.0447.0168.1053.0413.2103.0839C9.4015 21.7405 10.6717 22 12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2M8 8.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1zM8 12c-.5523 0-1 .4477-1 1s.4477 1 1 1h7c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageTextSquare01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2413 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5641.3918A4 4 0 0 0 2.436 4.184c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587V20.371c0 .2352 0 .475.0178.6715.017.188.0622.5427.3099.853a1.5 1.5 0 0 0 1.174.5642c.397-.0004.7022-.1867.8596-.2908.1646-.1088.3518-.2587.5355-.4057l2.4131-1.9305c.5186-.4149.6726-.532.8326-.6137a2 2 0 0 1 .5078-.1782c.176-.0361.3694-.0408 1.0335-.0408h6.5575c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 14.7106 22 14.0463 22 13.2413V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 2 17.0463 2 16.2413 2M7 7.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h5c.5523 0 1-.4477 1-1s-.4477-1-1-1zM7 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageTextSquare02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7588 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642.0442.5412.0442 1.2055.0442 2.0105v5.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7107 19 17.0464 19 16.2414 19h-2.5576c-.6641 0-.8575.0047-1.0334.0408a2 2 0 0 0-.5079.1782c-.1599.0817-.3139.1988-.8325.6137l-2.4131 1.9305c-.1837.147-.371.2968-.5355.4057-.1575.1041-.4627.2904-.8597.2908a1.5 1.5 0 0 1-1.174-.5642c-.2476-.3103-.2928-.665-.3098-.853C6 20.846 6 20.6062 6 20.371v-1.3792c-.3918-.0129-.7278-.0457-1.0353-.1281a4 4 0 0 1-2.8284-2.8284c-.1371-.5117-.1368-1.1023-.1364-1.8977l.0001-6.3789c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2895 2 6.9538 2 7.7588 2M6 8.5c0-.5523.4477-1 1-1h5c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1M7 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageXCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 2C7.2533 2 3 6.2533 3 11.5c0 1.06.174 2.0814.4958 3.036.0566.1679.09.2673.1116.3406l.007.0246-.0037.0078c-.0257.053-.064.1242-.1354.2565L1.8235 18.223c-.1024.1894-.2092.3871-.2827.5589-.073.1708-.1913.4842-.1331.8557.0682.4354.3245.8188.7008 1.0483.321.1959.6558.2064.8415.2042.1869-.0022.4103-.0253.6245-.0475l5.155-.5329a7 7 0 0 1 .1573-.0153l.004-.0003.0124.0043c.0389.014.0915.0342.1825.0693C10.1466 20.7764 11.2984 21 12.5 21c5.2468 0 9.5-4.2533 9.5-9.5S17.7468 2 12.5 2M9.2929 8.2929c.3905-.3905 1.0237-.3905 1.4142 0L12.5 10.0858l1.7929-1.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L13.9142 11.5l1.7929 1.7929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12.5 12.9142l-1.7929 1.7929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L11.0858 11.5l-1.793-1.7929c-.3904-.3905-.3904-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const MessageXSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2414 2H7.7588c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v6.3789c-.0005.7954-.0008 1.386.1363 1.8977a4 4 0 0 0 2.8284 2.8284c.3075.0824.6435.1152 1.0353.1281v1.3792c0 .2352-.0001.475.0178.6715.017.188.0622.5427.3099.853a1.5 1.5 0 0 0 1.174.5642c.3969-.0004.7021-.1867.8596-.2908.1646-.1089.3518-.2587.5355-.4057l2.4131-1.9305c.5186-.4149.6726-.532.8325-.6137a2 2 0 0 1 .5079-.1782c.1759-.0361.3693-.0408 1.0334-.0408h2.5576c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0442-.5412.0442-1.2055.0442-2.0105V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7107 2 17.0464 2 16.2414 2M8.7929 7.2929c.3905-.3905 1.0237-.3905 1.4142 0L12 9.0858l1.7929-1.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L13.4142 10.5l1.7929 1.7929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 11.9142l-1.7929 1.7929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L10.5858 10.5l-1.793-1.7929c-.3904-.3905-.3904-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const Phone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.0558 21.8804c-3.1932-.9064-6.2061-2.6167-8.7178-5.1284-2.5116-2.5116-4.222-5.5245-5.1283-8.7178l-.016-.0563c-.1475-.519-.2619-.9215-.2635-1.4733-.0019-.6308.2036-1.421.5126-1.971.5312-.9458 1.672-2.1578 2.6573-2.6562a3 3 0 0 1 2.7081 0c.8422.426 1.7802 1.3796 2.3031 2.1838a3 3 0 0 1 0 3.2706c-.1732.2664-.4201.513-.7068.7991-.0892.0891-.1875.1535-.1223.2894.6479 1.3493 1.5314 2.6149 2.652 3.7355s2.3863 2.0042 3.7356 2.652c.1407.0676.1961-.0288.2894-.1222.2862-.2867.5327-.5336.7991-.7069a3 3 0 0 1 3.2706 0c.7827.509 1.7611 1.4675 2.1838 2.3032a3 3 0 0 1 0 2.7081c-.4984.9853-1.7104 2.126-2.6562 2.6573-.55.309-1.3402.5145-1.971.5126-.5519-.0017-.9543-.116-1.4733-.2635z"
      clipRule="evenodd"
    />
  </svg>
);

export const PhoneCall01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.0687 5.8085c.1057-.542.6309-.8958 1.1729-.79a6 6 0 0 1 4.74 4.74c.1058.542-.2479 1.0672-.79 1.173-.542.1057-1.0672-.248-1.1729-.79a4.001 4.001 0 0 0-3.16-3.16c-.5421-.1058-.8958-.631-.79-1.173"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.0563 1.8896c.0609-.549.5554-.9445 1.1043-.8835a10 10 0 0 1 8.8333 8.8222c.0617.5488-.3333 1.0437-.8821 1.1054s-1.0437-.3332-1.1054-.8821a8 8 0 0 0-7.0667-7.0577c-.5489-.061-.9444-.5554-.8834-1.1043M6.338 17.7521c-2.4339-2.4339-4.2037-5.4649-5.1443-8.774-.1475-.5191-.2619-.9216-.2635-1.4735-.0019-.6307.2036-1.421.5125-1.971.5313-.9457 1.672-2.1577 2.6574-2.6561a3 3 0 0 1 2.7081 0c.8357.4227 1.7942 1.401 2.3031 2.1838a3 3 0 0 1 0 3.2705c-.1732.2665-.4201.513-.7068.7992-.0892.0891-.1875.1535-.1223.2894.6479 1.3493 1.5314 2.6148 2.652 3.7355s2.3863 2.0042 3.7356 2.652c.1397.0671.1969-.0296.2894-.1223.2862-.2866.5327-.5335.7991-.7068a3 3 0 0 1 3.2706 0c.7827.5089 1.7611 1.4675 2.1838 2.3032a3 3 0 0 1 0 2.708c-.4947.978-1.6968 2.1185-2.6562 2.6574-.55.3089-1.3402.5145-1.971.5126-.5519-.0017-.9543-.1161-1.4733-.2636-3.3093-.9405-6.3403-2.7104-8.7742-5.1443"
      clipRule="evenodd"
    />
  </svg>
);

export const PhoneCall02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4C9.4822 4 7.2073 5.0326 5.5727 6.7c-.3866.3944-1.0197.4007-1.4141.0141S3.7579 5.6943 4.1446 5.3C6.1397 3.2646 8.923 2 12 2s5.8603 1.2646 7.8556 3.3c.3866.3943.3803 1.0275-.0141 1.4141s-1.0275.3803-1.4141-.014C16.7928 5.0325 14.5179 4 12 4"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 8c-1.4807 0-2.81.6424-3.727 1.667-.3684.4114-1.0006.4465-1.4121.0781s-.4466-1.0005-.0782-1.412C8.063 6.9026 9.9267 6 12 6s3.937.9026 5.2174 2.333c.3683.4116.3333 1.0438-.0783 1.4121-.4115.3684-1.0437.3333-1.412-.0782C14.8101 8.6424 13.4808 8 12 8M12 12c3.1172 0 7.0703.7294 9.5554 2.7931.6564.545 1.2207 1.506 1.3769 2.3447.1387.7447.1589 1.6924.011 2.4424a3 3 0 0 1-2.3631 2.3632c-.5887.116-1.266.1013-1.8662.0421-1.4238-.1406-2.5501-1.267-2.6907-2.6907-.0147-.1486-.0146-.3126-.0145-.5034 0-.0421.012-.1015-.0308-.1166C14.7344 18.238 13.396 18 12 18s-2.7344.238-3.978.6748c-.0427.015-.0308.0735-.0308.1166 0 .1908.0001.3548-.0145.5034-.1406 1.4237-1.267 2.5501-2.6907 2.6907-.5911.0583-1.2834.0728-1.8662-.0421a3 3 0 0 1-2.3632-2.3632c-.1478-.75-.1277-1.6977.011-2.4424.1563-.8387.7206-1.7997 1.3769-2.3447C4.9252 12.733 8.8857 12 12 12"
      clipRule="evenodd"
    />
  </svg>
);

export const PhoneHangUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.7071 3.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-18 18c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l4.3085-4.3085c2.3091 2.102 5.0879 3.6428 8.0966 4.4979.5191.1475.9215.2619 1.4734.2636.6308.0018 1.421-.2037 1.971-.5126.9594-.5389 2.1615-1.6794 2.6562-2.6574a3 3 0 0 0 0-2.7081c-.4227-.8356-1.4011-1.7942-2.1839-2.3031a3 3 0 0 0-3.2705 0c-.2664.1732-.513.4202-.7991.7068a2 2 0 0 0-.0376.0392c-.0728.0776-.132.1406-.2518.0831a13.56 13.56 0 0 1-3.0513-2.0124zM10.0122 9.7452a13.5 13.5 0 0 1-.73-1.3248c-.0569-.1185.0106-.1826.088-.2562a2 2 0 0 0 .0343-.0332c.2867-.2862.5336-.5327.7068-.7991a3 3 0 0 0 0-3.2706c-.5089-.7827-1.4674-1.7611-2.3031-2.1838a3 3 0 0 0-2.708 0C4.1147 2.376 2.974 3.588 2.4427 4.5337c-.309.55-.5145 1.3402-.5126 1.971.0016.5519.116.9543.2635 1.4734a20.31 20.31 0 0 0 3.1448 6.4408z"
    />
  </svg>
);

export const PhoneIncoming01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.7071 3.7071 17.4142 8H20c.5523 0 1 .4477 1 1s-.4477 1-1 1h-5a1 1 0 0 1-1-1V4c0-.5523.4477-1 1-1s1 .4477 1 1v2.5858l4.2929-4.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143M1.1937 8.978c.9406 3.3093 2.7104 6.3402 5.1443 8.7742 2.434 2.4338 5.4649 4.2038 8.7742 5.1443.519.1475.9214.2619 1.4733.2635.6308.0019 1.421-.2036 1.971-.5125.9594-.539 2.1615-1.6795 2.6562-2.6574a3 3 0 0 0 0-2.7081c-.4227-.8357-1.4011-1.7942-2.1838-2.3031a3 3 0 0 0-3.2706 0c-.2664.1732-.5129.4201-.7991.7068a2 2 0 0 0-.0376.0392c-.0728.0776-.1319.1406-.2518.0831-1.3493-.6479-2.6149-1.5314-3.7356-2.652s-2.0041-2.3863-2.652-3.7356c-.0569-.1185.0106-.1826.088-.2562a2 2 0 0 0 .0343-.0332c.2867-.2862.5336-.5327.7068-.7991a3 3 0 0 0 0-3.2706c-.5089-.7827-1.4674-1.7611-2.3031-2.1838a3 3 0 0 0-2.708 0C3.1147 3.376 1.974 4.588 1.4427 5.5337c-.309.55-.5145 1.3402-.5126 1.971.0016.5519.116.9543.2635 1.4734"
    />
  </svg>
);

export const PhoneIncoming02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.2071 2.2929c.3905.3905.3905 1.0237 0 1.4142L15.4142 5.5H21c.5523 0 1 .4477 1 1s-.4477 1-1 1h-5.5858l1.7929 1.7929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-3.5-3.5c-.3905-.3905-.3905-1.0237 0-1.4142l3.5-3.5c.3905-.3905 1.0237-.3905 1.4142 0M1.1937 8.978c.9406 3.3093 2.7104 6.3402 5.1443 8.7742 2.434 2.4338 5.4649 4.2038 8.7742 5.1443.519.1475.9214.2619 1.4733.2635.6308.0019 1.421-.2036 1.971-.5125.9594-.539 2.1615-1.6795 2.6562-2.6574a3 3 0 0 0 0-2.7081c-.4227-.8357-1.4011-1.7942-2.1838-2.3031a3 3 0 0 0-3.2706 0c-.2664.1732-.5129.4201-.7991.7068a2 2 0 0 0-.0376.0392c-.0728.0776-.1319.1406-.2518.0831-1.3493-.6479-2.6149-1.5314-3.7356-2.652s-2.0041-2.3863-2.652-3.7356c-.0569-.1185.0106-.1826.088-.2562a2 2 0 0 0 .0343-.0332c.2867-.2862.5336-.5327.7068-.7991a3 3 0 0 0 0-3.2706c-.5089-.7827-1.4674-1.7611-2.3031-2.1838a3 3 0 0 0-2.708 0C3.1147 3.376 1.974 4.588 1.4427 5.5337c-.309.55-.5145 1.3402-.5126 1.971.0016.5519.116.9543.2635 1.4734"
    />
  </svg>
);

export const PhoneOutgoing01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 3c0-.5523.4477-1 1-1h5c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1V5.4142l-4.2929 4.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143L18.5858 4H16c-.5523 0-1-.4477-1-1M1.1937 8.978c.9406 3.3093 2.7104 6.3402 5.1443 8.7742 2.434 2.4338 5.4649 4.2038 8.7742 5.1443.519.1475.9214.2619 1.4733.2635.6308.0019 1.421-.2036 1.971-.5125.9594-.539 2.1615-1.6795 2.6562-2.6574a3 3 0 0 0 0-2.7081c-.4227-.8357-1.4011-1.7942-2.1838-2.3031a3 3 0 0 0-3.2706 0c-.2664.1732-.5129.4201-.7991.7068a2 2 0 0 0-.0376.0392c-.0728.0776-.1319.1406-.2518.0831-1.3493-.6479-2.6149-1.5314-3.7356-2.652s-2.0041-2.3863-2.652-3.7356c-.0569-.1185.0106-.1826.088-.2562a2 2 0 0 0 .0343-.0332c.2867-.2862.5336-.5327.7068-.7991a3 3 0 0 0 0-3.2706c-.5089-.7827-1.4674-1.7611-2.3031-2.1838a3 3 0 0 0-2.708 0C3.1147 3.376 1.974 4.588 1.4427 5.5337c-.309.55-.5145 1.3402-.5126 1.971.0016.5519.116.9543.2635 1.4734"
    />
  </svg>
);

export const PhoneOutgoing02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.7929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142L18.5858 5.5H13c-.5523 0-1 .4477-1 1s.4477 1 1 1h5.5858l-1.7929 1.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3.5-3.5c.3905-.3905.3905-1.0237 0-1.4142l-3.5-3.5c-.3905-.3905-1.0237-.3905-1.4142 0M1.1937 8.978c.9406 3.3093 2.7104 6.3402 5.1443 8.7742 2.434 2.4338 5.4649 4.2038 8.7742 5.1443.519.1475.9214.2619 1.4733.2635.6308.0019 1.421-.2036 1.971-.5125.9594-.539 2.1615-1.6795 2.6562-2.6574a3 3 0 0 0 0-2.7081c-.4227-.8357-1.4011-1.7942-2.1838-2.3031a3 3 0 0 0-3.2706 0c-.2664.1732-.5129.4201-.7991.7068a2 2 0 0 0-.0376.0392c-.0728.0776-.1319.1406-.2518.0831-1.3493-.6479-2.6149-1.5314-3.7356-2.652s-2.0041-2.3863-2.652-3.7356c-.0569-.1185.0106-.1826.088-.2562a2 2 0 0 0 .0343-.0332c.2867-.2862.5336-.5327.7068-.7991a3 3 0 0 0 0-3.2706c-.5089-.7827-1.4674-1.7611-2.3031-2.1838a3 3 0 0 0-2.708 0C3.1147 3.376 1.974 4.588 1.4427 5.5337c-.309.55-.5145 1.3402-.5126 1.971.0016.5519.116.9543.2635 1.4734"
    />
  </svg>
);

export const PhonePause = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 2c.5523 0 1 .4477 1 1v7c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M15 2c.5523 0 1 .4477 1 1v7c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.338 17.7522c-2.4339-2.434-4.2037-5.4649-5.1443-8.7741-.1475-.519-.2619-.9215-.2635-1.4734-.0019-.6308.2036-1.421.5125-1.971.5313-.9457 1.672-2.1578 2.6574-2.6562a3 3 0 0 1 2.7081 0c.8357.4227 1.7942 1.4011 2.3031 2.1838a3 3 0 0 1 0 3.2706c-.1732.2664-.4201.513-.7068.7991-.0892.0891-.1875.1535-.1223.2894.6479 1.3493 1.5314 2.6149 2.652 3.7356s2.3863 2.0041 3.7356 2.652c.1397.067.1969-.0297.2894-.1223.2862-.2867.5327-.5336.7991-.7068a3 3 0 0 1 3.2706 0c.7827.5089 1.7611 1.4674 2.1838 2.3031a3 3 0 0 1 0 2.7081c-.4947.9779-1.6968 2.1184-2.6562 2.6574-.55.3089-1.3402.5144-1.971.5125-.5519-.0016-.9543-.116-1.4733-.2635-3.3093-.9405-6.3403-2.7105-8.7742-5.1443"
      clipRule="evenodd"
    />
  </svg>
);

export const PhonePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 2c.5523 0 1 .4477 1 1v3h3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3v3c0 .5523-.4477 1-1 1s-1-.4477-1-1V8h-3c-.5523 0-1-.4477-1-1s.4477-1 1-1h3V3c0-.5523.4477-1 1-1M1.1937 8.978c.9406 3.3093 2.7104 6.3402 5.1443 8.7742 2.434 2.4338 5.4649 4.2038 8.7742 5.1443.519.1475.9214.2619 1.4733.2635.6308.0019 1.421-.2036 1.971-.5125.9594-.539 2.1615-1.6795 2.6562-2.6574a3 3 0 0 0 0-2.7081c-.4227-.8357-1.4011-1.7942-2.1838-2.3031a3 3 0 0 0-3.2706 0c-.2664.1732-.5129.4201-.7991.7068a2 2 0 0 0-.0376.0392c-.0728.0776-.1319.1406-.2518.0831-1.3493-.6479-2.6149-1.5314-3.7356-2.652s-2.0041-2.3863-2.652-3.7356c-.0569-.1185.0106-.1826.088-.2562a2 2 0 0 0 .0343-.0332c.2867-.2862.5336-.5327.7068-.7991a3 3 0 0 0 0-3.2706c-.5089-.7827-1.4674-1.7611-2.3031-2.1838a3 3 0 0 0-2.708 0C3.1147 3.376 1.974 4.588 1.4427 5.5337c-.309.55-.5145 1.3402-.5126 1.971.0016.5519.116.9543.2635 1.4734"
    />
  </svg>
);

export const PhoneX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.7071 3.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L18 4.5858l-2.2929-2.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143L16.5858 6l-2.2929 2.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L18 7.4142l2.2929 2.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143L19.4142 6zM6.338 17.7522c-2.4339-2.434-4.2037-5.4649-5.1443-8.7741-.1475-.519-.2619-.9215-.2635-1.4734-.0019-.6308.2036-1.421.5125-1.971.5313-.9457 1.672-2.1578 2.6574-2.6562a3 3 0 0 1 2.7081 0c.8357.4227 1.7942 1.4011 2.3031 2.1838a3 3 0 0 1 0 3.2706c-.1732.2664-.4201.513-.7068.7991-.0892.0891-.1875.1535-.1223.2894.6479 1.3493 1.5314 2.6149 2.652 3.7356s2.3863 2.0041 3.7356 2.652c.1397.067.1969-.0297.2894-.1223.2862-.2867.5327-.5336.7991-.7068a3 3 0 0 1 3.2706 0c.7827.5089 1.7611 1.4674 2.1838 2.3031a3 3 0 0 1 0 2.7081c-.4947.9779-1.6968 2.1184-2.6562 2.6574-.55.3089-1.3402.5144-1.971.5125-.5519-.0016-.9543-.116-1.4733-.2635-3.3093-.9405-6.3403-2.7105-8.7742-5.1443"
      clipRule="evenodd"
    />
  </svg>
);

export const Send01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.5951 1.4575c-.3958-.1322-.7643-.0366-.9475.0166-.1996.058-.4375.1509-.6762.2441L3.0143 8.3356c-.2668.104-.5253.205-.7248.3035-.1723.0853-.5387.275-.7431.6686a1.5 1.5 0 0 0 .0008 1.3846c.205.3933.5715.5826.744.6676.1995.0984.458.1989.725.3027l4.72 1.8355c.3521.137.5282.2054.7033.2096a1 1 0 0 0 .4486-.0943c.1587-.0744.2922-.208.5594-.4751l4.8454-4.8454c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-4.8454 4.8454c-.2671.2672-.4007.4007-.4751.5594a1 1 0 0 0-.0943.4486c.0042.1751.0726.3512.2096.7033l1.8355 4.7199c.1038.267.2043.5256.3027.7252.085.1724.2743.539.6676.7439a1.5 1.5 0 0 0 1.3846.0008c.3937-.2044.5833-.5708.6686-.7431.0986-.1995.1994-.4579.3035-.7247l6.6174-16.9572c.0932-.2387.1861-.4766.2441-.6762.0532-.1832.1488-.5517.0166-.9475a1.5 1.5 0 0 0-.9474-.9474"
    />
  </svg>
);

export const Send02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.7036 1.875a1.5 1.5 0 0 0-1.3296-.0022c-.3692.1818-.5632.5017-.6568.6673-.1007.1784-.204.407-.307.635L2.8257 19.9578c-.1057.2337-.211.4666-.2794.6631-.0628.1801-.1777.5434-.0662.9457a1.5 1.5 0 0 0 .8972.9957c.3886.1526.7617.0761.9474.0324.2025-.0477.4451-.1282.6886-.2091l4.8907-1.6233c.3941-.1308.5911-.1962.7368-.3178a1 1 0 0 0 .2897-.4013C11 19.8665 11 19.6589 11 19.2437V12c0-.5523.4477-1 1-1s1 .4477 1 1v7.2248c0 .4142 0 .6213.0692.7975.0612.1557.1604.2935.2886.4009.1452.1216.3415.1874.7343.3189l4.8952 1.6387c.243.0814.4853.1626.6875.2107.1856.0442.5583.1216.9472-.0298a1.5 1.5 0 0 0 .8998-.9929c.1126-.4018-.001-.7652-.0631-.9455-.0678-.1966-.1723-.4298-.2772-.6637L13.6633 3.1804c-.1023-.2283-.2048-.4573-.305-.636-.0931-.166-.286-.4864-.6547-.6695"
    />
  </svg>
);

export const Send03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.126 12.6649a1.5 1.5 0 0 0 0-1.3296c-.1824-.369-.5025-.5624-.6684-.6558-.1785-.1004-.4073-.2034-.6355-.306L4.0383 2.8209c-.2334-.1051-.4661-.21-.6624-.278-.1803-.0623-.5431-.1764-.9449-.0646a1.5 1.5 0 0 0-.9943.8974c-.1523.3882-.076.7609-.0322.9465.0475.2023.128.4445.2087.6875L3.2377 9.904c.1308.3941.1962.5911.3178.7368a1 1 0 0 0 .4013.2897C4.1334 11 4.341 11 4.7562 11H12c.5523 0 1 .4477 1 1s-.4477 1-1 1H4.7751c-.4141 0-.6212 0-.7975.0692a1 1 0 0 0-.4009.2886c-.1216.1452-.1873.3415-.3188.7343l-1.6376 4.8915c-.0815.2436-.1628.4861-.211.6886-.0442.1856-.1218.5589.03.9481.1715.4396.5398.7728.9942.8997.4025.1123.7662-.0022.9464-.0647.1967-.0681.43-.1731.6642-.2786l16.778-7.55c.2281-.1027.457-.2056.6356-.3061.1658-.0933.4859-.2868.6683-.6557"
    />
  </svg>
);

export const AlignCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1zM6 9c-.5523 0-1 .4477-1 1s.4477 1 1 1h12c.5523 0 1-.4477 1-1s-.4477-1-1-1zM2 14c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M6 17c-.5523 0-1 .4477-1 1s.4477 1 1 1h12c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const AlignJustify = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 10c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 18c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 6c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 14c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const AlignLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 10c0-.5523.4477-1 1-1h13c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 6c0-.5523.4477-1 1-1h17c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 14c0-.5523.4477-1 1-1h17c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M2 18c0-.5523.4477-1 1-1h13c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const AlignRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 10c0-.5523.4477-1 1-1h13c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1M3 6c0-.5523.4477-1 1-1h17c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1M3 14c0-.5523.4477-1 1-1h17c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1M7 18c0-.5523.4477-1 1-1h13c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Attachment01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.9705 4.182c-.9763-.9764-2.5592-.9764-3.5355 0l-9.0156 9.0156c-1.6598 1.6597-1.6598 4.3506 0 6.0104s4.3506 1.6597 6.0104 0l9.0156-9.0157c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4143l-9.0156 9.0156c-2.4408 2.4407-6.398 2.4407-8.8389 0-2.4407-2.4408-2.4407-6.3981 0-8.8389l9.0157-9.0156c1.7573-1.7573 4.6066-1.7573 6.3639 0 1.7574 1.7574 1.7574 4.6066 0 6.364l-8.662 8.662c-1.074 1.074-2.8152 1.074-3.8891 0s-1.074-2.8151 0-3.889l7.6014-7.6014c.3905-.3906 1.0237-.3906 1.4142 0s.3905 1.0237 0 1.4142l-7.6014 7.6014a.75.75 0 0 0 1.0607 1.0606l8.662-8.662c.9763-.9763.9763-2.5593 0-3.5356"
      clipRule="evenodd"
    />
  </svg>
);

export const Attachment02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.1667 3C8.6939 3 7.5 4.194 7.5 5.6667V16.5c0 2.4853 2.0147 4.5 4.5 4.5s4.5-2.0147 4.5-4.5V5.2558c0-.5523.4477-1 1-1s1 .4477 1 1V16.5c0 3.5899-2.9101 6.5-6.5 6.5-3.5898 0-6.5-2.9101-6.5-6.5V5.6667C5.5 3.0893 7.5893 1 10.1667 1s4.6666 2.0893 4.6666 4.6667v10.779c0 1.5648-1.2685 2.8334-2.8333 2.8334s-2.8333-1.2686-2.8333-2.8334V6.6512c0-.5523.4477-1 1-1s1 .4477 1 1v9.7945a.8333.8333 0 1 0 1.6666 0V5.6667C12.8333 4.1939 11.6394 3 10.1667 3"
      clipRule="evenodd"
    />
  </svg>
);

export const BezierCurve01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.5681 4c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2715-.1824.5412-.201.7698A4 4 0 0 0 9.0081 6H4.7324C4.3866 5.4022 3.7403 5 3 5c-1.1046 0-2 .8954-2 2s.8954 2 2 2c.7403 0 1.3866-.4022 1.7324-1h1.6108c-1.7969 1.4536-3.023 3.5849-3.289 6.0059a4.4 4.4 0 0 0-.1924.0111c-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.017.2081-.017.4539-.017.7063v.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.454.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.201-.7698.017-.2081.017-.4539.017-.7063v-.8638c0-.2524 0-.4982-.017-.7063-.0186-.2286-.0627-.4984-.201-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201a4 4 0 0 0-.069-.005c.3397-2.4036 1.9004-4.416 4.0352-5.387.0282.093.0651.1879.1136.283.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.201.2081.0171.4539.017.7063.017h.8638c.2524 0 .4982.0001.7063-.017.2286-.0186.4984-.0627.7698-.201a2 2 0 0 0 .874-.874c.0485-.0951.0854-.19.1137-.283 2.1347.9711 3.6954 2.9834 4.0351 5.387a3 3 0 0 0-.069.005c-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.0171.2081-.017.4539-.017.7063v.8638c0 .2524-.0001.4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201a4.4 4.4 0 0 0-.1925-.0111c-.266-2.421-1.492-4.5523-3.2889-6.0059h1.6108c.3458.5978.9921 1 1.7324 1 1.1046 0 2-.8954 2-2s-.8954-2-2-2c-.7403 0-1.3866.4022-1.7324 1h-4.2758a4 4 0 0 0-.0087-.1382c-.0187-.2286-.0628-.4983-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C12.9301 4 12.6843 4 12.4319 4z"
    />
  </svg>
);

export const BezierCurve02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.5681 1c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698a4 4 0 0 0-.0078.1188c-2.8415.9418-5.0867 3.187-6.0284 6.0286a4 4 0 0 0-.119.0077c-.2286.0187-.4984.0628-.7698.201a2 2 0 0 0-.874.8741c-.1383.2714-.1824.5412-.201.7698-.017.2081-.017.4539-.017.7063v.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011q.0576.0047.1188.0077c.9418 2.8415 3.187 5.0867 6.0286 6.0284a4 4 0 0 0 .0077.119c.0187.2286.0628.4984.201.7698.1918.3763.4978.6823.8741.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698a4 4 0 0 0 .0077-.1186c2.8417-.9417 5.0872-3.1871 6.0289-6.0288a4 4 0 0 0 .1185-.0077c.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201a4 4 0 0 0-.1186-.0078c-.9417-2.8417-3.1871-5.087-6.0288-6.0287a4 4 0 0 0-.0077-.1187c-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C12.9301 1 12.6843 1 12.4319 1zm3.4166 17.8831c1.7422-.7566 3.1418-2.1562 3.8985-3.8984l-.0214-.0016c-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.4539-.017-.7063v-.8638c0-.2524-.0001-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201l.0213-.0017c-.7567-1.7422-2.1562-3.1417-3.8984-3.8983l-.0016.0212c-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.201-.2081.017-.4539.017-.7063.017h-.8638c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698l-.0017-.021c-1.742.7566-3.1414 2.156-3.898 3.8981l.021.0016c.2285.0187.4983.0628.7697.201.3763.1918.6823.4978.874.8741.1383.2714.1824.5412.201.7698.017.2081.017.4539.017.7063v.8638c0 .2524 0 .4982-.017.7063-.0186.2286-.0627.4984-.201.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011l-.021.0016c.7567 1.742 2.1561 3.1414 3.8981 3.898l.0016-.0209c.0187-.2286.0628-.4984.201-.7698a2 2 0 0 1 .8741-.874c.2714-.1383.5412-.1824.7698-.201.2081-.0171.4539-.017.7063-.017h.8638c.2524 0 .4982-.0001.7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698z"
      clipRule="evenodd"
    />
  </svg>
);

export const BezierCurve03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.5681 2c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698C9 4.0699 9 4.3158 9 4.568v.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.0796.1562.1789.3003.2947.4292L4.5625 16 3.568 16c-.2524 0-.4982-.0001-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.017.2081-.017.4539-.017.7063v.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.454.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.201-.7698a4 4 0 0 0 .0088-.138h10.0164q.0034.0713.0088.138c.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201-.2081-.0171-.4539-.017-.7063-.017l-.9946.0001-4.9501-8.6628a2 2 0 0 0 .2948-.4293c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.454.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C12.9301 2 12.6843 2 12.4319 2zm-.1306 6h1.1248l4.9503 8.663a2 2 0 0 0-.2946.429c-.1383.2714-.1824.5412-.201.7698a4 4 0 0 0-.0088.1384H6.9918a4 4 0 0 0-.0087-.1384c-.0187-.2286-.0628-.4984-.201-.7698a2 2 0 0 0-.2948-.4292z"
      clipRule="evenodd"
    />
  </svg>
);

export const Bold01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 3c-.5523 0-1 .4477-1 1v16c0 .5523.4477 1 1 1h9c2.7614 0 5-2.2386 5-5 0-1.877-1.0343-3.5125-2.5641-4.3675C18.3991 10.7211 19 9.4307 19 8c0-2.7614-2.2386-5-5-5zm8 8c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3H7v6zm-7 2v6h8c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3z"
      clipRule="evenodd"
    />
  </svg>
);

export const Bold02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 4c0-.5523.4477-1 1-1h11.5c2.7614 0 5 2.2386 5 5 0 1.4307-.6009 2.7211-1.5641 3.6325C20.4657 12.4875 21.5 14.123 21.5 16c0 2.7614-2.2386 5-5 5H4c-.5523 0-1-.4477-1-1s.4477-1 1-1h1V5H4c-.5523 0-1-.4477-1-1m7.5 1v6h5c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3zm0 8v6h6c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3z"
      clipRule="evenodd"
    />
  </svg>
);

export const BoldSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.5 9.5c0 .8284-.6716 1.5-1.5 1.5H9.5V8H13c.8284 0 1.5.6716 1.5 1.5M9.5 16v-3H14c.8284 0 1.5.6716 1.5 1.5S14.8284 16 14 16z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9538 2 7.7587 2M7.5 7c0-.5523.4477-1 1-1H13c1.933 0 3.5 1.567 3.5 3.5a3.485 3.485 0 0 1-.6481 2.0295C16.8416 12.1478 17.5 13.247 17.5 14.5c0 1.933-1.567 3.5-3.5 3.5H8.5c-.5523 0-1-.4477-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Brush01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.264 2.2077c1.2634-1.1699 3.2255-1.1322 4.443.0854 1.2176 1.2175 1.2553 3.1796.0854 4.443l-6.3905 6.9019c-.3939.4254-.5909.6381-.8229.7205a1 1 0 0 1-.6325.0122c-.235-.0734-.44-.2784-.85-.6884l-2.7787-2.7787c-.41-.41-.615-.615-.6884-.85a1 1 0 0 1 .0122-.6325c.0823-.232.295-.429.7205-.823zM8.7621 12.1763c-.4105-.4104-.6157-.6157-.8608-.6875-.1976-.058-.4627-.0452-.6538.0315-.237.0951-.3852.275-.6815.6348a2.96 2.96 0 0 0-.2653.3749 3 3 0 0 0-.4166 1.4863c-1.2761-.1086-2.5897.3253-3.5661 1.3017-1.0312 1.0312-.9733 2.4822-.9338 3.4713l.005.1261c.0446 1.1116.0776 1.9326-.2791 2.6285A1 1 0 0 0 2 23c.2723 0 .583.0081.9151.0167.7515.0195 1.613.0419 2.3891-.0199 1.1446-.0911 2.4376-.3747 3.3778-1.3148.9764-.9764 1.4103-2.2899 1.3017-3.5659a3 3 0 0 0 1.4864-.4167 2.95 2.95 0 0 0 .3749-.2653c.3598-.2963.5397-.4444.6348-.6815.0767-.1911.0895-.4562.0315-.6538-.0718-.2451-.2771-.4504-.6875-.8608z"
    />
  </svg>
);

export const Brush02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.8618 1.017C7.0699 1 7.3158 1 7.568 1h8.8638c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.454.0169.7063V7.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C18.2401 9 17.9601 9 17.4 9H6.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C5 8.24 5 7.96 5 7.4V3.568c0-.2523 0-.498.017-.7062.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2715-.1383.5412-.1824.7698-.201M6.2545 11c-.2192 0-.3288 0-.428.0203-.4013.0821-.7432.453-.7923.8597-.0122.1005-.0048.191.01.3718.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.413.2105.8489.3132 1.316.3675V19.5c0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5v-3.5685c.4671-.0543.9029-.157 1.316-.3675a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0148-.1808.0222-.2713.01-.3718-.0491-.4067-.391-.7776-.7923-.8597C18.0743 11 17.9647 11 17.7455 11z"
    />
  </svg>
);

export const Brush03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.4319 1H5.5681c-.2524 0-.4982 0-.7063.017-.2286.0186-.4983.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698C3 3.0699 3 3.3158 3 3.568V7.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 9 4.04 9 4.6 9h14.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 8.24 21 7.96 21 7.4V3.568c0-.2524.0001-.4981-.0169-.7062-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C18.9301 1 18.6843 1 18.4319 1M20.9558 12.2518c.0148-.1808.0222-.2713.01-.3718-.0491-.4067-.391-.7776-.7923-.8597C20.0743 11 19.9647 11 19.7455 11H4.2545c-.2192 0-.3288 0-.428.0203-.4013.0821-.7432.453-.7923.8597-.0122.1005-.0048.191.01.3718.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.482.0394 1.0619.0437 1.7518.0441V19.5c0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5v-3.5001c.6899-.0004 1.2697-.0047 1.7518-.0441.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642"
    />
  </svg>
);

export const CircleCut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.839 3.8575c-.2512-.1186-.3768-.178-.5603-.1922-.1374-.0106-.3474.0244-.474.0791-.1689.073-.2715.173-.4769.3728C2.275 6.1155 1 8.909 1 12s1.275 5.8845 3.3279 7.8828c.2053.1998.308.2998.4768.3728.1265.0547.3366.0897.474.0791.1835-.0142.309-.0736.5603-.1922C8.8894 18.7017 11 15.5974 11 12S8.8894 5.2983 5.839 3.8575"
    />
    <path
      fill="currentColor"
      d="M8.4396 1.589c-.4388.15-.6581.225-.7521.3678a.5.5 0 0 0-.0606.4212c.05.1635.2705.3192.7113.6305C11.1583 5 13 8.285 13 12s-1.8417 6.9999-4.6618 8.9915c-.4408.3113-.6612.467-.7113.6305a.5.5 0 0 0 .0606.4212c.094.1428.3133.2178.752.3678C9.5564 22.7928 10.754 23 12 23c6.0751 0 11-4.9249 11-11S18.0751 1 12 1c-1.2461 0-2.4437.2072-3.5604.589"
    />
  </svg>
);

export const CodeSnippet01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2929 5.2929c.3905-.3905 1.0237-.3905 1.4142 0l6 6c.3905.3905.3905 1.0237 0 1.4142l-6 6c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L20.5858 12l-5.2929-5.2929c-.3905-.3905-.3905-1.0237 0-1.4142M8.7071 5.2929c.3905.3905.3905 1.0237 0 1.4142L3.4142 12l5.293 5.2929c.3904.3905.3904 1.0237 0 1.4142-.3906.3905-1.0238.3905-1.4143 0l-6-6c-.3905-.3905-.3905-1.0237 0-1.4142l6-6c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const CodeSnippet02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2929 6.2931c.3905-.3905 1.0237-.3905 1.4142 0l5 5c.3905.3905.3905 1.0237 0 1.4142l-5 5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l4.2929-4.2929-4.2929-4.2929c-.3905-.3905-.3905-1.0237 0-1.4142M7.7071 6.2931c.3905.3905.3905 1.0237 0 1.4142l-4.2929 4.2929 4.293 4.2929c.3904.3905.3904 1.0237 0 1.4142-.3906.3905-1.0238.3905-1.4143 0l-5-5c-.3905-.3905-.3905-1.0237 0-1.4142l5-5c.3905-.3905 1.0237-.3905 1.4142 0M14.2169 2.024c.5392.1198.8791.654.7593 1.1931l-4 18c-.1198.5392-.654.8791-1.1931.7593s-.879-.654-.7593-1.1931l4-18c.1198-.5392.654-.879 1.1931-.7593"
      clipRule="evenodd"
    />
  </svg>
);

export const Command = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 6c0-2.2091 1.7909-4 4-4s4 1.7909 4 4v2h4V6c0-2.2091 1.7909-4 4-4s4 1.7909 4 4-1.7909 4-4 4h-2v4h2c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4-4-1.7909-4-4v-2h-4v2c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4h2v-4H6c-2.2091 0-4-1.7909-4-4m6 2V6c0-1.1046-.8954-2-2-2s-2 .8954-2 2 .8954 2 2 2zm2 2v4h4v-4zm-2 6H6c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2zm8 0v2c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2zm0-8h2c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2z"
      clipRule="evenodd"
    />
  </svg>
);

export const Contrast01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 3.0548q.2842.0315.5625.0802c.544.0951 1.0622-.2687 1.1573-.8128.0952-.544-.2687-1.0622-.8127-1.1573A11.06 11.06 0 0 0 12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11a11.06 11.06 0 0 0 1.9049-.1645c.544-.0951.908-.6131.813-1.1572s-.6131-.908-1.1572-.813a9 9 0 0 1-.5607.0799z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M16.9195 3.2345c.3172-.452.9409-.5613 1.393-.244a11.06 11.06 0 0 1 2.6997 2.7008c.317.4522.2075 1.0758-.2447 1.3929s-1.0758.2075-1.3929-.2447a9.06 9.06 0 0 0-2.2111-2.212c-.452-.3172-.5613-.9409-.244-1.393M21.6779 9.2806c.544-.0952 1.0622.2688 1.1573.8128A11.06 11.06 0 0 1 23 12a11.06 11.06 0 0 1-.1648 1.9066c-.0951.544-.6133.908-1.1573.8128-.544-.0951-.9079-.6133-.8128-1.1573A9.06 9.06 0 0 0 21 12a9.06 9.06 0 0 0-.1349-1.5621c-.0951-.544.2688-1.0622.8128-1.1573M20.7639 16.9223c.4519.3174.561.9411.2436 1.393a11.05 11.05 0 0 1-2.6962 2.695c-.4521.3173-1.0758.2079-1.393-.2442s-.2078-1.0758.2443-1.393a9.06 9.06 0 0 0 2.2082-2.2072c.3174-.452.9411-.561 1.3931-.2436"
    />
  </svg>
);

export const Contrast02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11-4.9249 11-11 11S1 18.0751 1 12m20 0c0 4.4272-3.1966 8.1078-7.4076 8.8596-.4539.081-.6808.1215-.933.0301-.1986-.0719-.4194-.2568-.5251-.4396C12 20.2178 12 19.9452 12 19.4V4.6c0-.5452 0-.8178.1343-1.05.1057-.1829.3265-.3678.5251-.4397.2522-.0914.4791-.0509.933.0301C17.8034 3.8922 21 7.5728 21 12"
      clipRule="evenodd"
    />
  </svg>
);

export const Contrast03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11-4.9249 11-11 11S1 18.0751 1 12m5.5734 5.3933c5.9757 0 10.8199-4.8442 10.8199-10.82A10.85 10.85 0 0 0 17.0855 4C19.4559 5.7018 21 8.482 21 11.6227 21 16.8016 16.8016 21 11.6227 21 8.4819 21 5.7017 19.4559 4 17.0855a10.85 10.85 0 0 0 2.5734.3078"
      clipRule="evenodd"
    />
  </svg>
);

export const Crop01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v3H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h3v7.8385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C8.1795 19 8.6343 19 9.1614 19H17v3c0 .5523.4477 1 1 1s1-.4477 1-1v-3h3c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3V9.1614c0-.5271 0-.9819-.0306-1.3564-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C15.8205 5 15.3657 5 14.8385 5H7zm0 5v7.8c0 .5766.0008.9488.024 1.2322.0221.2716.0598.3723.085.4218a1 1 0 0 0 .437.437c.0495.0252.1502.0629.4218.0851.2834.0231.6556.0239 1.2322.0239H17V9.2c0-.5765-.0008-.9488-.0239-1.2322-.0222-.2716-.0599-.3723-.0851-.4218a1 1 0 0 0-.437-.437c-.0495-.0252-.1502-.0629-.4218-.085C15.7488 7.0007 15.3766 7 14.8 7z"
      clipRule="evenodd"
    />
  </svg>
);

export const Crop02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v3H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h3v7.8385c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C8.1795 19 8.6343 19 9.1614 19H17v3c0 .5523.4477 1 1 1s1-.4477 1-1v-3h3c.5523 0 1-.4477 1-1s-.4477-1-1-1H9.2c-.5765 0-.9488-.0008-1.2322-.0239-.2716-.0222-.3723-.0599-.4218-.0851a1 1 0 0 1-.437-.437c-.0252-.0495-.0629-.1502-.085-.4218C7.0007 15.7488 7 15.3766 7 14.8z"
    />
    <path
      fill="currentColor"
      d="M14.8 7c.5766 0 .9488.0008 1.2322.024.2716.0221.3723.0598.4218.085a1 1 0 0 1 .437.437c.0252.0495.0629.1502.0851.4218.0231.2834.0239.6556.0239 1.2322V14c0 .5523.4477 1 1 1s1-.4477 1-1V9.1615c0-.5272 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C15.8205 5 15.3657 5 14.8385 5H10c-.5523 0-1 .4477-1 1s.4477 1 1 1z"
    />
  </svg>
);

export const Cursor01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.1433 2.8098c-.251-.1046-.4973-.2073-.7027-.2723-.1828-.0578-.5643-.1688-.9746-.0358a1.5 1.5 0 0 0-.9646.9646c-.133.4102-.022.7917.0359.9745.065.2055.1677.4518.2723.7027l5.5372 13.2909c.1134.2723.2224.534.3272.7348.0891.1707.29.541.6955.737.4444.2148.966.1972 1.3949-.047.3914-.2228.5669-.6058.6443-.782.0911-.2075.1823-.476.2771-.7553l1.324-3.8979 5.2831 5.2831c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-5.283-5.283 3.8976-1.3238c.2793-.0949.5478-.186.7552-.2771.1762-.0774.5592-.2529.7821-.6444a1.5 1.5 0 0 0 .047-1.3948c-.1961-.4056-.5664-.6064-.737-.6955-.2008-.1049-.4626-.2139-.7348-.3273z"
      clipRule="evenodd"
    />
  </svg>
);

export const Cursor02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.9004 2.62c-.2253-.081-.4539-.1631-.647-.2133-.183-.0476-.5366-.1265-.9156.0048a1.5 1.5 0 0 0-.9266.9265c-.1312.379-.0523.7326-.0048.9157.0502.193.1323.4217.2133.647l5.7289 15.9592c.1005.2803.197.549.2922.7561.0804.175.2632.5577.6608.774a1.5 1.5 0 0 0 1.3991.0184c.4032-.2059.596-.5836.681-.7564.1006-.2045.204-.4707.3119-.7482l2.5788-6.6311 6.6312-2.5788c.2775-.1079.5436-.2114.7481-.3119.1728-.085.5506-.2779.7564-.681a1.5 1.5 0 0 0-.0184-1.399c-.2163-.3977-.599-.5805-.774-.661-.207-.0951-.4758-.1916-.756-.2921z"
    />
  </svg>
);

export const Cursor03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.0444 2.7304c-.2403-.0947-.4794-.189-.6799-.248-.1831-.0538-.5534-.1515-.9511-.0192a1.5 1.5 0 0 0-.9499.95c-.1323.3977-.0346.768.0192.9511.059.2005.1532.4395.248.6799l5.3262 13.5205c.075.1904.1542.3916.2356.5533.0827.164.241.4448.5496.6377a1.5 1.5 0 0 0 1.2247.1652c.3487-.1042.5758-.333.6989-.4692.1214-.1343.2511-.3073.3737-.4709l1.3483-1.7978 2.6683 3.6689c.081.1115.1751.241.2668.3466.1037.1194.2701.2883.5207.4014a1.5 1.5 0 0 0 1.0128.0794c.2651-.0725.4559-.2135.577-.3153.1069-.0899.2201-.2031.3175-.3006l3.2128-3.2128c.0975-.0975.2107-.2106.3007-.3176.1018-.121.2427-.3118.3153-.5769a1.5 1.5 0 0 0-.0795-1.0128c-.113-.2506-.282-.4171-.4014-.5208-.1055-.0916-.235-.1857-.3466-.2668l-3.6688-2.6682 1.7976-1.3482c.1637-.1227.3367-.2524.471-.3738.1362-.1232.365-.3503.4692-.699a1.5 1.5 0 0 0-.1652-1.2246c-.1929-.3086-.4737-.467-.6377-.5496-.1617-.0815-.3629-.1607-.5532-.2356z"
    />
  </svg>
);

export const Cursor04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.657 2.4452c-.2007-.059-.4116-.1212-.5916-.1567-.1811-.0356-.5052-.0844-.851.0445a1.5 1.5 0 0 0-.8816.8816c-.129.3458-.0802.67-.0445.851.0355.18.0976.391.1566.5916l4.2245 14.3632c.0545.1855.113.3845.1774.5469.0667.1682.1949.4493.4711.6653.3309.2588.7551.367 1.1695.2982.346-.0573.593-.2427.7322-.3584.1343-.1118.2809-.2585.4175-.3952L12 17.4144l3.7436 3.7436c.0842.0843.1848.1849.2806.2662.1111.0943.2797.2199.5123.2955.3013.0978.6258.0978.9271 0 .2326-.0756.4012-.2012.5123-.2955.0958-.0814.1964-.182.2806-.2662l2.9014-2.9014c.0842-.0842.1848-.1847.2662-.2806.0943-.1111.2198-.2797.2954-.5123a1.5 1.5 0 0 0 0-.927c-.0756-.2327-.2011-.4013-.2954-.5124-.0814-.0958-.182-.1964-.2663-.2806l-3.7436-3.7435 2.3628-2.3628c.1368-.1367.2834-.2832.3952-.4176.1157-.139.3011-.3862.3585-.7322a1.5 1.5 0 0 0-.2982-1.1695c-.2161-.2762-.4971-.4044-.6653-.471-.1625-.0645-.3614-.123-.5469-.1774z"
    />
  </svg>
);

export const CursorBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.2413 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 22 6.9537 22 7.7587 22H9.5c.5523 0 1-.4477 1-1s-.4477-1-1-1H7.8c-.8566 0-1.4389-.0008-1.889-.0376-.4384-.0358-.6626-.1007-.819-.1804a2 2 0 0 1-.874-.874c-.0797-.1564-.1446-.3806-.1804-.819C4.0008 17.6389 4 17.0566 4 16.2V7.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C6.3611 4.0008 6.9434 4 7.8 4h8.4c.8566 0 1.4389.0008 1.889.0376.4384.0358.6626.1007.819.1804.3763.1917.6823.4977.874.874.0797.1564.1446.3806.1804.819C19.9992 6.3611 20 6.9434 20 7.8v1.7c0 .5523.4477 1 1 1s1-.4477 1-1V7.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C17.7106 2 17.0463 2 16.2413 2"
    />
    <path
      fill="currentColor"
      d="m12.7925 10.5401 8.2941 2.7462c.2474.0818.4929.1631.6856.2466.1753.0759.5245.2387.7456.5972.249.4036.2924.9011.1172 1.3417-.1556.3914-.4714.6122-.6309.7174-.1753.1156-.403.2382-.6324.3617l-3.1335 1.6873-1.6873 3.1335c-.1235.2295-.2461.4571-.3617.6325-.1052.1595-.326.4752-.7174.6308a1.5 1.5 0 0 1-1.3417-.1171c-.3585-.2212-.5213-.5704-.5973-.7457-.0834-.1927-.1647-.4382-.2465-.6855l-2.7462-8.2942c-.071-.2142-.1442-.435-.1878-.6224-.0425-.1825-.1077-.5232.0226-.8877a1.5 1.5 0 0 1 .9075-.9075c.3645-.1303.7052-.0651.8877-.0226.1874.0436.4082.1168.6224.1878"
    />
  </svg>
);

export const CursorClick01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 1c.5523 0 1 .4477 1 1v1.5c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.5523.4477-1 1-1M3.2929 3.2929c.3905-.3905 1.0237-.3905 1.4142 0l1.0607 1.0607c.3905.3905.3905 1.0236 0 1.4142s-1.0237.3905-1.4142 0L3.2929 4.707c-.3905-.3905-.3905-1.0237 0-1.4142M5.7678 13.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-1.0607 1.0607c-.3905.3905-.3905 1.0236 0 1.4142s1.0237.3905 1.4142 0zM14.7678 3.2929c.3905.3905.3905 1.0237 0 1.4142l-1.0607 1.0607c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l1.0607-1.0607c.3905-.3905 1.0236-.3905 1.4142 0M2 8c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5c.5523 0 1-.4477 1-1s-.4477-1-1-1zM9.707 7.4795c-.2055-.0634-.42-.1296-.6029-.168-.1817-.0383-.512-.093-.8648.0364a1.5 1.5 0 0 0-.8914.8914c-.1295.3528-.0747.683-.0364.8648.0384.1828.1046.3974.168.603l3.4796 11.296c.0787.2559.1564.5081.237.7058.0724.1773.2298.5374.5905.7672a1.5 1.5 0 0 0 1.3516.1323c.3983-.1555.6226-.4782.728-.6382.1174-.1783.2425-.4106.3694-.6464l2.4809-4.6073 4.6073-2.4809c.2358-.1269.4681-.2519.6464-.3694.1599-.1053.4826-.3296.6381-.728a1.5 1.5 0 0 0-.1322-1.3516c-.2299-.3606-.5899-.5181-.7672-.5904-.1977-.0807-.4499-.1583-.7058-.2371z"
    />
  </svg>
);

export const CursorClick02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 1c.5523 0 1 .4477 1 1v1.5c0 .5523-.4477 1-1 1s-1-.4477-1-1V2c0-.5523.4477-1 1-1M3.2929 3.2929c.3905-.3905 1.0237-.3905 1.4142 0l1.0607 1.0607c.3905.3905.3905 1.0236 0 1.4142s-1.0237.3905-1.4142 0L3.2929 4.707c-.3905-.3905-.3905-1.0237 0-1.4142M5.7678 13.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-1.0607 1.0607c-.3905.3905-.3905 1.0236 0 1.4142s1.0237.3905 1.4142 0zM14.7678 3.2929c.3905.3905.3905 1.0237 0 1.4142l-1.0607 1.0607c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l1.0607-1.0607c.3905-.3905 1.0236-.3905 1.4142 0M2 8c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5c.5523 0 1-.4477 1-1s-.4477-1-1-1zM8.8063 7.548a1 1 0 0 0-1.2582 1.2583l4.1111 12.7778a.9998.9998 0 0 0 1.659.4008L15.5 19.8031l2.904 2.904a1 1 0 0 0 1.4142 0l2.8889-2.8889a.9999.9999 0 0 0 0-1.4142l-2.904-2.904 2.1818-2.1818a.9998.9998 0 0 0-.4008-1.659z"
    />
  </svg>
);

export const Delete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.1762 3.1155c.4076-.1164.8364-.116 1.3232-.1154h7.7419c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.0021.3918 1.5642C23 7.2895 23 7.954 23 8.7588v6.4827c0 .8049 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5641a4 4 0 0 1-1.748 1.7481c-.4854.2473-1.0021.3458-1.5642.3918-.5412.0442-1.2055.0442-2.0105.0441l-7.7419.0001c-.4868.0006-.9156.001-1.3232-.1154a3 3 0 0 1-.9896-.4948c-.3377-.2562-.5947-.5996-.8863-.9893L1.92 13.5601l-.0551-.073c-.1984-.262-.447-.5906-.549-.9778a2 2 0 0 1 0-1.0183c.102-.3872.3506-.7158.549-.9778l.0551-.0731 4.3803-5.8405c.2916-.3897.5486-.733.8863-.9893a3 3 0 0 1 .9896-.4948m9.5309 5.1774c.3905.3905.3905 1.0237 0 1.4142L15.4142 12l2.2929 2.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L14 13.4142l-2.2929 2.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L12.5858 12l-2.2929-2.2929c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L14 10.5858l2.2929-2.293c.3905-.3904 1.0237-.3904 1.4142 0"
      clipRule="evenodd"
    />
  </svg>
);

export const Dotpoints01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 12c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1M8 6c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1M8 18c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1M2 12c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M2 6c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2M2 18c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Dotpoints02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.5 2.5C3.1193 2.5 2 3.6193 2 5s1.1193 2.5 2.5 2.5S7 6.3807 7 5 5.8807 2.5 4.5 2.5M10 4h11c.5523 0 1 .4477 1 1s-.4477 1-1 1H10c-.5523 0-1-.4477-1-1s.4477-1 1-1M10 18h11c.5523 0 1 .4477 1 1s-.4477 1-1 1H10c-.5523 0-1-.4477-1-1s.4477-1 1-1M21 11H10c-.5523 0-1 .4477-1 1s.4477 1 1 1h11c.5523 0 1-.4477 1-1s-.4477-1-1-1M4.5 16.5C3.1193 16.5 2 17.6193 2 19s1.1193 2.5 2.5 2.5S7 20.3807 7 19s-1.1193-2.5-2.5-2.5M4.5 9.5C3.1193 9.5 2 10.6193 2 12s1.1193 2.5 2.5 2.5S7 13.3807 7 12 5.8807 9.5 4.5 9.5"
    />
  </svg>
);

export const Drop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.2943 1.2913a71 71 0 0 0-1.0006 1.0024c-.609.621-1.4346 1.4811-2.299 2.4354-.863.9525-1.7732 2.0084-2.5474 3.0198-.76.9928-1.4426 2.0109-1.7927 2.8758C3.232 11.6683 3 12.8082 3 13.9999c0 4.9706 4.0294 9 9 9s9-4.0294 9-9c0-1.1917-.2321-2.3316-.6546-3.3752-.3501-.865-1.0327-1.883-1.7927-2.8758-.7742-1.0114-1.6845-2.0673-2.5474-3.0198-.8644-.9543-1.69-1.8143-2.299-2.4354a71 71 0 0 0-1.0006-1.0024A.998.998 0 0 0 12 1a.9983.9983 0 0 0-.7057.2913"
    />
  </svg>
);

export const Dropper = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.8898 22.9937c-.2325-.0258-.4388-.1329-.5941-.2894a.99.99 0 0 1-.2894-.594c-.0297-.2671.0312-.5613.0878-.8351.0142-.0685.028-.1357.0402-.2009.0912-.4888.24-1.1665.4717-1.9281.456-1.4985 1.2663-3.4327 2.687-4.8535L10.5859 8l-.793-.7929c-.3904-.3905-.3904-1.0237 0-1.4142.3906-.3905 1.0238-.3905 1.4143 0l7 7c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L16 13.4142l-6.2927 6.2927c-1.4208 1.4208-3.355 2.231-4.8534 2.6871a18.1 18.1 0 0 1-1.9282.4717 10 10 0 0 0-.2009.0402c-.2738.0566-.568.1175-.835.0878M14.5456 4.0402c-.396.396-.594.594-.6682.8224a1 1 0 0 0 0 .618c.0742.2283.2722.4263.6682.8224l3.1515 3.1514c.396.396.594.5941.8223.6682a1 1 0 0 0 .6181 0c.2283-.0741.4263-.2722.8223-.6682l1.7475-1.7475c1.4951-1.495 1.4951-3.919 0-5.4142l-.0023-.0023c-1.4953-1.4928-3.9176-1.492-5.4119.0023z"
    />
  </svg>
);

export const Eraser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.764 1.4385a4 4 0 0 1 2.4721 0c.518.1683.9531.464 1.383.829.414.3513.8837.821 1.4528 1.3902l.2704.2704c.5692.5691 1.039 1.039 1.3903 1.4528.365.43.6607.865.829 1.383a4 4 0 0 1 0 2.4722c-.1683.518-.464.9531-.829 1.383-.3514.414-.8212.8838-1.3904 1.4529-.2053.2054-.308.3081-.4138.3715a1 1 0 0 1-1.0283 0c-.1058-.0634-.2085-.1661-.4139-.3715L11.928 5.5138c-.2054-.2054-.308-.308-.3714-.4138a1 1 0 0 1 0-1.0284c.0634-.1057.166-.2084.3714-.4137.5692-.5693 1.039-1.039 1.4529-1.3905.43-.365.865-.6606 1.3831-.829M10.7172 7.1314c-.396-.396-.594-.594-.8224-.6682a1 1 0 0 0-.618 0c-.2283.0742-.4263.2722-.8224.6682L3.6579 11.928c-.5692.5692-1.039 1.039-1.3904 1.4529-.365.43-.6606.865-.829 1.3831a4 4 0 0 0 0 2.4721c.1684.518.464.9531.829 1.383.3514.414.8212.8837 1.3903 1.4528l.7569.7569c.2874.288.5408.5419.8464.7292.2684.1644.561.2857.8671.3591.3485.0837.7072.0834 1.1141.083h1.5156q.0874.0001.1719-.0001H21c.5523 0 1-.4477 1-1s-.4477-1-1-1h-8.5857l4.4544-4.4544c.396-.396.594-.594.6682-.8223a1 1 0 0 0 0-.6181c-.0742-.2283-.2722-.4263-.6682-.8223z"
    />
  </svg>
);

export const Feather = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.2915 3.3055c2.6699-2.4269 6.747-2.4269 9.4168 0 .1237.1124.2588.2475.4762.465l.0451.045c.2175.2175.3525.3525.4649.4762 2.4269 2.6698 2.4269 6.7469 0 9.4168-.1742.1916-.4263.2915-.6853.2915H11c-.5523 0-1 .4477-1 1s.4477 1 1 1h5.4829c.6058 0 .9087 0 1.0489.1198a.5.5 0 0 1 .1738.4194c-.0145.1839-.2287.3981-.6571.8265l-1.8728 1.8728-.036.0362c-.134.1346-.3026.3042-.509.4307a2 2 0 0 1-.5781.2394c-.2353.0565-.4744.0559-.6644.0554l-.051-.0001H6.5679c-.2523 0-.498 0-.7062-.017a2.46 2.46 0 0 1-.3738-.0568l-2.7808 2.7808c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l2.7808-2.7808a2.5 2.5 0 0 1-.0568-.3738c-.017-.2082-.017-.454-.017-.7063v-6.8202c-.0005-.1899-.0012-.4291.0553-.6644.049-.204.1298-.3992.2395-.5781.1264-.2064.296-.375.4306-.509l.0362-.036 5.0538-5.0538c.2176-.2176.3526-.3526.4762-.465"
    />
  </svg>
);

export const Figma = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 5C4 2.5147 6.0147.5 8.5.5h7C17.9853.5 20 2.5147 20 5c0 1.4136-.6518 2.675-1.6713 3.5C19.3482 9.325 20 10.5864 20 12c0 2.4853-2.0147 4.5-4.5 4.5a4.48 4.48 0 0 1-2.5-.7578V19c0 2.4853-2.0147 4.5-4.5 4.5S4 21.4853 4 19c0-1.4136.6518-2.675 1.6713-3.5C4.6518 14.675 4 13.4136 4 12s.6518-2.675 1.6713-3.5C4.6518 7.675 4 6.4136 4 5m7 9.5H8.5C7.1193 14.5 6 13.3807 6 12s1.1193-2.5 2.5-2.5H11zm2-2.5c0 1.3807 1.1193 2.5 2.5 2.5S18 13.3807 18 12s-1.1193-2.5-2.5-2.5S13 10.6193 13 12m2.5-4.5C16.8807 7.5 18 6.3807 18 5s-1.1193-2.5-2.5-2.5H13v5zm-7-5H11v5H8.5C7.1193 7.5 6 6.3807 6 5s1.1193-2.5 2.5-2.5m2.5 14H8.5C7.1193 16.5 6 17.6193 6 19s1.1193 2.5 2.5 2.5S11 20.3807 11 19z"
      clipRule="evenodd"
    />
  </svg>
);

export const Framer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 .5a1 1 0 0 0-.707 1.7071L9.5857 7.5H5c-.5523 0-1 .4477-1 1v7a.997.997 0 0 0 .293.7073l6.9999 7A1 1 0 0 0 13 22.5002v-6l6-.0002a1 1 0 0 0 .7071-1.7071L14.4142 9.5H19c.5523 0 1-.4477 1-1v-7c0-.5523-.4477-1-1-1zm6 16H7.414L11 20.086zm7-9h-5.5858l-5-5H18zm-12 2h5.5858l5 5H6z"
      clipRule="evenodd"
    />
  </svg>
);

export const Hand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3c-.4054 0-.7.317-.7.6667v7.2222c0 .5523-.4477 1-1 1s-1-.4477-1-1V4.7778c0-.3496-.2946-.6667-.7-.6667s-.7.317-.7.6667v9.4444c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2.7778c0-.3496-.2946-.6666-.7-.6666s-.7.317-.7.6666v2.2223C4.5 17.6982 7.8391 21 12 21s7.5-3.3018 7.5-7.3333V8.1111c0-.3496-.2946-.6667-.7-.6667s-.7.3171-.7.6667v2.7778c0 .5523-.4477 1-1 1s-1-.4477-1-1V4.7778c0-.3496-.2946-.6667-.7-.6667s-.7.317-.7.6667v6.1111c0 .5523-.4477 1-1 1s-1-.4477-1-1V3.6667C12.7 3.317 12.4054 3 12 3m2.3358-.673C13.865 1.5286 12.9876 1 12 1s-1.865.5287-2.3358 1.327A2.72 2.72 0 0 0 8.6 2.111c-1.4724 0-2.7 1.1753-2.7 2.6667v4.091a2.73 2.73 0 0 0-.7-.091c-1.4724 0-2.7 1.1753-2.7 2.6666v2.2223C2.5 18.8399 6.772 23 12 23s9.5-4.1601 9.5-9.3333V8.1111c0-1.4913-1.2276-2.6667-2.7-2.6667-.2414 0-.4761.0316-.7.091v-.7576c0-1.4914-1.2276-2.6667-2.7-2.6667-.3762 0-.7364.0767-1.0642.2158"
      clipRule="evenodd"
    />
  </svg>
);

export const Heading01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v14H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1H7v-6h10v6h-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1V5h1c.5523 0 1-.4477 1-1s-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v6H7V5h1c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Heading02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v14H4c-.5523 0-1 .4477-1 1s.4477 1 1 1h7.5c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1v-6H17v6h-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1V5h1c.5523 0 1-.4477 1-1s-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v6h-6.5V5h1c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const HeadingSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9538 2 7.7587 2M9 7c0-.5523-.4477-1-1-1s-1 .4477-1 1v10c0 .5523.4477 1 1 1s1-.4477 1-1v-4h6v4c0 .5523.4477 1 1 1s1-.4477 1-1V7c0-.5523-.4477-1-1-1s-1 .4477-1 1v4H9z"
      clipRule="evenodd"
    />
  </svg>
);

export const ImageIndentLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1zM15 8.25c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1zM14 14.75c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1M3 19c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1zM4.5681 7c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698C2 9.0699 2 9.3158 2 9.568v4.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.454.0169.7063.0169H9.432c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063V9.5681c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C9.9301 7 9.6842 7 9.4319 7z"
    />
  </svg>
);

export const ImageIndentRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1zM3 19c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1zM2 9.25c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M3 13.75c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1zM14.5681 7c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.0171.2081-.017.454-.017.7063v4.8638c0 .2524-.0001.4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h4.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063V9.5681c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C19.9301 7 19.6843 7 19.4319 7z"
    />
  </svg>
);

export const Italic01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.0313 3H19c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3.3071l-5.25 14H14c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1s.4477-1 1-1h3.307l5.2499-14H10c-.5523 0-1-.4477-1-1s.4477-1 1-1h4.969a1 1 0 0 1 .0623 0"
    />
  </svg>
);

export const Italic02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m6.557 19 5.2499-14H9.5c-.5523 0-1-.4477-1-1s.4477-1 1-1h10c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2.0571l-5.25 14H14.5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-10c-.5523 0-1-.4477-1-1s.4477-1 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const ItalicSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9538 2 7.7587 2m7.1698 5.3712c.2051-.5128-.0443-1.0948-.5571-1.2999s-1.0947.0443-1.2999.557l-4 10.0001c-.205.5128.0443 1.0947.5571 1.2999.5128.2051 1.0948-.0443 1.2999-.5571z"
      clipRule="evenodd"
    />
  </svg>
);

export const LeftIndent01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1zM12 8.25c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zM11 14.75c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1s-.4477 1-1 1h-9c-.5523 0-1-.4477-1-1M3 19c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1zM4.852 7.7391c-.1813-.136-.368-.2761-.5322-.3774-.1597-.0985-.4628-.2694-.851-.2613a1.5 1.5 0 0 0-1.1498.5749c-.2394.3057-.2845.6508-.3016.8376C2 8.705 2 8.9384 2 9.1651v5.8699c0 .2267 0 .4601.0174.6522.017.1868.0622.5319.3016.8376a1.5 1.5 0 0 0 1.1498.5749c.3882.0081.6913-.1628.851-.2613.1643-.1013.351-.2413.5323-.3774l3.9172-2.9379c.1245-.0933.2653-.1989.3783-.3004.1245-.1121.3079-.2982.417-.5789a1.5 1.5 0 0 0 0-1.0875c-.1091-.2807-.2925-.4669-.417-.5789-.113-.1015-.2538-.2071-.3783-.3004z"
    />
  </svg>
);

export const LeftIndent02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.852 2.139c-.1813-.136-.368-.2761-.5322-.3774-.1597-.0985-.4628-.2694-.851-.2613a1.5 1.5 0 0 0-1.1498.5749c-.2394.3057-.2845.6508-.3016.8376C2 3.1049 2 3.3383 2 3.565V9.435c0 .2267 0 .46.0174.6522.017.1868.0622.5319.3016.8376a1.5 1.5 0 0 0 1.1498.5749c.3882.0081.6913-.1628.851-.2613.1643-.1013.351-.2413.5323-.3774L8.7693 7.923c.1245-.0933.2653-.1989.3783-.3004.1245-.112.3079-.2982.417-.579a1.5 1.5 0 0 0 0-1.0874c-.1091-.2807-.2925-.4668-.417-.5789-.113-.1015-.2538-.207-.3783-.3004zM12 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zM12 8.25c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zM2 14.75c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M3 19c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const LetterSpacing01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v18c0 .5523.4477 1 1 1s1-.4477 1-1zM22 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v18c0 .5523.4477 1 1 1s1-.4477 1-1z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m9.4622 14-1.5518 3.414c-.2286.5028-.8214.7251-1.3242.4966-.5028-.2286-.7251-.8214-.4966-1.3242l4.2867-9.4307c.1025-.2256.2056-.4525.3062-.6296.0939-.1653.2875-.4824.6547-.6632a1.5 1.5 0 0 1 1.3256 0c.3672.1808.5608.4979.6547.6632.1006.177.2037.404.3062.6296l4.2867 9.4307c.2285.5028.0062 1.0956-.4966 1.3242-.5028.2285-1.0956.0062-1.3242-.4966L14.5378 14zm4.1665-2h-3.2574L12 8.4168z"
      clipRule="evenodd"
    />
  </svg>
);

export const LetterSpacing02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 3c0-.5523.4477-1 1-1h10c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4v10c0 .5523-.4477 1-1 1s-1-.4477-1-1V4H7c-.5523 0-1-.4477-1-1"
    />
    <path
      fill="currentColor"
      d="M18.2929 14.2929c.3905-.3905 1.0237-.3905 1.4142 0L23 18a.997.997 0 0 1-.278.6919l-.0149.0152-3 3c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L19.5858 19H4.4142l1.293 1.2929c.3904.3905.3904 1.0237 0 1.4142-.3906.3905-1.0238.3905-1.4143 0l-3-3A.998.998 0 0 1 1 18a.997.997 0 0 1 .2929-.7071l3-3c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142L4.4142 17h15.1716l-1.2929-1.2929c-.3905-.3905-.3905-1.0237 0-1.4142"
    />
  </svg>
);

export const LineHeight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 2c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.6628 5.8629a1.5 1.5 0 0 0-1.3256 0c-.3672.1808-.5608.4979-.6547.6632-.1006.177-.2037.404-.3062.6296l-4.2867 9.4307c-.2285.5028-.0062 1.0956.4966 1.3242.5028.2285 1.0956.0062 1.3242-.4966L9.4622 14h5.0756l1.5518 3.414c.2286.5028.8214.7251 1.3242.4966.5028-.2286.7251-.8214.4966-1.3242l-4.2867-9.4307c-.1025-.2257-.2056-.4525-.3062-.6296-.0939-.1653-.2875-.4824-.6547-.6632M13.6287 12 12 8.4168 10.3713 12z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M2 21c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const MagicWand01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.0103 2c0-.5523.4477-1 1-1s1 .4477 1 1v1.5c0 .5523-.4478 1-1 1s-1-.4477-1-1zM19.3031 3.2929c.3906-.3905 1.0237-.3905 1.4143 0s.3905 1.0237 0 1.4142l-1.0607 1.0607c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142zM18.2425 12.2929c-.3905.3905-.3905 1.0237 0 1.4142l1.0606 1.0607c.3906.3905 1.0237.3905 1.4143 0s.3905-1.0237 0-1.4142l-1.0607-1.0607c-.3905-.3905-1.0237-.3905-1.4142 0M9.2425 4.7071c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0l1.0607 1.0607c.3905.3905.3905 1.0236 0 1.4142s-1.0237.3905-1.4143 0zM22.0103 8h-1.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5c.5522 0 1-.4477 1-1s-.4478-1-1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.8821 7.012a2 2 0 0 1 1.236 0c.2897.094.5116.2537.6865.402.1592.1353.333.309.5114.4876l.7824.7823c.1785.1785.3523.3522.4875.5115.1484.1748.308.3967.4021.6864a2 2 0 0 1 0 1.2361c-.0941.2897-.2537.5116-.4021.6864-.1352.1593-.309.333-.4875.5115L6.816 21.5981c-.1784.1785-.3522.3524-.5114.4875-.1749.1484-.3968.308-.6865.4021a2 2 0 0 1-1.236 0c-.2898-.0941-.5117-.2537-.6865-.4021-.1592-.1351-.333-.309-.5114-.4875l-.7824-.7823c-.1785-.1784-.3523-.3523-.4875-.5115-.1484-.1748-.308-.3967-.4021-.6864a2 2 0 0 1 0-1.2361c.0941-.2897.2537-.5116.4021-.6864.1352-.1593.309-.333.4875-.5115l9.2824-9.2823c.1784-.1785.3522-.3524.5114-.4875.1749-.1485.3967-.308.6865-.4022m-.0426 5.3361c-.1142-.037-.2133-.1362-.4116-.3344l-.4417-.4417c-.1982-.1982-.2973-.2973-.3344-.4116a.5.5 0 0 1 .0002-.3092c.0372-.1142.1364-.2132.3349-.4112l.9475-.9454c.198-.1975.2971-.2963.4112-.3333a.5.5 0 0 1 .3088.0002c.114.037.2129.136.4107.3338l.4396.4395c.1978.1978.2967.2967.3338.4108a.5.5 0 0 1 .0001.3088c-.0369.1141-.1357.2131-.3333.4111l-.9453.9476c-.198.1984-.297.2976-.4112.3349a.5.5 0 0 1-.3093.0001"
      clipRule="evenodd"
    />
  </svg>
);

export const MagicWand02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1zM16 14c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1zM7 9c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1M20 8c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1zM17.0929 11.0927c.3906-.3905 1.0237-.3905 1.4143 0l1.2 1.2c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4143 0l-1.2-1.2c-.3905-.3905-.3905-1.0237 0-1.4142M19.7072 5.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4143 0l-1.2 1.2c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4143 0zM10.2929 4.2929c.3905-.3905 1.0237-.3905 1.4142 0l1.2 1.2c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-1.2-1.2c-.3905-.3905-.3905-1.0237 0-1.4142M12.7071 12.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-9 9c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0z"
    />
  </svg>
);

export const Move = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L11 4.4142V11H4.4142l1.293-1.2929c.3904-.3905.3904-1.0237 0-1.4142-.3906-.3905-1.0238-.3905-1.4143 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L4.4142 13H11v6.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L13 19.5858V13h6.5858l-1.2929 1.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142l-3-3c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L19.5858 11H13V4.4142l1.2929 1.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143z"
    />
  </svg>
);

export const Paint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.2071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L10.0857 3 4.1578 8.928c-.5692.5691-1.039 1.0389-1.3904 1.4528-.365.43-.6606.865-.829 1.3831a4 4 0 0 0 0 2.4721c.1684.5181.464.9531.829 1.3831.3515.4139.8212.8837 1.3905 1.4529l3.2701 3.2702c.5692.5691 1.039 1.039 1.453 1.3904.4299.3649.865.6606 1.383.8289a4 4 0 0 0 2.4721 0c.518-.1683.9531-.464 1.383-.8289.414-.3514.8837-.8212 1.4528-1.3903l5.5264-5.5264c.1785-.1784.3523-.3522.4875-.5115.1484-.1748.308-.3967.4021-.6864a2 2 0 0 0 0-1.2361c-.0941-.2897-.2537-.5116-.4021-.6864-.1352-.1593-.309-.333-.4875-.5115l-8.8912-8.8912-.0116-.0115zM11.5 4.414l-5.8987 5.8987c-.6057.6057-1.017 1.018-1.3092 1.3623-.106.1248-.188.2314-.2521.3247h15.0458z"
      clipRule="evenodd"
    />
  </svg>
);

export const PaintPour = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.707 1.2929c-.3905-.3905-1.0236-.3905-1.4142 0s-.3905 1.0237 0 1.4142L7.5858 3 2.5282 8.0574c-.3727.3727-.6943.6943-.9375.9808-.2568.3024-.4844.6309-.6156 1.0347a3 3 0 0 0 0 1.8542c.1312.4038.3589.7323.6156 1.0347.2432.2865.5647.608.9375.9808l3.529 3.529c.3727.3727.6944.6944.9808.9376.3024.2567.631.4843 1.0348.6155a3 3 0 0 0 1.854 0c.404-.1312.7324-.3588 1.0348-.6155.2865-.2432.6081-.5648.9808-.9376l4.6557-4.6557c.1785-.1784.3523-.3522.4875-.5114.1484-.1749.308-.3967.4021-.6865a2 2 0 0 0 0-1.236c-.0941-.2898-.2537-.5116-.4021-.6865-.1352-.1592-.309-.333-.4875-.5114zM9 4.4142 3.9697 9.4444c-.223.223-.4026.4029-.5497.5556h11.1656z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20 12a.997.997 0 0 1 .6941.2799q.0475.0456.0944.0919c.06.0593.1443.1438.2448.2483.1999.2079.4691.5.7411.8328.2688.3291.5579.7191.7845 1.1216.2115.3757.4411.8862.4411 1.4254 0 1.6568-1.3431 3-3 3s-3-1.3432-3-3c0-.5392.2296-1.0497.4411-1.4254.2266-.4025.5157-.7925.7845-1.1216.272-.3328.5412-.6249.7411-.8328a14 14 0 0 1 .2448-.2483 9 9 0 0 1 .0944-.0919.995.995 0 0 1 .3948-.2343A1 1 0 0 1 20 12M2 21c-.5523 0-1 .4477-1 1s.4477 1 1 1h12c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Palette = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11c0 2.2091-1.7909 4-4 4h-.5c-.4962 0-.6475.0022-.7611.0171a2 2 0 0 0-1.7218 1.7218c-.0149.1136-.0171.2649-.0171.7611v.5c0 2.2091-1.7909 4-4 4-6.0751 0-11-4.9249-11-11m9-7c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m4 3c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2m-9 4c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const ParagraphSpacing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.2929 3.2929c.3905-.3905 1.0237-.3905 1.4142 0l3 3c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L7 6.4142v11.1716l1.2929-1.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-3 3c-.3905.3905-1.0237.3905-1.4142 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L5 17.5858V6.4142l-1.2929 1.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143zM12 6c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-8c-.5523 0-1-.4477-1-1M12 10c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-8c-.5523 0-1-.4477-1-1M13 13c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1zM12 18c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-8c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const ParagraphWrap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1zM3 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h15a2 2 0 0 1 0 4h-1.5858l.2929-.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-2 2c-.3905.3905-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L16.4142 19H18a4 4 0 0 0 2.8284-1.1716 3.9996 3.9996 0 0 0 0-5.6568A4 4 0 0 0 18 11z"
    />
    <path
      fill="currentColor"
      d="M3 17c-.5523 0-1 .4477-1 1s.4477 1 1 1h7c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const PenTool01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.9805 4.5192c-.261-.8867-.3915-1.33-.29-1.513a.5.5 0 0 1 .4335-.2574c.2093-.0015.536.3252 1.1896.9787l6.7542 6.7543a2 2 0 0 0-.0677.518c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2c-.1792 0-.3528.0236-.5181.0678L3.7278 2.3133c-.6535-.6535-.9803-.9803-.9788-1.1895a.5.5 0 0 1 .2575-.4336c.183-.1015.6263.029 1.5129.29l11.2982 3.326c.2767.0656.6243.1481.9195.3406.255.1662.4687.3885.6248.6498.1806.3026.2493.6532.304.9323l1.0411 5.2066a2 2 0 0 1 .9112.0763c.2897.0941.5116.2537.6865.4021.1592.1352.333.309.5114.4875l.7824.7823c.1784.1785.3523.3523.4874.5115.1485.1748.308.3967.4022.6865a2 2 0 0 1 0 1.236c-.0942.2897-.2537.5116-.4022.6865-.1351.1592-.309.333-.4874.5114l-4.7824 4.7824c-.1784.1785-.3522.3523-.5114.4874-.1749.1485-.3968.3081-.6865.4022a2 2 0 0 1-1.2361 0c-.2897-.0941-.5116-.2537-.6864-.4022-.1592-.1351-.333-.3089-.5114-.4874l-.7824-.7824c-.1784-.1783-.3524-.3523-.4875-.5114-.1484-.1749-.308-.3968-.4021-.6865a2 2 0 0 1-.0764-.9109l-5.2068-1.0411c-.279-.0547-.6296-.1234-.9322-.3041a2 2 0 0 1-.6499-.6247c-.1924-.2952-.275-.6428-.3406-.9195z"
    />
  </svg>
);

export const PenTool02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.5197 22.2618c-.8867.261-1.33.3915-1.513.29a.5.5 0 0 1-.2574-.4336c-.0016-.2093.3252-.536.9787-1.1896l6.7543-6.7542a2 2 0 0 0 .518.0677c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8955-2 2c0 .1792.0236.3528.0678.5181l-6.7543 6.7542c-.6535.6536-.9803.9803-1.1895.9788a.5.5 0 0 1-.4336-.2575c-.1015-.183.029-.6263.29-1.5129l3.326-11.2982c.0656-.2767.1481-.6243.3406-.9195a2 2 0 0 1 .6498-.6247c.3026-.1807.6532-.2494.9323-.3041l5.2066-1.0411a2 2 0 0 1 .0763-.9112c.0941-.2897.2537-.5116.4021-.6865.1352-.1592.309-.333.4875-.5114l.7823-.7823c.1785-.1785.3523-.3524.5115-.4875.1748-.1485.3967-.308.6864-.4022a2 2 0 0 1 1.2361 0c.2897.0942.5116.2537.6865.4022.1592.1351.333.309.5114.4874l4.7824 4.7824c.1785.1785.3523.3522.4874.5115.1485.1748.308.3967.4022.6864a2 2 0 0 1 0 1.236c-.0942.2898-.2537.5117-.4022.6865-.1351.1592-.3089.333-.4874.5114l-.7824.7824c-.1783.1784-.3523.3524-.5114.4875-.1749.1484-.3968.308-.6865.4021a2 2 0 0 1-.9109.0764l-1.0411 5.2068c-.0547.279-.1234.6297-.3041.9322a2 2 0 0 1-.6247.6499c-.2952.1925-.6429.2749-.9195.3406z"
    />
  </svg>
);

export const PenToolMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.6181 2.512a2 2 0 0 0-1.236 0c-.2898.094-.5116.2536-.6865.402-.1592.1352-.333.309-.5114.4876l-.7824.7823c-.1785.1785-.3523.3522-.4875.5115-.1484.1748-.308.3967-.4021.6864a2 2 0 0 0-.0572 1.0194L8.5598 7.7998l-.064.0182c-.2357.0664-.532.15-.7897.3175a2 2 0 0 0-.5642.553c-.1727.2542-.2623.5488-.3334.783l-.0195.0637-3.4528 9.5589c-.3534.9782-.53 1.4672-.434 1.6591a.5.5 0 0 0 .4344.276c.2145.0055.5822-.3622 1.3177-1.0977l5.4134-5.4135A2 2 0 0 1 10 14c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2a2 2 0 0 1-.518-.0677l-5.4131 5.4131c-.7355.7354-1.1032 1.1031-1.0977 1.3176a.5.5 0 0 0 .276.4344c.1918.0961.681-.0806 1.6591-.4339l9.5583-3.4527.0637-.0195c.2342-.0712.5288-.1607.783-.3334.22-.1494.408-.3412.553-.5642.1675-.2577.2511-.554.3175-.7896L18.2 17.44l1.3986-4.8951a2 2 0 0 0 1.0195-.0572c.2897-.0941.5116-.2537.6865-.4021.1592-.1352.333-.309.5114-.4875l.7824-.7823c.1785-.1785.3523-.3522.4875-.5115.1484-.1748.308-.3967.4021-.6864a2 2 0 0 0 0-1.236c-.0941-.2898-.2537-.5117-.4021-.6865-.1352-.1593-.309-.333-.4875-.5115L18.816 3.4015c-.1784-.1784-.3522-.3523-.5114-.4874-.1749-.1484-.3968-.308-.6865-.4021M2 4c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const PenToolPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.6181 2.512a2 2 0 0 0-1.236 0c-.2898.094-.5116.2536-.6865.402-.1592.1352-.333.309-.5114.4876l-.7824.7823c-.1785.1785-.3523.3522-.4875.5115-.1484.1748-.308.3967-.4021.6864a2 2 0 0 0-.0572 1.0194L8.5598 7.7998l-.064.0182c-.2357.0664-.532.15-.7897.3175a2 2 0 0 0-.5642.553c-.1727.2542-.2623.5488-.3334.783l-.0195.0637-3.4528 9.5589c-.3534.9782-.53 1.4672-.434 1.6591a.5.5 0 0 0 .4344.276c.2145.0055.5822-.3622 1.3177-1.0977l5.4134-5.4135A2 2 0 0 1 10 14c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2a2 2 0 0 1-.518-.0677l-5.4131 5.4131c-.7355.7354-1.1032 1.1031-1.0977 1.3176a.5.5 0 0 0 .276.4344c.1918.0961.681-.0806 1.6591-.4339l9.5583-3.4527.0637-.0195c.2342-.0712.5288-.1607.783-.3334.22-.1494.408-.3412.553-.5642.1675-.2577.2511-.554.3175-.7896L18.2 17.44l1.3986-4.8951a2 2 0 0 0 1.0195-.0572c.2897-.0941.5116-.2537.6865-.4021.1592-.1352.333-.309.5114-.4875l.7824-.7823c.1785-.1785.3523-.3522.4875-.5115.1484-.1748.308-.3967.4021-.6864a2 2 0 0 0 0-1.236c-.0941-.2898-.2537-.5117-.4021-.6865-.1352-.1593-.309-.333-.4875-.5115L18.816 3.4015c-.1784-.1784-.3522-.3523-.5114-.4874-.1749-.1484-.3968-.308-.6865-.4021M6 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1V6h2c.5523 0 1-.4477 1-1s-.4477-1-1-1H6z"
    />
  </svg>
);

export const Pencil01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.7072 2.2927c-1.4951-1.495-3.9192-1.495-5.4143 0L4.9764 13.6093c-.2336.2334-.4102.4099-.565.6094a4 4 0 0 0-.3642.5604c-.1195.2225-.209.4557-.3275.7639l-2.153 5.5978a.9998.9998 0 0 0 1.2923 1.2924l5.3797-2.0691.093-.0358.1252-.0482c.3081-.1184.5414-.208.7638-.3274a4 4 0 0 0 .5604-.3642c.1995-.1548.3761-.3315.6095-.565L21.7072 7.7069c1.4951-1.495 1.4951-3.9191 0-5.4142M5.381 16.7951l-1.14 2.9637 2.9638-1.1399z"
      clipRule="evenodd"
    />
  </svg>
);

export const Pencil02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l4 4c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142zM14.5365 4.2805a1.5 1.5 0 0 1 .927 0c.2327.0755.4013.201.5124.2954.0958.0813.1964.182.2805.2662l2.9014 2.9014c.0843.0842.1849.1847.2663.2806.0943.111.2198.2797.2954.5123a1.5 1.5 0 0 1 0 .927c-.0756.2327-.2011.4013-.2954.5124-.0814.0958-.1821.1964-.2663.2806L8.7703 20.6439c-.1867.1869-.3514.3519-.5423.4909a3 3 0 0 1-.5379.3122c-.2155.0967-.4404.1579-.6953.2273L2.263 22.9647a1 1 0 0 1-1.2278-1.2279l1.2904-4.7316c.0693-.2549.1305-.4799.2273-.6954a3 3 0 0 1 .3121-.5378c.139-.1909.304-.3557.491-.5424L13.7436 4.8422c.0842-.0843.1847-.185.2806-.2663.1111-.0943.2797-.2199.5123-.2954"
    />
  </svg>
);

export const PencilLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2929 2.2927c1.4951-1.495 3.9192-1.495 5.4143 0s1.4951 3.9191 0 5.4142L10.3906 19.0235c-.2334.2335-.41.4102-.6095.565a4 4 0 0 1-.5604.3642c-.2225.1194-.4556.209-.7637.3274l-.1252.0482-.093.0358-5.3798 2.0691a1 1 0 0 1-1.2923-1.2924l2.153-5.5978c.1185-.3082.208-.5414.3275-.7639a4 4 0 0 1 .3642-.5604c.1548-.1995.3314-.376.565-.6094zM5.3809 16.7951l-1.1398 2.9637 2.9637-1.1399z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M13 20h8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-8c-.5523 0-1-.4477-1-1s.4477-1 1-1"
    />
  </svg>
);

export const Perspective01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5681 2c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698C2 4.0699 2 4.3158 2 4.568v.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698a2 2 0 0 0 .874.874c.2714.1383.5412.1824.7698.201q.0667.0055.1382.0088v8.0164a4 4 0 0 0-.1382.0088c-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.017.2081-.017.4539-.017.7063v.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.454.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.201-.7698.0137-.1667.0164-.3575.0169-.5566l8.0562-1.1509c.0301.1529.0791.3148.1619.4773.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201A4 4 0 0 0 20 14.0082V9.9918a4 4 0 0 0 .1382-.0087c.2286-.0187.4984-.0628.7698-.201a2 2 0 0 0 .874-.8741c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.454.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4983-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C19.9301 4 19.6843 4 19.4319 4h-.8638c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.0828.1626-.1319.3245-.1619.4774l-8.0562-1.151c-.0005-.199-.0032-.3899-.0168-.5566-.0187-.2286-.0628-.4984-.201-.7698a2 2 0 0 0-.8741-.874c-.2714-.1383-.5412-.1824-.7698-.201C5.9301 2 5.6842 2 5.432 2zM18 14.0082V9.9918a4 4 0 0 1-.1382-.0087c-.2286-.0187-.4984-.0628-.7698-.201a2 2 0 0 1-.874-.8741c-.1383-.2714-.1824-.5412-.201-.7698-.0137-.1667-.0164-.3575-.0169-.5565l-8.0562-1.151c-.03.1529-.079.3148-.1619.4773a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.201A4 4 0 0 1 6 7.9919v8.0164q.0715.0034.1382.0088c.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.0828.1626.1319.3245.1619.4773L16 16.4184c.0005-.199.0032-.3899.0169-.5566.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201A4 4 0 0 1 18 14.0082"
      clipRule="evenodd"
    />
  </svg>
);

export const Perspective02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m7.0688 1.8799 11.6749 2.5944c.4193.0932.7852.1745 1.0859.2649.3206.0963.6322.2209.924.4311.4415.3181.7882.7503 1.003 1.2503.1419.3305.1959.6617.2204.9955.023.3132.023.6881.023 1.1176v6.9328c0 .4295 0 .8044-.023 1.1176-.0245.3338-.0785.665-.2204.9955a3 3 0 0 1-1.003 1.2503c-.2918.2102-.6034.3348-.924.4311-.3007.0904-.6667.1718-1.086.2649L7.0689 22.1203c-.6298.14-1.1653.259-1.6074.3172-.46.0606-.931.0733-1.4-.0812a3 3 0 0 1-1.6395-1.3152c-.2525-.4243-.3424-.8867-.383-1.349C2 19.2479 2 18.6993 2 18.0543V5.9459c0-.645 0-1.1936.039-1.6378.0406-.4623.1305-.9247.383-1.349a3 3 0 0 1 1.6395-1.3152c.469-.1545.94-.1418 1.4-.0812.4421.0582.9776.1772 1.6073.3172M9 11H4V5.9893c0-.7002.001-1.16.0313-1.5061.0297-.338.0806-.4529.1094-.5013a1 1 0 0 1 .5465-.4384c.0535-.0176.1767-.0423.513.002.3445.0454.7935.1443 1.477.2962L9 4.3578zm2 2v6.1979l4-.8889V13zm9-2h-3V6.1356l1.2772.2838c.4613.1025.7548.1684.9767.2351.2099.0631.2888.1084.3306.1386.1472.106.2628.25.3344.4167.0203.0475.0474.1343.0635.3528.017.2312.0176.532.0176 1.0045z"
      clipRule="evenodd"
    />
  </svg>
);

export const Pilcrow01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.5 3C7.4624 3 5 5.4624 5 8.5S7.4624 14 10.5 14H15v5h-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1V5h1c.5523 0 1-.4477 1-1s-.4477-1-1-1zM15 5h-4.5C8.567 5 7 6.567 7 8.5S8.567 12 10.5 12H15z"
      clipRule="evenodd"
    />
  </svg>
);

export const Pilcrow02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 3C6.2386 3 4 5.2386 4 8s2.2386 5 5 5h4v6h-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h7.5c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1V5h1c.5523 0 1-.4477 1-1s-.4477-1-1-1zm0 2h4v6H9c-1.6569 0-3-1.3431-3-3s1.3431-3 3-3"
      clipRule="evenodd"
    />
  </svg>
);

export const PilcrowSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 8h3v4h-3c-1.1046 0-2-.8954-2-2s.8954-2 2-2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9538 2 7.7587 2M7 10c0-2.2091 1.7909-4 4-4h4c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3h-3c-2.2091 0-4-1.7909-4-4"
      clipRule="evenodd"
    />
  </svg>
);

export const Reflect01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v3c0 .5523.4477 1 1 1s1-.4477 1-1zM3.8697 7.1767l4.4377 3.4137c.1206.0927.2576.198.3676.2992.1219.1123.2996.2973.4056.5737a1.5 1.5 0 0 1 0 1.0738c-.106.2764-.2837.4613-.4056.5736-.11.1013-.247.2066-.3676.2992l-4.4377 3.4137c-.1823.1403-.3692.2841-.5336.3883-.1589.1007-.4629.2775-.8545.2727a1.5 1.5 0 0 1-1.1592-.5708c-.2426-.3075-.2878-.6563-.3048-.8435C.9999 15.8765 1 15.6406 1 15.4106V8.5898c0-.23 0-.4659.0176-.6597.017-.1873.0622-.536.3048-.8436a1.5 1.5 0 0 1 1.1592-.5708c.3916-.0048.6957.172.8545.2727.1644.1042.3513.248.5336.3883M20.6639 6.7884c.1589-.1006.4629-.2775.8545-.2727a1.5 1.5 0 0 1 1.1593.5708c.2425.3075.2877.6563.3048.8436.0176.1938.0176.4296.0175.6596v6.8209c.0001.23.0001.4659-.0175.6597-.0171.1872-.0623.536-.3048.8435a1.5 1.5 0 0 1-1.1593.5708c-.3916.0048-.6956-.172-.8545-.2727-.1644-.1042-.3513-.248-.5335-.3883L15.6926 13.41c-.1205-.0927-.2576-.198-.3675-.2993-.122-.1123-.2997-.2972-.4057-.5736a1.5 1.5 0 0 1 0-1.0738c.106-.2764.2837-.4614.4057-.5737.1099-.1012.2469-.2065.3675-.2992l4.4378-3.4137c.1822-.1402.3691-.284.5335-.3883M12 9.5c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3c0-.5523.4477-1 1-1M13 18c0-.5523-.4477-1-1-1s-1 .4477-1 1v3c0 .5523.4477 1 1 1s1-.4477 1-1z"
    />
  </svg>
);

export const Reflect02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v3c0 .5523.4477 1 1 1s1-.4477 1-1zM20.2071 7.2929c.3905.3905.3905 1.0237 0 1.4142L17.9142 11H22c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4.0858l2.2929 2.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142l4-4c.3905-.3905 1.0237-.3905 1.4142 0M2 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h4.0858l-2.293 2.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0l4-4c.3905-.3905.3905-1.0237 0-1.4142l-4-4c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L6.0858 11zM12 9.5c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3c0-.5523.4477-1 1-1M13 18c0-.5523-.4477-1-1-1s-1 .4477-1 1v3c0 .5523.4477 1 1 1s1-.4477 1-1z"
    />
  </svg>
);

export const RightIndent01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1zM3 19c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1zM2 9.25c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M3 13.75c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zM20.5311 7.0003c-.3882-.008-.6913.1628-.851.2613-.1642.1013-.3509.2413-.5323.3774l-3.9171 2.9379c-.1246.0933-.2654.1989-.3783.3004-.1246.1121-.308.2982-.4171.5789a1.5 1.5 0 0 0 0 1.0875c.1091.2807.2925.4669.4171.5789.1129.1015.2537.207.3782.3004l3.9172 2.9379c.1814.1361.3681.2761.5323.3774.1597.0985.4628.2694.851.2613a1.5 1.5 0 0 0 1.1499-.5749c.2393-.3057.2845-.6508.3015-.8376.0175-.1921.0175-.4255.0174-.6522V9.065c.0001-.2267.0001-.46-.0174-.6522-.017-.1868-.0622-.532-.3015-.8376a1.5 1.5 0 0 0-1.1499-.575"
    />
  </svg>
);

export const RightIndent02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.5311 1.5003c-.3882-.008-.6913.1628-.851.2613-.1642.1013-.3509.2413-.5323.3774l-3.9172 2.9379c-.1245.0933-.2653.1989-.3782.3004-.1246.112-.308.2982-.4171.579a1.5 1.5 0 0 0 0 1.0874c.1091.2807.2925.4669.4171.5789.1129.1015.2537.207.3783.3004l3.9172 2.9379c.1813.1361.368.2761.5322.3774.1597.0985.4628.2694.851.2613a1.5 1.5 0 0 0 1.1499-.5749c.2393-.3057.2845-.6508.3015-.8376.0175-.1921.0175-.4255.0174-.6522V3.565c.0001-.2267.0001-.46-.0174-.6522-.017-.1868-.0622-.532-.3015-.8376a1.5 1.5 0 0 0-1.1499-.575M3 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zM3 8.25c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zM2 14.75c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M3 19c-.5523 0-1 .4477-1 1s.4477 1 1 1h18c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const RollerBrush = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.4162 1c-.3807-.0003-.7085-.0005-1.0014.0577a3 3 0 0 0-2.357 2.3571c-.0583.2929-.058.6207-.0578 1.0014v.1678c-.0003.3807-.0005.7085.0577 1.0014a3 3 0 0 0 2.3571 2.357c.2929.0583.6207.058 1.0014.0577H16.584c.3807.0003.7085.0006 1.0014-.0577a3 3 0 0 0 2.357-2.357 2 2 0 0 0 .0132-.073q.0364.002.0706.0043c.228.0156.3149.0422.3565.0594.245.1015.4397.2962.5412.5412.0172.0416.0438.1285.0594.3565.0162.237.0167.5466.0167 1.0262v.3c0 .5766-.0008.9488-.0239 1.2322-.0222.2716-.0599.3724-.0851.4218a1 1 0 0 1-.437.437c-.0495.0252-.1502.0629-.4218.085-.2834.0232-.6556.024-1.2322.024h-3.6385c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167-.0276.3378-.0303.7407-.0306 1.2032a4 4 0 0 0-.1382.0088c-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.017.2081-.017.4539-.017.7063v3.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-3.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201a4 4 0 0 0-.1381-.0088c.0004-.4696.0034-.7898.0238-1.0404.0222-.2716.0599-.3723.0851-.4218a1 1 0 0 1 .437-.437c.0495-.0252.1502-.0629.4218-.0851.2834-.0231.6556-.0239 1.2322-.0239h3.6385c.5272 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C23 8.8205 23 8.3658 23 7.8387V7.468c0-.4386 0-.8171-.0213-1.1304-.0226-.3298-.0721-.6597-.2071-.9856a3 3 0 0 0-1.6235-1.6236c-.326-.135-.6559-.1846-.9857-.207a7 7 0 0 0-.2031-.0108 2 2 0 0 0-.0169-.0958 3 3 0 0 0-2.357-2.357C17.2925.9994 16.9647.9997 16.584 1z"
    />
  </svg>
);

export const Scale01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m5.8625 1 .1376.0001c.5523 0 1 .4477 1 1s-.4477 1-1 1c-.9944 0-1.2954.0086-1.5176.0681a2 2 0 0 0-1.4142 1.4143C3.0087 4.7047 3 5.0057 3 6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.1376c-.0005-.7954-.0008-1.386.1363-1.8977a4 4 0 0 1 2.8284-2.8284C4.4765.9993 5.0671.9996 5.8625 1M19.5177 3.0682c-.2222-.0595-.5233-.0681-1.5176-.0681-.5523 0-1-.4477-1-1s.4477-1 1-1h.1376c.7954-.0005 1.386-.0008 1.8977.1363a4 4 0 0 1 2.8284 2.8284c.1371.5117.1368 1.1023.1363 1.8977v.1376c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-.9944-.0086-1.2954-.0682-1.5176a2 2 0 0 0-1.4142-1.4143M9.0001 2.0001c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4c-.5523 0-1-.4477-1-1M2.0001 9.0001c.5523 0 1 .4477 1 1v1.5357a4 4 0 0 1 .184-.0998c.4853-.2473 1.002-.3459 1.564-.3918C5.2895 11 5.9538 11 6.7588 11h.4826c.805 0 1.4693 0 2.0105.0442.5621.0459 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.0021.3918 1.5642C13 15.2894 13 15.9537 13 16.7587v.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-.1.1841h1.5361c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.7588c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918A4 4 0 0 1 1.436 20.816c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 18.7106 1 18.0463 1 17.2413v-.4826l.0001-.3105v-6.4481c0-.5523.4477-1 1-1M22.0001 9.0001c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1M22.0001 17.0001c.5523 0 1 .4477 1 1v.1376c.0005.7954.0008 1.386-.1363 1.8977a4 4 0 0 1-2.8284 2.8284c-.5117.1371-1.1023.1368-1.8977.1363h-.1376c-.5523 0-1-.4477-1-1s.4477-1 1-1c.9943 0 1.2954-.0086 1.5176-.0682a2 2 0 0 0 1.4142-1.4142c.0596-.2222.0682-.5233.0682-1.5176 0-.5523.4477-1 1-1"
    />
  </svg>
);

export const Scale02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H16c-.5523 0-1-.4477-1-1s.4477-1 1-1h.2c.8566 0 1.4389-.0008 1.889-.0376.4384-.0358.6626-.1007.819-.1804a2 2 0 0 0 .874-.874c.0797-.1564.1446-.3806.1804-.819.0368-.4501.0376-1.0324.0376-1.889V7.8c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804C17.6389 4.0008 17.0566 4 16.2 4H7.8c-.8566 0-1.4389.0008-1.889.0376-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 6.3611 4 6.9434 4 7.8V8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.2413c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9537 2 7.7587 2"
    />
    <path
      fill="currentColor"
      d="M8.8386 11H6.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C2 14.1795 2 14.6343 2 15.1614v2.6771c0 .5272 0 .982.0306 1.3565.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311c.3784.1928.7716.2641 1.167.2964C5.1795 22 5.6342 22 6.1613 22h2.6772c.5271 0 .982 0 1.3565-.0306.3954-.0323.7886-.1036 1.167-.2964a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167C13 18.8205 13 18.3657 13 17.8386v-2.6771c0-.5272 0-.982-.0306-1.3565-.0303-.3713-.095-.7407-.2625-1.0977L16 9.4143V12c0 .5523.4477 1 1 1s1-.4477 1-1V7c0-.5523-.4477-1-1-1h-5c-.5523 0-1 .4477-1 1s.4477 1 1 1h2.5858l-3.2931 3.2931c-.357-.1675-.7264-.2322-1.0977-.2625C9.8205 11 9.3657 11 8.8385 11"
    />
  </svg>
);

export const Scale03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 22 6.9537 22 7.7587 22h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 17.7106 22 17.0463 22 16.2413V7.7586c0-.805 0-1.4693-.0442-2.0104-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4247-.2164-.8734-.319-1.3555-.372a8 8 0 0 0-.2087-.0198c-.4798-.0392-1.0564-.0436-1.7419-.0441zM7.8 4h3.3783c-.0852.2646-.1256.5343-.1477.805C11 5.1795 11 5.6343 11 6.1614v2.6772c0 .527 0 .9819.0306 1.3564.0303.3713.095.7407.2625 1.0977L8 14.5858V12c0-.5523-.4477-1-1-1s-1 .4477-1 1v5c0 .5523.4477 1 1 1h5c.5523 0 1-.4477 1-1s-.4477-1-1-1H9.4142l3.2931-3.2931c.357.1675.7264.2322 1.0977.2625.3745.0306.8293.0306 1.3564.0306h2.6771c.5272 0 .982 0 1.3565-.0306.2707-.0221.5404-.0625.805-.1476V16.2c0 .8566-.0008 1.4389-.0376 1.889-.0358.4384-.1007.6626-.1804.819a2 2 0 0 1-.874.874c-.1564.0797-.3806.1446-.819.1804-.4501.0368-1.0324.0376-1.889.0376H7.8c-.8566 0-1.4389-.0008-1.889-.0376-.4384-.0358-.6626-.1007-.819-.1804a2 2 0 0 1-.874-.874c-.0797-.1564-.1446-.3806-.1804-.819C4.0008 17.6389 4 17.0566 4 16.2V7.8c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804C6.3611 4.0008 6.9434 4 7.8 4"
      clipRule="evenodd"
    />
  </svg>
);

export const Scissors01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 2C3.7909 2 2 3.7909 2 6s1.7909 4 4 4c.7418 0 1.4364-.202 2.032-.5538L10.5858 12 8.032 14.5538A3.98 3.98 0 0 0 6 14c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4 4-1.7909 4-4c0-.7418-.202-1.4365-.5538-2.032L12 13.4142l7.2929 7.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L13.4142 12l7.2929-7.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L12 10.5858 9.4462 8.032A3.98 3.98 0 0 0 10 6c0-2.2091-1.7909-4-4-4M4 6c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2m2 10c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Scissors02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.9572 9.4397C2.7852 8.7422 2 7.4628 2 6c0-2.2091 1.7909-4 4-4s4 1.7909 4 4c0 1.4038-.7232 2.6387-1.8173 3.3525l2.9963 1.5254 9.3673-4.7689c.4922-.2505 1.0943-.0546 1.3448.4375.2506.4922.0547 1.0943-.4374 1.3449L13.3831 12l8.0706 4.1087c.4922.2505.6881.8526.4375 1.3448s-.8527.688-1.3449.4375l-9.3673-4.7689-2.9963 1.5254C9.2768 15.3613 10 16.5962 10 18c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4c0-1.4628.7852-2.7422 1.9571-3.4397a1 1 0 0 1 .0833-.0482 4 4 0 0 1 .2973-.1514L8.9747 12 4.3377 9.6393a4 4 0 0 1-.297-.1513 1 1 0 0 1-.0834-.0483M4 6c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2c-.287 0-.5598-.0604-.8065-.1693l-.1965-.1C4.4009 7.3845 4 6.739 4 6m.997 10.2693C4.4007 16.6156 4 17.261 4 18c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2a1.99 1.99 0 0 0-.8065.1693z"
      clipRule="evenodd"
    />
  </svg>
);

export const ScissorsCut01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 2C3.7909 2 2 3.7909 2 6s1.7909 4 4 4c.7418 0 1.4364-.202 2.032-.5538L10.5858 12 8.032 14.5538A3.98 3.98 0 0 0 6 14c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4 4-1.7909 4-4c0-.7418-.202-1.4365-.5538-2.032L12 13.4142l7.2929 7.2929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L13.4142 12l7.2929-7.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L12 10.5858 9.4462 8.032A3.98 3.98 0 0 0 10 6c0-2.2091-1.7909-4-4-4M4 6c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2m2 10c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M16.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M22 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const ScissorsCut02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.9572 9.4397C2.7852 8.7422 2 7.4628 2 6c0-2.2091 1.7909-4 4-4s4 1.7909 4 4c0 1.4038-.7232 2.6387-1.8173 3.3525l2.9963 1.5254 9.3673-4.7689c.4922-.2505 1.0943-.0546 1.3448.4375.2506.4922.0547 1.0943-.4374 1.3449L13.3831 12l8.0706 4.1087c.4922.2505.6881.8526.4375 1.3448s-.8527.688-1.3449.4375l-9.3673-4.7689-2.9963 1.5254C9.2768 15.3613 10 16.5962 10 18c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4c0-1.4628.7852-2.7422 1.9571-3.4397a1 1 0 0 1 .0833-.0482 4 4 0 0 1 .2973-.1514L8.9747 12 4.3377 9.6393a4 4 0 0 1-.297-.1513 1 1 0 0 1-.0834-.0483M4 6c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2c-.287 0-.5598-.0604-.8065-.1693l-.1965-.1C4.4009 7.3845 4 6.739 4 6m.997 10.2693C4.4007 16.6156 4 17.261 4 18c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2a1.99 1.99 0 0 0-.8065.1693z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M16.5 12c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.01c-.5523 0-1-.4477-1-1M22 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Skew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5681 2c-.2524 0-.4982 0-.7063.017-.2286.0186-.4983.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698C3 4.0699 3 4.3158 3 4.568v.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698a2 2 0 0 0 .874.874c.2715.1383.5412.1824.7698.201q.0433.0036.0886.0062L3.5199 16c-.2354 0-.4632.001-.6581.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.017.2081-.017.4539-.017.7063v.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.454.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.201-.7698A4 4 0 0 0 6.9919 20h8.0164a4 4 0 0 0 .0088.1382c.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.1626-.0828-.3246-.1319-.4775-.1619l1.1509-8.0562c.1991-.0005.3901-.0032.5568-.0168.2286-.0187.4984-.0628.7698-.201a2 2 0 0 0 .874-.8741c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.454.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C20.9301 2 20.6843 2 20.4319 2h-.8638c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698A4 4 0 0 0 17.0082 4H8.9918a4 4 0 0 0-.0087-.1382c-.0187-.2286-.0628-.4984-.201-.7698a2 2 0 0 0-.8741-.874c-.2714-.1383-.5412-.1824-.7698-.201C6.9301 2 6.6842 2 6.432 2zm11.8501 14.0001 1.1509-8.0563c-.1528-.03-.3146-.079-.4771-.1618a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698A4 4 0 0 1 17.0082 6H8.9918a4 4 0 0 1-.0087.1382c-.0187.2286-.0628.4984-.201.7698a2 2 0 0 1-.8741.874c-.2714.1383-.5412.1824-.7698.201a4 4 0 0 1-.1568.0096L5.5372 16.08c.1207.0304.2455.0742.3708.138.3763.1917.6823.4977.874.874.1383.2714.1824.5412.201.7698q.0055.0667.0088.1382h8.0164a4 4 0 0 1 .0088-.1382c.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201.1666-.0137.3574-.0164.5564-.0169"
      clipRule="evenodd"
    />
  </svg>
);

export const Strikethrough01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 8c0-2.7614 2.2386-5 5-5h4c2.7614 0 5 2.2386 5 5 0 .5523-.4477 1-1 1s-1-.4477-1-1c0-1.6569-1.3431-3-3-3h-4C8.3431 5 7 6.3431 7 8c0 .5523-.4477 1-1 1s-1-.4477-1-1M18.0004 13H21c.5523 0 1-.4477 1-1s-.4477-1-1-1H3c-.5523 0-1 .4477-1 1s.4477 1 1 1h11c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3h-4c-1.6569 0-3-1.3431-3-3 0-.5523-.4477-1-1-1s-1 .4477-1 1c0 2.7614 2.2386 5 5 5h4c2.7614 0 5-2.2386 5-5a4.978 4.978 0 0 0-.9996-3"
    />
  </svg>
);

export const Strikethrough02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 3C7.2386 3 5 5.2386 5 8c0 .5523.4477 1 1 1h3.5c.5523 0 1-.4477 1-1 0-1.6569 1.3431-3 3-3h.5c1.6569 0 3 1.3431 3 3 0 .5523.4477 1 1 1s1-.4477 1-1c0-2.7614-2.2386-5-5-5z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.5 16c0 1.6569-1.3431 3-3 3H10c-1.6569 0-3-1.3431-3-3 0-.5523-.4477-1-1-1s-1 .4477-1 1c0 2.7614 2.2386 5 5 5h4c2.7614 0 5-2.2386 5-5a4.978 4.978 0 0 0-.9996-3H21c.5523 0 1-.4477 1-1s-.4477-1-1-1H3c-.5523 0-1 .4477-1 1s.4477 1 1 1h7.5c1.6569 0 3 1.3431 3 3"
      clipRule="evenodd"
    />
  </svg>
);

export const StrikethroughSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9538 2 7.7587 2m.0329 6.0996C8.3307 6.8656 9.563 6 10.9999 6h2.1667c1.4231 0 2.6355.8914 3.1141 2.1428.1973.5158-.0609 1.094-.5768 1.2912-.5158.1973-1.0939-.061-1.2912-.5768C14.2203 8.3544 13.7336 8 13.1666 8h-2.1667c-.6135 0-1.1433.3685-1.3756.9004-.2211.506-.8107.737-1.3168.516-.506-.2212-.737-.8107-.516-1.3168M5 12c0 .5523.4477 1 1 1h6.9999c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5h-2.1667c-.567 0-1.0538-.3544-1.246-.8572-.1974-.5159-.7755-.7741-1.2913-.5768-.5159.1973-.7741.7754-.5768 1.2912C8.1977 17.1086 9.41 18 10.8332 18h2.1667c1.933 0 3.5-1.567 3.5-3.5a3.49 3.49 0 0 0-.3368-1.5H18c.5523 0 1-.4477 1-1s-.4477-1-1-1H6c-.5523 0-1 .4477-1 1"
      clipRule="evenodd"
    />
  </svg>
);

export const Subscript = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.2929 4.2929c.3905-.3905 1.0237-.3905 1.4142 0L8 8.5858l4.2929-4.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L9.4142 10l4.2929 4.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L8 11.4142l-4.2929 4.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L6.5858 10l-4.293-4.2929c-.3904-.3905-.3904-1.0237 0-1.4142M19.4536 11.0395a3.11 3.11 0 0 0-2.0457.3598l-.004.0023c-.6242.3567-1.1046.9241-1.3461 1.6032-.185.5204.0868 1.0922.6072 1.2773.5204.185 1.0922-.0869 1.2772-.6073.0783-.2201.2372-.4122.452-.5356a1.11 1.11 0 0 1 1.3721.2278.982.982 0 0 1 .2337.6328c0 .2478-.1162.49-.4793.7822-.3827.3079-.8928.5518-1.4473.8134-.5806.2739-1.1638.6228-1.5606 1.2364-.3952.6112-.5128 1.3388-.5128 2.168 0 .5523.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2.8533a.7.7 0 0 1 .0455-.0819c.0882-.1364.2551-.2875.7344-.5136l.0562-.0265c.503-.237 1.2112-.5706 1.7916-1.0376C21.3962 15.8399 22 15.0821 22 13.9998a2.982 2.982 0 0 0-.7222-1.9425l-.0082-.0094a3.11 3.11 0 0 0-1.816-1.0084"
    />
  </svg>
);

export const TextInput = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 4h-1.5c-.5523 0-1-.4477-1-1s.4477-1 1-1h5c.5523 0 1 .4477 1 1s-.4477 1-1 1H18v2h.8385c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 9.1796 23 9.6343 23 10.1615v3.677c0 .5272 0 .982-.0306 1.3565-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 18 19.3658 18 18.8387 18H18v2h1.5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-5c-.5523 0-1-.4477-1-1s.4477-1 1-1H16z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.1615 6H13c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1H5.1615c-.527 0-.982 0-1.3565-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 14.8205 1 14.3657 1 13.8386v-3.6771c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 6 4.6343 6 5.1615 6"
    />
  </svg>
);

export const Transform = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5681 2c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698C2 4.0699 2 4.3158 2 4.568v.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698a2 2 0 0 0 .874.874c.2714.1383.5412.1824.7698.201q.0667.0055.1382.0088v8.0164a4 4 0 0 0-.1382.0088c-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698-.017.2081-.017.4539-.017.7063v.8638c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.454.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.201-.7698A4 4 0 0 0 7.9919 20h8.0164a4 4 0 0 0 .0088.1382c.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h.8638c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201A4 4 0 0 0 20 16.0082V7.9918a4 4 0 0 0 .1382-.0087c.2286-.0187.4984-.0628.7698-.201a2 2 0 0 0 .874-.8741c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.454.0169-.7063v-.8638c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C19.9301 2 19.6843 2 19.4319 2h-.8638c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698A4 4 0 0 0 16.0082 4H7.9918a4 4 0 0 0-.0087-.1382c-.0187-.2286-.0628-.4984-.201-.7698a2 2 0 0 0-.8741-.874c-.2714-.1383-.5412-.1824-.7698-.201C5.9301 2 5.6842 2 5.432 2zM18 16.0082V7.9918a4 4 0 0 1-.1382-.0087c-.2286-.0187-.4984-.0628-.7698-.201a2 2 0 0 1-.874-.8741c-.1383-.2714-.1824-.5412-.201-.7698A4 4 0 0 1 16.0082 6H7.9918a4 4 0 0 1-.0087.1382c-.0187.2286-.0628.4984-.201.7698a2 2 0 0 1-.8741.874c-.2714.1383-.5412.1824-.7698.201A4 4 0 0 1 6 7.9919v8.0164q.0715.0034.1382.0088c.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.201.7698q.0055.0667.0088.1382h8.0164a4 4 0 0 1 .0088-.1382c.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2714-.1383.5412-.1824.7698-.201A4 4 0 0 1 18 16.0082"
      clipRule="evenodd"
    />
  </svg>
);

export const Type01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.968 3h10.064c.4386 0 .8171 0 1.1304.0213.3298.0226.6597.072.9857.207a3 3 0 0 1 1.6235 1.6237c.135.3259.1845.6558.2071.9856C21 6.151 21 6.5294 21 6.968V7c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-.4796-.0005-.7893-.0167-1.0262-.0156-.228-.0422-.3149-.0594-.3565a1 1 0 0 0-.5412-.5412c-.0416-.0172-.1285-.0438-.3565-.0594C17.7893 5.0005 17.4796 5 17 5h-4v14h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2V5H7c-.4796 0-.7893.0005-1.0262.0167-.228.0156-.3149.0422-.3565.0594a1 1 0 0 0-.5412.5412c-.0172.0416-.0438.1285-.0594.3565C5.0005 6.2108 5 6.5204 5 7c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.032c0-.4386 0-.8171.0213-1.1304.0226-.3298.072-.6597.207-.9856A3 3 0 0 1 4.852 3.2284c.3259-.135.6558-.1845.9856-.207C6.151 3 6.5294 3 6.968 3"
      clipRule="evenodd"
    />
  </svg>
);

export const Type02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.968 3h10.064c.4386 0 .8171 0 1.1304.0213.3298.0226.6597.072.9857.207a3 3 0 0 1 1.6235 1.6237c.135.3259.1845.6558.2071.9856C21 6.151 21 6.5294 21 6.968V7c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-.4796-.0005-.7893-.0167-1.0262-.0156-.228-.0422-.3149-.0594-.3565a1 1 0 0 0-.5412-.5412c-.0416-.0172-.1285-.0438-.3565-.0594C17.7893 5.0005 17.4796 5 17 5h-2.25v14H16c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.25V5H7c-.4796 0-.7893.0005-1.0262.0167-.228.0156-.3149.0422-.3565.0594a1 1 0 0 0-.5412.5412c-.0172.0416-.0438.1285-.0594.3565C5.0005 6.2108 5 6.5204 5 7c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.032c0-.4386 0-.8171.0213-1.1304.0226-.3298.072-.6597.207-.9856A3 3 0 0 1 4.852 3.2284c.3259-.135.6558-.1845.9856-.207C6.151 3 6.5294 3 6.968 3"
      clipRule="evenodd"
    />
  </svg>
);

export const TypeSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9538 2 7.7587 2M7 7c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3v9c0 .5523-.4477 1-1 1s-1-.4477-1-1V8H8c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const TypeStrikethrough01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.2929 2.2929c.3905-.3905 1.0237-.3905 1.4142 0l18 18c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 14.4142V19h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-6.5858l-6-6V7c0 .5523-.4477 1-1 1s-1-.4477-1-1V6c0-.4627.1052-.9016.2926-1.2932l-.9997-.9997c-.3905-.3905-.3905-1.0237 0-1.4142m15.7333 2.7238C17.7893 5.0005 17.4796 5 17 5h-4v1.5c0 .5523-.4477 1-1 1s-1-.4477-1-1V5H9.5c-.5523 0-1-.4477-1-1s.4477-1 1-1h7.532c.4386 0 .8171 0 1.1304.0213.3298.0225.6597.072.9857.207a3 3 0 0 1 1.6235 1.6237c.135.3259.1845.6558.2071.9856C21 6.151 21 6.5294 21 6.968V7c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-.4796-.0005-.7893-.0167-1.0262-.0156-.228-.0422-.3149-.0594-.3565a1 1 0 0 0-.5412-.5412c-.0416-.0172-.1285-.0438-.3565-.0594"
      clipRule="evenodd"
    />
  </svg>
);

export const TypeStrikethrough02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.2929 2.2929c.3905-.3905 1.0237-.3905 1.4142 0l18 18c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L14.75 16.1642V19H16c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h1.25v-8.3358L5 6.4142V7c0 .5522-.4477 1-1 1s-1-.4478-1-1V6c0-.4628.1052-.9016.2925-1.2932L2.293 3.707c-.3905-.3905-.3905-1.0237 0-1.4142"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.75 10.5074V5H17c.4796 0 .7893.0005 1.0262.0167.228.0156.3149.0422.3565.0594.245.1015.4397.2962.5412.5412.0172.0416.0438.1285.0594.3565C18.9995 6.2108 19 6.5204 19 7c0 .5523.4477 1 1 1s1-.4477 1-1v-.032c0-.4386 0-.8171-.0213-1.1304-.0225-.3298-.0721-.6597-.2071-.9856a3 3 0 0 0-1.6235-1.6236c-.326-.135-.6559-.1845-.9857-.207C17.8491 3 17.4707 3 17.032 3H7.2426l2 2H9.25v.0074z"
    />
  </svg>
);

export const Underline01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 21c0-.5523.4477-1 1-1h16c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1M6 3c.5523 0 1 .4477 1 1v7c0 2.7614 2.2386 5 5 5s5-2.2386 5-5V4c0-.5523.4477-1 1-1s1 .4477 1 1v7c0 3.866-3.134 7-7 7s-7-3.134-7-7V4c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Underline02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 4c0-.5523.4477-1 1-1h7.5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1v5c0 2.7036 1.789 4.9919 4.2495 5.7409C16.2098 14.9921 18 12.7051 18 10V5h-1c-.5523 0-1-.4477-1-1s.4477-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1v5c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8V5H3c-.5523 0-1-.4477-1-1m1 17c0-.5523.4477-1 1-1h16c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const UnderlineSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.7587 2h8.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 22 17.0463 22 16.2413 22H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 17.7106 2 17.0463 2 16.2413V7.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 2 6.9538 2 7.7587 2M9.5 7c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5c0 2.4853 2.0147 4.5 4.5 4.5s4.5-2.0147 4.5-4.5V7c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5zM8 16c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const ZoomIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 2c-4.9706 0-9 4.0294-9 9s4.0294 9 9 9c2.125 0 4.078-.7365 5.6177-1.9681l3.6751 3.6751c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-3.6751-3.6751C19.2635 15.078 20 13.125 20 11c0-4.9706-4.0294-9-9-9m0 5c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2H8c-.5523 0-1-.4477-1-1s.4477-1 1-1h2V8c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ZoomOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 2c-4.9706 0-9 4.0294-9 9s4.0294 9 9 9c2.125 0 4.078-.7365 5.6177-1.9681l3.6751 3.6751c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-3.6751-3.6751C19.2635 15.078 20 13.125 20 11c0-4.9706-4.0294-9-9-9m-3 8c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const AlarmClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.7071 3.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM19.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22a9 9 0 0 0 5.6175-1.9683l1.6754 1.6754c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-1.6754-1.6754A9.0003 9.0003 0 0 0 18.364 6.636a9.0003 9.0003 0 0 0-12.728 0 9 9 0 0 0-.6677 11.9815L3.293 20.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l1.6754-1.6754A9 9 0 0 0 12 22m1-13c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 .2652.1054.5196.2929.7071l2 2c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L13 12.5858z"
      clipRule="evenodd"
    />
  </svg>
);

export const AlarmClockCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.7071 3.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM19.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22a9 9 0 0 0 5.6175-1.9683l1.6754 1.6754c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-1.6754-1.6754A9.0003 9.0003 0 0 0 18.364 6.636a9.0003 9.0003 0 0 0-12.728 0 9 9 0 0 0-.6677 11.9815L3.293 20.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l1.6754-1.6754A9 9 0 0 0 12 22m4.2071-10.2929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 14.0858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const AlarmClockMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.7071 3.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM19.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22a9 9 0 0 0 5.6175-1.9683l1.6754 1.6754c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-1.6754-1.6754A9.0003 9.0003 0 0 0 18.364 6.636a9.0003 9.0003 0 0 0-12.728 0 9 9 0 0 0-.6677 11.9815L3.293 20.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l1.6754-1.6754A9 9 0 0 0 12 22M9 12c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const AlarmClockOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.7071 2.2929A1 1 0 0 0 3.5 2.1337c-.3824-.221-.88-.168-1.2071.1592-.3905.3905-.3905 1.0237 0 1.4142L2.5858 4l-1.293 1.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0L4 5.4142l1.4324 1.4324a9 9 0 0 0-.4641 11.7709l-1.6754 1.6754c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l1.6754-1.6754a9 9 0 0 0 11.771-.4639l2.1394 2.1393c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20.4203 16.1777a9.0002 9.0002 0 0 0-11.598-11.598zM19.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
    />
  </svg>
);

export const AlarmClockPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.7071 3.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-3 3c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM19.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22a9 9 0 0 0 5.6175-1.9683l1.6754 1.6754c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-1.6754-1.6754A9.0003 9.0003 0 0 0 18.364 6.636a9.0003 9.0003 0 0 0-12.728 0 9 9 0 0 0-.6677 11.9815L3.293 20.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l1.6754-1.6754A9 9 0 0 0 12 22m0-13c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Calendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 1c.5523 0 1 .4477 1 1v1.0016c.4755.0033.891.0131 1.2518.0426.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 7.2894 22 7.9537 22 8.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 23 17.0463 23 16.2413 23H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 18.7106 2 18.0463 2 17.2413V8.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918.3608-.0295.7763-.0393 1.2518-.0426V2c0-.5523.4477-1 1-1s1 .4477 1 1v1h6V2c0-.5523.4477-1 1-1M7 5.0018V6c0 .5523.4477 1 1 1s1-.4477 1-1V5h6v1c0 .5523.4477 1 1 1s1-.4477 1-1v-.9982c.4455.003.7954.0118 1.089.0358.4384.0358.6626.1007.819.1804.3763.1917.6823.4977.874.874.0797.1564.1446.3806.1804.819C19.9992 7.3611 20 7.9434 20 8.8V9H4v-.2c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804.2936-.024.6435-.0327 1.089-.0358"
      clipRule="evenodd"
    />
  </svg>
);

export const CalendarCheck01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H9V2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.0016c-.4755.0033-.891.0131-1.2518.0426-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 7.2894 2 7.9537 2 8.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 23 6.9537 23 7.7587 23h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 18.7106 22 18.0463 22 17.2413V8.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918-.3608-.0295-.7763-.0393-1.2518-.0426zM7 6v-.9982c-.4455.003-.7954.0118-1.089.0358-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 7.3611 4 7.9434 4 8.8V9h16v-.2c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804-.2936-.024-.6435-.0327-1.089-.0358V6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5H9v1c0 .5523-.4477 1-1 1s-1-.4477-1-1m9.2071 8.2071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 16.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const CalendarCheck02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.7071 15.7929c.3905.3905.3905 1.0237 0 1.4142l-4.5 4.5c-.3905.3905-1.0237.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L17.5 19.5858l3.7929-3.7929c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H9V2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.0016c-.4755.0033-.891.0131-1.2518.0426-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 7.2894 2 7.9537 2 8.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 23 6.9537 23 7.7587 23h5.5673c.6058 0 .9087 0 1.049-.1198a.5.5 0 0 0 .1737-.4194c-.0145-.1839-.2287-.3981-.657-.8265l-.513-.513c-1.1716-1.1716-1.1716-3.071 0-4.2426 1.1308-1.1309 2.9399-1.1702 4.1179-.1179l2.3821-2.3821a2.987 2.987 0 0 1 1.3306-.7732c.3451-.0939.5177-.1408.5962-.2014.0836-.0645.1164-.1075.1567-.2051C22 13.1074 22 12.9716 22 12.7V8.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918-.3608-.0295-.7763-.0393-1.2518-.0426zM7 6v-.9982c-.4455.003-.7954.0118-1.089.0358-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 7.3611 4 7.9434 4 8.8V9h16v-.2c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804-.2936-.024-.6435-.0327-1.089-.0358V6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5H9v1c0 .5523-.4477 1-1 1s-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const CalendarDate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H9V2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.0016c-.4755.0033-.891.0131-1.2518.0426-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 7.2894 2 7.9537 2 8.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 23 6.9537 23 7.7587 23h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 18.7106 22 18.0463 22 17.2413V8.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918-.3608-.0295-.7763-.0393-1.2518-.0426zM7 6v-.9982c-.4455.003-.7954.0118-1.089.0358-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 7.3611 4 7.9434 4 8.8V9h16v-.2c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804-.2936-.024-.6435-.0327-1.089-.0358V6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5H9v1c0 .5523-.4477 1-1 1s-1-.4477-1-1m5.4718 6.1183A1 1 0 0 1 13 13v4h.25c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2.5c-.5523 0-1-.4477-1-1s.4477-1 1-1H11v-2.1339c-.453.2621-1.0377.1301-1.332-.3114-.3064-.4595-.1822-1.0804.2773-1.3867l1.5-1a1 1 0 0 1 1.0265-.0497"
      clipRule="evenodd"
    />
  </svg>
);

export const CalendarHeart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H9V2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.0016c-.4755.0033-.891.0131-1.2518.0426-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 7.2894 2 7.9537 2 8.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 23 6.9537 23 7.7587 23h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 18.7106 22 18.0463 22 17.2413V8.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918-.3608-.0295-.7763-.0393-1.2518-.0426zM7 6v-.9982c-.4455.003-.7954.0118-1.089.0358-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 7.3611 4 7.9434 4 8.8V9h16v-.2c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804-.2936-.024-.6435-.0327-1.089-.0358V6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5H9v1c0 .5523-.4477 1-1 1s-1-.4477-1-1m1.8619 7.0094c1.002-.8323 2.3356-.5878 3.1354.3212.7997-.909 2.1161-1.1448 3.1353-.3212s1.1431 2.2241.3562 3.2085c-.4679.5854-1.614 1.6352-2.4662 2.39-.3518.3116-.5277.4674-.7394.5306a1.028 1.028 0 0 1-.5718 0c-.2118-.0632-.3877-.219-.7395-.5306-.8522-.7548-1.9983-1.8046-2.4662-2.39-.787-.9844-.6458-2.3761.3562-3.2085"
      clipRule="evenodd"
    />
  </svg>
);

export const CalendarHeart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.9973 16.8306c-.7998-.909-2.1334-1.1535-3.1354-.3212s-1.1431 2.2241-.3562 3.2085c.4679.5854 1.614 1.6352 2.4662 2.39.3518.3116.5277.4674.7395.5306.1811.0541.3906.0541.5718 0 .2117-.0632.3876-.219.7394-.5306.8522-.7548 1.9983-1.8046 2.4662-2.39.7869-.9844.6631-2.3848-.3562-3.2085-1.0192-.8236-2.3356-.5878-3.1353.3212"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 1c.5523 0 1 .4477 1 1v1.0016c.4755.0033.891.0131 1.2518.0426.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 7.2894 22 7.9537 22 8.7587v4.3379c0 .3681 0 .5521-.0571.6612-.059.1124-.1133.1647-.2279.2193-.1111.0529-.3382.0442-.7924.0268-.6685-.0255-1.3274.1151-1.9263.3895-1.3559-.6223-3.0285-.572-4.4123.5776-1.823 1.5143-2.1219 4.1423-.6405 5.9956.1438.1799.3278.3843.5356.601.4592.4788.6887.7182.7004.9005.0104.163-.0517.3088-.1766.4141C14.8632 23 14.543 23 13.9026 23h-6.144c-.8049 0-1.4692 0-2.0104-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 18.7106 2 18.0463 2 17.2413V8.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918.3608-.0295.7763-.0393 1.2518-.0426V2c0-.5523.4477-1 1-1s1 .4477 1 1v1h6V2c0-.5523.4477-1 1-1M7 5.0018V6c0 .5523.4477 1 1 1s1-.4477 1-1V5h6v1c0 .5523.4477 1 1 1s1-.4477 1-1v-.9982c.4455.003.7954.0118 1.089.0358.4384.0358.6626.1007.819.1804.3763.1917.6823.4977.874.874.0797.1564.1446.3806.1804.819C19.9992 7.3611 20 7.9434 20 8.8V9H4v-.2c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804.2936-.024.6435-.0327 1.089-.0358"
      clipRule="evenodd"
    />
  </svg>
);

export const CalendarMinus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H9V2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.0016c-.4755.0033-.891.0131-1.2518.0426-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 7.2894 2 7.9537 2 8.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 23 6.9537 23 7.7587 23h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 18.7106 22 18.0463 22 17.2413V8.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918-.3608-.0295-.7763-.0393-1.2518-.0426zM7 6v-.9982c-.4455.003-.7954.0118-1.089.0358-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 7.3611 4 7.9434 4 8.8V9h16v-.2c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804-.2936-.024-.6435-.0327-1.089-.0358V6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5H9v1c0 .5523-.4477 1-1 1s-1-.4477-1-1m2 9c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const CalendarMinus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 18c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H9V2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.0016c-.4755.0033-.891.0131-1.2518.0426-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 7.2894 2 7.9537 2 8.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 23 6.9537 23 7.7587 23h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 .7633-.5067c.2361-.1992.3541-.2988.3805-.4886.0194-.1404-.0556-.3458-.161-.4405C20.6562 21 20.4636 21 20.0785 21H16c-1.6569 0-3-1.3431-3-3s1.3431-3 3-3h5.2c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C22 14.62 22 14.48 22 14.2V8.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918-.3608-.0295-.7763-.0393-1.2518-.0426zM7 6v-.9982c-.4455.003-.7954.0118-1.089.0358-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 7.3611 4 7.9434 4 8.8V9h16v-.2c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804-.2936-.024-.6435-.0327-1.089-.0358V6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5H9v1c0 .5523-.4477 1-1 1s-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const CalendarPlus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H9V2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.0016c-.4755.0033-.891.0131-1.2518.0426-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 7.2894 2 7.9537 2 8.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 23 6.9537 23 7.7587 23h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 18.7106 22 18.0463 22 17.2413V8.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918-.3608-.0295-.7763-.0393-1.2518-.0426zM7 6v-.9982c-.4455.003-.7954.0118-1.089.0358-.4384.0358-.6626.1007-.819.1804a2 2 0 0 0-.874.874c-.0797.1564-.1446.3806-.1804.819C4.0008 7.3611 4 7.9434 4 8.8V9h16v-.2c0-.8566-.0008-1.4389-.0376-1.889-.0358-.4384-.1007-.6626-.1804-.819a2 2 0 0 0-.874-.874c-.1564-.0797-.3806-.1446-.819-.1804-.2936-.024-.6435-.0327-1.089-.0358V6c0 .5523-.4477 1-1 1s-1-.4477-1-1V5H9v1c0 .5523-.4477 1-1 1s-1-.4477-1-1m5 6c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const CalendarPlus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 15c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1v-2h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 1c.5523 0 1 .4477 1 1v1.0016c.4755.0033.891.0131 1.2518.0426.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 7.2894 22 7.9537 22 8.7587v4.4868a.2546.2546 0 0 1-.2545.2545c-.0909 0-.1742-.0489-.2235-.1253C20.9879 12.5476 20.0579 12 19 12c-1.6569 0-3 1.3431-3 3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3q.0002.2065.0272.4057c.1045.7727.1567 1.1591.1086 1.2806-.0574.145-.0839.1754-.2198.2518-.1139.064-.3874.0643-.9345.0649-2.4076.0025-4.8152-.003-7.2228-.003-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 18.7106 2 18.0463 2 17.2413V8.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918.3608-.0295.7763-.0393 1.2518-.0426V2c0-.5523.4477-1 1-1s1 .4477 1 1v1h6V2c0-.5523.4477-1 1-1M7 5.0018V6c0 .5523.4477 1 1 1s1-.4477 1-1V5h6v1c0 .5523.4477 1 1 1s1-.4477 1-1v-.9982c.4455.003.7954.0118 1.089.0358.4384.0358.6626.1007.819.1804.3763.1917.6823.4977.874.874.0797.1564.1446.3806.1804.819C19.9992 7.3611 20 7.9434 20 8.8V9H4v-.2c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804.2936-.024.6435-.0327 1.089-.0358"
      clipRule="evenodd"
    />
  </svg>
);

export const Clock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11-4.9249 11-11 11S1 18.0751 1 12m12-6c0-.5523-.4477-1-1-1s-1 .4477-1 1v6a1 1 0 0 0 .5528.8944l4 2c.494.247 1.0946.0468 1.3416-.4472s.0468-1.0946-.4472-1.3416L13 11.382z"
      clipRule="evenodd"
    />
  </svg>
);

export const ClockCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.7071 16.7929c.3905.3905.3905 1.0237 0 1.4142l-4.5 4.5c-.3905.3905-1.0237.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L17.5 20.5858l3.7929-3.7929c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11c.373 0 .7416-.0186 1.1051-.0548.0301-.003-.0453.0045-.0382.0036.3861-.0497.567-.5563.2997-.8393-.0049-.0051.0234.0231.0121.0118-1.1716-1.1716-1.1716-3.071 0-4.2426 1.1308-1.1309 2.9399-1.1702 4.1179-.1179l2.3821-2.3821a2.99 2.99 0 0 1 2.0255-.8772c.3547-.0112.5321-.0169.6266-.0619.0951-.0453.1469-.0907.2043-.1791.057-.0878.0775-.2121.1184-.4608A11.1 11.1 0 0 0 23 12c0-6.0751-4.9249-11-11-11m0 4c.5523 0 1 .4477 1 1v5.382l3.4472 1.7236c.494.247.6942.8476.4472 1.3416s-.8476.6942-1.3416.4472l-4-2A1 1 0 0 1 11 12V6c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ClockFastForward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 4c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8c2.5127 0 4.7544-1.1573 6.2226-2.9717.3474-.4293.9771-.4957 1.4064-.1483s.4958.9771.1484 1.4064C17.9457 20.5499 15.1418 22 12 22 6.4772 22 2 17.5228 2 12S6.4772 2 12 2c5.1343 0 9.3648 3.8693 9.9347 8.851l.058-.058c.3905-.3906 1.0237-.3907 1.4143-.0002s.3906 1.0236.0002 1.4142l-1.9994 2a1 1 0 0 1-1.4143.0002l-2.0006-2c-.3905-.3905-.3906-1.0236-.0002-1.4142s1.0237-.3907 1.4143-.0002l.5678.5677C19.649 7.2412 16.203 4 12 4"
    />
    <path
      fill="currentColor"
      d="M13 7c0-.5523-.4477-1-1-1s-1 .4477-1 1v5a1 1 0 0 0 .4453.8321l3 2c.4595.3063 1.0804.1821 1.3868-.2774s.1821-1.0804-.2774-1.3868L13 11.4648z"
    />
  </svg>
);

export const ClockPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12C1 5.9249 5.9249 1 12 1s11 4.9249 11 11c0 .583-.0454 1.1555-.1327 1.714-.0728.4649-.1092.6974-.2014.8051-.0988.1155-.1663.1519-.3171.1709-.1407.0178-.4631-.1288-1.108-.4222A2.99 2.99 0 0 0 20 14c-1.6569 0-3 1.3431-3 3-1.6569 0-3 1.3431-3 3 0 .4425.0958.8627.2678 1.2408.2934.6449.44.9673.4222 1.108-.019.1508-.0554.2183-.1709.3171-.1077.0922-.3402.1286-.8051.2014A11.1 11.1 0 0 1 12 23C5.9249 23 1 18.0751 1 12m12-6c0-.5523-.4477-1-1-1s-1 .4477-1 1v6a1 1 0 0 0 .5528.8944l4 2c.494.247 1.0946.0468 1.3416-.4472s.0468-1.0946-.4472-1.3416L13 11.382z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M21 17c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1v-2h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2z"
    />
  </svg>
);

export const ClockRewind = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 4c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8c3.7912 0 6.9664-2.6371 7.7914-6.1771l-.3844.3843c-.3906.3905-1.0238.3904-1.4143-.0002s-.3903-1.0237.0002-1.4142l2.0006-2a1.0004 1.0004 0 0 1 1.4143.0002l1.9994 2c.3904.3906.3903 1.0237-.0002 1.4142-.3906.3905-1.0238.3904-1.4143-.0002l-.1951-.1952C20.8665 18.5704 16.8338 22 12 22 6.4772 22 2 17.5228 2 12S6.4772 2 12 2c3.67 0 6.8771 1.9776 8.6155 4.9205.2809.4755.1231 1.0887-.3524 1.3696s-1.0887.1231-1.3696-.3524C17.5 5.5787 14.9338 4 12 4"
    />
    <path
      fill="currentColor"
      d="M13 7c0-.5523-.4477-1-1-1s-1 .4477-1 1v5a1 1 0 0 0 .4453.8321l3 2c.4595.3063 1.0804.1821 1.3868-.2774s.1821-1.0804-.2774-1.3868L13 11.4648z"
    />
  </svg>
);

export const ClockSnooze = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 19c-.5523 0-1-.4477-1-1s.4477-1 1-1h4a1 1 0 0 1 .7071 1.7071L20.4142 21H22c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4a1 1 0 0 1-.7071-1.7071L19.5858 19z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11c.805 0 1.5897-.0865 2.3455-.2506.2277-.0495.3415-.0742.423-.1305.0819-.0566.1244-.1066.1671-.1965.0426-.0895.0512-.253.0685-.58A3 3 0 0 1 15.7639 20 2.99 2.99 0 0 1 15 18c0-1.6569 1.3431-3 3-3h4c.1629 0 .2443 0 .2867-.0073.1858-.0322.3018-.1244.3752-.2981.0167-.0396.0288-.0915.0529-.1953A11.03 11.03 0 0 0 23 12c0-6.0751-4.9249-11-11-11m0 4c.5523 0 1 .4477 1 1v5.382l3.4472 1.7236c.494.247.6942.8476.4472 1.3416s-.8476.6942-1.3416.4472l-4-2A1 1 0 0 1 11 12V6c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ClockStopwatch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 1c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v1.052c-4.7767.4997-8.5 4.539-8.5 9.448 0 5.2467 4.2533 9.5 9.5 9.5s9.5-4.2533 9.5-9.5c0-4.909-3.7233-8.9483-8.5-9.448V3h1c.5523 0 1-.4477 1-1s-.4477-1-1-1zm3 8.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v4a1 1 0 0 0 .4855.8575l2.5 1.5c.4736.2841 1.0878.1306 1.372-.343s.1306-1.0878-.343-1.372L13 12.9338z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.122 3.3847c.3905-.3905 1.0237-.3905 1.4142 0l1.5 1.5c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-1.5-1.5c-.3905-.3905-.3905-1.0237 0-1.4142M5.878 3.3847c.3905.3905.3905 1.0237 0 1.4142l-1.5 1.5c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l1.5-1.5c.3905-.3905 1.0237-.3905 1.4142 0"
    />
  </svg>
);

export const Hourglass01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 2c0-.5523.4477-1 1-1h16c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.9999v1.8671c.0004.7143.0007 1.2538-.1374 1.767a4 4 0 0 1-.5915 1.2629c-.3058.4345-.7204.7797-1.2695 1.2367L13.5621 12l3.4397 2.8663c.549.457.9636.8022 1.2694 1.2367.2696.3831.4698.8106.5915 1.2629.1381.5132.1378 1.0527.1374 1.767V21H20c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1s.4477-1 1-1h1v-1.8671c-.0003-.7143-.0006-1.2538.1374-1.767a4 4 0 0 1 .5915-1.2629c.3059-.4345.7205-.7797 1.2695-1.2367L10.438 12 6.9984 9.1337c-.549-.457-.9636-.8022-1.2695-1.2367a4 4 0 0 1-.5915-1.263C4.9994 6.121 4.9997 5.5815 5 4.867V3H4c-.5523 0-1-.4477-1-1m4 2.7518V3h10.0001v1.7518c0 .8805-.0081 1.1373-.0687 1.3627a2 2 0 0 1-.2957.6314c-.1344.1909-.3265.3615-1.0029.9251l-3.6327 3.0273L8.3674 7.671c-.6764-.5636-.8686-.7342-1.0029-.925a2 2 0 0 1-.2957-.6315C7.008 5.889 7 5.6323 7 4.7518"
      clipRule="evenodd"
    />
  </svg>
);

export const Hourglass02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m15.4142 12 1.3495-1.3495A11.05 11.05 0 0 0 20 2.8375C20 1.8226 19.1773 1 18.1626 1H5.8374C4.8227 1 4 1.8227 4 2.8374a11.05 11.05 0 0 0 3.2363 7.8131L8.5858 12l-1.3495 1.3495A11.05 11.05 0 0 0 4 21.1626C4 22.1773 4.8227 23 5.8374 23h12.3252C19.1773 23 20 22.1773 20 21.1626a11.05 11.05 0 0 0-3.2363-7.8131zM13 10.999c.1756.0001.2635.0001.3534-.0164a1.03 1.03 0 0 0 .3862-.1599c.0753-.0518.137-.1135.2604-.2369l1.3495-1.3495a9.05 9.05 0 0 0 2.4738-4.619c.0919-.458.1378-.687.0491-.9438-.0698-.202-.2549-.4279-.4391-.536C17.1989 3 16.9225 3 16.3696 3H7.6304c-.5529 0-.8293 0-1.0637.1375-.1842.1081-.3693.334-.439.536-.0888.2568-.0429.4858.049.9439a9.05 9.05 0 0 0 2.4738 4.6189L10 10.5858c.122.122.183.183.2572.2344.1134.0785.2542.1368.3898.1616.0887.0161.1756.0162.3492.0162z"
      clipRule="evenodd"
    />
  </svg>
);

export const Hourglass03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5682 1c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698C4 3.0699 4 3.3158 4 3.568v2.1897c-.0004.407-.0008.7657.0829 1.1141a3 3 0 0 0 .3592.8672c.1872.3055.4411.559.7291.8464L8.586 12l-3.4146 3.4145c-.288.2875-.5419.5409-.7291.8464a3 3 0 0 0-.3592.8672c-.0837.3484-.0833.7072-.083 1.1141l.0001 2.1897c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.2011.208.017.4538.0169.7062.0169H17.432c.2524 0 .4982.0001.7063-.0169.2286-.0187.4984-.0628.7698-.2011a2 2 0 0 0 .874-.874c.1383-.2714.1824-.5412.2011-.7698.017-.2081.0169-.4539.0169-.7063l.0001-2.1897c.0003-.4069.0007-.7657-.083-1.1141a3 3 0 0 0-.3592-.8672c-.1872-.3055-.4411-.5589-.7291-.8464L15.4143 12l3.4146-3.4145c.288-.2874.5419-.5409.7291-.8464a3 3 0 0 0 .3592-.8672c.0837-.3484.0833-.7072.083-1.114l-.0001-2.1898c0-.2523.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C17.9302 1 17.6844 1 17.432 1zm10.7875 6.2302-3.3012 3.3012c-.1729.1729-.2594.2594-.3603.3212a1 1 0 0 1-.2891.1198C13.29 11 13.1677 11 12.9231 11h-1.846c-.2446 0-.3669 0-.482-.0276a1 1 0 0 1-.2891-.1198c-.1009-.0618-.1874-.1483-.3603-.3212L6.6445 7.2302c-.3796-.3796-.4496-.4587-.497-.5361a1 1 0 0 1-.1198-.289c-.0212-.0884-.0276-.1938-.0276-.7306V3.6c0-.2965.0008-.4588.0103-.5754l.0011-.0131.0132-.0012C6.1413 3.0008 6.3036 3 6.6001 3h10.8c.2965 0 .4588.0008.5754.0103l.0132.0011.0011.0132c.0095.1166.0103.2789.0103.5754v2.0745c0 .5368-.0064.6422-.0276.7305a1 1 0 0 1-.1198.289c-.0474.0775-.1174.1566-.497.5362M9 17.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const ClockRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m19.5407 5.675-.1087.4055C16.553 2.4568 11.3788 1.3892 7.2501 3.773c-2.7355 1.5793-4.3878 4.3145-4.698 7.2286-.0584.5491.3394 1.0417.8886 1.1002s1.0418-.3394 1.1002-.8886c.2454-2.3057 1.5507-4.462 3.7092-5.7082 3.1559-1.822 7.0855-1.0898 9.3951 1.5552l-.3439-.0922c-.5335-.143-1.0818.1736-1.2247.7071-.143.5335.1736 1.0818.7071 1.2247l2.732.7321c.5335.143 1.0818-.1736 1.2248-.7071l.732-2.732c.143-.5335-.1736-1.0819-.7071-1.2248s-1.0818.1736-1.2247.7071M20.5594 11.8984c.5492.0585.947.5511.8885 1.1002-.3101 2.9141-1.9624 5.6493-4.6979 7.2286-4.1288 2.3838-9.3031 1.3161-12.182-2.3078l-.1087.4052c-.1429.5335-.6912.85-1.2247.7071s-.85-.6913-.7071-1.2247l.732-2.7321c.143-.5335.6913-.85 1.2248-.7071l2.732.7321c.5335.1429.85.6912.7071 1.2247s-.6912.85-1.2247.7071l-.3444-.0923c2.3096 2.6455 6.2396 3.3779 9.3957 1.5558 2.1584-1.2462 3.4637-3.4025 3.7092-5.7082.0584-.5492.551-.947 1.1002-.8886"
    />
    <path
      fill="currentColor"
      d="M13.0001 7.5c0-.5523-.4478-1-1-1s-1 .4477-1 1v4.4999a1 1 0 0 0 .4855.8575l2.5 1.5c.4735.2842 1.0878.1306 1.3719-.343.2842-.4736.1306-1.0878-.343-1.372l-2.0144-1.2087z"
    />
  </svg>
);

export const WatchCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.4105 1h-2.8211c-.4382 0-.8205 0-1.1394.0237-.3396.0252-.6766.0808-1.0118.2274a3 3 0 0 0-1.2586 1.0317c-.2094.3-.33.6195-.4214.9477-.0858.308-.1607.6828-.2467 1.1126l-.4619 2.3096C4.7754 8.0697 4 9.9443 4 12s.7754 3.9303 2.0496 5.3473l.462 2.3098c.0859.4298.1608.8046.2466 1.1126.0914.3282.212.6477.4214.9477a3 3 0 0 0 1.2586 1.0317c.3352.1465.6722.2022 1.0118.2274.319.0237.7011.0237 1.1394.0237h2.8211c.4383 0 .8204 0 1.1394-.0237.3396-.0252.6766-.0809 1.0118-.2274a3 3 0 0 0 1.2586-1.0317c.2094-.3.33-.6195.4214-.9477.0858-.308.1607-.6827.2466-1.1124l.462-2.3099C19.2246 15.9304 20 14.0558 20 12s-.7754-3.9305-2.0497-5.3475l-.462-2.3096c-.0859-.4297-.1608-.8044-.2466-1.1124-.0914-.3282-.212-.6477-.4214-.9477a3 3 0 0 0-1.2586-1.0317c-.3352-.1466-.6722-.2022-1.0118-.2274C14.231 1 13.8487 1 13.4105 1M12 4c-1.2732 0-2.477.2974-3.5456.8266l.0116-.058c.0946-.4727.1554-.7738.2189-1.0016.06-.2157.1049-.2967.1347-.3394a1 1 0 0 1 .4195-.344c.0477-.0208.1359-.0488.3592-.0654.2359-.0176.543-.0182 1.025-.0182h2.7533c.4819 0 .7891.0006 1.025.0182.2233.0166.3115.0446.3592.0655a1 1 0 0 1 .4195.344c.0298.0426.0746.1236.1347.3393.0635.2278.1243.529.2189 1.0016l.0116.058C14.4769 4.2974 13.2732 4 12 4M8.466 19.2316l-.0116-.0582C9.523 19.7026 10.7268 20 12 20s2.4769-.2974 3.5455-.8266l-.0116.0582c-.0946.4727-.1554.7738-.2189 1.0016-.0601.2157-.1049.2967-.1347.3394a1 1 0 0 1-.4195.3439c-.0477.0209-.1359.0489-.3592.0655-.2359.0176-.5431.0182-1.025.0182h-2.7533c-.482 0-.7891-.0006-1.025-.0182-.2233-.0166-.3115-.0446-.3592-.0655a1 1 0 0 1-.4195-.3439c-.0298-.0427-.0746-.1237-.1347-.3394-.0635-.2278-.1243-.5289-.2189-1.0016M13 9c0-.5523-.4477-1-1-1s-1 .4477-1 1v3c0 .2652.1054.5196.2929.7071l1.5 1.5c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L13 11.5858z"
      clipRule="evenodd"
    />
  </svg>
);

export const WatchSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.4138.9998 10.262.9997c-.7123-.0011-1.337-.0021-1.8877.2228a3 3 0 0 0-1.2245.9237c-.3676.4677-.5382 1.0686-.7329 1.7538l-.0415.146-.2208.7726-.0166.0084a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C4.5 7.6795 4.5 8.1343 4.5 8.6614v6.6772c0 .5271 0 .9819.0306 1.3564.0323.3954.1036.7886.2964 1.167a3 3 0 0 0 1.311 1.311l.0168.0085.2206.7721.0415.146c.1947.6852.3653 1.2861.733 1.7538a3 3 0 0 0 1.2244.9237c.5507.2249 1.1754.2239 1.8877.2228l.1518-.0001h3.1725l.1518.0001c.7122.0011 1.3369.0021 1.8876-.2228a3 3 0 0 0 1.2245-.9237c.3676-.4677.5383-1.0686.7329-1.7538l.0416-.146.2206-.7721.0167-.0085a3 3 0 0 0 1.311-1.311c.1928-.3784.2641-.7716.2964-1.167.0306-.3745.0306-.8293.0306-1.3565v-6.677c0-.5272 0-.982-.0306-1.3565-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311l-.0166-.0084-.2207-.7726-.0416-.146c-.1946-.6852-.3653-1.286-.7329-1.7538a3 3 0 0 0-1.2245-.9237c-.5507-.2249-1.1754-.224-1.8876-.2228l-.1518.0001zM8.6613 4.5q-.1731 0-.3356.0003c.24-.8355.3081-1.0057.3967-1.1184a1 1 0 0 1 .4081-.3078c.1375-.0562.3285-.0743 1.2833-.0743h3.1725c.9547 0 1.1457.018 1.2832.0743a1 1 0 0 1 .4082.3078c.0885.1127.1566.2829.3967 1.1184Q15.5118 4.5 15.3387 4.5zm.061 16.1177c-.0885-.1127-.1566-.2828-.3965-1.118q.1626.0004.3356.0003h6.6772q.1731 0 .3356-.0003c-.2399.8352-.308 1.0053-.3965 1.118a1 1 0 0 1-.4082.3078c-.1375.0562-.3285.0743-1.2832.0743h-3.1725c-.9548 0-1.1458-.0181-1.2833-.0743a1 1 0 0 1-.4081-.3078M13 9c0-.5523-.4477-1-1-1s-1 .4477-1 1v3c0 .2652.1054.5196.2929.7071l1.5 1.5c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L13 11.5858z"
      clipRule="evenodd"
    />
  </svg>
);

export const File01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v10.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C16.7106 23 16.0463 23 15.2413 23H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9537 1 8.7587 1"
      clipRule="evenodd"
    />
  </svg>
);

export const File02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1M8 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const File03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1M13 8c0-.5523-.4477-1-1-1s-1 .4477-1 1v10c0 .5523.4477 1 1 1s1-.4477 1-1zm3 3c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1m-8 2c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const File04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.9989 1.9523A1 1 0 0 1 13 2.0156v4.4163c0 .2524-.0001.4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2714.1383.5412.1824.7698.201.2081.017.4539.017.7063.017h4.4164c.0262 0 .0393 0 .0632.0012.4938.0235.9279.4578.9512.9516A1 1 0 0 1 21 10v7.2414c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C16.7106 23 16.0463 23 15.2413 23H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9537 1 8.7587 1H12c.0156 0 .0234 0 .0473.0011.4937.0234.928.4574.9516.9512"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.4686 6.9263C19.3484 7 19.2016 7 18.908 7H15.8c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2186C15 6.62 15 6.48 15 6.2V3.092c0-.2936 0-.4404.0737-.5607.1042-.1698.3495-.2713.5432-.2248.1371.033.2328.1287.4241.3202l3.3323 3.3323c.1915.1913.2872.287.3202.4241.0465.1937-.055.439-.2249.5432"
    />
  </svg>
);

export const File05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zM8 13c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1zm0 4c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7z"
    />
  </svg>
);

export const File06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zM18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7zM8 9c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const File07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zM13 11.5c0-.5523-.4477-1-1-1s-1 .4477-1 1V19c0 .5523.4477 1 1 1s1-.4477 1-1zm3 1.5c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1s-1-.4477-1-1v-5c0-.5523.4477-1 1-1m-8 2c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7z"
    />
  </svg>
);

export const FileAttachment01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 3a.5.5 0 0 0-.5.5V9c0 .5523-.4477 1-1 1s-1-.4477-1-1V3.5C4 2.1193 5.1193 1 6.5 1S9 2.1193 9 3.5V9c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4V5c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 1.1046.8954 2 2 2s2-.8954 2-2V3.5a.5.5 0 0 0-.5-.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M4.0959 14.9323c-.4345-.0656-.6517-.0985-.775-.0512-.1203.0462-.192.1079-.2557.22C3 15.2159 3 15.4072 3 15.7898v1.4515c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1h-3.5009c-.4896 0-.7344 0-.8543.0732-.1249.0762-.1762.1425-.2183.2827-.0405.1345.0351.4243.1865 1.004.0951.364.1457.7462.1457 1.1401V9c0 3.3137-2.6863 6-6 6a6.04 6.04 0 0 1-.9041-.0677"
    />
  </svg>
);

export const FileAttachment02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.0959 14.9323A6.04 6.04 0 0 0 5 15c3.3137 0 6-2.6863 6-6V3.5c0-.394-.0506-.776-.1457-1.1402-.1514-.5796-.227-.8694-.1865-1.004.0421-.14.0934-.2064.2183-.2826C11.006 1 11.2508 1 11.7404 1h3.5009c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v10.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C16.7106 23 16.0463 23 15.2413 23H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413v-1.4515c0-.3826 0-.5739.0652-.6887.0636-.1121.1354-.1738.2557-.22.1233-.0473.3405-.0144.775.0512M12.5 10c0-.5523.4477-1 1-1H17c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3.5c-.5523 0-1-.4477-1-1m-1 4c0-.5523.4477-1 1-1H17c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4.5c-.5523 0-1-.4477-1-1M9 17c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M6 3.5a.5.5 0 0 1 1 0V9c0 1.1046-.8954 2-2 2s-2-.8954-2-2V5c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 2.2091 1.7909 4 4 4s4-1.7909 4-4V3.5C9 2.1193 7.8807 1 6.5 1S4 2.1193 4 3.5V9c0 .5523.4477 1 1 1s1-.4477 1-1z"
    />
  </svg>
);

export const FileAttachment03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.5 13a.5.5 0 0 0-.5.5V19c0 .5523-.4477 1-1 1s-1-.4477-1-1v-5.5c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5V19c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4v-4c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 1.1046.8954 2 2 2s2-.8954 2-2v-5.5a.5.5 0 0 0-.5-.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v1.7678c0 .2673-.2327.4735-.5.4735-1.9632 0-3.6328 1.2572-4.2476 3.0105A3 3 0 0 0 16 12c-1.6569 0-3 1.3431-3 3v4c0 .8961.1964 1.7463.5486 2.5099.2833.6142.4249.9214.3989 1.0741-.0262.1539-.0814.2401-.2102.3284C13.6095 23 13.319 23 12.7381 23H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9537 1 8.7587 1"
    />
  </svg>
);

export const FileAttachment04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h3.9794c.5809 0 .8714 0 .9992-.0876.1288-.0883.184-.1745.2102-.3284.026-.1527-.1156-.4599-.3989-1.0741C13.1964 20.7463 13 19.8961 13 19v-4c0-1.6569 1.3431-3 3-3q.1275 0 .2524.0105C16.8672 10.2572 18.5368 9 20.5 9c.2673 0 .5-.2062.5-.4735V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1M7 9c-.5523 0-1 .4477-1 1s.4477 1 1 1h4.5c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h3.5c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1m1-9c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20 13.5a.5.5 0 0 1 1 0V19c0 1.1046-.8954 2-2 2s-2-.8954-2-2v-4c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 2.2091 1.7909 4 4 4s4-1.7909 4-4v-5.5c0-1.3807-1.1193-2.5-2.5-2.5S18 12.1193 18 13.5V19c0 .5523.4477 1 1 1s1-.4477 1-1z"
    />
  </svg>
);

export const FileAttachment05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1M13 8.5a.5.5 0 0 1 1 0V14c0 1.1046-.8954 2-2 2s-2-.8954-2-2v-4c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 2.2091 1.7909 4 4 4s4-1.7909 4-4V8.5C16 7.1193 14.8807 6 13.5 6S11 7.1193 11 8.5V14c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const FileCheck01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.7071 16.7929c.3905.3905.3905 1.0237 0 1.4142l-4.5 4.5c-.3905.3905-1.0237.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L17.5 20.5858l3.7929-3.7929c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v7.346c0 .1973 0 .2959-.0242.3708-.0254.0786-.048.1179-.1029.1795-.0525.0587-.1636.1237-.3858.2536a3 3 0 0 0-.6084.4701l-2.3821 2.3821c-1.178-1.0523-2.9871-1.013-4.1179.1179-1.1716 1.1716-1.1716 3.071 0 4.2426.0208.0209.0312.0313.0372.0376.2925.3136.0804.8259-.3483.8408-.0087.0003-.0234.0003-.0529.0003h-4.256c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9537 1 8.7587 1"
    />
  </svg>
);

export const FileCheck02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h4.256c.0295 0 .0442 0 .0529-.0003.4287-.0149.6408-.5272.3483-.8408-.006-.0063-.0164-.0167-.0372-.0376-1.1716-1.1716-1.1716-3.071 0-4.2426 1.1308-1.1309 2.9399-1.1702 4.1179-.1179l2.3821-2.3821a3 3 0 0 1 .6084-.4701c.2222-.1299.3333-.1949.3858-.2536.0549-.0616.0775-.1009.1029-.1795C21 14.4006 21 14.302 21 14.1047v-7.346c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1M8 9c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1m1-9c-.5523 0-1 .4477-1 1s.4477 1 1 1h8c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M22.7071 18.2071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L17.5 20.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
    />
  </svg>
);

export const FileCheck03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zm3.2071 12.1915c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 16.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7z"
    />
  </svg>
);

export const FileDownload01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 16c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3a1 1 0 0 0 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L20 19.5858z"
    />
    <path
      fill="currentColor"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23c1.6915 0 3.3832.0033 5.0747.0026.6025-.0003.9037-.0005 1.0439-.1203a.5.5 0 0 0 .1736-.4194c-.0145-.1838-.2277-.397-.6541-.8235l-.5181-.5181c-1.1716-1.1716-1.1716-3.071 0-4.2426C14.4645 16.2929 15.2322 16 16 16c0-1.6569 1.3431-3 3-3q.2029.0001.3987.0263c.7766.1031 1.1649.1546 1.2862.1064.1451-.0578.1749-.0839.2513-.2201.0638-.1139.0638-.3887.0638-.9384V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1"
    />
  </svg>
);

export const FileDownload02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v5.2155c0 .5497 0 .8245-.0638.9384-.0764.1362-.1062.1623-.2513.2201-.1213.0482-.5096-.0033-1.2862-.1064A3 3 0 0 0 19 13c-1.6569 0-3 1.3431-3 3-.7678 0-1.5355.2929-2.1213.8787-1.1716 1.1716-1.1716 3.071 0 4.2426l.5181.5181c.4264.4265.6396.6397.6541.8235a.5.5 0 0 1-.1736.4194c-.1402.1198-.4414.12-1.0439.1203-.9331.0004-1.8662-.0004-2.7993-.0013C10.2756 23.0007 9.5171 23 8.7587 23c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9538 1 8.7587 1M7 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19 15c.5523 0 1 .4477 1 1v3.5858l1.2929-1.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-3 3a1 1 0 0 1-1.4142 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L18 19.5858V16c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const FileDownload03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zM12 12c.5523 0 1 .4477 1 1v3.5858l1.2929-1.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-3 3a1 1 0 0 1-1.4142 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L11 16.5858V13c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7z"
    />
  </svg>
);

export const FileHeart01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.9966 15.0382c-.9997-1.1362-2.6667-1.4418-3.9193-.4014s-1.4288 2.7801-.4452 4.0106c.7451.9322 2.8657 2.8062 3.8504 3.6603.1791.1553.2687.233.3731.2637a.51.51 0 0 0 .2819 0c.1045-.0307.194-.1084.3731-.2637.9847-.8541 3.1054-2.7281 3.8505-3.6603.9836-1.2305.8288-2.9811-.4453-4.0106s-2.9195-.7348-3.9192.4014"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v4.3587c0 .3261 0 .4891-.0522.5942-.0524.1054-.1069.1618-.2104.2176-.1033.0557-.2981.0622-.6876.0753-.718.024-1.4192.2149-2.0543.5418-1.5739-.8106-3.5652-.8027-5.1961.552-2.0734 1.7224-2.4076 4.6984-.7295 6.7978.4791.5994 1.3029 1.3961 2.0381 2.0775.1387.1286.2081.1929.2368.2324a.4973.4973 0 0 1-.3077.7846C13.9892 23 13.8968 23 13.7119 23H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9537 1 8.7587 1"
    />
  </svg>
);

export const FileHeart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.7587 1h6.4826c.8049 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v4.3587c0 .3261 0 .4891-.0522.5942-.0524.1054-.1069.1618-.2104.2176-.1033.0557-.2981.0622-.6876.0753-.718.024-1.4192.2149-2.0543.5418-1.5739-.8106-3.5652-.8027-5.1961.552-2.0734 1.7224-2.4076 4.6984-.7295 6.7978.4791.5994 1.3029 1.3961 2.0381 2.0775.1387.1286.2081.1929.2368.2324a.4973.4973 0 0 1-.3077.7846C13.9892 23 13.8968 23 13.7119 23H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9538 1 8.7587 1M7 8c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1m1-9c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M17.9966 15.0382c-.9997-1.1362-2.6667-1.4418-3.9193-.4014s-1.4288 2.7801-.4452 4.0106c.7451.9322 2.8657 2.8062 3.8504 3.6603.1791.1553.2687.233.3731.2637a.51.51 0 0 0 .2819 0c.1044-.0307.194-.1084.3731-.2637.9847-.8541 3.1054-2.7281 3.8505-3.6603.9836-1.2305.8288-2.9811-.4453-4.0106s-2.9195-.7348-3.9192.4014"
    />
  </svg>
);

export const FileHeart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zM8.8619 13.5095c1.002-.8324 2.3356-.5879 3.1354.3211.7997-.909 2.1161-1.1448 3.1353-.3211 1.0193.8236 1.1431 2.224.3562 3.2084-.5713.7148-2.1535 2.1218-2.9776 2.839-.1787.1555-.268.2333-.3726.2641a.51.51 0 0 1-.2826 0c-.1047-.0308-.194-.1086-.3727-.2641-.824-.7172-2.4063-2.1242-2.9776-2.839-.787-.9844-.6458-2.3761.3562-3.2084"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7z"
    />
  </svg>
);

export const FileMinus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 17c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.0612-.1201.0918-.1801.0987-.2821.0125-.1842-.1328-.4213-.3026-.4938C20.2661 20 20.1716 20 19.9828 20H15c-1.6569 0-3-1.3431-3-3s1.3431-3 3-3h5.2c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C21 13.62 21 13.48 21 13.2V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1"
    />
  </svg>
);

export const FileMinus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587V13.2c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C20.62 14 20.48 14 20.2 14H15c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3h4.9828c.1888 0 .2833 0 .3773.0401.1698.0725.3151.3096.3026.4938-.0069.102-.0375.162-.0987.282a4 4 0 0 1-1.748 1.7481c-.4854.2473-1.0021.3459-1.5642.3918C16.7106 23 16.0463 23 15.2413 23H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9538 1 8.7587 1M7 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M15 16c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const FileMinus03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zM9 15c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7z"
    />
  </svg>
);

export const FilePlus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 15c0-.5523-.4477-1-1-1s-1 .4477-1 1v2h-2c-.5523 0-1 .4477-1 1s.4477 1 1 1h2v2c0 .5523.4477 1 1 1s1-.4477 1-1v-2h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2z"
    />
    <path
      fill="currentColor"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23c2.0972 0 4.2016.0502 6.3012.0241.5167-.0064.775-.0096.8888-.0759.1323-.077.1633-.1139.2168-.2574.046-.1233-.012-.4872-.128-1.2149A3 3 0 0 1 16 21c-1.6569 0-3-1.3431-3-3s1.3431-3 3-3c0-1.6569 1.3431-3 3-3q.2029.0001.3987.0263c.7766.1031 1.1649.1546 1.2862.1064.1451-.0578.1749-.0839.2513-.2201.0638-.1139.0638-.3887.0638-.9384V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1"
    />
  </svg>
);

export const FilePlus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v4.2155c0 .5497 0 .8245-.0638.9384-.0764.1362-.1062.1623-.2513.2201-.1213.0482-.5096-.0033-1.2862-.1064A3 3 0 0 0 19 12c-1.6569 0-3 1.3431-3 3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3c0 .162.0128.3209.0375.4759.116.7277.174 1.0916.128 1.2149-.0535.1435-.0845.1804-.2168.2574-.1138.0663-.3721.0695-.8887.0759-1.2667.0157-2.5352.0037-3.8027-.0083C10.424 23.0079 9.5905 23 8.7587 23c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9538 1 8.7587 1M7 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19 14c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2h-2c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-2c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const FilePlus03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zM12 12c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7z"
    />
  </svg>
);

export const FileQuestion01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.9884 14.6721a1.248 1.248 0 0 1 1.5875.2723c.1899.2255.2938.511.2934.8058v.0015c0 .2186-.1772.5197-.6789.8542-.2204.1469-.4479.2614-.6243.3398a4.3 4.3 0 0 1-.2045.0847 2 2 0 0 1-.0504.0186l-.0092.0032.0011-.0003c-.5229.1752-.8053.7409-.6308 1.2643.1746.524.7409.8071 1.2649.6325l.0012-.0004.0428-.0149a4 4 0 0 0 .0923-.034c.0761-.029.1809-.071.3049-.1261.2452-.109.5797-.2755.9214-.5033.6223-.4149 1.569-1.2376 1.5695-2.5174a3.2484 3.2484 0 0 0-6.3126-1.0822c-.1833.521.0905 1.0919.6115 1.2752s1.0919-.0905 1.2752-.6115a1.25 1.25 0 0 1 .545-.662M18.65 20c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
    <path
      fill="currentColor"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.1618 0 .2428 0 .2603-.0012.3876-.0274.5498-.2562.4471-.6309-.0047-.017-.0464-.1357-.1298-.3731A3 3 0 0 1 15.65 21c0-.536.1406-1.0392.3869-1.4747a3 3 0 0 1-.2621-.5766 3 3 0 0 1-.152-1.0775 3 3 0 0 1-.1184-.039c-1.5629-.5498-2.3843-2.2625-1.8344-3.8255a5.2484 5.2484 0 0 1 6.1062-3.378c.4988.1126.7482.1689.8791.1261.1312-.0429.2034-.1007.2741-.2192C21 10.4173 21 10.2001 21 9.7658V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1"
    />
  </svg>
);

export const FileQuestion02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v3.0071c0 .4343 0 .6515-.0706.7698-.0707.1185-.1429.1763-.2741.2192-.1309.0428-.3803-.0135-.8791-.1261a5.2483 5.2483 0 0 0-6.1062 3.378c-.5499 1.563.2715 3.2757 1.8344 3.8255q.0591.0209.1184.039a3 3 0 0 0 .152 1.0775c.0684.205.1567.3977.2621.5766A2.986 2.986 0 0 0 15.65 21c0 .3487.0595.6835.1689.9948.0834.2374.1251.3561.1298.3731.1027.3747-.0595.6035-.4471.6309-.0175.0012-.0985.0012-.2603.0012H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9538 1 8.7587 1M7 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M17.9884 14.6721a1.248 1.248 0 0 1 1.5875.2723c.1899.2255.2938.511.2934.8058v.0015c0 .2186-.1772.5197-.6789.8542-.2204.1469-.4479.2614-.6243.3398a4.3 4.3 0 0 1-.2045.0847 2 2 0 0 1-.0504.0186l-.0081.0029c-.5229.1752-.8053.7409-.6308 1.2643.1746.524.7409.8071 1.2649.6325l.0012-.0004.0428-.0149a4 4 0 0 0 .0923-.034c.0761-.029.1809-.071.3049-.1261.2452-.109.5797-.2755.9214-.5033.6223-.4149 1.569-1.2376 1.5695-2.5174a3.2484 3.2484 0 0 0-6.3126-1.0822c-.1833.521.0905 1.0919.6115 1.2752s1.0919-.0905 1.2752-.6115a1.25 1.25 0 0 1 .545-.662M18.65 20c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const FileQuestion03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zm-.818 10.5024a1.248 1.248 0 0 0-1.3887.8161c-.1832.521-.7541.7947-1.2751.6115-.521-.1833-.7948-.7542-.6115-1.2752a3.2481 3.2481 0 0 1 5.5493-1.014 3.248 3.248 0 0 1 .7632 2.0957c-.0002 1.2801-.947 2.1029-1.5694 2.5179-.3417.2278-.6762.3943-.9214.5033a6 6 0 0 1-.3049.1261l-.1364.0493c-.5239.1746-1.0902-.1085-1.2649-.6325-.1744-.5234.108-1.0891.6309-1.2643l-.0011.0003.0092-.0032a2 2 0 0 0 .0503-.0186 4 4 0 0 0 .2046-.0847c.1763-.0784.4039-.1929.6243-.3398.5017-.3345.6788-.6356.6788-.8542v-.0015a1.248 1.248 0 0 0-1.0372-1.2322M11 19c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7z"
    />
  </svg>
);

export const FileX01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.7071 16.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L18.0858 19.5l-1.7929 1.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L19.5 20.9142l1.7929 1.7929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142L20.9142 19.5l1.7929-1.7929c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L19.5 18.0858z"
    />
    <path
      fill="currentColor"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v6.846c0 .1973 0 .2959-.0242.3708-.0254.0786-.048.1179-.1029.1795-.0525.0587-.1636.1237-.3858.2536a3 3 0 0 0-.6084.4701l-.3787.3787-.3787-.3787c-1.1716-1.1716-3.071-1.1716-4.2426 0s-1.1716 3.071 0 4.2426l.3787.3787-.3787.3787a2.99 2.99 0 0 0-.8767 2.0102c-.0183.4977-.0274.7465-.0833.8495-.0615.1133-.102.1523-.2174.2096-.105.052-.2903.052-.6609.052H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9537 1 8.7587 1"
    />
  </svg>
);

export const FileX02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h4.2817c.3706 0 .5559 0 .6609-.052.1154-.0573.1559-.0963.2174-.2096.0558-.103.065-.3518.0833-.8495a2.99 2.99 0 0 1 .8767-2.0102l.3787-.3787-.3787-.3787c-1.1716-1.1716-1.1716-3.071 0-4.2426s3.071-1.1716 4.2426 0l.3787.3787.3787-.3787a3 3 0 0 1 .6084-.4701c.2222-.1299.3333-.1949.3858-.2536.0549-.0616.0775-.1009.1029-.1795C21 13.9006 21 13.802 21 13.6047v-6.846c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1M7 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M16.2929 17.7071c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L19.5 18.0858l1.7929-1.7929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142L20.9142 19.5l1.7929 1.7929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L19.5 20.9142l-1.7929 1.7929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L18.0858 19.5z"
    />
  </svg>
);

export const FileX03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zM8.7929 12.2929c.3905-.3905 1.0237-.3905 1.4142 0L12 14.0858l1.7929-1.7929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142L13.4142 15.5l1.7929 1.7929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 16.9142l-1.7929 1.7929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L10.5858 15.5l-1.793-1.7929c-.3904-.3905-.3904-1.0237 0-1.4142"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7z"
    />
  </svg>
);

export const FileSearch01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 13.5c-2.4853 0-4.5 2.0147-4.5 4.5s2.0147 4.5 4.5 4.5c.8805 0 1.702-.2529 2.3957-.69l.8972.8971c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-.8971-.8972A4.48 4.48 0 0 0 22.5 18c0-2.4853-2.0147-4.5-4.5-4.5M15.5 18c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5-1.1193 2.5-2.5 2.5-2.5-1.1193-2.5-2.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.7587 1h6.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C21 5.2894 21 5.9537 21 6.7587v4.1544c0 .4402 0 .6602-.0748.7811-.073.118-.1547.1797-.288.2178-.1368.039-.3781-.0295-.8608-.1663A6.5 6.5 0 0 0 18 11.5c-3.5899 0-6.5 2.9101-6.5 6.5 0 1.2156.3337 2.3533.9145 3.3264.4209.7053.6314 1.0579.6159 1.2208-.0157.1658-.0678.2576-.2021.356-.132.0968-.4863.0968-1.195.0968H8.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7106 3 18.0463 3 17.2413V6.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C7.2894 1 7.9537 1 8.7587 1"
    />
  </svg>
);

export const FileSearch02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h2.8746c.7087 0 1.063 0 1.195-.0968.1343-.0984.1864-.1902.2021-.356.0155-.1629-.195-.5155-.6159-1.2208C11.8337 20.3533 11.5 19.2156 11.5 18c0-3.5899 2.9101-6.5 6.5-6.5.6159 0 1.2118.0857 1.7764.2457.4827.1368.724.2053.8608.1663.1333-.0381.215-.0998.288-.2178.0748-.1209.0748-.3409.0748-.7811V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1M7 5c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-1 5c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1m0 4c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.5 18c0-2.4853 2.0147-4.5 4.5-4.5s4.5 2.0147 4.5 4.5c0 .8805-.2529 1.702-.69 2.3957l.8971.8972c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-.8972-.8971A4.48 4.48 0 0 1 18 22.5c-2.4853 0-4.5-2.0147-4.5-4.5m4.5-2.5c-1.3807 0-2.5 1.1193-2.5 2.5s1.1193 2.5 2.5 2.5 2.5-1.1193 2.5-2.5-1.1193-2.5-2.5-2.5"
      clipRule="evenodd"
    />
  </svg>
);

export const FileSearch03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 13c-1.3807 0-2.5 1.1193-2.5 2.5S10.6193 18 12 18s2.5-1.1193 2.5-2.5S13.3807 13 12 13"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2.0156c0-.0263 0-.0395-.0011-.0633-.0236-.4938-.4579-.9278-.9516-.9512C12.0234 1 12.0156 1 12 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V9.9999c0-.0155 0-.0233-.0011-.047-.0233-.494-.4574-.9282-.9512-.9517C20.0238 9 20.0107 9 19.9845 9h-4.4164c-.2524 0-.4982 0-.7063-.017-.2286-.0186-.4984-.0627-.7698-.201a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.0171-.2081-.017-.454-.017-.7063zM7.5 15.5c0-2.4853 2.0147-4.5 4.5-4.5s4.5 2.0147 4.5 4.5c0 .8805-.2529 1.702-.69 2.3957l.8971.8972c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-.8972-.8971A4.48 4.48 0 0 1 12 20c-2.4853 0-4.5-2.0147-4.5-4.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.908 7c.2936 0 .4404 0 .5606-.0737.1699-.1042.2714-.3495.2249-.5432-.033-.1371-.1287-.2328-.3202-.424L16.041 2.6266c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C15 2.6516 15 2.7984 15 3.092V6.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2184C15.38 7 15.52 7 15.8 7z"
    />
  </svg>
);

export const Folder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964.3745-.0306.8293-.0306 1.3565-.0306h3.9852c.5935-.0009 1.1155-.0016 1.5954.164.4204.145.8033.3816 1.121.6928.3627.3552.5955.8224.8603 1.3536L13.6179 6h3.6234c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C23 10.2894 23 10.9537 23 11.7587v4.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 22 18.0463 22 17.2413 22H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 17.7106 1 17.0463 1 16.2413zm8.0223-2.1615c.7904 0 .947.013 1.0677.0547.1401.0483.2678.1272.3737.2309.0911.0893.1729.2236.5263.9306L11.3819 6H3.0001c.0004-.465.0035-.7828.0238-1.032.0222-.2716.0599-.3723.0851-.4218a1 1 0 0 1 .437-.437c.0495-.0252.1502-.0629.4218-.085.2834-.0232.6557-.024 1.2322-.024z"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617v10.0796c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-3.6234l-.8945-1.7894c-.2648-.5312-.4976-.9984-.8603-1.3536a3 3 0 0 0-1.121-.6928c-.4799-.1656-1.0019-.1649-1.5954-.164H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1797 1 5.6346 1 6.1617m9.09-2.1068c-.1206-.0416-.2773-.0547-1.0677-.0547H5.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4219C3.0035 5.217 3.0004 5.535 3 6h8.3819l-.3919-.7836c-.3534-.707-.4352-.8413-.5263-.9306a1 1 0 0 0-.3737-.231m6.1171 8.1522c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 14.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617v10.0796c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-3.6234l-.8945-1.7894c-.2648-.5312-.4976-.9984-.8603-1.3536a3 3 0 0 0-1.121-.6928c-.4799-.1656-1.0019-.1649-1.5954-.164H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1797 1 5.6346 1 6.1617m9.09-2.1068c-.1206-.0416-.2773-.0547-1.0677-.0547H5.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4219C3.0035 5.217 3.0004 5.535 3 6h8.3819l-.3919-.7836c-.3534-.707-.4352-.8413-.5263-.9306a1 1 0 0 0-.3737-.231M12 10c.5523 0 1 .4477 1 1v3.5858l1.2929-1.2929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-3 3a1 1 0 0 1-1.4142 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L11 14.5858V11c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 11a.75.75 0 0 0-.75.75v.75h1.5v-.75A.75.75 0 0 0 12 11M9.5 15.7c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545h3.4c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-.4c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C14.12 14.5 13.98 14.5 13.7 14.5h-3.4c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C9.5 14.88 9.5 15.02 9.5 15.3z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617v10.0796c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-3.6234l-.8945-1.7894c-.2648-.5312-.4976-.9984-.8603-1.3536a3 3 0 0 0-1.121-.6928c-.4799-.1656-1.0019-.1649-1.5954-.164H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1797 1 5.6346 1 6.1617m9.09-2.1068c-.1206-.0416-.2773-.0547-1.0677-.0547H5.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4219C3.0035 5.217 3.0004 5.535 3 6h8.3819l-.3919-.7836c-.3534-.707-.4352-.8413-.5263-.9306a1 1 0 0 0-.3737-.231M9.25 11.75C9.25 10.2312 10.4812 9 12 9s2.75 1.2312 2.75 2.75v.778c.2025.024.4296.0736.658.19.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698.017.2081.0169.4539.0169.7063v.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-3.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698-.017-.2081-.017-.4539-.017-.7063v-.8638c0-.2524 0-.4982.017-.7063.0186-.2286.0627-.4984.201-.7698a2 2 0 0 1 .874-.874c.2284-.1164.4555-.166.658-.19z"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617v10.0796c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-3.6234l-.8945-1.7894c-.2648-.5312-.4976-.9984-.8603-1.3536a3 3 0 0 0-1.121-.6928c-.4799-.1656-1.0019-.1649-1.5954-.164H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1797 1 5.6346 1 6.1617m9.09-2.1068c-.1206-.0416-.2773-.0547-1.0677-.0547H5.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4219C3.0035 5.217 3.0004 5.535 3 6h8.3819l-.3919-.7836c-.3534-.707-.4352-.8413-.5263-.9306a1 1 0 0 0-.3737-.231M9 13c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617v10.0796c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-3.6234l-.8945-1.7894c-.2648-.5312-.4976-.9984-.8603-1.3536a3 3 0 0 0-1.121-.6928c-.4799-.1656-1.0019-.1649-1.5954-.164H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1797 1 5.6346 1 6.1617m9.09-2.1068c-.1206-.0416-.2773-.0547-1.0677-.0547H5.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4219C3.0035 5.217 3.0004 5.535 3 6h8.3819l-.3919-.7836c-.3534-.707-.4352-.8413-.5263-.9306a1 1 0 0 0-.3737-.231M12 10c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderQuestion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617v10.0796c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-3.6234l-.8945-1.7894c-.2648-.5312-.4976-.9984-.8603-1.3536a3 3 0 0 0-1.121-.6928c-.4799-.1656-1.0019-.1649-1.5954-.164H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1797 1 5.6346 1 6.1617m9.09-2.1068c-.1206-.0416-.2773-.0547-1.0677-.0547H5.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4219C3.0035 5.217 3.0004 5.535 3 6h8.3819l-.3919-.7836c-.3534-.707-.4352-.8413-.5263-.9306a1 1 0 0 0-.3737-.231m1.2485 7.3672a1.248 1.248 0 0 1 1.5875.2723c.1899.2255.2938.511.2934.8058v.0015c0 .2186-.1772.5197-.6789.8542-.2204.1469-.4479.2614-.6243.3398a4.3 4.3 0 0 1-.2045.0847 2 2 0 0 1-.0504.0186l-.0089.0031c-.5223.1757-.8044.7411-.63 1.2641.1746.524.7409.8071 1.2649.6325l.1363-.0493c.0761-.029.1809-.071.3049-.1261.2452-.109.5797-.2755.9214-.5033.6224-.415 1.5693-1.2378 1.5695-2.5179a3.2484 3.2484 0 0 0-6.3126-1.0817c-.1833.521.0905 1.0919.6115 1.2752s1.0919-.0905 1.2752-.6115a1.25 1.25 0 0 1 .545-.662M12 16.75c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.5 11C10.1193 11 9 12.1193 9 13.5s1.1193 2.5 2.5 2.5 2.5-1.1193 2.5-2.5-1.1193-2.5-2.5-2.5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617v10.0796c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-3.6234l-.8945-1.7894c-.2648-.5312-.4976-.9984-.8603-1.3536a3 3 0 0 0-1.121-.6928c-.4799-.1656-1.0019-.1649-1.5954-.164H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1797 1 5.6346 1 6.1617m9.09-2.1068c-.1206-.0416-.2773-.0547-1.0677-.0547H5.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4219C3.0035 5.217 3.0004 5.535 3 6h8.3819l-.3919-.7836c-.3534-.707-.4352-.8413-.5263-.9306a1 1 0 0 0-.3737-.231M7 13.5C7 11.0147 9.0147 9 11.5 9s4.5 2.0147 4.5 4.5c0 .8805-.2529 1.702-.69 2.3957l.8971.8972c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-.8972-.8971A4.48 4.48 0 0 1 11.5 18C9.0147 18 7 15.9853 7 13.5"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 11c-.4631 0-.9018.105-1.2934.2924l4.001 4.001A2.99 2.99 0 0 0 15 14c0-1.6569-1.3431-3-3-3M9 14c0-.4631.105-.9018.2924-1.2934l4.001 4.001A2.99 2.99 0 0 1 12 17c-1.6569 0-3-1.3431-3-3"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617v10.0796c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-3.6234l-.8945-1.7894c-.2648-.5312-.4976-.9984-.8603-1.3536a3 3 0 0 0-1.121-.6928c-.4799-.1656-1.0019-.1649-1.5954-.164H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1797 1 5.6346 1 6.1617m9.09-2.1068c-.1206-.0416-.2773-.0547-1.0677-.0547H5.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4219C3.0035 5.217 3.0004 5.535 3 6h8.3819l-.3919-.7836c-.3534-.707-.4352-.8413-.5263-.9306a1 1 0 0 0-.3737-.231M7 14c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.1617v10.0796c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C5.2894 22 5.9537 22 6.7587 22h10.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-3.6234l-.8945-1.7894c-.2648-.5312-.4976-.9984-.8603-1.3536a3 3 0 0 0-1.121-.6928c-.4799-.1656-1.0019-.1649-1.5954-.164H5.1615c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 5.1797 1 5.6346 1 6.1617m9.09-2.1068c-.1206-.0416-.2773-.0547-1.0677-.0547H5.2c-.5766 0-.9488.0008-1.2322.024-.2716.0221-.3723.0598-.4218.085a1 1 0 0 0-.437.437c-.0252.0495-.0629.1502-.085.4219C3.0035 5.217 3.0004 5.535 3 6h8.3819l-.3919-.7836c-.3534-.707-.4352-.8413-.5263-.9306a1 1 0 0 0-.3737-.231m-1.2971 6.738c.3905-.3905 1.0237-.3905 1.4142 0L12 12.5858l1.7929-1.7929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142L13.4142 14l1.7929 1.7929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 15.4142l-1.7929 1.7929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L10.5858 14l-1.793-1.7929c-.3904-.3905-.3904-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const Paperclip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.9705 4.182c-.9763-.9764-2.5592-.9764-3.5355 0l-9.0156 9.0156c-1.6598 1.6597-1.6598 4.3506 0 6.0104s4.3506 1.6597 6.0104 0l9.0156-9.0157c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4143l-9.0156 9.0156c-2.4408 2.4407-6.398 2.4407-8.8389 0-2.4407-2.4408-2.4407-6.3981 0-8.8389l9.0157-9.0156c1.7573-1.7573 4.6066-1.7573 6.3639 0 1.7574 1.7574 1.7574 4.6066 0 6.364l-8.662 8.662c-1.074 1.074-2.8152 1.074-3.8891 0s-1.074-2.8151 0-3.889l7.6014-7.6014c.3905-.3906 1.0237-.3906 1.4142 0s.3905 1.0237 0 1.4142l-7.6014 7.6014a.75.75 0 0 0 1.0607 1.0606l8.662-8.662c.9763-.9763.9763-2.5593 0-3.5356"
      clipRule="evenodd"
    />
  </svg>
);

export const Clipboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.5681 1c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1383.2714-.1824.5412-.201.7698a4 4 0 0 0-.0092.1463c-.395.0127-.7335.0454-1.043.1283a4 4 0 0 0-2.8284 2.8284C2.9993 6.4765 2.9996 7.0671 3 7.8625l.0001 9.3789c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.5412.0442 1.2055.0442 2.0105.0442h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642.0442-.5412.0442-1.2055.0442-2.0105V7.8625c.0005-.7954.0008-1.386-.1363-1.8977a4 4 0 0 0-2.8284-2.8284c-.3096-.083-.648-.1156-1.0432-.1284a4 4 0 0 0-.0091-.1462c-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201C14.9301 1 14.6843 1 14.4319 1zM9 4.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 3 10.04 3 10.6 3h2.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C15 3.76 15 4.04 15 4.6V5H9z"
      clipRule="evenodd"
    />
  </svg>
);

export const ClipboardAttachment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.8618 1.017C9.0699 1 9.3158 1 9.568 1h4.8638c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698q.0057.0706.0091.1462c.3952.0128.7336.0455 1.0432.1284a4 4 0 0 1 2.8284 2.8284c.1371.5117.1368 1.1023.1363 1.8977v9.3789c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918-.5412.0442-1.2055.0442-2.0105.0442H8.7588c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7107 3 18.0464 3 17.2414V7.8625c-.0005-.7954-.0008-1.386.1363-1.8977a4 4 0 0 1 2.8284-2.8284c.3095-.083.648-.1156 1.043-.1283a4 4 0 0 1 .0091-.1463c.0187-.2286.0628-.4984.201-.7698a2 2 0 0 1 .8741-.874c.2714-.1383.5412-.1824.7698-.201m.2472 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.2401 3 13.9601 3 13.4 3h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437M13 11a.5.5 0 0 1 1 0v4.5c0 1.1046-.8954 2-2 2s-2-.8954-2-2v-4c0-.5523-.4477-1-1-1s-1 .4477-1 1v4c0 2.2091 1.7909 4 4 4s4-1.7909 4-4V11c0-1.3807-1.1193-2.5-2.5-2.5S11 9.6193 11 11v4.5c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const ClipboardDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.8618 1.017C9.0699 1 9.3158 1 9.568 1h4.8638c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698q.0057.0706.0091.1462c.3952.0128.7336.0455 1.0432.1284a4 4 0 0 1 2.8284 2.8284c.1371.5117.1368 1.1023.1363 1.8977v9.3789c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918-.5412.0442-1.2055.0442-2.0105.0442H8.7588c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7107 3 18.0464 3 17.2414V7.8625c-.0005-.7954-.0008-1.386.1363-1.8977a4 4 0 0 1 2.8284-2.8284c.3095-.083.648-.1156 1.043-.1283a4 4 0 0 1 .0091-.1463c.0187-.2286.0628-.4984.201-.7698a2 2 0 0 1 .8741-.874c.2714-.1383.5412-.1824.7698-.201m.2472 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.2401 3 13.9601 3 13.4 3h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437M13 11c0-.5523-.4477-1-1-1s-1 .4477-1 1v3.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3 3a1 1 0 0 0 1.4142 0l3-3c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L13 14.5858z"
      clipRule="evenodd"
    />
  </svg>
);

export const ClipboardCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.8618 1.017C9.0699 1 9.3158 1 9.568 1h4.8638c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698q.0057.0706.0091.1462c.3952.0128.7336.0455 1.0432.1284a4 4 0 0 1 2.8284 2.8284c.1371.5117.1368 1.1023.1363 1.8977v9.3789c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918-.5412.0442-1.2055.0442-2.0105.0442H8.7588c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7107 3 18.0464 3 17.2414V7.8625c-.0005-.7954-.0008-1.386.1363-1.8977a4 4 0 0 1 2.8284-2.8284c.3095-.083.648-.1156 1.043-.1283a4 4 0 0 1 .0091-.1463c.0187-.2286.0628-.4984.201-.7698a2 2 0 0 1 .8741-.874c.2714-.1383.5412-.1824.7698-.201m.2472 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.2401 3 13.9601 3 13.4 3h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437m7.0981 9.6611c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L11 15.5858l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const ClipboardX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.8618 1.017C9.0699 1 9.3158 1 9.568 1h4.8638c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698q.0057.0706.0091.1462c.3952.0128.7336.0455 1.0432.1284a4 4 0 0 1 2.8284 2.8284c.1371.5117.1368 1.1023.1363 1.8977v9.3789c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918-.5412.0442-1.2055.0442-2.0105.0442H8.7588c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7107 3 18.0464 3 17.2414V7.8625c-.0005-.7954-.0008-1.386.1363-1.8977a4 4 0 0 1 2.8284-2.8284c.3095-.083.648-.1156 1.043-.1283a4 4 0 0 1 .0091-.1463c.0187-.2286.0628-.4984.201-.7698a2 2 0 0 1 .8741-.874c.2714-.1383.5412-.1824.7698-.201m.2472 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.2401 3 13.9601 3 13.4 3h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437m-.3161 7.7469c.3905-.3905 1.0237-.3905 1.4142 0L12 13.0858l1.7929-1.7929c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142L13.4142 14.5l1.7929 1.7929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 15.9142l-1.7929 1.7929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L10.5858 14.5l-1.793-1.7929c-.3904-.3905-.3904-1.0237 0-1.4142"
      clipRule="evenodd"
    />
  </svg>
);

export const ClipboardPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.8618 1.017C9.0699 1 9.3158 1 9.568 1h4.8638c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698q.0057.0706.0091.1462c.3952.0128.7336.0455 1.0432.1284a4 4 0 0 1 2.8284 2.8284c.1371.5117.1368 1.1023.1363 1.8977v9.3789c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918-.5412.0442-1.2055.0442-2.0105.0442H8.7588c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7107 3 18.0464 3 17.2414V7.8625c-.0005-.7954-.0008-1.386.1363-1.8977a4 4 0 0 1 2.8284-2.8284c.3095-.083.648-.1156 1.043-.1283a4 4 0 0 1 .0091-.1463c.0187-.2286.0628-.4984.201-.7698a2 2 0 0 1 .8741-.874c.2714-.1383.5412-.1824.7698-.201m.2472 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.2401 3 13.9601 3 13.4 3h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437M12 10c.5523 0 1 .4477 1 1v2h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2H9c-.5523 0-1-.4477-1-1s.4477-1 1-1h2v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ClipboardMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.8618 1.017C9.0699 1 9.3158 1 9.568 1h4.8638c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698q.0057.0706.0091.1462c.3952.0128.7336.0455 1.0432.1284a4 4 0 0 1 2.8284 2.8284c.1371.5117.1368 1.1023.1363 1.8977v9.3789c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918-.5412.0442-1.2055.0442-2.0105.0442H8.7588c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 18.7107 3 18.0464 3 17.2414V7.8625c-.0005-.7954-.0008-1.386.1363-1.8977a4 4 0 0 1 2.8284-2.8284c.3095-.083.648-.1156 1.043-.1283a4 4 0 0 1 .0091-.1463c.0187-.2286.0628-.4984.201-.7698a2 2 0 0 1 .8741-.874c.2714-.1383.5412-.1824.7698-.201m.2472 2.529C9 3.76 9 4.04 9 4.6V5h6v-.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.2401 3 13.9601 3 13.4 3h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437M9 13c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const StickerSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2.8c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C11.62 2 11.4803 2 11.2008 2H7.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C2 6.2894 2 6.9537 2 7.7587v8.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 22 6.9537 22 7.7587 22h8.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C22 17.7106 22 17.0463 22 16.2413v-3.4421c0-.2795 0-.4193-.0545-.5263a.5.5 0 0 0-.2185-.2185c-.107-.0545-.247-.0545-.527-.0545h-3.4413c-.805.0001-1.4693.0001-2.0105-.0441-.5621-.046-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C12 7.7106 12 7.0462 12 6.2413z"
    />
    <path
      fill="currentColor"
      d="M19.908 10c.2935 0 .4403 0 .5605-.0738.1699-.104.2715-.3494.2249-.5432-.033-.1371-.1287-.2327-.3201-.424L15.041 3.6267c-.1913-.1915-.287-.2872-.4241-.3202-.1937-.0465-.439.055-.5432.2248C14 3.6516 14 3.7984 14 4.0921v2.1078c0 .8566.0008 1.439.0376 1.889.0358.4384.1007.6626.1804.819.1917.3764.4977.6823.874.874.1564.0797.3806.1447.819.1805.4501.0368 1.0324.0375 1.889.0375z"
    />
  </svg>
);

export const StickerCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.7779 1C7.4251 1 3.0502 3.7858 1.4539 7.8853c-.1465.3763-.2198.5645-.1782.722a.505.505 0 0 0 .2558.3173c.145.0742.3791.037.8473-.0371A11.2 11.2 0 0 1 4.1324 8.75c6.1398 0 11.1171 4.9773 11.1171 11.1171 0 .5263-.0365 1.0441-.1072 1.5508-.0683.4891-.1024.7337-.024.8782a.501.501 0 0 0 .3272.2489c.1602.037.355-.0475.7447-.2163 3.9922-1.7301 6.7049-5.8098 6.7049-10.2116C22.8951 5.9773 17.9177 1 11.7779 1"
    />
    <path
      fill="currentColor"
      d="M11.9414 21.3943c.3044.3042.4566.4563.6292.4764.1397.0163.3077-.0412.4081-.1397.124-.1217.1487-.317.1982-.7074a9.2 9.2 0 0 0 .0726-1.1565c0-5.0352-4.0818-9.1171-9.117-9.1171-.3938 0-.7818.025-1.1624.0734-.3904.0497-.5856.0745-.7072.1987-.0985.1004-.1559.2684-.1395.4081.0202.1726.1724.3247.4768.6289z"
    />
  </svg>
);

export const Box = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 5c0-1.6568 1.3432-3 3-3h16c1.6569 0 3 1.3432 3 3s-1.3431 3-3 3H4C2.3432 8 1 6.6569 1 5M4 10c-.5523 0-1 .4477-1 1v5.2413c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 22 7.9537 22 8.7587 22h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 17.7106 21 17.0463 21 16.2413V11c0-.5523-.4477-1-1-1zm6 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Bus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.7587 1h8.4826c.8049 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.073.1434.1331.2894.1827.4386.0793.2387.119.3581.0834.4995-.0278.11-.1204.2385-.2161.2995-.123.0784-.2756.0784-.5808.0784H2.9668c-.3052 0-.4578 0-.5808-.0784-.0957-.061-.1884-.1894-.216-.2995-.0357-.1414.004-.2608.0833-.4995a3.15 3.15 0 0 1 .1827-.4386 4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C6.2894 1 6.9537 1 7.7587 1M2.7995 6.5c-.2798 0-.4198 0-.5267.0545a.5.5 0 0 0-.2185.2184c-.0545.107-.0545.2468-.0546.5266q-.0003 1.4503.0002 2.9005c0 .2801 0 .4201.0546.527a.5.5 0 0 0 .2185.2185C2.38 11 2.52 11 2.8 11h18.4c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.1069.0545-.2469.0546-.527.0001-.9668.0005-1.9337.0002-2.9005-.0001-.2798-.0001-.4196-.0546-.5266a.5.5 0 0 0-.2185-.2184c-.107-.0545-.2469-.0545-.5267-.0545z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 13.8c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C21.62 13 21.48 13 21.2 13H2.8c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C2 13.38 2 13.52 2 13.8v.4413c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642A4 4 0 0 0 4 19.4641v1.759c0 .1192-.0001.2614.0101.3867.0119.1452.0423.3532.1534.5712.1438.2822.3733.5117.6555.6555.218.1111.426.1415.5712.1534.1253.0102.2675.0102.3866.0101H7.723c.1191.0001.2614.0001.3867-.0101.1452-.0119.3532-.0423.5712-.1534a1.5 1.5 0 0 0 .6555-.6555c.111-.218.1415-.426.1534-.5712.0102-.1253.0101-.2675.0101-.3867V20h5v1.2231c-.0001.1191-.0001.2614.0101.3867.0119.1452.0423.3532.1534.5712.1438.2822.3733.5117.6555.6555.2179.1111.4259.1415.5712.1534.1252.0102.2675.0102.3866.0101h1.9463c.1191.0001.2614.0001.3867-.0101.1452-.0119.3532-.0423.5712-.1534a1.5 1.5 0 0 0 .6555-.6555c.111-.218.1415-.426.1534-.5712.0102-.1253.0101-.2675.0101-.3866v-1.7591a4 4 0 0 0 1.564-1.6481c.2473-.4854.3459-1.0021.3918-1.5642C22 15.7106 22 15.0463 22 14.2413zM5.5 15.5c0-.5523.4477-1 1-1H8c.5523 0 1 .4477 1 1s-.4477 1-1 1H6.5c-.5523 0-1-.4477-1-1m10.5-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Car01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.1614 2.9997q3.8386.0057 7.6772 0c.6835-.001 1.2834-.002 1.8179.2083.4674.1838.8811.482 1.2033.8673.3685.4406.5573 1.01.7725 1.6587.2142.6458.4296 1.2911.6451 1.9365l.3067.9192.9687-.4843c.494-.247 1.0946-.0468 1.3416.4472s.0468 1.0946-.4472 1.3416l-.5974.2987c.2857.29.5271.6237.7142.9909.2473.4854.3459 1.0021.3918 1.5642C23 13.2892 23 13.9535 23 14.7585l-.0002.9278c-.0001.6324-.0003 1.2649.0003 1.8974.0003.3807.0005.7085-.0577 1.0014a3 3 0 0 1-2.3571 2.3571c-.3958.0787-.8093.0705-1.2171.0625A18 18 0 0 0 19 20.9998c-1.4865 0-2.7205-1.0811-2.9585-2.5h-8.083c-.238 1.4189-1.472 2.5-2.9585 2.5-.1218 0-.2447.0024-.3682.0049-.4078.008-.8213.0162-1.217-.0625a3 3 0 0 1-2.3571-2.3571c-.0583-.2929-.058-.6207-.0577-1.0014.0005-.6343.0003-1.2685.0002-1.9028L1 14.7585c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 .7142-.9909l-.5974-.2987c-.494-.247-.6942-.8476-.4472-1.3416s.8476-.6942 1.3416-.4472l.9687.4843.3067-.9192c.2154-.6452.431-1.291.6451-1.9365.2152-.6487.404-1.2181.7725-1.6587a3 3 0 0 1 1.2033-.8673c.5345-.2103 1.1344-.2094 1.8179-.2084M5.3836 9.0113c.404-.0115.8609-.0115 1.3751-.0115h10.4826c.5142 0 .9711 0 1.3751.0115l-.8357-2.5072c-.2893-.8678-.3629-1.0356-.4551-1.1458a1 1 0 0 0-.4011-.2891c-.1337-.0526-.3162-.0694-1.2309-.0694H8.3064c-.9147 0-1.0972.0168-1.2309.0694a1 1 0 0 0-.401.289c-.0922.1103-.166.2781-.4552 1.1459zM4 13c0-.5523.4477-1 1-1h3c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1m12-1c-.5523 0-1 .4477-1 1s.4477 1 1 1h3c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Car02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.1615 2h7.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C20 5.1795 20 5.6343 20 6.1614V8h1c0-.5523.4477-1 1-1s1 .4477 1 1v1c0 .5523-.4477 1-1 1h-.3542c.3757.3314.6881.7324.9182 1.184.2473.4854.3459 1.0021.3918 1.5642C23 13.2894 23 13.9537 23 14.7587v3.2733c0 .4386 0 .8171-.0213 1.1304-.0226.3298-.0721.6597-.2071.9857a3 3 0 0 1-1.6235 1.6235c-.326.135-.6559.1845-.9857.2071C19.8491 22 19.4706 22 19.032 22c-.1261 0-.2535.0026-.3815.0053-.3746.0078-.7545.0156-1.1198-.0422a3 3 0 0 1-2.4938-2.4938c-.023-.1452-.0317-.3003-.035-.4693H8.9981c-.0033.169-.012.3241-.035.4693a3 3 0 0 1-2.4938 2.4938c-.3653.0578-.745.05-1.1197.0422A18 18 0 0 0 4.968 22c-.4386 0-.8171 0-1.1304-.0213-.3298-.0226-.6597-.0721-.9857-.2071a3 3 0 0 1-1.6235-1.6235c-.135-.326-.1845-.6559-.207-.9857C1 18.8491 1 18.4707 1 18.032v-3.2733c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642A4 4 0 0 1 2.3543 10H2c-.5523 0-1-.4477-1-1V8c0-.5523.4477-1 1-1s1 .4477 1 1h1V6.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C7.1795 2 7.6343 2 8.1615 2M6 9.0016C6.2167 9.0001 6.446 9 6.688 9H6V6.2c0-.5766.0008-.9488.024-1.2322.0221-.2716.0598-.3723.085-.4218a1 1 0 0 1 .437-.437c.0495-.0252.1502-.0629.4218-.085C7.2512 4.0007 7.6234 4 8.2 4h7.6c.5766 0 .9488.0008 1.2322.024.2716.0221.3723.0598.4218.085a1 1 0 0 1 .437.437c.0252.0495.0629.1502.0851.4218.0231.2834.0239.6556.0239 1.2322V9h-.688.2048zm11.5168-.0015L18 9v.0016a80 80 0 0 0-.4832-.0015M4.5 13.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5S6.8284 15 6 15s-1.5-.6716-1.5-1.5M18 12c-.8284 0-1.5.6716-1.5 1.5S17.1716 15 18 15s1.5-.6716 1.5-1.5S18.8284 12 18 12"
      clipRule="evenodd"
    />
  </svg>
);

export const Compass01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m.8 3.0002a.8.8 0 0 0-1.6 0v1.6a.8.8 0 0 0 1.6 0zm-7.0226 1.777a.8.8 0 0 1 1.1314 0l1.1314 1.1315A.8.8 0 1 1 6.9088 8.04L5.7774 6.9087a.8.8 0 0 1 0-1.1314M3.2 12.0003a.8.8 0 0 1 .8-.8h1.6a.8.8 0 0 1 0 1.6H4a.8.8 0 0 1-.8-.8m14.4 0a.8.8 0 0 1 .8-.8H20a.8.8 0 0 1 0 1.6h-1.6a.8.8 0 0 1-.8-.8m-.5088 3.9597a.8.8 0 0 0-1.1314 1.1314l1.1314 1.1313a.8.8 0 0 0 1.1313 0 .8.8 0 0 0 0-1.1313zm1.1313-10.1826a.8.8 0 0 1 0 1.1313L17.0912 8.04a.8.8 0 0 1-1.1314-1.1313l1.1314-1.1314a.8.8 0 0 1 1.1313 0M12 17.6a.8.8 0 0 1 .8.8v1.6a.8.8 0 0 1-1.6 0v-1.6a.8.8 0 0 1 .8-.8m-3.9598-1.6402a.8.8 0 0 1 0 1.1314l-1.1314 1.1313a.8.8 0 0 1-1.1314 0 .8.8 0 0 1 0-1.1313l1.1314-1.1314a.8.8 0 0 1 1.1314 0M12 9a1 1 0 0 1 .8575.4855l.6214 1.0356 1.0356.6214a1 1 0 0 1 0 1.715l-1.0356.6214-.6214 1.0356a1 1 0 0 1-1.715 0l-.6214-1.0356-1.0356-.6214a1 1 0 0 1 0-1.715l1.0356-.6214.6214-1.0356A1 1 0 0 1 12 9"
      clipRule="evenodd"
    />
  </svg>
);

export const Compass02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m0 2.2002a.8.8 0 0 1 .8.8v1.6a.8.8 0 0 1-1.6 0v-1.6a.8.8 0 0 1 .8-.8m-5.0912 2.577a.8.8 0 1 0-1.1314 1.1315L6.9089 8.04a.8.8 0 1 0 1.1314-1.1313zM4 11.2003a.8.8 0 0 0 0 1.6h1.6a.8.8 0 0 0 0-1.6zm14.4 0a.8.8 0 0 0 0 1.6H20a.8.8 0 0 0 0-1.6zm-2.4402 4.7597a.8.8 0 0 1 1.1314 0l1.1313 1.1314a.8.8 0 0 1 0 1.1313.8.8 0 0 1-1.1313 0l-1.1314-1.1313a.8.8 0 0 1 0-1.1314m2.2627-9.0512a.8.8 0 0 0 0-1.1314.8.8 0 0 0-1.1313 0l-1.1314 1.1313A.8.8 0 0 0 17.0912 8.04zM12.8 18.4a.8.8 0 0 0-1.6 0v1.6a.8.8 0 0 0 1.6 0zm-4.7598-1.3088a.8.8 0 0 0-1.1314-1.1314l-1.1314 1.1314a.8.8 0 0 0 0 1.1313.8.8 0 0 0 1.1314 0zm3.2527-7.7984c.3905-.3905 1.0237-.3905 1.4142 0l2 2c.3905.3905.3905 1.0237 0 1.4142l-2 2c-.3905.3905-1.0237.3905-1.4142 0l-2-2c-.3905-.3905-.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
  </svg>
);

export const Compass03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1m3.6174 7.0794c-.1625-.058-.4068.0235-.8953.1863l-4.4626 1.4876c-.1392.0464-.2087.0695-.2665.109a.5.5 0 0 0-.1304.1304c-.0395.0578-.0627.1274-.1091.2665L8.266 14.7219c-.1629.4885-.2443.7328-.1864.8952a.5.5 0 0 0 .303.303c.1625.058.4067-.0235.8953-.1863l4.4626-1.4875c.1392-.0464.2087-.0696.2665-.1091a.5.5 0 0 0 .1304-.1304c.0395-.0578.0627-.1274.1091-.2665l1.4875-4.4626c.1629-.4886.2443-.7329.1864-.8953a.5.5 0 0 0-.303-.303"
      clipRule="evenodd"
    />
  </svg>
);

export const Flag01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 2.9968a.997.997 0 0 1 .2929-.704s-.044.0382.0464-.044q.03-.0273.0738-.0637a2.9 2.9 0 0 1 .2353-.1734c.198-.132.4782-.2894.8552-.4402C5.2595 1.2692 6.3873 1 8 1c1.6935 0 3.0967.5615 4.3157 1.0492l.0557.0223C13.6395 2.5788 14.7193 3 16 3c1.3873 0 2.2595-.2308 2.7536-.4285.248-.0992.4053-.1918.4886-.2473a1 1 0 0 0 .073-.053c.392-.3687 1.0087-.3615 1.3919.0217A.997.997 0 0 1 21 3v11.999a.997.997 0 0 1-.2929.7081l-.001.0011a1.7 1.7 0 0 1-.1192.1067 3 3 0 0 1-.2353.1734c-.198.132-.4782.2894-.8552.4402C18.7405 16.7308 17.6127 17 16 17c-1.6934 0-3.0967-.5615-4.3157-1.0492l-.0557-.0223C10.3605 15.4212 9.2806 15 8 15c-1.3873 0-2.2595.2308-2.7536.4285A3.3 3.3 0 0 0 5 15.5381V22c0 .5523-.4477 1-1 1s-1-.4477-1-1V2.9968"
    />
  </svg>
);

export const Flag02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v20c0 .5523.4477 1 1 1s1-.4477 1-1v-6.4619a3.3 3.3 0 0 1 .2464-.1096C5.7405 15.2308 6.6127 15 8 15c1.2807 0 2.3605.4212 3.6286.9285l.0557.0223C12.9033 16.4385 14.3066 17 16 17c1.6127 0 2.7405-.2692 3.4964-.5715.377-.1508.6572-.3082.8552-.4402a3 3 0 0 0 .2353-.1734 1.7 1.7 0 0 0 .1192-.1067l.001-.0011A.997.997 0 0 0 21 14.999V4a.997.997 0 0 0-.2929-.7071c-.3832-.3832-.9999-.3904-1.3919-.0216a1 1 0 0 1-.073.0529c-.0833.0555-.2406.1481-.4886.2473C18.2595 3.7692 17.3873 4 16 4c-1.2807 0-2.3605-.4212-3.6286-.9285l-.0557-.0223C11.0967 2.5615 9.6935 2 8 2c-1.2918 0-2.2724.1727-3 .3968z"
    />
  </svg>
);

export const Flag03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.0047 2.291c-.291-.2137-.6072-.258-.7895-.2747C20.0363 2 19.8221 2 19.6201 2H4c-.5523 0-1 .4477-1 1v18c0 .5523.4477 1 1 1s1-.4477 1-1v-7h14.6201c.202.0001.4162.0001.5951-.0163.1823-.0167.4985-.061.7895-.2746a1.5 1.5 0 0 0 .6057-1.0699c.0335-.3594-.0912-.6533-.1707-.8183-.0779-.1618-.1882-.3455-.2921-.5186L19.1662 8l1.9813-3.3022c.104-.1732.2143-.3569.2922-.5187.0795-.165.2042-.4589.1707-.8183a1.5 1.5 0 0 0-.6057-1.0698"
    />
  </svg>
);

export const Flag04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5681 1.5c-.2524 0-.4982 0-.7063.017-.2286.0186-.4984.0627-.7698.201a2 2 0 0 0-.874.874c-.1215.2385-.1703.4757-.193.6849-.0554.243-.025.5083-.025.7551V21c0 .5523.4477 1 1 1s1-.4477 1-1v-9h5.5v1.4319c0 .2524 0 .4982.017.7063.0186.2286.0627.4984.201.7698.1917.3763.4977.6823.874.874.2715.1383.5412.1824.7698.2011.2081.017.4539.0169.7063.0169h7.7317c.1777.0001.3724.0001.5374-.0149.1756-.016.4623-.0582.7363-.2443a1.5 1.5 0 0 0 .6333-.9745c.0588-.326-.0191-.6051-.0758-.772-.0533-.1569-.1324-.3348-.2046-.4972l-1.3209-2.972 1.2242-2.4484c.0833-.1665.1735-.3469.2356-.5058.0652-.1667.1596-.4518.1096-.7901a1.5 1.5 0 0 0-.6242-1.01c-.2802-.196-.5774-.239-.7557-.2553-.1699-.0156-.3716-.0156-.5578-.0155H14.5V4.0681c0-.2524.0001-.4982-.0169-.7063-.0187-.2286-.0628-.4984-.2011-.7698a2 2 0 0 0-.874-.874c-.2714-.1383-.5412-.1824-.7698-.201-.2081-.017-.4539-.017-.7063-.017z"
      clipRule="evenodd"
    />
  </svg>
);

export const Flag05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5123 1.5h8.0307c.2524 0 .4982 0 .7064.017.2286.0186.4983.0627.7697.201a2 2 0 0 1 .8741.874c.1383.2714.1823.5412.201.7698.017.2081.017.454.0169.7063v1.654h5.0617c.1949 0 .4036 0 .5785.016.1806.0166.4884.0604.7746.2662.3424.2462.5653.625.6142 1.0439.041.3502-.0702.6405-.1434.8064-.071.1607-.1724.343-.2671.5134l-1.4313 2.5764 1.4313 2.5764c.0947.1703.1961.3527.2671.5134.0732.1659.1844.4562.1434.8064a1.5 1.5 0 0 1-.6142 1.0439c-.2862.2058-.594.2496-.7746.2662-.1749.016-.3835.016-.5784.0159h-7.6603c-.2524.0001-.4982.0001-.7064-.0169-.2285-.0187-.4983-.0628-.7697-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7697-.017-.2082-.017-.454-.017-.7064v-1.654l-4.0526-.0001 2.3283 9.313c.134.5358-.1918 1.0788-.7276 1.2127-.5358.134-1.0788-.1918-1.2127-.7276L2.0179 4.6948c-.077-.3079-.1498-.5992-.1889-.8463-.0417-.2641-.0662-.5924.041-.939a2 2 0 0 1 .8744-1.12c.3103-.188.6347-.244.901-.2675.2493-.022.5496-.022.8669-.022"
      clipRule="evenodd"
    />
  </svg>
);

export const Flag06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5681 2h5.8638c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2714.1824.5412.2011.7698q.0053.0667.0087.1382h5.4401c.2524 0 .4982 0 .7063.017.2286.0186.4984.0627.7698.201.3763.1917.6823.4977.874.874.1383.2715.1824.5412.2011.7698.017.2081.0169.454.0169.7063v6.8638c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4984-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.2011-.2081.017-.4539.0169-.7063.0169h-4.8638c-.2524 0-.4982.0001-.7063-.0169-.2286-.0187-.4984-.0628-.7698-.2011a2 2 0 0 1-.874-.874c-.1383-.2714-.1824-.5412-.201-.7698a4 4 0 0 1-.0092-.1468c-.1772.0087-.3745.0086-.5759.0086H5v7c0 .5523-.4477 1-1 1s-1-.4477-1-1V4c0-.0767.0086-.1514.025-.2231.0227-.2092.0715-.4464.193-.6849a2 2 0 0 1 .874-.874c.2715-.1383.5412-.1824.7698-.201C5.0699 2 5.3158 2 5.568 2"
      clipRule="evenodd"
    />
  </svg>
);

export const Globe01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1c6.0751 0 11 4.9249 11 11s-4.9249 11-11 11S1 18.0751 1 12 5.9249 1 12 1M3.055 11c.413-3.7368 3.1138-6.784 6.6707-7.7102A16.3 16.3 0 0 0 7.0501 11zm0 2c.413 3.7368 3.1138 6.784 6.6707 7.7102A16.3 16.3 0 0 1 7.0501 13zm11.2193 7.7102c3.5569-.9262 6.2577-3.9734 6.6708-7.7102h-3.9952a16.3 16.3 0 0 1-2.6756 7.7102M20.9451 11h-3.9952a16.3 16.3 0 0 0-2.6756-7.7102C17.8312 4.216 20.532 7.2632 20.9451 11M12 3.5508A14.3 14.3 0 0 1 14.9424 11H9.0576A14.3 14.3 0 0 1 12 3.5508m0 16.8984A14.3 14.3 0 0 1 9.0576 13h5.8848A14.3 14.3 0 0 1 12 20.4492"
      clipRule="evenodd"
    />
  </svg>
);

export const Globe02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 23c6.0751 0 11-4.9249 11-11S18.0751 1 12 1 1 5.9249 1 12s4.9249 11 11 11m2.2743-19.7102A16.3 16.3 0 0 1 16.4208 8h3.6437c-1.1453-2.3046-3.2493-4.0486-5.7902-4.7102M12 3.5508A14.3 14.3 0 0 1 14.3356 8H9.6644A14.3 14.3 0 0 1 12 3.5508M14.9998 12a14.3 14.3 0 0 0-.1857-2H9.1859a14.3 14.3 0 0 0-.1857 2c.015.6737.0775 1.3419.1857 2h5.6282a14.3 14.3 0 0 0 .1857-2m-.6642 4H9.6644A14.3 14.3 0 0 0 12 20.4492 14.3 14.3 0 0 0 14.3356 16m-7.1732-2a16.3 16.3 0 0 1-.1622-1.9792 1 1 0 0 1 0-.0416A16.3 16.3 0 0 1 7.1624 10H3.223A9.03 9.03 0 0 0 3 12c0 .6874.077 1.3568.223 2zm-3.2269 2h3.6437a16.3 16.3 0 0 0 2.1465 4.7102C7.1848 20.0486 5.0807 18.3046 3.9355 16m12.4853 0h3.6437c-1.1453 2.3046-3.2493 4.0486-5.7902 4.7102A16.3 16.3 0 0 0 16.4208 16m4.3562-2h-3.9394a16.3 16.3 0 0 0 .1622-1.9792 1 1 0 0 0 0-.0416A16.3 16.3 0 0 0 16.8376 10h3.9394A9.03 9.03 0 0 1 21 12a9.03 9.03 0 0 1-.223 2M9.7257 3.2898A16.3 16.3 0 0 0 7.5792 8H3.9355c1.1453-2.3046 3.2493-4.0486 5.7902-4.7102"
      clipRule="evenodd"
    />
  </svg>
);

export const Globe03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 12c0-6.0746-4.9241-10.9992-10.9985-11h-.0038C5.9237 1.0012 1 5.9256 1 12c0 6.0751 4.9249 11 11 11s11-4.9249 11-11M3.4394 9.2144c.8877-2.73 3.045-4.8873 5.775-5.775-.5317.8005-.9421 1.6835-1.256 2.5945-.168.488-.31.9886-.429 1.4955-.507.119-1.0076.261-1.4955.429-.911.3138-1.794.7243-2.5945 1.256m0 5.5712c.8877 2.73 3.045 4.8873 5.775 5.775-.5317-.8005-.9421-1.6835-1.256-2.5944-.168-.488-.31-.9887-.429-1.4956-.507-.119-1.0076-.261-1.4955-.4291-.911-.3138-1.794-.7242-2.5945-1.2559m6.259 2.0603q.0714.2372.151.4689c.4834 1.4033 1.1843 2.5893 2.1506 3.4294.9663-.8401 1.6672-2.0261 2.1505-3.4294q.0798-.2317.1511-.4689c-.7739.0907-1.5415.1385-2.2808.1539a1 1 0 0 1-.0416 0c-.7393-.0154-1.5069-.0632-2.2808-.1539m5.0666-2.0809c-.9182.1422-1.8545.215-2.765.2348-.9105-.0198-1.8468-.0926-2.765-.2348-.1422-.9182-.215-1.8545-.2348-2.765.0198-.9105.0926-1.8468.2348-2.765.9182-.1422 1.8545-.215 2.765-.2348.9105.0198 1.8468.0926 2.765.2348.1422.9182.215 1.8545.2348 2.765-.0198.9105-.0926 1.8468-.2348 2.765m1.7056 1.7056c-.119.5069-.261 1.0076-.4291 1.4955-.3138.911-.7242 1.794-1.2559 2.5945 2.73-.8877 4.8873-3.045 5.775-5.775-.8005.5317-1.6835.9421-2.5944 1.2559-.488.1681-.9886.3101-1.4956.4291m4.09-7.2562c-.8877-2.73-3.045-4.8873-5.775-5.775.5317.8005.9421 1.6835 1.2559 2.5945.1681.488.3101.9886.4291 1.4955.507.119 1.0076.261 1.4956.429.9109.3138 1.7939.7243 2.5944 1.256m-3.7147.484q.2372.0714.4689.151c1.4033.4834 2.5893 1.1843 3.4294 2.1506-.8401.9663-2.0261 1.6672-3.4294 2.1505a13 13 0 0 1-.4689.1511c.0907-.7739.1385-1.5415.1539-2.2808a1 1 0 0 0 0-.0416c-.0154-.7393-.0632-1.5069-.1539-2.2808M14.3016 7.154a13 13 0 0 0-.1511-.469C13.6672 5.282 12.9663 4.096 12 3.2559c-.9663.84-1.6672 2.0261-2.1506 3.4294a12.5 12.5 0 0 0-.151.469c.7739-.0908 1.5415-.1386 2.2808-.154a1 1 0 0 1 .0416 0c.7393.0154 1.5069.0632 2.2808.154M7.1541 9.6984c-.0907.7739-.1385 1.5415-.1539 2.2808a1 1 0 0 0 0 .0416c.0154.7393.0632 1.5069.154 2.2808a13 13 0 0 1-.469-.1511C5.2819 13.6672 4.0959 12.9663 3.2558 12c.84-.9663 2.0261-1.6672 3.4294-2.1506q.2317-.0796.469-.151"
      clipRule="evenodd"
    />
  </svg>
);

export const Globe04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m13.8939 12.5808 2.6403 1.1316c.13.0556.2801.1199.4055.1871.1411.0756.3469.203.5142.4278a1.5 1.5 0 0 1 .2938.9882c-.0173.2796-.1201.4988-.1971.6392-.0683.1248-.1589.2606-.2374.3782-.4907.7363-.9322 1.7537-1.6284 2.3259a1.5 1.5 0 0 1-.5165.2765c-.8722.2649-2.4607.3131-3.3569-.0394a1.5 1.5 0 0 1-.6017-.4336c-.6045-.723-.765-1.9654-1.0536-2.8317l-.0077-.0227c-.0284-.0833-.087-.2552-.103-.4405a1.5 1.5 0 0 1 .0333-.4681c.1475-.6356.5581-1.2992.8877-1.849.0687-.1147.1751-.2693.3455-.4066.224-.1806.4952-.293.7813-.3237.2176-.0233.4021.0108.5318.0433.426.1066.8666.2451 1.2689.4175"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11 11-4.9249 11-11S18.0751 1 12 1M3.5055 9.0187C3.1781 9.9517 3 10.955 3 12c0 4.9706 4.0294 9 9 9s9-4.0294 9-9c0-3.8325-2.3955-7.1055-5.7709-8.4034-.0829 1.2456.3521 3.2117-.692 4.1728-1.095 1.008-3.0549 1.4442-4.3932 2.0389l-.8885 1.1847c-.07.0933-.1537.2051-.2357.2978-.0953.1076-.2416.2532-.4565.3606a1.5 1.5 0 0 1-.903.1397c-.2374-.0373-.421-.1319-.5443-.2057-.1061-.0636-.2198-.1448-.3146-.2126z"
      clipRule="evenodd"
    />
  </svg>
);

export const Globe05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1c1.0396 0 2.047.1445 3.0024.415A4.98 4.98 0 0 1 17 1c2.7614 0 5 2.2386 5 5 0 .3906-.0488.7655-.1365 1.1256C22.5913 8.5957 23 10.2514 23 12c0 6.0751-4.9249 11-11 11S1 18.0751 1 12a11.1 11.1 0 0 1 .0725-1.2702C1.7023 5.253 6.3545 1 12 1M3.284 9.748C4.284 5.8671 7.8072 3 12 3c.3252 0 .6461.0172.962.0507A4.978 4.978 0 0 0 12 6c0 1.4216.6468 2.6357 1.4577 3.6886.6746.8759 1.5379 1.7315 2.3711 2.5572.1562.1548.3114.3086.4641.4613.3905.3905 1.0237.3905 1.4142 0 .1527-.1527.3079-.3065.4641-.4613.8332-.8257 1.6965-1.6813 2.3711-2.5572q.0587-.0762.1162-.1536A9 9 0 0 1 21 12c0 4.9706-4.0294 9-9 9a9 9 0 0 1-.4999-.0136v-1.1167l2.3655-2.7597c.6128-.715.4229-1.8113-.3947-2.2786l-2.7377-1.5644-1.7942-3.1442a1.5 1.5 0 0 0-1.4359-.7507zM17 4.5c-.6904 0-1.25.5596-1.25 1.25S16.3096 7 17 7s1.25-.5596 1.25-1.25S17.6904 4.5 17 4.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Globe06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.5924 3.3257A9 9 0 0 1 12 3c1.962 0 3.7773.6278 5.2561 1.6935-.7868.52-1.3737 1.0847-1.7805 1.6884-.6216.9226-.7809 1.8765-.6522 2.747.125.8453.5132 1.5671.9212 2.1012.3956.5178.881.9509 1.3085 1.1645 1.0763.5381 2.3183.8076 3.2468.9464.84.1257 2.6207.5461 2.6866-.7918Q23 12.2762 23 12c0-6.0751-4.9249-11-11-11S1 5.9249 1 12s4.9249 11 11 11q.2762 0 .5492-.0135c.5516-.0272.9768-.4963.9496-1.048-.0272-.5516-.4964-.9767-1.048-.9496A9 9 0 0 1 12 21c-3.5094 0-6.5496-2.0086-8.0338-4.9389l.9685-.5591 3.5728.6686c.9256.1733 1.7801-.5393 1.7759-1.481l-.014-3.1531 1.8258-3.126a1.5 1.5 0 0 0-.0678-1.6188z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.9456 12.6561a.9999.9999 0 0 0-1.2896 1.2897l3.1668 8.3487a1 1 0 0 0 1.8635.0166l1.3207-3.304 3.304-1.3206a1.0002 1.0002 0 0 0-.0166-1.8636z"
      clipRule="evenodd"
    />
  </svg>
);

export const Luggage01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v8.4826c0 .8049 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918A10 10 0 0 0 7 20.9729V22c0 .5523.4477 1 1 1s1-.4477 1-1v-1h6v1c0 .5523.4477 1 1 1s1-.4477 1-1v-1.0271a10 10 0 0 0 .2518-.0171c.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 16.7106 21 16.0463 21 15.2413V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0462 1 15.2413 1M9.5 6c.5523 0 1 .4477 1 1v8c0 .5523-.4477 1-1 1s-1-.4477-1-1V7c0-.5523.4477-1 1-1m6 1c0-.5523-.4477-1-1-1s-1 .4477-1 1v8c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Luggage02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.9647 2.1364c.5117-.1371 1.1023-.1368 1.8977-.1364h.2752c.7954-.0004 1.386-.0007 1.8977.1364a4 4 0 0 1 2.8284 2.8284c.0824.3075.1152.6434.1281 1.0352h.2495c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C23 10.2894 23 10.9537 23 11.7587v4.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 22 18.0462 22 17.2413 22H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 17.7106 1 17.0463 1 16.2413v-4.4826c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 6 5.9537 6 6.7587 6h.2495c.013-.3918.0457-.7277.1281-1.0352a4 4 0 0 1 2.8284-2.8284m4.9672 3.346c.0318.1188.0491.26.0582.5176H9.0099c.0092-.2575.0264-.3988.0582-.5175a2 2 0 0 1 1.4143-1.4143c.2222-.0595.5233-.0681 1.5176-.0681s1.2954.0086 1.5176.0681a2 2 0 0 1 1.4143 1.4143m-2.8774 8.2906C12 13.88 12 14.02 12 14.3v2.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545h4.9c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-2.4c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C18.12 13.5 17.98 13.5 17.7 13.5h-4.9c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185"
      clipRule="evenodd"
    />
  </svg>
);

export const Luggage03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.8624 2c-.7954-.0004-1.386-.0007-1.8977.1364a4 4 0 0 0-2.8284 2.8284c-.0824.3075-.1151.6434-.128 1.0352h-.2496c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C1 10.2894 1 10.9537 1 11.7586v4.4827c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918.4824.0394.9672.0464 1.4518.0464.28-.0001.42-.0001.527-.0546a.5.5 0 0 0 .2185-.2185C7 21.6222 7 21.4814 7 21.2V9c0-.5523.4477-1 1-1s1 .4477 1 1v12.2c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C9.38 22 9.52 22 9.8 22h4.4c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C15 21.62 15 21.48 15 21.2V20c0-.5523.4477-1 1-1s1 .4477 1 1v1.2c0 .2814 0 .4222.0545.5291a.5.5 0 0 0 .2185.2185c.1069.0545.247.0545.527.0546.4846 0 .9694-.007 1.4518-.0464.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C23 17.7106 23 17.0463 23 16.2413v-4.4826c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C18.7106 6 18.0463 6 17.2413 6h-.2495c-.0129-.3918-.0457-.7277-.1281-1.0352a4 4 0 0 0-2.8284-2.8284c-.5117-.1371-1.1023-.1368-1.8977-.1364zm3.1277 4c-.0091-.2575-.0264-.3988-.0582-.5175a2 2 0 0 0-1.4143-1.4143c-.2222-.0595-.5232-.0681-1.5176-.0681-.9943 0-1.2954.0086-1.5176.0681a2 2 0 0 0-1.4143 1.4143c-.0318.1187-.049.26-.0582.5175zM12 14.3c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185c.107-.0545.247-.0545.527-.0545h4.9c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185c.0545.107.0545.247.0545.527v2.4c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185c-.107.0545-.247.0545-.527.0545h-4.9c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C12 17.12 12 16.98 12 16.7zM16 8c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V9c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Map01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 2.7982c0-.4527 0-.679-.0951-.8103a.5.5 0 0 0-.351-.2037c-.1612-.0175-.3578.0948-.7508.3194L1.5039 5.1318A1 1 0 0 0 1 6v16a1 1 0 0 0 1.4961.8682l4.6977-2.6843c.2936-.1678.4404-.2517.5473-.3696a1 1 0 0 0 .2095-.3612C8 19.3019 8 19.1328 8 18.7947zM10 18.7947c0 .3381 0 .5072.0494.6584a1 1 0 0 0 .2095.3612c.1069.1179.2537.2018.5473.3696l2.9969 1.7125c.393.2246.5896.3369.7507.3194a.5.5 0 0 0 .3511-.2037C15 21.8808 15 21.6545 15 21.2018V5.2053c0-.3381 0-.5072-.0494-.6584a1 1 0 0 0-.2095-.3612c-.1069-.1179-.2537-.2018-.5473-.3695l-2.9969-1.7126c-.393-.2246-.5896-.3369-.7507-.3194a.5.5 0 0 0-.3511.2037C10 2.1192 10 2.3455 10 2.7982zM23 2a1 1 0 0 0-1.5547-.832l-3.7328 2.4885c-.2605.1737-.3908.2605-.485.3752a1 1 0 0 0-.1844.3444C17 4.518 17 4.6747 17 4.9878v16.0526c0 .4856 0 .7283.1012.8622a.5.5 0 0 0 .369.1974c.1675.01.3695-.1246.7736-.394l4.3109-2.8739A1 1 0 0 0 23 18z"
    />
  </svg>
);

export const Map02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.7482 2.0442c.1647-.0135.247-.0202.344-.0092.2734.0311.5574.2022.7127.4293.055.0807.0938.1711.1714.3521l3.748 8.7453-7.538 4.1589c-.3905.2155-.5857.3232-.7454.3042a.5.5 0 0 1-.3472-.205c-.0938-.1306-.0938-.3536-.0939-.7995q0-3.6308.0002-7.2616c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918M3.0424 18.0842c-.3358.1853-.5037.2779-.6355.462-.0937.1309-.182.3938-.1865.5546-.0062.2264.0443.3402.1454.5678q.033.0742.0702.1474a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C6.2894 22 6.9537 22 7.7587 22h6.2259c.4051 0 .6076 0 .7343-.0853a.5.5 0 0 0 .2119-.3213c.0285-.15-.0513-.3362-.2109-.7085l-3.2039-7.4758zM18.2518 21.9558c-.1645.0134-.2467.0202-.3436.0092-.2736-.0311-.5577-.2022-.713-.4295-.055-.0806-.0938-.171-.1712-.3517L9.2803 3.1151c-.1596-.3723-.2394-.5585-.2109-.7085a.5.5 0 0 1 .212-.3213C9.4078 2 9.6103 2 10.0155 2h6.2257c.8049 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5641.3918a4 4 0 0 1 1.7481 1.748c.2473.4854.3459 1.002.3918 1.5642C22 6.2894 22 6.9537 22 7.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.7481 1.748c-.4853.2473-1.002.3459-1.5641.3918"
    />
  </svg>
);

export const Mark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 9c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3-1.3431-3-3-3"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.055C6.8284 3.516 3.516 6.8283 3.055 11H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.055c.461 4.1716 3.7734 7.4839 7.945 7.9451V22c0 .5523.4477 1 1 1s1-.4477 1-1v-1.0549c4.1716-.4612 7.4839-3.7735 7.9451-7.9451H22c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1.0549C20.4839 6.8284 17.1716 3.516 13 3.055zM7 12c0-2.7614 2.2386-5 5-5s5 2.2386 5 5-2.2386 5-5 5-5-2.2386-5-5"
      clipRule="evenodd"
    />
  </svg>
);

export const MarkerPin01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 10c0-4.9706 4.0294-9 9-9s9 4.0294 9 9c0 2.5262-1.1468 4.7402-2.7077 6.767-1.3043 1.6936-2.974 3.3488-4.6417 5.002l-.0011.0012c-.315.3123-.63.6245-.9424.9369-.3905.3905-1.0237.3905-1.4142 0a310 310 0 0 0-.9437-.9383c-1.6677-1.6532-3.3371-3.3082-4.6415-5.0018C4.1468 14.7402 3 12.5262 3 10m12 0c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
      clipRule="evenodd"
    />
  </svg>
);

export const MarkerPin02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 10c0-4.9706 4.0294-9 9-9s9 4.0294 9 9c0 3.1191-1.7439 5.3655-3.5287 7.2244-.4306.4486-.8748.8854-1.3042 1.3077l-.0557.0548c-.4506.4432-.884.8706-1.2922 1.3009-.8207.8648-1.4908 1.6914-1.9248 2.5594a1 1 0 0 1-1.7888 0c-.434-.868-1.1041-1.6946-1.9248-2.5594-.4082-.4303-.8416-.8577-1.2922-1.3009l-.0558-.0549c-.4294-.4223-.8735-.859-1.3041-1.3076C4.7439 15.3655 3 13.1191 3 10m12-.5c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
      clipRule="evenodd"
    />
  </svg>
);

export const MarkerPin03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 10c0-4.9706 4.0294-9 9-9s9 4.0294 9 9c0 3.6785-2.0607 5.6862-3.9824 7.298-.2031.1704-.4023.3353-.5968.4963-1.7203 1.4239-3.0677 2.5392-3.4402 4.4018a1 1 0 0 1-1.9612 0c-.3725-1.8626-1.72-2.9779-3.4402-4.4018-.1945-.161-.3937-.3259-.5968-.4963C5.0607 15.6862 3 13.6785 3 10m12 0c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3"
      clipRule="evenodd"
    />
  </svg>
);

export const MarkerPin04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 8c0-3.866 3.134-7 7-7s7 3.134 7 7c0 2.4418-1.3689 4.1882-2.7162 5.5915-.3255.3391-.661.6689-.9824.9851l-.0426.0418c-.3383.3328-.6603.6504-.9631.9695-.6097.6426-1.0923 1.2413-1.4013 1.8593a1 1 0 0 1-1.7888 0c-.309-.618-.7916-1.2167-1.4013-1.8593-.3028-.3191-.6248-.6367-.9631-.9695l-.0426-.0419c-.3215-.3161-.6569-.6459-.9825-.985C6.369 12.1882 5 10.4418 5 8m9 0c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.4036 15.2013c.5053-.2229.7342-.8132.5113-1.3185s-.8132-.7343-1.3185-.5113c-1.003.4424-1.8772.9975-2.5145 1.6659C1.44 15.7109 1 16.5451 1 17.5c0 1.8813 1.6463 3.2514 3.5186 4.0939C6.4846 22.4787 9.1306 23 12 23s5.5153-.5213 7.4814-1.4061C21.3537 20.7514 23 19.3813 23 17.5c0-.9549-.4398-1.7891-1.0819-2.4626-.6373-.6684-1.5116-1.2235-2.5145-1.6659-.5053-.223-1.0956.006-1.3185.5113s.006 1.0956.5113 1.3185c.8484.3743 1.4741.7966 1.8741 1.2161.395.4144.5295.7787.5295 1.0826 0 .6041-.5923 1.4839-2.3393 2.2701C17.0075 20.514 14.6535 21 12 21s-5.0075-.486-6.6607-1.2299C3.5923 18.9839 3 18.1041 3 17.5c0-.3039.1345-.6682.5295-1.0826.4-.4195 1.0257-.8418 1.8741-1.2161"
    />
  </svg>
);

export const MarkerPin05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.0035 2a.997.997 0 0 1 .539.1598l5.3272 3.2783c.1693.104.3496.215.4919.3216.1458.1093.3887.3105.5246.6408a1.5 1.5 0 0 1-.0352 1.2206c-.1547.3218-.4088.5087-.5608.6094-.1482.0983-.3345.1986-.5095.2927L13 11.0974V17c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6.4799a1 1 0 0 1 0-.0382V3.0153a.996.996 0 0 1 .231-.6546A.998.998 0 0 1 12 2z"
    />
    <path
      fill="currentColor"
      d="M8.193 14.3554c.5418-.1065.8948-.6322.7882-1.1741-.1065-.5419-.6322-.8948-1.1741-.7883-1.8502.3638-3.4878.9721-4.6907 1.7834C1.9357 14.9727 1 16.0947 1 17.4998c0 1.8812 1.6463 3.2514 3.5186 4.0939 1.966.8847 4.612 1.4061 7.4814 1.4061s5.5153-.5214 7.4814-1.4061C21.3537 20.7512 23 19.381 23 17.4998c0-1.4051-.9357-2.5271-2.1164-3.3234-1.2029-.8113-2.8405-1.4196-4.6907-1.7834-.5419-.1065-1.0676.2464-1.1741.7883-.1066.5419.2464 1.0676.7883 1.1741 1.6816.3307 3.044.8625 3.9582 1.4791C20.7016 16.466 21 17.0596 21 17.4998c0 .604-.5923 1.4839-2.3393 2.27-1.6532.744-4.0072 1.23-6.6607 1.23s-5.0075-.486-6.6607-1.23C3.5923 18.9837 3 18.1038 3 17.4998c0-.4402.2984-1.0338 1.2347-1.6653.9142-.6166 2.2766-1.1484 3.9582-1.4791"
    />
  </svg>
);

export const MarkerPin06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2C9.7909 2 8 3.7909 8 6c0 1.8638 1.2748 3.43 3 3.874V17c0 .5523.4477 1 1 1s1-.4477 1-1V9.874C14.7252 9.43 16 7.8638 16 6c0-2.2091-1.7909-4-4-4"
    />
    <path
      fill="currentColor"
      d="M8.193 14.3554c.5418-.1065.8948-.6322.7882-1.1741-.1065-.5419-.6322-.8948-1.1741-.7883-1.8502.3638-3.4878.9721-4.6907 1.7834C1.9357 14.9727 1 16.0947 1 17.4998c0 1.8812 1.6463 3.2514 3.5186 4.0939 1.966.8847 4.612 1.4061 7.4814 1.4061s5.5153-.5214 7.4814-1.4061C21.3537 20.7512 23 19.381 23 17.4998c0-1.4051-.9357-2.5271-2.1164-3.3234-1.2029-.8113-2.8405-1.4196-4.6907-1.7834-.5419-.1065-1.0676.2464-1.1741.7883-.1066.5419.2464 1.0676.7883 1.1741 1.6816.3307 3.044.8625 3.9582 1.4791C20.7016 16.466 21 17.0596 21 17.4998c0 .604-.5923 1.4839-2.3393 2.27-1.6532.744-4.0072 1.23-6.6607 1.23s-5.0075-.486-6.6607-1.23C3.5923 18.9837 3 18.1038 3 17.4998c0-.4402.2984-1.0338 1.2347-1.6653.9142-.6166 2.2766-1.1484 3.9582-1.4791"
    />
  </svg>
);

export const NavigationPointer01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.5951 1.4575c-.3958-.1322-.7643-.0366-.9475.0166-.1996.058-.4375.1509-.6762.2441L3.0143 8.3356c-.2668.104-.5253.205-.7248.3035-.1723.0853-.5387.275-.7431.6686a1.5 1.5 0 0 0 .0008 1.3846c.205.3933.5715.5826.744.6676.1995.0984.458.1989.725.3027l6.7113 2.6099 2.6099 6.7112c.1038.267.2043.5256.3027.7252.085.1724.2743.539.6676.7439a1.5 1.5 0 0 0 1.3846.0008c.3937-.2044.5833-.5708.6686-.7431.0986-.1995.1994-.4579.3035-.7247l6.6174-16.9572c.0932-.2387.1861-.4766.2441-.6762.0532-.1832.1488-.5517.0166-.9475a1.5 1.5 0 0 0-.9474-.9474"
    />
  </svg>
);

export const NavigationPointer02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.6656 1.9025a1.5 1.5 0 0 0-1.3399 0c-.3733.1864-.5662.5146-.6581.6817-.1002.1822-.2028.4161-.3057.6508L3.0507 19.9047c-.1151.2623-.2266.5163-.2979.7271-.0616.1821-.1865.5753-.0528.9982.1475.4664.5131.8316.9797.9785.423.1332.816.0079.9982-.054.2107-.0715.4646-.1833.7267-.2987l6.5911-2.9 6.5911 2.9001c.2621.1153.516.2271.7267.2986.182.0619.5751.1872.9981.054a1.5 1.5 0 0 0 .9797-.9785c.1337-.4229.0088-.8161-.0528-.9982-.0713-.2108-.1828-.4648-.2978-.7271L13.6294 3.2351c-.1029-.2348-.2055-.4687-.3056-.6509-.0919-.1671-.2849-.4953-.6582-.6817"
    />
  </svg>
);

export const NavigationPointerOff01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3.5317 3.5317-2.8103 1.0967c-.2669.104-.5253.2049-.7248.3035-.1723.0853-.5387.275-.7431.6685a1.5 1.5 0 0 0 .0008 1.3847c.205.3933.5715.5826.744.6676.1995.0984.458.1989.725.3027l6.7113 2.6099 2.6099 6.7113c.1038.2669.2043.5255.3027.7251.085.1724.2743.539.6676.7439a1.5 1.5 0 0 0 1.3846.0008c.3937-.2045.5833-.5708.6686-.7431.0986-.1995.1994-.4579.3035-.7247l1.0967-2.8104 3.5318 3.5318c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m18.349 14.1064 3.9328-10.0778c.0932-.2387.1861-.4766.2441-.6762.0532-.1832.1488-.5517.0166-.9475a1.5 1.5 0 0 0-.9474-.9474c-.3958-.1322-.7643-.0366-.9475.0166-.1996.058-.4375.1509-.6762.2441L9.8936 5.651z"
    />
  </svg>
);

export const NavigationPointerOff02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.7071 1.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L7.758 9.1722 3.0506 19.9051c-.115.2623-.2265.5163-.2978.7271-.0616.1822-.1865.5753-.0528.9982a1.5 1.5 0 0 0 .9796.9785c.4231.1333.8161.0079.9982-.0539.2107-.0716.4646-.1833.7268-.2987l6.591-2.9001 6.5911 2.9001c.2621.1154.516.2271.7267.2987.1821.0618.5751.1872.9982.0539a1.5 1.5 0 0 0 .5605-.3226l.4208.4208c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m18.4354 14.1928-4.806-10.9577c-.1029-.2348-.2055-.4687-.3056-.6509-.0919-.1671-.2849-.4953-.6582-.6817a1.5 1.5 0 0 0-1.3399 0c-.3733.1864-.5662.5146-.6581.6817-.1002.1822-.2028.4161-.3057.6508L9.4826 5.24z"
    />
  </svg>
);

export const Passport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.2413 1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642C3 5.2894 3 5.9537 3 6.7587v10.4826c0 .805 0 1.4693.0442 2.0105.046.5621.1445 1.0788.3918 1.5642a4 4 0 0 0 1.748 1.748c.4854.2473 1.002.3459 1.5642.3918C7.2894 23 7.9537 23 8.7587 23h6.4826c.805 0 1.4693 0 2.0105-.0442.5621-.0459 1.0788-.1445 1.5642-.3918a4 4 0 0 0 1.748-1.748c.2473-.4854.3459-1.0021.3918-1.5642C21 18.7106 21 18.0463 21 17.2413V6.7587c0-.805 0-1.4693-.0442-2.0105-.0459-.5621-.1445-1.0788-.3918-1.5642a4 4 0 0 0-1.748-1.748c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 1 16.0463 1 15.2413 1M12 12c1.933 0 3.5-1.567 3.5-3.5S13.933 5 12 5 8.5 6.567 8.5 8.5 10.067 12 12 12m-2 3c-.5523 0-1 .4477-1 1s.4477 1 1 1h4c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Rocket01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.4654 4.3718c1.1624.7712 2.2814 1.6818 3.3285 2.7288 1.0531 1.0531 1.968 2.179 2.7421 3.3485l.2091.3339c.249.3978.3736.5967.4041.8042a1 1 0 0 1-.0704.5397c-.0827.1927-.2541.353-.5968.6736l-2.3059 2.1572.6489 1.9467.022.0654c.0808.2397.1824.5411.1871.8579a2 2 0 0 1-.1539.7988c-.1219.2924-.3283.5345-.4923.7271l-.0447.0525-1.5619 1.8458c-.2679.3167-.5117.605-.7298.8194-.2221.2185-.5315.4794-.9543.5841a2 2 0 0 1-1.5964-.2817c-.3615-.243-.5629-.5941-.6968-.8753-.1315-.2761-.262-.6305-.4054-1.0197l-.3257-.8841c-1.4971.3321-3.1005.0486-4.4095-.844L4.207 21.2071c-.3905.3905-1.0237.3905-1.4142 0-.3906-.3905-.3906-1.0237 0-1.4142l2.4423-2.4423c-.9438-1.3256-1.2493-2.9699-.9093-4.5028l-.884-.3256c-.3892-.1434-.7435-.2739-1.0196-.4054-.2812-.134-.6323-.3353-.8753-.6968a2 2 0 0 1-.2817-1.5965c.1046-.4228.3656-.7322.584-.9542.2145-.218.5027-.462.8194-.7299l1.8459-1.5619.0525-.0446c.1925-.1641.4347-.3704.727-.4924a2 2 0 0 1 .7989-.1538c.3167.0046.6182.1063.8579.187l.0653.022 1.9465.6489 2.171-2.3208c.3312-.354.4967-.531.6953-.6137a1 1 0 0 1 .5541-.0625c.212.0364.4129.172.8146.4433l.261.1763zM14.5746 2.7076c-.298-.2013-.2264-.647.1259-.7193.9459-.1942 1.9347-.2795 2.8714-.4356.7068-.1178 1.303-.2172 1.7881-.2538.5002-.0378 1.0117-.0222 1.4998.1872a3 3 0 0 1 1.5746 1.5745c.2094.4882.2249.9997.1872 1.4998-.0366.4852-.136 1.0813-.2538 1.7882-.1584.9502-.239 1.9612-.4422 2.9219-.0732.3462-.5133.4066-.7011.1066-.8393-1.3403-1.9005-2.5748-3.0164-3.6907-1.1398-1.1398-2.361-2.1342-3.6335-2.9788"
    />
  </svg>
);

export const Plane = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.0263 2.1174c1.3533-1.3978 3.5894-1.4159 4.9651-.0402 1.3381 1.3381 1.363 3.4997.0561 4.8682L19.05 10.0905l1.8115 7.8678c.057.2431.1287.5489.1046.8611-.0208.27-.0962.533-.2217.773-.368.704-1.1559 1.3475-1.7521 1.8438-.2327.1937-.55.4181-.9643.4914a2 2 0 0 1-1.5407-.3637c-.3378-.2508-.5212-.5935-.6427-.8708-.118-.2692-.232-.6115-.3563-.9844l-1.5111-4.5333-2.2012 2.2012c-.1068.1068-.1604.1608-.1975.2019l-.0029.0032c.0055.0954.0178.1905.0283.2854.0634.5707.1252 1.1416.1904 1.7121.0248.2172.056.4906.0125.7637a2 2 0 0 1-.2361.6729c-.1366.2405-.3317.4344-.4868.5885-.3037.3019-.6074.6196-.8687.8389-.1991.1671-.4584.3505-.798.439-.4611.1202-.95.0718-1.3786-.1365-.3157-.1534-.534-.3841-.6964-.587-.7924-.9896-1.4063-2.1268-2.1348-3.1633-1.0364-.7287-2.1737-1.3424-3.1633-2.1348-.2029-.1624-.4336-.3807-.587-.6964a2 2 0 0 1-.1365-1.3785c.0885-.3397.272-.599.439-.7981.2193-.2613.537-.565.8388-.8687.1542-.155.3481-.3502.5886-.4868a2 2 0 0 1 .6729-.236c.273-.0436.5465-.0124.7637.0124.5705.0652 1.1414.127 1.7121.1904.1502.0167.2259.0248.281.028l.0044.0003c.071-.0638.1376-.1329.2051-.2004l2.2012-2.2012-4.5333-1.5111c-.373-.1243-.7152-.2383-.9844-.3563-.2773-.1216-.62-.305-.8708-.6427a2 2 0 0 1-.3637-1.5407c.0733-.4143.2977-.7316.4914-.9643.4946-.5942 1.143-1.3857 1.8438-1.7521.24-.1255.503-.201.773-.2217.3122-.024.618.0476.8611.1046l7.8375 1.8048z"
      clipRule="evenodd"
    />
  </svg>
);

export const Rocket02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.2311 2.7176A13.88 13.88 0 0 1 22.0062.9998c.5499.0034.9938.4501.9938 1 0 2.8103-.7884 7.7077-5.8524 11.4166.0852.3576.1822.8282.2492 1.3483.0731.5674.1143 1.2205.0545 1.8632-.0589.634-.2226 1.3318-.6192 1.9268l-.0009.0013c-.679 1.0149-1.9595 1.6034-2.854 1.9278-.4806.1744-.9247.298-1.2479.3782a10.5 10.5 0 0 1-.5033.1129c-.3082.0586-.6222-.003-.8669-.2072A1 1 0 0 1 11 20v-4.586L8.586 13H4a1 1 0 0 1-.984-1.1786c.0338-.1849.0768-.3684.122-.5507.0802-.3232.2038-.7672.3782-1.2479.3245-.8945.9129-2.175 1.9278-2.854l.0013-.0008c.595-.3967 1.2928-.5604 1.9269-.6193.6426-.0598 1.2958-.0186 1.8631.0545.5255.0678 1.0006.166 1.3595.2519a13.88 13.88 0 0 1 4.6363-4.1375"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.0032 14.9883a3.18 3.18 0 0 0-2.147.7463c-.5268.4428-.9135 1.0526-1.2 1.6392-.2922.5981-.5143 1.2437-.6801 1.8235-.1668.5831-.2827 1.1208-.357 1.5119a16 16 0 0 0-.0823.4709q-.0147.0925-.0277.1852l-.0002.0016a1 1 0 0 0 .284.84c.2203.2204.5316.3253.8405.284q.0933-.0131.1864-.0278a17.3423 17.3423 0 0 0 1.9828-.4393c.5798-.1659 1.2253-.3879 1.8235-.6801.5863-.2864 1.196-.673 1.6386-1.1995 1.021-1.2092 1.0363-3.0926-.152-4.266l-.0122-.0118a3.18 3.18 0 0 0-2.0973-.8781"
      clipRule="evenodd"
    />
  </svg>
);

export const Route = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1 5c0-2.2091 1.7909-4 4-4s4 1.7909 4 4-1.7909 4-4 4-4-1.7909-4-4M15 19c0-2.2091 1.7909-4 4-4s4 1.7909 4 4-1.7909 4-4 4-4-1.7909-4-4M15.3531 6.065C14.5699 6.0009 13.4769 6 11.9344 6H11.5c-.5523 0-1-.4477-1-1s.4477-1 1-1h.4847c1.4811 0 2.6568 0 3.5319.0718.4457.0365.8583.0947 1.2195.197.3601.102.7313.2648 1.0349.5521a3 3 0 0 1 .8798 2.7674c-.082.41-.2909.7572-.5261 1.0485-.2358.292-.539.5778-.8818.865-.673.5639-1.6329 1.2428-2.8421 2.0981L12.3366 13.06l-.0091.0065-2.0323 1.4375c-1.2593.8907-2.1512 1.5225-2.7535 2.0273-.2987.2503-.4912.4409-.6103.5884-.0986.1221-.1195.1813-.1216.1875a1 1 0 0 0 .2915.917c.0054.0038.0566.0401.2076.0828.1824.0517.4496.0962.838.128.7832.0643 1.8763.0651 3.4187.0651H12.5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-.9846c-1.4811 0-2.6569 0-3.532-.0718-.4457-.0365-.8583-.0947-1.2194-.1969-.3602-.102-.7313-.2649-1.035-.5523a3 3 0 0 1-.8797-2.7673c.082-.4099.2908-.7572.526-1.0485.2358-.292.539-.5778.8818-.865.2936-.246.6418-.5139 1.0414-.8087a1 1 0 0 1 .124-.1036l5.7823-4.0899c1.2593-.8907 2.1512-1.5226 2.7536-2.0273.2987-.2503.4911-.4409.6102-.5884.0986-.122.1195-.1813.1216-.1875a1 1 0 0 0-.2915-.917c-.0053-.0038-.0565-.04-.2076-.0828-.1824-.0517-.4496-.0962-.838-.128"
    />
  </svg>
);

export const Ticket01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.1615 3h13.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C23 6.1795 23 6.6343 23 7.1614V8.5c0 .5523-.4477 1-1 1-1.3807 0-2.5 1.1193-2.5 2.5s1.1193 2.5 2.5 2.5c.5523 0 1 .4477 1 1v1.3386c0 .5271 0 .9819-.0306 1.3564-.0323.3954-.1036.7886-.2964 1.167a3 3 0 0 1-1.311 1.311c-.3784.1928-.7716.2641-1.167.2964C19.8205 21 19.3657 21 18.8386 21H5.1614c-.5271 0-.9819 0-1.3564-.0306-.3954-.0323-.7886-.1036-1.167-.2964a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 17.8205 1 17.3657 1 16.8386V15.5c0-.5523.4477-1 1-1 1.3807 0 2.5-1.1193 2.5-2.5S3.3807 9.5 2 9.5c-.5523 0-1-.4477-1-1V7.1614c0-.5271 0-.9819.0306-1.3564.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 3 4.6343 3 5.1615 3M11 6.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v1c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 4c.5523 0 1 .4477 1 1v1c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1c0-.5523.4477-1 1-1m1 6c0-.5523-.4477-1-1-1s-1 .4477-1 1v1c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Ticket02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.7587 3h10.4826c.805 0 1.4693 0 2.0105.0442.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C23 7.2894 23 7.9537 23 8.7587v6.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C18.7106 21 18.0463 21 17.2413 21H6.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C1 16.7106 1 16.0463 1 15.2413V8.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918C5.2894 3 5.9538 3 6.7587 3M9 6.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v1c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 4c.5523 0 1 .4477 1 1v1c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1c0-.5523.4477-1 1-1m1 6c0-.5523-.4477-1-1-1s-1 .4477-1 1v1c0 .5523.4477 1 1 1s1-.4477 1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const Train = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 1c-.5523 0-1 .4477-1 1s.4477 1 1 1h3v1H8.7587c-.805 0-1.4693 0-2.0105.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642-.0177.2169-.0289.4343-.0358.652-.0172.542-.0258.813.0806 1.0339.0916.1902.2512.3549.4384.4525C3.7447 10 4.0298 10 4.6 10h14.8c.5702 0 .8553 0 1.0726-.1134a1.02 1.02 0 0 0 .4384-.4525c.1064-.2209.0978-.4919.0806-1.034a13 13 0 0 0-.0358-.652c-.0459-.562-.1445-1.0787-.3918-1.564a4 4 0 0 0-1.748-1.7481c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 4 16.0463 4 15.2413 4H13V3h3c.5523 0 1-.4477 1-1s-.4477-1-1-1zM9.5 21c-.5523 0-1 .4477-1 1s.4477 1 1 1h5c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.3788 19.9939C16.0356 20 15.6572 20 15.2413 20H8.7587c-.4159 0-.7943 0-1.1375-.0061l-1.2268 2.4535c-.247.494-.8477.6942-1.3416.4472-.494-.2469-.6942-.8476-.4473-1.3416l.9201-1.8402a3.1 3.1 0 0 1-.3416-.1488 4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 15.7106 3 15.0463 3 14.2413V13.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C3.76 12 4.04 12 4.6 12h14.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054v.6413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748 3.1 3.1 0 0 1-.3417.1488l.9201 1.8402c.247.494.0468 1.0947-.4472 1.3416-.494.247-1.0947.0468-1.3417-.4472zM8.5 14c-.8284 0-1.5.6716-1.5 1.5S7.6716 17 8.5 17s1.5-.6716 1.5-1.5S9.3284 14 8.5 14m7 0c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Tram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5752 1c-.3669 0-.6443-.0002-.9216.0387a4 4 0 0 0-.721.1702c-.2654.0892-.5135.2134-.8415.3775l-1.0383.5192c-.494.247-.6942.8477-.4473 1.3416.247.494.8477.6942 1.3417.4472l.9865-.4932c.4018-.201.5198-.2574.6367-.2968.1173-.0394.238-.068.3605-.085.0956-.0135.1965-.0177.4512-.019L9.3818 5h-.623c-.805 0-1.4694 0-2.0106.0442-.5621.046-1.0788.1445-1.5642.3918a4 4 0 0 0-1.748 1.748c-.2473.4854-.3459 1.002-.3918 1.5642-.0177.2169-.0289.4343-.0358.652-.0172.542-.0258.813.0806 1.0339.0916.1902.2512.3549.4384.4525C3.7447 11 4.0298 11 4.6 11h14.8c.5702 0 .8553 0 1.0726-.1134a1.02 1.02 0 0 0 .4384-.4525c.1064-.2209.0978-.4919.0806-1.034a13 13 0 0 0-.0358-.652c-.0459-.562-.1445-1.0787-.3918-1.564a4 4 0 0 0-1.748-1.7481c-.4854-.2473-1.0021-.3459-1.5642-.3918C16.7106 5 16.0463 5 15.2413 5h-.6232l.9998-1.9995c.2547.0012.3555.0054.4512.0188.1225.0172.2432.0457.3604.0851.117.0394.2349.0959.6368.2968l.9865.4933c.4939.247 1.0946.0467 1.3416-.4473s.0468-1.0946-.4472-1.3416l-1.0383-.5192c-.3281-.1641-.5762-.2883-.8416-.3776a4 4 0 0 0-.7209-.1702C16.069.9999 15.7916 1 15.4248 1zm3.8069 4 1-2h-2.7642l1 2zM16.3788 20.9939C16.0356 21 15.6572 21 15.2413 21H8.7587c-.4159 0-.7943 0-1.1375-.0061l-.7266 1.4535c-.247.494-.8476.6942-1.3416.4473s-.6943-.8476-.4473-1.3416l.42-.8403a3.1 3.1 0 0 1-.3417-.1488 4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C3 16.7106 3 16.0463 3 15.2413V14.6c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C3.76 13 4.04 13 4.6 13h14.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054v.6413c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748 3.1 3.1 0 0 1-.3417.1488l.4201.8402c.247.494.0468 1.0947-.4472 1.3416-.494.247-1.0947.0468-1.3417-.4472zM8.5 15c-.8284 0-1.5.6716-1.5 1.5S7.6716 18 8.5 18s1.5-.6716 1.5-1.5S9.3284 15 8.5 15m7 0c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Truck01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.8385 3h-5.677c-.5272 0-.982 0-1.3565.0306-.3954.0323-.7886.1036-1.167.2964a3 3 0 0 0-1.311 1.311c-.1928.3784-.2641.7716-.2964 1.167C1 6.1795 1 6.6343 1 7.1614V15c0 1.3406.8794 2.4759 2.0928 2.8604C3.4864 19.656 5.0862 21 7 21c1.8638 0 3.4299-1.2748 3.874-3h3.1064l.0196.0002h.5355C14.7782 19.6962 16.2368 21 18 21c1.7841 0 3.2565-1.335 3.4727-3.0605a1.76 1.76 0 0 0 .2927-.0915c.49-.203.8794-.5924 1.0824-1.0824.0969-.2341.1274-.4598.1404-.6502.0118-.1741.0118-.3787.0118-.5887v-2.8638l.0001-.051c.0005-.1899.0011-.4291-.0554-.6644a2 2 0 0 0-.2394-.5781c-.1265-.2063-.296-.375-.4307-.5089l-.0361-.036-4.0628-4.0628-.036-.0361c-.1339-.1347-.3026-.3042-.5089-.4307a2 2 0 0 0-.5781-.2394c-.2354-.0566-.4745-.056-.6644-.0554h-1.4059a7 7 0 0 0-.013-.1951c-.0323-.3954-.1036-.7886-.2964-1.167a3 3 0 0 0-1.311-1.311c-.3784-.1928-.7716-.2641-1.167-.2964C11.8205 3 11.3657 3 10.8385 3m10.1612 12.6957C21 15.6394 21 15.5749 21 15.5002v-2.8373c0-.131-.0002-.1963-.0024-.2438l-.0002-.0036-.0024-.0027c-.032-.0351-.0781-.0815-.1707-.1741l-4.0628-4.0628c-.0926-.0926-.139-.1387-.1741-.1707l-.0027-.0024-.0036-.0002c-.0475-.0022-.1128-.0024-.2438-.0024H15v7.696C15.6125 14.6798 16.7268 14 18 14c1.273 0 2.3872.6796 2.9997 1.6957M7 15c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m9.5 2.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5S18.8284 19 18 19s-1.5-.6716-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Truck02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.1615 2h7.677c.5272 0 .982 0 1.3565.0306.3954.0323.7886.1036 1.167.2964a3 3 0 0 1 1.311 1.311c.1928.3784.2641.7716.2964 1.167C17 5.1796 17 5.6343 17 6.1615v.8387h1.3373L18.3883 7c.1899-.0005.429-.0011.6644.0554.2041.049.3991.1297.5781.2394.2063.1265.375.296.5089.4307l.036.0361 2.0628 2.0628.0361.036c.1347.134.3042.3026.4307.5089.1096.179.1904.374.2394.5781.0565.2353.0559.4745.0554.6644l-.0001.051v2.7692c0 .2524.0001.4982-.0169.7063-.0187.2286-.0628.4983-.2011.7698a2 2 0 0 1-.874.874c-.2714.1383-.5412.1824-.7698.201-.1438.0118-.3056.0154-.4752.0165.2161.4547.337.9634.337 1.5003 0 1.933-1.567 3.5-3.5 3.5S14 20.433 14 18.5c0-.5368.1208-1.0454.3368-1.5H9.6632c.216.4546.3368.9632.3368 1.5 0 1.933-1.567 3.5-3.5 3.5S3 20.433 3 18.5c0-.5704.1364-1.1089.3784-1.5846-.2506-.0455-.4985-.1192-.7404-.2424a3 3 0 0 1-1.311-1.311c-.1928-.3784-.2641-.7716-.2964-1.167C1 13.8205 1 13.3657 1 12.8386V6.1615c0-.5272 0-.982.0306-1.3565.0323-.3954.1036-.7886.2964-1.167a3 3 0 0 1 1.311-1.311c.3784-.1928.7716-.2641 1.167-.2964C4.1795 2 4.6343 2 5.1615 2m12.3143 15.0002h.0484C18.3415 17.0131 19 17.6797 19 18.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5c0-.8203.6585-1.4869 1.4758-1.4998m-.0127-2H17v-6h1.3373c.131 0 .1963.0002.2438.0024l.0036.0002.0027.0024c.0351.032.0815.0781.1741.1707l2.0628 2.0628c.0926.0926.1387.139.1707.1741l.0024.0027.0002.0036c.0022.0475.0024.1128.0024.2438v2.7373c0 .2965-.0008.4588-.0103.5754l-.0011.0131-.0132.0012c-.1166.0095-.2789.0103-.5754.0103h-2.8631L17.5 15zM8 18.5c0-.8276-.6703-1.4987-1.4976-1.5h-.0048C5.6703 17.0013 5 17.6724 5 18.5c0 .8284.6716 1.5 1.5 1.5S8 19.3284 8 18.5"
      clipRule="evenodd"
    />
  </svg>
);

export const Cloud01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 4C8.7764 4 6.0632 6.1782 5.2492 9.143 2.814 9.7096 1 11.8925 1 14.5 1 17.5376 3.4624 20 6.5 20h11c3.0376 0 5.5-2.4624 5.5-5.5 0-2.6075-1.8139-4.7904-4.2492-5.357C17.9368 6.1782 15.2236 4 12 4"
    />
  </svg>
);

export const Cloud02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 3c-4.2188 0-7.6749 3.2656-7.9783 7.407C2.2446 11.1735 1 12.9404 1 15c0 2.7614 2.2386 5 5 5h11.5c3.0376 0 5.5-2.4624 5.5-5.5 0-2.1919-1.2817-4.0823-3.1342-4.9663C19.1766 5.8153 15.9177 3 12 3"
    />
  </svg>
);

export const Cloud03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.5 3C4.8056 3 1 6.8056 1 11.5S4.8056 20 9.5 20h7c3.5898 0 6.5-2.9101 6.5-6.5 0-3.5181-2.795-6.3834-6.2856-6.4965C15.2141 4.601 12.5447 3 9.5 3"
    />
  </svg>
);

export const CloudLightning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.4914 8.1868C22.0836 8.8498 24 11.2011 24 14c0 3.3137-2.6863 6-6 6H6.5C2.9102 20 0 17.0899 0 13.5c0-3.0623 2.1176-5.63 4.9684-6.3185C6.324 4.6905 8.9646 3 12 3c3.4283 0 6.3528 2.1564 7.4914 5.1868m-5.8545.4084c.3287-.4438.2355-1.07-.2083-1.3988s-1.0701-.2354-1.3988.2084l-3.3334 4.5A1 1 0 0 0 9.5 13.5h3.0148l-2.1517 2.9048c-.3287.4438-.2355 1.07.2083 1.3988s1.0701.2354 1.3988-.2084l3.3334-4.5A1 1 0 0 0 14.5 11.5h-3.0148z"
      clipRule="evenodd"
    />
  </svg>
);

export const CloudMoon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.1336 2.4057a.9997.9997 0 0 0-1.2124-1.2123C12.0948 1.899 10 4.4536 10 7.5a6.5 6.5 0 0 0 .1854 1.5469c-2.5193.2919-4.6293 1.9212-5.6046 4.1577C2.5105 13.8165 1 15.731 1 18c0 2.7614 2.2386 5 5 5h11.5c3.0376 0 5.5-2.4624 5.5-5.5 0-2.0122-1.0806-3.772-2.6931-4.7308 1.2219-.8846 2.1238-2.1838 2.5-3.691a1 1 0 0 0-1.2125-1.2124 4.5 4.5 0 0 1-1.0944.1338c-2.4853 0-4.5-2.0147-4.5-4.5 0-.3785.0465-.7447.1336-1.0939m.6072 9.588c1.4619-.0771 2.74-.8523 3.5053-1.999-3.3877-.1301-6.1107-2.8529-6.2412-6.2404C12.796 4.5613 12 5.9384 12 7.5a4.49 4.49 0 0 0 .3003 1.6205c1.8325.3443 3.4124 1.4027 4.4405 2.8731"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M6 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H3c-.5523 0-1 .4477-1 1s.4477 1 1 1h1v1c0 .5523.4477 1 1 1s1-.4477 1-1V6h1c.5523 0 1-.4477 1-1s-.4477-1-1-1H6z"
    />
  </svg>
);

export const CloudOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.7071 2.2929c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142l3.699 3.699a6.97 6.97 0 0 0-.7427 1.7368C2.814 9.7095 1 11.8924 1 14.4999c0 3.0375 2.4624 5.5 5.5 5.5h11c.3372 0 .6681-.0305.9899-.089l.0057-.0011 1.7973 1.7973c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M21.9607 17.7181C22.6146 16.8133 23 15.7017 23 14.5c0-2.6075-1.8139-4.7904-4.2492-5.357C17.9368 6.1782 15.2236 4 12 4c-1.0961 0-2.1331.2518-3.0566.7008z"
    />
  </svg>
);

export const CloudRaining01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 18c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1M16 18c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1M12 19c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12 1C8.7764 1 6.0632 3.1782 5.2492 6.143 2.814 6.7096 1 8.8925 1 11.5 1 14.5376 3.4624 17 6.5 17h11c3.0376 0 5.5-2.4624 5.5-5.5 0-2.6075-1.8139-4.7904-4.2492-5.357C17.9368 3.1782 15.2236 1 12 1"
    />
  </svg>
);

export const CloudRaining02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.2492 6.143C6.0632 3.1782 8.7764 1 12 1s5.9368 2.1782 6.7508 5.143C21.1861 6.7096 23 8.8925 23 11.5c0 3.0376-2.4624 5.5-5.5 5.5H17v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3h-2v5c0 .5523-.4477 1-1 1s-1-.4477-1-1v-5H9v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3h-.5C3.4624 17 1 14.5376 1 11.5c0-2.6075 1.8139-4.7904 4.2492-5.357"
    />
  </svg>
);

export const CloudRaining03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.2492 6.143C6.0632 3.1782 8.7764 1 12 1s5.9368 2.1782 6.7508 5.143C21.1861 6.7096 23 8.8925 23 11.5c0 3.0376-2.4624 5.5-5.5 5.5h-.973l-1.3485 3.3712c-.2051.5128-.7871.7622-1.2999.5571-.5128-.2052-.7622-.7871-.5571-1.2999L14.3729 17h-1.846l-2.1485 5.3712c-.2051.5128-.787.7622-1.2998.5571-.5128-.2052-.7622-.7871-.5571-1.2999L10.3729 17h-1.846l-1.3484 3.3712c-.2051.5128-.787.7622-1.2999.5571-.5127-.2052-.7622-.7871-.557-1.2999l1.0519-2.6298C3.3944 16.9313 1 14.4953 1 11.5c0-2.6075 1.8139-4.7904 4.2492-5.357"
    />
  </svg>
);

export const CloudRaining04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1C9.689 1 7.6613 2.2062 6.5094 4.0198 3.4252 4.2694 1 6.8515 1 10c0 3.3137 2.6863 6 6 6h10.5c3.0376 0 5.5-2.4624 5.5-5.5 0-2.8652-2.1909-5.2187-4.9888-5.4765C17.0375 2.6626 14.714 1 12 1M8 17.5c.5523 0 1 .4477 1 1V21c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2.5c0-.5523.4477-1 1-1M16 17.5c.5523 0 1 .4477 1 1V21c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2.5c0-.5523.4477-1 1-1M13 19.5c0-.5523-.4477-1-1-1s-1 .4477-1 1V22c0 .5523.4477 1 1 1s1-.4477 1-1z"
    />
  </svg>
);

export const CloudRaining05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1C9.689 1 7.6613 2.2062 6.5094 4.0198 3.4252 4.2694 1 6.8515 1 10c0 3.3137 2.6863 6 6 6h10.5c3.0376 0 5.5-2.4624 5.5-5.5 0-2.8652-2.1909-5.2187-4.9888-5.4765C17.0375 2.6626 14.714 1 12 1M8.3714 17.5713c.5128.2051.7622.7871.5571 1.2999l-1 2.5c-.2051.5128-.787.7622-1.2999.5571-.5127-.2052-.7622-.7871-.557-1.2999l1-2.5c.205-.5128.787-.7622 1.2998-.5571M16.3714 17.5713c.5128.2051.7622.7871.5571 1.2999l-1 2.5c-.2051.5128-.7871.7622-1.2999.5571-.5128-.2052-.7622-.7871-.5571-1.2999l1-2.5c.2052-.5128.7871-.7622 1.2999-.5571M12.9285 18.8712c.2051-.5128-.0443-1.0948-.5571-1.2999s-1.0947.0443-1.2999.5571l-1 2.5c-.205.5128.0443 1.0947.5571 1.2999.5128.2051 1.0948-.0443 1.2999-.5571z"
    />
  </svg>
);

export const CloudRaining06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1C9.689 1 7.6613 2.2062 6.5094 4.0198 3.4252 4.2694 1 6.8515 1 10c0 3.3137 2.6863 6 6 6h10.5c3.0376 0 5.5-2.4624 5.5-5.5 0-2.8652-2.1909-5.2187-4.9888-5.4765C17.0375 2.6626 14.714 1 12 1M4 18c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1M10 17c-.5523 0-1 .4477-1 1s.4477 1 1 1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1zM6 20c-.5523 0-1 .4477-1 1s.4477 1 1 1h7c.5523 0 1-.4477 1-1s-.4477-1-1-1zM16 20c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const CloudSnowing01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.2492 6.143C6.0632 3.1782 8.7764 1 12 1s5.9368 2.1782 6.7508 5.143C21.1861 6.7096 23 8.8925 23 11.5c0 3.0376-2.4624 5.5-5.5 5.5h-11C3.4624 17 1 14.5376 1 11.5c0-2.6075 1.8139-4.7904 4.2492-5.357M8 18.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zM11 22c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M15 19.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H16c-.5523 0-1-.4477-1-1"
    />
  </svg>
);

export const CloudSnowing02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1C9.689 1 7.6613 2.2062 6.5094 4.0198 3.4252 4.2694 1 6.8515 1 10c0 3.3137 2.6863 6 6 6h10.5c3.0376 0 5.5-2.4624 5.5-5.5 0-2.8652-2.1909-5.2187-4.9888-5.4765C17.0375 2.6626 14.714 1 12 1M8 17c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zM8 20c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zM11 18.5c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1M12 20.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1zM15 18c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H16c-.5523 0-1-.4477-1-1M16 20c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const CloudSun01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.0723 7.0657C11.521 4.1957 14.0041 2 17 2c3.3137 0 6 2.6863 6 6 0 1.7185-.7227 3.2673-1.8786 4.3604C22.2728 13.3685 23 14.8493 23 16.5c0 3.0376-2.4624 5.5-5.5 5.5H7c-3.3137 0-6-2.6863-6-6 0-3.1485 2.4252-5.7306 5.5094-5.9802.9949-1.5664 2.6431-2.6797 4.5629-2.954m8.2007 4.2263a5.48 5.48 0 0 0-1.2618-.2686c-.8388-2.0336-2.6792-3.5492-4.908-3.9302C13.514 5.321 15.1027 4 17 4c2.2091 0 4 1.7909 4 4 0 1.3636-.682 2.5691-1.727 3.292"
      clipRule="evenodd"
    />
  </svg>
);

export const CloudSun02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.5 1.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.6c0 .5523.4477 1 1 1s1-.4477 1-1zM2 9c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.6c.5523 0 1-.4477 1-1s-.4477-1-1-1zM3.6127 3.1127c.3905-.3905 1.0237-.3905 1.4142 0l1.1314 1.1314c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L3.6127 4.5269c-.3905-.3905-.3905-1.0237 0-1.4142M17.3883 4.527c.3905-.3906.3905-1.0238 0-1.4143s-1.0237-.3905-1.4142 0l-1.1314 1.1314c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM16.4 10c0-.5523.4477-1 1-1H19c.5523 0 1 .4477 1 1s-.4477 1-1 1h-1.6c-.5523 0-1-.4477-1-1M7.5001 10c0-1.6569 1.3432-3 3-3 1.1282 0 2.1124.6223 2.6256 1.5472.268.483.8767.6572 1.3596.3892s.6572-.8767.3892-1.3596C14.023 6.0422 12.384 5 10.5001 5c-2.7614 0-5 2.2386-5 5 0 .5523.4477 1 1 1s1-.4477 1-1M12 10c-2.2463 0-4.2025 1.2341-5.2307 3.059A5 5 0 0 0 6 13c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5h12c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5c-.2612 0-.5182.0201-.7693.059C16.2025 11.2341 14.2463 10 12 10"
    />
  </svg>
);

export const CloudSun03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.5 3C6.9102 3 4 5.9101 4 9.5c0 .4465.0449.8815.13 1.3011.11.5412-.2398 1.069-.781 1.1789s-1.0691-.2398-1.179-.7811A8.53 8.53 0 0 1 2 9.5C2 4.8056 5.8056 1 10.5 1c4.311 0 7.8709 3.2083 8.4252 7.368.0729.5474-.3118 1.0503-.8592 1.1232-.5475.073-1.0504-.3117-1.1233-.8591C16.5191 5.453 13.7952 3 10.5 3"
    />
    <path
      fill="currentColor"
      d="M12 9c-2.798 0-5.2104 1.641-6.3312 4.0108C3.0618 13.1813 1 15.3499 1 18c0 2.7614 2.2386 5 5 5h11.5c3.0376 0 5.5-2.4624 5.5-5.5 0-2.9541-2.329-5.3643-5.251-5.4945C16.4857 10.1906 14.3824 9 12 9"
    />
  </svg>
);

export const Droplets01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 1a1 1 0 0 0-.8501.4734 27 27 0 0 0-.1362.2242c-.0846.141-.2048.3437-.3487.5933-.2874.4983-.6716 1.1875-1.057 1.9484-.384.758-.7773 1.6026-1.0767 2.4089C1.2415 7.4285 1 8.2745 1 9c0 2.2091 1.7909 4 4 4s4-1.7909 4-4c0-.7255-.2415-1.5715-.5313-2.3518-.2994-.8063-.6926-1.651-1.0766-2.409-.3855-.7608-.7697-1.45-1.057-1.9483a39 39 0 0 0-.3488-.5933 27 27 0 0 0-.1362-.2242A1 1 0 0 0 5 1M9 16c0 3.866 3.134 7 7 7s7-3.134 7-7c0-1.2647-.429-2.8178-1.0001-4.3555-.5806-1.5636-1.3488-3.2159-2.1078-4.714-.7605-1.501-1.5197-2.8631-2.0883-3.8491a78 78 0 0 0-.6886-1.1715 50 50 0 0 0-.1943-.321l-.0708-.1155a1 1 0 0 0-1.7002 0l-.0708.1154a50 50 0 0 0-.1943.3211 78 78 0 0 0-.6886 1.1715c-.5686.986-1.3278 2.348-2.0883 3.849-.759 1.4982-1.5272 3.1505-2.1078 4.7141C9.4291 13.1822 9 14.7353 9 16"
    />
  </svg>
);

export const Droplets02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.9806 2.3039a1 1 0 0 0-1.9612 0C10.5674 4.5638 9.1992 6.76 7.3753 8.219 5.1957 9.9628 4 12.1294 4 14.5a8.0001 8.0001 0 0 0 13.6569 5.6569A8 8 0 0 0 20 14.5c0-2.3706-1.1957-4.5372-3.3753-6.2809-1.8239-1.459-3.1921-3.6553-3.6441-5.9152"
    />
  </svg>
);

export const Droplets03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.9806 4.5837a1 1 0 0 0-1.9612 0c-.2436 1.2181-.967 2.4015-1.9341 3.1752C2.7421 8.8334 2 10.2237 2 11.7298c0 2.7593 2.2348 5.05 5 5.05s5-2.2907 5-5.05c0-1.524-.7593-2.8892-2.0779-3.9649-.969-.7904-1.6992-1.9695-1.9415-3.1812"
    />
    <path
      fill="currentColor"
      d="M14 1.5a1 1 0 0 1 .9806.8039c.452 2.2599 1.8202 4.4561 3.6441 5.9152 2.179 1.7432 3.3746 3.9091 3.3753 6.2788a7.98 7.98 0 0 1-4.9067 7.3955 7.98 7.98 0 0 1-3.0932.6154 7.98 7.98 0 0 1-3.0933-.6154 7.99 7.99 0 0 1-2.8404-2.0071c-.2729-.3009-.4093-.4514-.4276-.6111a.494.494 0 0 1 .1193-.385c.1055-.1214.3527-.18.847-.2973C11.7146 17.8549 14 15.0227 14 11.7298c0-1.9644-.8657-3.6575-2.1991-4.9653-.2058-.2019-.3088-.3029-.3478-.3984-.0384-.094-.0469-.166-.0312-.2662.0159-.102.0915-.2221.2428-.4624.6509-1.034 1.1231-2.1755 1.3547-3.3336A1 1 0 0 1 14 1.5"
    />
  </svg>
);

export const Hurricane01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.53 20.2573c.134-.5357.6771-.8613 1.2129-.7272C8.9045 19.821 10.3796 20 12 20s3.0955-.179 4.2571-.4699c.5358-.1341 1.0788.1915 1.213.7272.1341.5358-.1915 1.0788-.7272 1.2129C15.3975 21.8071 13.7564 22 12 22s-3.3975-.1929-4.7429-.5298c-.5357-.1341-.8613-.6771-.7272-1.2129M5.0645 16.0772c.1951-.5166.7721-.7773 1.2888-.5822 1.3202.4986 3.3371.8383 5.6467.8383s4.3265-.3397 5.6467-.8383c.5167-.1951 1.0937.0656 1.2888.5822s-.0655 1.0937-.5822 1.2889c-1.6116.6086-3.8841.9672-6.3533.9672s-4.7417-.3586-6.3533-.9672c-.5167-.1952-.7773-.7722-.5822-1.2889M3.6513 11.139c.292-.4687.9088-.6119 1.3776-.3199 1.194.7441 3.7895 1.3476 6.9711 1.3476 3.1817 0 5.7771-.6035 6.9711-1.3476.4688-.292 1.0855-.1488 1.3776.3199s.1489 1.0855-.3198 1.3776c-1.6688 1.0398-4.7168 1.6501-8.0289 1.6501s-6.36-.6103-8.0289-1.6501c-.4687-.2921-.6119-.9089-.3198-1.3776M5.3198 2.93C7.0754 2.3448 9.4372 2 12 2s4.9246.3448 6.6802.93c.8726.2908 1.6508.6592 2.2315 1.1168C21.4811 4.4957 22 5.148 22 6s-.5189 1.5044-1.0883 1.9532c-.5807.4576-1.3589.826-2.2315 1.1168-1.7556.5852-4.1173.93-6.6802.93s-4.9246-.3448-6.6802-.93c-.8726-.2909-1.6508-.6592-2.2315-1.1169C2.5189 7.5045 2 6.852 2 6s.5189-1.5044 1.0883-1.9531c.5807-.4577 1.359-.826 2.2315-1.1169"
      clipRule="evenodd"
    />
  </svg>
);

export const Hurricane02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 19a7.1 7.1 0 0 0 1-.0709C7.6077 18.4439 5 15.5265 5 12c0-4.9706 4.0294-9 9-9s9 4.0294 9 9c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-3.866-3.134-7-7-7-.3395 0-.6734.0242-1 .0709 3.3923.4852 6 3.4026 6 6.9291 0 4.9706-4.0294 9-9 9s-9-4.0294-9-9c0-.5523.4477-1 1-1s1 .4477 1 1c0 3.866 3.134 7 7 7m2-9c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Hurricane03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 8c0-.5523.4477-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1H6c-.5523 0-1-.4477-1-1M7 16c0-.5523.4477-1 1-1h7c.5523 0 1 .4477 1 1s-.4477 1-1 1H8c-.5523 0-1-.4477-1-1M2 4c0-.5523.4477-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1M8 12c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.5523 0-1-.4477-1-1M11 20c0-.5523.4477-1 1-1h5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-5c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const Lightning01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.9923 2.124a1.0001 1.0001 0 0 0-1.7605-.7641L3.3023 12.0752c-.1543.1851-.3106.3726-.4244.5374-.1076.1558-.3041.4622-.3102.8648-.007.461.1984.8996.557 1.1893.3132.2531.6744.2983.863.3154.1994.0181.4435.018.6845.018h6.195l-.8595 6.8759a1.0001 1.0001 0 0 0 1.7605.7642l8.9295-10.7153c.1543-.1851.3106-.3726.4244-.5374.1076-.1558.3041-.4622.3102-.8648a1.5 1.5 0 0 0-.557-1.1893c-.3133-.2531-.6744-.2983-.863-.3154C19.8128 9 19.5687 9 19.3277 9h-6.1949z"
    />
  </svg>
);

export const Lightning02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.4944 1.0001 8.4594 1c-.1269-.0013-.39-.0039-.6395.0822a1.5 1.5 0 0 0-.5605.3464c-.1886.1847-.304.4212-.3596.5352l-.0154.0314-4.2141 8.4283c-.0833.1665-.1736.3469-.2357.5059-.065.1667-.1595.4517-.1095.7901.0603.4081.286.7734.6242 1.0099.2802.196.5774.2391.7556.2554.17.0155.3717.0155.5579.0154h4.8931l-2.6138 8.7127a1 1 0 0 0 1.6777.9815L20.4386 10.023c.1832-.19.3645-.378.4974-.5428.12-.149.3561-.458.384-.8814a1.5 1.5 0 0 0-.5288-1.2446c-.3242-.2738-.7106-.3184-.9011-.3354-.2109-.0188-.472-.0187-.736-.0187H13.443l1.7433-4.6489a1 1 0 0 0-.9363-1.351z"
    />
  </svg>
);

export const Moon01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.067 2.412A1 1 0 0 0 7.7436 1.089C3.769 2.8864 1 6.8876 1 11.5377 1 17.8682 6.1319 23 12.4623 23c4.6501 0 8.6513-2.7689 10.4489-6.7437a1.0001 1.0001 0 0 0-1.3233-1.3232c-1.1864.5366-2.5041.8358-3.8944.8358-5.2259 0-9.4623-4.2364-9.4623-9.4623 0-1.3903.2992-2.708.8357-3.8945"
    />
  </svg>
);

export const Moon02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.5395 2.9138a1 1 0 0 0-.5896-1.8644C5.3669 1.5788 1 6.2788 1 12c0 6.0751 4.9249 11 11 11 5.7208 0 10.4206-4.3664 10.9504-9.949a1 1 0 0 0-1.8643-.5897c-1.2063 2.1159-3.4806 3.5389-6.0861 3.5389-3.866 0-7-3.134-7-7C8 6.3945 9.4232 4.12 11.5395 2.9138"
    />
  </svg>
);

export const MoonEclipse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1C5.9249 1 1 5.9249 1 12s4.9249 11 11 11c1.7264 0 3.3625-.3984 4.8189-1.1092a1 1 0 0 0-.4801-1.8978A8 8 0 0 1 16 20c-4.4183 0-8-3.5817-8-8s3.5817-8 8-8q.1704 0 .3388.007a1 1 0 0 0 .4801-1.8978C15.3625 1.3984 13.7264 1 12 1M19.4008 5.201c.4415-.3319 1.0684-.243 1.4002.1984 2.9326 3.9009 2.9319 9.3037-.0019 13.2039-.3319.4414-.9589.53-1.4002.198-.4414-.332-.53-.9589-.198-1.4003 2.3982-3.1883 2.3988-7.611.0015-10.7998-.3319-.4414-.243-1.0683.1984-1.4002"
    />
  </svg>
);

export const MoonStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 1a1 1 0 0 1 .8944.5528l.6178 1.2356c.2825.565.3686.7275.4732.8632.1049.1361.2269.2581.363.363.1357.1046.2983.1907.8632.4732l1.2356.6178a1 1 0 0 1 0 1.7888l-1.2356.6178c-.5649.2825-.7275.3686-.8632.4732a2 2 0 0 0-.363.363c-.1046.1357-.1907.2983-.4732.8632l-.6178 1.2356a1 1 0 0 1-1.7888 0l-.6178-1.2356c-.2825-.565-.3686-.7275-.4732-.8632a2 2 0 0 0-.363-.363c-.1357-.1046-.2983-.1907-.8632-.4732l-1.2356-.6178a1 1 0 0 1 0-1.7888l1.2356-.6178c.5649-.2825.7275-.3686.8632-.4732a2 2 0 0 0 .363-.363c.1046-.1357.1907-.2983.4732-.8632l.6178-1.2356A1 1 0 0 1 18 1m0 3.2279c-.1284.2424-.2523.4514-.4014.6447a4 4 0 0 1-.726.726c-.1933.149-.4022.273-.6447.4014.2425.1284.4514.2523.6447.4013.2722.2099.5162.4539.726.726.1491.1934.273.4024.4014.6448.1284-.2424.2523-.4514.4014-.6447a4 4 0 0 1 .726-.726c.1933-.149.4022-.273.6447-.4014-.2425-.1284-.4514-.2523-.6447-.4013a4 4 0 0 1-.726-.726c-.1491-.1934-.273-.4024-.4014-.6448"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M11.1067 3.8688a1 1 0 0 0-.5896-1.8643C5.1769 2.5108 1 7.0063 1 12.4786 1 18.2894 5.7106 23 11.5215 23c5.472 0 9.9673-4.1764 10.474-9.5162a.9999.9999 0 0 0-1.8642-.5897c-1.1404 2.0004-3.2904 3.3454-5.7534 3.3454-3.6545 0-6.6171-2.9626-6.6171-6.6171 0-2.4631 1.3452-4.6133 3.3459-5.7536"
    />
  </svg>
);

export const Snowflake01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.2929 1.2929c.3905-.3905 1.0237-.3905 1.4142 0L12 3.5858l2.2929-2.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L13 5.4142v4.8539l4.2034-2.4269.9909-3.698c.1429-.5334.6913-.85 1.2247-.707.5335.143.8501.6913.7071 1.2247l-.8392 3.1322 3.1321.8392c.5335.143.8501.6913.7071 1.2248-.1429.5334-.6912.85-1.2247.7071l-3.698-.9909L14.0004 12l4.203 2.4267 3.698-.9909c.5335-.143 1.0818.1736 1.2247.7071.143.5335-.1736 1.0818-.7071 1.2247l-3.1321.8393.8392 3.1321c.143.5335-.1736 1.0819-.7071 1.2248s-1.0818-.1736-1.2247-.7071l-.9909-3.698L13 13.7317v4.8541l2.7071 2.7071c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L12 20.4142l-2.2929 2.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L11 18.5858v-4.8536l-4.2035 2.4269-.9908 3.698c-.143.5334-.6913.85-1.2248.7071s-.85-.6913-.7071-1.2248l.8393-3.1321-3.1322-.8393c-.5335-.1429-.85-.6912-.7071-1.2247s.6913-.8501 1.2247-.7071l3.698.9908 4.2039-2.4271-4.2033-2.4267-3.6984.991c-.5335.1429-1.0818-.1737-1.2248-.7071s.1737-1.0818.7071-1.2248l3.1322-.8392-.8393-3.1322c-.143-.5334.1737-1.0818.7071-1.2247.5335-.143 1.0818.1736 1.2248.707l.9907 3.6976L11 10.2676V5.4142l-2.7071-2.707c-.3905-.3906-.3905-1.0238 0-1.4143"
    />
  </svg>
);

export const Snowflake02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1c.5523 0 1 .4477 1 1v3.5858l3.2929-3.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L13 8.4142V11h2.5858l4.7071-4.7071c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142L18.4142 11H22c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3.5858l3.2929 3.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L15.5858 13H13v2.5858l4.7071 4.7071c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 18.4142V22c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3.5858l-3.2929 3.2929c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142L11 15.5858V13H8.4142l-4.707 4.7071c-.3906.3905-1.0238.3905-1.4143 0s-.3905-1.0237 0-1.4142L5.5858 13H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h3.5858l-3.293-3.2929c-.3904-.3905-.3904-1.0237 0-1.4142.3906-.3905 1.0238-.3905 1.4143 0L8.4142 11H11V8.4142l-4.7071-4.707c-.3905-.3906-.3905-1.0238 0-1.4143s1.0237-.3905 1.4142 0L11 5.5858V2c0-.5523.4477-1 1-1"
    />
  </svg>
);

export const Stars01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.9333 1.641a.9999.9999 0 0 0-1.8666 0L12.888 4.7054c-.3004.781-.3948 1.0061-.5239 1.1878a2 2 0 0 1-.471.471c-.1815.129-.4066.2234-1.1877.5238L7.641 8.0666a1 1 0 0 0 0 1.8668l3.0644 1.1786c.7811.3004 1.0062.3948 1.1877.5239.1823.1296.3414.2887.471.471.1291.1815.2235.4066.5239 1.1877l1.1787 3.0644a.9998.9998 0 0 0 1.8666 0l1.1787-3.0644c.3004-.7811.3948-1.0062.5239-1.1877a2 2 0 0 1 .471-.471c.1815-.1291.4066-.2235 1.1877-.5239l3.0644-1.1786a1 1 0 0 0 0-1.8668L19.2946 6.888c-.7811-.3004-1.0062-.3948-1.1877-.5239a2 2 0 0 1-.471-.471c-.1291-.1815-.2235-.4066-.5239-1.1877zM7.3944 12.5528a1 1 0 0 0-1.7888 0l-.7845 1.5689c-.2825.565-.3686.7276-.4731.8632a2 2 0 0 1-.363.3631c-.1357.1045-.2983.1906-.8633.4731l-1.569.7845a1 1 0 0 0 0 1.7888l1.569.7845c.565.2825.7275.3686.8632.4731.1361.105.2582.227.363.3631.1046.1356.1907.2982.4732.8632l.7845 1.5689a1 1 0 0 0 1.7888 0l.7845-1.5689c.2825-.565.3685-.7276.4731-.8632.105-.1361.227-.2581.363-.3631.1357-.1045.2983-.1906.8633-.4731l1.5689-.7845a1 1 0 0 0 0-1.7888l-1.5689-.7845c-.565-.2825-.7275-.3686-.8632-.4731a2 2 0 0 1-.363-.3631c-.1047-.1356-.1907-.2982-.4732-.8632z"
    />
  </svg>
);

export const Stars02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.5 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.5H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5V7c0 .5523.4477 1 1 1s1-.4477 1-1V5.5H7c.5523 0 1-.4477 1-1s-.4477-1-1-1H5.5zM5.5 17c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.5H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5V22c0 .5523.4477 1 1 1s1-.4477 1-1v-1.5H7c.5523 0 1-.4477 1-1s-.4477-1-1-1H5.5zM13.9333 2.641a.9999.9999 0 0 0-1.8666 0L10.3325 7.15c-.3004.781-.3948 1.0061-.524 1.1877a2 2 0 0 1-.471.471c-.1815.129-.4066.2235-1.1876.5239L3.641 11.0667a.9999.9999 0 0 0 0 1.8666L8.15 14.6675c.781.3004 1.0061.3948 1.1877.5239a2 2 0 0 1 .471.471c.129.1816.2235.4067.5239 1.1877l1.7342 4.5089a.9998.9998 0 0 0 1.8666 0l1.7342-4.5089c.3004-.781.3948-1.0061.5239-1.1877a2 2 0 0 1 .471-.471c.1816-.1291.4067-.2235 1.1877-.5239l4.5089-1.7342a.9998.9998 0 0 0 0-1.8666l-4.5089-1.7342c-.781-.3004-1.0061-.3948-1.1877-.524a2 2 0 0 1-.471-.471c-.1291-.1815-.2235-.4066-.5239-1.1876z"
    />
  </svg>
);

export const Stars03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.3944 1.5528a1 1 0 0 0-1.7888 0L4.821 3.1217c-.2825.565-.3686.7275-.4731.8632a2 2 0 0 1-.363.363c-.1357.1046-.2983.1907-.8633.4732l-1.569.7845a1 1 0 0 0 0 1.7888l1.569.7845c.565.2825.7275.3685.8632.4731a2 2 0 0 1 .363.363c.1046.1357.1907.2983.4732.8633l.7845 1.5689a1 1 0 0 0 1.7888 0l.7845-1.5689c.2825-.565.3685-.7275.4731-.8632a2 2 0 0 1 .363-.363c.1357-.1047.2983-.1907.8633-.4732l1.5689-.7845a1 1 0 0 0 0-1.7888L9.8783 4.821c-.565-.2825-.7275-.3686-.8632-.4731a2 2 0 0 1-.363-.363c-.1047-.1357-.1907-.2983-.4732-.8633zM19.5 3c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.5H16c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5V8c0 .5523.4477 1 1 1s1-.4477 1-1V6.5H21c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1.5zM6.5 16c0-.5523-.4477-1-1-1s-1 .4477-1 1v1.5H3c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5V21c0 .5523.4477 1 1 1s1-.4477 1-1v-1.5H8c.5523 0 1-.4477 1-1s-.4477-1-1-1H6.5zM17.8944 11.5528a1 1 0 0 0-1.7888 0l-.9512 1.9022c-.2824.565-.3685.7276-.4731.8633a2 2 0 0 1-.363.363c-.1357.1046-.2983.1907-.8633.4731l-1.9022.9512a1 1 0 0 0 0 1.7888l1.9022.9512c.565.2824.7276.3685.8633.4731.1361.1049.2581.2269.363.363.1046.1357.1907.2983.4731.8633l.9512 1.9022a1 1 0 0 0 1.7888 0l.9512-1.9022c.2824-.565.3685-.7276.4731-.8633a2 2 0 0 1 .363-.363c.1357-.1046.2983-.1907.8633-.4731l1.9022-.9512a1 1 0 0 0 0-1.7888l-1.9022-.9512c-.565-.2824-.7276-.3685-.8633-.4731a2 2 0 0 1-.363-.363c-.1046-.1357-.1907-.2983-.4731-.8633z"
    />
  </svg>
);

export const Sun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1zM13 20c0-.5523-.4477-1-1-1s-1 .4477-1 1v2c0 .5523.4477 1 1 1s1-.4477 1-1zM1 12c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1M5.607 4.1928c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L5.607 7.0212c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142zM19.8072 4.1928c.3906.3905.3906 1.0237 0 1.4142L18.393 7.0212c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l1.4142-1.4142c.3905-.3905 1.0237-.3905 1.4142 0M7.0212 18.397c.3905-.3905.3905-1.0236 0-1.4142s-1.0237-.3905-1.4142 0L4.1928 18.397c-.3905.3906-.3905 1.0237 0 1.4143s1.0237.3905 1.4142 0zM16.9788 16.9828c.3905-.3905 1.0237-.3905 1.4142 0l1.4142 1.4142c.3906.3906.3906 1.0237 0 1.4143s-1.0237.3905-1.4142 0l-1.4142-1.4143c-.3905-.3905-.3905-1.0236 0-1.4142M20 11c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1zM12 6c-3.3137 0-6 2.6863-6 6s2.6863 6 6 6 6-2.6863 6-6-2.6863-6-6-6"
    />
  </svg>
);

export const SunSetting01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M4 19c0-.5523.4477-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1M4.607 5.1928c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142L4.607 8.0212c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142zM20.8071 5.1928c.3905.3905.3905 1.0237 0 1.4142l-1.4142 1.4142c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l1.4142-1.4142c.3905-.3905 1.0237-.3905 1.4142 0M5.0709 14C5.556 10.6077 8.4735 8 12 8s6.4439 2.6077 6.9291 6H22c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1s.4477-1 1-1z"
    />
  </svg>
);

export const SunSetting02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M3 20c0-.5523.4477-1 1-1h16c.5523 0 1 .4477 1 1s-.4477 1-1 1H4c-.5523 0-1-.4477-1-1M2 12c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1zM4.1928 5.1928c.3905-.3905 1.0237-.3905 1.4142 0L7.0212 6.607c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L4.1928 6.607c-.3905-.3905-.3905-1.0237 0-1.4142M19.8069 6.607c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L16.9784 6.607c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4143 0zM19 13c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1M2 15.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h20c.5523 0 1-.4477 1-1s-.4477-1-1-1zM12 7c-3.3137 0-6 2.6863-6 6 0 .5523.4477 1 1 1h10c.5523 0 1-.4477 1-1 0-3.3137-2.6863-6-6-6"
    />
  </svg>
);

export const SunSetting03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M13.5663 21.8229c-.9471-.4305-2.1854-.4305-3.1324 0-1.473.6695-3.3147.6695-4.7876 0-.5028-.2286-.7251-.8214-.4966-1.3242s.8214-.7251 1.3242-.4966c.947.4305 2.1853.4305 3.1324 0 1.4729-.6695 3.3146-.6695 4.7876 0 .947.4305 2.1853.4305 3.1324 0 .5027-.2285 1.0956-.0062 1.3241.4966s.0062 1.0956-.4965 1.3242c-1.473.6695-3.3147.6695-4.7876 0M2 12c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1zM4.1928 5.1928c.3905-.3905 1.0237-.3905 1.4142 0L7.0212 6.607c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L4.1928 6.607c-.3905-.3905-.3905-1.0237 0-1.4142M19.8069 6.607c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0L16.9784 6.607c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4143 0zM19 13c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1M6 13c0-3.3137 2.6863-6 6-6s6 2.6863 6 6c0 .5523-.4477 1-1 1H7c-.5523 0-1-.4477-1-1M2.5139 18.3229c.947-.4305 2.1853-.4305 3.1324 0 1.473.6695 3.3147.6695 4.7876 0 .9471-.4305 2.1853-.4305 3.1324 0 1.4729.6695 3.3147.6695 4.7876 0 .9471-.4305 2.1853-.4305 3.1324 0 .5028.2285 1.0956.0062 1.3242-.4966.2285-.5028.0062-1.0956-.4966-1.3242-1.4729-.6695-3.3147-.6695-4.7876 0-.9471.4305-2.1853.4305-3.1324 0-1.4729-.6695-3.3147-.6695-4.7876 0-.947.4305-2.1853.4305-3.1324 0-1.473-.6695-3.3147-.6695-4.7876 0-.5028.2286-.7251.8214-.4966 1.3242.2286.5028.8214.7251 1.3242.4966"
    />
  </svg>
);

export const Sunrise = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.2929 1.2929c.3905-.3905 1.0237-.3905 1.4142 0l4 4c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L13 4.4142V9c0 .5523-.4477 1-1 1s-1-.4477-1-1V4.4142l-2.2929 2.293c-.3905.3904-1.0237.3904-1.4142 0-.3905-.3906-.3905-1.0238 0-1.4143zM2 17c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1zM4.1928 10.1928c.3905-.3905 1.0237-.3905 1.4142 0l1.4142 1.4142c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L4.1928 11.607c-.3905-.3905-.3905-1.0237 0-1.4142M19.8071 11.607c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-1.4142 1.4142c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM19 18c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1M6 18c0-3.3137 2.6863-6 6-6s6 2.6863 6 6c0 .5523-.4477 1-1 1H7c-.5523 0-1-.4477-1-1M2 21c-.5523 0-1 .4477-1 1s.4477 1 1 1h20c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Sunset = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1c.5523 0 1 .4477 1 1v4.5858l2.2929-2.293c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142s1.0237-.3905 1.4142 0L11 6.5858V2c0-.5523.4477-1 1-1M2 17c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1zM4.1928 10.1928c.3905-.3905 1.0237-.3905 1.4142 0l1.4142 1.4142c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L4.1928 11.607c-.3905-.3905-.3905-1.0237 0-1.4142M19.8071 11.607c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-1.4142 1.4142c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0zM19 18c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1M6 18c0-3.3137 2.6863-6 6-6s6 2.6863 6 6c0 .5523-.4477 1-1 1H7c-.5523 0-1-.4477-1-1M2 21c-.5523 0-1 .4477-1 1s.4477 1 1 1h20c.5523 0 1-.4477 1-1s-.4477-1-1-1z"
    />
  </svg>
);

export const Thermometer01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5 4.5C8.5 2.567 10.067 1 12 1s3.5 1.567 3.5 3.5v8.7572c1.22 1.0077 2 2.534 2 4.2428 0 3.0376-2.4624 5.5-5.5 5.5s-5.5-2.4624-5.5-5.5c0-1.7088.78-3.2351 2-4.2428z"
      clipRule="evenodd"
    />
  </svg>
);

export const Thermometer02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1c-1.933 0-3.5 1.567-3.5 3.5v8.7572c-1.22 1.0077-2 2.534-2 4.2428 0 3.0376 2.4624 5.5 5.5 5.5s5.5-2.4624 5.5-5.5c0-1.7088-.78-3.2351-2-4.2428V4.5C15.5 2.567 13.933 1 12 1m0 14.5c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2"
      clipRule="evenodd"
    />
  </svg>
);

export const Thermometer03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 1C6.067 1 4.5 2.567 4.5 4.5v8.7572c-1.22 1.0077-2 2.534-2 4.2428C2.5 20.5376 4.9624 23 8 23s5.5-2.4624 5.5-5.5c0-1.7088-.78-3.2351-2-4.2428V4.5C11.5 2.567 9.933 1 8 1m0 14.5c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2M14 3c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1M14 7c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1M14 11c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1h-6c-.5523 0-1-.4477-1-1"
      clipRule="evenodd"
    />
  </svg>
);

export const ThermometerCold = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 1c-1.6569 0-3 1.3432-3 3v9.9998c-1.213.9111-2 2.3633-2 4.0002 0 2.7614 2.2386 5 5 5s5-2.2386 5-5c0-1.6369-.787-3.0891-2-4.0002V4c0-1.6568-1.3431-3-3-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10 4c0-.5523-.4477-1-1-1s-1 .4477-1 1v2.5858l-1.2929-1.293c-.3905-.3904-1.0237-.3904-1.4142 0-.3905.3906-.3905 1.0238 0 1.4143L8 9.4142V11H6.4142l-2.707-2.7071c-.3906-.3905-1.0238-.3905-1.4143 0s-.3905 1.0237 0 1.4142L3.5858 11H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h1.5858l-1.293 1.2929c-.3904.3905-.3904 1.0237 0 1.4142.3906.3905 1.0238.3905 1.4143 0L6.4142 13H8v1.5858l-2.7071 2.7071c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L8 17.4142V20c0 .5523.4477 1 1 1s1-.4477 1-1v-2.6337c.3824.2211.8799.168 1.2071-.1592.3905-.3905.3905-1.0237 0-1.4142L10 14.5858V13h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2V9.4142l2.7071-2.707c.3905-.3906.3905-1.0238 0-1.4143s-1.0237-.3905-1.4142 0L10 6.5858z"
    />
  </svg>
);

export const ThermometerWarm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.9214 9.0101a5 5 0 0 1 3.0947-1.01c.5522.009.9927.4638.9838 1.016s-.4638.9927-1.016.9838a3 3 0 0 0-2.947 2.2266 3 3 0 0 0 1.447 3.3984c.4833.2672.6585.8757.3912 1.359s-.8757.6585-1.359.3912a5 5 0 0 1-2.4117-5.6639 5 5 0 0 1 1.817-2.701M12 2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1M7.3071 17.6929c.3905.3905.3905 1.0237 0 1.4142l-1.4 1.4c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l1.4-1.4c.3905-.3905 1.0237-.3905 1.4142 0M1 13c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1M4.4929 5.4929c.3905-.3905 1.0237-.3905 1.4142 0l1.4 1.4c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-1.4-1.4c-.3905-.3905-.3905-1.0237 0-1.4142M15 4c0-1.6568 1.3431-3 3-3s3 1.3432 3 3v9.9998c1.213.9111 2 2.3633 2 4.0002 0 2.7614-2.2386 5-5 5s-5-2.2386-5-5c0-1.6369.787-3.0891 2-4.0002z"
      clipRule="evenodd"
    />
  </svg>
);

export const Umbrella01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1C6.5205 1 1.9785 5.0054 1.1389 10.2481l-.0148.0903c-.0615.3715-.1424.8602.048 1.3663.1566.4156.4944.8118.88 1.032.2782.1589.5548.2172.8042.242.216.0214.4654.0214.7087.0213H11v6.4c0 1.9509 1.5304 3.6 3.5 3.6s3.5-1.6491 3.5-3.6c0-.5523-.4477-1-1-1s-1 .4477-1 1c0 .921-.7082 1.6-1.5 1.6s-1.5-.679-1.5-1.6V13h7.4349c.2434.0001.4927.0001.7088-.0213.2494-.0248.5259-.0831.8041-.2419.3857-.2203.7235-.6165.88-1.0321.1905-.5061.1096-.9948.0481-1.3663l-.0148-.0903C22.0214 5.0054 17.4794 1 12 1"
    />
  </svg>
);

export const Umbrella02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.5833 12.8124a.997.997 0 0 1-.6403.186.996.996 0 0 1-.6951-.3394A.996.996 0 0 1 1 12.0034V12C1 5.9249 5.9249 1 12 1s11 4.9251 11 11.0003a.9963.9963 0 0 1-.2458.6564.998.998 0 0 1-.6972.3417.997.997 0 0 1-.6403-.186c-.2269-.1581-.4765-.288-.7276-.4024-.4775-.2176-1.0802-.41-1.6892-.41s-1.2116.1924-1.6892.41c-.2518.1147-.5016.2451-.7292.4035a1.001 1.001 0 0 1-.9674.1091c-.4278-.1775-.8673-.33-1.3091-.4683-.4245-.1328-.877-.2581-1.305-.345v7.2909c0 1.9509-1.5304 3.6-3.5 3.6s-3.5-1.6491-3.5-3.6c0-.5523.4477-1 1-1s1 .4477 1 1c0 .9209.7082 1.6 1.5 1.6s1.5-.6791 1.5-1.6v-7.2853c-.428.0842-.8805.2066-1.305.3394-.4418.1383-.8813.2908-1.3091.4683a1.001 1.001 0 0 1-.9674-.1091c-.2276-.1584-.4774-.2888-.7292-.4035C6.2117 12.1924 5.609 12 5 12s-1.2117.1924-1.6892.41c-.2511.1144-.5007.2443-.7276.4024"
      clipRule="evenodd"
    />
  </svg>
);

export const Umbrella03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.47 5.0522C6.8152.9356 12.7435-.2638 17.4866 2.466l.0132.0076.0132.0076c4.7357 2.7428 6.6612 8.4765 4.7688 13.4321-.1375.3601-.3045.8734-.7571 1.2448-.3434.2817-.834.4559-1.2781.4538-.3204-.0015-.589-.0893-.8174-.1926-.1978-.0894-.4137-.2141-.6245-.3359l-6.4387-3.7174L7.9586 21H22c.5523 0 1 .4477 1 1s-.4477 1-1 1H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h3.6492l4.9848-8.634-6.4389-3.7175c-.2108-.1216-.4268-.2463-.6031-.3729-.2037-.1461-.414-.3349-.5755-.6115-.2239-.3836-.3183-.8956-.246-1.3338.0953-.578.4563-.979.6994-1.278m1.552 1.2613c2.0173-2.4824 5.1846-3.667 8.2642-3.2235a10.6 10.6 0 0 0-.8186.586c-1.4594 1.1484-2.9662 2.8778-4.2814 4.9674L4.7585 6.651c.0388-.0575.1256-.1678.2635-.3376M18.9747 7.433c-.2648 1.838-1.0091 4.0076-2.1611 6.1914l3.4394 1.9724c.0303-.0623.0825-.1926.1605-.397 1.1412-2.9883.5835-6.3236-1.3405-8.769a10.6 10.6 0 0 1-.0983 1.0022"
      clipRule="evenodd"
    />
  </svg>
);

export const Waves = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.4171 7.589c-.5298.2543-1.147.411-1.917.411-.7889 0-1.4144-.154-1.9481-.4123-.499-.2415-.8794-.5587-1.1672-.7987l-.025-.0208c-.4242-.3535-.4816-.9841-.128-1.4084s.9841-.4816 1.4084-.128c.3094.2578.5214.429.7829.5555C3.6643 5.9041 3.9888 6 4.5 6c.4798 0 .8002-.0933 1.0516-.214.2727-.131.5011-.3088.8236-.5669l.0254-.0202c.2992-.2395.6878-.5506 1.1822-.788C8.1127 4.1568 8.73 4 9.5 4c.7888 0 1.4143.154 1.9481.4123.4989.2415.8794.5587 1.1672.7987l.0249.0208c.3094.2578.5214.429.7829.5555.2412.1168.5657.2127 1.0769.2127.4799 0 .8002-.0933 1.0517-.214.2727-.131.5011-.3088.8236-.5669l.0254-.0202c.2991-.2395.6878-.5506 1.1822-.788C18.1127 4.1568 18.7299 4 19.5 4c.7888 0 1.4143.154 1.9481.4123.4989.2415.8794.5587 1.1672.7987l.0249.0208c.4243.3535.4816.9841.128 1.4084s-.9841.4816-1.4084.128c-.3093-.2578-.5213-.429-.7828-.5555C20.3357 6.0959 20.0112 6 19.5 6c-.4799 0-.8002.0933-1.0516.214-.2727.131-.5012.3088-.8237.5669l-.0253.0202c-.2992.2395-.6878.5506-1.1823.788C15.8873 7.8432 15.2701 8 14.5 8c-.7888 0-1.4143-.154-1.948-.4123-.499-.2415-.8794-.5587-1.1672-.7987l-.025-.0208c-.3093-.2578-.5213-.429-.7828-.5555C10.3357 6.0959 10.0112 6 9.5 6c-.4799 0-.8002.0933-1.0516.214-.2727.131-.5012.3088-.8237.5669l-.0253.0202c-.2992.2395-.6878.5506-1.1823.788M6.4171 19.589c-.5298.2543-1.147.411-1.917.411-.7889 0-1.4144-.1541-1.9481-.4123-.499-.2415-.8794-.5587-1.1672-.7987l-.025-.0208c-.4242-.3535-.4816-.9841-.128-1.4084s.9841-.4816 1.4084-.128c.3094.2578.5214.429.7829.5555.2412.1168.5657.2127 1.077.2127.4798 0 .8002-.0933 1.0516-.214.2727-.1309.5011-.3089.8236-.5669l.0254-.0202c.2992-.2395.6878-.5506 1.1822-.7879C8.1127 16.1567 8.73 16 9.5 16c.7888 0 1.4143.1541 1.9481.4123.4989.2415.8794.5587 1.1672.7987l.0249.0208c.3094.2578.5214.429.7829.5555.2412.1168.5657.2127 1.0769.2127.4799 0 .8002-.0933 1.0517-.214.2727-.1309.5011-.3089.8236-.5669l.0254-.0202c.2991-.2395.6878-.5506 1.1822-.7879.5298-.2543 1.147-.411 1.9171-.411.7888 0 1.4143.1541 1.9481.4123.4989.2415.8794.5587 1.1672.7987l.0249.0208c.4243.3535.4816.9841.128 1.4084s-.9841.4816-1.4084.128c-.3093-.2578-.5213-.429-.7828-.5555C20.3357 18.0959 20.0112 18 19.5 18c-.4799 0-.8002.0933-1.0516.214-.2727.1309-.5012.3089-.8237.5669l-.0253.0202c-.2992.2395-.6878.5506-1.1823.7879-.5298.2543-1.147.411-1.9171.411-.7888 0-1.4143-.1541-1.948-.4123-.499-.2415-.8794-.5587-1.1672-.7987l-.025-.0208c-.3093-.2578-.5213-.429-.7828-.5555C10.3357 18.0959 10.0112 18 9.5 18c-.4799 0-.8002.0933-1.0516.214-.2727.1309-.5012.3089-.8237.5669l-.0253.0202c-.2992.2395-.6878.5506-1.1823.7879M6.4171 13.589c-.5298.2543-1.147.411-1.917.411-.7889 0-1.4144-.1541-1.9481-.4123-.499-.2415-.8794-.5587-1.1672-.7987l-.025-.0208c-.4242-.3535-.4816-.9841-.128-1.4084s.9841-.4816 1.4084-.128c.3094.2578.5214.429.7829.5555.2412.1168.5657.2127 1.077.2127.4798 0 .8002-.0933 1.0516-.214.2727-.1309.5011-.3089.8236-.5669l.0254-.0202c.2992-.2395.6878-.5506 1.1822-.7879C8.1127 10.1567 8.73 10 9.5 10c.7888 0 1.4143.1541 1.9481.4123.4989.2415.8794.5587 1.1672.7987l.0249.0208c.3094.2578.5214.429.7829.5555.2412.1168.5657.2127 1.0769.2127.4799 0 .8002-.0933 1.0517-.214.2727-.1309.5011-.3089.8236-.5669l.0254-.0202c.2991-.2395.6878-.5506 1.1822-.7879.5298-.2543 1.147-.411 1.9171-.411.7888 0 1.4143.1541 1.9481.4123.4989.2415.8794.5587 1.1672.7987l.0249.0208c.4243.3535.4816.9841.128 1.4084s-.9841.4816-1.4084.128c-.3093-.2578-.5213-.429-.7828-.5555C20.3357 12.0959 20.0112 12 19.5 12c-.4799 0-.8002.0933-1.0516.214-.2727.1309-.5012.3089-.8237.5669l-.0253.0202c-.2992.2395-.6878.5506-1.1823.7879-.5298.2543-1.147.411-1.9171.411-.7888 0-1.4143-.1541-1.948-.4123-.499-.2415-.8794-.5587-1.1672-.7987l-.025-.0208c-.3093-.2578-.5213-.429-.7828-.5555C10.3357 12.0959 10.0112 12 9.5 12c-.4799 0-.8002.0933-1.0516.214-.2727.1309-.5012.3089-.8237.5669l-.0253.0202c-.2992.2395-.6878.5506-1.1823.7879"
      clipRule="evenodd"
    />
  </svg>
);

export const Wind01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.2192 12.9796c-2.1692.6942-4.64 1.4849-7.4908.6805-.4427-.1249-.9718-.3102-1.3756-.4579a38 38 0 0 1-.6628-.2499l-.0413-.0162-.0154-.006s-.0002-.0001.3567-.905l-.3567.905c-.5138-.2026-.7662-.7835-.5636-1.2972.2027-.5138.7834-.766 1.2971-.5634l-.3666.9296.3666-.9296.0117.0046.037.0144a34.0451 34.0451 0 0 0 .6246.2355c.3938.1441.8646.3078 1.2314.4113 2.232.6297 4.1737.0318 6.4238-.688l.0855-.0273c2.1692-.6942 4.6399-1.485 7.4907-.6806.4428.1249.972.3102 1.3757.458a36 36 0 0 1 .6628.2499l.0413.0161.0154.006s.0002.0001-.3667.9304l.3667-.9304c.5138.2027.7662.7835.5636 1.2973s-.7834.766-1.2972.5633l-.0116-.0045-.0369-.0144-.1409-.0544a36 36 0 0 0-.4837-.1811c-.3939-.1441-.8647-.3078-1.2315-.4113-2.232-.6298-4.1737-.0319-6.4238.6879zM12.2192 18.9796c-2.1692.6942-4.64 1.4849-7.4908.6805-.4427-.1249-.9718-.3102-1.3756-.4579a38 38 0 0 1-.6628-.2499l-.0413-.0162-.0154-.006s-.0002-.0001.3567-.905l-.3567.905c-.5138-.2026-.7662-.7835-.5636-1.2972.2027-.5138.7834-.766 1.2971-.5634l-.3666.9296.3666-.9296.0117.0046.037.0144a35.5216 35.5216 0 0 0 .6246.2355c.3938.1441.8646.3078 1.2314.4113 2.232.6297 4.1737.0318 6.4238-.688l.0855-.0273c2.1692-.6942 4.6399-1.4849 7.4907-.6806.4428.1249.972.3102 1.3757.458a36 36 0 0 1 .6628.2499l.0413.0161.0154.006s.0002.0001-.3667.9304l.3667-.9304c.5138.2027.7662.7835.5636 1.2973s-.7834.766-1.2972.5633l-.0116-.0045-.0369-.0144-.1409-.0544a36 36 0 0 0-.4837-.1811c-.3939-.1441-.8647-.3078-1.2315-.4113-2.232-.6298-4.1737-.0319-6.4238.6879zM12.2192 6.9796c-2.1692.6942-4.64 1.4849-7.4908.6805-.4427-.1249-.9718-.3102-1.3756-.458a37 37 0 0 1-.6628-.2498l-.0413-.0162-.0154-.006s-.0002 0 .3567-.905l-.3567.905c-.5138-.2026-.7662-.7835-.5636-1.2972.2027-.5138.7834-.766 1.2971-.5634l-.3666.9296.3666-.9296.0117.0046.037.0144a34.8051 34.8051 0 0 0 .6246.2355c.3938.144.8646.3078 1.2314.4113 2.232.6297 4.1737.0318 6.4238-.688l.0855-.0273c2.1692-.6942 4.6399-1.485 7.4907-.6806.4428.125.972.3102 1.3757.458a37 37 0 0 1 .6628.2499l.0413.0161.0154.006s.0002.0001-.3667.9304l.3667-.9303c.5138.2026.7662.7834.5636 1.2972s-.7834.766-1.2972.5633l-.0116-.0045-.0369-.0145-.1409-.0543a35 35 0 0 0-.4837-.1811c-.3939-.1441-.8647-.3079-1.2315-.4113-2.232-.6298-4.1737-.0319-6.4238.688z"
      clipRule="evenodd"
    />
  </svg>
);

export const Wind02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 7c-.5922 0-1.1233.2561-1.4909.667-.3684.4114-1.0006.4465-1.4121.0781s-.4465-1.0005-.0782-1.412C16.7498 5.5164 17.8153 5 19 5c2.2092 0 4 1.7909 4 4s-1.7908 4-4 4H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h17c1.1046 0 2-.8954 2-2s-.8954-2-2-2"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 5a.995.995 0 0 0-.7456.3336c-.3683.4115-1.0005.4465-1.412.0782-.4116-.3683-.4466-1.0005-.0782-1.412C9.312 3.3876 10.1114 3 11 3c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h9c.5523 0 1-.4477 1-1s-.4477-1-1-1M14 19a.995.995 0 0 1-.7456-.3336c-.3683-.4115-1.0005-.4465-1.412-.0782-.4116.3683-.4466 1.0005-.0782 1.412C12.312 20.6124 13.1114 21 14 21c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1"
      clipRule="evenodd"
    />
  </svg>
);

export const Wind03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 6.5c-.5922 0-1.1233.2561-1.4909.667-.3684.4114-1.0006.4465-1.4121.0781s-.4465-1.0005-.0782-1.412C16.7498 5.0164 17.8153 4.5 19 4.5c2.2092 0 4 1.7909 4 4s-1.7908 4-4 4h-6c-.5523 0-1-.4477-1-1s.4477-1 1-1h6c1.1046 0 2-.8954 2-2s-.8954-2-2-2M9 4c-.5922 0-1.1233.2561-1.491.667-.3683.4114-1.0005.4465-1.412.0781-.4116-.3683-.4466-1.0005-.0782-1.412C6.7498 2.5164 7.8152 2 9 2c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4H2c-.5523 0-1-.4477-1-1s.4477-1 1-1h7c1.1046 0 2-.8954 2-2s-.8954-2-2-2M13 20c-.5922 0-1.1233-.2562-1.491-.6669-.3683-.4115-1.0005-.4466-1.412-.0782s-.4466 1.0005-.0782 1.412C10.7498 21.4836 11.8152 22 13 22c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4H2c-.5523 0-1 .4477-1 1s.4477 1 1 1h11c1.1046 0 2 .8954 2 2s-.8954 2-2 2"
      clipRule="evenodd"
    />
  </svg>
);
